/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://console-static.huaweicloud.com/static/authui/20220329103830/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 142);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : null;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(354)("./" + window.language + "/resource"), __webpack_require__(355)("./" + window.language + "/resourcehk"), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, i18nhk, iamEnv) {

    if (iamEnv.ipIsInternational()) {
        $.extend(i18n.framework, i18nhk.framework);
    }
    console.dir(i18n.framework);
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamEnv) {
    "use strict";

    function getAjaxConf() {
        return {
            timeout: 10 * 60 * 1000,
            headers: {
                "Pragma": "no-store",
                "Cache-control": "no-store"
            },
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            data: {}
        };
    };
    var supportType = ["GET", "POST", "PUT", "DELETE", "PATCH"];

    function iamAjax(reqType) {
        return function (config) {
            var deferred = $.Deferred();
            adaptConfig(config);
            if (iamEnv.getUrlPrefix() !== undefined) {
                config.url = iamEnv.getUrlPrefix() + config.url;
            }
            var ajaxConf = getAjaxConf();
            $.extend(true, ajaxConf, config);
            ajaxConf["type"] = reqType;

            var ajax = $.ajax(ajaxConf);
            ajax.success(function () {
                deferred.resolve(arguments[0]);
            }).error(function () {
                deferred.reject(arguments[0]);
            });
            return deferred.promise();
        };
    }

    //adapt earlier implement
    function adaptConfig(config) {
        if (config.params) {
            config.data = config.params;
            delete config.params;
        }
        if (config.header) {
            config.headers = config.header;
            delete config.header;
        }
    }

    var iamHttpService = {};

    for (var i = 0; i < supportType.length; i++) {
        iamHttpService[supportType[i].toLowerCase()] = iamAjax(supportType[i]);
    }

    return iamHttpService;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var tzOffsets;

    //SHA256算法
    var CryptoJS = CryptoJS || function (h, s) {
        var f = {},
            t = f.lib = {},
            g = function g() {},
            j = t.Base = { extend: function extend(a) {
                g.prototype = this;var c = new g();a && c.mixIn(a);c.hasOwnProperty("init") || (c.init = function () {
                    c.$super.init.apply(this, arguments);
                });c.init.prototype = c;c.$super = this;return c;
            }, create: function create() {
                var a = this.extend();a.init.apply(a, arguments);return a;
            }, init: function init() {}, mixIn: function mixIn(a) {
                for (var c in a) {
                    a.hasOwnProperty(c) && (this[c] = a[c]);
                }a.hasOwnProperty("toString") && (this.toString = a.toString);
            }, clone: function clone() {
                return this.init.prototype.extend(this);
            } },
            q = t.WordArray = j.extend({ init: function init(a, c) {
                a = this.words = a || [];this.sigBytes = c != s ? c : 4 * a.length;
            }, toString: function toString(a) {
                return (a || u).stringify(this);
            }, concat: function concat(a) {
                var c = this.words,
                    d = a.words,
                    b = this.sigBytes;a = a.sigBytes;this.clamp();if (b % 4) for (var e = 0; e < a; e++) {
                    c[b + e >>> 2] |= (d[e >>> 2] >>> 24 - 8 * (e % 4) & 255) << 24 - 8 * ((b + e) % 4);
                } else if (65535 < d.length) for (e = 0; e < a; e += 4) {
                    c[b + e >>> 2] = d[e >>> 2];
                } else c.push.apply(c, d);this.sigBytes += a;return this;
            }, clamp: function clamp() {
                var a = this.words,
                    c = this.sigBytes;a[c >>> 2] &= 4294967295 << 32 - 8 * (c % 4);a.length = h.ceil(c / 4);
            }, clone: function clone() {
                var a = j.clone.call(this);a.words = this.words.slice(0);return a;
            }, random: function random(a) {
                for (var c = [], d = 0; d < a; d += 4) {
                    c.push(4294967296 * h.random() | 0);
                }return new q.init(c, a);
            } }),
            v = f.enc = {},
            u = v.Hex = { stringify: function stringify(a) {
                var c = a.words;a = a.sigBytes;for (var d = [], b = 0; b < a; b++) {
                    var e = c[b >>> 2] >>> 24 - 8 * (b % 4) & 255;d.push((e >>> 4).toString(16));d.push((e & 15).toString(16));
                }return d.join("");
            }, parse: function parse(a) {
                for (var c = a.length, d = [], b = 0; b < c; b += 2) {
                    d[b >>> 3] |= parseInt(a.substr(b, 2), 16) << 24 - 4 * (b % 8);
                }return new q.init(d, c / 2);
            } },
            k = v.Latin1 = { stringify: function stringify(a) {
                var c = a.words;a = a.sigBytes;for (var d = [], b = 0; b < a; b++) {
                    d.push(String.fromCharCode(c[b >>> 2] >>> 24 - 8 * (b % 4) & 255));
                }return d.join("");
            }, parse: function parse(a) {
                for (var c = a.length, d = [], b = 0; b < c; b++) {
                    d[b >>> 2] |= (a.charCodeAt(b) & 255) << 24 - 8 * (b % 4);
                }return new q.init(d, c);
            } },
            l = v.Utf8 = { stringify: function stringify(a) {
                try {
                    return decodeURIComponent(escape(k.stringify(a)));
                } catch (c) {
                    throw Error("Malformed UTF-8 data");
                }
            }, parse: function parse(a) {
                return k.parse(unescape(encodeURIComponent(a)));
            } },
            x = t.BufferedBlockAlgorithm = j.extend({ reset: function reset() {
                this._data = new q.init();this._nDataBytes = 0;
            }, _append: function _append(a) {
                "string" == typeof a && (a = l.parse(a));this._data.concat(a);this._nDataBytes += a.sigBytes;
            }, _process: function _process(a) {
                var c = this._data,
                    d = c.words,
                    b = c.sigBytes,
                    e = this.blockSize,
                    f = b / (4 * e),
                    f = a ? h.ceil(f) : h.max((f | 0) - this._minBufferSize, 0);a = f * e;b = h.min(4 * a, b);if (a) {
                    for (var m = 0; m < a; m += e) {
                        this._doProcessBlock(d, m);
                    }m = d.splice(0, a);c.sigBytes -= b;
                }return new q.init(m, b);
            }, clone: function clone() {
                var a = j.clone.call(this);
                a._data = this._data.clone();return a;
            }, _minBufferSize: 0 });t.Hasher = x.extend({ cfg: j.extend(), init: function init(a) {
                this.cfg = this.cfg.extend(a);this.reset();
            }, reset: function reset() {
                x.reset.call(this);this._doReset();
            }, update: function update(a) {
                this._append(a);this._process();return this;
            }, finalize: function finalize(a) {
                a && this._append(a);return this._doFinalize();
            }, blockSize: 16, _createHelper: function _createHelper(a) {
                return function (c, d) {
                    return new a.init(d).finalize(c);
                };
            }, _createHmacHelper: function _createHmacHelper(a) {
                return function (c, d) {
                    return new w.HMAC.init(a, d).finalize(c);
                };
            } });var w = f.algo = {};return f;
    }(Math);
    (function (h) {
        for (var s = CryptoJS, f = s.lib, t = f.WordArray, g = f.Hasher, f = s.algo, j = [], q = [], v = function v(a) {
            return 4294967296 * (a - (a | 0)) | 0;
        }, u = 2, k = 0; 64 > k;) {
            var l;a: {
                l = u;for (var x = h.sqrt(l), w = 2; w <= x; w++) {
                    if (!(l % w)) {
                        l = !1;break a;
                    }
                }l = !0;
            }l && (8 > k && (j[k] = v(h.pow(u, 0.5))), q[k] = v(h.pow(u, 1 / 3)), k++);u++;
        }var a = [],
            f = f.SHA256 = g.extend({ _doReset: function _doReset() {
                this._hash = new t.init(j.slice(0));
            }, _doProcessBlock: function _doProcessBlock(c, d) {
                for (var b = this._hash.words, e = b[0], f = b[1], m = b[2], h = b[3], p = b[4], j = b[5], k = b[6], l = b[7], n = 0; 64 > n; n++) {
                    if (16 > n) a[n] = c[d + n] | 0;else {
                        var r = a[n - 15],
                            g = a[n - 2];a[n] = ((r << 25 | r >>> 7) ^ (r << 14 | r >>> 18) ^ r >>> 3) + a[n - 7] + ((g << 15 | g >>> 17) ^ (g << 13 | g >>> 19) ^ g >>> 10) + a[n - 16];
                    }r = l + ((p << 26 | p >>> 6) ^ (p << 21 | p >>> 11) ^ (p << 7 | p >>> 25)) + (p & j ^ ~p & k) + q[n] + a[n];g = ((e << 30 | e >>> 2) ^ (e << 19 | e >>> 13) ^ (e << 10 | e >>> 22)) + (e & f ^ e & m ^ f & m);l = k;k = j;j = p;p = h + r | 0;h = m;m = f;f = e;e = r + g | 0;
                }b[0] = b[0] + e | 0;b[1] = b[1] + f | 0;b[2] = b[2] + m | 0;b[3] = b[3] + h | 0;b[4] = b[4] + p | 0;b[5] = b[5] + j | 0;b[6] = b[6] + k | 0;b[7] = b[7] + l | 0;
            }, _doFinalize: function _doFinalize() {
                var a = this._data,
                    d = a.words,
                    b = 8 * this._nDataBytes,
                    e = 8 * a.sigBytes;
                d[e >>> 5] |= 128 << 24 - e % 32;d[(e + 64 >>> 9 << 4) + 14] = h.floor(b / 4294967296);d[(e + 64 >>> 9 << 4) + 15] = b;a.sigBytes = 4 * d.length;this._process();return this._hash;
            }, clone: function clone() {
                var a = g.clone.call(this);a._hash = this._hash.clone();return a;
            } });s.SHA256 = g._createHelper(f);s.HmacSHA256 = g._createHmacHelper(f);
    })(Math);

    //该方法慎用(已确认tiny 53版本有问题，调用textBox的option方法会导致其他输入框无法获取焦点)。
    function trimSpace(inputId) {
        $("#" + inputId).widget().option("value", getTrimValue(inputId));
    }

    function getTrimValue(inputId) {
        var inputField = $("#" + inputId).widget();
        var value;
        inputField ? value = $.trim(inputField.getValue()) : value = "";
        return value.replace(/\s+/g, function (match, capture) {
            return " ";
        });
    }

    function getUrlParams() {
        var urlParams = {};
        var searchStr = window.location.search.substring(1);
        var params = searchStr.split("&");
        for (var index = 0; index < params.length; index++) {
            var key = params[index].substring(0, params[index].indexOf("="));
            var value = params[index].substring(params[index].indexOf("=") + 1).replace(/\+/g, encodeURIComponent(' '));
            urlParams[key] = decodeURIComponent(value);
        }
        return urlParams;
    }

    function i18nFormat() {
        if (arguments.length === 1) {
            return arguments[0];
        }
        var regex = /{\d+}/g;
        var args = arguments;
        return args[0].replace(regex, function (m, i) {
            var index = parseInt(m.substr(1, m.length - 1)) + 1;
            return args[index] != undefined ? args[index] : m;
        });
    }

    function getPwdStrengthLevel(pwd, password_char_combination) {
        var modes = 0;
        for (var i = 0; i < pwd.length; i++) {
            //测试每一个字符的类别并统计一共有多少种模式.
            modes |= charMode(pwd.charCodeAt(i));
        }

        //测试某个字符是属于哪一类.
        function charMode(iN) {
            if (iN >= 48 && iN <= 57) //数字
                return 1;
            if (iN >= 65 && iN <= 90) //大写字母
                return 2;
            if (iN >= 97 && iN <= 122) //小写
                return 4;else return 8; //特殊字符
        }

        //计算出当前密码当中一共有多少种模式
        function bitTotal(num) {
            var modes = 0;
            for (var i = 0; i < 4; i++) {
                if (num & 1) {
                    modes++;
                }
                num >>>= 1;
            }
            return modes;
        }

        function getLevel(allBits) {
            if (password_char_combination) {
                if (allBits < password_char_combination) {
                    return "low";
                } else if (allBits === password_char_combination) {
                    return "mid";
                } else if (allBits > password_char_combination) {
                    return "high";
                } else {
                    return "low";
                }
            } else {
                switch (allBits) {
                    case 4:
                    case 3:
                        return "high";
                    case 2:
                        return "mid";
                    case 1:
                        return "low";
                    default:
                        return "low";
                }
            }
        }

        return getLevel(bitTotal(modes));
    }

    function pwdLevel4Display(lowId, midId, highId) {
        return {
            params: [lowId, midId, highId],
            validFn: function validFn(params) {
                var defaultColor = "#e2e2e2"; //#D0D0D0
                var lowColor = "#FF4C4C"; //"#FF7D73 #ff4c4c";
                var midColor = "#FF8833"; //"#FFD42A #ff6a00";
                var highColor = "#3dcca6"; //"#A3E000 #0a9e00"
                var low;
                var mid;
                var high;
                var level;
                var pwd = this.val();

                if (pwd == null || pwd == '') {
                    low = mid = high = defaultColor;
                    switchClazz('');
                } else {
                    if (pwd.length < 6) {
                        level = 'low';
                    } else {
                        level = getPwdStrengthLevel(pwd);
                    }

                    switch (level) {
                        case "high":
                            low = mid = high = highColor;
                            switchClazz('high');
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                            break;
                        case "low":
                            low = lowColor;
                            mid = high = defaultColor;
                            switchClazz('low');
                            $("#" + lowId)[0].style.height = "4px";
                            $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                            break;
                        case "mid":
                            low = mid = midColor;
                            high = defaultColor;
                            switchClazz('mid');
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                            $("#" + highId)[0].style.height = "2px";
                            break;
                        default:
                            low = mid = high = defaultColor;
                            $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                            switchClazz('');
                    }
                }

                $("#" + params[0])[0].style.background = low;
                $("#" + params[1])[0].style.background = mid;
                $("#" + params[2])[0].style.background = high;
                return true;
            }
        };
    }

    function switchClazz(clazz) {
        try {
            $("#TIP").removeClass('high');
            $("#TIP").removeClass('low');
            $("#TIP").removeClass('mid');
            $("#TIP").addClass(clazz);
        } catch (e) {}
    }

    function clearPwdDisplayLevel(lowId, midId, highId) {
        try {
            $("#" + lowId)[0].style.backgroundColor = "#D0D0D0";
            $("#" + midId)[0].style.backgroundColor = "#D0D0D0";
            $("#" + highId)[0].style.backgroundColor = "#D0D0D0";
            switchClazz('');
        } catch (e) {
            console.dir(e);
        }
    }

    function setPwdLevel(lowId, midId, highId, pwd, pwdLvlColors) {
        var level = '';
        if (pwd == null || pwd == '') {
            level = '';
        } else if (pwd.length < 6) {
            level = 'low';
        } else {
            level = getPwdStrengthLevel(pwd);
        }

        setPwdLevelByLevel(lowId, midId, highId, level, pwdLvlColors);
    }

    function setPwdLevelByLevel(lowId, midId, highId, level, pwdLvlColors) {
        var defaultColor = "#e2e2e2"; //#D0D0D0
        var lowColor = "#ff4c4c"; //"#FF7D73";
        var midColor = "#ff6a00"; //"#FFD42A";
        var highColor = "#0a9e00"; //"#A3E000"
        if (pwdLvlColors && pwdLvlColors.length >= 4) {
            defaultColor = pwdLvlColors[0];
            lowColor = pwdLvlColors[1];
            midColor = pwdLvlColors[2];
            highColor = pwdLvlColors[3];
        }
        var low;
        var mid;
        var high;
        switch (level) {
            case "high":
                low = mid = high = highColor;
                switchClazz('high');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                break;
            case "low":
                low = lowColor;
                mid = high = defaultColor;
                switchClazz('low');
                $("#" + lowId)[0].style.height = "4px";
                $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                break;
            case "mid":
                low = mid = midColor;
                high = defaultColor;
                switchClazz('mid');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                $("#" + highId)[0].style.height = "2px";
                break;
            default:
                low = mid = high = defaultColor;
                switchClazz('');
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
        }

        if ($("#" + lowId).size() != 0) {
            $("#" + lowId)[0].style.background = low;
            $("#" + midId)[0].style.background = mid;
            $("#" + highId)[0].style.background = high;
        }
    }

    function getEmailURL(emailURL) {
        var domainURLs = {
            'yeah.net': "http://www.yeah.net/",
            'sogou.com': "http://mail.sogou.com/",
            '188.com': "http://www.188.com/index.htm?from=h2",
            'x263.net': "http://mail.263.net/",
            '263.net.cn': "http://mail.263.net/",
            '263.net': "http://mail.263.net/",
            '21cn.com': "http://mail.21cn.com/",
            'eyou.com': "http://www.eyou.com/",
            'yahoo.com': "http://cn.mail.yahoo.com/",
            'yahoo.com.cn': "http://cn.mail.yahoo.com/",
            'yahoo.cn': "http://cn.mail.yahoo.com/",
            'foxmail.com': "http://mail.qq.com/",
            'qq.com': "http://mail.qq.com/",
            'LIVE.COM': "http://www.hotmail.com/",
            'LIVE.CN': "http://www.hotmail.com/",
            'hotmail.com': "http://www.hotmail.com/",
            'gmail.com': "http://mail.google.com/",
            '139.com': "http://mail.139.com/",
            '126.com': "http://www.126.com/",
            'tom.com': "http://mail.tom.com/",
            'vip.tom.com': "http://mail.tom.com/",
            '163.net': "http://mail.tom.com/",
            'sohu.com': "http://login.mail.sohu.com/",
            'sina.com': "http://mail.sina.com.cn/",
            'sina.cn': "http://mail.sina.com.cn/",
            '2008.sina.com': "http://mail.sina.com.cn/",
            '163.com': "http://mail.163.com/",
            'huawei.com': "http://imail.huawei.com/"
        };
        var domain = emailURL.split("@")[1];
        if (domain in domainURLs) {
            return domainURLs[domain];
        }
        return "";
    }

    function getMessageInstance(width, i18n) {
        return {
            ERROR: getHandlerByType("error", width, i18n),
            PROMPT: getHandlerByType("prompt", width, i18n),
            CONFIRM: getHandlerByType("confirm", width, i18n),
            WARN: getHandlerByType("warn", width, i18n)
        };
    }

    function getMobileMessageInstance(width, i18n) {
        return {
            "ERROR": getMobileHandlerByType("error", width, i18n),
            "PROMPT": getMobileHandlerByType("prompt", width, i18n),
            "CONFIRM": getMobileHandlerByType("confirm", width, i18n),
            "WARN": getMobileHandlerByType("warn", width, i18n)
        };
    }

    function getMobileHandlerByType(type, width, i18n) {
        return function (content, detail, id, buttons, closeCallback) {
            createTipDiv(content);
            $("#TipDiv").show();
            setTimeout(function () {
                $("#TipDiv").remove();
                closeCallback && closeCallback();
            }, 2000);
        };
    }

    function createTipDiv(tipInfo) {
        var tipDiv = '<p id="TipDiv" style="background: rgba(0, 0, 0, 0.8); text-align: center; line-height: 16px;color: #fff; ' + 'position: absolute;left: 16%;top: 50%;-webkit-border-radius: 2px;z-index: 9999;display: block; padding: 15px 17px;' + 'transform: translate(-10%, -50%);-webkit-transform: translate(-10%, -50%); width: 84%; font-size: 16px;">' + tipInfo + '</p>';
        $("#TipDiv").remove();
        $(document.body).append(tipDiv);
    }
    function setPwdLevel4Hws(lowId, midId, highId, flag, value, i18n, pwdMinLen, levelChar) {
        var level = "";
        if (value == null || value == '') {
            level = "";
        } else {
            if (levelChar === "low" || value.length < pwdMinLen) {
                level = "low";
            } else if (levelChar === "mid") {
                level = "mid";
            } else {
                level = getPwdStrengthLevel(value);
            }
        }
        setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n);
    }

    function setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n) {
        var defaultColor = "#e2e2e2";
        var lowColor = "#ff4c4c";
        var midColor = "#ff6a00";
        var highColor = "#0a9e00";
        var low;
        var mid;
        var high;
        var flagStr = "";
        switch (level) {
            case "high":
                low = mid = high = highColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthHigh");
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "4px";
                break;
            case "low":
                low = lowColor;
                mid = high = defaultColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthLow");
                $("#" + lowId)[0].style.height = "4px";
                $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
                break;
            case "mid":
                low = mid = midColor;
                high = defaultColor;
                flagStr = "&nbsp;&nbsp;" + i18n("strengthMid");
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = "4px";
                $("#" + highId)[0].style.height = "2px";
                break;
            default:
                low = mid = high = defaultColor;
                flagStr = "&nbsp;&nbsp;";
                $("#" + lowId)[0].style.height = $("#" + midId)[0].style.height = $("#" + highId)[0].style.height = "2px";
        }
        if ($("#" + flag).size() != 0) {
            $("#" + flag)[0].innerHTML = flagStr;
        }
        if ($("#" + lowId).size() != 0) {
            $("#" + lowId)[0].style.background = low;
            $("#" + midId)[0].style.background = mid;
            $("#" + highId)[0].style.background = high;
        }
    }
    function validatePasswdNameSHA256(value, userName) {
        // 比较SHA256的值以保护用户隐私
        if (userName && (CryptoJS.SHA256(value.toLowerCase()).toString() === userName || CryptoJS.SHA256(value.split("").reverse().join("").toLowerCase()).toString() === userName)) {
            return false;
        }
        return true;
    }

    function validatePasswdName(value, userName) {
        if (userName && (value.toLowerCase() === userName.toLowerCase() || value.toLowerCase() === userName.split("").reverse().join("").toLowerCase())) {
            return false;
        }
        return true;
    }

    function removeErrorInfo(id) {
        if ($(id)[0].hasChildNodes()) {
            $(id).empty();
        }
    }
    function showOKImage(infoid) {
        var imgSrc = __webpack_require__(27);
        var imgDom = '<img style="margin-top: 19px;float:left;" src="' + imgSrc + '"/>';
        $(infoid).html(imgDom);
    }
    function addErrorTip(errorTxt, errorInfoid) {
        var imgSrc = __webpack_require__(10);
        var errorDomFragment = '<span><img style="margin-top: -1px;" src="' + imgSrc + '">&nbsp;' + errorTxt + '</span>';
        if (errorDomFragment.replace(/\//ig, "") !== $(errorInfoid).html().replace(/\//ig, "")) {
            removeErrorInfo(errorInfoid);
        } else {
            return;
        }
        $(errorInfoid).html(errorDomFragment);
    }

    function maxRptCharTimes(value, contSameCharLen) {
        if (value === undefined || contSameCharLen === 0) {
            return true;
        }
        if (searchMaxString(value) > contSameCharLen || value.length === 0) {
            return false;
        }
        return true;
    }

    function searchMaxString(origString) {
        var stringLen = origString.length;
        var maxLength = 1;
        var index = 1;
        var flagChar = origString.charAt(0);
        for (var i = 0; i < stringLen;) {
            index = 1;
            for (var j = i + 1; j < stringLen; j++) {
                if (flagChar == origString.charAt(j)) {
                    index++;
                } else {
                    break;
                }
            }
            if (index > maxLength) {
                maxLength = index;
            }
            i = j;
            flagChar = origString.charAt(i);
        }
        return maxLength;
    }

    function getHandlerByType(type, width, i18n) {
        return function (content, detail, id, buttons, closeCallback) {
            var options = {
                type: type,
                content: content,
                "detail-msg": detail,
                width: width,
                "append-to": "#" + id,
                buttons: []
            };
            switch (type) {
                case "error":
                    options.title = i18n("title.error");break;
                case "prompt":
                    options.title = i18n("title.prompt");break;
                case "confirm":
                    options.title = i18n("title.confirm");break;
                case "warn":
                    options.title = i18n("title.warn");break;
            }
            var msg = new tinyWidget.Message(options);
            if (buttons === undefined || buttons.length === 0) {
                var btns = [{
                    key: "btnId2",
                    label: i18n("btnTxtOK"),
                    focused: false,
                    handler: function handler(event) {
                        msg.destroy();
                    }
                }];
                msg.option("buttons", btns);
            } else {
                msg.buttonHandlers = {};
                for (var index = 0; index < buttons.length; index++) {
                    msg.buttonHandlers[buttons[index].label] = buttons[index].handler;
                    buttons[index].handler = function (event) {
                        var originalHandler = msg.buttonHandlers[event.value];
                        msg.destroy();
                        if (originalHandler) {
                            originalHandler();
                        }
                    };
                }
                msg.option("buttons", buttons);
            }

            if (closeCallback) {
                msg.on("close", closeCallback);
            }
            msg.show();
        };
    }

    function getSecurityMasker() {
        return {
            maskMobile: function maskMobile(mobile) {
                if (mobile === "" || mobile === undefined) {
                    return "";
                }

                var countryCode = "";
                var mobileNumber = "";
                if (mobile.indexOf("-") !== -1) {
                    countryCode = mobile.split("-")[0] + "-";
                    mobileNumber = mobile.split("-")[1];
                } else {
                    mobileNumber = mobile;
                }

                if (mobileNumber.length > 5) {
                    return countryCode + mobileNumber.substr(0, 3) + "****" + mobileNumber.substr(mobileNumber.length - 2, mobileNumber.length);
                } else if (mobileNumber.length > 3) {
                    return countryCode + mobileNumber.substr(0, 3) + "****";
                } else {
                    return countryCode + mobileNumber + "****";
                }
            },
            maskEmail: function maskEmail(email) {
                if (!email) {
                    return "******";
                }
                if (email.indexOf("@") === -1) {
                    return "******";
                }
                var pair = email.split("@");
                if (pair.length !== 2) {
                    return "******";
                }
                var pref = pair[0];
                var len = pref.length;
                var beginString = len < 2 ? pref : pref.substring(0, 1);
                var endString = len > 2 ? pref.substring(len - 1, len) : "";
                var maskEmail = "";
                if (len === 2 || len === 3) {
                    maskEmail = "*";
                } else if (len === 4) {
                    maskEmail = "**";
                } else if (len > 4) {
                    maskEmail = "***";
                }
                return beginString + maskEmail + endString + "@" + pair[1];
            }
        };
    }

    function SortArray(sortStr) {
        var sortCode = function sortCode(a, b) {
            a = a[sortStr];
            a = a.substring(a.indexOf("(") + 1, a.indexOf(")"));
            b = b[sortStr];
            b = b.substring(b.indexOf("(") + 1, b.indexOf(")"));
            return a.localeCompare(b);
        };
        return sortCode;
    }
    function getCodeValue(codeObj, value) {
        var codeValue;
        for (var item in codeObj) {
            if (codeObj[item].label === value) {
                codeValue = codeObj[item].id;
            }
        }
        return codeValue;
    }
    function getCountryValue(codeObj, value) {
        var countryValue;
        for (var item in codeObj) {
            if (codeObj[item].id === value) {
                countryValue = codeObj[item].label;
            }
        }
        return countryValue;
    }

    function getPhoneRegex(countryCode, regexJson) {
        if (!regexJson) {
            return;
        }
        var pattern = regexJson[countryCode];
        return pattern;
    }
    function getCountryCode($scope) {
        $.ajax({
            type: "GET",
            url: "/authui/getCountryCode",
            contentType: "charset=UTF-8",
            async: false,
            success: function success(data) {
                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                var codeList = data["codeArray"];
                $scope.model.defaultCode = data["defaultCode"];
                $scope.model.phoneLenObj = data["phoneLen"];
                if (codeList.length) {
                    codeList = codeList.sort(SortArray('label'));
                    $scope.model.codeJson = codeList;
                    for (var item in codeList) {
                        $scope.model.codeArray.push(codeList[item].label);
                    }
                    $scope.model.codeValues = $scope.model.codeArray;
                    $scope.model.defaultValue = getCountryValue($scope.model.codeJson, $scope.model.defaultCode);
                    $scope.model.codeValues = $scope.model.codeArray;
                    $scope.$evalAsync();
                }
            }
        });
    }
    function getPubPhoneLen(codeObj, phoneLenObj) {
        if (!phoneLenObj) {
            return 32;
        }
        var countryCode = getCodeValue(codeObj, $("#codeSelectId").widget().getValue());
        if (getPhoneRegex(countryCode, phoneLenObj)) {
            return getPhoneRegex(countryCode, phoneLenObj);
        }
        return 32;
    }
    function UTCtoLocal(UTCTime, format) {
        var utcTime = new Date(UTCTime.replace(/-/g, "/")); //保证浏览器兼容
        var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset() * 1000 * 60);

        if (tzOffsets === undefined) {
            tzOffsets = getTzOffsets();
        }
        if (tzOffsets[0] !== tzOffsets[1]) {
            //timezone has DST
            var tzOffset = localTime.getTimezoneOffset();
            if (tzOffset === tzOffsets[0]) {
                //DST
                return getTimeString(localTime) + " DST";
            }
        }
        return getTimeString(localTime);

        function getTimeString(date) {
            function normalize(str) {
                return str.length < 2 ? "0" + str : str;
            }

            var time = normalize(date.getHours() + "") + ":" + normalize(date.getMinutes() + "") + ":" + normalize(date.getSeconds() + "");
            if (format.toLowerCase() === "dd-mm-yyyy hh:mm:ss") {
                return normalize(date.getDate() + "") + "-" + normalize(date.getMonth() + 1 + "") + "-" + date.getFullYear() + " " + time;
            }
            if (format.toLowerCase() === "mm-dd-yyyy hh:mm:ss") {
                return normalize(date.getMonth() + 1 + "") + "-" + normalize(date.getDate() + "") + "-" + date.getFullYear() + " " + time;
            }
            return date.getFullYear() + "-" + normalize(date.getMonth() + 1 + "") + "-" + normalize(date.getDate() + "") + " " + time;
        }

        function getTzOffsets() {
            var arr = [];
            for (var i = 0; i < 365; i++) {
                var d = new Date();
                d.setDate(i);
                var newOffset = d.getTimezoneOffset(); //东半球为负，西半球为正， DST提前一个小时
                arr.push(newOffset);
            }
            var DST = Math.min.apply(null, arr);
            var nonDST = Math.max.apply(null, arr);

            return [DST, nonDST];
        }
    }

    function getCurrentTimeZone() {
        var minutes = new Date().getTimezoneOffset();
        var hour = parseInt(minutes / 60, 10);
        var munite = minutes % 60;
        var prefix = '-';
        if (hour < 0 || munite < 0) {
            prefix = '+';
            hour = -hour;
            if (munite < 0) {
                munite = -munite;
            }
        }
        hour = hour + '';
        munite = munite + '';
        if (hour.length === 1) {
            hour = '0' + hour;
        }
        if (munite.length === 1) {
            munite = '0' + munite;
        }
        return 'GMT' + prefix + hour + ':' + munite;
    }

    function getMailbox(value, $scope) {
        function isCompleted(value, suggestions) {
            if (-1 !== value.indexOf("@")) return !0;
            for (var i = 0; i < suggestions.length; i++) {
                if (0 === suggestions[i].label.indexOf(value)) return !0;
            }return !1;
        }

        var i,
            list = [{ "id": "1", "label": "@163.com" }, { "id": "2", "label": "@sina.com" }, {
            "id": "3",
            "label": "@huawei.com"
        }, { "id": "4", "label": "@qq.com" }, { "id": "5", "label": "@gmail.com" }, {
            "id": "6",
            "label": "@126.com"
        }, { "id": "7", "label": "@yahoo.com" }, { "id": "8", "label": "@sohu.com" }];
        if (isCompleted(value, $scope.model.suggestions)) return;
        for (i = 0; i < list.length; i++) {
            list[i].label = value + list[i].label;
        }$scope.model.suggestions = list;
    }

    function getAuthenticationUrl(url, authenUrl) {
        var searchParam = "";
        if (url.indexOf("?") !== -1 && url.indexOf("service") !== -1) {
            searchParam = url.substring(url.indexOf("?") + 1);
        }
        if (!searchParam) {
            url = url + "&service=" + encodeURIComponent(authenUrl);
            return url;
        }
        var params = searchParam.split("&");
        for (var index = 0; index < params.length; index++) {
            var key = params[index].substring(0, params[index].indexOf("="));
            var value = params[index].substring(params[index].indexOf("=") + 1);
            if (key === 'service') {
                url = url.replace(value, encodeURIComponent(authenUrl));
                return url;
            }
        }
        return url;
    }

    function validateCharNum(value, contSameCharLen) {
        if (contSameCharLen == 0) {
            return true;
        }
        var num = 1;
        var finalNum = 1;
        var char = value.charAt(0);
        for (var i = 1; i < value.length; i++) {
            if (char == value.charAt(i)) {
                num++;
                finalNum = num >= finalNum ? num : finalNum;
            } else {
                char = value.charAt(i);
                num = 1;
            }
        }
        return finalNum <= contSameCharLen;
    }

    function validatePasswdChar(value, password_char_combination) {
        var invalidChars = new RegExp("[\u4E00-\u9FA5]+");
        if (invalidChars.test(value)) {
            return false;
        }
        if (getPwdStrengthLevel(value, password_char_combination) !== "high" && getPwdStrengthLevel(value, password_char_combination) !== "mid") {
            return false;
        }
        return true;
    }

    function buildTip(number, chars, maxSameChars, notEqualName, notContsMobile, i18n) {
        var defaultPng = __webpack_require__(41);
        var tip = "<div class='tip-div' style='font-size:12px;font-family:Arial;color:#050505;margin: 5px 0 5px 10px;'>" + "<img id='minLenId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;" + "<div class='tootip-div'>" + number + "</div>" + "<img id='containsCharsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;" + "<div class='tootip-div'>" + chars + "</div>";
        if (maxSameChars) {
            tip = tip + "<img id='maxSameCharsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;" + "<div id='maxSameCharsLabel' class='tootip-div'>" + maxSameChars + "</div>";
        }
        if (notEqualName) {
            tip = tip + "<img id='notNameId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;" + "<div class='tootip-div'>" + notEqualName + "</div>";
        }
        if (notContsMobile) {
            tip = tip + "<img id='notContsId' class='tootip-img' src='" + defaultPng + "'></img>&nbsp;&nbsp;" + "<div class='tootip-div'>" + notContsMobile + "</div>";
        }
        tip = tip + "<div ><div  style='display:inline-block;margin-left:-8px;height:20px;'><span style='float:right' id='strengthflag'></span><span id='strengthHigh' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span id='strengthMid' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span id='strengthLow' class='passwordStrength' style='margin:0;position:relative;top:50%;transform:translateY(-50%);'></span><span style='display: inline-block;float:left;margin-left:27px;margin-right:10px;'>" + i18n("safetyDegree") + "</span></div></div>" + "</div>";
        return tip;
    }

    function getInputObj(id) {
        var inputObj = $("#" + id);
        if (inputObj[0].tagName !== "INPUT") {
            inputObj = $("#" + id + " input");
        }
        return inputObj;
    }

    return {
        i18nFormat: i18nFormat,
        trimSpace: trimSpace,
        getTrimValue: getTrimValue,
        getUrlParams: getUrlParams,
        getPwdStrengthLevel: getPwdStrengthLevel,
        pwdLevel4Display: pwdLevel4Display,
        clearPwdDisplayLevel: clearPwdDisplayLevel,
        getEmailURL: getEmailURL,
        getMessageInstance: getMessageInstance,
        getMobileMessageInstance: getMobileMessageInstance,
        getSecurityMasker: getSecurityMasker,
        SortArray: SortArray,
        getCodeValue: getCodeValue,
        getCountryValue: getCountryValue,
        UTCtoLocal: UTCtoLocal,
        setPwdLevel: setPwdLevel,
        setPwdLevelByLevel: setPwdLevelByLevel,
        getPhoneRegex: getPhoneRegex,
        getCountryCode: getCountryCode,
        getPubPhoneLen: getPubPhoneLen,
        getMailbox: getMailbox,
        EmailRegex: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
        getCurrentTimeZone: getCurrentTimeZone,
        validateCharNum: validateCharNum,
        validatePasswdChar: validatePasswdChar,
        validatePasswdName: validatePasswdName,
        validatePasswdNameSHA256: validatePasswdNameSHA256,
        showOKImage: showOKImage,
        addErrorTip: addErrorTip,
        removeErrorInfo: removeErrorInfo,
        maxRptCharTimes: maxRptCharTimes,
        setPwdLvlByLvl: setPwdLvlByLvl,
        setPwdLevel4Hws: setPwdLevel4Hws,
        buildTip: buildTip,
        getInputObj: getInputObj,
        getAuthenticationUrl: getAuthenticationUrl
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(71), __webpack_require__(3), __webpack_require__(5), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (IAMValidator, i18n, utils, iamEnv) {
    "user strict";

    var iamUtils = {};

    iamUtils.layout = {
        btnMinWidth: "70px",
        searchBoxWidth: "200px",
        inputLabelWidth: "200px",
        inputFiledWidth: "300px",
        inputFiledWidthHalf: "125px",
        inputFieldHeight: "36px",
        scrollHeight: "200px",
        loginInputFiledWidth: "100%",
        loginInputFieldHeight: "48px"
    };

    var iamValidator = new IAMValidator(i18n);
    iamUtils.validator = iamValidator.getCompoundValidator();
    iamUtils.directValidator = iamValidator.getCompoundDirectValidator();
    iamUtils.directValidator.phone = iamUtils.directValidator.phoneAdd;
    iamUtils.unifyValid = iamValidator.unifyValid;

    iamUtils.clearPwdDisplayLevel = utils.clearPwdDisplayLevel;
    iamUtils.getPwdStrengthLevel = utils.getPwdStrengthLevel;
    iamUtils.trimSpace = utils.trimSpace;
    iamUtils.getTrimValue = utils.getTrimValue;
    iamUtils.i18nFormat = utils.i18nFormat;
    iamUtils.getUrlParams = utils.getUrlParams;

    iamUtils.MESSAGE = utils.getMessageInstance("550px", i18n);
    iamUtils.mobileMessage = utils.getMobileMessageInstance("300px", i18n);
    iamUtils.SecurityMasker = utils.getSecurityMasker();
    iamUtils.SortArray = utils.SortArray;
    iamUtils.getCodeValue = utils.getCodeValue;
    iamUtils.getCountryValue = utils.getCountryValue;
    iamUtils.getDomainURL = utils.getEmailURL;
    iamUtils.getCountryCode = utils.getCountryCode;
    iamUtils.needRecordUsername = true;
    iamUtils.getPubPhoneLen = utils.getPubPhoneLen;
    iamUtils.getMailbox = utils.getMailbox;
    iamUtils.setPwdLevel = utils.setPwdLevel;
    iamUtils.getPhoneRegex = utils.getPhoneRegex;
    iamUtils.setPwdLevelByLevel = utils.setPwdLevelByLevel;
    iamUtils.isSupportSms = true;
    iamUtils.getCurrentTimeZone = utils.getCurrentTimeZone;
    iamUtils.getAuthenticationUrl = utils.getAuthenticationUrl;

    function getConfig() {
        var config = {
            homepageUrl: "http://www.huaweicloud.com/?locale={0}",
            HongKongHomepageUrl: "https://intl.huaweicloud.com",
            bssAccountInfoUrl: "https://account.huaweicloud.com/usercenter?locale={0}#/userindex/cusmanagement",
            helpCenterUrl: iamEnv.ipIsInternational() ? "https://support-intl.huaweicloud.com" : "http://support.huaweicloud.com",
            consoleHomeUrl: "https://console.huaweicloud.com/console/",
            userCenterUrl: "https://account.huaweicloud.com/usercenter",
            hkUserCenterUrl: "https://account-intl.huaweicloud.com/usercenter/",
            authenticationUrl: "http://activity.huaweicloud.com/newuser_trial/index.html",
            styleOfSite: "",
            vmallCASUrl: "https://hwid1.vmall.com",
            hasQrlogin: "true",
            hasHwid: "true",
            hasHwCloudLink: "true", //华为ID登录页是否有华为云帐号登录链接
            cbcRegUrl: "https://reg.huaweicloud.com/registerui/cn/register.html?locale={0}",
            cbcRegUrlIntl: "https://reg.huaweicloud.com/registerui/intl/register.html?locale={0}",
            upgradeDescLink: 'https://support.huaweicloud.com/account_faq/faq_id_0050.html'
        };
        for (var key in config) {
            if (Object.prototype.hasOwnProperty.call(config, key) && config[key]) {
                config[key] = utils.i18nFormat(config[key], window.language);
            }
        }
        return config;
    }

    iamUtils.CONFIG = getConfig();
    iamUtils.EmailRegex = utils.EmailRegex;
    iamUtils.redirect2Login = function () {
        var service = iamUtils.getUrlParams()["service"];
        var language = window.language;
        if (service && language) {
            window.location.href = "/authui/?locale=" + language + "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]);
        } else if (service && !language) {
            window.location.href = "/authui/?service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]);
        } else {
            window.location.href = "/authui/?locale=" + language;
        }
    };
    iamUtils.hwPDACloudService = "https://hwid1.vmall.com/oauth2/portal/regbyphone.jsp?service=http%3A%2F%2Fwww1.hicloud.com%3A80%2Fuser%2Fdrump.action%3Furi%3D%2Fuser%2Flogin.action%26lang%3Dzh-cn&loginChannel=1000002&reqClientType=1&deviceID=&lang=zh-cn&InviterUserID=&Inviter=&isFromPC=1&loginUrl=https://hwid1.vmall.com/oauth2/portal/cloud_login.jsp&adUrl=https%3A%2F%2Fwww1.hicloud.com%2Fothers%2Fshow_advert.action%3Flang%3Dzh-cn&viewType=0&isDialog=0&themeName=cloudTheme";
    iamUtils.enterEvent = function (event, callBack) {
        if (event.keyCode === 13) {
            callBack();
        }
    };

    // add style of Russia
    iamUtils.isShowByStyleOfSite = function () {
        return iamUtils.CONFIG.styleOfSite == "Russia" ? true : false;
    };
    // 拆分于iamEnv.js
    iamUtils.ipIsInternational = iamEnv.ipIsInternational;

    //自定义UI4.0风格tip，ele为需要被绑定tip的元素
    //推荐在ng-init中调用此函数，以免出现元素未初始化的情况
    iamUtils.showTooltip = function (ele, content, maxWidth) {

        if (!(ele instanceof jQuery)) {
            return;
        }

        var tipHtml = '<div class="iam-ti-tooltip iam-ti-tooltip-top-left" \
                            style="display: block;"> \
                            <div class="iam-ti-tooltip-content"  \
                            style="overflow-y: auto; padding: 1px; white-space: normal;"> \
                            TIP_CONTENT</div>\
                    <div class="iam-ti-tooltip-top-left-sqr"></div></div>'.replace('TIP_CONTENT', content);

        var tip;
        var isShown = false;
        var maxW = maxWidth ? maxWidth : '320px';

        var addTip = function addTip() {
            var pos = ele.first().offset();
            tip = $(tipHtml);
            tip.css('left', pos.left);
            tip.css('max-width', maxW);
            $(document.body).append(tip);
            tip.css('top', pos.top - tip.outerHeight() - 14);
            tip.mouseleave(function () {
                tip && tip.remove();
            });
            isShown = true;
        };

        ele.mouseenter(function () {
            //光标进入元素区域，显示tip
            setTimeout(function () {
                if (ele.is(":hover") && !isShown) {
                    addTip();
                }
            }, 500);
        }).mouseleave(function () {
            //若光标移动到tip上，不自动消失
            setTimeout(function () {
                if (tip && !tip.is(":hover")) {
                    isShown = false;
                    tip && tip.remove();
                }
            }, 300);
        }).on('keypress', function (e) {
            //回车后移除tip
            if (e.which == 13) {
                tip && tip.remove();
            }
        }).click(
        //兼容移动端触摸场景
        function () {
            if (ele.is(":hover") && !isShown) {
                addTip();
            }
        }).blur(function () {
            tip && !tip.is(":hover") && tip.remove();
        });
    };

    iamUtils.initialCloudBI = function (url, params) {
        var biInterval = setInterval(function () {
            if (window.init && onPageView) {
                initialCloudBI();
                addPageView4CloudBI(url, params);
                clearInterval(biInterval);
            }
        }, 1000);
    };

    iamUtils.pages = {
        login: "iam_loginwebsite_login",
        upgrade: "iam_loginwebsite_upgrade"
    };

    return iamUtils;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(93);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = " <style ng-if=\"!model.ipIsInternational && model.currentLanguage !== 'zh-cn'\">@media only screen and (max-width:1920px){#footer .footer-content{height:38px}#footer .footer-content.unfold{height:61px}}@media only screen and (max-width:1680px){#footer .footer-content{height:38px}}@media only screen and (max-width:1440px){#footer .footer-content{height:38px}}@media only screen and (max-width:1366px){#footer .footer-content{height:38px}}@media only screen and (max-width:1280px){#footer .widthLimit{margin:0;padding:0}#footer .footer-content.fold{height:65px;display:flex;flex-direction:column-reverse;align-items:center}#footer .footer-content.unfold{height:79px;display:flex;flex-direction:column-reverse;align-items:center}#footer .copyrightDiv{text-align:center;margin-bottom:15px}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:1024px){#footer .widthLimit{margin:0;padding:0}#footer .footer-content{height:109px;display:flex;flex-direction:column-reverse;align-items:center}#footer .copyrightDiv{text-align:center}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:768px){#footer .footer-content.fold{display:none}}</style> <style ng-if=\"model.ipIsInternational\">@media only screen and (max-width:1920px){#footer .footer-content{height:38px}}@media only screen and (max-width:1680px){#footer .footer-content{height:38px}}@media only screen and (max-width:1440px){#footer .footer-content{height:38px}}@media only screen and (max-width:1366px){#footer .footer-content{height:38px}}@media only screen and (max-width:1280px){#footer .footer-content{height:65px}#footer .widthLimit{margin:0;padding:0}#footer .copyrightDiv{text-align:center;margin-bottom:15px}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:1024px){#footer .widthLimit{margin:0;padding:0}#footer .footer-content{height:65px;display:flex;flex-direction:column-reverse;align-items:center}#footer .copyrightDiv{text-align:center}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:768px){#footer .footer-content{display:none!important}}</style> <div ng-if=\"!model.ipIsInternational\" class=\"footer-content\" ng-class=\"{'unfold': model.showICP, 'fold': !model.showICP}\"> <div class=\"copyrightDiv\"> <span class=\"right-space\" ng-bind=\"model.copyRight\"></span><span ng-if=\"model.currentLanguage !== 'zh-cn'\" class=\"swapClick\" ng-class=\"{'unfold': model.showICP, 'fold': !model.showICP}\" ng-click=\"swapICP()\"></span> <div class=\"right-space\" ng-if=\"model.showICP\"> <a class=\"link\" ng-bind=\"i18n('copyrightNotice3')\" href=\"http://beian.miit.gov.cn/publish/query/indexFirst.action\" target=\"_blank\" rel=\"noopener noreferrer nofollow\"></a> <span ng-bind=\"i18n('copyrightNotice4')\"></span> <a href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000093\" target=\"_blank\" rel=\"noopener noreferrer\"> <img style=\"vertical-align:sub\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" alt=\"\"> </a> <a href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000093\" target=\"_blank\" rel=\"noopener noreferrer\" ng-bind=\"i18n('copyrightNotice5')\"></a> </div> </div> <div class=\"otherLinkDiv\"> <span id=\"laws\"> <a ng-if=\"footer.legalNotice\" ng-bind=\"i18n('legalStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.legalNotice }}\"></a> <span ng-if=\"footer.privacyProtect\">|</span> <a ng-if=\"footer.privacyProtect\" ng-bind=\"i18n('privacyStrategyStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.privacyProtect}}\"></a> <span ng-if=\"footer.cookies\">|</span> <a ng-if=\"footer.cookies\" ng-bind=\"i18n('hwId.cookies')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.cookies}}\"></a> </span> </div> </div> <div ng-if=\"model.ipIsInternational\" class=\"footer-content\"> <div class=\"copyrightDiv\"> <span class=\"right-space\" ng-bind=\"model.copyRight\"></span> <div class=\"right-space\" ng-bind=\"model.copyRightForHongKong\"></div> </div> <div class=\"otherLinkDiv\"> <span id=\"laws\"> <a ng-if=\"footer.siteTerms\" ng-bind=\"i18n('siteTerms')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.siteTerms }}\"></a> <span ng-if=\"footer.privacyProtect\">|</span> <a ng-if=\"footer.privacyProtect\" ng-bind=\"i18n('privacyStrategyStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.privacyProtect }}\"></a> <span ng-if=\"footer.cookies\">|</span> <a ng-if=\"footer.cookies\" ng-bind=\"i18n('hwId.cookies')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.cookies}}\"></a> </span> </div> </div> <div ng-if=\"model.styleOfSite\" class=\"footer-content-russia\"> <div id=\"russia_follow_us\" class=\"col-md-6-left\" style=\"vertical-align:middle;margin-left:10px;cursor:pointer\" ng-click=\"model.toFacebook()\"> <p style=\"float:left;margin-top:5px\">Follow Us</p> <img id=\"facebook_pic\" ng-src=\"~custom/images/russia_facebook.png\" style=\"margin-left:10px\"> </div> <div class=\"col-md-6-right\"> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.paymentMethods }}\">Payment Methods</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.userAgreement }}\">User Agreement</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.contactUs }}\">Contact Us</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.privacyPolicy }}\">Privacy Policy</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.cookies }}\">Cookies</a> </div> </div> ";
// Exports
module.exports = code;

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var cookieOp = {};

    cookieOp.addCookie = function (name, value, expiresMillis, path) {
        var cookieStr;
        if (this.hasCookie(name)) {
            this.delCookie(name);
        }
        if (value) {
            cookieStr = name + "=" + encodeURIComponent(value);
        }
        var expiresTime = Number(expiresMillis);
        if (!isNaN(expiresTime) && expiresTime > 0) {
            var date = new Date();
            date.setTime(date.getTime() + expiresTime);
            if (path) {
                cookieStr += ";path=" + path + "; expires=" + date.toUTCString();
            } else {
                cookieStr += "; expires=" + date.toUTCString();
            }
        }
        if (value) {
            document.cookie = cookieStr + ";secure";
        }
    };

    cookieOp.getCookie = function (name) {
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");

        for (var i = 0; i < cookieArray.length; i++) {
            var arr = $.trim(cookieArray[i]).split("=");
            if (arr[0] === name) {
                return decodeURIComponent(arr[1]);
            }
        }
        return undefined;
    };

    cookieOp.delCookie = function (name) {
        var date = new Date();
        date.setTime(date.getTime() - 10000);
        //设置cookie的过期时间为过去的某个时间
        document.cookie = name + "=v; expires=" + date.toUTCString();
    };

    cookieOp.hasCookie = function (name) {
        return this.getCookie(name) != undefined;
    };

    cookieOp.setCookie = function (name, value, expiresMillis) {
        this.addCookie(name, value, expiresMillis);
    };

    cookieOp.DEFAULT_EXPIRES_TIME = 30 * 24 * 3600 * 1000; //30天

    return cookieOp;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  }

  if (options.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(url)) {
    return "\"".concat(url, "\"");
  }

  return url;
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * 环境配置，要与其他东西分离，防止循环引用
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var ENV = {};

    // 根据IP判断是否显示国际站
    ENV.ipIsInternational = function () {
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");
        for (var i = 0; i < cookieArray.length; i++) {
            var arr = cookieArray[i].toString().split("=");
            if (arr[0].trim() === "Site") {
                // mainland国内IP intl国际IP
                return decodeURIComponent(arr[1]) === "intl";
            }
        }
        return false;
    };

    ENV.IS_PUBLISH_ENV = true;

    ENV.SERVER_CONFIG = {
        "PROTOCOL": "https",
        "SERVER_IP": "",
        "SERVER_PORT": ""
    };

    ENV.isPublishEnv = function () {
        // 是否是发布环境
        if (ENV.IS_PUBLISH_ENV !== undefined && ENV.IS_PUBLISH_ENV !== "") {
            return ENV.IS_PUBLISH_ENV;
        }
        return true;
    };
    ENV.getUrlPrefix = function () {
        var protocol = ENV.SERVER_CONFIG.PROTOCOL;
        var ip = ENV.SERVER_CONFIG.SERVER_IP;
        var port = ENV.SERVER_CONFIG.SERVER_PORT;
        var url_pre = "";
        if (protocol !== "" && ip !== "" && port !== "") {
            url_pre = protocol + "://" + ip + ":" + port;
        }
        return url_pre;
    };

    return ENV;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var VersionCheck = __webpack_require__(88)
var Regex = __webpack_require__(87)

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var toSJISFunction
var CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  var digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var verifycodeSuccess = __webpack_require__(27);
    var verifycodeFail = __webpack_require__(10);
    var validUrl = "/authui/preValidVerifycode";

    function changeToSuccessImg(imgWidget) {
        imgWidget.attr("src", verifycodeSuccess);
        imgWidget.show();
    }

    function changeToFailImg(imgWidget) {
        imgWidget.attr("src", verifycodeFail);
        imgWidget.show();
    }

    function clearVerifycodeImg(imgWidget) {
        if (imgWidget.src !== "") {
            imgWidget.hide();
        }
    }

    function validateVerifyCode(verifycode, imgWidget) {
        // 过滤掉ios中文输入法下可能出现的特殊空格字符
        verifycode = verifycode.replace(/\u2006/g, "");
        if (verifycode === "" || verifycode === undefined) {
            clearVerifycodeImg(imgWidget);
            return false;
        }
        if (verifycode.length < 4) {
            changeToFailImg(imgWidget);
            return false;
        } else {
            return true;
        }
    }

    function substrVerifyCode(verifycode) {
        if (verifycode === "" && verifycode === undefined) {
            return "";
        }
        if (verifycode.length > 4) {
            return verifycode.substring(0, 4);
        } else {
            return verifycode;
        }
    }

    function checkVerifyCode(imgWidget, verifycode, index, callback, iamHttpService, i18n) {
        iamHttpService.post({
            url: validUrl,
            params: {
                verifycode: verifycode,
                index: index
            }
        }).then(function (data) {
            if (data === "success") {
                changeToSuccessImg(imgWidget);
            } else {
                changeToFailImg(imgWidget);
                callback();
            }
        }, function () {
            if (i18n) {
                // 接口异常 提示用户刷新页面
                angular.element("#serverError").removeClass("ng-hide");
                angular.element("#serverError").css("display", "block");
                angular.element("#serverError>span:first").text(i18n("systemException"));

                setTimeout(function () {
                    angular.element("#serverError").addClass("ng-hide");
                    angular.element("#serverError").css("display", "none");
                    angular.element("#serverError>span:first").text("");
                }, 10000);
            }
        });
    }

    function preValidVerifyCode(imgWidget, verifycode, index, callback, iamHttpService, i18n) {
        if (validateVerifyCode(verifycode, imgWidget) === false) {
            return;
        }
        checkVerifyCode(imgWidget, substrVerifyCode(verifycode), index, callback, iamHttpService, i18n);
    }

    return {
        preValidVerifyCode: preValidVerifyCode
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Implementation of a subset of node.js Buffer methods for the browser.
 * Based on https://github.com/feross/buffer
 */

/* eslint-disable no-proto */



var isArray = __webpack_require__(60)

function typedArraySupport () {
  // Can typed array instances be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff

function Buffer (arg, offset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, offset, length)
  }

  if (typeof arg === 'number') {
    return allocUnsafe(this, arg)
  }

  return from(this, arg, offset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array

  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    })
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

function createBuffer (that, length) {
  var buf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    buf = new Uint8Array(length)
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = that
    if (buf === null) {
      buf = new Buffer(length)
    }
    buf.length = length
  }

  return buf
}

function allocUnsafe (that, size) {
  var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0)

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      buf[i] = 0
    }
  }

  return buf
}

function fromString (that, string) {
  var length = byteLength(string) | 0
  var buf = createBuffer(that, length)

  var actual = buf.write(string)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (that, array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = fromArrayLike(that, buf)
  }

  return buf
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(that, len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function byteLength (string) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  return utf8ToBytes(string).length
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function from (that, value, offset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, offset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, offset)
  }

  return fromObject(that, value)
}

Buffer.prototype.write = function write (string, offset, length) {
  // Buffer#write(string)
  if (offset === undefined) {
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
    } else {
      length = undefined
    }
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  return utf8Write(this, string, offset, length)
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

Buffer.prototype.fill = function fill (val, start, end) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : new Buffer(val)
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return createBuffer(null, 0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = allocUnsafe(null, length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

Buffer.byteLength = byteLength

Buffer.prototype._isBuffer = true
Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

module.exports.alloc = function (size) {
  var buffer = new Buffer(size)
  buffer.fill(0)
  return buffer
}

module.exports.from = function (data) {
  return new Buffer(data)
}


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAFMandsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATZJREFUeNpi+P//P4PtqWUNIJoRyFjAwMAQD8SNDMgyAAHECCJAgMXu9HIHIL0fLgIQQGAGUBTCA4JDppGMTAxYAEAAwVQmQFUtANn3H1kFsjZBdIH3WM0ACCCYgAGQfx6LpYZARRdAFoF0zMeiwBHkGyBORHezIcwRUAUofsBrHUAAwcMGqFABSCVAJRcAJR8gmwLiyKOZ8BCoSAE5JrCBhUw4JBOhdDwTFkEQXQATZEFSMAGIFYF4AxDrI0fGQiibH4jvI0uC5Aj7glA4AAQYXAFUkQDULbi8zQB1UgHQgA/oUQLSfAGLU/CBh0BsADIMFOAKUE8SCz5CAwYGFJmQ/IhsAwOOiAKlrgdo4gnYso4ANDkmomkugGYLfXQNIEMWoInxQ5PsBGiix6kZFkvUCVhqRDEAN06lVCS9fmEAAAAASUVORK5CYII="

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTc4cHgiIGhlaWdodD0iMTc4cHgiIHZpZXdCb3g9IjAgMCAxNzggMTc4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA2MC4xICg4ODEzMykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+5LqM57u056CB6IOM5pmvPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9Iumhtemdoi0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5LqM57u056CB6IOM5pmvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgc3Ryb2tlPSIjRTlFREZBIiBmaWxsPSIjRkZGRkZGIiB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE3NSIgaGVpZ2h0PSIxNzUiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSLnm7Tnur8iIHN0cm9rZT0iIzI1MkIzQSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgcG9pbnRzPSIxNzAgMCAxNzYgMCAxNzYgNiI+PC9wb2x5bGluZT4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSLnm7Tnur/lpIfku70iIHN0cm9rZT0iIzI1MkIzQSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy4wMDAwMDAsIDMuMDAwMDAwKSByb3RhdGUoLTkwLjAwMDAwMCkgdHJhbnNsYXRlKC0zLjAwMDAwMCwgLTMuMDAwMDAwKSAiIHBvaW50cz0iMCAwIDYgMCA2IDYiPjwvcG9seWxpbmU+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0i55u057q/5aSH5Lu9LTIiIHN0cm9rZT0iIzI1MkIzQSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy4wMDAwMDAsIDE3My4wMDAwMDApIHJvdGF0ZSgtMTgwLjAwMDAwMCkgdHJhbnNsYXRlKC0zLjAwMDAwMCwgLTE3My4wMDAwMDApICIgcG9pbnRzPSIwIDE3MCA2IDE3MCA2IDE3NiI+PC9wb2x5bGluZT4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSLnm7Tnur/lpIfku70tMyIgc3Ryb2tlPSIjMjUyQjNBIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzMuMDAwMDAwLCAxNzMuMDAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTczLjAwMDAwMCwgLTE3My4wMDAwMDApICIgcG9pbnRzPSIxNzAgMTcwIDE3NiAxNzAgMTc2IDE3NiI+PC9wb2x5bGluZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23), __webpack_require__(4), __webpack_require__(71), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (perVerifycodeUtil, iamHttpService, IAMValidator, utils) {
    var html = __webpack_require__(228);
    function getOptions() {

        var width = "410px";
        var height = "250px";
        if (window.language != "zh-cn") {
            width = "550px";
            height = "280px";
        }
        return {
            height: height,
            width: width,
            content: html,
            "content-type": 'url',
            resizable: false,
            isMobile: false,
            isMobileApp: false
        };
    }

    function addCssToPage(href) {
        var head = document.getElementsByTagName("head")[0];
        var cssLink = document.createElement("link");
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = href;
        head.appendChild(cssLink);
    };
    function GraphicVerifyWindow(i18n, options, btnCallbacks, verifyCodeIndex) {
        var winOptions = getOptions();
        $.extend(true, winOptions, options);

        if (winOptions.isMobile == true || winOptions.isMobileApp == true) {
            addCssToPage("/authui/public/base/mobile/css/graphVerCode.css");
        }
        if (winOptions.isMobile === true) {
            var width = 300;
            var height = 210;
            winOptions.width = width + "px";
            winOptions.height = height + "px";
        }
        if (winOptions.isMobileApp === true) {
            var width = 300;
            var height = 210;
            winOptions.width = width + "px";
            winOptions.height = height + "px";
            winOptions.isMobile = true;
        }

        var okCallbacks = $.Callbacks();
        var cancelCallbacks = $.Callbacks();
        if ($.isArray(btnCallbacks)) {
            okCallbacks.add(btnCallbacks[0]);
            btnCallbacks[1] && cancelCallbacks.add(btnCallbacks[1]);
        } else if ($.isFunction(btnCallbacks)) {
            okCallbacks.add(btnCallbacks);
        }

        var okBtnConfig = {
            key: "btnOK",
            label: i18n("btnTxtOK"),
            focused: true,
            handler: function handler() {
                $("#btnOK").addClass("DelHoverStyle");
                var iamValidator = new IAMValidator(i18n);
                if (!iamValidator.unifyValid.FormValid($("#GraphicsVerification"))) {
                    iamValidator.unifyValid.focusFirst($("#GraphicsVerification"));
                    return;
                }

                var verifyCode = $("#graph_verifyCode").widget().getValue();
                if (verifyCode.length >= 4) {
                    okCallbacks.fire(verifyCode);
                }
            }
        };

        winOptions.buttons = [{
            key: "btnCancel",
            label: i18n("btnTxtCancel"),
            focused: false,
            handler: function handler() {
                cancelCallbacks.fire();
            }
        }];

        if (winOptions.isMobileApp === true) {
            winOptions.buttons.push(okBtnConfig);
        } else {
            winOptions.buttons.unshift(okBtnConfig);
        }

        $(document).keydown(function (event) {
            if (event.keyCode === 13) {
                var id = $(document.activeElement).attr("id");
                if (!id) {
                    id = $(document.activeElement.parentNode).attr("id");
                }
                if (id === "graph_verifyCode") {
                    $("#btnOK").click();
                }
            }
        });

        var window = new tinyWidget.Window(winOptions);
        okCallbacks.add(function () {
            window.destroy();
        });
        cancelCallbacks.add(function () {
            window.destroy();
        });
        this.window = window;

        initController(i18n, verifyCodeIndex, winOptions.isMobile);
    }

    GraphicVerifyWindow.prototype.show = function () {
        this.window.show();
        $(".overview").html(html);
    };

    function initController(i18n, index, isMobile) {
        var ctrl = function ctrl($scope) {

            function getVerifyCode(index) {
                return "/authui/verifycode?index=" + index + "&alt=" + Math.random();
            }

            $scope.model = {
                inputId: "graph_verifyCode",
                focused: true,
                InputGrapVerifyCodeInfo: i18n("InputGrapVerifyCodeInfo"),
                GraphicsVerifyCode: i18n("GraphicsVerifyCodeLabel"),
                checkCodeTip: i18n("getVerifyCode"),
                verifyCodeSrc: getVerifyCode(index),
                verifyCode: "",
                tipPosition: "top",
                checkCodePH: "",
                isMobile: false,
                isMobileApp: false
            };

            if (isMobile === true) {
                $scope.model.checkCodePH = i18n("verifyCodePlaceHolder");
                $scope.model.isMobile = true;
            } else {
                $scope.style = {
                    verifyCodeInfo: { "margin-left": "10%", "margin-top": "4%" },
                    verifyCodeContent: { "margin-left": "10%", "margin-top": "5%" }
                };
            }

            $scope.model.msgKeyPress = function (event) {
                if (event.keyCode === 13) {
                    $("#btnOK").click();
                    $scope.$apply();
                }
            };
            var iamValidator = new IAMValidator(i18n);
            $scope.model.checkCodeValidator = [iamValidator.limitLength(4), iamValidator.notBlank(), iamValidator.maxLen(4)];

            $scope.model.getVerifyCode = function () {
                $("#GrapVerifyCodeImg")[0].src = getVerifyCode(index);
                $("#" + $scope.model.inputId).widget().option("value", "");
                $("#validresultImg").hide();
            };

            $scope.model.preValidVerifyCode = function (event, value) {
                $("#" + $scope.model.inputId + " input").attr("maxLength", 4);
                var img = $("#validresultImg");
                perVerifycodeUtil.preValidVerifyCode(img, value, index, preValidCallback, iamHttpService);
            };

            function preValidCallback() {
                $("#" + $scope.model.inputId).widget().option("value", "");
                $scope.$apply();
                var verifyCodeImg = $("#GrapVerifyCodeImg")[0];
                if (verifyCodeImg) {
                    verifyCodeImg.src = getVerifyCode(index);
                }
            }
        };

        ctrl = ["$scope", ctrl];

        var iamModule = angular.module('authui.config');
        iamModule.controller('graphicVerifyCode.ctrl', ctrl);
    }

    return GraphicVerifyWindow;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAXJJREFUOBG1lb1OwzAQx+/ctIkQgr2oGWAANpD6ADwBKjwAI+xIRUwoYkIqLwAjDwB9CMYMTDC1QyrKhlgQaqra+J8PFCJHARo8xPb57uezfXdhMrTDK1UPn4OOVKqjl9tE3IzV1Fj3vmDuN1bc/vURT/PmnBccnI32WMqeIrWWX8vOmXighOjenLfuvsuTmecpMZTBBUnVzSqUjgX3VoV76nksoWulBn+CwVg7MKQAoxN8oiPjmCRntxAUtUadKZyqomUiUdvH8RkPMBkFT6Y7291Zoq11m5YXLVpwmI4vX+hjYobiTu2WuynwmiYYXHl9m9HjICSRPJ0ZFTsNBlhWEhrGo9w/vEfy7Q2HHLtm1MkKwRJaoOOsstbWwDRoq4ByEx5W2jQwSqeKoGoMD/2KaMD4AoleFRAsgaqBoJwXCkbM0qSfpF7phknqRa8clSBdNUqNihS0bVrGvsIGJUjn2O+hSflK9/q/ApvugH6eX8AnYOKWmjntITYAAAAASUVORK5CYII="

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAqRJREFUOBGtlU1oE0EUx+dNNrUpavHgwUg39SaC0ENQ6aGCV1HbUxG0Tf0o6FktColjCtWqePWL1ra3QqARpBdP6qWVnMVbk42NoGKRljSku/N8b5sN2+0WRRzYzOyb//xm3s57LyBCmlJoFLXVpxF7aTopBMQ3ZVihviAB8p3SnFMK7OByCBoGMuU+0PqRAFEEELNSG+9bjegy62r2xkEt7R5E0S9QdKKUN2eyHXN+RhOIiDB41xoHFL1SyKuvRjve+YXB8VC6fFIL/RJB5KfvmSMAtJJaEziQKT0k04m2NnHu6e3EShAQ9n7tfmlftSpeE3RhJpu4xRrJP66bdLKdYCmFrewBa/2NN+Y17BUzeA74ApZs67MEeTno5iVlJR0Hn9E36yJaRUjM7ZItYy9U/Icf7LqPeuKQYR6WfJt8AUHY8IOf7Y6t39DuBcMAE4zIWTrkGbqYx34Yj921xGCWwaFBYTAbFNWrq8doo3aItaQn7xz4TvOVwXRxWgCcD2r5nSOCWQaNkxQa2aBoKpt4S7bYFjuKOG3ycYut8cLhpWHjBgEh7sVZmNCzpdSXLrTtC5EInPJs/p4Za44dd2/ZPxE2Hhr7uh9tJwcg1aQyC2GaWoycpkZArHAGhInYdl192+1U6/Pk6oepUfPJTjqxWqf0xAqfsMDpFCYcfo7RNWc9R7Dl00fNK2Eaz9ZgFCQnupub3kyj50Cula0Jytk9MrI3Nf9JRDnA+aHY3fapmMEsyVWDE52D089MZawj5MJFerq1/WtF26V171nS5X6/1l1LDGa5H3Iz9fQ4pdHxv81jD9jI50UEOcKVxz06DyhT85zoLPDEf+p9xSHvlbHmt+ASRNAFgi4G3Q8Ds4a1vIbXepptFeS/FVhvB+65Av3rX8BvlP5euq/kErIAAAAASUVORK5CYII="

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAiNJREFUOBGtVc1rE0EU/73JZpP20KStYmlJhFgpRauXeil4ln5B9aAQUG/qP1DxJKGnQv8CPYlXQYsgCoI9qIe2gRZ6aA9tKBsapCJYS0qbmB3nTbLN7mYbQ/XB7rzP38689+YtIYAePJPh0o41ZUs5pczDAPVW3WRBrVlBNG/2JeefP6SyP5z8intP8zfJtuck5AW/zS0TaEsKMf1yJvHGq69JmYwUOduahS2n3Q5/5QXNpUTySSZDNvsaTsCpwDhYbSAHi7nH/NJH5mPCrrxmRRCFDUL5twwy1XUidIuPT1yAo7y1HpSzS6kI0mNxdMVC2LRK+LJ6gMW1gzqIi+OcRhLJQcHVDALrOWPg0e1uHfLq4x6iUcL9yTjOxo+z5IIDGIOxRK01PEYWOHBj+wjvPu/j01IRK+uHIJWgKwORBl9HwVj8OdVnjbS2eQh+HEolTM1a3xpaz3HhdVjUm9at9/IXz5vgfBa+l5HLl7xGj0S9CrA5RU3C3fE4KqrLXrz9qddmEQpQX6cTfdKjqhCdBj583Ue++XEVhizwDrMnoY1cbce1y236qO8VYAuUNfiiq+qk/c7dMQN3bsS0+sdeBRPXOzT/q1jBwnLR765lxjJ4aqjG3vL34rmuEMxwdXYM9Ucx1F/F2NktBwJyYzNWS1cvcDt+Ze3q6SrrEaSmht+nZVnFOmPsuG14BOE0oLXx5Xy8miRHUut/G7AuTPzLL+APYOTY0W1RETMAAAAASUVORK5CYII="

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAArZJREFUOBGtVU1IVFEUPufOk3JyI21ickalTdGiCIMgqJUtSzf9UPhTZPRDRPRDwdjLCSJdtIoQ0cpdbdRdu6yVgVAtgn7AxqdNVFgLS03v3Nv5Xj153rFVXpg55577ne/ec8859zEtM3zfenkTNBprG2S5johTf2C2IHJUMQ/WqMyA77N23dk1NLVPNLIxXcSUZ6aHynjPVntlH4Gb0wvrjdK7rKUDZKnGKnWxvyM9EOdYJLTWcvO14BZbalCkjt/LpZ/Gga7emp3Ybcj0WKbBB9czl5nFU8YiYVP7eKeYdiSTtO/ulervLsFy85M3xytnZmhISEf6O6ovAaPwF4YpJ/sXWVu3LQPOHdgYPogKHFhnJOCDDt4oVsfcMFv8ya1GF88x2QY5xWcm9ag2kc5JMubj5GH41vTWepmNCtlEAlyyNr+QtFo/JrY/K5LeBo+8/UTmyJgO9sbJoIe+wgEuhdJANl2QpoV1lng4Ub7Kv3O1aqovV/VKLn5I7v6wi8UcHODyRK+T0uhwQX1+9ZjYDkb2sAqywU5S/CSyxSXKy/DCBSHkVFRncUCkt/r5bcUinW7JBvVyipeJNclctBaX4PhR1Kkwy/EFV7c6Mc3Eb4nsaym0TWb212YXg/lcuWwnQ05oC+gA0cWpdNy/kX4v1k78mrL5Xsk6TlhfgpyeT0kCC7jDUbSTyCWER7OTWzTps2srE2dun0/P/iV4IRWxp4RMDCGHpVEPjS69eUJsPUuACfOVNB+a+mYCKaEuZF3uskWwyyYF/S1c3QqvBhodxRkn7PMzBaWkC5i2zxXnPxU1DUtIw2WeOhfHQQ99hSPkggFt05wdf4fexNwdp/wvFSgb1445fOC72HoRaEUfB5DiCZIzjMjr8dwNP9o0LoEBFj7wjdZKwghfnpV4YKMdIP/nE/Ab8dBeuJ1OF+4AAAAASUVORK5CYII="

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAklJREFUOBGtVc1rE0EU/81mTbpJpRK1SqWrWLHWosU2KCIK6lEPVW9ShHowf0HVkwYPIuQvUPDixYOgxUsRQfCgB42IKFqUVkw0amslJtom2Y9x3iRbN9ndVKoPdubN+555H8vgA2eu8hXVT9lhm/NhwU4ArKsmxvNizyiMjYc36OPXksxoVmfNhFMXcseYbac5eE8zz31mYFNcUcZuXOq+00ivn1Iprkzb2Suw+ZhbYElcYenNin4+lWI2yaqOwrKMkbIIYBpZws7SIq9M14Rt3SaCH6ghwLT8OC6aEjpO12eUgEou+8bvzXo3RnBodwz9PW34PGfg+WQZ9x6XYPkYpzeNdOt9oR2Dp09wzpMuXxJds0rFudG1iGoK7j4sIt4Rwr6BKMCBtx+qzeJ0jts/iy/Veml4BErzFi5fn8V82UahZOFbwcS2TRGsW7347B4dsqUIqqgzL1SqHPlZA1XDhr4+jANDMSn04l3ZK/yHkhDuqGjFPQJgV28UI0c7JPfpqwXQFwysiyJsCVMfK7h1/wdyXw0k+jUMbddayguDsp0Chb7MmXjw5BduThTARJHtpcQEAs9ThBk//s6tbbiY7MSR/Ssl25J9ALRrnm51q2dUanSRnZNuKuEzIrLOuIrDe9ola0A4IJh871sykke2Whb2YJ+Gg4kYtuhhzHw38ex1GROPijBMqd+wOIX9V62nRRgWKsGVUAuv1noyy3IEianR4NJ1WNoYSztjbLFsaAShhVGX/Ua0Pr4coidl/23AOh5o/5dfwG8CLu0pw7kVVwAAAABJRU5ErkJggg=="

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADkklEQVRYR51X0VHcQAxdsc5vQirIUUHwnPwdqCBQQaACoAKOCgIVBCoAKuDybd0YKshdAZnAv40yz7P2rJf12Yd+mOF2V09P0pNMZgPL8/y7MWaPiHZVdRt/cV1VH4no2RizVNW7LMvuxz5LQweLotiuquqnMebAGLM9dN79DjB31tqLNE2X6+70AoDj19fXE1U93cBx6OuZiC63trau0jQFqDcWBQDnZVk+NBSPjLr3GFKUJMl+DMQbAEVR7FZV9dAT9QrUGmPm1tplmqaP8OruTFAfLlVfImierbUAUd9prAPA5ftPxPmKiGbT6fR6DBuLxeJIVWfGmBAIQOz4TLQA1tB+b609ai4VRTGpqupcVXe9FCG/c7DDzDeOFRQvAKNzWgvT0QLI83xGROdBhDfMfNT8r+dM54pzcNxQLSIA8SMAcZFlGRgyNQAXVRFQ33HuaP01JgXGmA7VIoK68ZnA7ylatAYQQbmy1u76uRIR0PzJAwCxuVZVtBo04qRTXERn0+n00ksHis+viTrABsA/P3oiOvYLLs9zqB86o7EnZq5VsC89qvo7yzJ0RW0RBp+Z+TOJCNDfem+tmBkt1dpisThVVahhbeRF5wEYBCkiUEWfhUMACIvkipmhfq2hRsqybEElSfIYikrIUsgAHhMRpMRP1Q3leT4nom+ev0NmRtFsZOE7qtpWevNQyDZAAkDhS66rzo5arUPixAvdgVQ29uKKuDOInGKi22qrp6iIqO+AmQcnZHPepeY2mBlwvhdKrsdCx9+7AbjIEY1fsE9ONXsZDAMGABz+2iAcm4JI98A5Io+OXbwfpsAY8/TuIgxleQzwaBGOacNYEYYAxtROzFdMiJbMvLNRD448LCIY9W3NqOp+I8UdnQ+leOT7a49FpPiFmbf7htHS5bS3oDZp355Fp1ZcfxyjG/xpd83Mx31hbQJARDBrQqGaoGOGFpJeEGMBiAhUsl1qnAJ2FxLXo1ihsFa1muCiv7bWnkWGz19jzIeGoSzLPvps9Ug0jnRGeWwphX77qcAl/G/W7HtDRSkiWMEw+cIPmTeLTt9aDiZCEDUQfHphAU2SZOWv5WVZYs5jJ0CuO/uEAwznB2vXcm/I9KVjKPi+33tleu2nWVmWp0SE5STGxhgwL6p62WzAsQuDo9dtzFihQe1YIC/u4/R03XACoEEAPmo3TA5UdUJEKLCmY57cdgwtmW+yUf0HsHM9+E6+42QAAAAASUVORK5CYII="

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAFRSURBVDhPrZU7TsNAEIYnWwAFSRQeHREQQUkHFWeAA8B9cgEkOioUDgDHCFRBAgkUQNDxiBJSQIqE/ca7EQ7Gwng/yZY98vya3Zn9XRhZZILhUKTZetGr/diXTvdT45XytNSqs7K1saCXMRqO8UOw2XqVxmlbFudm5Pah56Jx1pZL8vz2Ifu7NSs876IRMcGTszs5t1V1egMXSadSmpJNW+nezqqLiIyLRuzGVvRXMeBbcsj1qCDLpLL7p74Gs0AOuWiAoQHsWZbKJiEXDbQMnaQBeem+D3QqCgfHV6OLy6jcEBjmLBTMqfFDGwK0EmY9H4YyQ6FL5myGAi3DIeds5gUNNQxuHPS8oBE5kG0LrsFB/y/kooGWdhkLwjVWlrLvJznkehsbjw0WtG73IUulfIs5fLevRIM9bFy7t98pF6NlphqsJ+0X4J+P6tsJvwCRL9mKo75A9B/AAAAAAElFTkSuQmCC"

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


var canPromise = __webpack_require__(262)

var QRCode = __webpack_require__(275)
var CanvasRenderer = __webpack_require__(279)
var SvgRenderer = __webpack_require__(280)

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  var args = [].slice.call(arguments, 1)
  var argsNum = args.length
  var isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        var data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    var data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_welcomeEmail_lazy_css__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_welcomeEmail_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_welcomeEmail_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_welcomeEmail_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_welcomeEmail_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABUVJREFUWAmtl0tonFUUx2cmmSRjNY2NtM1UBYXUJJPMomoViqGxGx9tsdCCJBBpRHFRBV22tpQGEReKiEVB+qAaF0XTNmIQXAShSKQgmMwMGbPIwhjTxFhjjSGvib//5Lsfd+7M5IFeuDnn/M/znvuYL8HAOkcymSxbXl5uYR7EpQEaDQaDUWgEOgZNQhOhUOh6Q0NDL/zCekIH1zIi8fZMJnMKuzaSVK5l7+knKeBz+Hebmpp+Wc2naAHDw8Plc3NzJ0j+BgE2rRZkFd0Muk6KeK9YRwoWoFUvLS1dwfnxVYJvRPVjaWnpfrbmN9cp5AKDg4Nxkt8AL5T8V/b4Q1ZzgIA7obILQI+DH4Z9nzkhzBm7FhcXvx8aGnrIwQM5HfBWrqD3OoZjJDnZ2Nj4KTR7uFKpVDNBv0Oeqqqquo8xKx9t3ezsbCv425yZbXYcsJvhcHhXXV3dmMH9DsjRa3tOcpyulpSUsI1N5+H9k03yVxUE7KxJLrm2tnYuHo9foEMxdN3CzFBBCwsLl6Fhg/kF6MAB5rSdAL2s+kgsFvvDOBiK7knxJLpoMJvW19dPyRfsExsn+Z5EInHaYNkCvKum026P/urq6iMkWrRBwxNoi3jaOWIwl+KboRsvg1+zdfi+rpzCsgV499y+amO0/dloNPqP7fgf+KP4jlr+EXIelxyikjJom6XUvp4q1HZjk06n7xGP3V8GW43ShVvYnrZt6EKHzl0IRs+r/8JhOM7eXbSNXZ4DWO9hRdvv+hDzErHtV3HT/Px8iwo4aBsjf4nhko25PO17zMP6XV0xmZi6QVdtPbduv85Agw3Cd/AYveJgrrhHAMXWDAwMfMtM43OOh+Yu19CWsf/GluHjpYBRB4yAfUTQHezdSUdnRPNW+N3DZyd3vBSDF4yRS+lCGjsfRq4J8SenAOQXsdDVe5NVneeQ3o9Tie+1wmgvbzF7eIJbuTH7BGPXpk6MjIxUSXYHtjcdbHsQh9s43mkpthCwmf3Rz+kdBqewDHa3kT+jM8cMbihxkuiz24ntJV7OvE5w6it5pqeND3Z/6xD677KneJAreI0idiN/gZGSanU6L5uRE5LdQcIYPjEPf87VS+bUm63LqpVbW5BXgLQUkWSlekoHs9aBwJ+08BiJPvbkPIJPSiCB/WttG3F7HrBl5daqsk5GQZJmw3v0EVFWt427fNbRbVQ84Dik1IEeG6T69vHxcftZnpe+rKxss223UZ7DvJvYh2w/5VYBfUz/SVX7JicnO6BhZpCZlhP712Q7b4TXgjjU3fhsNX7Kqdwh9k0r7DIKUZJ+wKmeZ2YQH/awuGixoSSs8mnpCTxl7PjpbZmYmPgBeYfBPNql3Ho4Auz7GSpsh7Vb79kFZgn4M0KfAWzKg9WL3EwS2/cyxRwm5mscvCdse4+fUU7x/icZlZ7BOOflI/EFDt5L0KK/DXSpj47t9QKvi5C8k7j61F/5HhBTXl7+FiTnx4XARynsCqu8WzaFRkVFxVMU2M7sYv7EVPtV8Ci8ttAd/V6uLO53QBJt0+f4DdicB4NAv1PMCd6Ac/BFu6EY2IWJ0wp9h5nzUYp6lOv8KHs/LluNnAIE0NI4jl/D5hQhHWOCArrRfwUd4Qt3tLKycml6enor3wgx8H3gz0NrVsxz/o5i/wzfiuZhyyrzChDqdeL//Mekn5UfslduStNLmDdkGIlE9uqwoJzJM1g/oNPeqViFkitMwQ7Y8dUNbodO7Lr/OWUb9LB16aoVS2xyrFmAMaSQgv+eS8+e6z8n/ailoD3MPhJnn3DjX4z+C+ibZ447H1t1AAAAAElFTkSuQmCC"

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/loginimg_zh-cn.png";

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNqclEEOgjAQRUvDHm9AOYFNXGs8AltXyg04Cldgo1tuIHGtCTcQb4AnwBkzJc1AhfqTn4ZJ56Wd6RD0fS+4do+LgmUPVla4Bde3zaHl+wMbAskrWArwUbhVgnOAdSMIADQsFTgW83qBUwA1A4RO0CwE2CCNJ5IUKDwBgvYX35Ns72cs3tMj+Q2OrO9EUheWKsNasNg+ZG00d40dACx8zeJKTkBOlOACrDld0iOyVVGnsiUAVDgBiSgBa5WAu18AzJcTd7RBagaAqiXNQukAXWcAJeabx5ZTV4Tni81NYQUNU+oBMrPTDRACYUe042p8irUZvtGv4N//yUeAAQAzOVxJLyqQ7wAAAABJRU5ErkJggg=="

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/success-big.png";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAFMandsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQpJREFUeNpi+P//P8N/H58GEA1iLIAJMCDLAAQQI1gaCBiBIv8hDKgIQABBGL6+EB4IbN7MyMSABQAEEMzEBDAGmwo1DAYwtDERNAMggGDWGwDlzmOx0xDonAtMQAUJcAVA96HQIHGgPHY3owGirAMIIHjYABUqAMkEqOQCoOQDZFNAHHk0Ex4CFSmAQmYBkBOPwxkLkYNuIZokWBMLmkAilD0fW9CCTHCAYrhpLFBOPA53LCTCFwTCASDAEAogigSA5AQ83oa5tQBowAf0KAFpvoDFKfjAQyA2ABkGCk+QE+9jsY0BzUXYxEBAkQnJjxgRAk1uiUjJDps3iUuGhJMpFbxDpYClQhQDAO1qptc9mrUPAAAAAElFTkSuQmCC"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var dictionary = {
        '&amp;': '&',
        '&gt;': '>',
        '&lt;': '<',
        '&quot;': '"',
        '&#39;': "'",
        '&nbsp;': " ",
        "\n": '<br/>'
    };

    var entityToChar = {};
    var charToEntity = {};

    var charKeys = [];
    var entityKeys = [];
    var key, echar;
    for (key in dictionary) {
        echar = dictionary[key];
        entityToChar[key] = echar;
        charToEntity[echar] = key;
        charKeys.push(echar);
        entityKeys.push(key);
    }
    var charToEntityRegex = new RegExp('(' + charKeys.join('|') + ')', 'g');
    var entityToCharRegex = new RegExp('(' + entityKeys.join('|') + '|&#[0-9]{1,5};' + ')', 'g');

    var htmlEncodeReplaceFn = function htmlEncodeReplaceFn(match, capture) {
        return charToEntity[capture];
    };

    var htmlDecodeReplaceFn = function htmlDecodeReplaceFn(match, capture) {
        return capture in entityToChar ? entityToChar[capture] : String.fromCharCode(parseInt(capture.substr(2), 10));
    };

    var htmlEncode = function htmlEncode(value) {
        return !value ? value : String(value).replace(charToEntityRegex, htmlEncodeReplaceFn);
    };

    var htmlEncodeObj = function htmlEncodeObj(obj) {
        for (var prop in obj) {
            if (_typeof(obj[prop]) === "object") {
                continue;
            }
            obj[prop] = htmlEncode(obj[prop]);
        }
    };

    var htmlDecode = function htmlDecode(value) {
        return !value ? value : String(value).replace(entityToCharRegex, htmlDecodeReplaceFn);
    };

    var batchHtmlEncode = function batchHtmlEncode(array) {
        if (Array.isArray(array)) {
            for (var index = 0; index < array.length; index++) {
                for (var prop in array[index]) {
                    if (_typeof(array[index][prop]) === "object") {
                        continue;
                    }
                    array[index][prop] = htmlEncode(array[index][prop]);
                }
            }
        }
    };

    return {
        htmlDecode: htmlDecode,
        batchHtmlEncode: batchHtmlEncode,
        htmlEncode: htmlEncode,
        htmlEncodeObj: htmlEncodeObj
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
    "user strict";

    var unifyValid = window.tinyWidget.UnifyValid;
    unifyValid.focusFirst = function (elements) {
        var unifyValidThis = this;
        var isValid;
        // elements参数可为 校验元素数组/校验元素父容器
        var validElements = this._parseElements(elements);
        var $element;
        // 循环元素列表
        for (var i = 0, len = validElements.length; i < len; i++) {
            $element = $(validElements[i]).filter("[validator]");
            $element = !$element.length ? $(validElements[i]).find("[validator]") : $element;
            if (!$element.length) {
                break;
            }
            //特殊情况处理，包括:
            //不进行校验的情况：1）元素不显示(IP控件 input是隐藏的，所以此处是通过eleInput来判断元素是否显示的)；
            //2）元素处于disable状态（控件变为disabled状态时，清除其校验信息）
            if ($element.data("eleTip").is(":hidden")) {
                continue;
            }
            //各控件disable状态可否通过 disabled 属性区分
            if ($element.attr("disabled")) {
                continue;
            }
            isValid = unifyValidThis._check($element);
            if (!isValid) {
                $($element).focus(); //使得第一个校验失败的输入框提示错误信息
                break;
            }
        }
    };

    function IAMValidator(i18n) {
        this.i18n = i18n;
        this.unifyValid = unifyValid;
        this.directValidator = new DirectValidator(i18n);
    }

    IAMValidator.prototype.notBlank = function (cannotContainBlank) {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var value = this.val();

                if (cannotContainBlank !== undefined && cannotContainBlank) {
                    if (value == undefined || value.length === 0 || value.toString().indexOf(" ") !== -1) {
                        return i18n("emptyTxt");
                    }
                    return "";
                }

                if (value == undefined || value.length === 0) {
                    return i18n("blankTxt");
                }
                return "";
            }
        };
    };

    IAMValidator.prototype.maxLen = function (maxLen, errorDetail) {
        var i18n = this.i18n;
        var maxLenNum = Number(maxLen);
        if (isNaN(maxLenNum)) {
            maxLenNum = 255;
        }
        if (errorDetail === undefined) {
            errorDetail = i18n("maxLenTxt");
        }
        return {
            validFn: "maxSize",
            params: [maxLenNum],
            errorDetail: utils.i18nFormat(errorDetail, maxLenNum)
        };
    };

    IAMValidator.prototype.minLen = function (minLen, errorDetail) {
        var i18n = this.i18n;
        var minLenNum = Number(minLen);
        if (isNaN(minLenNum)) {
            minLenNum = 0;
        }
        if (errorDetail === undefined) {
            errorDetail = i18n("minLenTxt");
        }
        return {
            validFn: "minSize",
            params: [minLenNum],
            errorDetail: utils.i18nFormat(errorDetail, minLenNum)
        };
    };

    IAMValidator.prototype.validInput = function (regExpStr, errorDetail) {
        return {
            validFn: function validFn() {
                var value = this.val();
                if (value === undefined || value === "") {
                    return true;
                }
                var pattern = new RegExp(regExpStr);
                return pattern.test(value);
            },
            errorDetail: errorDetail
        };
    };

    IAMValidator.prototype.notEqualOrInvert = function (compareId, errorDetail) {
        return {
            validFn: function validFn(params) {
                var userName = "";
                try {
                    var userNameWidget = $("#" + params[0]).widget();
                    if (userNameWidget) {
                        userName = userNameWidget.getValue();
                    } else {
                        try {
                            //目前只支持span类型的
                            userName = $("#" + params[0])[0].innerHTML;
                        } catch (e) {
                            //如果在dom查找不到，则传入的ID即为用户名
                            userName = compareId;
                        }
                    }
                } catch (ex) {
                    userName = compareId;
                }
                var pwd = this.val();
                if (userName.toLowerCase() === pwd.toLowerCase()) {
                    return false;
                }
                if (pwd.toLowerCase() === userName.split("").reverse().join("").toLowerCase()) {
                    return false;
                }
                return true;
            },
            params: [compareId],
            errorDetail: errorDetail
        };
    };

    IAMValidator.prototype.equal = function (compareId, errorDetail) {
        return {
            validFn: function validFn(params) {
                return $("#" + params[0]).widget().getValue() === this.val();
            },
            params: [compareId],
            errorDetail: errorDetail
        };
    };

    IAMValidator.prototype.unequal = function (compareId, errorDetail) {
        return {
            "validFn": function validFn(params) {
                return $("#" + params[0]).widget().getValue() !== this.val();
            },
            "params": [compareId],
            "errorDetail": errorDetail
        };
    };

    IAMValidator.prototype.pwdLevelCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var pwd = this.val();
                var strengthLevel = utils.getPwdStrengthLevel(pwd);
                return strengthLevel === "high" || strengthLevel === "mid" ? true : false;
            },
            errorDetail: i18n("passwordChars")
        };
    };

    IAMValidator.prototype.emailCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: "email",
            errorDetail: i18n("validEmail")
        };
    };

    IAMValidator.prototype.checkCountryCode = function (codeArray, errorDetail) {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var value = this.val();
                if (value === undefined || value === "") {
                    return true;
                }
                for (var i = 0; i < codeArray.length; i++) {
                    if (value === codeArray[i]) {
                        return true;
                    }
                }
                return false;
            },
            errorDetail: errorDetail
        };
    };

    IAMValidator.prototype.checkCharLength = function (maxLen) {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var value = this.val();
                var charLength = 0;
                for (var i = 0; i < value.length; i++) {
                    if (value.charCodeAt(i) >= 0 && value.charCodeAt(i) <= 255) {
                        charLength = charLength + 1;
                    } else {
                        charLength = charLength + 2;
                    }
                }
                if (charLength > maxLen) {
                    return false;
                }
                return true;
            },
            errorDetail: utils.i18nFormat(i18n("maxLenTxt"), maxLen)
        };
    };

    IAMValidator.prototype.phoneCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var num = this.val();
                var pattern = /^[0-9]\d*$/;
                return pattern.test(num);
            },
            errorDetail: i18n("validPhone")
        };
    };

    IAMValidator.prototype.phoneAddCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var num = this.val();
                var pattern = /^1\d{10}$/;
                return pattern.test(num);
            },
            errorDetail: i18n("validPhone")
        };
    };

    IAMValidator.prototype.phoneAddCheckIntl = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var num = this.val();
                var pattern = /^\d{1,25}$/;
                return pattern.test(num);
            },
            errorDetail: i18n("validPhone")
        };
    };

    IAMValidator.prototype.msgCodeCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var num = this.val();
                var pattern = /^[a-zA-Z0-9]*$/;
                return pattern.test(num);
            },
            errorDetail: i18n("commonContainsChar")
        };
    };

    IAMValidator.prototype.smsMsgCodeCheck = function () {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var num = this.val();
                var pattern = /^[0-9]*$/;
                return pattern.test(num);
            },
            errorDetail: i18n("msgCodeErrorInfo")
        };
    };

    IAMValidator.prototype.limitLength = function (length) {
        return {
            validFn: function validFn() {
                var value = this.val();
                if (value === undefined) {
                    return true;
                }
                value = value.toString();
                if (value.length > length) {
                    this.val(value.substring(0, length));
                }
                return true;
            }
        };
    };

    IAMValidator.prototype.maxRptCharTimes = function (numOfRptCharInPwd) {
        var i18n = this.i18n;
        return {
            validFn: function validFn() {
                var value = this.val();
                return utils.maxRptCharTimes(value, numOfRptCharInPwd);
            },
            errorDetail: utils.i18nFormat(i18n("passwordPolicy.errorMsgOfRptChar"), numOfRptCharInPwd)
        };
    };

    IAMValidator.prototype.getCompoundValidator = function () {
        var me = this;
        return {
            required: function required() {
                return [me.notBlank()];
            },
            notBlank: function notBlank(cannotContainBlank) {
                return me.notBlank(cannotContainBlank);
            },
            maxLen: function maxLen(_maxLen, errorDetail) {
                return [me.maxLen(_maxLen, errorDetail)];
            },
            minLen: function minLen(_minLen) {
                return [me.minLen(_minLen)];
            },
            commonValidInput: function commonValidInput() {
                return [me.limitLength(255), me.validInput("^[\u4E00-\u9FA5a-zA-Z0-9\\_\\- ]+$", me.i18n("commonContainsChar")), me.maxLen(255)];
            },
            name: function name(policy) {
                var accountPolicy = policy.accountpolicy;
                var minLength, maxLength;
                $.ajaxSettings.async = false;
                $.getJSON('/authui/public/base/settings.json', function (data) {
                    minLength = data.accountMinLen;
                    maxLength = data.accountMaxLen;
                });
                $.ajaxSettings.async = true;
                return [me.limitLength(128), me.notBlank(true), me.validInput(accountPolicy.username_contains_char, me.i18n("nameContainsChar")), me.minLen(minLength), me.maxLen(maxLength)];
            },
            password: function password(policy, userNameId, pwdMinLen, numOfRptCharInPwd, oldpwdId) {
                var pwdPolicy = policy.passwordpolicy;
                var validators = [me.notBlank(false), me.minLen(pwdMinLen), me.maxRptCharTimes(numOfRptCharInPwd), me.maxLen(pwdPolicy.password_maxlen)];

                if (userNameId && pwdPolicy.pwd_not_is_the_username_or_invert === "true") {
                    validators.push(me.notEqualOrInvert(userNameId, me.i18n("pwdNotUsernameOrInvert")));
                }

                if (oldpwdId) {
                    validators.push(me.unequal(oldpwdId, me.i18n("pwdSame")));
                }
                validators.push(me.pwdLevelCheck());
                validators.unshift(me.limitLength(33));
                return validators;
            },
            email: function email() {
                return [me.limitLength(300), me.notBlank(true), me.emailCheck(), me.maxLen(255), me.checkCharLength(255)];
            },
            phone: function phone(phoneLen) {
                return [me.limitLength(128), me.notBlank(true), me.phoneCheck(), me.maxLen(phoneLen, me.i18n("phoneMaxLenTxt"))];
            },
            phoneAdd: function phoneAdd() {
                return [me.limitLength(11), me.notBlank(true), me.phoneAddCheck(), me.maxLen(11, me.i18n("phoneMaxLenTxt"))];
            },
            phoneAddIntl: function phoneAddIntl() {
                return [me.limitLength(25), me.notBlank(true), me.phoneAddCheckIntl(), me.maxLen(25, me.i18n("phoneMaxLenTxt"))];
            },
            countryCode: function countryCode(codeArray) {
                return [me.limitLength(128), me.notBlank(), me.checkCountryCode(codeArray, me.i18n("inValidCountryCode"))];
            },
            passwordLevel: function passwordLevel(lowId, midId, highId) {
                return utils.pwdLevel4Display(lowId, midId, highId);
            },
            confirmPwd: function confirmPwd(pwdId) {
                return [me.limitLength(33), me.notBlank(), me.equal(pwdId, me.i18n("passwordEqual"))];
            },
            msgCode: function msgCode() {
                return [me.limitLength(8), me.notBlank(true), me.msgCodeCheck(), me.maxLen(8, me.i18n("maxLenTxt"))];
            },
            msgCodeForHC: function msgCodeForHC() {
                return [me.limitLength(6), me.notBlank(true), me.msgCodeCheck(), me.maxLen(6, me.i18n("maxLenTxt"))];
            },
            mfaCode: function mfaCode() {
                //mfa校验
                return [me.limitLength(6), me.notBlank(true), me.smsMsgCodeCheck(), me.maxLen(6, me.i18n("maxLenTxt"))];
            },
            smsMsgCode: function smsMsgCode() {
                return [me.limitLength(6), me.notBlank(true), me.smsMsgCodeCheck(), me.maxLen(6, me.i18n("maxLenTxt"))];
            },
            graphVerifyCode: function graphVerifyCode() {
                return [me.limitLength(4), me.notBlank(), me.maxLen(4)];
            },
            childValidator: me
        };
    };

    IAMValidator.prototype.getCompoundDirectValidator = function () {
        var me = this;
        var dv = me.directValidator;
        return {
            required: function required(value) {
                return dv.notBlank(value);
            },
            notBlank: function notBlank(value, cannotContainBlank) {
                return dv.notBlank(value, cannotContainBlank);
            },
            notEmpty: function notEmpty(value, cannotContainBlank) {
                return dv.notEmpty(value, cannotContainBlank);
            },
            maxLen: function maxLen(value, _maxLen2, errorDetail) {
                return dv.maxLen(value, _maxLen2, errorDetail);
            },
            minLen: function minLen(value, _minLen2) {
                return dv.minLen(value, _minLen2);
            },
            commonValidInput: function commonValidInput(value) {
                var retObj = dv.validInput(value, "^[\u4E00-\u9FA5a-zA-Z0-9\\_\\- ]+$", me.i18n("commonContainsChar"));
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value);
                return retObj;
            },
            name: function name(value, policy) {
                var accountPolicy = policy.accountpolicy;
                var minLength, maxLength;
                var retObj = dv.notBlank(value, false);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.validInput(value, "^[a-zA-Z\\_\\- ][0-9a-zA-Z\\_\\- ]*$", me.i18n("nameContainsChar"));
                if (!retObj.result) {
                    return retObj;
                }
                $.ajaxSettings.async = false;
                $.getJSON('/authui/public/base/settings.json', function (data) {
                    minLength = data.accountMinLen;
                    maxLength = data.accountMaxLen;
                });
                $.ajaxSettings.async = true;
                if (minLength < 1) {
                    minLength = 1;
                }
                if (maxLength > 64) {
                    maxLength = 64;
                }
                retObj = dv.minLen(value, minLength);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, maxLength);
                return retObj;
            },
            password: function password(pwd, policy, userNameId, pwdMinLen) {
                var pwdPolicy = policy.passwordpolicy;
                var retObj = dv.notBlank(pwd, false);
                if (!retObj.result) {
                    retObj.cases = "not-blank";
                    return retObj;
                }
                retObj = dv.minLen(pwd, pwdMinLen ? pwdMinLen : pwdPolicy.password_minlen);
                if (!retObj.result) {
                    retObj.cases = "min-len";
                    return retObj;
                }
                retObj = dv.maxLen(pwd, pwdPolicy.password_maxlen);
                if (!retObj.result) {
                    retObj.cases = "max-len";
                    return retObj;
                }

                if (userNameId && pwdPolicy.pwd_not_is_the_username_or_invert === "true") {
                    retObj = dv.notEqualOrInvert(pwd, userNameId, me.i18n("pwdNotUsernameOrInvert"));
                    if (!retObj.result) {
                        retObj.cases = "conf-name";
                        return retObj;
                    }
                }
                return retObj;
            },
            email: function email(value) {
                var retObj = dv.notEmpty(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.emailCheck(value);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.checkCharLength(value, 255);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, 255);
                return retObj;
            },
            phone: function phone(value, phoneLen) {
                var retObj = dv.notEmpty(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.phoneCheck(value);
                if (!retObj.result) {
                    return retObj;
                }
                var length = phoneLen ? phoneLen : 32;
                retObj = dv.maxLen(value, length, me.i18n("phoneMaxLenTxt"));
                return retObj;
            },
            phoneAdd: function phoneAdd(value) {
                var retObj = dv.notEmpty(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.phoneAddCheck(value);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, 11, me.i18n("phoneMaxLenTxt"));
                return retObj;
            },
            confirmPwd: function confirmPwd(value, pwdId) {
                var retObj = dv.notBlank(value, false);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.equal(value, pwdId, me.i18n("passwordEqual"));
                return retObj;
            },
            msgCode: function msgCode(value) {
                var retObj = dv.notEmpty(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.msgCodeCheck(value);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, 8, me.i18n("maxLenTxt"));
                return retObj;
            },
            smsMsgCode: function smsMsgCode(value) {
                var retObj = dv.notEmpty(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.smsMsgCodeCheck(value);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, 6, me.i18n("maxLenTxt"));
                return retObj;
            },
            graphVerifyCode: function graphVerifyCode(value) {
                var retObj = dv.notBlank(value, true);
                if (!retObj.result) {
                    return retObj;
                }
                retObj = dv.maxLen(value, 4);
                return retObj;
            },
            childValidator: me.directValidator
        };
    };

    function DirectValidator(i18n) {
        this.i18n = i18n;
    }

    function getRetObj(result, err) {
        return {
            result: result,
            errorInfo: err
        };
    }

    DirectValidator.prototype.notBlank = function (value, notContainSpace) {
        if (value === undefined || value.length === 0) {
            return getRetObj(false, this.i18n("blankTxt"));
        }

        if (notContainSpace && value.indexOf(" ") !== -1) {
            return getRetObj(false, this.i18n("emptyTxt"));
        }
        return getRetObj(true);
    };

    DirectValidator.prototype.notEmpty = function (value, notContainSpace) {
        if (notContainSpace && (value === undefined || value.indexOf(" ") !== -1 || value.length === 0)) {
            return getRetObj(false, this.i18n("emptyTxt"));
        }

        if (!value || $.trim(value.toString()).length === 0) {
            return getRetObj(false, this.i18n("blankTxt"));
        }
        return getRetObj(true);
    };

    DirectValidator.prototype.maxLen = function (value, maxLen, errorDetail) {
        var maxLenNum = Number(maxLen);
        if (isNaN(maxLenNum)) {
            maxLenNum = 255;
        }
        if (!errorDetail) {
            errorDetail = this.i18n("maxLenTxt");
        }
        return value.length > maxLenNum ? getRetObj(false, utils.i18nFormat(errorDetail, maxLenNum)) : getRetObj(true);
    };

    DirectValidator.prototype.minLen = function (value, minLen, errorDetail) {
        var minLenNum = Number(minLen);
        if (isNaN(minLenNum)) {
            minLenNum = 0;
        }
        if (!errorDetail) {
            errorDetail = this.i18n("minLenTxt");
        }
        return value.length < minLenNum ? getRetObj(false, utils.i18nFormat(errorDetail, minLenNum)) : getRetObj(true);
    };

    DirectValidator.prototype.validInput = function (value, regExpStr, errorDetail) {
        if (!value) {
            return getRetObj(true);
        }
        var pattern = new RegExp(regExpStr);
        var result = pattern.test(value);
        return result ? getRetObj(true) : getRetObj(false, errorDetail);
    };

    DirectValidator.prototype.notEqualOrInvert = function (value, compareId, errorDetail) {
        var targetValue = "";
        var targetWidget = undefined;

        try {
            targetWidget = $("#" + compareId).widget();
        } catch (e) {
            targetValue = compareId;
        }

        if (targetWidget) {
            targetValue = targetWidget.getValue();
        } else if (targetValue === "") {
            //just span
            targetValue = $("#" + compareId).html();
            if (!targetValue) {
                targetValue = compareId;
            }
        }

        if (value && (value.toLowerCase() === targetValue.toLowerCase() || value.toLowerCase() === targetValue.split("").reverse().join("").toLowerCase())) {
            return getRetObj(false, errorDetail);
        }
        return getRetObj(true);
    };

    DirectValidator.prototype.equal = function (value, compareId, errorDetail) {
        if ($("#" + compareId).widget().getValue() !== value) {
            return getRetObj(false, errorDetail);
        }
        return getRetObj(true);
    };

    DirectValidator.prototype.emailCheck = function (value) {
        var pattern = /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
        return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validEmail"));
    };

    DirectValidator.prototype.phoneCheck = function (value) {
        var pattern = /^[0-9]\d*$/;
        return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validPhone"));
    };

    DirectValidator.prototype.phoneAddCheck = function (value) {
        var pattern = /^1\d{10}$/;
        return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validPhone"));
    };

    DirectValidator.prototype.checkCharLength = function (value, maxLen) {
        var charLength = 0;
        for (var i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) >= 0 && value.charCodeAt(i) <= 255) {
                charLength = charLength + 1;
            } else {
                charLength = charLength + 2;
            }
        }
        return charLength > maxLen ? getRetObj(false, utils.i18nFormat(this.i18n("maxLenTxt"), maxLen)) : getRetObj(true);
    };

    DirectValidator.prototype.msgCodeCheck = function (value) {
        var pattern = /^[a-zA-Z0-9]*$/;
        return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("commonContainsChar"));
    };

    DirectValidator.prototype.smsMsgCodeCheck = function (value) {
        var pattern = /^[0-9]*$/;
        return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("msgCodeErrorInfo"));
    };

    return IAMValidator;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var validUrl = "/authui/preValidVerifycode";
    function changeToSuccess(failResultId, verifyCodeId) {
        $("#" + failResultId).hide();
        $("#" + verifyCodeId).removeClass("iam-input-error");
    }

    function changeToFail(failResultId, verifyCodeId) {
        $("#" + failResultId).show();
        $("#" + verifyCodeId).addClass("iam-input-error");
    }
    function clear(failResultId, verifyCodeId) {
        $("#" + failResultId).hide();
        $("#" + verifyCodeId).removeClass("iam-input-error");
    }

    function validateVerifyCode(failResultId, verifyCodeId, verifycode) {
        // 过滤掉ios中文输入法下可能出现的特殊空格字符
        verifycode = verifycode.replace(/\u2006/g, "");
        if (verifycode === "" || verifycode === undefined) {
            clear(failResultId, verifyCodeId);
            return false;
        }
        if (verifycode.length < 4) {
            changeToFail(failResultId, verifyCodeId);
            return false;
        } else {
            return true;
        }
    }

    function substrVerifyCode(verifycode) {
        if (verifycode === "" && verifycode === undefined) {
            return "";
        }
        if (verifycode.length > 4) {
            return verifycode.substring(0, 4);
        } else {
            return verifycode;
        }
    }

    function checkVerifyCode(failResultId, verifyCodeId, verifycode, index, callback, iamHttpService, i18n) {
        iamHttpService.post({
            url: validUrl,
            params: {
                verifycode: verifycode,
                index: index
            }
        }).then(function (data) {
            if (data === "success") {
                changeToSuccess(failResultId, verifyCodeId);
            } else {
                changeToFail(failResultId, verifyCodeId);
                callback();
            }
        }, function () {
            if (i18n) {
                // 接口异常 提示用户刷新页面
                angular.element("#serverError").removeClass("ng-hide");
                angular.element("#serverError").css("display", "block");
                angular.element("#serverError>span:first").text(i18n("systemException"));

                setTimeout(function () {
                    angular.element("#serverError").addClass("ng-hide");
                    angular.element("#serverError").css("display", "none");
                    angular.element("#serverError>span:first").text("");
                }, 10000);
            }
        });
    }

    function preValidVerifyCodeNew(failResultId, verifyCodeId, verifycode, index, callback, iamHttpService, i18n) {
        if (validateVerifyCode(failResultId, verifyCodeId, verifycode) === false) {
            return;
        }
        checkVerifyCode(failResultId, verifyCodeId, substrVerifyCode(verifycode), index, callback, iamHttpService, i18n);
    }

    return {
        preValidVerifyCodeNew: preValidVerifyCodeNew
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var ECLevel = __webpack_require__(62)

var EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

var EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),
/* 87 */
/***/ (function(module, exports) {

var numeric = '[0-9]+'
var alphanumeric = '[A-Z $%*+\\-./:]+'
var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

var TEST_KANJI = new RegExp('^' + kanji + '$')
var TEST_NUMERIC = new RegExp('^' + numeric + '$')
var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),
/* 89 */
/***/ (function(module, exports) {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  var hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  var hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  var margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0 ? 4 : options.margin

  var width = options.width && options.width >= 21 ? options.width : undefined
  var scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  var scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  var size = qr.modules.size
  var data = qr.modules.data
  var scale = exports.getScale(size, opts)
  var symbolSize = Math.floor((size + opts.margin * 2) * scale)
  var scaledMargin = opts.margin * scale
  var palette = [opts.color.light, opts.color.dark]

  for (var i = 0; i < symbolSize; i++) {
    for (var j = 0; j < symbolSize; j++) {
      var posDst = (i * symbolSize + j) * 4
      var pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        var iSrc = Math.floor((i - scaledMargin) / scale)
        var jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_lazy_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0I1QTczRDU1MTg1MTFFMzg0ODNEMzVEODM4Qjc5QUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0I1QTczRDY1MTg1MTFFMzg0ODNEMzVEODM4Qjc5QUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQjVBNzNEMzUxODUxMUUzODQ4M0QzNUQ4MzhCNzlBQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQjVBNzNENDUxODUxMUUzODQ4M0QzNUQ4MzhCNzlBQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqOHkBwAAAC6SURBVHjaYnxxTIaNgYGhG4hjgFiIgTjwHogXA3EpC5DoAuI8BtKAIFTPdyYgEYtD0TkglgRieSC+jENNKhMeZ+8B4hdA/AiI9+FQI8SEx5nIBgvgUkSsAYLkGCBIqQFCONhEGyBCTS/gDEQWPAZwAfFVIGaGskk24AkQm0HZd4BYglQv/APiP0D8H1+aBrngHY5QlgPiW1BLJHDof8cEzVW4AMgQGTzyc0AuKANiRmimEiQxO9cCBBgAyUYbnEIVpWYAAAAASUVORK5CYII="

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDAgNDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwIDQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0U5NEU0Qzt9Cjwvc3R5bGU+CjxwYXRoIGlkPSJYTUxJRF84MzVfIiBjbGFzcz0ic3QwIiBkPSJNMjAsMEM5LDAsMCw5LDAsMjBzOSwyMCwyMCwyMHMyMC05LDIwLTIwUzMxLDAsMjAsMHogTTIxLjMsMjkuN2gtM3YtM2gzVjI5Ljd6IE0yMS4zLDI0LjRoLTMKCWwtMC40LTE0aDMuOEwyMS4zLDI0LjR6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAACXlBMVEUAAADax4rGxqP556zmsVD/6KXu5JvwvFPglEFnY3nnpEjosU1+XFTmuVfu13Hrv1jpsFa1k3mne2HlvnPdqmPqz3fu3YrJoWv04J/mz5z246aSi3i2p2/0zGj82WDrtFjar1O7klO4dkfimUJcWnbho0rgr1vntFfmvFflvGOZdFKXZkOUemnmv2XkuWWVe2ziqlXnt1Tr0HDpwl6ObmCkbEKqhVyOc2jdoVHmuljfrmDq0nPapWDUnErqy3XjtWXesXLrzHjz34rqzYfmw3fy4YrqyYDevW/dzoTIhkndsXLRsIneuHjlyIzQroTjuXjlyYfktWvw2prhvoHTmGfx45j3773TuYT/25LdijyKf321oXU+Nm3cumXfuWLtwlzpwVz40FvpvlvqvFfouFXjrlHipEjcmEfknEXPbzfbZyzZQR/YMBrWKBrhJhLdHxDTGg5HV4xBT4YYKYaWk4SDgYIWIYBybH0qLn1KS3tlZHpNS3WGfHIcHXEwLHAnF28rKW07NGuzn2pNQ2ruzWnDrGnuy2jryGjAnGgoH2j1x2RCNGPcrmIsEGGQdl/pu17YtV7FoV3muVxoRVzWqFvSmVp2SVbyw1XbkVTuvFPfo1PgmVPpt1LcnFLWkVLlp1F7W1HpsU92QE5oMUtFAUrpqUjnjUFOAEHUgz+DUj14FzvbczieMTdhATfodjXWcDXcbjXVcTS/Xi/hay7WXS3cWS3vYyvaVSrUVymnJSjXSyeKDSbNSiWfHCPMTyLFQiHkSR/lPxvVLRrPLBnUJRfUHhbaJxXVGxTZJxPNFhBdOhm/AAAAWXRSTlMABQIU/hIJ/v79/Pj29PPx4cC6s7CNfmxZWRv+/v7+/v7+/v78/Pr6+fPz8vHq6ujl5eTj4ODe2NTQzMW6ubKsnJeQkJCJiIOBgX9ubGpoW1lMREM0JR8dDgvYx1gAAAE7SURBVBjTYgADJmZJQUFJZiYGOGD2EzLV1jIT8paCibCJ86zctGPD1D4ecUaICKuPyYLMYznZOfNqzP0jwEJBOt1KB4/mHjqZ3dGsHwxW5M4Zk5l/PPdIQcGMShUPVqBlgQLlMSvyDq+P3HVidjWnkQQTA5MXV1SFYtb+jZGrl02si2J3Y2JgFMmILl68efueLVvXLSqLXirCCBgDow1HT+GS/AP7srblLS+K5bIHCjmodpXUr929d+eaVb3SsuouQCHhufPjShsbJk/rrK2KW8hiBxRyVkvnkI9tnaDQJDNFOU1DDOjRMEfe9Mjpiewz5RIzZmmKMoPcKqGbkJqSkBSfnDqpXS+ACeRpJ76W/uSUpDlpLPFtfK5soLAKFbU05Odm4eblN7YWk4KEGWOIp62FgYCVsG84SAAAL7BaooX965sAAAAASUVORK5CYII="

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABDElEQVRYR+2WsQ3CMBBFX3pmQGIBFoCCEgpEyY6UNFBSQA8TIDEDA6CTYgklcXxnG5wiKZ3E7+ny7+KKwldVmM8oMNgKHIA5sAGeiTmZASfgAeybe/kqcAS2wAtYJUgI/AJMAdlzpxWY1NbLBIlv+LWu5lsrIM+lSKjgAgmFMEZCDdcIWCthgmsFtBJmuEUgJBEFtwr4JGTdtZo37b5ZEgph13vNYMoz0udmeEwFnJBInIFFvXAD1kCrz0NTNKYC7lMUEyj6CboG099C2DcVf96GmpEcJaEJoQbuwm6WCAlY4FESfQIxcLOETyAFbpIY7JEs96FUpubdcigNjfBs90NdkA2U83ecVWqswAc5LnIhhPs4dQAAAABJRU5ErkJggg=="

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/loading_hwid.gif";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAFV3XwhAAAAAXNSR0IArs4c6QAAAh9JREFUOBGNUj1oU1EUPt/Ja2otTetQsIOis7uLgZrBrVUoaEpMTLc6uCl2cVRQEByc3JIXh5eHEkK7R6QOgoPQpThZpC0RpRSlr8/Sdzzn1leiJcUD995zz893z/nuQRiG2Z3dJAbwhE1hwBeRBdT8QEiFdSUe50YPLECRhF4QyZh5PUvU+KZdUkG90dxQ40RqYL2cAmF57tYsst7QaQbjtpDka43mcql0rXv4XJpyBCN19J6GO0HAa4/5Ant8GaAtZtwjUNXesmDPNgwPzJdnZr6b7vvBfCISakHrtUaQ0X7InnusaAsW8K9oj5tDgzjn9QuwBCsliumz8UXVSpGtX1seI48MrpidCVct0AUprMDDA4HE5XLxHQbwSSv+oOVMW7ArvNPpnFj70n1jBhOJk5UM587sy49VK9whFQqFXdeuUtFqtcZEKEcU5ewpSzrCrhl7xX7xWAp6g4/TDegvmsB8vVq+8ao3qe4HvhC+jo5kH27//LWk3F1y/gwmMwm6+5KsGtWOAOcAVgyk3giea293UjAb0Kx3cnxvL5K5SjGvn/hRKTpfvVl8679s3jWCTBxJTgEt2Qnwuh6PbOnMrOl6XypNf4tieVbzm0/1ty+qT8dc4ZKD7zD9sCJhLPpheDaJZUrRzKdd0KAO3+IffUot41GMjWpl9n673R7Z2o4mXaBu/zXeaXC/U8neZBtM93166RfYz24AlmsYvwHWI/CzUKsO6gAAAABJRU5ErkJggg=="

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAFV3XwhAAAAAXNSR0IArs4c6QAAAg9JREFUOBGdU01oE1EQnnm7MWlKU6MHfw6ieLcIQg8KguDNEAKSFNLNBi9evIigJ+968uxF2lTFXdRT7iKoB6GIPyiIiKd6EQkkpEmTfeN8r6SsthV04O3Om/nmm3kz73Ecx3v6Aztk5tvGKcTPReQGL7UeCamYbCZ3BIqzMPELITkDA8QgMG2AkZdXojUlOYQNxOjmQBjUTD5nZtgz80ZBI0XZ9YG9G9arr7fSbQbswDFxpP/gdUlQBTE/gTPjZY4bQ1ebjQXG3sdnf3F6ulQq9aG37kfXxnb0RoQKrQfRZ5uIK/kWzg3An6Ls36eyfNTfDYAAlLI+pG8uHdrETF/1HyckBfU+BIh9f07G47d6fo3QPjaCWpiIbRcLuTaKNsRX2NoS/A7kG3NiaSXqwFAul7vW0h3LclIkBVpcrL5vBrW9xHQJQIhH3NYTzkPf1l0Y04L+YWq7tiAN/psOot/axB6fC+u1Z+mg5Vb0SpjW8lkO+kP7RTtxGH42HOybzT/92en30OqdyrbGN2cl53+S3uiD9vAgeeaUZ63oEFcnSWZnssVud3jeEsWwuU5OnHop3uk9nNKsx6S38QMkmHCzXl1lNiOP+eLm8k5XKpWO3qsLk9gtIgVeDxsLc4MNuanJLyvopa6PStoGOLH2XiLyGEtH5d6LztvNFf5tTwTGfxVUbXAx3fh08z8EiAXHL74G804X/8s/AAAAAElFTkSuQmCC"

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/loginimg_en-us.png";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/loginimg_intl_zh-cn.png";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/logo.svg";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAELElEQVR4Xu2ZW2gcZRTHf2cm2xUbLFpoCsnuzCbgJRaf6u1BXwSlIAgqaos3FFGrlqqoiPqkIipeqFoVUbxhVVQQhKLgS/vgrU+iWxWSndlNIBGqKKm43cwc+cIsBEkys5eRrjPf63znm/P9zv9857sIGW+S8fmTA8gVkHECeQpkXAD5IpinQJ4CGSeQp0DGBZBXgTwF8hTIOIE8Bf4LAVQqlZEwDLcCk6o6LiKbgZOBE6L//w38rqpzIjINVC3LOlSr1ebT9i81BYyPj29YXFy8BLjUTLzLiVSBz4aGhj6fnp7+o8sx1jTrO4CJiYlNrVbrNlXdJiKF6O9HVfV7EfkB+DEMw7lisfiniCxNSlU3NJvNkyzLMso4U1W3iMhZwProe0tE9hcKhVempqZ+7SeIvgEYGRlZXywWbwKuAYpAAHxlIjg8PHygWq0e68TxycnJdQsLCxdGCjofsIEm8H6z2Xxjfn7+aCfjrda3LwAcxzlDVZ8AxkxAReSLIAj2zszMzPbDybGxsVHbtneq6sWwtHmbEZEHfd8/3Ov4PQNwXXd7EAS7Irkftizrcc/zfurVsZXsXdc9PQzDhwADvGXb9h7P8/b18q+eAJTL5V3A9VHU9/m+/wLQinFoArgMOA8wOW/aHPA18CkwFWNfcBznLlXdHqnh7Xq9vqdbCF0DcF13dxiG15pIiMjD9Xr9yzjHgbuBKwFrlb4h8BHwXBzIcrl8kao+ZpRnWda7nuc93w2ErgA4jnOzqt4OHFPVBxqNxsEEkzdROjua2CfAfsDUfNPGgW3A5YCpHN8BRl1rqqlUKl0gIk8C60TkZd/3X+8UQscASqXSVhHZG5WnexNM3nS9H7gKMCVsN/DLKo6eCphIbgI+BJ6Km1AE4ZnIn52NRuNQnM3y7x0BGB0d3Wjb9nvARuDVer3+WoKfmZw3C5UpizesMfn2UAbCW1HZM3ketyZQLpdvAW4FjgRBsGN2dvZIAr+WunQEwHGcR6MNzre+798JmJyNa/cAO4APgKfjOkff7wOuBgzsZxPYWI7jvKiq55gNk+/7jySw6QxApVI5LQiCd0xeWpZ1hed5ZuVO0oyUTY7fCJidYJK2BXgzWiNM6sQ213U3h2H4sVlDbNu+rlar/Rxr1IkCSqXSSyJyLtBp2TkAnAiYXd1fSZyK+hs709/YJWrtsqyq3zQajTuSGCVOgcwDyHwKGDllehE0ADJfBg2ETG+E2qtqprfCbQiZPgy1IWT6OLxMCdm9EFm2JmT3SqwNIdOXosv33Jm9Fv/3wSOzDyMrncBWehpT1VNExLwfmIeRpoj89r96GktyFD0e+iQ+Dh8PzqbhQw4gDaqDNGaugEGKVhq+5gpIg+ogjZkrYJCilYavuQLSoDpIY+YKGKRopeFrroA0qA7SmLkCBilaafj6D6V0WF+CtG72AAAAAElFTkSuQmCC"

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+YnRuX3JhZGlvX25vcm1hbDwvdGl0bGU+CiAgICA8ZyBpZD0i6KeE5YiZIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i6YCJ5qGGIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMyNS4wMDAwMDAsIC00NTYuMDAwMDAwKSIgc3Ryb2tlPSIjMzMzMzMzIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTc2LjAwMDAwMCwgMzA4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImJ0bl9yYWRpb19ub3JtYWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0OS4wMDAwMDAsIDE0OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGN4PSI5IiBjeT0iOSIgcj0iOC41Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+YnRuX3JhZGlvX3NlbGVjdGVkPC90aXRsZT4KICAgIDxnIGlkPSLnmbvlvZUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLlvLnnqpct5YW25LuW5pa55byP6aqM6K+BIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTkwLjAwMDAwMCwgLTMzNC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MDAuMDAwMDAwLCAyMTUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMi4wMDAwMDAsIDEwMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iYnRuX3JhZGlvX3NlbGVjdGVkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NTguMDAwMDAwLCAxOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0i5qSt5ZyG5b2iIiBzdHJva2U9IiMzMzMzMzMiIGN4PSI5IiBjeT0iOSIgcj0iOC41Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0i5qSt5ZyG5b2iIiBmaWxsPSIjMDAwMDAwIiBjeD0iOSIgY3k9IjkiIHI9IjQiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT4xIHBj6ZSZ6K+vaWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjEtcGPplJnor69pY29uIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMyI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIsMCBDNS40LDAgMCw1LjQgMCwxMiBDMCwxOC42IDUuNCwyNCAxMiwyNCBDMTguNiwyNCAyNCwxOC42IDI0LDEyIEMyNCw1LjQgMTguNiwwIDEyLDAgWiIgaWQ9IlhNTElEXzI5OF8iIGZpbGw9IiNGQTJBMkQiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy41LDE1LjcyOTY1MTIgTDEzLjUsMTguNzM4MzcyMSBMMTAuNSwxOC43MzgzNzIxIEwxMC41LDE1LjcyOTY1MTIgTDEzLjUsMTUuNzI5NjUxMiBaIE0xMy41LDUuNSBMMTIuOSwxMy45MjQ0MTg2IEwxMS4xLDEzLjkyNDQxODYgTDEwLjUsNS41IEwxMy41LDUuNSBaIiBpZD0i5b2i54q257uT5ZCIIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var _cssMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var config = {
    hasHwid: "true"
    // 统一id登录页和老登录页路由根据配置项true切换
};var hasHwid = config.hasHwid === 'true' ? true : false;
// 登录页在litesdk环境下需要额外加载css
var isLiteSDK = window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true;
var sdkCss = isLiteSDK ? [__webpack_require__(293)] : [];

// 配置路由与css文件的对应关系，并在切换路由时动态卸载/加载
// 注意需要动态加载的css文件需要以.lazy.css结尾
// cssMap中的每一项返回一个当前路由所需css文件列表，可用lang参数匹配语言
var cssMap = (_cssMap = {}, _defineProperty(_cssMap, hasHwid ? 'login2' : 'login', function (lang) {
    return [__webpack_require__(352)("./" + lang + "/loginpage.lazy.css")];
}), _defineProperty(_cssMap, 'loginVerification', function loginVerification(lang) {
    return [__webpack_require__(351)("./" + lang + "/loginVerification.lazy.css")];
}), _defineProperty(_cssMap, 'fpwd', function fpwd(lang) {
    return [__webpack_require__(292)];
}), _defineProperty(_cssMap, 'fphone', function fphone(lang) {
    return [__webpack_require__(350)("./" + lang + "/fphone.lazy.css")];
}), _defineProperty(_cssMap, hasHwid ? 'login' : 'hwIDLogin', function (lang) {
    return lang === 'zh-cn' ? [__webpack_require__(90), __webpack_require__(304)].concat(sdkCss) : [__webpack_require__(90)].concat(sdkCss);
}), _defineProperty(_cssMap, 'resetPwd', function resetPwd(lang) {
    return [__webpack_require__(353)("./" + lang + "/resetPwd.lazy.css")];
}), _defineProperty(_cssMap, 'privacyUpdate', function privacyUpdate(lang) {
    return [__webpack_require__(295)];
}), _defineProperty(_cssMap, 'welcomeLogin', function welcomeLogin(lang) {
    return [__webpack_require__(63)];
}), _defineProperty(_cssMap, 'welEmailFailed', function welEmailFailed(lang) {
    return [__webpack_require__(63)];
}), _defineProperty(_cssMap, 'welEmailResend', function welEmailResend(lang) {
    return [__webpack_require__(63)];
}), _defineProperty(_cssMap, 'closecookie', function closecookie(lang) {
    return [__webpack_require__(282)];
}), _defineProperty(_cssMap, 'error', function error(lang) {
    return [__webpack_require__(287)];
}), _defineProperty(_cssMap, 'upgrade', function upgrade(lang) {
    return [__webpack_require__(301)];
}), _defineProperty(_cssMap, 'casLoginError', function casLoginError(lang) {
    return [__webpack_require__(281)];
}), _defineProperty(_cssMap, 'ssologin', function ssologin(lang) {
    return [__webpack_require__(300)];
}), _defineProperty(_cssMap, 'notify', function notify(lang) {
    return [__webpack_require__(294)];
}), _cssMap);

function getCurrentHash() {
    var defaultHash = 'login';
    var hash = window.location.hash.slice(2);
    var questionMarkIndex = hash.indexOf('?');
    if (~questionMarkIndex) {
        hash = hash.slice(0, questionMarkIndex);
    }
    return hash ? hash : defaultHash;
}

function handleHash(hash) {
    if (hash === lastHash) {
        return;
    }
    if (lastCssArray) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = lastCssArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var css = _step.value;

                css.default.unuse();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    if (cssMap[hash]) {
        var cssArray = cssMap[hash](window.language || 'zh-cn');
        lastCssArray = cssArray;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = cssArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _css = _step2.value;

                _css.default.use();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        lastHash = hash;
    }
}

var lastHash = void 0;
var lastCssArray = void 0;

handleHash(getCurrentHash());

window.addEventListener('hashchange', function () {
    handleHash(getCurrentHash());
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerConfig;

function routerConfig(myApp) {

    __webpack_require__(151);
    __webpack_require__(147);
    __webpack_require__(149);
    __webpack_require__(152);
    __webpack_require__(143);
    __webpack_require__(157);
    __webpack_require__(145);
    __webpack_require__(146);
    __webpack_require__(155);
    __webpack_require__(160);
    __webpack_require__(158);
    __webpack_require__(159);
    __webpack_require__(154);
    __webpack_require__(144);
    __webpack_require__(156);
    __webpack_require__(153);
    var bfController = __webpack_require__(148);

    var config = {
        hasHwid: "true"
    };
    var hasHwid = config.hasHwid === "true" ? true : false;
    // 统一id登录页和老登录页路由根据配置项true切换
    var routerList = [{
        name: hasHwid ? 'login2' : 'login',
        url: hasHwid ? '/login2' : '/login',
        views: {
            "content@": {
                controller: 'authui.login2.ctrl',
                template: __webpack_require__(243)
            },
            "banner@": {
                controller: bfController,
                template: __webpack_require__(242)
            },
            "footer@": {
                controller: bfController,
                template: __webpack_require__(8)
            }
        }
    }, {
        name: "fpwd",
        url: "/fpwd",
        views: {
            "content@": {
                template: __webpack_require__(238),
                controller: "authui.fpwd.ctrl"
            },
            'banner@': {
                template: __webpack_require__(237),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: hasHwid ? 'login' : 'hwIDLogin',
        url: hasHwid ? '/login' : '/hwIDLogin',
        views: {
            "content@": {
                template: __webpack_require__(240),
                controller: "authui.login.ctrl"
            },
            'banner@': {
                template: __webpack_require__(239),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(241),
                controller: bfController
            }
        }
    }, {
        name: "loginVerification",
        url: "/loginVerification",
        views: {
            "content@": {
                template: __webpack_require__(245),
                controller: "authui.loginVerification.ctrl"
            },
            'banner@': {
                template: __webpack_require__(244),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "fphone",
        url: "/fphone",
        views: {
            "content@": {
                template: __webpack_require__(236),
                controller: "authui.fphone.ctrl"
            },
            'banner@': {
                template: __webpack_require__(235),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "resetPwd",
        url: "/resetPwd",
        views: {
            "content@": {
                template: __webpack_require__(251),
                controller: "authui.resetPwd.ctrl"
            },
            'banner@': {
                template: __webpack_require__(250),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "welcomeLogin",
        url: "/welcomeLogin",
        views: {
            "content@": {
                template: __webpack_require__(258),
                controller: "authui.welcomeLogin.ctrl"
            },
            'banner@': {
                template: __webpack_require__(59),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "welEmailFailed",
        url: "/welEmailFailed",
        views: {
            "content@": {
                template: __webpack_require__(256),
                controller: "authui.welEmailFailed.ctrl"
            },
            'banner@': {
                template: __webpack_require__(59),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "welEmailResend",
        url: "/welEmailResend",
        views: {
            "content@": {
                template: __webpack_require__(257),
                controller: "authui.welEmailResend.ctrl"
            },
            'banner@': {
                template: __webpack_require__(59),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "closecookie",
        url: "/closecookie",
        views: {
            "content@": {
                template: __webpack_require__(232),
                controller: "authui.closecookie.ctrl"
            },
            'banner@': {
                template: __webpack_require__(231),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "privacyUpdate",
        url: "/privacyUpdate",
        views: {
            "content@": {
                template: __webpack_require__(249),
                controller: "authui.privacyUpdate.ctrl"
            },
            'banner@': {
                template: __webpack_require__(248),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "error",
        url: "/error",
        views: {
            "content@": {
                template: __webpack_require__(234),
                controller: "authui.error.ctrl"
            },
            'banner@': {
                template: __webpack_require__(233),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "upgrade",
        url: "/upgrade",
        views: {
            "content@": {
                template: __webpack_require__(255),
                controller: "authui.upgrade.ctrl"
            },
            'banner@': {
                template: __webpack_require__(254),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "casLoginError",
        url: "/casLoginError",
        views: {
            "content@": {
                template: __webpack_require__(230),
                controller: "authui.casLoginError.ctrl"
            },
            'banner@': {
                template: __webpack_require__(229),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "ssologin",
        url: "/ssologin",
        views: {
            "content@": {
                template: __webpack_require__(253),
                controller: "authui.ssologin.ctrl"
            },
            'banner@': {
                template: __webpack_require__(252),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }, {
        name: "notify",
        url: "/notify",
        views: {
            "content@": {
                template: __webpack_require__(247),
                controller: "authui.notify.ctrl"
            },
            'banner@': {
                template: __webpack_require__(246),
                controller: bfController
            },
            'footer@': {
                template: __webpack_require__(8),
                controller: bfController
            }
        }
    }];

    var routerConfig = function routerConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/login');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = routerList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _config = _step.value;

                $stateProvider.state(_config);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    myApp.config(routerConfig);
}

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    function CloseCookie($scope, _i18n, _iamUtils) {
        var i18n = _i18n;
        var iamUtils = _iamUtils;
        $scope.i18n = i18n;
        $scope.model = {
            chromeUrl: __webpack_require__(319),
            firefoxUrl: __webpack_require__(323),
            ieUrl: __webpack_require__(330)
        };
    }
    return CloseCookie;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(33), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, util, GrahicVerifyWindow, perVerifycodeUtil) {
    'use strict';

    var me, i18n, iamUtils, step;

    function FPhoneController($scope, $compile, _i18n, _iamUtils, _step, securityPolicy) {
        i18n = _i18n;
        iamUtils = _iamUtils;
        step = _step;
        me = this;
        step.render($scope, $compile);

        function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {}
        }

        document.title = i18n('titles.fphone');

        $scope.redirect2Login = function () {
            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_redirect2Login', '');
            iamUtils.redirect2Login();
        };

        $scope.i18n = i18n;
        $scope.model = {
            currentLanguage: window.language,
            width: '310px',
            verifyCodeWidth: '135px',
            codeSelectWidth: '135px',
            phoneInputWidth: '210px',
            height: iamUtils.layout.inputFieldHeight,
            optionWidth: '135px',
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            scrollHeight: iamUtils.layout.scrollHeight,
            homePageURL: iamUtils.CONFIG.homepageUrl,
            tipPosition: 'top',
            type: 'password',
            emailRegExp: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
            emailVCodeBtnTxt: i18n('fphone.getVerifyCodeByEmail'),
            smsVCodeBtnTxt: i18n('fphone.getVerifyCodeBySms'),
            codeJson: '',
            codeArray: [],
            defaultCode: '',
            phoneLenObj: '',
            select: function select() {
                var value = $('#' + $scope.model.newPhoneNumId).widget().getValue();
                var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
                $scope.model.phoneLen = iamUtils.getPubPhoneLen($scope.model.codeJson, $scope.model.phoneLenObj);
                $scope.model.phoneValidator = iamUtils.validator.phone($scope.model.phoneLen);
                $scope.$apply();
                iamUtils.unifyValid.FormValid($('#' + $scope.model.newPhoneNumId));
                var errorInfo = validatePhone(value, $scope.model.phoneLen);
                if (errorInfo === '') {
                    me.isKeyExisted($scope, iamHttpService, 'mobile', countryCode, value, i18n('fphone.phoneRepeat'), $scope.model.newPhoneNumId, '#phoneError');
                } else {
                    $('#phoneError').empty();
                }
            },
            matchMethod: function matchMethod(keyword, op) {
                keyword = keyword.trim();
                if (op.toLowerCase().indexOf(keyword.toLowerCase()) >= 0 || keyword == '00' + op.substring(op.indexOf('+') + 1, op.indexOf(')'))) {
                    return true;
                }
            },
            enterpriseId: 'enterpriseId',
            enterpriseNamePH: i18n('fpwd.enterpriseNamePH'),
            codeSelectId: 'codeSelectId',
            newPhoneNumId: 'newPhoneNumId',
            newPhoneNumPH: i18n('fphone.newPhoneNumPH'),
            newPhoneNum: '',

            registerEmail: '',
            registerEmailId: 'registerEmailId',
            registerEmailPH: i18n('fphone.registerEmailPH'),

            passwordId: 'passwordId',
            passwordPH: i18n('fphone.'),

            emailVerifyCodeId: 'emailVerifyCodeId',
            emailVerifyCodePH: i18n('fphone.emailVerifyCodePH'),

            smsVerifyCodeId: 'smsVerifyCodeId',
            smsVerifyCodePH: i18n('fphone.smsVerifyCodePH'),

            countToHomepage: iamUtils.i18nFormat(i18n('countToHomepage'), 10),

            sendEmailVCodeFailed: false,
            sendSmsVCodeFailed: false,

            emailCodeMsg: '',
            smsCodeMsg: '',
            lastEmailAddress: '',
            newPhoneNumFocused: false,
            disable: false,

            selectChange: function selectChange(event, value) {
                send2CloudBISafe('input', 'change', 'fPhone_' + getQueryString('UserType') + '_accountPhone_CountryCode', value);
            },

            textBlur: function textBlur(id) {

                var value = iamUtils.getTrimValue(id);

                send2CloudBISafe('input', 'change', 'fPhone_' + getQueryString('UserType') + '_' + id, value);

                if (id === $scope.model.enterpriseId) {
                    $scope.model.enterpriseName = value;
                } else if (id === $scope.model.registerEmailId) {
                    $scope.model.registerEmail = value;
                } else if (id === $scope.model.emailVerifyCodeId) {
                    $scope.model.emailVerifyCode = value;
                } else if (id === $scope.model.smsVerifyCodeId) {
                    $scope.model.smsVerifyCode = value;
                }

                $scope.$evalAsync();
            },
            onPhoneBlur: function onPhoneBlur() {
                var value = iamUtils.getTrimValue($scope.model.newPhoneNumId);

                send2CloudBISafe('input', 'change', 'fPhone_' + getQueryString('UserType') + '_phone', value);

                $scope.model.newPhoneNum = value;
                $scope.$evalAsync();

                var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
                $scope.model.phoneLen = iamUtils.getPhoneRegex(countryCode, $scope.model.phoneLenObj);
                $scope.model.phoneLen = $scope.model.phoneLen ? $scope.model.phoneLen : 32;
                var errorInfo = validatePhone(value, $scope.model.phoneLen);
                if (errorInfo === '') {
                    me.isKeyExisted($scope, iamHttpService, 'mobile', countryCode, value, i18n('fphone.phoneRepeat'), $scope.model.newPhoneNumId, '#phoneError');
                }
            },
            onEmailChange: function onEmailChange(event, value) {
                limitLength($scope.model.registerEmailId, value, 255);
            },
            onPhoneChange: function onPhoneChange(event, value) {
                $('#phoneError').empty();
                limitLength($scope.model.newPhoneNumId, value, 128);
            },
            onEmailVCodeChange: function onEmailVCodeChange(event, value) {
                limitLength($scope.model.emailVerifyCodeId, value, 120);
            },
            onSmsVCodeChange: function onSmsVCodeChange(event, value) {
                limitLength($scope.model.smsVerifyCodeId, value, 120);
            },
            checkCodeId: 'checkCodeId',
            checkCodeValidator: [iamUtils.validator.childValidator.limitLength(4)],
            checkCode: '',
            checkCodeWidth: 190,
            checkCodePH: i18n('fpwd.verifyCodePH'),
            checkCodeTip: i18n('getVerifyCode'),
            checkCodeMaxLength: 4,
            verifyCodeImg: ''
        };

        $(document).keydown(function (event) {
            if (event.keyCode === 13) {
                var id = $(document.activeElement).attr('id');
                if (id === 'emailMsgBtn') {
                    $scope.model.emailVerifyCodeBtnClick();
                } else if (id === 'smsMsgBtn') {
                    $scope.model.smsVerifyCodeBtnClick();
                }
                $scope.$evalAsync();
            }
        });
        initLoginUrl();
        iamUtils.getCountryCode($scope);

        $scope.model.preValidVerifyCode = function (event, value) {
            var img = $('#validresultImg');
            perVerifycodeUtil.preValidVerifyCode(img, value, '4', preValidCallback, iamHttpService);
        };

        $scope.model.preValidVerifyCodeBlur = function (event, value) {
            //send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_VerifyCodeImg", $scope.model.checkCode);
        };

        $scope.model.getVerifyCodeImg = function () {
            //send2CloudBISafe("button", "click" , "login_" + ($scope.model.isCompany ? 'company' : 'personal')+"_getVerifyCodeImg", '');
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
            }
            $scope.model.checkCode = '';
            $('#validresultImg').hide();
        };

        $scope.model.getVerifyCodeImg();

        function preValidCallback() {
            $scope.model.checkCode = '';
            $scope.$apply();
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
            }
        }

        $scope.model.emailValidator = iamUtils.validator.email();
        $scope.model.countryCodeValidator = iamUtils.validator.countryCode($scope.model.codeArray);
        $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
        $scope.model.smsMsgCodeValidator = iamUtils.validator.smsMsgCode();
        if (iamUtils.getPhoneRegex($scope.model.defaultCode, $scope.model.phoneLenObj)) {
            $scope.model.phoneLen = iamUtils.getPhoneRegex($scope.model.defaultCode, $scope.model.phoneLenObj);
        }
        $scope.model.phoneLen = $scope.model.phoneLen ? $scope.model.phoneLen : 32;
        $scope.model.phoneValidator = iamUtils.validator.phone($scope.model.phoneLen);
        var commonValidator = iamUtils.validator.commonValidInput();
        commonValidator.push(iamUtils.validator.required()[0]);
        $scope.model.commonValidator = commonValidator;

        $scope.model.enterpriseValidator = iamUtils.validator.commonValidInput();
        var enterpriseValidator = function () {
            var validators = [iamUtils.validator.childValidator.limitLength(128), iamUtils.validator.notBlank(false), iamUtils.validator.minLen(1)[0], iamUtils.validator.maxLen(128, i18n('validAccountName'))[0]];

            return validators;
        }();
        $scope.model.enterpriseFocus = function () {
            if ($scope.model.enterpriseValidator != enterpriseValidator) {
                $scope.model.enterpriseValidator = enterpriseValidator;
            }
        };

        $scope.model.emailValidator = checkEmail($scope);
        function checkEmail($scope) {
            var emailCheck = {
                validFn: function validFn() {
                    var value = this.val();
                    var emailPattern = $scope.model.emailRegExp;
                    return emailPattern.test(value);
                },
                errorDetail: i18n('validEmail')
            };

            var validators = [iamUtils.validator.childValidator.limitLength(255), iamUtils.validator.notBlank(true), iamUtils.validator.maxLen(255, i18n('validEmail'))[0], //����??��?�䨮3��?��128
            emailCheck];
            return validators;
        }

        $scope.model.step1KeyPress = function (event) {
            iamUtils.enterEvent(event, $scope.nextStep1);
        };
        $scope.model.step2KeyPress = function (event) {
            iamUtils.enterEvent(event, $scope.nextStep2);
        };

        $scope.nextStep1 = function () {
            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_nextStep1', '');

            var $step1 = $('#step1');
            if (!iamUtils.unifyValid.FormValid($step1)) {
                iamUtils.unifyValid.focusFirst($step1);
                return;
            }
            if ($scope.model.registerEmail !== $scope.model.lastEmailAddress) {
                $scope.model.sendEmailVCodeFailed = false;
                $scope.model.sendSmsVCodeFailed = false;
            }
            checkUserExist($scope);
        };

        function checkUserExist($scope) {
            var domainName = $('#' + $scope.model.enterpriseId).widget().getValue();
            var accountName = $('#' + $scope.model.registerEmailId).widget().getValue();
            var userType = iamUtils.getUrlParams().UserType;

            var checkCode = $scope.model.checkCode;
            checkCode = $scope.model.checkCode;
            $scope.model.checkCode = '';

            if (checkCode.length < 4) {
                $scope.model.getVerifyCodeImg();
                iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseVerificationCode'), '', 'fphonePopupMsg');
                return;
            }

            iamHttpService.post({
                url: '/authui/userFindPwd/exists',
                params: {
                    type: 'email',
                    userType: userType,
                    value: accountName,
                    domainName: domainName,
                    verifyCode: checkCode,
                    scene: 'fphone'
                }
            }).then(function (data) {
                if (data === 'checkVerifyCode4Forbidden') {
                    iamUtils.MESSAGE.ERROR(i18n('operationTooFrequent'), '', 'fphonePopupMsg');
                    return;
                }
                data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (data.count != 1) {
                    if (domainName === '') {
                        iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEmail'), '', 'fphonePopupMsg');
                    } else {
                        iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseAccountAndEmail'), '', 'fphonePopupMsg');
                    }
                    return;
                }
                goToStep(2);

                $('#step1').hide();
                $('#step2').show();
            }), function (data) {
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
            };
        }

        $scope.onCancelBtnClick = function () {
            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_cancelHandlerStep1', '');

            window.location.href = $scope.model.loginUrl;
        };

        $scope.model.emailVerifyCodeBtnClick = function () {

            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_emailVerifyCode', '');

            if ($('#emailMsgBtn').hasClass('msgBtnDisabled')) {
                return;
            }

            $scope.model.sendEmailVCodeFailed = false;
            sendEmailVCode($scope);
            emailMsgBtnHandler($scope);
        };

        function sendEmailVCode($scope) {
            var userType = getQueryString('UserType');
            if (userType === 'p') {
                var params = {
                    email: $('#' + $scope.model.registerEmailId).widget().getValue()
                };
            } else {
                var params = {
                    domain: encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                    email: $('#' + $scope.model.registerEmailId).widget().getValue()
                };
            }
            $('#emailCodeMsg').hide();
            iamHttpService.post({
                url: '/rest/authui/fphone/emailVerifyCode',
                params: params
            }).then(function (data) {
                if (data.retcode == 200) {
                    if (data.remainderCount >= 0) {
                        $scope.model.emailCodeMsg = data.remainderCount == 0 ? i18n('verifyCode.cantAcquire') : iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#emailCodeMsg').show();
                    }
                } else if (data.retcode == 412) {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                } else if (data.retcode == 411) {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                } else {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                }
            }, function () {
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                $scope.model.sendEmailVCodeFailed = true;
            });
        }

        function emailMsgBtnHandler($scope) {
            var timeInterval = 60;
            var counter = 0;
            $('#emailMsgBtn').addClass('msgBtnDisabled');
            function timer() {
                if (counter < timeInterval) {
                    if ($scope.model.sendEmailVCodeFailed) {
                        $('#emailMsgBtn').removeClass('msgBtnDisabled');
                        $scope.model.emailVCodeBtnTxt = i18n('fphone.getVerifyCodeByEmail');
                        $scope.$apply();
                        $scope.model.sendEmailVCodeFailed = false;
                        return;
                    }

                    counter++;
                    $scope.model.emailVCodeBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                    if (counter != 0) {
                        $scope.$apply();
                    }

                    setTimeout(timer, 1000);
                } else {
                    $('#emailMsgBtn').removeClass('msgBtnDisabled');
                    $scope.model.emailVCodeBtnTxt = i18n('fphone.getVerifyCodeByEmail');
                    $scope.$apply();
                }
            }
            setTimeout(timer, 0);
        };

        $scope.model.smsVerifyCodeBtnClick = function () {

            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_smsVerifyCode', '');

            if (validatePhone($('#' + $scope.model.newPhoneNumId).widget().getValue()) !== '') {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
                return;
            }
            $scope.dft.done(function () {
                sendSmsVerifyCode();
            }).fail(function () {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
            });
        };

        function sendSmsVerifyCode() {
            if ($('#smsMsgBtn').hasClass('msgBtnDisabled')) {
                return;
            }

            iamHttpService.get({
                url: '/rest/authui/verifycode/needverify',
                params: {
                    scene: 'findPhone'
                }
            }).then(function (data) {
                if (data.needVerify) {
                    var winOptions = {
                        title: i18n('GraphicsVerifyCode')
                    };

                    var win = new GrahicVerifyWindow(i18n, winOptions, okHandler, 5);
                    win.show();
                } else {
                    smsMsgBtnHandler($scope);
                    setTimeout(function () {
                        sendMsg($scope, null);
                    }, 200);
                }
            }, function () {
                $('#msgBtn').removeClass('msgBtnDisabled');
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'popupMsg');
            });
        }

        function okHandler(verifyCode) {
            $scope.model.sendSmsVCodeFailed = false;
            smsMsgBtnHandler($scope);
            setTimeout(sendMsg($scope, verifyCode), 200);
        }

        function sendMsg($scope, verifyCode) {
            $('#smsCodeMsg').hide();
            var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
            if (!countryCode) {
                $scope.model.sendSmsVCodeFailed = true;
                // js控制显示国家码错误信息
                $('#' + $scope.model.codeSelectId + ' .tiny-combobox-container ').addClass('valid_error_input');
                setTimeout(function () {
                    $('div#codeSelectId div.tiny-combobox-container input').focus().focus();
                }, 500);
                return;
            }
            iamHttpService.post({
                url: '/rest/authui/fphone/smsVerifyCode',
                params: {
                    countryCode: countryCode,
                    phone: $('#' + $scope.model.newPhoneNumId).widget().getValue(),
                    graphicsVerifyCode: verifyCode
                }
            }).then(function (data) {
                if (data.retcode == 200) {
                    if (data.remainderCount >= 0) {
                        $scope.model.smsCodeMsg = data.remainderCount == 0 ? i18n('verifyCode.cantAcquire') : iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#smsCodeMsg').show();
                    }
                } else if (data.retcode == 412) {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                } else if (data.retcode == 404) {
                    iamUtils.MESSAGE.ERROR(i18n('GrapVerifyCodeFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                } else if (data.retcode == 411) {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                } else {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                }
            }, function () {
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                $scope.model.sendSmsVCodeFailed = true;
            });
        }

        function smsMsgBtnHandler($scope) {
            var timeInterval = 60;
            var counter = 0;
            $('#smsMsgBtn').addClass('msgBtnDisabled');
            function timer() {
                if (counter < timeInterval) {
                    if ($scope.model.sendSmsVCodeFailed) {
                        $('#smsMsgBtn').removeClass('msgBtnDisabled');
                        $scope.model.smsVCodeBtnTxt = i18n('fphone.getVerifyCodeBySms');
                        $scope.$apply();
                        $scope.model.sendSmsVCodeFailed = false;
                        return;
                    }

                    counter++;
                    $scope.model.smsVCodeBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                    if (counter != 0) {
                        $scope.$apply();
                    }

                    setTimeout(timer, 1000);
                } else {
                    $('#smsMsgBtn').removeClass('msgBtnDisabled');
                    $scope.model.smsVCodeBtnTxt = i18n('fphone.getVerifyCodeBySms');
                    $scope.$apply();
                }
            }
            setTimeout(timer, 0);
        };

        function initLoginUrl() {
            var service = util.getUrlParams().service;
            var url = '/authui/login.action?locale=' + window.language;
            $scope.model.loginUrl = service !== undefined ? url + '&service=' + service : url;
        }

        $scope.nextStep2 = function () {
            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_nextStep2', '');

            var $nextBtn = $('#nextBtn');
            if ($nextBtn.hasClass('submitBtnDisable')) {
                return;
            }
            if (validatePhone($('#' + $scope.model.newPhoneNumId).widget().getValue()) !== '') {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
                return;
            }
            var $step2 = $('#step2');
            if (!iamUtils.unifyValid.FormValid($step2)) {
                iamUtils.unifyValid.focusFirst($step2);
                return;
            }

            $scope.dft.done(function () {
                changePhoneNum();
            }).fail(function () {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
            });
        };

        $scope.turnToStep1 = function () {

            send2CloudBISafe('button', 'click', 'fPhone_' + getQueryString('UserType') + '_turnToStep1', '');

            $('#step2').hide();
            $('#step1').show();
            goToStep(1);
            clearInputStep2($scope);
            util.removeErrorInfo('#phoneError');
            $scope.model.newPhoneNum = '';
            $scope.model.lastEmailAddress = $('#' + $scope.model.registerEmailId).widget().getValue();
            $scope.model.sendEmailVCodeFailed = true;
            $scope.model.sendSmsVCodeFailed = true;
            $scope.model.phoneValidator = iamUtils.validator.phone();
            $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
            $scope.model.smsMsgCodeValidator = iamUtils.validator.smsMsgCode();
            $scope.$evalAsync();
        };
        function clearInputStep2($scope) {
            $scope.model.emailVerifyCode = '';
            $scope.model.smsVerifyCode = '';
            $('#smsCodeMsg').hide();
            $('#emailCodeMsg').hide();
        }
        function changePhoneNum() {
            $('#nextBtn').addClass('submitBtnDisable');
            $('#nextBtn').removeClass('submitBtn');
            var userType = getQueryString('UserType');
            var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
            clearInputStep2($scope);
            iamHttpService.post({
                url: '/rest/authui/fphone/changePhoneNum',
                params: {
                    domain: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                    email: $('#' + $scope.model.registerEmailId).widget().getValue(),
                    countryCode: countryCode,
                    phone: $('#' + $scope.model.newPhoneNumId).widget().getValue(),
                    emailVCode: $('#' + $scope.model.emailVerifyCodeId).widget().getValue(),
                    smsVCode: $('#' + $scope.model.smsVerifyCodeId).widget().getValue()
                }
            }).then(function (data) {
                if (data.retcode == 200) {
                    goToStep(3);
                    $scope.model.maskNewPhoneNum = iamUtils.SecurityMasker.maskMobile(countryCode + '-' + $scope.model.newPhoneNum).replace(/^0*/, '+').replace(/-/, ' ');
                    $('#step2').hide();
                    $('#step3').show();
                    goToHomeLater();
                } else {
                    if (data.retcode == 400) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('invalidInput'), '', 'fphonePopupMsg');
                    } else if (data.retcode == 414) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.invalid'), '', 'fphonePopupMsg');
                    } else if (data.retcode == 415) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.emailInvalidAndSMSError'), '', 'fphonePopupMsg');
                    } else if (data.retcode == 416) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.email.invalid'), '', 'fphonePopupMsg');
                    } else if (data.retcode == 417) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.email.error'), '', 'fphonePopupMsg');
                    } else if (data.retcode == 409) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('fphone.phoneRepeat'), '', 'fphonePopupMsg');
                        $scope.model.newPhoneNumFocused = true;
                    } else if (data.retcode == 403) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('selfManage.alertTip'), '', 'fphonePopupMsg');
                        $scope.model.newPhoneNumFocused = true;
                    } else {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
                    }
                    var $nextBtn = $('#nextBtn');
                    $nextBtn.addClass('submitBtn');
                    $nextBtn.removeClass('submitBtnDisable');
                }
                try {
                    $scope.$apply();
                } catch (e) {}
            }, function (data) {
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
                var $nextBtn = $('#nextBtn');
                $nextBtn.addClass('submitBtn');
                $nextBtn.removeClass('submitBtnDisable');
                try {
                    $scope.$apply();
                } catch (e) {}
            });
        }

        function goToStep(stepNum) {
            step.goToStep(stepNum);
        }

        function goToHomeLater() {
            var timeInterval = 10;
            var counter = 0;

            function timer() {
                if (counter < timeInterval) {
                    $scope.model.countToHomepage = iamUtils.i18nFormat(i18n('countToHomepage'), timeInterval - counter);
                    if (counter != 0) {
                        $scope.$apply();
                    }
                    counter++;
                    setTimeout(timer, 1000);
                } else {
                    iamUtils.redirect2Login();
                }
            }

            setTimeout(timer, 0);
        }

        function initPage(iamUtils) {
            var uType = iamUtils.getUrlParams().UserType;
            //var uType = getQueryString('UserType');
            //getQueryString 可能取到#后面的部分
            if (uType == null || uType == '') {
                window.location.assign('/authui');
                return;
            }
            $scope.model.enterpriseFocused = true;
            $scope.model.registerEmailFocused = false;
            if (uType == 'p') {
                $('#enterprise').hide();
                $scope.model.enterpriseFocused = false;
                $scope.model.registerEmailFocused = true;
            }
        }

        function validatePhone(value, length) {
            if (validateBlank(value) !== '') {
                return validateBlank(value);
            }

            if (!me.validatePhoneLength(value)) {
                return i18n('validPhone');
            }
            var phoneLen = length ? length : 32;
            var lengthValidator = validateMaxLength(value, phoneLen, i18n('phoneMaxLenTxt'));
            if (lengthValidator !== '') {
                return lengthValidator;
            }
            return '';
        }

        function validateBlank(value) {
            if (value == undefined || value.length === 0 || value.toString().indexOf(' ') !== -1) {
                return i18n('emptyTxt');
            }
            return '';
        }

        function validateMaxLength(value, maxLen, errorInfo) {
            var minLenNum = Number(maxLen);
            if (isNaN(minLenNum)) {
                minLenNum = 0;
            }

            if (value.length > maxLen) {
                return iamUtils.i18nFormat(errorInfo, minLenNum);
            }

            return '';
        }

        function addErrorInfo(errorTxt, txtFielId, errorInfoid) {
            util.removeErrorInfo(errorInfoid);
            var imgSrc = __webpack_require__(10);
            var errorDomFragment = '<img src="' + imgSrc + '"><span>' + errorTxt + '</span>';
            $(errorInfoid).html(errorDomFragment);
            var tempNewPhoneNum = $('#' + txtFielId);
            if (tempNewPhoneNum[0].tagName === 'INPUT') {
                tempNewPhoneNum.addClass('tiny-input-text valid_error_input');
            } else {
                tempNewPhoneNum.find('input').addClass('tiny-input-text valid_error_input');
            }
        }

        function limitLength(fieldId, value, length) {
            if (value.length > length) {
                $('#' + fieldId).val(value.substring(0, length));
            }
        }

        initPage(iamUtils);
    }
    function getQueryString(param) {
        var query = decodeURI(window.location.search.substring(1));
        var queryArr = query.split('&');
        for (var i = 0; i < queryArr.length; i++) {
            var pairs = queryArr[i].split('=');
            if (param === pairs[0]) {
                return pairs[1];
            }
        }
        return null;
    }

    function showOkImg(txtFielId, infoid) {
        util.removeErrorInfo(infoid);
        var tempNewPhoneNum = $('#' + txtFielId);
        if (tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.removeClass('valid_error_input');
        } else {
            tempNewPhoneNum.find('input').removeClass('valid_error_input');
        }
        var imgSrc = __webpack_require__(27);
        var imgDom = '<img src="' + imgSrc + '"/>';
        $(infoid).html(imgDom);
    }
    FPhoneController.prototype.validatePhoneLength = function (value) {
        var pattern = /^[0-9]\d*$/;
        return pattern.test(value);
    };

    FPhoneController.prototype.isKeyExisted = function ($scope, iamHttpService, type, countryCode, value, errorTxt, txtFielId, errorInfoid) {
        var userType = getQueryString('UserType');

        $scope.dft = $.Deferred();
        iamHttpService.post({
            url: '/authui/fphone/exists',
            params: {
                domainName: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                countryCode: countryCode,
                mobile: value,
                email: $('#' + $scope.model.registerEmailId).widget().getValue()
            }
        }).then(function (data) {
            if (data.count) {
                addErrorInfo(errorTxt, txtFielId, errorInfoid);
                $scope.dft.reject();
            } else {
                showOkImg(txtFielId, errorInfoid);
                $scope.dft.resolve();
            }
        }, function (data) {
            addErrorInfo(i18n('systemException'), txtFielId, errorInfoid);
            $scope.dft.resolve();
        });
    };

    return FPhoneController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
    "use strict";

    function BFController($scope) {
        initCommonPageBanner($scope);
        var hash = location.hash.substring(2);
        if (hash === "register" || hash === "registerFailed") {
            initRegisterPageBanner($scope);
        }
        if (hash === "login") {
            initLoginPageBanner($scope);
        } else if (hash === "resetPwd") {
            initresetPwdPageBanner($scope);
        }
        $scope.model.refreshPage = refreshPage;
    };

    function initRegisterPageBanner($scope) {
        document.title = $scope.i18n("titles.register");

        var redirectUrl = utils.getUrlParams()["service"];
        if (redirectUrl === undefined) {
            redirectUrl = "";
        }
        $scope.model.redirectUrl = "/authui" + (redirectUrl.length != 0 ? "?" + redirectUrl : "");
    }

    function initLoginPageBanner($scope) {
        document.title = $scope.i18n("titles.login");

        $("#enterpriseSwitch").hover(function () {
            $("#languages").hide();
        });
        $("#rootSwitch").hover(function () {
            $("#languages").hide();
        });
    }

    function initresetPwdPageBanner($scope) {
        $scope.model.isShowLogoutInResetPwdPage = true;
    }

    function refreshPage(language, $scope) {
        var searchStr = window.location.search.substring(1);
        if (searchStr === "") {
            window.location.search = "locale=" + language;
        } else {
            var newSearchStr = "";
            var params = searchStr.split("&");
            var needAddLocale = true;
            // 取出URL中的locale参数，替换为新的语言
            for (var index = 0; index < params.length; index++) {
                var key = params[index].substring(0, params[index].indexOf("="));
                if ("locale" === key) {
                    var value = params[index].substring(params[index].indexOf("=") + 1);
                    params[index] = key + "=" + language;
                    needAddLocale = false;
                }
                if (index === 0) {
                    newSearchStr += params[index];
                } else {
                    newSearchStr += "&" + params[index];
                }
            }
            if (needAddLocale) {
                newSearchStr += "&locale=" + language;
            }
            window.location.search = newSearchStr;
        }
    }

    function initCommonPageBanner($scope) {
        var languageSwitch = $("#languageSwitch");
        languageSwitch.unbind("hover").hover(function () {
            var languages = $("#languages");
            var loginPageLanguages = $("#loginPageLanguages");
            var children = languages.children();
            if (children.length == 0 && loginPageLanguages.children().length == 0) {
                return;
            }
            for (var index = 0; index < children.length; index++) {
                $(children[index]).click(function (event) {
                    refreshPage(event.currentTarget.id, $scope);
                });
            }

            if (!languages.is(":visible")) {
                languages.show();
            }

            if (!loginPageLanguages.is(":visible")) {
                loginPageLanguages.show();
                if ($scope.model.isMobile) {
                    var maskDiv = $("<div id='loginPageLanguagesMask' style='position: fixed;top: 0px;left: 0px;width: 100%;height: 100%;background-color: rgba(0,0,0,0.2);z-index: 100;'></div>");
                    $(document.body).append(maskDiv);
                }
            }
        }, function () {
            // 
        });

        $(document).click(function (event) {
            if (event.target !== $("#languageSwitch")[0] && event.target !== $("#languageSwitch > span")[0] && event.target !== $("#languageSwitch > div")[0] && event.target !== $("#languageSwitch > img")[0]) {
                $("#languages").hide();
                $("#loginPageLanguages").hide();
                $('#loginPageLanguagesMask').remove();
            }
        });
    }
    return BFController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(11), __webpack_require__(5), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, cookieOp, util, htmlTransformer, $filter) {
    'use strict';

    var timeFormat, me, iamUtils, iamEnv;

    function send2CloudBISafe() {
        try {
            send2CloudBI.apply(null, arguments);
        } catch (e) {
            console.dir(e);
        }
    }
    var loginVerificationCtrl = function loginVerificationCtrl($scope, $sce, i18n, _iamUtils, _iamEnv, $filter, $interval) {
        timeFormat = this.timeFormat;
        me = this;
        iamUtils = _iamUtils;
        iamEnv = _iamEnv;
        $scope.model = {
            currentLanguage: window.language,
            tipPosition: 'top',
            tipWidth: '250px',
            msgCodeWidth: '100px',
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            changeMobileHref: getChangeMobileHref(),
            msgTxtId: 'msgTxtId',
            msgBtnTxt: i18n('msgCodeTxt'), //loginVerification.emailCodeTxt
            lockInfo: '',
            presetInfo: '',
            lastSuccessTime: '',
            failedTimes: '',
            lastFailedTime: '',
            phoneNum: '',
            actionError: '',
            isSendSmsCodeFailed: false,
            keypress: function keypress(event) {
                if (event.keyCode === 13) {
                    $('#OKBtn').click();
                }
            },
            verificationType: '' // phone,email,mfa 
        };

        $scope.i18n = i18n;
        $scope.onGetMsgBtnClick = function () {
            onGetMsgBtnClick($scope, i18n, iamUtils);
        };
        $scope.onOkBtnClick = function () {
            onOkBtnClick($scope, iamUtils, iamEnv);
        };
        $scope.onCancelBtnClick = function () {
            send2CloudBISafe('button', 'click', 'login_verification_' + $scope.model.verificationType + '_cancel', '');
            var service = util.getUrlParams().service;
            var hwIdLogoutLink = { value: 'https://id1.cloud.huawei.com/AMW/logout' };
            var redirectUrl = hwIdLogoutLink.value;
            service !== undefined ? service = 'https://auth.huaweicloud.com/authui/logout?service=' + service : service = 'https://auth.huaweicloud.com/authui/logout';
            if (redirectUrl) {
                window.location.href = redirectUrl + '?service=' + service;
            } else {
                window.location.href = service;
            }

            $('#cancelBtnBtn').removeClass('cancelBtnCls');
            $('#cancelBtnBtn').addClass('disabledCancelBtnCls');
        };

        $scope.model.msgValidator = iamUtils.validator.smsMsgCode();
        $scope.model.emailValidator = iamUtils.validator.msgCode(); //验证先去一样
        $scope.model.mfaValidator = iamUtils.validator.mfaCode();
        $scope.model.mfaHelp = $scope.mfaHelp;

        $scope.model.changePhone = function () {
            send2CloudBISafe('button', 'click', 'login_verification_' + $scope.model.verificationType + '_changePhone', '');
        };

        $scope.model.buttonEvent = function (name) {
            send2CloudBISafe('button', 'click', 'login_verification_' + $scope.model.verificationType + '_' + name, '');
        };

        $scope.model.msgCodeBlur = function () {

            send2CloudBISafe('input', 'change', 'login_verification_' + $scope.model.verificationType, $('#' + $scope.model.msgTxtId).widget().getValue());
        };

        document.title = i18n('titles.loginVerification');
        initPageInfo($scope, $sce, i18n, $filter);
    };

    function onGetMsgBtnClick($scope, i18n, iamUtils) {

        if ($scope.model.verificationType) {
            send2CloudBISafe('button', 'click', 'login_verification_' + $scope.model.verificationType, '');
        }

        if ($('#getMsgCodeBtn').hasClass('getMsgCodeBtn')) {
            disableGetMsgCodeBtn($scope, i18n, iamUtils);
            if ($('#msgErrorTip').text() !== '') {
                $('#msgErrorTip').text('');
            }

            iamHttpService.post({
                url: '/authui/sendLoginSms',
                params: {}
            }).then(function (data) {
                var retJson = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (retJson.result === 'success') {
                    var remainderCount = retJson.remainderCount;
                    if (remainderCount >= 0) {
                        var content = remainderCount == 0 ? i18n('verifyCode.cantAcquire') : iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), remainderCount);
                        $('#msgErrorTip').text(content);
                    }

                    return;
                } else if (retJson.result === 'faster') {
                    $('#msgErrorTip').text(i18n('verifyCode.intervalError'));
                } else if (retJson.result === 'locked') {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (retJson.lockDuration && retJson.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), retJson.lockDuration);
                    }
                    $('#msgErrorTip').text(lockedMsg);
                } else if (retJson.result === 'error') {
                    $('#msgErrorTip').text(i18n('verifyCode.sendFailed'));
                }

                $scope.model.isSendSmsCodeFailed = true;
            }, function (data) {
                if (data.status == 403) {
                    var btnBack2Login = [{
                        key: 'btnwed12',
                        label: i18n('btnTxtOK'),
                        accessKey: '3',
                        focused: true,
                        handler: function handler(event) {
                            iamUtils.redirect2Login();
                        }
                    }];
                    iamUtils.MESSAGE.ERROR(i18n('sessionExpired'), '', 'popupMsg', btnBack2Login, iamUtils.redirect2Login);
                } else {
                    $('#msgErrorTip').text(i18n('systemException'));
                    $scope.model.isSendSmsCodeFailed = true;
                }
            });
        }
    }

    function onOkBtnClick($scope, iamUtils, iamEnv) {

        send2CloudBISafe('button', 'click', 'login_verification_' + $scope.model.verificationType + '_nextStep', '');

        if (!iamUtils.unifyValid.FormValid($('#getMsgDiv'))) {
            iamUtils.unifyValid.focusFirst($('#getMsgDiv'));
            return;
        }

        if (me.isDisabledOfOkBtn()) {
            return;
        } else {
            me.disableOKBtn();
        }

        if (iamEnv.isPublishEnv()) {
            var temp = document.createElement('form');
            if (window.location.search === '') {
                temp.action = '/authui/validateUser';
            } else {
                temp.action = '/authui/validateUser?' + window.location.search.substring(1, window.location.search.length);
            }
            temp.method = 'post';
            temp.style.display = 'none';
            if ($scope.model.verificationType !== '' && $scope.model.verificationType !== 'none') {
                var opt = document.createElement('textarea');
                opt.name = 'smsCode';
                opt.value = $('#' + $scope.model.msgTxtId).widget().getValue();
                temp.appendChild(opt);
            }
            // step
            var step = document.createElement('textarea');
            step.name = 'step';
            step.value = 'afterAntiPhishing';
            temp.appendChild(step);
            // IAMCSRF
            var IAMCSRFClient = document.createElement('textarea');
            IAMCSRFClient.name = 'IAMCSRF';
            IAMCSRFClient.value = $('#IAMCSRFClient').text();
            temp.appendChild(IAMCSRFClient);

            //isSupport 为true 为新接口
            if ($scope.isSupport) {
                var isSupport = document.createElement('textarea');
                isSupport.name = 'isSupport';
                isSupport.value = true;
                temp.appendChild(isSupport);
            }

            document.body.appendChild(temp);
            temp.submit();
        } else {
            iamHttpService.post({
                url: '/authui/validateUser',
                params: {}
            }).then(function (data) {
                if (data.loginResult === 'success') {
                    window.location.href = data.redirectUrl;
                    return;
                }
            }, function (data) {});
        }
    }

    loginVerificationCtrl.prototype.isDisabledOfOkBtn = function () {
        return !$('#OKBtn').hasClass('submitBtn');
    };

    loginVerificationCtrl.prototype.disableOKBtn = function () {
        $('#OKBtn').removeClass('submitBtn');
        $('#OKBtn').addClass('disabledSubmitBtn');
    };

    function initPageInfo($scope, $sce, i18n, $filter) {
        getInfoFromServer($scope, $sce, i18n, $filter);

        var actionErrors = util.getUrlParams().actionErrors;
        if (actionErrors !== undefined) {
            var msg = {
                '403': i18n('selfManage.alertTip'),
                '406': i18n('invalidInput'),
                '418': i18n('verifyCode.error'),
                '419': i18n('verifyCode.invalid'),
                '429': i18n('loginVerification.mfaCodeLocked')
            };

            $scope.model.actionError = msg[actionErrors];
        }
    }

    function getInfoFromServer($scope, $sce, i18n, $filter) {
        var loginURL = '/authui/login' + window.location.search;

        iamHttpService.get({
            url: '/authui/getAntiPhishingInfo',
            params: {
                isSupport: !!$scope.isSupport
            },
            mask: true
        }).then(function (data) {

            if (data.result === 'failed') {
                window.location.href = loginURL;
                return;
            }

            if (data.loginTip !== undefined) {
                $scope.model.presetInfo = $sce.trustAsHtml(htmlTransformer.htmlDecode(String(data.loginTip)));
            }

            var loginRecord = data.loginRecord;
            if (loginRecord !== undefined) {
                $scope.model.failedTimes = loginRecord.failedTimes;

                if (loginRecord.lastSuccessfulTime !== undefined) {
                    var utcTime = new Date(loginRecord.lastSuccessfulTime.replace(/-/g, '/'));
                    var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset() * 1000 * 60);
                    $scope.model.lastSuccessTime = $filter('date')(localTime, i18n('dateFormate')) + ' ' + iamUtils.getCurrentTimeZone();
                }

                if (loginRecord.lastFailedTime !== undefined) {
                    var utcTime = new Date(loginRecord.lastFailedTime.replace(/-/g, '/'));
                    var localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset() * 1000 * 60);
                    $scope.model.lastFailedTime = $filter('date')(localTime, i18n('dateFormate')) + ' ' + iamUtils.getCurrentTimeZone();
                }

                $scope.model.lockInfo = util.i18nFormat(i18n('loginVerification.lockInfo'), loginRecord.maxTimesFailLock, loginRecord.releaseLockTime);
            }

            if (data.IAMCSRF !== undefined) {
                $scope.model.IAMCSRF = $sce.trustAsHtml(htmlTransformer.htmlEncode(data.IAMCSRF));
            }

            // 兼容旧接口，login_protect_type 不存在时
            if (data.mfa && data.mfa.login_protect_type) {
                $scope.model.verificationType = data.mfa.login_protect_type;
            }

            if (data.mobile) {
                $scope.model.phoneNum = iamUtils.SecurityMasker.maskMobile(data.mobile);
                $scope.model.phoneNum = $scope.model.phoneNum.replace(/^0*/, '+').replace(/-/, ' ');
                $scope.model.verificationType = $scope.model.verificationType || 'sms';
            }

            $scope.model.verificationType == 'email' && ($scope.model.msgBtnTxt = i18n('loginVerification.emailCodeTxt'));

            if ($scope.model.verificationType == 'vmfa') {
                var content = '<div><p>' + iamUtils.i18nFormat(i18n('loginVerification.MFANotUseMessage2')) + '</p></div>';

                if (data.isTenant !== 'true') {
                    content = '<div><p>' + i18n('loginVerification.MFANotUseMessage1') + '</p></div>';
                }

                setTimeout(function () {
                    new tinyWidget.Tip({
                        content: content,
                        element: $('#getMFACodeTip'),
                        position: 'bottom',
                        id: 'input_tip1'
                    });
                });

                if (typeof data.showRememberMFA === 'boolean' && data.showRememberMFA) {
                    $scope.authModel.showrememberMFACheckbox = true;
                }

                setTimeout(function () {
                    if ($scope.authModel.rememberMFADisabled) {
                        iamUtils.showTooltip($('#rememberMFACheckbox'), i18n('loginVerification.rememberMFALabel.disabledTip'));
                    }
                });
            }

            if (data.email) {
                $scope.model.emailNum = data.email;
                $scope.model.emailCheckContent = iamUtils.i18nFormat(i18n('loginVerification.emailCheckContent'), $scope.model.emailNum);
            }

            if ($scope.model.phoneNum !== '') {
                $scope.isShowPhone = true;
            } else {
                $('#OKBtn').focus();
            }

            /* 华为云局点新版登录验证页面需要 */
            if (me.productTypeIsHWS) {
                $scope.authModel.haveBindEmail = data.email && data.email !== '';
                $scope.authModel.haveBindPhone = data.mobile && data.mobile !== '';
                $scope.authModel.havaBindMFA = data.mfa && data.mfa.sn && data.mfa.sn !== '';
                $scope.authModel.completeMobile = data.mobile;
                if (data.mobile) {
                    // $scope.authModel.countryValue = iamUtils.getCountryValue($scope.authModel.countryCodeList, data.mobile.split('-')[0]);
                    //按严婷婷建议，修改为不显示国家名
                    var code = data.mobile.split('-')[0];
                    $scope.authModel.countryValue = code.replace(/^0*/, '+');
                }
                if ($scope.model.verificationType == 'none' || $scope.model.verificationType == '') {
                    $scope.authModel.disabledSubmitBtn = false;
                }
            }
            /* END */

            $scope.$apply();
        }, function () {
            window.location.href = loginURL;
        });
    }

    function disableGetMsgCodeBtn($scope, i18n, iamUtils) {
        $('#getMsgCodeBtn').removeClass('getMsgCodeBtn');
        $('#getMsgCodeBtn').addClass('disabledMsgBtn');
        var timeInterval = 60;
        var counter = 0;
        function timer() {
            if (counter < timeInterval) {
                if ($scope.model.isSendSmsCodeFailed) {
                    activateSendEmailBtn($scope, i18n);
                    $scope.model.isSendSmsCodeFailed = false;
                    $scope.$apply();
                    return;
                }
                counter++;
                $scope.model.msgBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                $scope.$apply();

                setTimeout(timer, 1000);
            } else {
                activateSendEmailBtn($scope, i18n);
                $scope.$apply();
            }
        }

        setTimeout(timer, 0);
    }

    function activateSendEmailBtn($scope, i18n) {
        $('#getMsgCodeBtn').removeClass('disabledMsgBtn');
        $('#getMsgCodeBtn').addClass('getMsgCodeBtn');
        $scope.model.msgBtnTxt = i18n('msgCodeTxt');
        $scope.model.verificationType == 'email' && ($scope.model.msgBtnTxt = i18n('loginVerification.emailCodeTxt'));
    }

    function getChangeMobileHref() {
        var isCurCompany = true;
        var userType = cookieOp.getCookie('accountType');
        if (userType === undefined || userType !== 'company') {
            isCurCompany = false;
        }

        var service = util.getUrlParams().service !== undefined ? '&service=' + util.getUrlParams().service : '';
        return '/authui/login.html?locale=' + window.language + '&UserType=' + (isCurCompany ? 'e' : 'p') + service + '#/fphone';
    }

    return loginVerificationCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, util) {
    "use strict";

    function privacyUpdateCtrl($scope, $state) {
        $scope.model = {
            privacyPolicyUpdate: i18n("privacyPolicyUpdate"),
            privacyTipPre: i18n("privacyTipPre"),
            privacyTipSuf: i18n("privacyTipSuf"),
            secretprotect: i18n("secretprotect"),
            btnTxtOK: i18n("agreementBtnTxt"),
            btnTxtCancel: i18n("btnTxtCancel"),
            checked: true,
            disable: false,
            privacyAgreement: "https://www.huaweicloud.com/declaration/sa_prp_current.html",
            chkChange: function chkChange() {
                if (this.checked) {
                    $scope.model.disable = false;
                } else {
                    $scope.model.disable = true;
                }
            }
        };
        $(document).keydown(function (event) {
            if (event.keyCode === 13) {
                if ($scope.model.disable === false) {
                    $scope.onSubmitClick();
                }
            }
        });
        $scope.onSubmitClick = function () {
            onSubmitClick($scope);
        };
        $scope.onCancelClick = function () {
            var service = util.getUrlParams().service;
            var redirectUrl = "https://id1.cloud.huawei.com/AMW/logout";
            service !== undefined ? service = "https://auth.huaweicloud.com/authui/logout?service=" + service : service = "https://auth.huaweicloud.com/authui/logout";
            window.location.href = redirectUrl + "?service=" + service;
        };
    };
    function onSubmitClick($scope) {
        if (window.productType === "HWS" && $scope.model.disable) {
            iamUtils.MESSAGE.ERROR(i18n("privacyAgreementNotAcceptedError"), "", "popupMsg");
        } else {
            var temp = document.createElement("form");
            temp.action = iamUtils.getUrlParams()['isFromID'] == '1' ? "/authui/signPrivateAggreement" : '/authui/validateUser';
            if (window.location.search !== "") {
                temp.action = temp.action + "?" + window.location.search.substring(1, window.location.search.length);
            }
            temp.method = "post";
            temp.style.display = "none";
            var step = document.createElement("textarea");
            step.name = "step";
            step.value = "afterPrivatePolicy";
            temp.appendChild(step);
            // 统一ID兼容
            if (iamUtils.getUrlParams()['isFromID']) {
                var opt = document.createElement("textarea");
                opt.name = "isFromID";
                opt.value = iamUtils.getUrlParams()['isFromID'];
                temp.appendChild(opt);
            }
            document.body.appendChild(temp);
            temp.submit();
        }
    }
    return privacyUpdateCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (cookieOp, iamHttpService, utils) {
    'use strict';

    var i18n, iamUtils;

    function ResetPwd($scope, securityPolicy, _i18n, _iamUtils) {
        i18n = _i18n;
        iamUtils = _iamUtils;

        $scope.i18n = i18n;
        $scope.model = {
            currentLanguage: window.language,
            width: '315px',
            msgCodeWidth: iamUtils.layout.inputFiledWidthHalf,
            height: iamUtils.layout.inputFieldHeight,
            type: 'password',
            newPwdType: 'password',
            confirmPwdType: 'password',
            pwdVisible_1: false,
            pwdVisible_2: false,
            showConfirmPasswordCheck: false,
            submitType: 'major',
            focused: true,
            validTip: __webpack_require__(41),
            validSuc: __webpack_require__(66),
            validFail: __webpack_require__(68),
            tipPosition: 'top',
            isFormShow: false,
            oldPasswordId: 'oldPasswordId',
            passwordId: 'passwordId',
            confirmPasswordId: 'confirmPasswordId',
            lowPasswords: [],
            msgCodeId: 'msgCodeId',
            msgBtnTxt: i18n('resetPwd.getSmsMsgCode'),
            msgCodeBtnId: 'msgCodeBtnId',
            msgBtnDisable: false,
            containsChars: i18n('passwordChars'),
            contSameCharLen: 0,
            homepageUrl: iamUtils.CONFIG.homepageUrl,
            verifyTypeValue: '',
            phone: '',
            email: '',
            verifyTypeLabel: '',
            verifyTypeBtn: '',
            passwdErr: 'None',
            msgCodeLabel: '',
            verifyType: '',
            loginUrl: '/authui/login.action?locale=' + window.language,
            verifyCodeMsg: '',
            emailMsgCodeBtnHandler: '',
            passwordFocused: false,
            smsMsgCodeBtnHandler: '',
            isLogout: true,
            password: '',
            oldPasswdLabel: i18n('resetPwd.oldPasswd'),
            isFirstLogin: false,
            maxPwdLength: securityPolicy.passwordpolicy.password_maxlen
        };

        initPage();

        getPasswordPolicy($scope, iamHttpService, securityPolicy);

        $scope.model.onUserClickSomeBox = function () {
            $('#errorMsg').html('');
            setClearTag();
        };

        $scope.model.onPasswordChange = function () {
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            if ($scope.model.lowPasswords.indexOf($scope.model.password) > -1) {
                $scope.model.isWeakPassword = true;
            } else {
                $scope.model.isWeakPassword = false;
            }
            $scope.model.confirmPassword = '';
            $scope.model.showPasswordCheck = false;
            $scope.model.showConfirmPasswordCheck = false; //改动新密码后重置确认密码状态
            $scope.model.onUserClickSomeBox();
            pwdObj.removeClass('valid_error_input');
            utils.removeErrorInfo('#passwordError');
            showTip($scope);
            if (checkSame(pwdObj)) {
                return;
            }
        };

        $scope.model.onConfirmPasswordChange = function (event, value) {
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            //显示确认密码成功提示条件：不为空、新密码合法、相等
            if ($scope.model.confirmPassword && !pwdObj.hasClass('valid_error_input') && $scope.model.confirmPassword === $scope.model.password) {
                $scope.model.showConfirmPasswordCheck = true;
            } else {
                $scope.model.showConfirmPasswordCheck = false;
            }
        };

        // 密码显示和隐藏切换
        $scope.model.pwdVisibleFunc = function (index) {
            var type, pwdObj;
            if (index == 1) {
                type = $scope.model.pwdVisible_1 ? 'password' : 'text';
                $scope.model.pwdVisible_1 = !$scope.model.pwdVisible_1;
                $('#passwordId>input').attr('type', type);
            } else if (index == 2) {
                type = $scope.model.pwdVisible_2 ? 'password' : 'text';
                $scope.model.pwdVisible_2 = !$scope.model.pwdVisible_2;
                $('#confirmPasswordId>input').attr('type', type);
            }
            $scope.$apply();
        };

        $scope.model.onPasswordFocus = function () {
            showTip($scope);
        };
        $scope.model.oldPasswordBlur = function () {
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            checkSame(pwdObj);
        };
        $scope.model.passwordBlur = function () {
            $scope.model.isWeakPassword = false;
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            if (checkSame(pwdObj)) {
                return;
            }
            if (validPassword($scope)) {
                passwdAsynCheck($scope);
                $scope.model.passwdDtd.done(function () {
                    pwdObj.removeClass('valid_error_input');
                    $scope.model.showPasswordCheck = true;
                    $scope.$apply();
                }).fail(function () {
                    password2error($scope);
                    utils.addErrorTip($scope.model.passwdErr, '#passwordError');
                    $scope.model.showPasswordCheck = false;
                    $scope.$apply();
                });
            } else {
                password2error($scope);
            }
        };

        function passwdAsynCheck($scope) {
            var dtd = $.Deferred();
            iamHttpService.post({
                url: '/authui/passwdAsynCheck',
                params: {
                    domain: $scope.model.domain,
                    username: $scope.model.name,
                    pvvd: $scope.model.password,
                    isCheckByName: 'true'
                }
            }).then(function (data) {
                if (data.result === true) {
                    $scope.model.passwdErr = 'None';
                    utils.removeErrorInfo('#passwordError');
                    dtd.resolve();
                } else {
                    if (data.error_code === '1000') {
                        $scope.model.passwdErr = i18n('invalidInput');
                    } else if (data.error_code === '1001') {
                        $scope.model.passwdErr = i18n('pwdNotUsernameOrInvert');
                    } else if (data.error_code === '1002') {
                        $scope.model.passwdErr = i18n('pwdNotContsMobileOrEmail');
                    } else if (data.error_code === '1003') {
                        $scope.model.isWeakPassword = true;
                        $scope.model.passwdErr = i18n('pwdWeak');
                        $scope.model.lowPasswords.push($scope.model.password);
                        // 会导致JS报错 去掉该设置
                        // iamUtils.setPwdLevelByLevel("strengthLow", "strengthMid", "strengthHigh","low");
                    } else if (data === 'checkVerifyCode4Forbidden') {
                        $scope.model.passwdErr = i18n('freqLocked');
                    } else {
                        $scope.model.passwdErr = i18n('systemException');
                    }
                    dtd.reject();
                }
            }, function () {
                $scope.model.passwdErr = i18n('systemException');
                dtd.reject();
            });
            $scope.model.passwdDtd = dtd.promise();
        }

        function password2error($scope) {
            var pwdObj = $('#' + $scope.model.passwordId); //兼容tiny1.48.1和之前的老版本
            if (pwdObj[0].tagName === 'INPUT') {
                pwdObj.addClass('tiny-input-text valid_error_input');
            } else {
                pwdObj.find('input').addClass('tiny-input-text valid_error_input');
            }
        }

        $scope.model.onVerifyTypeClick = function () {
            $('#errorMsg').html('');
            setClearTag();

            if ($scope.model.verifyTypeBtn === i18n('resetPwd.byMailbox')) {
                $scope.model.verifyTypeBtn = i18n('resetPwd.byPhone');
                $scope.model.verifyTypeLabel = i18n('resetPwd.mailbox');
                $scope.model.msgCodeLabel = i18n('resetPwd.emailMsgCode');
                $scope.model.verifyType = 'email';
                $scope.model.verifyTypeValue = $scope.model.email;
                $scope.model.emailMsgCodeBtnHandler.enableTimer();
                $scope.model.smsMsgCodeBtnHandler.disableTimer($scope.model.msgCode);
                $scope.model.msgCode = '';
                $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
            } else {
                $scope.model.verifyTypeBtn = i18n('resetPwd.byMailbox');
                $scope.model.verifyTypeLabel = i18n('resetPwd.phone');
                $scope.model.msgCodeLabel = i18n('resetPwd.smsMsgCode');
                $scope.model.verifyType = 'phone';
                $scope.model.verifyTypeValue = $scope.model.phone ? $scope.model.phone.replace(/^0*/, '+').replace(/-/, ' ') : $scope.model.phone;
                $scope.model.smsMsgCodeBtnHandler.enableTimer();
                $scope.model.emailMsgCodeBtnHandler.disableTimer($scope.model.msgCode);
                $scope.model.msgCode = '';
                $scope.model.msgCodeValidator = iamUtils.validator.smsMsgCode();
            }
            $('#verifyCodeMsg').hide();
        };

        var tmer = null;
        function startTimeOut() {

            if (tmer != null) {
                clearTimeout(tmer);
                tmer = null;
            }

            tmer = setTimeout(function () {
                window.history.back(-1);
                clearTimeout(tmer);
                tmer = null;
            }, 30 * 60 * 1000);
        };

        startTimeOut();

        function checkBlack() {
            return [{
                validFn: function validFn() {
                    var value = this.val();
                    if (value == undefined || value.length === 0) {
                        return i18n('blankTxt');
                    }
                    return '';
                }
            }];
        };

        $scope.model.equalValidate = iamUtils.validator.confirmPwd('passwordId');
        $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
        $scope.model.requiredValidate = iamUtils.validator.commonValidInput();
        $scope.model.requiredValidate.unshift(iamUtils.validator.notBlank());
        $scope.model.requiredValidate.unshift(iamUtils.validator.childValidator.limitLength(128));

        var oldPasswdValidater = checkBlack();
        oldPasswdValidater.push(iamUtils.validator.maxLen(securityPolicy.passwordpolicy.password_maxlen)[0]);
        oldPasswdValidater.unshift(iamUtils.validator.childValidator.limitLength(33));
        $scope.model.oldPasswdValidate = oldPasswdValidater;

        $scope.model.onMsgCodeBtnClick = function () {

            $('#errorMsg').html('');
            setClearTag();

            if ($('#msgBtn').hasClass('msgBtnDisabled')) {
                return;
            }

            if ($scope.model.verifyType === 'phone') {
                $scope.model.smsMsgCodeBtnHandler.startTimer($scope.model.msgCode);
            } else {
                $scope.model.emailMsgCodeBtnHandler.startTimer($scope.model.msgCode);
            }

            startTimeOut();

            var url = $scope.model.verifyType === 'phone' ? '/authui/mobileAuthCode' : '/authui/emailAuthCode';
            $('#verifyCodeMsg').hide();
            iamHttpService.post({
                url: url
            }).then(function (data) {
                if (data.retcode === 200) {
                    if (data.remainderCount >= 0) {
                        $scope.model.verifyCodeMsg = data.remainderCount == 0 ? i18n('verifyCode.cantAcquire') : iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#verifyCodeMsg').show();
                    }
                } else if (data.retcode === 411) {
                    stopMsgCodeHandler($scope);
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'popupMsg');
                } else if (data.retcode == 412) {
                    stopMsgCodeHandler($scope);
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'popupMsg');
                } else if (data.retcode == 410) {
                    iamUtils.redirect2Login();
                } else {
                    stopMsgCodeHandler($scope);
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'popupMsg');
                }
            }, function (data) {
                stopMsgCodeHandler($scope);
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'popupMsg');
            });
        };

        $scope.model.submitKeyPress = function (event) {
            iamUtils.enterEvent(event, $scope.onSubmitClick);
        };

        $scope.onSubmitClick = function () {
            if ($('#submitBtn').hasClass('btnDisabled')) {
                return;
            }
            var oldPwdObj = utils.getInputObj('oldPasswordId');
            if (oldPwdObj.val().length === 0) {
                oldPwdObj.addClass('valid_error_input');
                oldPwdObj.focus();
                return;
            }
            var pwdObj = utils.getInputObj('passwordId');
            if (checkSame(pwdObj)) {
                $scope.model.passwordFocused = true;
                return;
            }
            if (!validPassword($scope)) {
                pwdObj.addClass('valid_error_input');
                $scope.model.passwordFocused = true;
                return;
            }
            if (pwdObj.val().length === 0) {
                pwdObj.addClass('valid_error_input');
                $scope.model.passwordFocused = true;
                return;
            }

            $('#submitBtn').addClass('btnDisabled');

            if (!iamUtils.unifyValid.FormValid($('#formUl'))) {
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }
            if (!$scope.model.passwdDtd) {
                passwdAsynCheck($scope);
            }
            $scope.model.passwdDtd.fail(function () {
                password2error($scope);
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }).done(function () {
                pwdObj.removeClass('valid_error_input');
                post('/authui/modifyPwd' + window.location.search, {
                    oldimt: $('#' + $scope.model.oldPasswordId).widget().getValue(),
                    newimt: $('#' + $scope.model.passwordId).widget().getValue(),
                    authCode: $scope.model.needValidation ? $('#' + $scope.model.msgCodeId).widget().getValue() : '',
                    pwdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue()),
                    verifyType: $scope.model.needValidation ? $scope.model.verifyType : '',
                    Submit: 'Login'
                });
                clearSensitiveInfo($scope);
            });
        };

        if ($scope.model.isLogout) {
            $scope.onCancelClick = function () {
                cancelModify($scope);
                var index = window.location.search.indexOf('actionErrors');
                if (index != -1) {
                    var subsearch = window.location.search.substring(0, index - 1);
                    window.location.href = '/authui/' + subsearch;
                } else {
                    window.location.href = '/authui/' + window.location.search;
                }
            };
        } else {
            $scope.onCancelClick = function () {
                var serviceId = iamUtils.getUrlParams()['service'];
                var bindEmailUrl = iamUtils.getUrlParams()['bindEmailUrl'];
                if (bindEmailUrl) {
                    if (serviceId === undefined) {
                        window.location.href = '/authui/remindBindEmail.html?bindEmailUrl=' + encodeURIComponent(bindEmailUrl);
                    } else {
                        window.location.href = '/authui/remindBindEmail.html?service=' + encodeURIComponent(serviceId) + '&bindEmailUrl=' + encodeURIComponent(bindEmailUrl);
                    }
                    return;
                }

                if (serviceId === undefined) {
                    window.location.href = '/authui/?locale=' + window.language;
                } else {
                    /*
                     * 1、iamUtils.getUrlParams() 获取url参数值时会做一次url解码
                     * 2、/authui/ 接口在产生ST后，会对service参数做一次url解码，然后将用户重定向到新产生的url
                     * 3、在ICT-O下，两次url解码会导致url中的锚点（ 即：'/#'）暴露，在之后的重定向过程中会锚点信息丢失
                     * 4、为了解决锚点丢失问题，需要此处做url编码
                     * */
                    window.location.href = '/authui/?service=' + encodeURIComponent(serviceId) + '&locale=' + window.language;
                }
            };
        };

        this.getUserInfo($scope, iamHttpService, securityPolicy);

        function checkSame(pwdObj) {
            if ($scope.model.oldPassword === $scope.model.password && $scope.model.oldPassword != '') {
                $scope.model.passwdErr = $scope.model.pwdSameErrorInfo;
                utils.addErrorTip($scope.model.passwdErr, '#passwordError');
                pwdObj.addClass('tiny-input-text valid_error_input');
                return true;
            } else {
                pwdObj.removeClass('valid_error_input');
                utils.removeErrorInfo('#passwordError');
                return false;
            }
        }

        function initPage() {
            if (isApiKeyInit()) {
                return;
            }

            var leftDays = iamUtils.getUrlParams()['leftDays'];
            var isFirstLogin = iamUtils.getUrlParams()['isFirstLogin'];
            $scope.model.isFirstLogin = isFirstLogin === 'true';
            var isPwdExpire = iamUtils.getUrlParams()['isPwdExpire'];

            document.title = i18n('pwdModifyTitle');
            $scope.resetPwdTitle = i18n('pwdModifyTitle');
            $scope.model.pwdSameErrorInfo = i18n('pwdSame');

            if (isFirstLogin) {
                if (isFirstLogin === 'true') {
                    //首次登录
                    document.title = i18n('resetPwd.title');
                    $scope.resetPwdTitle = i18n('resetPwd.title');
                    $scope.titleDetail = i18n('resetPwd.titleDetail');
                    $scope.model.oldPasswdLabel = i18n('resetPwd.InitPasswd');
                    $scope.model.pwdSameErrorInfo = i18n('initialPwdSame');
                } else //密码被管理员重置过
                    {
                        $scope.titleDetail = i18n('resetPwd.titleDetail');
                    }
                return;
            }

            if (isPwdExpire) {
                if (isPwdExpire === 'true') {
                    //密码已经过期
                    document.title = i18n('pwdExpiredTitle');
                    $scope.resetPwdTitle = i18n('pwdExpiredTitle');
                    $scope.titleDetail = i18n('pwdExpiredDesc');
                    $scope.model.oldPasswdLabel = i18n('resetPwd.oldPasswd');
                    $scope.model.pwdSameErrorInfo = i18n('pwdSame');
                }
                return;
            }

            if (leftDays) {
                if (leftDays === '0') {
                    //密码过期
                    $scope.titleDetail = i18n('pwdExpiredDesc');
                } else {
                    //密码即将到期提醒修改
                    $scope.titleDetail = iamUtils.i18nFormat(i18n('pwdExpiringDesc'), leftDays);
                    $scope.model.isLogout = false;
                }
            }
        }
        function isApiKeyInit() {
            var isApiKey = iamUtils.getUrlParams()['isApiKey'];
            if (isApiKey === 'true') {
                $scope.model.isApiKey = true;
                document.title = i18n('resetPwd.apiKeyTitle');
                $scope.resetPwdTitle = i18n('resetPwd.apiKeyTitle');
                $scope.titleDetail = i18n('resetPwd.apiKeyDetail');
                $scope.model.oldPasswdLabel = i18n('resetPwd.apkKey');
                $scope.model.isLogout = false;
                return true;
            }
            return false;
        }

        function getPasswordPolicy($scope, iamHttpService, securityPolicy) {
            var dtd = $.Deferred();
            iamHttpService.get({
                url: '/rest/authui/welcome/getPassvvdPolicy',
                mask: true
            }).then(function (data) {
                if (data.retinfo === 'success') {
                    $scope.model.pwdMinLen = data.pwdMinLen;
                    $scope.model.name = data.name;
                    $scope.model.contSameCharLen = data.contSameCharLen;
                    $scope.model.domain = data.domain;
                    securityPolicy.passwordpolicy.password_minlen = data.pwdMinLen;
                    securityPolicy.passwordpolicy.password_char_combination = data.password_char_combination;

                    $scope.$apply();
                    dtd.resolve();
                } else {
                    iamUtils.redirect2Login();
                    dtd.reject();
                }
            }, function (data) {
                iamUtils.redirect2Login();
                dtd.reject();
            });
            $scope.model.pwdMinLenDtd = dtd.promise();
        }

        function validPassword($scope) {
            var password = $scope.model.password;
            var isBlank = password.length == 0;
            var minLenResult = password.length >= $scope.model.pwdMinLen && password.length <= 32;
            var containsCharsResult = utils.validatePasswdChar($scope.model.password, securityPolicy.passwordpolicy.password_char_combination);
            var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
            var validatePasswdName = utils.validatePasswdName(password, $scope.model.name) && utils.validatePasswdNameSHA256(password, $scope.model.name);
            return !isBlank && minLenResult && containsCharsResult && maxSameCharsResult && validatePasswdName;
        }
        function showTip($scope) {
            var password = $scope.model.password;
            var isBlank = password.length == 0;
            var minLenResult = password.length >= $scope.model.pwdMinLen && password.length <= 32;
            var containsCharsResult = utils.validatePasswdChar($scope.model.password, securityPolicy.passwordpolicy.password_char_combination);
            var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
            var validatePasswdName = utils.validatePasswdName(password, $scope.model.name) && utils.validatePasswdNameSHA256(password, $scope.model.name);
            changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope);
            if (!$scope.model.isWeakPassword || !minLenResult) {
                utils.setPwdLevel4Hws('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', password, i18n, $scope.model.pwdMinLen);
            } else {
                utils.setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', 'low', i18n);
            }
        }
        function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
            change2ResultEach($scope, 'minLenId', minLenResult);
            change2ResultEach($scope, 'containsCharsId', containsCharsResult);
            change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
            change2ResultEach($scope, 'notNameId', validatePasswdName);
            if (isBlank) {
                $('#containsCharsId').attr('src', $scope.model.validTip);
                $('#minLenId').attr('src', $scope.model.validTip);
                $('#maxSameCharsId').attr('src', $scope.model.validTip);
                $('#notNameId').attr('src', $scope.model.validTip);
            }
        }

        function change2ResultEach($scope, id, result) {
            if (result) {
                $('#' + id).attr('src', $scope.model.validSuc);
            } else {
                $('#' + id).attr('src', $scope.model.validFail);
            }
        }
    };

    function setClearTag() {
        var url = '' + window.location;
        if (getSlashSuffix(url) === 'resetPwd') {
            window.location = window.location + '?clear=Y';
        }
    }

    function getSlashSuffix(url) {
        var reg = new RegExp('(#/)([^&]*)(&|$)', 'i');
        var r = url.match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    };

    function setErrorMsg($scope) {
        var url = '' + window.location;
        if (getSlashSuffix(url) === 'resetPwd?clear=Y') return;
        var errorMsgObj = {
            '400': i18n('systemException'),
            '401': i18n('wrongNamePwd'),
            '403': i18n('selfManage.alertTip'),
            '406': i18n('invalidInput'),
            '411': i18n('wrongVerifyCode'),
            '413': i18n('userAccountsLocked'),
            '414': i18n('domainuserAccountsLocked'),
            '415': i18n('userAccountsLocked'),
            '417': i18n('historyPwdSame'),
            '418': dealPwdErrorTips(),
            '419': i18n('noRight'),
            '420': i18n('verifyCode.invalid'),
            '421': i18n('verifyCode.error'),
            '426': i18n('modifyPwdIntervalTimeLessThanMinValidTime')
        };
        if (iamUtils.getUrlParams()['actionErrors']) {
            var status = iamUtils.getUrlParams()['actionErrors'];
            var errCode = parseInt(status);
            if (errCode >= 422 && errCode <= 424) {
                $('#errorMsg').html(iamUtils.i18nFormat(dealPwdMoreErrorTips(), 425 - errCode));
            } else {
                $('#errorMsg').html(errorMsgObj[status]);
            }
        }
        function dealPwdErrorTips() {
            if ($scope.model.isFirstLogin) {
                return i18n('resetPwd.InitPasswdError');
            } else if ($scope.model.isApiKey) {
                return i18n('resetPwd.apiKeyError');
            } else {
                return i18n('resetPwd.resetPwdFailed');
            }
        }
        function dealPwdMoreErrorTips() {
            if ($scope.model.isFirstLogin) {
                return i18n('resetPwd.InitPasswdCount');
            } else if ($scope.model.isApiKey) {
                return i18n('resetPwd.apiKeyErrorCount');
            } else {
                return i18n('resetPwd.resetCount');
            }
        }
    }

    function post(URL, PARAMS) {
        var temp = document.createElement('form');
        temp.action = URL;
        temp.method = 'post';
        temp.style.display = 'none';
        for (var x in PARAMS) {
            var opt = document.createElement('textarea');
            opt.name = x;
            opt.value = PARAMS[x];
            temp.appendChild(opt);
        }
        document.body.appendChild(temp);
        temp.submit();
        return temp;
    }

    function clearSensitiveInfo($scope) {
        $scope.model.oldPassword = '';
        $scope.model.msgCode = '';
        $scope.model.password = '';
        $scope.model.confirmPassword = '';
    }

    ResetPwd.prototype.msgCodeBtnHandler = function ($scope, msgBtnTxt, enable) {
        var handler = {
            timeInterval: 60,
            counter: 60,
            enable: enable,
            msgCode: '',
            msgBtnDisable: false,
            msgBtnTxt: msgBtnTxt,
            enableTimer: function enableTimer() {
                handler.enable = true;
                if (handler.msgBtnDisable) {
                    $('#msgBtn').addClass('msgBtnDisabled');
                } else {
                    $('#msgBtn').removeClass('msgBtnDisabled');
                }

                if (!handler.msgBtnDisable) {
                    $scope.model.msgBtnTxt = handler.msgBtnTxt;
                }
            },
            disableTimer: function disableTimer(msgCode) {
                handler.enable = false;
                if (msgCode != null) {
                    handler.msgCode = msgCode;
                }
            },
            startTimer: function startTimer(msgCode) {
                handler.counter = 0;
                if (msgCode != null) {
                    handler.msgCode = msgCode;
                }
                setTimeout(count, 0);
            },
            stopTimer: function stopTimer() {
                handler.counter = handler.timeInterval;
                handler.msgBtnDisable = false;
                $('#msgBtn').removeClass('msgBtnDisabled');
                if (handler.enable) {
                    $scope.model.msgBtnTxt = handler.msgBtnTxt;
                }
                $scope.$apply();
            }
        };

        function count() {
            if (handler.counter < handler.timeInterval) {
                handler.counter++;
                if (handler.enable) {
                    handler.msgBtnDisable = true;
                    $('#msgBtn').addClass('msgBtnDisabled');
                    $scope.model.msgBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), handler.timeInterval - handler.counter);
                    if (handler.counter != 0) {
                        $scope.$apply();
                    }
                }
                setTimeout(count, 1000);
            } else {
                if (handler.enable) {
                    handler.stopTimer();
                } else {
                    handler.msgBtnDisable = false;
                }
            }
        }
        return handler;
    };

    function stopMsgCodeHandler($scope) {
        if ($scope.model.verifyType === 'phone') {
            $scope.model.smsMsgCodeBtnHandler.stopTimer();
        } else {
            $scope.model.emailMsgCodeBtnHandler.stopTimer();
        }
    }

    function cancelModify($scope) {
        $.ajax('/authui/cancelModifyPwd', {
            async: false,
            cache: false,
            dataType: 'json',
            method: 'POST',
            'headers': {
                'Pragma': 'no-store',
                'Cache-control': 'no-store'
            }
        });
    };

    //个性化定制默认页面初始化，在各个局点的custom中实现该方法
    ResetPwd.prototype.customizedInitResetPage = function ($scope, userInfo) {};

    ResetPwd.prototype.getUserInfo = function ($scope, iamHttpService, securityPolicy) {
        var me = this;
        $scope.model.passwordValidate = [{}];
        iamHttpService.get({
            url: '/authui/getUserInfo',
            mask: true
        }).then(function (data) {
            var retJson = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (retJson.retinfo === 'success') {
                var userInfo = retJson.data;
                var isMobile = iamUtils.isSupportSms && userInfo.mobile;
                $scope.model.verifyTypeValue = isMobile ? iamUtils.SecurityMasker.maskMobile(userInfo.mobile).replace(/^0*/, '+').replace(/-/, ' ') : userInfo.email;
                $scope.model.verifyTypeLabel = isMobile ? i18n('resetPwd.phone') : i18n('resetPwd.mailbox');
                $scope.model.msgCodeLabel = isMobile ? i18n('resetPwd.smsMsgCode') : i18n('resetPwd.emailMsgCode');
                $scope.model.verifyTypeBtn = isMobile ? i18n('resetPwd.byMailbox') : i18n('resetPwd.byPhone');
                $scope.model.emailMsgCodeBtnHandler = isMobile ? me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), false) : me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), true);
                $scope.model.smsMsgCodeBtnHandler = isMobile ? me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), true) : me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), false);
                $scope.model.verifyType = isMobile ? 'phone' : 'email';
                $scope.model.phone = userInfo.mobile ? iamUtils.SecurityMasker.maskMobile(userInfo.mobile) : i18n('emptyStr');
                $scope.model.email = userInfo.email ? userInfo.email : i18n('emptyStr');
                $scope.model.name = userInfo.name;
                $scope.model.domain = userInfo.domain;
                $scope.model.needValidation = retJson.needValidation;

                //法电业务没有绑定邮箱不进行验证码校验
                var productType = window.productType;

                if (productType == 'OCB' && !userInfo.email) {
                    $scope.model.needValidation = false;
                }
                /*if(!userInfo.email){
                    $scope.model.needValidation = false;
                }*/

                $scope.model.needVerifyTypeBtn = isMobile && userInfo.email ? true : false;
                //me.customizedInitResetPage($scope, userInfo);
                if ($scope.model.verifyType === 'email') {
                    $scope.model.msgBtnTxt = i18n('resetPwd.getEmailMsgCode');
                }
                if (retJson.contSameCharLen && retJson.contSameCharLen != 0) {
                    $scope.model.contSameCharLen = retJson.contSameCharLen;
                    $scope.model.maxSameChars = utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'), $scope.model.contSameCharLen);
                } else {
                    $scope.model.contSameCharLen = 0;
                    $scope.model.maxSameChars = null;
                }
                $scope.model.pwdMinLen = retJson.pwdMinLen ? retJson.pwdMinLen : 6;
                me.setPwdMinLen($scope, securityPolicy, retJson.pwdMinLen, retJson.contSameCharLen);
                $scope.model.isFormShow = true;
                $scope.$apply();
                setErrorMsg($scope);
            } else {
                me.redirect2Login();
            }
        }, function (data) {
            me.redirect2Login();
        });
    };

    ResetPwd.prototype.setPwdMinLen = function ($scope, securityPolicy, pwdMinLen, numOfRptCharInPwd) {
        var pwdValidator = iamUtils.validator.password(securityPolicy, $scope.model.name, pwdMinLen, numOfRptCharInPwd, $scope.model.oldPasswordId);
        $scope.model.passwordValidate = pwdValidator;
        $scope.model.pwdTip = utils.buildTip(utils.i18nFormat(i18n('minMaxLenTxt'), pwdMinLen, securityPolicy.passwordpolicy.password_maxlen), utils.i18nFormat($scope.model.containsChars, securityPolicy.passwordpolicy.password_char_combination), $scope.model.maxSameChars, i18n('pwdNotUsernameOrInvert'), null, i18n);
    };

    ResetPwd.prototype.redirect2Login = function () {
        var service = iamUtils.getUrlParams()['service'];
        var language = window.language;
        if (service && language) {
            window.location.href = '/authui/?locale=' + language + '&service=' + encodeURIComponent(iamUtils.getUrlParams()['service']);
        } else if (service && !language) {
            window.location.href = '/authui/?service=' + encodeURIComponent(iamUtils.getUrlParams()['service']);
        } else {
            window.location.href = '/authui/?locale=' + language;
        }
    };
    return ResetPwd;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    //viewModel: {title: "title", hide: false}

    function Step(containerID, viewModel, type) {
        this.containerID = containerID;
        this.viewModel = [];
        this.suffix = Math.floor(Math.random() * 1000); // suffix for id attributes
        this.type = type ? type : "all"; //默认全部显示，移动端的type为single

        for (var i = 0; i < viewModel.length; i++) {
            this.viewModel.push({
                title: viewModel[i].title,
                imgClz: viewModel[i].imgClz,
                imgClzHL: viewModel[i].imgClzHL,
                imgClzCur: viewModel[i].imgClz,
                show: this.type === "all" || !viewModel[i].hide,
                ID: "step-" + (i + 1) + "-" + this.suffix,
                numID: "stepNum" + (i + 1) + "-" + this.suffix,
                numClass: "sm-stepNum " + (i === 0 ? "sm-selectedStepNum" : ""),
                titleID: "stepTitle" + (i + 1) + "-" + this.suffix,
                titleClass: "sm-stepTitle " + (i === 0 ? "sm-selectedStepTitle" : ""),
                nextShow: false
            });
        }

        this.stepCallback = $.Callbacks();
    }

    Step.prototype.template = '<div id="{{ stepView.ID }}" wt ng-show="stepView.show" ng-repeat="stepView in viewModel">' + '<span id="{{stepView.numID}}" class="{{stepView.imgClzCur}}"></span>' + '<span id="{{stepView.titleID}}" class="{{stepView.titleClass}}" ng-bind="stepView.title"></span>' + '<span class="simple-next" ng-show="stepView.nextShow">&gt;&gt;</span>' + '</div>';

    Step.prototype.render = function ($scope, $compile) {
        var template = this.template;;
        var link = $compile(template);
        var scope = $scope.$new(false);
        scope.viewModel = this.viewModel;
        scope.type = this.type;
        var node = link(scope);
        $("#" + this.containerID).html(node);
        this.scope = scope;
    };

    //for setTimeout use
    Step.prototype.refresh = function () {
        try {
            this.scope.$digest();
        } catch (e) {}
    };

    Step.prototype.goToStep = function (step, args) {
        if (step > this.viewModel.length) {
            return;
        }
        step--;

        var stepNum = "sm-stepNum";
        var selectedNum = "sm-stepNum selectedStepNum";
        var stepTitle = "sm-stepTitle";
        var selectedTitle = "sm-stepTitle selectedStepTitle";

        for (var i = 0; i < this.viewModel.length; i++) {
            if (i <= step) {
                this.viewModel[i].numClass = selectedNum;
                this.viewModel[i].titleClass = selectedTitle;
                this.viewModel[i].imgClzCur = this.viewModel[i].imgClz + ' ' + this.viewModel[i].imgClzHL;
            } else {
                this.viewModel[i].numClass = stepNum;
                this.viewModel[i].titleClass = stepTitle;
                this.viewModel[i].imgClzCur = this.viewModel[i].imgClz;
            }
            this.viewModel[i].show = this.type === "all" ? true : i === step;

            if (i == this.viewModel.length - 1) {
                this.viewModel[i].nextShow = false;
            } else {
                this.viewModel[i].nextShow = true;
            }
        }
        this.refresh();
        this.stepCallback.fire(step + 1, args);
    };

    Step.prototype.onStepChange = function (stepCallbacks) {
        this.stepCallback.add(stepCallbacks);
    };

    return Step;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var _framework;

    var framework = (_framework = {
        "title.error": "Error",
        "title.prompt": "Information",
        "title.confirm": "Confirm",
        "title.warn": "Warning",

        "hasBindUniportal": "Your HUAWEI CLOUD account has already been upgraded. Use your HUAWEI ID to log in.",

        "mobileLoginModel.intlIpTip": "Use a mobile number registered on the Chinese mainland to log in to this page.",
        "mobileLoginModel.mobileLogin": "Mobile Number Login",
        "mobileLoginModel.accountLogin": "Account/Email Login",
        "mobileLoginModel.mobilePlaceHolder": "Mobile number",
        "mobileLoginModel.accountPlaceHolder": "Account name or email",
        "mobileLoginModel.userPlaceHolder": "IAM user name or email",
        "mobileLoginModel.notRegisterTip": "Unregistered mobile number. ",
        "mobileLoginModel.isMobileTip": "You appear to have entered a mobile number. Switch to ",
        "mobileLoginModel.registerNow": "Register now",
        "mobileLoginModel.multiUsersTip": "The mobile number is bound to multiple accounts. Select the account you want to use.",
        "mobileLoginModel.operationTooFrequent": "You have tried too many times within a short period. Try again {0} minutes later.",
        "mobileLoginModel.invalidNumber": "Enter a valid mobile number.",
        "mobileLoginModel.retry": "Retry",
        "mobileLoginModel.retrievePwd": "Reset Password",
        "emailLoginModel.multiUsersTip": "The email address is bound to multiple accounts. Select the account you want to use.",
        "fpwd.multiEmailUsersTip": "The email address is bound to multiple accounts. Select the account for which you want to reset the password.",

        "loginRegistTip": "New users can register by invitation only.",
        "accountName": " Account Name",
        "uniportalTip": "Huawei official website users, Huawei enterprise partners, Huawei employees, and ICT developers",
        "activeAccount": "Activate",
        "activeAccountMsg": "Dear user, this is your first login to HUAWEI CLOUD. Please read and agree with the HUAWEI CLOUD Customer Agreement and Privacy Statement before you proceed further.",
        "userNameTip": "Username:",
        "searchBoxPlaceHolder": "Enter a keyword.",
        "submitBtnTxt": "OK",
        "cancelBtnTxt": "Cancel",
        "btnTxtOK": "OK",
        "btnTxtCancel": "Cancel",
        "btnTxtYes": "Yes",
        "btnTxtNo": "No",
        "logout": "Exit",
        "connect": "and",
        "emptyStr": "--",
        "blankTxt": "This field cannot be left blank.",
        "emptyTxt": "This field cannot be left blank or contain spaces.",
        "nameBlankTxt": "This field cannot be left blank.",
        "passwordEqual": "Passwords do not match.",
        "validEmail": "Enter a valid email address.",
        "validPhone": "Enter a valid mobile number.",
        "maxLenTxt": "Enter a maximum of {0} characters.",
        "minLenTxt": "Enter at least {0} characters.",
        "minMaxLenTxt": "Must contain {0}–{1} characters.",
        "phoneMaxLenTxt": "Enter a maximum of {0} digits.",
        "msgCodeErrorInfo": "Only digits are allowed.",
        "nameContainsChar": "Only letters, digits, hyphens (-), and underscores (_) are allowed. The name must start with a letter or hyphen.",
        "commonContainsChar": "Only letters and digits are allowed.",
        "pwdNotUsernameOrInvert": "Cannot be the username or the username spelled backwards.",
        "pwdNotContsMobileOrEmail": "The password cannot contain the mobile number or email address.",
        "pwdNotContsMobile": "The password cannot contain the mobile number.",
        "pwdcantContsMobileOrEmail": "The password cannot contain the mobile number or email address.",
        "pwdWeak": "The password could be leaked. Enter another one. ",
        "usernameNotPwdOrInvert": "The username cannot be the password or the password spelled backwards.",
        "passwordChars": "Must contain at least {0} of the following character types: uppercase letters, lowercase letters, digits, spaces, and special characters (~`!?,.:;-_'\"(){}[]/<>@#$%^&*+|\\=).",
        "mobilePasswordChars1": "The password must contain at least two of the following: ",
        "mobilePasswordChars2": "uppercase letters, lowercase letters, digits, and special characters.",
        "validEmailOrPhone": "Enter a valid email address or mobile number.",
        "validAccountName": "Enter a valid account name.",
        "validPwd": "Enter a valid password.",
        "validAgency": "Enter a valid agent name.",
        "validCheckCode": "Enter a maximum of 4 characters.",
        "tooMuchErrorCode": "You have exceeded the maximum verification code requests allowed. Please try again later.",
        "pwdCannotEqualName": "Cannot be the account name or the account name spelled backwards.",
        "passwordPolicy.errorMsgOfRptChar": "The password can contain a maximum of {0} consecutive identical characters.",
        "inValidCcompanyName": "Cannot contain only special characters, digits, spaces, or tab characters.",
        "companyNameLength": "Enter a maximum of 32 characters.",
        "accountTipInfo": "Your account information:",
        "yes": "Yes",
        "no": "No",
        "iamUserTip": "You can log in as an IAM user if your account has been created by another HUAWEI CLOUD account.",
        "registerFailed": "Registration failed.",
        "recommended": "Recommended",
        "strengthLow": "Weak",
        "strengthMid": "Medium",
        "strengthHigh": "Strong",

        accountNameBlank: "Enter the account name.",
        userNameBlank: "Enter the IAM user name or email address.",
        pwdBlank: "Enter the password.",
        checkCodeBlank: "Enter the verification code.",
        phoneBlank: "Enter the mobile number.",
        checkCodeBlank4Intl: "Enter the verification code.",
        backToHomepage: "Back to Homepage",

        backTo: "Back",
        homepage: "Homepage",
        mobileHome: "Homepage",

        "isHwsUser": "Your account is registered on the HUAWEI CLOUD China website and can only be used there.",
        "isHongKongUser": "Your account is registered on the HUAWEI CLOUD international website and can only be used there.",
        "isRuUser": "Your account is registered on the HUAWEI CLOUD international website and can only be used there.",
        "isHwsUser1": "Your account is registered on the ",
        "isHongKongUser1": "Your account is registered on the ",
        "isRuUser1": "Your account is registered on the ",
        "goLogin.hws": "HUAWEI CLOUD China website",
        "goLogin.hk": "HUAWEI CLOUD international website",
        "goLogin.ru": "HUAWEI CLOUD international website",
        "toLogin.hws": " and can only be used there.",
        "toLogin.hk": " and can only be used there.",
        "toLogin.ru": " and can only be used there.",

        "language": "English",
        "lanuage.hk": "International",
        "lanuage.ch": "中国站",
        "language.zh-cn": "简体中文",
        "language.en-us": "English",

        "titles.login": "HUAWEI CLOUD - Login",
        "titles.resetPwd": "HUAWEI CLOUD - Reset Password",
        "titles.fpwd": "HUAWEI CLOUD - Forgot Password",
        "titles.register": "HUAWEI CLOUD - Register",
        "titles.agencyRegister": "HUAWEI CLOUD - Agent Register",
        "titles.reactivate": "HUAWEI CLOUD - Reactivate",
        "titles.registerSuccess": "HUAWEI CLOUD - Registration Successful",
        "titles.fphone": "HUAWEI CLOUD - Change Mobile Number",
        "titles.loginVerification": "HUAWEI CLOUD - Login Verification",
        "titles.bindAccount": "HUAWEI CLOUD - First Login",
        "titles.bindAccountSuccess": "HUAWEI CLOUD - Registration Successful (Register and Bind)",

        registerFree: "HUAWEI CLOUD Account Registration",
        freeRegister: "Free Registration",
        createDomain: "Create Account",
        createDomainBtn: "Create and Bind",
        createSubUser: "Create Subuser Account",
        createFailed: "Failed to create the account.",
        bindDomain: "Bind Account",
        createDomainLink: "Create Account",
        bindDomainLink: "Bind Account",
        bindFailed: "Failed to bind the account.",
        bindRepeat: "Your account has already been bound to another partner. You cannot bind the account to more than one partner.",
        "createDomain.remindCompleteInfo": "Complete the following information to create and bind a HUAWEI CLOUD account. Already have an account?",
        "bindDomain.remindCompleteInfo": "Enter your HUAWEI CLOUD account information to bind to this account. Do not have an account yet?",
        "createSubUserInfo": "Complete the following information to create and bind a HUAWEI CLOUD subuser account.",
        enterpriseUser: "IAM User Login",
        enterpriseUserLogin: "IAM User Login",
        personageUser: "Account Login",
        enterpriseUser4Intl: "IAM User Login (International)",
        personageUser4Intl: "Account Login (International)",
        accountPlaceHolder: "Account name",
        HongKongAccountPlaceHolder: "Account name",
        domainPlaceHolder: "Agent ID/name",
        roleNamePlaceHolder: "Agent name",
        failedToswitchRole: "Agent switchover failed.",
        switchSubmit: "Switch Role",
        agencyDesc: "A user ID and password can be used to manage resources of multiple accounts. After the HUAWEI CLOUD administrator assigns roles to you, you can switch between roles.",
        userNamePlaceHolder: "IAM user name, email, or mobile number",
        HongKongUserNamePlaceHolder: "IAM user name or email address",
        accountNamePlaceHolder: "Account name, email, or mobile number",
        HongKongAccountNamePlaceHolder: "Account name or email",
        accountTip: "Account",
        passwdPlaceHolder: "Password",
        iamPasswdPlaceHolder: "IAM user password",
        verifyCodePlaceHolder: "CAPTCHA code",
        "GraphicsVerifyCodeLabel": "CAPTCHA Code:",
        GraphicsVerifyCode: "Security check",
        InputGrapVerifyCodeInfo: "For security purposes, please enter the characters displayed on the following image.",
        GrapVerifyCodeFailed: "The CAPTCHA code is incorrect or has expired. Enter the correct code.",
        "getVerifyCode": "Refresh the image.",
        loginSubmit: "Log In",
        logining: "Logging in...",
        mobileNumberLogin: "Mobile number",
        noMobileLogin: "Account name or email",
        userNameMobliePH: "Mobile number",

        rememberName: " Remember me",
        rememberLogin: " Remember me",
        rememberName4Intl: " Remember me",
        forgetPwd: "Forgot Password",
        emaiNamePwd: "Incorrect email address.",
        phoneNamePwd: "Incorrect mobile number.",
        domainNamePwd: "Incorrect account name.",
        wrongNamePwd: "Incorrect password.",
        wrongNamePwd4Intl: "Incorrect username or email address.",

        learnMore: "Learn more",
        iamAccountTip: "The account used to create an IAM user in IAM. ",
        iamUsernameTip: "An IAM user created using the account in IAM. ",
        iamAccountTipHelp: "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        iamUsernameTipHelp: "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

        wrongIPBlacklist: "The device you are using for login is insecure. Use another device.",
        wrongIPFrequencyLimiting: "The maximum number of unsuccessful login attempts allowed from the same IP address has been reached. Try again later.",
        wrongEquipmentIDFrequencyLimiting: "The maximum number of unsuccessful login attempts allowed from the same device has been reached. Try again later or use another device.",
        MachineOperation: "The device you are using for login is insecure. Use another device.",

        emaiNamePwdChances: "Incorrect email address. You will need to log in again if {0} more attempts are unsuccessful.",
        phoneNamePwdChances: "Incorrect mobile number. You will need to log in again if {0} more attempts are unsuccessful.",
        domainNamePwdChances: "Incorrect account name. You will need to log in again if {0} more attempts are unsuccessful.",
        wrongNamePwdChances: "Incorrect password. You will need to log in again if {0} more attempts are unsuccessful.",
        wrongNamePwdFourChances: "Incorrect authentication information. 4 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdThreeChances: "Incorrect authentication information. 3 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdTwoChances: "Incorrect authentication information. 2 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdoneChances: "Incorrect authentication information. 1 more unsuccessful attempt will disable login for 15 minutes.",
        wrongNamePwdFourChances4Intl: "Incorrect password. 4 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdThreeChances4Intl: "Incorrect password. 3 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdTwoChances4Intl: "Incorrect password. 2 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdoneChances4Intl: "Incorrect password. 1 more unsuccessful attempt will disable login for 15 minutes.",

        userAccountsLocked: "You have entered incorrect username or password 5 times. The IP address you are using for login will be locked for 15 minutes.",
        userAccountsStopped: "Your account has been disabled. Please contact the administrator.",
        domainAccountsStopped: "Your account has been disabled.",
        clientIpInvalid: "You are not allowed to log in from this device due to the access control rules set by the administrator. ",
        userNotExist: "The user does not exist. Contact the administrator. ",
        "clientIpInvalid.learnMore": "Learn more",
        "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
        notAllowFpwd: "You are not allowed to reset the password using this device.",
        warning: "Warning",
        "systemException": "The system is busy. Refresh the page and try again.",
        freqLocked: "You have tried too many times within a short period. Please try again later.",
        wrongVerifyCode: "The verification code is incorrect or has expired.",
        invalidInput: "Invalid parameter value.",
        serviceUrlInvalid: "Login failed. <a href='/'>Try again</a>. ",
        maxSessionLimit: "The maximum number of online user sessions has been reached.",
        "multiUserInvalid": "You have already logged in from this device. Refresh the page or log out if you want to use another account to log back in.",
        "pageTimeout": "The operation timed out. Refresh the page and try again.",
        "accountClosed": "The account is being closed.",
        invalidInputFourChances: "Incorrect parameter. 4 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputThreeChances: "Incorrect parameter. 3 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputTwoChances: "Incorrect parameter. 2 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputoneChances: "Incorrect parameter. 1 more unsuccessful attempt will disable login for 15 minutes.",
        loginReactivateFail: "Failed to send the activation email. Please try again.",
        pwdSame: "The new password must be different from the old password.",
        initialPwdSame: "The new password must be different from the initial password.",
        historyPwdSame: "The new password must be different from historical passwords.",
        copyrightNotice1: "© {0}, Copyright by HUAWEI CLOUD. All rights reserved. ",
        copyrightNotice1_hk: "© {0}, Huawei Services (Hong Kong) Co., Limited or its affiliates. All rights reserved.",
        copyrightNotice2: "All rights reserved.",
        copyrightNotice3: "Jiangsu ICP Registration Number: 17040376-32",
        copyrightNotice4: "Jiangsu B2-20130048",
        copyrightNotice5: "Jiangsu Public Security Website Registration Number: 32011402010636",
        "legalNotice": "Legal Notice",
        "legalStatement": "Legal Notice",
        "siteTerms": "Site Terms",
        "privacyProtect": "Privacy Statement",
        "privacyStrategyStatement": "Privacy Statement",
        "reportAbuse": "Report Abuse",
        "sa_nisr": "Acceptable Use Policy",
        "sa_nisr_intl": "Acceptable Use Policy",
        "sa_cua": "HUAWEI CLOUD Customer Agreement",
        "sa_cua_intl": "HUAWEI CLOUD Customer Agreement",
        "enterpriseSwitchTip": "This login mode is for logging in with usernames assigned by an enterprise administrator.",
        "personalSwitchTip": "This login mode is for logging in with account names created during account registration.",
        "usingOtherWaysLogin": "Use Another Account",
        "otherWaysLogin": "Log In Using Another Account",
        "HWSdeveloper": "Huawei Developer Alliance",
        "hwportal": "Huawei Official Website",
        "HWICTdeveloper": "Huawei ICT Developer",
        "WeLink": "WeLink",
        readAgree: "I have read and agreed to the ",
        hwCloudAgreement: "HUAWEI CLOUD Customer Agreement",
        secretprotect: "Privacy Statement",
        hwCloudAgreementMobile: "HUAWEI CLOUD Customer Agreement",
        secretprotectMobile: " Privacy Statement",
        companyUserRegistration: "Register Enterprise User",
        personalUserRegistration: "Register User",
        companyAccountName: "Username:",
        userName: "Username: ",
        registerMail: "Email Address:",
        congratulationsSucceed: "Registration successful.",
        password: "Password:",
        registerMailStep3: "Email:",
        passwordPlaceHolder: "Enter the password.",
        confirmPassword: "Confirm Password: ",
        confirmPasswordPlaceHolder: "Enter the password again.",
        companyName: "Enterprise:",
        contact: "Contact:",
        phoneNum: "Mobile Number: ",
        phonePlaceHolder: "Enter your mobile number.",
        msgCode: "Verification Code: ",
        msgCodeTxt: "Send Code",
        msgPHTxt: "Verification code",
        msgCodeTxtWait: "Resend Code ({0}s)",
        msgCodeWrong: "The verification code is incorrect.",
        region: "Region: ",
        "register.submit": "Register",
        "register.finish": "Finish",
        submit: "Next",
        innerKeyWord: "The name cannot start with a system keyword.",
        accountNamePH: "Enter your username.",
        emailPH: "Enter your email address.",
        companyNamePH: "Enter the name of your enterprise.",
        mobileCompanyName: "(Optional) Enter the name of your enterprise.",
        "registerSuccess": "Registration successful.",
        "pleaseCompleteInfo": "For security purposes, please provide information about your enterprise.",
        "complete": "Complete the",
        "companyInfo": "enterprise profile",
        "rejectAndBack": "Go back to the",
        "homePage": "homepage",
        "period": ".",
        "goTo": " Go to",
        "myCredential": "My Credentials",
        "completeUserInfo": "to complete personal information.",
        "fpwd.findPasswd": "Reset Password",
        "fpwd.enterpriseName": "Account Name:",
        "fpwd.accountName": "Email Address or Mobile Number:",
        "fpwd.SMSVerifyCode": "Enter the verification code.",
        "fpwd.emailVerifyCode": "Enter the verification code.",
        "fpwd.getCode": "Send Code",
        "fpwd.confirmAccount": "Verify Identity",
        "fpwd.resetPwd": "Reset Password",
        "fpwd.resetSuccess": "Finish",
        "fpwd.findSuccess": "Password reset successfully.",
        "fpwd.newPasswd": "New Password:",
        "fpwd.confirmPasswd": "Confirm Password:",
        "fpwd.enterpriseNamePH": "Enter the account name.",
        "fpwd.accountNamePH": "Enter an email address or mobile number.",
        "fpwd.verifyCodePH": "Verification code",
        "fpwd.confirmPasswdPH": "Enter the new password again.",
        "fpwd.newPasswdPH": "Enter a new password.",
        "fpwd.newPasswdPHApp": "New Password",
        "fpwd.nextStepBtn": "Next",
        "fpwd.backTo": "Back",

        "fpwd.titleDetail": "Enter your account information.",
        "fpwd.titleIAMDetail": "Enter your IAM user information.",
        "fpwd.multiUsersTip": "The mobile number is bound to multiple accounts. Select the account for which you want to reset the password.",
        "fpwd.accountConfirm": "Account Verification",
        "fpwd.personalAccount": "Account",
        "fpwd.IAMAccount": "IAM User",
        "fpwd.typePersonalTip": "The account created when you registered with HUAWEI CLOUD using a mobile number.",
        "fpwd.typeIAMTip": "The user created using an account in IAM.",
        "fpwd.accountOrEmailPH": "Account name or email",
        "fpwd.IAMAccountNamePH": "IAM user name, email, or mobile number",
        "fpwd.IAMAccountNamePHNew": "IAM user name or email",
        "fpwd.identityVerification": "Identity Verification",
        "fpwd.identityVerificationDec": "Select an identity verification method.",
        "fpwd.passwordReset": "Reset Password",
        "fpwd.passwordResetDesc": "Set a new password.",
        "fpwd.step1.fpwdByPhone": "Mobile Number Verification",
        "fpwd.step1.fpwdByemail": "Account/Email Verification",
        "fpwd.step1.phoneAccountNamePH": "Mobile number",
        "fpwd.step2.verificationCodePH": "Verification code",
        "fpwd.step2.sendVerificationCode": "Send Code",
        "fpwd.step2.unbindDesc": "Your identity cannot be verified because the account you are using has not been bound with any email address or mobile number.",
        "fpwd.step2.unbindIAMDesc": "Your identity cannot be verified because the IAM user account you are using has not been bound with any email address or mobile number.",
        "fpwd.step2.exceptionService": "If your mobile number or email address is unavailable, request the administrator to reset your password.",
        "fpwd.step2.sendEmailCode": "Email address ({0})",
        "fpwd.step2.sendMobileCode": "Mobile number ({0})",
        "fpwd.step2.unabledMethod": "Contact customer service",
        "fpwd.step2.helpMsg": "Customer Service",
        "fpwd.step2.helpTel1": "Chinese mainland: +86 4000-955-988",
        "fpwd.step2.helpTel2": "Hong Kong SAR, China: +852 800-931-122",
        "fpwd.retrieveTxt": "Resend Code ({0}s)",
        "fpwd.step3.showPwdTip": "Show",
        "fpwd.step3.hidePwdTip": "Hide",
        "fpwd.goToLogin": "Log In",
        "fpwd.successTxt": "Password reset successfully",
        "fpwd.loginCountdownTxt": "You will be automatically redirected to the login page in {0}s.",

        "domainuserAccountsLocked": "Your account is pending activation. Click the link in the registration email to activate your account.",
        "fpwd.sendCodeFailed": "Failed to send the verification code because the system is busy.",
        "fpwd.getCodeFail": "You have already obtained the verification code 5 times. Please try again tomorrow.",
        "wrong_sendCodeFailed": "Failed to send the verification code. Click Send Code to obtain another one.",
        "fpwd.invalidVerifyCode": "The verification code is incorrect. Please try again.",
        "fpwd.setPasswdFailed": "Failed to set the password. Please try again.",
        "fpwd.ipLocked": "The IP address has been locked.",
        "fpwd.MultipleIAMUserNameByMobile": "The mobile number is bound to multiple IAM users. Reset the password by using your email.",
        "fpwd.MultipleAccountNameByMobile": "The mobile number is bound to multiple accounts. Enter an account name to continue.",
        "fpwd.MultipleAccountNameByMobileError": "The mobile number is bound to multiple accounts. Reset the password by using this mobile number on a computer or using your email.",
        "fpwd.MultipleAccountsByMobileReminder": "The account name must be specified if the mobile number is bound to multiple accounts.",
        "fpwd.EnterCorrectEnterpriseAccount": "Enter the name of an account that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectMobile": "Enter a mobile number that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "Enter an account name or mobile number that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEmail": "Enter an email address that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "Enter the correct account name or email address.",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "Enter the correct CAPTCHA code.",
        "operationTooFrequent": "You have tried too many times within a short period. Please try again later.",

        "fpwd.contactService": "If you do not have access to your mobile phone and email, contact customer service at {0} for assistance.", //4000-955-988, +7 (495) 800 1 800
        "fpwd.contactHKService": "If you do not have access to your email, contact customer service at {0} for assistance.",
        "fpwd.ErrorRegionAccount": "Enter a valid HUAWEI CLOUD account.",
        "countryCodeSelect": "Select a country code.",
        bindPhone: "Mobile Number:",
        bindPhoneNum: "Mobile Number:",
        "alreadyHaveAccount": "",
        "login": "Log In",
        "loginNow": "Log In",
        safetyDegree: "Password Strength:",
        handsRegisterInfo: "To use Huawei PDA Cloud Service, ",
        hansRegistration: "register now.",
        filloutRegisterInfo: "Set Registration Info",
        checkAccountInfo: "Complete Account Info",
        registerSucceed: "Finish",
        successAccoutInfo: "Your account information: ",
        descriptionInfo: "You can log in using the account name, mobile number, or email address.",
        linkFailed: "The link has expired.",
        linkFailedDetail: "Your account has already been activated or the activation link has expired.",
        linkFailedHelp: "",
        linkFailedLogin: "Log in",
        serverTimeout: "The server timed out. Please try again later.",
        mainMsg: "The activation email has been sent to: ",
        secondMsg: "Click the link in the email and complete the activation within 24 hours.",
        checkEmail: "Open Email",
        didNotGetEmail: "Didn't receive the email?",
        checkSpamMail: "1. Check your junk folder.",
        stillDidNotGetEmail: "2. If you haven't got the email, ",
        resendEmail: "send the email again.",
        alwaysDidNotGetEmail: "3. If you still haven't got the email, ",
        changeMailbox: "enter another email address.",
        replaceEmailTip: "You can change your email address only once in 24 hours. Ensure that you enter the correct email address.",
        sendNewEmail: "Send",
        alreadySend: "The activation email has been sent.",
        sendFailed: "Failed to send the email.",
        inputEmail: "Enter your email address.",
        "email": "Email:",
        countToHomepage: "You will be automatically redirected to the login page in {0} seconds.",
        "registerFailed.emailRepeat": "An account associated with the same email address already exists.",
        "registerFailed.nameRepeat": "An account associated with the same name already exists.",
        "registerFailed.mobileRepeat": "An account associated with the same mobile number already exists.",
        "registerFailed.nameCannotBegin": "The name cannot start with a digit or an underscore (_).",
        "registerFailed.nameCannotContain": "Only letters, digits, hyphens (-), and underscores (_) are allowed.",
        "registerSuccess.backToHomepage": "1. ",
        "registerSuccess.returnHomepage": "Back",
        "registerSuccess.backToHomepageLink": "Go back to the HUAWEI CLOUD homepage.",
        "registerSuccess.backToHomepageLinkP1": "Go back to",
        "registerSuccess.backToHomepageLinkP2": "the HUAWEI CLOUD homepage.",
        "registerSuccess.second": "2.",
        "registerSuccess.goToBss": "Visit ",
        "registerSuccess.goToBssFillInfo": " and complete the registration information. You will receive updates about discounts and promotions as and when they become available.",
        "registerSuccess.bssAccountInfo": "User Center",
        "registerSuccess.redirecting": "Redirecting...",
        "registerSuccess.redirecting.back": "You will be automatically redirected to the initial page in {0} seconds.",
        "registerSuccess.autoClose": "You will be automatically redirected to the initial page in {0} seconds.",
        "registerSuccess.browserPreventClose": "Your browser configuration does not allow the system to automatically close pages.",
        "registerSuccess.homepage": "Home",
        "registerSuccess.userCenter": "User Center",
        "registerSuccess.consoleHome": "Management Console",
        "registerSuccess.helpCenter": "Help",

        "resetPwd.title": "First Login",
        "resetPwd.titleDetail": "For security purposes, please change the password.",
        "resetPwd.phone": "Mobile Number:",
        "resetPwd.mailbox": "Email Address:",
        "resetPwd.byPhone": "Mobile Number Verification",
        "resetPwd.byMailbox": "Email Address Verification",
        "resetPwd.smsMsgCode": "Verification Code: ",
        "resetPwd.emailMsgCode": "Verification Code:",
        "resetPwd.getSmsMsgCode": "Send Code",
        "resetPwd.getEmailMsgCode": "Send Code",
        "resetPwd.retrieveMsgCode": "Resend Code ({0}s)",
        "resetPwd.resetFailed": "Failed to change the password.",
        "resetPwd.oldPasswd": "Old Password:",
        "resetPwd.newPasswd": "New Password:",
        "resetPwd.apiKeyTitle": "Change API Password",
        "resetPwd.apiKeyDetail": "For security purposes, please change the API password.",
        "resetPwd.apkKey": "Old API Password:",
        "resetPwd.confirmNewPasswd": "Confirm Password:",
        "resetPwd.resetPwdFailed": "The old password is incorrect. Enter the correct password.",
        "resetPwd.resetCount": "The old password is incorrect. You will need to log in again if {0} more attempts are unsuccessful.",
        "resetPwd.getCodeFail": "You have already obtained the verification code 5 times. Please try again 15 minutes later.",
        "resetPwd.InitPasswd": "Initial Password:",
        "resetPwd.InitPasswdError": "The initial password is incorrect. Enter the correct password.",
        "resetPwd.InitPasswdCount": "The initial password is incorrect. You will need to log in again if {0} more attempts are unsuccessful.",
        "modifyPwdIntervalTimeLessThanMinValidTime": "Change the password only when the minimum password age has been reached. Click Cancel to cancel the change password operation and log in.",
        "pwdModifyTitle": "Change Password",
        "pwdExpiredTitle": "Password Expired",
        "pwdExpiringDesc": "Your password will expire in {0} days. Please change it at the earliest.",
        "pwdExpiredDesc": "Your password has expired. Please set a new password.",
        "noRight": "Insufficient permissions. Please contact the administrator.",

        "browserSupport": "HUAWEI CLOUD works best with the following browsers:",
        "browserSupport.chrome": "Google Chrome",
        "browserSupport.chromeVersion": "(36.0 or later)",
        "browserSupport.firefox": "Mozilla Firefox",
        "browserSupport.firefoxVersion": "(35.0 or later)",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "(9.0 or later)",

        "reactivate.reactivateAccount": "Activate Account",
        "reactivate.pleaseCheckEmail": "Your account is pending activation. Log in to your registered email address and click the link in the registration email to activate your account.",
        "advertisement.txt": "Free for the first 100 trials",
        "advertisement.buttonTxt": "Apply",

        "fphone.changePhoneNum": "Change Mobile Number",
        "fphone.changeSuccess": "Finish",
        "fphone.registerEmail": "Email Address:",
        "fphone.registerEmailPH": "Enter your email address.",
        "fphone.emailVerifyCode": "Email Verification Code:",
        "fphone.getVerifyCodeByEmail": "Send Code",
        "fphone.emailVerifyCodePH": "Enter the verification code.",
        "fphone.newPhoneNum": "New Mobile Number:",
        "fphone.newPhoneNumPH": "Enter a new mobile number.",
        "fphone.smsVerifyCode": "SMS Verification Code:",
        "fphone.getVerifyCodeBySms": "Send Code",
        "fphone.smsVerifyCodePH": "Enter the verification code.",
        "fphone.changePhoneSuccess": "The mobile number has been changed successfully.",
        "fphone.newPhoneNumInfo": "New Mobile Number:",
        "fphone.phoneRepeat": "The mobile number has already been used.",
        "fphone.exceedMaxAccounts": "The maximum number of accounts (6) that can be bound to the mobile number has been reached. ",
        "mobileNumber": "Mobile Number:",
        "fphone.changeMobile": "Change Mobile Number",
        "sendSmsIntervalErr": "The maximum number of attempts to obtain the verification code has been reached. Please try again after 1 minute.",
        "cookie.chromeDesc": "Choose Settings > Show Advanced Settings > Privacy > Content Setting. Deselect \"Block third-party cookie and site data\", select \"Allow local data (recommended)\", and click Finish. Then, restart the browser and log in again.",
        "cookie.firefoxDesc": "Choose Options > Privacy. Select Custom settings for history, deselect \"Always use private browsing mode\", select \"Accept a cookie from the sites\", and click OK. Then, restart the browser and log in again.",
        "cookie.ieDesc": "Choose Tools > Internet Options > Privacy. Set the setting for the Internet zone to \"Accept All Cookies\", click Apply, and click OK. Then, restart the browser and log in again.",
        "cookie.chromeName": "Google Chrome:",
        "cookie.firefoxName": "Mozilla Firefox:",
        "cookie.ieName": "Internet Explorer:",
        "cookie.title": "How Do I Enable Cookies on My Browser?",
        "cookie.loginTip": "You can log in only if cookies are enabled. ",
        "cookie.startCookie": "Learn more",
        "verifyCode.intervalError": "The maximum number of attempts to obtain the verification code has been reached. Please try again after 1 minute.",
        "verifyCode.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.locked": "The verification code function has been locked. Please try again tomorrow.",
        "verifyCode.locked.custom": "The verification code function has been locked. Please try again {0} minutes later or contact custom service at 4000-955-988.",
        "verifyCode.sendFailed": "Failed to send the verification code. Click Send Code to obtain another one.",
        "verifyCode.remainderCount": "You have {0} verification attempts remaining. If the remaining attempts are unsuccessful, you will need to wait for some time before you can send a code again.",
        "verifyCode.cantAcquire": "The verification code function has been locked. Please enter the most recent verification code you obtained.",
        "verifyCode.emailInvalidAndSMSError": "The SMS verification code is incorrect. Try again with a valid email verification code.",
        "verifyCode.email.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.email.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.sms.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.sms.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.usernameRepeat": "The username has already been used. Enter another username.",
        "verifyCode.maxmiumSubUserNum": "The number of users has reached the maximum limit allowed.",
        "verifyCode.emailExist": "The email address has already been used. Enter another email address.",

        "loginVerification": "Login Verification",
        "loginVerification.tips": "If you do not want the custom information to be displayed during login, contact the administrator."
    }, _defineProperty(_framework, "titles.loginVerification", "HUAWEI CLOUD - Login Verification"), _defineProperty(_framework, "loginVerification.presetLoginInfo", "Preset Custom Information"), _defineProperty(_framework, "loginVerification.warningInfo", "If the displayed information is not your preset custom information, cancel the login."), _defineProperty(_framework, "loginVerification.checkBySMS", "SMS"), _defineProperty(_framework, "loginVerification.SMSHasSentTo", " (The verification code will be sent to your mobile phone.)"), _defineProperty(_framework, "loginVerification.pleaseClickAgain", " (If the verification code is not received within 60s, click Send Code again.)"), _defineProperty(_framework, "loginVerification.userLoginInfo", "Login Information"), _defineProperty(_framework, "loginVerification.lastSuccessTime", "Last Successful Login"), _defineProperty(_framework, "loginVerification.lastFailedTime", "Last Unsuccessful Login"), _defineProperty(_framework, "loginVerification.failedTimes", "Unsuccessful Login Attempts"), _defineProperty(_framework, "loginVerification.lockInfo", "Your account will be locked for {1} minutes if {0} more consecutive login attempts are unsuccessful."), _defineProperty(_framework, "loginVerification.MFATitle", "Virtual MFA device"), _defineProperty(_framework, "loginVerification.MFAContext", "Enter the 6-digit code generated on the authenticator app."), _defineProperty(_framework, "loginVerification.MFAHelp", "Learn how to get MFA verification codes."), _defineProperty(_framework, "loginVerification.MFALabel", "Verification Code"), _defineProperty(_framework, "loginVerification.MFANotUseTip", "Virtual MFA Device Unavailable?"), _defineProperty(_framework, "loginVerification.MFANotUseMessage1", "Contact your administrator to remove the virtual MFA device."), _defineProperty(_framework, "loginVerification.MFANotUseMessage2", "Contact HUAWEI CLOUD customer service."), _defineProperty(_framework, "loginVerification.resetMFAHelpUrl", "<a href='{0}' target='_blank' rel='noopener noreferrer'>Learn how</a> to unbind or remove a virtual MFA device."), _defineProperty(_framework, "loginVerification.rememberMFALabel", "Remember me for 7 days"), _defineProperty(_framework, "loginVerification.rememberMFALabel.disabledTip", "Limited to 5 IAM users per browser. "), _defineProperty(_framework, "loginVerification.emailCheckTitle", "Email"), _defineProperty(_framework, "loginVerification.emailCheckContent", " (A verification code will be sent to {0}.)"), _defineProperty(_framework, "loginVerification.emailCodeLabel", "Verification Code"), _defineProperty(_framework, "loginVerification.emailCodeTxt", "Send Code"), _defineProperty(_framework, "loginVerification.verificationType", "Verification Method"), _defineProperty(_framework, "loginVerification.verificationTypeForPhone", "绑定手机号与验证方式"), _defineProperty(_framework, "loginVerification.verificationTypeForEmail", "绑定邮件地址与验证方式"), _defineProperty(_framework, "loginVerification.bindPhone", "Mobile Number"), _defineProperty(_framework, "loginVerification.bindPhoneTips", "The administrator has enabled SMS-based authentication. Enter a mobile number."), _defineProperty(_framework, "loginVerification.bindPhonePH", "Enter a mobile number."), _defineProperty(_framework, "loginVerification.bindEmail", "Email Address"), _defineProperty(_framework, "loginVerification.bindEmailTips", "The administrator has enabled email-based authentication. Enter an email address."), _defineProperty(_framework, "loginVerification.bindEmailPH", "Enter an email address."), _defineProperty(_framework, "loginVerification.verifyCode", "Verification Code"), _defineProperty(_framework, "loginVerification.verifyCodeBtnTxt", "Send Code"), _defineProperty(_framework, "loginVerification.verifyCodePH", "6-digit code"), _defineProperty(_framework, "loginVerification.verifyCodeEmailPH", "6-digit code"), _defineProperty(_framework, "loginVerification.sendCodeTxt", "The verification code has been sent. To ensure your account security, do not share this code with anyone."), _defineProperty(_framework, "loginVerification.sendCodeFailed", "Failed to send the verification code because the system is busy."), _defineProperty(_framework, "loginVerification.validEmailOrPhone", "The email address or mobile number is unavailable."), _defineProperty(_framework, "loginVerification.retrieveTxt", "Resend Code ({0}s)"), _defineProperty(_framework, "loginVerification.otherAccount", "Use Another Account"), _defineProperty(_framework, "loginVerification.goOnLogin", "OK"), _defineProperty(_framework, "loginVerification.title", "Bind Virtual MFA Device"), _defineProperty(_framework, "loginVerification.firstStep", "Step 1: Scan the following QR code to install the HUAWEI CLOUD app, or install another authenticator app."), _defineProperty(_framework, "loginVerification.firstStepIntroduction", "The authenticator app will prompt you to add your account."), _defineProperty(_framework, "loginVerification.secondStep", "Step 2: Set up the app."), _defineProperty(_framework, "loginVerification.secondStepIntroduction", "Open the app, and scan the following QR code or enter the secret key."), _defineProperty(_framework, "loginVerification.username", "Username"), _defineProperty(_framework, "loginVerification.domainname", "Account Name"), _defineProperty(_framework, "loginVerification.secretKey", "Secret Key"), _defineProperty(_framework, "loginVerification.thirdStep", "Step 3: Enter the MFA verification codes."), _defineProperty(_framework, "loginVerification.thirdStepIntroduction", "Enter two consecutive MFA verification codes generated on the app."), _defineProperty(_framework, "loginVerification.firstRegCode", "Verification Code 1"), _defineProperty(_framework, "loginVerification.secondRegCode", "Verification Code 2"), _defineProperty(_framework, "loginVerification.submitText", "OK"), _defineProperty(_framework, "loginVerification.bindMFASucceed", "Virtual MFA device bound successfully."), _defineProperty(_framework, "loginVerification.mfaCodeError", "Incorrect MFA verification code. Enter the correct code."), _defineProperty(_framework, "loginVerification.mfaCodeLocked", "You have exceeded the maximum verification code requests allowed. Please try again after 5 minutes."), _defineProperty(_framework, "bindAccount.title", "Bind HUAWEI CLOUD Account"), _defineProperty(_framework, "bindAccount.submit", "Register and Bind"), _defineProperty(_framework, "registerGiftSuffixMobile", "Claim Cash Coupons"), _defineProperty(_framework, "bindAccount.remindCompleteInfo", "Complete the following information to register a HUAWEI CLOUD account and bind it."), _defineProperty(_framework, "bindAccount.bindSuccess", "Account registered and bound successfully."), _defineProperty(_framework, "bindAccount.HWSAccount", "Your HUAWEI CLOUD account:"), _defineProperty(_framework, "bindAccount.timeRemind", "After {0} seconds"), _defineProperty(_framework, "bindAccount.redirectPage", "Back to the initial page"), _defineProperty(_framework, "validCountryCode", "Select a country code."), _defineProperty(_framework, "registerGift", "You can claim cash coupons after successful registration."), _defineProperty(_framework, "registerGiftAddress", "Claim Cash Coupons"), _defineProperty(_framework, "registerSuccess.goToGift", "Go to "), _defineProperty(_framework, "registerSuccess.goToGiftFillInfo", " to claim special cash coupons for new users."), _defineProperty(_framework, "usercompanyAccount", "Your account information is as follows:"), _defineProperty(_framework, "welcomeLogin.titleDetail", "For security purposes, set a password."), _defineProperty(_framework, "welcomeEmail.title", "Welcome Email"), _defineProperty(_framework, "welcomeEmail.linkTimeout", "The link has expired."), _defineProperty(_framework, "welcomeEmail.linkExpired", "The link is unavailable."), _defineProperty(_framework, "welcomeEmail.resendEmail", "Send another welcome email again."), _defineProperty(_framework, "welcomeEmail.contactAdm", "Contact the administrator to send another welcome email again."), _defineProperty(_framework, "welcomeEmail.alreadySend", "The welcome email has been sent."), _defineProperty(_framework, "titles.setPassword", "HUAWEI CLOUD - Set Password"), _defineProperty(_framework, "titles.welcomeEmail", "HUAWEI CLOUD - Welcome Email"), _defineProperty(_framework, "welcomeEmail.setPassword", "Set Password"), _defineProperty(_framework, "dateFormate", "MMM dd, yyyy HH:mm:ss"), _defineProperty(_framework, "sessionExpired", "Your session has expired. Log in again."), _defineProperty(_framework, "m.userNamePlaceHolder", "Username, email, or mobile number"), _defineProperty(_framework, "m.HongKongUserNamePlaceHolder", "Username or email"), _defineProperty(_framework, "m.accountNamePlaceHolder", "Account name or email"), _defineProperty(_framework, "m.HongKongAccountNamePlaceHolder", "Account name or email"), _defineProperty(_framework, "m.verifyCodePlaceHolder", "CAPTCHA code"), _defineProperty(_framework, "inValidCountryCode", "Select a country code."), _defineProperty(_framework, "mobile.CountryCode", "+86 (Chinese mainland)"), _defineProperty(_framework, "authenticationInfo", "Some functions will be unavailable to users who have not completed real-name authentication."), _defineProperty(_framework, "authenticationForwardInfo", "Complete real-name authentication for a complete service experience."), _defineProperty(_framework, "authenticationForward", "real-name authentication"), _defineProperty(_framework, "registerSuccess.goToAuthentication", "Complete"), _defineProperty(_framework, "registerSuccess.authenticationInfo", "to get a 6-month free trial package."), _defineProperty(_framework, "fpwd.findByEmail", "Email Address Verification"), _defineProperty(_framework, "fpwd.findByPhone", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.accountNameByEmail", "Email Address:"), _defineProperty(_framework, "fpwd.accountNameByPhone", "Mobile Number:"), _defineProperty(_framework, "fpwd.phoneAccountNamePH", "Enter a mobile number."), _defineProperty(_framework, "eChannelName", "Huawei Enterprise Partner"), _defineProperty(_framework, "uniportalName", "Huawei Account"), _defineProperty(_framework, "moreLink", "More"), _defineProperty(_framework, "registerSuccess.authenticationForward", "Complete Real-Name Authentication"), _defineProperty(_framework, "homepageLink", "Home"), _defineProperty(_framework, "helpCenter", "Documentation"), _defineProperty(_framework, "cloudCommunity", "Cloud Community"), _defineProperty(_framework, "registerSuccess.goToUserZone", "Go to "), _defineProperty(_framework, "registerSuccess.userZoneLink", "New User Zone"), _defineProperty(_framework, "registerSuccess.userZoneInfo", " to get your special 50% off package."), _defineProperty(_framework, "register.accountPlaceHolder", "Account name"), _defineProperty(_framework, "register.passwordPlaceHolder", "Password"), _defineProperty(_framework, "register.confirmPasswordPlaceHolder", "Confirm password"), _defineProperty(_framework, "register.phonePlaceHolder", "Mobile number"), _defineProperty(_framework, "register.msgCodePlaceHolder", "Verification code"), _defineProperty(_framework, "register.accountNameLength", "Enter 5 to 32 characters."), _defineProperty(_framework, "register.bindACccountPlaceHolder", "Account name, email, or mobile number"), _defineProperty(_framework, "remindBindEmail.title", "Bind Email Address"), _defineProperty(_framework, "remindBindEmail.remindMsg", "Your account does not have an email address bound to it. Bind an email address to:"), _defineProperty(_framework, "remindBindEmail.remindInfo1", "● Receive notifications when cloud resources are provisioned, deleted, or are about to expire."), _defineProperty(_framework, "remindBindEmail.remindInfo2", "● Verify your identity when you perform important operations, such as changing your mobile number, resetting your password, and deleting ECSs."), _defineProperty(_framework, "remindBindEmail.bind", "Bind Now"), _defineProperty(_framework, "remindBindEmail.nextBind", "Bind Later"), _defineProperty(_framework, "remindBindEmail.remind", "Information"), _defineProperty(_framework, "remindBindEmail.remindHideInfo", "Bind an email address on a new tab page."), _defineProperty(_framework, "remindBindEmail.remindHideFailde", "If the binding fails, "), _defineProperty(_framework, "remindBindEmail.remindHideFailde2", "bind another email address."), _defineProperty(_framework, "remindBindEmail.remindHideSuccess", "Binding Completed"), _defineProperty(_framework, "notify.openPage", "Please wait..."), _defineProperty(_framework, "notify.closeSecondBefore", "Operation Successful."), _defineProperty(_framework, "notify.closePage", "Operation successful. Please close the page"), _defineProperty(_framework, "registerFailed.accountNameRepeat", "An account with the same name already exists."), _defineProperty(_framework, "register.bindAccountPlaceHolder", "Account name, email, or mobile number"), _defineProperty(_framework, "privacyPolicyUpdate", "Privacy Statement Updated"), _defineProperty(_framework, "privacyTipPre", "Dear customer, we have updated the HUAWEI CLOUD Privacy Statement. We understand the importance of your privacy and are fully committed to protecting it. Please read the updated"), _defineProperty(_framework, "privacyTipSuf", "carefully to learn how we protect your personal data."), _defineProperty(_framework, "agreementBtnTxt", "Agree"), _defineProperty(_framework, "privacyAgreementNotAcceptedError", "Select the check box to confirm that you have read and accepted the HUAWEI CLOUD Privacy Statement."), _defineProperty(_framework, "OIDC.errorDefault", "System error. Please contact the administrator."), _defineProperty(_framework, "OIDC.errorO001", "System error. Please try again."), _defineProperty(_framework, "OIDC.errorO002", "Invalid domain ID."), _defineProperty(_framework, "OIDC.errorO003", "Invalid identity provider ID."), _defineProperty(_framework, "OIDC.errorO004", "Invalid service URL."), _defineProperty(_framework, "OIDC.errorO005", "Cannot find the OpenID Connect configuration."), _defineProperty(_framework, "OIDC.errorO006", "Invaid OpenID configuration."), _defineProperty(_framework, "OIDC.errorO007", "Invalid ID Token."), _defineProperty(_framework, "OIDC.errorO008", "The State parameter is invalid."), _defineProperty(_framework, "OIDC.errorO009", "Invalid JWT."), _defineProperty(_framework, "OIDC.errorO010", "Acl check failed."), _defineProperty(_framework, "OIDC.errorO011", "Failed to obtain the IAM token based on the mapping rules. Check the mapping rules or contact the administrator."), _defineProperty(_framework, "OIDC.errorO012", "No reachable project to log in."), _defineProperty(_framework, "OIDC.errorO013", "Too many requests. Please try again later."), _defineProperty(_framework, "OIDC.errorO014", "Cannot access the console in the [program] access mode."), _defineProperty(_framework, "OIDC.errorO015", "Invalid error."), _defineProperty(_framework, "console_term_500Error_label", "The system is busy. Please try again later."), _defineProperty(_framework, "console_term_404Error_label", "Sorry! Failed to find the page."), _defineProperty(_framework, "console_term_401Error_label", "Sorry! The page has expired."), _defineProperty(_framework, "titles.loginReminder", "HUAWEI CLOUD – Login"), _defineProperty(_framework, "QRLogin.title1", "QR Login"), _defineProperty(_framework, "QRLogin.title2", "Log in to Huawei Cloud"), _defineProperty(_framework, "QRLogin.countDownTipPre1", "Please use the "), _defineProperty(_framework, "QRLogin.countDownTipPre2", "HUAWEI CLOUD APP"), _defineProperty(_framework, "QRLogin.countDownTipPre3", " to scan the QR code to log in "), _defineProperty(_framework, "QRLogin.remainingTime", "{0} seconds"), _defineProperty(_framework, "QRLogin.countDownTipSuffix", "QR code expires after "), _defineProperty(_framework, "QRLogin.QRCodeInvalid", "QR code has expired"), _defineProperty(_framework, "QRLogin.refresh", "refresh"), _defineProperty(_framework, "QRLogin.scanSuc", "Scan Successfully"), _defineProperty(_framework, "QRLogin.scanSucTip", "Please follow the prompts to confirm login on your phone"), _defineProperty(_framework, "QRLogin.loginFail", "Login Failed"), _defineProperty(_framework, "QRLogin.loginFailTipPre", "Please click "), _defineProperty(_framework, "QRLogin.loginFailTipSuffix", " and re-scan the QR code to log in"), _defineProperty(_framework, "QRLogin.downloadApp", "Download HUAWEI CLOUD App"), _defineProperty(_framework, "QRLogin.comma", ", "), _defineProperty(_framework, "QRLogin.loginReminder", "Login Reminder"), _defineProperty(_framework, "QRLogin.accountLogin", "Password Login"), _defineProperty(_framework, "hwId.cookieMsg", "We use cookies to improve your browsing experience. By continuing to browse our site, you accept our cookie policy. "), _defineProperty(_framework, "hwId.hwAccount", "HUAWEI ID"), _defineProperty(_framework, "hwId.privacyContent", "Your account and network information will be used to help improve your login experience. "), _defineProperty(_framework, "hwId.hwportal", "Huawei Website Account"), _defineProperty(_framework, "hwId.eChannel", "Huawei Enterprise Partner"), _defineProperty(_framework, "hwId.casLogin.systemError", "Error"), _defineProperty(_framework, "hwId.casLogin.systemErrorDesc", "A system error occurred. Please refresh the page or contact customer service at +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China)."), _defineProperty(_framework, "hwId.casLogin.accountError", "Error"), _defineProperty(_framework, "hwId.casLogin.accountErrorDesc", "Your account cannot be used to log in to HUAWEI CLOUD. Log in with another account."), _defineProperty(_framework, "hwId.casLogin.accountErrorLink", "Learn more"), _defineProperty(_framework, "hwId.casLogin.accountErrorUrl", "/en-us/iam_faq/iam_01_0006.html"), _defineProperty(_framework, "hwId.casLogin.loginError", "Error"), _defineProperty(_framework, "hwId.casLogin.loginErrorDesc", "You cannot use your account to log in to HUAWEI CLOUD in this mode. Click HUAWEI ID Login and log in."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorDesc", "Your current account is registered in [Europe or Russia]. HUAWEI CLOUD does not support accounts in the above regions for the time being. Please log in with accounts in other regions."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorLink", "Learn more"), _defineProperty(_framework, "hwId.casLogin.accountTurkeyErrorLink", "Your current account is registered in [Turkey]. HUAWEI CLOUD does not support accounts in Turkey. Please <a href='{0}' target='_blank' rel='noopener noreferrer'>register for a HUAWEI CLOUD account</a> immediately, or log in with accounts in other region."), _defineProperty(_framework, "hwId.casLogin.inactivatedError", "Inactive Account"), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc", "Your account has not been activated. The system has automatically sent an activation email to your registered email address. Please go to and click the link in the email address to complete the activation within 24 hours."), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc.noEmail", "Your account has not been activated and does not have an email address. Huawei Cloud services are temporarily unavailable. Please change to another account and log in again."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidError", "Inactive HUAWEI CLOUD Services"), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc", "Your HUAWEI CLOUD business has not been activated, and the system has automatically sent an activation email to your registered email address. Please go to and click the link in the email address to complete the activation within 24 hours."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc.noEmail", "Your HUAWEI CLOUD business has not been activated and you do not have an email address. You cannot use HUAWEI CLOUD services temporarily. Please change to another account and log in again."), _defineProperty(_framework, "hwId.casLogin.accessErrorDesc", "HUAWEI CLOUD does not have the authority to obtain the information of your current account. This account login is not supported temporarily. Please log in with another account."), _defineProperty(_framework, "hwId.refresh", "Refresh"), _defineProperty(_framework, "hwId.cookies", "Cookies"), _defineProperty(_framework, "hwId.otherAccount", "Use Another Account:"), _defineProperty(_framework, "hwId.otherAccount.h5", "Use Another Account"), _defineProperty(_framework, "hwId.hwIdLogin", "Huawei Account Login"), _defineProperty(_framework, "hwId.accountPlaceHolder", "Tenant name or HUAWEI CLOUD account name"), _defineProperty(_framework, "fpwd.accountFpwdTitle", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.iamFpwdTitle", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.goAccountFpwd", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.goIAMFpwd", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.step2.accountHelpMsg", "If you cannot perform verification using your mobile phone and email account, please call +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China). If you have already retrieved your password, go to the login page and log in. "), _defineProperty(_framework, "fpwd.step2.switchPhoneVerify", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step2.switchEmailVerify", "Email Address Verification"), _defineProperty(_framework, "fpwd.pwdValidateRule", "Password requirements:"), _defineProperty(_framework, "fpwd.pwdSafetyDegree", "Password strength:"), _defineProperty(_framework, "fpwd.selectUserTitle", "Select Account Name"), _defineProperty(_framework, "fpwd.step1.fpwdByEmail", "Tenant Name/Email Address Verification"), _defineProperty(_framework, "fpwd.step1.fpwdByPhone", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH", "Mobile number"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder", "CAPTCHA code"), _defineProperty(_framework, "fpwd.accountOrEmailPH", "Account name or email address"), _defineProperty(_framework, "fpwd.IAMAccountPH", "Name of the administrator account"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew", "IAM user name or email address"), _defineProperty(_framework, "fpwd.step2.sendVerificationCode", "Send Code"), _defineProperty(_framework, "fpwd.confirmPasswdPH", "Enter the new password again."), _defineProperty(_framework, "fpwd.accountOrEmailPH.h5", "Account name or email address"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH.h5", "Mobile number"), _defineProperty(_framework, "fpwd.IAMAccountPH.h5", "Name of the administrator account"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew.h5", "IAM user name or email address"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder.h5", "CAPTCHA code"), _defineProperty(_framework, "fpwd.newPasswdPH.h5", "Enter a new password."), _defineProperty(_framework, "fpwd.confirmPasswdPH.h5", "Enter the new password again."), _defineProperty(_framework, "fpwd.iamFpwdAccountError", "Please enter the correct IAM user name"), _defineProperty(_framework, "hwId.upgradeTitle", "Upgrade to HUAWEI ID and Get Access to All Huawei Services"), _defineProperty(_framework, 'hwId.upgradeDesc', 'You are logged in with a HUAWEI CLOUD account, which is just for HUAWEI CLOUD services. Upgrade your account to a HUAWEI ID to access the full range of Huawei services, including HUAWEI Developers, HUAWEI devices (such as HUAWEI Phones), Huawei Mobile Services (such as HUAWEI Mobile Cloud and HUAWEI Video). After upgrading, you\'ll be able to use your HUAWEI ID for all your HUAWEI CLOUD resources as well. '), _defineProperty(_framework, 'hwId.upgradeDescLink', 'Learn more'), _defineProperty(_framework, 'hwId.upgradeAgreements.pre', 'I understand that HUAWEI ID collects my account name, mobile number, email address, registration country/region, and login credentials, and I have read and agree to'), _defineProperty(_framework, "hwId.upgradeAgreements.userAgreement", " HUAWEI ID User Agreement "), _defineProperty(_framework, "hwId.upgradeAgreements.and", " and "), _defineProperty(_framework, "hwId.upgradeAgreements.privacyPolicy", " Statement About HUAWEI ID and Privacy"), _defineProperty(_framework, "hwId.upgradeAgreements.period", "."), _defineProperty(_framework, "hwId.upgradeBtnTxt", "Upgrade Now"), _defineProperty(_framework, "hwId.upgradeCancelBtnTxt", "Upgrade Later"), _defineProperty(_framework, "hwId.upgradePageTitle", "Account Upgrade - HUAWEI CLOUD"), _defineProperty(_framework, "hwId.upgradeGoBack", "Account Upgrade"), _defineProperty(_framework, "hwId.upgradeErrorTitle", "Failed to load"), _defineProperty(_framework, "hwId.upgradeErrorDesc", "Service error, please contact customer service"), _defineProperty(_framework, "hwId.upgradeErrorBtn", "OK"), _defineProperty(_framework, "hwId.forgetPwd", "Forgot Password"), _defineProperty(_framework, "hwId.hwCloudAccount", "HUAWEI CLOUD Account"), _defineProperty(_framework, "hwId.hwCloudAccountLogin", "Account Login"), _defineProperty(_framework, "quickLogin.title", "Quick Login"), _defineProperty(_framework, "quickLogin.loginTip", "Log in through SMS or email verification."), _defineProperty(_framework, "quickLogin.accountInputPH", "Mobile number, email address, or account name"), _defineProperty(_framework, "quickLogin.smsCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.emailCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.codeBtn", "	Send Code"), _defineProperty(_framework, "quickLogin.codeCountdown", "Resend Code ({0}s)"), _defineProperty(_framework, "quickLogin.mobileLogin", "Mobile Number Verification"), _defineProperty(_framework, "quickLogin.emailLogin", "Email Address Verification"), _defineProperty(_framework, "quickLogin.selectUsersTitle", "Select Account"), _defineProperty(_framework, "quickLogin.selectUsersTitle.h5", "Select Account"), _defineProperty(_framework, "quickLogin.notAllowed", "This account does not support quick login. Use another account."), _defineProperty(_framework, "quickLogin.smsCodeMsg", "Send a verification code to the mobile number {0}."), _defineProperty(_framework, "quickLogin.emailCodeMsg", "Send a verification code to the email address {0}."), _defineProperty(_framework, "quickLogin.noMobile", "This account is not associated with a mobile number. Log in using an email address."), _defineProperty(_framework, "quickLogin.noEmail", "This account is not associated with an email address. Log in using a mobile number."), _defineProperty(_framework, "quickLogin.qucikLoginTip", "This account has been upgraded to a HUAWEI ID. Log in through the HUAWEI ID login page."), _defineProperty(_framework, "quickLogin.notActivate", "This account is not activated, quick login is not allowed"), _defineProperty(_framework, "quickLogin.register", "Free Registration"), _defineProperty(_framework, "ssologin.title", "Select Identity Provider"), _defineProperty(_framework, "ssologin.btnTxt", "Access"), _defineProperty(_framework, "idpLogin.loginLink", "Federated User"), _defineProperty(_framework, "idpLogin.title", "Federated User Login"), _defineProperty(_framework, "idpLogin.h5SelectTip", "Select Identity Provider"), _defineProperty(_framework, "idpLogin.accountPh", "HUAWEI CLOUD account name or tenant name"), _defineProperty(_framework, "idpLogin.listPh", "Identity provider"), _defineProperty(_framework, "idpLogin.goLogin", "Log In"), _defineProperty(_framework, "idpLogin.goAccountLogin", "HUAWEI CLOUD Account"), _defineProperty(_framework, "idpLogin.noIdps", "This account is not associated with any identity provider. Enter another account name or tenant name."), _defineProperty(_framework, "idpLogin.domainNotExist", "This account does not exist. Enter another account name or tenant name."), _defineProperty(_framework, 'selfManage.alertTip', 'The administrator has disabled Information Self-Management. If you need to modify your information, contact the administrator.'), _framework);
    function i18n(key) {
        return i18n.framework[key];
    }
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var framework = {
        "fpwd.emailVerifyCode": "Verification Code",
        "fpwd.getCode": "Send Code",
        accountNameBlank: "The account name cannot be left blank."
    };
    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        var _framework;

        var framework = (_framework = {
                "title.error": "Error",
                "title.prompt": "Information",
                "title.confirm": "Confirm",
                "title.warn": "Warning",

                "hasBindUniportal": "Your HUAWEI CLOUD account has already been upgraded. Use your HUAWEI ID to log in.",

                "mobileLoginModel.intlIpTip": "Esta página solo se puede utilizar para iniciar sesión con un número de celular de la parte continental de China.",
                "mobileLoginModel.mobileLogin": "Inicio de sesión con número de celular",
                "mobileLoginModel.accountLogin": "Inicio de sesión con cuenta/correo electrónico",
                "mobileLoginModel.mobilePlaceHolder": "Número de celular",
                "mobileLoginModel.accountPlaceHolder": "Nombre de la cuenta o correo electrónico",
                "mobileLoginModel.userPlaceHolder": "Nombre o correo del usuario de IAM",
                "mobileLoginModel.notRegisterTip": "Número de celular no registrado.",
                "mobileLoginModel.isMobileTip": "",
                "mobileLoginModel.registerNow": "Regístrese ahora",
                "mobileLoginModel.multiUsersTip": "El número de celular está vinculado a múltiples cuentas. Seleccione la cuenta que desea usar.",
                "mobileLoginModel.operationTooFrequent": "Operaciones demasiado frecuentes. Vuelva a intentarlo dentro de {0} minutos.",
                "mobileLoginModel.invalidNumber": "Ingrese un número de teléfono válido.",
                "mobileLoginModel.retry": "Vuelva a intentarlo",
                "mobileLoginModel.retrievePwd": "Recuperar contraseña",
                "emailLoginModel.multiUsersTip": "The email address is bound to multiple accounts. Select the account you want to use.", //TODO
                "fpwd.multiEmailUsersTip": "The email address is bound to multiple accounts. Select the account for which you want to reset the password.", //TODO

                "loginRegistTip": "El registro de usuarios nuevos solo es posible mediante invitación.",
                "accountName": " Nombre de la cuenta",
                "uniportalTip": "Cuentas del sitio web de Huawei, socios de Huawei, empleados de Huawei y desarrolladores TIC",
                "activeAccount": "Activar",
                "activeAccountMsg": "Estimado usuario de Huawei: Esta es la primera vez que usted inicia sesión en HUAWEI CLOUD. Lea y acepte el acuerdo de cliente y de protección de la privacidad de HUAWEI CLOUD antes de activar el servicio.",
                "userNameTip": "Nombre de usuario",
                "searchBoxPlaceHolder": "Ingrese una palabra clave.",
                "submitBtnTxt": "Aceptar",
                "cancelBtnTxt": "Cancelar",
                "btnTxtOK": "Aceptar",
                "btnTxtCancel": "Cancelar",
                "btnTxtYes": "Sí",
                "btnTxtNo": "No",
                "logout": "Salir",
                "connect": "y",
                "emptyStr": "--",
                "blankTxt": "Este campo es obligatorio.",
                "emptyTxt": "Este campo es obligatorio. No se permiten espacios.",
                "nameBlankTxt": "Este campo es obligatorio.",
                "passwordEqual": "Las contraseñas no coinciden.",
                "validEmail": "Ingrese una dirección de correo válida.",
                "validPhone": "Ingrese un número de celular válido.",
                "maxLenTxt": "Ingrese {0} caracteres como máximo.",
                "minLenTxt": "Ingrese al menos {0} caracteres.",
                "minMaxLenTxt": "Debe contener entre {0} y {1} caracteres.",
                "phoneMaxLenTxt": "Ingrese un máximo de {0} dígitos.",
                "msgCodeErrorInfo": "Solo se permiten dígitos.",
                "nameContainsChar": "Use solo letras, dígitos, guiones (-) o guiones bajos (_) y comience con una letra o guion (-).",
                "commonContainsChar": "Solo se permiten letras y dígitos.",
                "pwdNotUsernameOrInvert": "No puede ser el nombre de usuario ni el nombre de usuario escrito al revés.",
                "pwdNotContsMobileOrEmail": "La contraseña no puede contener el número de celular ni la dirección de correo.",
                "pwdNotContsMobile": "No incluya su número de celular completo.",
                "pwdcantContsMobileOrEmail": "La contraseña no puede contener el número de celular ni la dirección de correo.",
                "pwdWeak": "The password could be leaked. Enter another one. ",
                "usernameNotPwdOrInvert": "El nombre de usuario no puede ser igual a la contraseña ni a esta escrita en orden inverso.",
                "passwordChars": "Debe contener el menos {0} de los siguientes tipos de caracteres: letras mayúsculas, letras minúsculas, dígitos y caracteres especiales~`! ?,.:; -_'\" ( ) { } [ ] /<>@# $% ^& * + |\\ = y espacios).",
                "mobilePasswordChars1": "La contraseña debe contener al menos dos de los siguientes tipos de caracteres:",
                "mobilePasswordChars2": "letras mayúsculas, letras minúsculas, dígitos y caracteres especiales.",
                "validEmailOrPhone": "Ingrese una dirección de correo o un número de celular válidos.",
                "validAccountName": "Ingrese un nombre de cuenta válido.",
                "validPwd": "Ingrese una contraseña válida.",
                "validAgency": "Ingrese un nombre de agente válido.",
                "validCheckCode": "Ingrese 4 caracteres como máximo.",
                "tooMuchErrorCode": "Se ingresaron demasiados códigos de verificación incorrectos. Obtenga otro código de verificación.",
                "pwdCannotEqualName": "No puede ser igual al nombre de su cuenta ni a este en orden inverso.",
                "passwordPolicy.errorMsgOfRptChar": "La contraseña puede contener {0} caracteres consecutivos iguales como máximo.",
                "inValidCcompanyName": "No puede contener solo caracteres especiales, dígitos, espacios ni caracteres de tabulación.",
                "companyNameLength": "Ingrese 32 caracteres como máximo.",
                "accountTipInfo": "Información de la cuenta:",
                "yes": "Sí",
                "no": "No",
                "iamUserTip": "Si es creado por una cuenta de HUAWEI CLOUD, inicie sesión como usuario de IAM.",
                "registerFailed": "Error de registro.",
                "recommended": "Recomendado",
                "strengthLow": "No segura",
                "strengthMid": "Seguridad media",
                "strengthHigh": "Segura",
                "accountNameBlank": "El nombre de la cuenta es obligatorio.",
                "userNameBlank": "El nombre de usuario es obligatorio.",
                "pwdBlank": "La contraseña es obligatoria.",
                "checkCodeBlank": "El código de verificación es obligatorio.",
                "phoneBlank": "El número de celular es obligatorio.",
                "checkCodeBlank4Intl": "Ingrese un código de verificación.",
                "backToHomepage": "Volver a la página de inicio",
                "backTo": "Volver",
                "homepage": "Inicio",
                "mobileHome": "Página de inicio",
                "isHwsUser": "Está iniciando sesión en el sitio web de HUAWEI CLOUD internacional. Haga clic aquí para iniciar sesión en el sitio web de HUAWEI CLOUD China.",
                "isHongKongUser": "Está iniciando sesión en el sitio web de HUAWEI CLOUD China. Haga clic aquí para iniciar sesión en el sitio web internacional de HUAWEI CLOUD.",
                "isRuUser": "Está iniciando sesión en el sitio web de HUAWEI CLOUD internacional. Haga clic aquí para iniciar sesión en el sitio web internacional de HUAWEI CLOUD.",
                "isHwsUser1": "Está iniciando sesión en el sitio web de HUAWEI CLOUD internacional. Haga clic",
                "isHongKongUser1": "Está iniciando sesión en el sitio web de HUAWEI CLOUD China. Haga clic",
                "isRuUser1": "Está iniciando sesión en el sitio web de HUAWEI CLOUD internacional. Haga clic",
                "goLogin.hws": "aquí",
                "goLogin.hk": "aquí",
                "goLogin.ru": "aquí",
                "toLogin.hws": " para iniciar sesión en el sitio web de HUAWEI CLOUD China.",
                "toLogin.hk": " para iniciar sesión en el sitio web de HUAWEI CLOUD internacional.",
                "toLogin.ru": " para iniciar sesión en el sitio web de HUAWEI CLOUD internacional.",
                "language": "Inglés",
                "lanuage.hk": "Internacional",
                "lanuage.ch": "中国站,",
                "lanuage.zh-cn": "简体中文,",
                "language.en-us": "Inglés",
                "titles.login": "Iniciar sesión en HUAWEI CLOUD",
                "titles.resetPwd": "Restablecimiento de contraseña de HUAWEI CLOUD",
                "titles.fpwd": "Olvidé la contraseña de HUAWEI CLOUD",
                "titles.register": "Registro en HUAWEI CLOUD",
                "titles.agencyRegister": "Registro de agente en HUAWEI CLOUD",
                "titles.reactivate": "Reactivar HUAWEI CLOUD",
                "titles.registerSuccess": "Registro exitoso en HUAWEI CLOUD",
                "titles.fphone": "Cambio de número de celular de HUAWEI CLOUD",
                "titles.loginVerification": "Verificación de inicio de sesión en HUAWEI CLOUD",
                "titles.bindAccount": "Primer inicio de sesión en HUAWEI CLOUD",
                "titles.bindAccountSuccess": "Registro correcto en HUAWEI CLOUD (registro y vinculación)",
                "registerFree": "Registre su cuenta de HUAWEI CLOUD",
                "freeRegister": "Registro gratis",
                "createDomain": "Crear cuenta",
                "createDomainBtn": "Crear y vincular",
                "createSubUser": "Crear cuenta de usuario secundario",
                "createFailed": "Error al crear la cuenta.",
                "bindDomain": "Vincular cuenta",
                "createDomainLink": "Crear cuenta",
                "bindDomainLink": "Vincular cuenta",
                "bindFailed": "Error al vincular la cuenta.",
                "bindRepeat": "La cuenta está vinculada con otro socio. No vuelva a vincularla.",
                "createDomain.remindCompleteInfo": "Configure la siguiente información para crear una cuenta de HUAWEI CLOUD y vincularla. ¿Ya tiene una cuenta?",
                "bindDomain.remindCompleteInfo": "Configure la siguiente información para crear una cuenta de HUAWEI CLOUD y vincularla. ¿Aún no tiene una cuenta?",
                "createSubUserInfo": "Ingrese la siguiente información para crear una cuenta de usuario secundario de HUAWEI CLOUD y vincularla.",
                "enterpriseUser": "Inicio de sesión de usuario de IAM",
                "enterpriseUserLogin": "Inicio de sesión de usuario de IAM",
                "personageUser": "Inicio de sesión en cuenta",
                "enterpriseUser4Intl": "Inicio de sesión de usuario de IAM (internacional)",
                "personageUser4Intl": "Inicio de sesión en cuenta (internacional)",
                "accountPlaceHolder": "Nombre de la cuenta",
                "HongKongAccountPlaceHolder": "Nombre de la cuenta",
                "domainPlaceHolder": "Nombre/ID del agente",
                "roleNamePlaceHolder": "Nombre del agente",
                "failedToswitchRole": "Error de cambio de agente.",
                "switchSubmit": "Cambiar rol",
                "agencyDesc": "Se puede usar un ID de usuario y una contraseña para gestionar los recursos de múltiples cuentas. Después de que el administrador de HUAWEI CLOUD configura los roles y le proporciona detalles relacionados con la cuenta y el rol, usted podrá seleccionar un rol u otro.",
                "userNamePlaceHolder": "Nombre de usuario, correo o número de celular del usuario de IAM",
                "HongKongUserNamePlaceHolder": "Nombre o correo del usuario de IAM",
                "accountNamePlaceHolder": "Nombre de la cuenta, correo o número de celular",
                "HongKongAccountNamePlaceHolder": "Nombre de la cuenta o correo electrónico",
                "accountTip": "Cuenta",
                "passwdPlaceHolder": "Contraseña",
                "iamPasswdPlaceHolder": "IAM user password", //TODO: 翻译
                "verifyCodePlaceHolder": "Código CAPTCHA",
                "GraphicsVerifyCodeLabel": "Código de verificación: ",
                "GraphicsVerifyCode": "Verificación de seguridad",
                "InputGrapVerifyCodeInfo": "Para garantizar la seguridad de la cuenta, ingrese el código que se muestra en la imagen siguiente.",
                "GrapVerifyCodeFailed": "El código de verificación es incorrecto o ha expirado. Vuelva a intentarlo.",
                "getVerifyCode": "Obtenga otro código de verificación.",
                "loginSubmit": "Iniciar sesión",
                "logining": "Iniciando sesión...",
                "mobileNumberLogin": "Número de celular",
                "noMobileLogin": "Nombre de la cuenta o correo electrónico",
                "userNameMobliePH": "Número de celular",
                "rememberName": " Recordarme",
                "rememberLogin": " Recordarme",
                "rememberName4Intl": " Recordarme",
                "forgetPwd": "¿Olvidó su contraseña?",
                "emaiNamePwd": "Dirección de correo incorrecta.",
                "phoneNamePwd": "Número de celular incorrecto.",
                "domainNamePwd": "Nombre de usuario incorrecto.",
                "wrongNamePwd": "Contraseña incorrecta.",
                "wrongNamePwd4Intl": "Nombre de usuario o dirección de correo incorrectos.",
                //TODO: 翻译
                "learnMore": "Learn more",
                "iamAccountTip": "The account used to create an IAM user in IAM. ",
                "iamUsernameTip": "An IAM user created using the account in IAM. ",
                "iamAccountTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
                "iamUsernameTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

                "wrongIPBlacklist": "El dispositivo usado para el inicio de sesión no es seguro. Use otro dispositivo.",
                "wrongIPFrequencyLimiting": "La cantidad de intentos fallidos de inicio de sesión originados desde la misma dirección IP alcanzó el límite máximo. Vuelva a intentarlo más tarde.",
                "wrongEquipmentIDFrequencyLimiting": "La cantidad de intentos fallidos de inicio de sesión originados desde el mismo dispositivo alcanzó el límite máximo. Vuelva a intentarlo más tarde o inicie sesión usando otro dispositivo.",
                "MachineOperation": "El dispositivo usado para el inicio de sesión no es seguro. Use otro dispositivo.",
                "emaiNamePwdChances": "Dirección de correo incorrecta. Después de {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "phoneNamePwdChances": "Número de celular incorrecto. Después de {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "domainNamePwdChances": "Nombre de usuario incorrecto. Después de {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "wrongNamePwdChances": "Contraseña incorrecta. Después de {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "wrongNamePwdFourChances": "Información de autenticación incorrecta. Si realiza 4 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "wrongNamePwdThreeChances": "Información de autenticación incorrecta. Si realiza 3 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "wrongNamePwdTwoChances": "Información de autenticación incorrecta. Si realiza 2 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "wrongNamePwdoneChances": "Información de autenticación incorrecta. Si realiza 1 intento incorrecto más, no podrá iniciar sesión durante 15 minutos.",
                "wrongNamePwdFourChances4Intl": "Contraseña incorrecta. Quedan 4 intentos más antes de que se active el bloqueo de 15 minutos.",
                "wrongNamePwdThreeChances4Intl": "Contraseña incorrecta. Quedan 3 intentos más antes de que se active el bloqueo de 15 minutos.",
                "wrongNamePwdTwoChances4Intl": "Contraseña incorrecta. Quedan 2 intentos más antes de que se active el bloqueo de 15 minutos.",
                "wrongNamePwdoneChances4Intl": "Contraseña incorrecta. Queda 1 intento más antes de que se active el bloqueo de 15 minutos.",
                "userAccountsLocked": "Ha ingresado un nombre de usuario o una contraseña incorrectos 5 veces. El nombre de usuario se bloqueará durante 15 minutos.",
                "userAccountsStopped": "El usuario se deshabilitó. Comuníquese con el administrador.",
                "domainAccountsStopped": "El usuario se deshabilitó.",
                "clientIpInvalid": "No está permitido iniciar sesión desde este terminal. ",
                userNotExist: "The user does not exist. Contact the administrator. ",
                "clientIpInvalid.learnMore": "Learn more",
                "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
                "notAllowFpwd": "No está permitido recuperar la contraseña desde este terminal.",
                "warning": "Advertencia",
                "systemException": "El sistema está ocupado. Actualice la página y vuelva a intentarlo.",
                "freqLocked": "Se superó la cantidad máxima de intentos permitida. Vuelva a intentarlo más tarde.",
                "wrongVerifyCode": "El código de verificación es incorrecto o ha expirado.",
                "invalidInput": "El valor del parámetro no es válido.",
                serviceUrlInvalid: "Login failed. <a href='/'>Try again</a>. ",
                "maxSessionLimit": "La cantidad de sesiones de usuarios que pueden estar en línea al mismo tiempo supera el límite permitido por el sistema.",
                "multiUserInvalid": "Ha iniciado sesión en este terminal. Cierre sesión y vuelva a intentarlo.",
                "pageTimeout": "The operation timed out. Refresh the page and try again.",
                "accountClosed": "La cuenta se está cerrando.",
                "invalidInputFourChances": "Parámetro incorrecto. Si realiza 4 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "invalidInputThreeChances": "Parámetro incorrecto. Si realiza 3 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "invalidInputTwoChances": "Parámetro incorrecto. Si realiza 2 intentos incorrectos más, no podrá iniciar sesión durante 15 minutos.",
                "invalidInputoneChances": "Parámetro incorrecto. Si realiza 1 intento incorrecto más, no podrá iniciar sesión durante 15 minutos.",
                "loginReactivateFail": "La cuenta no se activó. El correo de activación no se puede enviar a esta cuenta. Vuelva a intentarlo.",
                "pwdSame": "La contraseña nueva no puede ser igual a la contraseña anterior.",
                "initialPwdSame": "La contraseña nueva no puede ser igual a la contraseña inicial.",
                "historyPwdSame": "La contraseña nueva no puede ser igual a una contraseña histórica.",
                "copyrightNotice1": "© {0}, Copyright by HUAWEI CLOUD. All rights reserved. ",
                "copyrightNotice1_hk": "©{0} Huawei Services (Hong Kong) Co., Ltd.",
                "copyrightNotice2": "",
                "copyrightNotice3": "Licencia de ICP de Jiangsu 09062682 - número 13",
                "copyrightNotice4": "Número B2-20130048 de Jiangsu",
                "copyrightNotice5": "Licencia de red pública de Jiangsu: número 32011402010636",
                "legalNotice": "Aviso legal",
                "legalStatement": "Aviso legal",
                "siteTerms": "Site Terms",
                "privacyProtect": "Declaración de privacidad",
                "privacyStrategyStatement": "Declaración de privacidad",
                "reportAbuse": "Denunciar abuso",
                "sa_nisr": "Política de uso aceptable",
                "sa_nisr_intl": "Política de uso aceptable",
                "sa_cua": "Contrato de cliente de HUAWEI CLOUD",
                "sa_cua_intl": "Contrato de cliente de HUAWEI CLOUD",
                "enterpriseSwitchTip": "Este modo de acceso es aplicable a usuarios empresariales, es decir, a usuarios creados por el administrador de la empresa.",
                "personalSwitchTip": " Este modo de acceso es aplicable a usuarios empresariales, es decir, a usuarios creados durante el registro.",
                "usingOtherWaysLogin": "Usar otra cuenta para iniciar sesión",
                "otherWaysLogin": "Inicio de sesión en otra cuenta",
                "HWSdeveloper": "Alianza de desarrolladores de Huawei",
                "hwportal": "Sitio web oficial de Huawei",
                "HWICTdeveloper": "Desarrollador de TIC de Huawei",
                "WeLink": "WeLink",
                "readAgree": "He leído y acepto el",
                "hwCloudAgreement": "contrato de cliente de HUAWEI CLOUD",
                "secretprotect": "Declaración de privacidad",
                "hwCloudAgreementMobile": "contrato de cliente de HUAWEI CLOUD",
                "secretprotectMobile": " Declaración de privacidad",
                "companyUserRegistration": "Registrar empleado empresarial",
                "personalUserRegistration": "Registrar usuario",
                "companyAccountName": "Nombre de usuario",
                "userName": "Nombre de usuario:",
                "registerMail": "Dirección de correo:",
                "congratulationsSucceed": "Registro realizado.",
                "password": "Contraseña:",
                "registerMailStep3": "Correo:",
                "passwordPlaceHolder": "Ingrese su contraseña.",
                "confirmPassword": "Confirmar contraseña:",
                "confirmPasswordPlaceHolder": "Vuelva a ingresar la contraseña.",
                "companyName": "Empresa:",
                "contact": "Contacto:",
                "phoneNum": "Número de celular: ",
                "phonePlaceHolder": "Ingrese su número de teléfono celular.",
                "msgCode": "Código de verificación vía SMS:",
                "msgCodeTxt": "Enviar código",
                "msgPHTxt": "Código de verificación",
                "msgCodeTxtWait": "Reenviar código ({0} s)",
                "msgCodeWrong": "El código de verificación vía SMS es incorrecto.",
                "region": "Región:",
                "register.submit": "Registro",
                "register.finish": "Finalizar",
                "submit": "Siguiente",
                "innerKeyWord": "No se permiten palabras claves del sistema al principio.",
                "accountNamePH": "Ingrese su nombre de usuario.",
                "emailPH": "Ingrese su dirección de correo.",
                "companyNamePH": "Ingrese el nombre de su empresa.",
                "mobileCompanyName": "(Opcional) Ingrese su nombre empresarial.",
                "registerSuccess": "Registro realizado.",
                "pleaseCompleteInfo": "Para mejorar la seguridad de la cuenta, complete la información de su empresa.",
                "complete": "Complete el",
                "companyInfo": "perfil empresarial",
                "rejectAndBack": "Vuelva al",
                "homePage": "página de inicio",
                "period": ".,",
                "goTo": " Acceda a",
                "myCredential": "Mis credenciales",
                "completeUserInfo": "Complete la información personal.",
                "fpwd.findPasswd": "Restablecer contraseña",
                "fpwd.enterpriseName": "Nombre de la cuenta:",
                "fpwd.accountName": "Dirección de correo o número de celular:",
                "fpwd.SMSVerifyCode": "Ingrese el código de verificación enviado por SMS.",
                "fpwd.emailVerifyCode": "Ingrese el código de verificación enviado al correo electrónico.",
                "fpwd.getCode": "Enviar código",
                "fpwd.confirmAccount": "Confirmar cuenta",
                "fpwd.resetPwd": "Restablecer contraseña",
                "fpwd.resetSuccess": "Finalizar",
                "fpwd.findSuccess": "Se restableció la contraseña.",
                "fpwd.newPasswd": "Contraseña nueva:",
                "fpwd.confirmPasswd": "Confirmar contraseña:",
                "fpwd.enterpriseNamePH": "Ingrese el nombre de la cuenta.",
                "fpwd.accountNamePH": "Ingrese una dirección de correo o un número de celular.",
                "fpwd.verifyCodePH": "Ingrese el código",
                "fpwd.confirmPasswdPH": "Vuelva a ingresar la contraseña nueva.",
                "fpwd.newPasswdPH": "Ingrese una contraseña nueva.",
                "fpwd.newPasswdPHApp": "Contraseña nueva",
                "fpwd.nextStepBtn": "Siguiente",
                "fpwd.backTo": "Volver",
                "fpwd.titleDetail": "Ingrese la información de la cuenta.",
                "fpwd.titleIAMDetail": "Ingrese la información de usuario de IAM.",
                "fpwd.multiUsersTip": "El número de celular está vinculado a múltiples cuentas. Seleccione la cuenta para la que desea restablecer la contraseña.",
                "fpwd.accountConfirm": "Verificación de cuenta",
                "fpwd.personalAccount": "Cuenta",
                "fpwd.IAMAccount": "Usuario de IAM",
                "fpwd.typePersonalTip": "Una cuenta creada cuando se registró con HUAWEI CLOUD utilizando un número de celular.",
                "fpwd.typeIAMTip": "Un usuario creado usando una cuenta de IAM",
                "fpwd.accountOrEmailPH": "Nombre de la cuenta o correo electrónico",
                "fpwd.IAMAccountPH": "Nombre de la cuenta del administrador",
                "fpwd.IAMAccountNamePH": "Nombre, correo o celular del usuario de IAM.",
                "fpwd.IAMAccountNamePHNew": "correo o celular del usuario de IAM.",
                "fpwd.identityVerification": "Verificación de identidad",
                "fpwd.identityVerificationDec": "Seleccione un método de verificación de identidad.",
                "fpwd.passwordReset": "Restablecer contraseña",
                "fpwd.passwordResetDesc": "Configure una contraseña nueva.",
                "fpwd.step1.fpwdByPhone": "Usar número de teléfono celular",
                "fpwd.step1.fpwdByemail": "Usar el nombre de la cuenta o la dirección de correo",
                "fpwd.step1.phoneAccountNamePH": "Número de celular",
                "fpwd.step2.verificationCodePH": "Ingrese el código de verificación.",
                "fpwd.step2.sendVerificationCode": "Enviar código",
                "fpwd.step2.unbindDesc": "Su identidad no puede ser verificada porque no se vinculó ninguna dirección de correo electrónico ni número de móvil a su cuenta.",
                "fpwd.step2.unbindIAMDesc": "Su identidad no puede ser verificada porque no se vinculó ninguna dirección de correo electrónico ni número de celular al usuario de IAM.",
                "fpwd.step2.exceptionService": "If your mobile number or email address is unavailable, request the administrator to reset your password.",
                "fpwd.step2.sendEmailCode": "Dirección de correo electrónico ({0})",
                "fpwd.step2.sendMobileCode": "Número de celular ({0})",
                "fpwd.step2.unabledMethod": "Ninguna de las opciones anteriores",
                "fpwd.step2.helpMsg": "Comuníquese con el servicio de atención al cliente.",
                "fpwd.step2.helpTel1": "China continental +86 4000 955 988",
                "fpwd.step2.helpTel2": "Hong Kong, China +852 800 931 122",
                "fpwd.retrieveTxt": "Reenviar código ({0} s)",
                "fpwd.step3.showPwdTip": "Mostrar",
                "fpwd.step3.hidePwdTip": "Ocultar",
                "fpwd.goToLogin": "Iniciar sesión",
                "fpwd.successTxt": "Se restableció la contraseña",
                "fpwd.loginCountdownTxt": "Será redireccionado a la página de inicio en {0}s.",
                "domainuserAccountsLocked": "La dirección de correo de la cuenta de usuario no se ha activado. Finalice el proceso de activación haciendo clic en el enlace enviado a su correo electrónico.",
                "fpwd.sendCodeFailed": "El sistema está ocupado. Error al obtener el código de verificación.",
                "fpwd.getCodeFail": "Ha obtenido el código de verificación 5 veces. Vuelva a intentarlo mañana.",
                "wrong_sendCodeFailed": "Error al obtener el código de verificación. Obtenga otro código de verificación.",
                "fpwd.invalidVerifyCode": "El código de verificación es incorrecto. Vuelva a intentarlo.",
                "fpwd.setPasswdFailed": "Error al configurar la contraseña nueva debido a una excepción del servidor. Vuelva a intentarlo.",
                "fpwd.ipLocked": "Se bloqueó la dirección IP.",
                "fpwd.MultipleIAMUserNameByMobile": "Recupere la contraseña usando el correo porque el número de celular está vinculado a múltiples usuarios de IAM.",
                "fpwd.MultipleAccountNameByMobile": "Debe ingresar el nombre de una cuenta porque el número de celular está vinculado a múltiples cuentas.",
                "fpwd.MultipleAccountNameByMobileError": "La contraseña no puede recuperarse desde un teléfono celular usando este número porque está vinculada a múltiples cuentas. Vuelva a intentarlo usando el número en una PC o utilizando su dirección de correo electrónico para recuperar la contraseña en un teléfono celular.",
                "fpwd.MultipleAccountsByMobileReminder": "Si múltiples cuentas utilizan el mismo número de celular, se deberá ingresar el nombre de la cuenta.",
                "fpwd.EnterCorrectEnterpriseAccount": "Ingrese el nombre de una cuenta registrada en HUAWEI CLOUD.",
                "fpwd.EnterCorrectMobile": "Ingrese un número de celular registrado en HUAWEI CLOUD.",
                "fpwd.EnterCorrectEnterpriseAccountAndMobile": "Ingrese un nombre de cuenta o un número de celular registrados en HUAWEI CLOUD.",
                "fpwd.EnterCorrectEmail": "Ingrese una dirección de correo registrada en HUAWEI CLOUD.",
                "fpwd.EnterCorrectEnterpriseAccountAndEmail": "Ingrese un nombre de cuenta y una dirección de correo correctos.",
                "fpwd.EnterCorrectEnterpriseVerificationCode": "Ingrese el código de verificación correcto.",
                "operationTooFrequent": "Operaciones demasiado frecuentes. Vuelva a intentarlo más tarde.",
                "fpwd.contactService": "Nota: Si no tiene acceso al correo ni al número de celular registrados, comuníquese con el servicio de atención al cliente al {0} para recibir asistencia., //4000-955-988, +7 (495) 800 1 800.",
                "fpwd.contactHKService": "Nota: Si no puede acceder a su correo registrado, comuníquese con el servicio de atención al cliente al {0} para recibir asistencia.",
                "fpwd.ErrorRegionAccount": "Ingrese una cuenta de HUAWEI CLOUD válida.",
                "countryCodeSelect": "Seleccione un código de país.",
                "bindPhone": "Número de celular:",
                "bindPhoneNum": "Número de celular:",
                "alreadyHaveAccount": ",",
                "login": "Iniciar sesión",
                "loginNow": "Iniciar sesión",
                "safetyDegree": "Seguridad de la contraseña:",
                "handsRegisterInfo": "Para usar el servicio PDA en la nube de Huawei, haga clic",
                "hansRegistration": "Registro.",
                "filloutRegisterInfo": "Configurar información de registro",
                "checkAccountInfo": "Completar información de la cuenta",
                "registerSucceed": "Finalizar",
                "successAccoutInfo": "Sus cuentas son:",
                "descriptionInfo": "Para iniciar sesión, use alguna de las cuentas anteriores.",
                "linkFailed": "El enlace ha expirado.",
                "linkFailedDetail": "Su cuenta se ha activado o ha finalizado el tiempo de espera para la activación.",
                "linkFailedHelp": "Intente",
                "linkFailedLogin": "Iniciar sesión",
                "serverTimeout": "Finalizó el tiempo de espera del servidor. Vuelva a intentarlo más tarde.",
                "mainMsg": "El correo de activación se ha enviado a:",
                "secondMsg": "Haga clic en el enlace del correo dentro de las próximas 24 horas para finalizar la activación.",
                "checkEmail": "Abrir correo ahora",
                "didNotGetEmail": "¿No recibió el correo?",
                "checkSpamMail": "1. Revise la carpeta de correo no deseado.",
                "stillDidNotGetEmail": "2. Si no lo recibió,",
                "resendEmail": "vuelva a enviar un correo.",
                "alwaysDidNotGetEmail": "3. Si nunca recibe el correo,",
                "changeMailbox": "cambie su dirección de correo.",
                "replaceEmailTip": "Podrá cambiar su dirección de correo una vez dentro de las próximas 24 horas. Revise su dirección de correo cuidadosamente.",
                "sendNewEmail": "Enviar",
                "alreadySend": "Se envió el correo de activación.",
                "sendFailed": "Error al enviar el correo.",
                "inputEmail": "Ingrese su dirección de correo.",
                "email": "Correo:",
                "countToHomepage": "Redireccionando a la página de inicio de sesión en {0} segundos.",
                "registerFailed.emailRepeat": "La dirección de correo electrónico se ha registrado.",
                "registerFailed.nameRepeat": "Este nombre de usuario se ha registrado.",
                "registerFailed.mobileRepeat": "El número de celular se ha registrado.",
                "registerFailed.nameCannotBegin": "El nombre no puede comenzar con un dígito ni con un guion bajo (_).",
                "registerFailed.nameCannotContain": "Solo se permiten letras, dígitos, guiones (-) y guiones bajos (_).",
                "registerSuccess.backToHomepage": "1. ,",
                "registerSuccess.returnHomepage": "Página de inicio",
                "registerSuccess.backToHomepageLink": "Vuelva a la página de inicio de HUAWEI CLOUD.",
                "registerSuccess.backToHomepageLinkP1": "Vuelva a",
                "registerSuccess.backToHomepageLinkP2": "la página de inicio de HUAWEI CLOUD.",
                "registerSuccess.second": "2.,",
                "registerSuccess.goToBss": "Visite",
                "registerSuccess.goToBssFillInfo": " para completar la información de registro. A continuación, recibirá mensajes de descuentos de servicios de HUAWEI CLOUD de forma periódica.",
                "registerSuccess.bssAccountInfo": "Centro de usuarios",
                "registerSuccess.redirecting": "Redireccionando...",
                "registerSuccess.redirecting.back": "Volver a la página original después de {0} segundos",
                "registerSuccess.autoClose": "Esta página se cerrará en {0} segundos.",
                "registerSuccess.browserPreventClose": "La configuración del navegador no permite que el sistema cierre páginas automáticamente.",
                "registerSuccess.homepage": "Inicio",
                "registerSuccess.userCenter": "Centro de usuarios",
                "registerSuccess.consoleHome": "Consola de gestión",
                "registerSuccess.helpCenter": "Ayuda",
                "resetPwd.title": "Primer inicio de sesión",
                "resetPwd.titleDetail": "Para mejorar la seguridad de la cuenta, ingrese una contraseña nueva.",
                "resetPwd.phone": "Número de celular verificado:",
                "resetPwd.mailbox": "Dirección de correo verificada:",
                "resetPwd.byPhone": "Verificar vía celular",
                "resetPwd.byMailbox": "Verificar vía correo",
                "resetPwd.smsMsgCode": "Código de verificación vía SMS:",
                "resetPwd.emailMsgCode": "Código de verificación vía correo:",
                "resetPwd.getSmsMsgCode": "Enviar código",
                "resetPwd.getEmailMsgCode": "Enviar código",
                "resetPwd.retrieveMsgCode": "Reenviar código ({0} s)",
                "resetPwd.resetFailed": "Error al cambiar la contraseña.",
                "resetPwd.oldPasswd": "Contraseña anterior:",
                "resetPwd.newPasswd": "Contraseña nueva:",
                "resetPwd.apiKeyTitle": "Cambiar contraseña de API",
                "resetPwd.apiKeyDetail": "Para mejorar la seguridad de la cuenta, ingrese una contraseña de API nueva.",
                "resetPwd.apkKey": "Contraseña de API anterior:",
                "resetPwd.confirmNewPasswd": "Confirmar contraseña:",
                "resetPwd.resetPwdFailed": "La contraseña anterior es incorrecta. Vuelva a intentarlo.",
                "resetPwd.resetCount": "La contraseña anterior es incorrecta. Si realiza {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "resetPwd.getCodeFail": "Se realizaron más de 5 intentos fallidos de obtención de código de verificación. Vuelva a intentarlo dentro de 15 minutos.",
                "resetPwd.InitPasswd": "Contraseña inicial:",
                "resetPwd.InitPasswdError": "La contraseña inicial es incorrecta. Vuelva a intentarlo.",
                "resetPwd.InitPasswdCount": "La contraseña inicial es incorrecta. Si realiza {0} intentos fallidos más, deberá iniciar sesión nuevamente.",
                "modifyPwdIntervalTimeLessThanMinValidTime": "El intervalo entre cambios de contraseñas debe ser superior o igual a la duración mínima de la contraseña. Haga clic en Cancelar para ingresar al sistema.",
                "pwdModifyTitle": "Cambiar contraseña",
                "pwdExpiredTitle": "Contraseña expirada",
                "pwdExpiringDesc": "Su contraseña expirará en {0} días. Cámbiela inmediatamente.",
                "pwdExpiredDesc": "Su contraseña ha expirado. Cámbiela.",
                "noRight": "Permisos insuficientes. Comuníquese con el administrador para la concesión de permisos.",
                "browserSupport": "HUAWEI CLOUD funciona mejor con los siguientes navegadores",
                "browserSupport.chrome": "Chrome",
                "browserSupport.chromeVersion": "(36.0 o posterior)",
                "browserSupport.firefox": "FireFox",
                "browserSupport.firefoxVersion": "(35.0 o posterior),",
                "browserSupport.ie": "Internet Explorer:",
                "browserSupport.ieVersion": "(9.0 o posterior),",
                "reactivate.reactivateAccount": "Activar cuenta",
                "reactivate.pleaseCheckEmail": "Su cuenta no se ha activado. Inicie sesión con su dirección de correo registrada y haga clic en el enlace del correo de registro para activar la cuenta.",
                "advertisement.txt": "Gratis para las primeras 100 pruebas",
                "advertisement.buttonTxt": "Solicitar",
                "fphone.changePhoneNum": "Cambiar número de celular",
                "fphone.changeSuccess": "Finalizar",
                "fphone.registerEmail": "Dirección de correo verificada:",
                "fphone.registerEmailPH": "Ingrese una dirección de correo.",
                "fphone.emailVerifyCode": "Código de verificación vía correo:",
                "fphone.getVerifyCodeByEmail": "Obtener código de verificación vía correo",
                "fphone.emailVerifyCodePH": "Ingrese el código",
                "fphone.newPhoneNum": "Número de celular nuevo:",
                "fphone.newPhoneNumPH": "Ingrese un número de celular nuevo.",
                "fphone.smsVerifyCode": "Código de verificación vía SMS:",
                "fphone.getVerifyCodeBySms": "Obtener código de verificación vía SMS",
                "fphone.smsVerifyCodePH": "Ingrese el código",
                "fphone.changePhoneSuccess": "El número de celular se modificó correctamente.",
                "fphone.newPhoneNumInfo": "Número de celular nuevo:",
                "fphone.phoneRepeat": "El número de celular ya existe.",
                "fphone.exceedMaxAccounts": "La cantidad de cuentas vinculadas a este número de celular alcanzó el límite máximo permitido (6).",
                "mobileNumber": "celular:",
                "fphone.changeMobile": "Cambiar número de celular",
                "sendSmsIntervalErr": "La cantidad de intentos de obtención de códigos de verificación supera el límite máximo. Vuelva a intentarlo dentro de 1 minuto.",
                "cookie.chromeDesc": "Seleccione Ajustes. En la página Ajustes, haga clic en Mostrar ajustes avanzados y seleccione Ajustes de contenidos en Privacidad. En el cuadro de diálogo Ajustes de contenidos, quite la marca de Bloquear datos de sitios y cookies de terceros, seleccione Permitir datos locales (recomendado) y haga clic en Finalizar. Luego, reinicie el navegador y vuelva a iniciar sesión.",
                "cookie.firefoxDesc": "Haga clic en Opciones y seleccione Privacidad. En la página Privacidad, seleccione Ajustes personalizados para el historial, quite la marca de Siempre usar el modo de búsqueda privada, seleccione Aceptar cookies de los sitios y haga clic en Aceptar. Luego, reinicie el navegador y vuelva a iniciar sesión.",
                "cookie.ieDesc": "Seleccione Herramientas > Opciones de Internet. En el cuadro de diálogo Opciones de Internet, haga clic en la pestaña Privacidad. En la pestaña Privacidad, seleccione el valor menor de Bloquear todas las cookies y haga clic en Guardar. Luego, reinicie el navegador y vuelva a iniciar sesión.",
                "cookie.chromeName": "Google Chrome:",
                "cookie.firefoxName": "Mozilla Firefox:",
                "cookie.ieName": "Internet Explorer:",
                "cookie.title": "¿Cómo habilito las Cookies en mi navegador?",
                "cookie.loginTip": "Iniciar sesión después de habilitar las Cookies.",
                "cookie.startCookie": "¿Habilitar Cookies?",
                "verifyCode.intervalError": "Sus solicitudes de códigos de verificación son excesivas. Vuelva a intentarlo dentro de 1 minuto.",
                "verifyCode.invalid": "El código de verificación ha expirado. Haga clic en Obtener código para recibir un código nuevo.",
                "verifyCode.error": "El código de verificación es incorrecto. Vuelva a intentarlo.",
                "verifyCode.locked": "Se excedió la cantidad máxima de solicitudes de códigos de verificación permitida. Vuelva a intentarlo mañana.",
                "verifyCode.locked.custom": "Se excedió la cantidad máxima de solicitudes de códigos de verificación permitida. Vuelva a intentarlo dentro de {0} minutos o comuníquese con el servicio de atención al cliente al 4000-955-988.",
                "verifyCode.sendFailed": "No se pudo enviar el código de verificación. Obtenga otro.",
                "verifyCode.remainderCount": "Quedan {0} intentos de verificación. Si los intentos restantes no se realizan correctamente, el código de verificación nuevo solo se podrá generar después de un período especificado.",
                "verifyCode.cantAcquire": "La función de solicitud de código de verificación se ha bloqueado. Ingrese el último código de verificación recibido.",
                "verifyCode.emailInvalidAndSMSError": "El código de verificación vía SMS es incorrecto. Vuelva a intentarlo con un código de verificación vía correo electrónico válido.",
                "verifyCode.email.invalid": "El código de verificación enviado al correo ha expirado. Obtenga otro.",
                "verifyCode.email.error": "El código de verificación enviado al correo es incorrecto. Vuelva a intentarlo.",
                "verifyCode.sms.invalid": "El código de verificación enviado vía SMS ha expirado. Obtenga otro.",
                "verifyCode.sms.error": "El código de verificación vía SMS es incorrecto. Vuelva a intentarlo.",
                "verifyCode.usernameRepeat": "El nombre de usuario ya existe. Ingrese otro.",
                "verifyCode.maxmiumSubUserNum": "Se alcanzó la cantidad máxima de usuarios.",
                "verifyCode.emailExist": "La dirección de correo ya existe. Ingrese otro.",
                "loginVerification": "Verificación de inicio de sesión",
                "loginVerification.tips": "If you do not want the custom information to be displayed during login, contact the administrator."
        }, _defineProperty(_framework, "titles.loginVerification", "Verificación de inicio de sesión en la nube"), _defineProperty(_framework, "loginVerification.presetLoginInfo", "Información preestablecida de inicio de sesión"), _defineProperty(_framework, "loginVerification.warningInfo", "Si la información que se muestra no coincide con la información de inicio de sesión preestablecida, cancele el inicio de sesión."), _defineProperty(_framework, "loginVerification.checkBySMS", "Verificación vía SMS"), _defineProperty(_framework, "loginVerification.SMSHasSentTo", "(El código de verificación vía SMS se enviará a su teléfono celular)"), _defineProperty(_framework, "loginVerification.pleaseClickAgain", "(Si no lo recibe en los próximos 60 segundos, haga clic en Obtener código otra vez)."), _defineProperty(_framework, "loginVerification.userLoginInfo", "Información de inicio de sesión"), _defineProperty(_framework, "loginVerification.lastSuccessTime", "Último inicio de sesión exitoso"), _defineProperty(_framework, "loginVerification.lastFailedTime", "Último inicio de sesión fallido"), _defineProperty(_framework, "loginVerification.failedTimes", "Intentos fallidos consecutivos de inicio de sesión"), _defineProperty(_framework, "loginVerification.lockInfo", "Después de {0} intentos fallidos consecutivos de inicio de sesión, el usuario actual se bloqueará durante {1} minutos."), _defineProperty(_framework, "loginVerification.MFATitle", "Autenticación de inicio de sesión vía MFA Virtual"), _defineProperty(_framework, "loginVerification.MFAContext", "Ingrese el código de verificación de 6 dígitos generado en la aplicación de autenticación. "), _defineProperty(_framework, "loginVerification.MFAHelp", "Más información cómo obtener el código de autenticación."), _defineProperty(_framework, "loginVerification.MFALabel", "Código de autenticación de MFA"), _defineProperty(_framework, "loginVerification.MFANotUseTip", "¿El dispositivo MFA virtual no está disponible?"), _defineProperty(_framework, "loginVerification.MFANotUseMessage1", "Comuníquese con el administrador de HUAWEI CLOUD de su compañía para restablecer el dispositivo MFA virtual."), _defineProperty(_framework, "loginVerification.MFANotUseMessage2", "Comuníquese con el servicio de atención al cliente de HUAWEI CLOUD."), _defineProperty(_framework, "loginVerification.resetMFAHelpUrl", "<a href='{0}' target='_blank' rel='noopener noreferrer'>Learn how</a> to unbind or remove a virtual MFA device."), _defineProperty(_framework, "loginVerification.rememberMFALabel", "Remember me for 7 days"), _defineProperty(_framework, "loginVerification.rememberMFALabel.disabledTip", "Limited to 5 IAM users per browser. "), _defineProperty(_framework, "loginVerification.emailCheckTitle", "Autenticación de inicio de sesión vía correo electrónico,"), _defineProperty(_framework, "loginVerification.emailCheckContent", "(Se enviará un código de autenticación a {0})."), _defineProperty(_framework, "loginVerification.emailCodeLabel", "Código de verificación vía correo electrónico"), _defineProperty(_framework, "loginVerification.emailCodeTxt", "Enviar código"), _defineProperty(_framework, "loginVerification.verificationType", "Método de autenticación:"), _defineProperty(_framework, "loginVerification.verificationTypeForPhone", "绑定手机号与验证方式"), _defineProperty(_framework, "loginVerification.verificationTypeForEmail", "绑定邮件地址与验证方式"), _defineProperty(_framework, "loginVerification.bindPhone", "Número de celular"), _defineProperty(_framework, "loginVerification.bindPhoneTips", "El administrador ha habilitado la autenticación basada en teléfono celular. Ingrese un número de teléfono celular."), _defineProperty(_framework, "loginVerification.bindPhonePH", "Ingrese un número de teléfono celular."), _defineProperty(_framework, "loginVerification.bindEmail", "Dirección de correo:"), _defineProperty(_framework, "loginVerification.bindEmailTips", "El administrador ha habilitado la autenticación basada en correo electrónico. Ingrese la dirección de correo electrónico."), _defineProperty(_framework, "loginVerification.bindEmailPH", "Ingrese una dirección de correo."), _defineProperty(_framework, "loginVerification.verifyCode", "Código de verificación"), _defineProperty(_framework, "loginVerification.verifyCodeBtnTxt", "Enviar código"), _defineProperty(_framework, "loginVerification.verifyCodePH", "Código de 6 dígitos"), _defineProperty(_framework, "loginVerification.verifyCodeEmailPH", "Código de 6 dígitos"), _defineProperty(_framework, "loginVerification.sendCodeTxt", "Se envió el código de verificación. Para garantizar la seguridad de su cuenta, no comparta este código con nadie."), _defineProperty(_framework, "loginVerification.sendCodeFailed", "Error al enviar el código de verificación porque el sistema está ocupado."), _defineProperty(_framework, "loginVerification.validEmailOrPhone", "Ingrese una dirección de correo o un número de celular válidos."), _defineProperty(_framework, "loginVerification.retrieveTxt", "Reenviar código ({0} s)"), _defineProperty(_framework, "loginVerification.otherAccount", "Use otra cuenta."), _defineProperty(_framework, "loginVerification.goOnLogin", "Aceptar"), _defineProperty(_framework, "loginVerification.title", "Vincular el dispositivo MFA virtual"), _defineProperty(_framework, "loginVerification.firstStep", "Paso 1: Descargue e instale la aplicación de autenticación en su teléfono celular."), _defineProperty(_framework, "loginVerification.firstStepIntroduction", "The authenticator app will prompt you to add your account."), _defineProperty(_framework, "loginVerification.secondStep", "Paso 2. Configure la aplicación de autenticación."), _defineProperty(_framework, "loginVerification.secondStepIntroduction", "Abra la aplicación de autenticación en su smartphone. Obtenga los códigos de autenticación de seis dígitos mediante el escaneo del siguiente código QR o ingresando la siguiente clave secreta en la aplicación."), _defineProperty(_framework, "loginVerification.username", "Nombre de usuario"), _defineProperty(_framework, "loginVerification.domainname", "Nombre de la cuenta"), _defineProperty(_framework, "loginVerification.secretKey", "Clave secreta"), _defineProperty(_framework, "loginVerification.thirdStep", "Paso 3: Ingrese los códigos de verificación."), _defineProperty(_framework, "loginVerification.thirdStepIntroduction", "Use la aplicación de autenticación para generar dos códigos de autenticación consecutivos e ingrese los códigos aquí."), _defineProperty(_framework, "loginVerification.firstRegCode", "Código de Autenticación 1"), _defineProperty(_framework, "loginVerification.secondRegCode", "Código de autenticación 2"), _defineProperty(_framework, "loginVerification.submitText", "Aceptar"), _defineProperty(_framework, "loginVerification.bindMFASucceed", "El dispositivo MFA virtual se vinculó correctamente."), _defineProperty(_framework, "loginVerification.mfaCodeError", "El código de verificación de MFA es incorrecto. Ingrese otro código."), _defineProperty(_framework, "loginVerification.mfaCodeLocked", "Ha realizado demasiados intentos dentro de un período de tiempo reducido. Vuelva a intentarlo dentro de cinco minutos."), _defineProperty(_framework, "bindAccount.title", "Vincule la cuenta de HUAWEI CLOUD"), _defineProperty(_framework, "bindAccount.submit", "Registrar y vincular"), _defineProperty(_framework, "registerGiftSuffixMobile", "Más populares"), _defineProperty(_framework, "bindAccount.remindCompleteInfo", "Complete la siguiente información para registrar una cuenta de HUAWEI CLOUD y vincularla."), _defineProperty(_framework, "bindAccount.bindSuccess", " Registro exitoso. La cuenta de HUAWEI CLOUD se ha vinculado."), _defineProperty(_framework, "bindAccount.HWSAccount", "Su cuenta de HUAWEI CLOUD:"), _defineProperty(_framework, "bindAccount.timeRemind", "Después de {0} segundos"), _defineProperty(_framework, "bindAccount.redirectPage", "Volver a la página original"), _defineProperty(_framework, "validCountryCode", "Seleccione un código de país válido."), _defineProperty(_framework, "registerGift", "Si el registro es correcto, usted podrá obtener cupones de efectivo."), _defineProperty(_framework, "registerGiftAddress", "Obtener cupones de efectivo"), _defineProperty(_framework, "registerSuccess.goToGift", "Acceda a"), _defineProperty(_framework, "registerSuccess.goToGiftFillInfo", " para obtener cupones especiales de efectivo para usuarios nuevos."), _defineProperty(_framework, "usercompanyAccount", "La información de su cuenta es la siguiente:"), _defineProperty(_framework, "welcomeLogin.titleDetail", "Para la seguridad de su cuenta, configure una contraseña."), _defineProperty(_framework, "welcomeEmail.title", "Correo de bienvenida"), _defineProperty(_framework, "welcomeEmail.linkTimeout", "Disculpe, su enlace no es válido porque expiró."), _defineProperty(_framework, "welcomeEmail.linkExpired", "Disculpe, su enlace no está disponible."), _defineProperty(_framework, "welcomeEmail.resendEmail", "Haga clic aquí para enviar un correo de bienvenida nuevo."), _defineProperty(_framework, "welcomeEmail.contactAdm", "Comuníquese con el administrador para enviar un correo de bienvenida nuevo."), _defineProperty(_framework, "welcomeEmail.alreadySend", "Se envió un correo de bienvenida."), _defineProperty(_framework, "titles.setPassword", "Configuración de contraseña de HUAWEI CLOUD"), _defineProperty(_framework, "titles.welcomeEmail", "Correo de bienvenida a HUAWEI CLOUD"), _defineProperty(_framework, "welcomeEmail.setPassword", "Configurar contraseña"), _defineProperty(_framework, "dateFormate", "M/d/y HH:mm:ss,"), _defineProperty(_framework, "sessionExpired", "La sesión expiró. Vuelva a iniciar sesión."), _defineProperty(_framework, "m.userNamePlaceHolder", "Nombre de usuario / Correo / Número de celular"), _defineProperty(_framework, "m.HongKongUserNamePlaceHolder", "Nombre de usuario/correo electrónico"), _defineProperty(_framework, "m.accountNamePlaceHolder", "Nombre de usuario/correo electrónico"), _defineProperty(_framework, "m.HongKongAccountNamePlaceHolder", "Nombre de usuario/correo electrónico"), _defineProperty(_framework, "m.verifyCodePlaceHolder", "Verificar código"), _defineProperty(_framework, "inValidCountryCode", "Seleccione un código de país válido."), _defineProperty(_framework, "mobile.CountryCode", "+86 (China)"), _defineProperty(_framework, "authenticationInfo", "Ciertas funciones no están disponibles para usuarios que no hayan efectuado la autenticación de nombre real."), _defineProperty(_framework, "authenticationForwardInfo", "Realice la autenticación de nombre real para obtener una mejor experiencia de servicio."), _defineProperty(_framework, "authenticationForward", "autenticación de nombre real"), _defineProperty(_framework, "registerSuccess.goToAuthentication", "Podrá finalizar,"), _defineProperty(_framework, "registerSuccess.authenticationInfo", "para obtener una prueba gratuita del paquete durante 6 meses."), _defineProperty(_framework, "fpwd.findByEmail", "Restablecer contraseña vía correo electrónico"), _defineProperty(_framework, "fpwd.findByPhone", "Restablecer contraseña usando el número de celular"), _defineProperty(_framework, "fpwd.accountNameByEmail", "Correo registrado:"), _defineProperty(_framework, "fpwd.accountNameByPhone", "Número de celular registrado:"), _defineProperty(_framework, "fpwd.phoneAccountNamePH", "Ingrese un número de teléfono celular."), _defineProperty(_framework, "eChannelName", "Socio empresarial de Huawei"), _defineProperty(_framework, "uniportalName", "Cuenta de Huawei"), _defineProperty(_framework, "moreLink", "Más"), _defineProperty(_framework, "registerSuccess.authenticationForward", "Complete la autenticación de nombre real"), _defineProperty(_framework, "homepageLink", "Inicio"), _defineProperty(_framework, "helpCenter", "Documentación"), _defineProperty(_framework, "cloudCommunity", "Comunidad en la nube"), _defineProperty(_framework, "registerSuccess.goToUserZone", "Acceda a"), _defineProperty(_framework, "registerSuccess.userZoneLink", "Nueva zona de usuarios"), _defineProperty(_framework, "registerSuccess.userZoneInfo", " para obtener un paquete especial con un descuento del 50 %."), _defineProperty(_framework, "register.accountPlaceHolder", "Nombre de la cuenta"), _defineProperty(_framework, "register.passwordPlaceHolder", "Contraseña"), _defineProperty(_framework, "register.confirmPasswordPlaceHolder", "Confirmar contraseña"), _defineProperty(_framework, "register.phonePlaceHolder", "Número de celular"), _defineProperty(_framework, "register.msgCodePlaceHolder", "Código de verificación"), _defineProperty(_framework, "register.accountNameLength", "Ingrese entre 5 y 32 caracteres."), _defineProperty(_framework, "register.bindACccountPlaceHolder", "Nombre de dominio / Dirección de correo / Número de celular"), _defineProperty(_framework, "remindBindEmail.title", "Vincular dirección de correo"), _defineProperty(_framework, "remindBindEmail.remindMsg", "Su cuenta no tiene una dirección de correo vinculada. Vincular una dirección de correo a:"), _defineProperty(_framework, "remindBindEmail.remindInfo1", "● Recibir notificaciones cuando los recursos de la nube se aprovisionan o se eliminan, o cuando están a punto de expirar."), _defineProperty(_framework, "remindBindEmail.remindInfo2", "● Verificar su identidad al realizar operaciones importantes, tales como cambiar el número de celular, restablecer la contraseña y eliminar los ECS."), _defineProperty(_framework, "remindBindEmail.bind", "Vincular ahora"), _defineProperty(_framework, "remindBindEmail.nextBind", "Vincular más tarde"), _defineProperty(_framework, "remindBindEmail.remind", "Información"), _defineProperty(_framework, "remindBindEmail.remindHideInfo", "Vincule la dirección de correo en una página nueva."), _defineProperty(_framework, "remindBindEmail.remindHideFailde", "Si la vinculación no se realiza correctamente, intente"), _defineProperty(_framework, "remindBindEmail.remindHideFailde2", "vincular otra dirección de correo."), _defineProperty(_framework, "remindBindEmail.remindHideSuccess", "Vinculación finalizada"), _defineProperty(_framework, "notify.openPage", "Please wait..."), _defineProperty(_framework, "notify.closeSecondBefore", "Operation Successful."), _defineProperty(_framework, "notify.closePage", "Operation successful. Please close the page"), _defineProperty(_framework, "registerFailed.accountNameRepeat", "El nombre de la cuenta se ha registrado."), _defineProperty(_framework, "register.bindAccountPlaceHolder", "Nombre de la cuenta / Dirección de correo / Número de celular"), _defineProperty(_framework, "privacyPolicyUpdate", "Actualizaciones de la declaración de privacidad"), _defineProperty(_framework, "privacyTipPre", "Dear customer, we have updated the HUAWEI CLOUD Privacy Statement. We understand the importance of your privacy and are fully committed to protecting it. Please read the updated"), _defineProperty(_framework, "privacyTipSuf", "carefully to learn how we protect your personal data."), _defineProperty(_framework, "agreementBtnTxt", "Agree"), _defineProperty(_framework, "privacyAgreementNotAcceptedError", "Lea y acepte primero la Declaración de privacidad de HUAWEI CLOUD."), _defineProperty(_framework, "OIDC.errorDefault", "System error. Please contact the administrator."), _defineProperty(_framework, "OIDC.errorO001", "System error. Please try again."), _defineProperty(_framework, "OIDC.errorO002", "Invalid domain ID."), _defineProperty(_framework, "OIDC.errorO003", "Invalid identity provider ID."), _defineProperty(_framework, "OIDC.errorO004", "Invalid service URL."), _defineProperty(_framework, "OIDC.errorO005", "Cannot find the OpenID Connect configuration."), _defineProperty(_framework, "OIDC.errorO006", "Invaid OpenID configuration."), _defineProperty(_framework, "OIDC.errorO007", "Invalid ID Token."), _defineProperty(_framework, "OIDC.errorO008", "The State parameter is invalid."), _defineProperty(_framework, "OIDC.errorO009", "Invalid JWT."), _defineProperty(_framework, "OIDC.errorO010", "Acl check failed."), _defineProperty(_framework, "OIDC.errorO011", "Failed to obtain the IAM token based on the mapping rules. Check the mapping rules or contact the administrator."), _defineProperty(_framework, "OIDC.errorO012", "No reachable project to log in."), _defineProperty(_framework, "OIDC.errorO013", "Too many requests. Please try again later."), _defineProperty(_framework, "OIDC.errorO014", "Cannot access the console in the [program] access mode."), _defineProperty(_framework, "OIDC.errorO015", "Invalid error."), _defineProperty(_framework, "console_term_500Error_label", "The system is busy. Please try again later."), _defineProperty(_framework, "console_term_404Error_label", "Sorry! Failed to find the page."), _defineProperty(_framework, "console_term_401Error_label", "Sorry! The page has expired."), _defineProperty(_framework, "titles.loginReminder", "HUAWEI CLOUD – Login"), _defineProperty(_framework, "QRLogin.title1", "QR Login"), _defineProperty(_framework, "QRLogin.title2", "Log in to Huawei Cloud"), _defineProperty(_framework, "QRLogin.countDownTipPre1", "Please use the "), _defineProperty(_framework, "QRLogin.countDownTipPre2", "HUAWEI CLOUD APP"), _defineProperty(_framework, "QRLogin.countDownTipPre3", " to scan the QR code to log in "), _defineProperty(_framework, "QRLogin.remainingTime", "{0} seconds"), _defineProperty(_framework, "QRLogin.countDownTipSuffix", "QR code expires after "), _defineProperty(_framework, "QRLogin.QRCodeInvalid", "QR code has expired"), _defineProperty(_framework, "QRLogin.refresh", "refresh"), _defineProperty(_framework, "QRLogin.scanSuc", "Scan Successfully"), _defineProperty(_framework, "QRLogin.scanSucTip", "Please follow the prompts to confirm login on your phone"), _defineProperty(_framework, "QRLogin.loginFail", "Login Failed"), _defineProperty(_framework, "QRLogin.loginFailTipPre", "Please click "), _defineProperty(_framework, "QRLogin.loginFailTipSuffix", " and re-scan the QR code to log in"), _defineProperty(_framework, "QRLogin.downloadApp", "Download HUAWEI CLOUD App"), _defineProperty(_framework, "QRLogin.comma", ", "), _defineProperty(_framework, "QRLogin.loginReminder", "Login Reminder"), _defineProperty(_framework, "QRLogin.accountLogin", "Password Login"), _defineProperty(_framework, "hwId.cookieMsg", "Utilizamos cookies para mejorar nuestro sitio y su experiencia de navegación. Al seguir navegando en él, usted acepta nuestra política de cookies."), _defineProperty(_framework, "hwId.hwAccount", "HUAWEI ID"), _defineProperty(_framework, "hwId.privacyContent", "Durante el inicio de sesión, usted acepta proporcionar a HUAWEI CLOUD la información de su cuenta y de su red para ayudarnos a ofrecerle una mejor experiencia. "), _defineProperty(_framework, "hwId.hwportal", "Cuenta del sitio web oficial de Huawei"), _defineProperty(_framework, "hwId.eChannel", "Socio empresarial de Huawei"), _defineProperty(_framework, "hwId.casLogin.systemError", "Error"), _defineProperty(_framework, "hwId.casLogin.systemErrorDesc", "Se produjo un error del sistema. Actualice la página o comuníquese con el servicio al cliente a través de la siguiente dirección: clientes@huaweicloud.com."), _defineProperty(_framework, "hwId.casLogin.accountError", "Error"), _defineProperty(_framework, "hwId.casLogin.accountErrorDesc", "Su cuenta no puede utilizarse para iniciar sesión en HUAWEI CLOUD. Inicie sesión con otra cuenta."), _defineProperty(_framework, "hwId.casLogin.accountErrorLink", "Más información"), _defineProperty(_framework, "hwId.casLogin.accountErrorUrl", "/en-us/iam_faq/iam_01_0006.html"), _defineProperty(_framework, "hwId.casLogin.loginError", "Error"), _defineProperty(_framework, "hwId.casLogin.loginErrorDesc", "No puede usar su cuenta para iniciar sesión en HUAWEI CLOUD en este modo. Haga clic en Inicio de sesión con ID de HUAWEI e inicie sesión."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorDesc", "Su cuenta está registrada en Europa o Rusia y no puede utilizarse para acceder a HUAWEI CLOUD. Inicie sesión utilizando una cuenta registrada en otro país o región."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorLink", "Más información sobre por qué no se puede iniciar sesión."), _defineProperty(_framework, "hwId.casLogin.accountTurkeyErrorLink", "Your current account is registered in [Turkey]. HUAWEI CLOUD does not support accounts in Turkey. Please <a href='{0}' target='_blank' rel='noopener noreferrer'>register for a HUAWEI CLOUD account</a> immediately, or log in with accounts in other region."), _defineProperty(_framework, "hwId.casLogin.inactivatedError", "Cuenta no activada"), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc", "Su cuenta no se ha activado. Actívela dentro de las próximas 24 horas haciendo clic en el enlace correspondiente que se ha enviado a la dirección de correo electrónico vinculada con su cuenta."), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc.noEmail", "Su cuenta no puede utilizarse para acceder a los servicios de HUAWEI CLOUD porque no se ha activado y no está vinculada con una dirección de correo electrónico. Inicie sesión con otra cuenta."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidError", "Servicios de HUAWEI CLOUD no activados"), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc", "Los servicios de HUAWEI CLOUD no se han activado para su cuenta. Actívelos dentro de las próximas 24 horas haciendo clic en el enlace correspondiente que se ha enviado a la dirección de correo electrónico vinculada con su cuenta."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc.noEmail", "No puede utilizar los servicios de HUAWEI CLOUD porque no se han habilitado para su cuenta y esta no está vinculada con una dirección de correo electrónico. Inicie sesión con otra cuenta."), _defineProperty(_framework, "hwId.casLogin.accessErrorDesc", "HUAWEI CLOUD no puede obtener la información de su cuenta. Inicie sesión utilizando otra cuenta."), _defineProperty(_framework, "hwId.refresh", "Actualizar"), _defineProperty(_framework, "hwId.cookies", "Cookies"), _defineProperty(_framework, "hwId.otherAccount", "Utilizar otra cuenta :"), _defineProperty(_framework, "hwId.otherAccount.h5", "Utilizar otra cuenta"), _defineProperty(_framework, "hwId.hwIdLogin", "Huawei Account Login"), _defineProperty(_framework, "hwId.accountPlaceHolder", "Nombre de tenant o nombre de cuenta de HUAWEI CLOUD"), _defineProperty(_framework, "hwId.upgradeTitle", "Actualizar con un ID de HUAWEI y obtener acceso a todos los servicios de Huawei"), _defineProperty(_framework, 'hwId.upgradeDesc', 'You are logged in with a HUAWEI CLOUD account, which is just for HUAWEI CLOUD services. Upgrade your account to a HUAWEI ID to access the full range of Huawei services, including HUAWEI Developers, HUAWEI devices (such as HUAWEI Phones), Huawei Mobile Services (such as HUAWEI Mobile Cloud and HUAWEI Video). After upgrading, you\'ll be able to use your HUAWEI ID for all your HUAWEI CLOUD resources as well. '), _defineProperty(_framework, 'hwId.upgradeDescLink', 'Learn more'), _defineProperty(_framework, 'hwId.upgradeAgreements.pre', 'I understand that HUAWEI ID collects my account name, mobile number, email address, registration country/region, and login credentials, and I have read and agree to'), _defineProperty(_framework, "hwId.upgradeAgreements.userAgreement", "el Contrato de usuario de ID de HUAWEI"), _defineProperty(_framework, "hwId.upgradeAgreements.and", " y "), _defineProperty(_framework, "hwId.upgradeAgreements.privacyPolicy", "la Declaración acerca de ID de HUAWEI y la privacidad"), _defineProperty(_framework, "hwId.upgradeAgreements.period", "."), _defineProperty(_framework, "hwId.upgradeBtnTxt", "Actualizar ahora"), _defineProperty(_framework, "hwId.upgradeCancelBtnTxt", "Actualizar más tarde"), _defineProperty(_framework, "hwId.upgradePageTitle", "Actualización de la cuenta_HUAWEI CLOUD"), _defineProperty(_framework, "hwId.upgradeGoBack", "Actualizar cuenta"), _defineProperty(_framework, "hwId.upgradeErrorTitle", "Error de carga"), _defineProperty(_framework, "hwId.upgradeErrorDesc", "Error de servicio. Comuníquese con el servicio de atención al cliente."), _defineProperty(_framework, "hwId.upgradeErrorBtn", "Aceptar"), _defineProperty(_framework, "hwId.forgetPwd", "¿Olvidó la contraseña?"), _defineProperty(_framework, "hwId.hwCloudAccount", "HUAWEI CLOUD Account"), _defineProperty(_framework, "hwId.hwCloudAccountLogin", "Inicio de sesión en cuenta"), _defineProperty(_framework, "fpwd.accountFpwdTitle", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.iamFpwdTitle", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.goAccountFpwd", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.goIAMFpwd", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.step2.accountHelpMsg", "If you cannot perform verification using your mobile phone and email account currently, please call +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China). If you have already retrieved your password, log in now."), _defineProperty(_framework, "fpwd.step2.switchPhoneVerify", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step2.switchEmailVerify", "Email Address Verification"), _defineProperty(_framework, "fpwd.pwdValidateRule", "Password requirements:"), _defineProperty(_framework, "fpwd.pwdSafetyDegree", "Password strength:"), _defineProperty(_framework, "fpwd.selectUserTitle", "Select Account Name"), _defineProperty(_framework, "fpwd.step1.fpwdByEmail", "Account Name/Email Address Verification"), _defineProperty(_framework, "fpwd.step1.fpwdByPhone", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH", "Mobile number"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder", "CAPTCHA code"), _defineProperty(_framework, "fpwd.accountOrEmailPH", "Account name or email address"), _defineProperty(_framework, "fpwd.IAMAccountPH", "Name of the administrator account"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew", "IAM user name or email address"), _defineProperty(_framework, "fpwd.step2.sendVerificationCode", "Send Code"), _defineProperty(_framework, "fpwd.confirmPasswdPH", "Enter the new password again."), _defineProperty(_framework, "fpwd.accountOrEmailPH.h5", "Account name or email address"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH.h5", "Mobile number"), _defineProperty(_framework, "fpwd.IAMAccountPH.h5", "Name of the administrator account"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew.h5", "IAM user name or email address"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder.h5", "CAPTCHA code"), _defineProperty(_framework, "fpwd.newPasswdPH.h5", "Enter a new password."), _defineProperty(_framework, "fpwd.confirmPasswdPH.h5", "Enter the new password again."), _defineProperty(_framework, "fpwd.iamFpwdAccountError", "Please enter the correct IAM user name"), _defineProperty(_framework, "quickLogin.title", "Quick Login"), _defineProperty(_framework, "quickLogin.loginTip", "Log in through SMS or email verification."), _defineProperty(_framework, "quickLogin.accountInputPH", "Mobile number, email address, or account name"), _defineProperty(_framework, "quickLogin.smsCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.emailCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.codeBtn", "	Send Code"), _defineProperty(_framework, "quickLogin.codeCountdown", "Resend Code ({0}s)"), _defineProperty(_framework, "quickLogin.mobileLogin", "Mobile Number Verification"), _defineProperty(_framework, "quickLogin.emailLogin", "Email Address Verification"), _defineProperty(_framework, "quickLogin.selectUsersTitle", "Select Account"), _defineProperty(_framework, "quickLogin.selectUsersTitle.h5", "Select Account"), _defineProperty(_framework, "quickLogin.notAllowed", "This account does not support quick login. Use another account."), _defineProperty(_framework, "quickLogin.smsCodeMsg", "Send a verification code to the mobile number {0}."), _defineProperty(_framework, "quickLogin.emailCodeMsg", "Send a verification code to the email address {0}."), _defineProperty(_framework, "quickLogin.noMobile", "This account is not associated with a mobile number. Log in using an email address."), _defineProperty(_framework, "quickLogin.noEmail", "This account is not associated with an email address. Log in using a mobile number."), _defineProperty(_framework, "quickLogin.qucikLoginTip", "This account has been upgraded to a HUAWEI ID. Log in through the HUAWEI ID login page."), _defineProperty(_framework, "quickLogin.notActivate", "This account is not activated, quick login is not allowed"), _defineProperty(_framework, "quickLogin.register", "Free Registration"), _defineProperty(_framework, "ssologin.title", "Seleccionar proveedor de identidades"), _defineProperty(_framework, "ssologin.btnTxt", "Acceder"), _defineProperty(_framework, "idpLogin.loginLink", "Usuario federado"), _defineProperty(_framework, "idpLogin.title", "	Inicio de sesión de usuario federado"), _defineProperty(_framework, "idpLogin.h5SelectTip", "Seleccionar proveedor de identidades"), _defineProperty(_framework, "idpLogin.accountPh", "Nombre de cuenta o nombre de tenant de HUAWEI CLOUD"), _defineProperty(_framework, "idpLogin.listPh", "Proveedor de identidades"), _defineProperty(_framework, "idpLogin.goLogin", "Iniciar sesión"), _defineProperty(_framework, "idpLogin.goAccountLogin", "Cuenta de HUAWEI CLOUD"), _defineProperty(_framework, "idpLogin.noIdps", "Esta cuenta no está vinculada con ningún proveedor de identidades. Ingrese otro nombre de cuenta o nombre de tenant."), _defineProperty(_framework, "idpLogin.domainNotExist", "Esta cuenta no existe. Ingrese otro nombre de cuenta o nombre de tenant."), _defineProperty(_framework, 'selfManage.alertTip', 'The administrator has disabled Information Self-Management. If you need to modify your information, contact the administrator.'), _framework);
        function i18n(key) {
                return i18n.framework[key];
        };
        i18n.framework = framework;
        return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var framework = {
        "clientIpInvalid.helpUrl": "/es-us/usermanual-iam/iam_07_0003.html"
    };

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        var _framework;

        var framework = (_framework = {
                "title.error": "Error",
                "title.prompt": "Information",
                "title.confirm": "Confirm",
                "title.warn": "Warning",

                "hasBindUniportal": "Your HUAWEI CLOUD account has already been upgraded. Use your HUAWEI ID to log in.",

                "mobileLoginModel.intlIpTip": "Esta página somente pode ser usada para acessar com um número de celular da parte continental da China.",
                "mobileLoginModel.mobileLogin": "Acesso por número de celular",
                "mobileLoginModel.accountLogin": "Acesso por conta/e-mail",
                "mobileLoginModel.mobilePlaceHolder": "Número de celular",
                "mobileLoginModel.accountPlaceHolder": "Nome da conta ou e-mail",
                "mobileLoginModel.userPlaceHolder": "Nome de usuário do IAM ou e-mail",
                "mobileLoginModel.notRegisterTip": "Número de celular não registrado.",
                "mobileLoginModel.isMobileTip": "",
                "mobileLoginModel.registerNow": "Registrar agora",
                "mobileLoginModel.multiUsersTip": "O número de celular está vinculado a várias contas. Selecione a conta que você deseja usar.",
                "mobileLoginModel.operationTooFrequent": "As operações foram feitas frequentemente demais. Tente novamente após {0} minutos.",
                "mobileLoginModel.invalidNumber": "Informe um número de telefone válido.",
                "mobileLoginModel.retry": "Tentar novamente",
                "mobileLoginModel.retrievePwd": "Recuperar senha",
                "emailLoginModel.multiUsersTip": "The email address is bound to multiple accounts. Select the account you want to use.", //TODO
                "fpwd.multiEmailUsersTip": "The email address is bound to multiple accounts. Select the account for which you want to reset the password.", //TODO

                "loginRegistTip": "Novos usuários precisam ter um convite para fazer o registro.",
                "accountName": " Nome da conta",
                "uniportalTip": "Contas do site da Huawei, parceiros da Huawei, funcionários da Huawei e desenvolvedores de TIC",
                "activeAccount": "Ativar",
                "activeAccountMsg": "Caro usuário da Huawei, este é seu primeiro acesso no HUAWEI CLOUD. Você precisa ler e concordar com o Contrato do Cliente e a Declaração de Privacidade do HUAWEI CLOUD antes de ativar o serviço.",
                "userNameTip": "Nome de usuário:",
                "searchBoxPlaceHolder": "Informe uma palavra-chave.",
                "submitBtnTxt": "OK",
                "cancelBtnTxt": "Cancelar",
                "btnTxtOK": "OK",
                "btnTxtCancel": "Cancelar",
                "btnTxtYes": "Sim",
                "btnTxtNo": "Não",
                "logout": "Sair",
                "connect": "e",
                "emptyStr": "--",
                "blankTxt": "Este campo não pode ficar em branco.",
                "emptyTxt": "Este campo não pode ficar em branco. Não são permitidos espaços.",
                "nameBlankTxt": "Este campo não pode ficar em branco.",
                "passwordEqual": "As senhas não correspondem.",
                "validEmail": "Informe um endereço e-mail válido.",
                "validPhone": "Informe um número de celular válido.",
                "maxLenTxt": "Digite no máximo {0} caracteres.",
                "minLenTxt": "Informe pelo menos {0} caracteres.",
                "minMaxLenTxt": "Precisa ter de {0} a {1} caracteres.",
                "phoneMaxLenTxt": "Digite no máximo {0} dígitos.",
                "msgCodeErrorInfo": "Apenas dígitos são permitidos.",
                "nameContainsChar": "Use somente letras, dígitos, hifens (-) ou traços-baixos (_) e comece com uma letra ou hífen (-).",
                "commonContainsChar": "Apenas letras e dígitos são permitidos.",
                "pwdNotUsernameOrInvert": "Não pode ser o nome de usuário ou o nome de usuário de trás para a frente.",
                "pwdNotContsMobileOrEmail": "A senha não pode conter o número de celular nem o endereço e-mail.",
                "pwdNotContsMobile": "Não inclua seu número de celular completo.",
                "pwdcantContsMobileOrEmail": "A senha não pode conter o número de celular nem o endereço e-mail.",
                "pwdWeak": "The password could be leaked. Enter another one. ",
                "usernameNotPwdOrInvert": "O nome de usuário não pode ser a senha ou a senha escrita de trás para frente.",
                "passwordChars": "Deve conter pelo menos {0} dos seguintes tipos de caracteres: letras maiúsculas, letras minúsculas, dígitos e caracteres especiais (~`! ?,.:; -_'\" ( ) { } [ ] /<>@# $% ^& * + |\\ = e espaços).",
                "mobilePasswordChars1": "A senha precisa ter pelo menos dois dos seguintes tipos de caractere: ",
                "mobilePasswordChars2": "letras maiúsculas, letras minúsculas, dígitos e caracteres especiais.",
                "validEmailOrPhone": "Informe um endereço de e-mail válido ou um número de celular.",
                "validAccountName": "Informe um nome de conta válido.",
                "validPwd": "Informe uma senha válida.",
                "validAgency": "Informe um nome de agente válido.",
                "validCheckCode": "Informe no máximo 4 caracteres.",
                "tooMuchErrorCode": "Você inseriu códigos de verificação incorretos várias vezes. Obtenha outro código de verificação.",
                "pwdCannotEqualName": "Não pode ser o nome da conta ou o nome da conta escrito de trás para frente.",
                "passwordPolicy.errorMsgOfRptChar": "A senha pode ter no máximo {0} caracteres iguais consecutivos.",
                "inValidCcompanyName": "Não pode ter apenas caracteres especiais, dígitos, espaços ou caracteres de tabulação.",
                "companyNameLength": "Informe no máximo 32 caracteres.",
                "accountTipInfo": "Informações da conta:",
                "yes": "Sim",
                "no": "Não",
                "iamUserTip": "Caso tenha sido criado por uma conta do HUAWEI CLOUD, acesse como um usuário do IAM.",
                "registerFailed": "Falha no registro.",
                "recommended": "Recomendado",
                "strengthLow": "Fraco",
                "strengthMid": "Médio",
                "strengthHigh": "Forte",
                "accountNameBlank": "O nome da conta não pode ficar em branco.",
                "userNameBlank": "O nome de usuário não pode ficar em branco.",
                "pwdBlank": "A senha não pode ficar em branco.",
                "checkCodeBlank": "O código de verificação não pode ficar em branco.",
                "phoneBlank": "O número de celular não pode ficar em branco.",
                "checkCodeBlank4Intl": "Informe um código de verificação.",
                "backToHomepage": "Voltar a Página inicial",
                "backTo": "Voltar",
                "homepage": "Início",
                "mobileHome": "Página inicial",
                "isHwsUser": "Você está acessando o site internacional do HUAWEI CLOUD. Clique aqui para acessar o site chinês do HUAWEI CLOUD.",
                "isHongKongUser": "Você está acessando o site chinês do HUAWEI CLOUD. Clique aqui para acessar o site internacional do HUAWEI CLOUD.",
                "isRuUser": "Você está acessando o site internacional do HUAWEI CLOUD. Clique aqui para acessar o site internacional do HUAWEI CLOUD.",
                "isHwsUser1": "Você está acessando o site internacional do HUAWEI CLOUD. Clique ",
                "isHongKongUser1": "Você está acessando o site chinês do HUAWEI CLOUD. Clique ",
                "isRuUser1": "Você está acessando o site internacional do HUAWEI CLOUD. Clique ",
                "goLogin.hws": "aqui",
                "goLogin.hk": "aqui",
                "goLogin.ru": "aqui",
                "toLogin.hws": " para acessar o site chinês do HUAWEI CLOUD.",
                "toLogin.hk": " para acessar o site internacional do HUAWEI CLOUD.",
                "toLogin.ru": " para acessar o site internacional do HUAWEI CLOUD.",
                "language": "Inglês",
                "lanuage.hk": "Internacional",
                "lanuage.ch": "中国站",
                "lanuage.zh-cn": "简体中文",
                "lanuage.en-us": "Inglês",
                "titles.login": "Acesso ao HUAWEI CLOUD",
                "titles.resetPwd": "Redefinir senha do HUAWEI CLOUD",
                "titles.fpwd": "Senha esquecida do HUAWEI CLOUD",
                "titles.register": "Registro no HUAWEI CLOUD",
                "titles.agencyRegister": "Registro de agente no HUAWEI CLOUD",
                "titles.reactivate": "Reativação do HUAWEI CLOUD",
                "titles.registerSuccess": "Registro bem-sucedido no HUAWEI CLOUD",
                "titles.fphone": "Alteração de número de celular no HUAWEI CLOUD",
                "titles.loginVerification": "Verificação de acesso no HUAWEI CLOUD",
                "titles.bindAccount": "Primeiro acesso no HUAWEI CLOUD",
                "titles.bindAccountSuccess": "Registro bem-sucedido no (registro e vinculação) HUAWEI CLOUD",
                "registerFree": "Registre sua conta do HUAWEI CLOUD",
                "freeRegister": "Registro gratuito",
                "createDomain": "Criar conta",
                "createDomainBtn": "Criar e vincular",
                "createSubUser": "Criar conta de subusuário",
                "createFailed": "Falha ao criar a conta.",
                "bindDomain": "Vincular conta",
                "createDomainLink": "Criar conta",
                "bindDomainLink": "Vincular conta",
                "bindFailed": "Falha ao vincular a conta.",
                "bindRepeat": "Sua conta foi vinculada a outro parceiro. Não a vincule novamente.",
                "createDomain.remindCompleteInfo": "Informe os dados a seguir para criar e vincular uma conta do HUAWEI CLOUD. Já tem uma conta?",
                "bindDomain.remindCompleteInfo": "Informe os dados a seguir para criar e vincular uma conta do HUAWEI CLOUD. Ainda não tem uma conta?",
                "createSubUserInfo": "Informe os dados a seguir para criar e vincular uma conta de subusuário do HUAWEI CLOUD.",
                "enterpriseUser": "Acesso de usuário do IAM",
                "enterpriseUserLogin": "Acesso de usuário do IAM",
                "personageUser": "Acesso de conta",
                "enterpriseUser4Intl": "Acesso de usuário do IAM (Internacional)",
                "personageUser4Intl": "Acesso de conta (Internacional)",
                "accountPlaceHolder": "Nome da conta",
                "HongKongAccountPlaceHolder": "Nome da conta",
                "domainPlaceHolder": "ID/nome do agente",
                "roleNamePlaceHolder": "Nome do agente",
                "failedToswitchRole": "Falha na troca de agente.",
                "switchSubmit": "Mudar de função",
                "agencyDesc": "A senha e a ID do usuário podem ser utilizadas para gerenciar recursos de várias contas. Depois que um administrador do HUAWEI CLOUD configurar os papéis para você e fornecer os dados da conta e do papel, você poderá trocar de papel.",
                "userNamePlaceHolder": "Nome de usuário do IAM, e-mail, número de celular",
                "HongKongUserNamePlaceHolder": "Nome de usuário do IAM ou e-mail",
                "accountNamePlaceHolder": "Nome da conta, e-mail ou número de celular",
                "HongKongAccountNamePlaceHolder": "Nome da conta ou e-mail",
                "accountTip": "Conta",
                "passwdPlaceHolder": "Senha",
                "iamPasswdPlaceHolder": "IAM user password", //TODO: 翻译
                "verifyCodePlaceHolder": "Código CAPTCHA",
                "GraphicsVerifyCodeLabel": "Código de verificação:,    ",
                "GraphicsVerifyCode": "Verificação de segurança",
                "InputGrapVerifyCodeInfo": "Para garantir a segurança da conta, informe o código que aparece na imagem a seguir.",
                "GrapVerifyCodeFailed": "O código de verificação está incorreto ou expirou. Tente novamente.",
                "getVerifyCode": "Obtenha outro código de verificação.",
                "loginSubmit": "Acesso",
                "logining": "Acessando...",
                "mobileNumberLogin": "Número de celular",
                "noMobileLogin": "Nome da conta ou e-mail",
                "userNameMobliePH": "Número de celular",
                "rememberName": " Lembrar de mim",
                "rememberLogin": " Lembrar de mim",
                "rememberName4Intl": " Lembrar de mim",
                "forgetPwd": "Esqueceu a senha?",
                "emaiNamePwd": "Endereço de e-mail incorreto.",
                "phoneNamePwd": "Número de celular incorreto.",
                "domainNamePwd": "Nome de usuário incorreto.",
                "wrongNamePwd": "Senha incorreta.",
                "wrongNamePwd4Intl": "Nome de usuário ou endereço e-mail incorreto.",
                //TODO: 翻译
                "learnMore": "Learn more",
                "iamAccountTip": "The account used to create an IAM user in IAM. ",
                "iamUsernameTip": "An IAM user created using the account in IAM. ",
                "iamAccountTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
                "iamUsernameTipHelp": "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

                "wrongIPBlacklist": "O dispositivo usado para acessar não é seguro. Use outro dispositivo.",
                "wrongIPFrequencyLimiting": "O número de tentativas de acesso incorretas provenientes do mesmo endereço IP atingiu o limite máximo. Tente novamente mais tarde.",
                "wrongEquipmentIDFrequencyLimiting": "O número de tentativas de acesso incorretas provenientes do mesmo dispositivo atingiu o limite máximo. Tente novamente mais tarde ou use outro dispositivo para acessar.",
                "MachineOperation": "O dispositivo usado para acessar não é seguro. Use outro dispositivo.",
                "emaiNamePwdChances": "Endereço de e-mail incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
                "phoneNamePwdChances": "Número de celular incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
                "domainNamePwdChances": "Nome de usuário incorreto. Você precisará acessar novamente após mais {0} tentativas incorretas.",
                "wrongNamePwdChances": "Senha incorreta. Você precisará acessar novamente após mais {0} tentativas incorretas.",
                "wrongNamePwdFourChances": "Informações de autenticação incorretas. Depois de mais 4 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "wrongNamePwdThreeChances": "Informações de autenticação incorretas. Depois de mais 3 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "wrongNamePwdTwoChances": "Informações de autenticação incorretas. Depois de mais 2 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "wrongNamePwdoneChances": "Informações de autenticação incorretas. Depois de mais 1 tentativa incorreta, o acesso será desabilitado por 15 minutos.",
                "wrongNamePwdFourChances4Intl": "Senha incorreta. Você tem mais 4 tentativas antes do bloqueio de 15 minutos.",
                "wrongNamePwdThreeChances4Intl": "Senha incorreta. Você tem mais 3 tentativas antes do bloqueio de 15 minutos.",
                "wrongNamePwdTwoChances4Intl": "Senha incorreta. Você tem mais 2 tentativas antes do bloqueio de 15 minutos.",
                "wrongNamePwdoneChances4Intl": "Senha incorreta. Você tem mais 1 tentativa antes do bloqueio de 15 minutos.",
                "userAccountsLocked": "Você informou a senha ou o nome de usuário incorreto 5 vezes. O nome de usuário será bloqueado por 15 minutos.",
                "userAccountsStopped": "O usuário foi desativado. Entre em contato com o administrador.",
                "domainAccountsStopped": "O usuário foi desativado.",
                "clientIpInvalid": "Você não tem permissão para acessar deste terminal. ",
                userNotExist: "The user does not exist. Contact the administrator. ",
                "clientIpInvalid.learnMore": "Learn more",
                "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
                "notAllowFpwd": "Você não tem permissão para procurar sua senha deste terminal.",
                "warning": "Aviso",
                "systemException": "O sistema está ocupado. Atualize a página e tente novamente.",
                "freqLocked": "Você excedeu o número máximo de tentativas permitido. Tente novamente mais tarde.",
                "wrongVerifyCode": "O código de verificação está incorreto ou expirou.",
                "invalidInput": "Valor inválido para o parâmetro.",
                serviceUrlInvalid: "Login failed. <a href='/'>Try again</a>. ",
                "maxSessionLimit": "O número de sessões de usuário on-line ao mesmo tempo excede o limite do sistema.",
                "multiUserInvalid": "Você acessou neste terminal. Saia e tente novamente.",
                "pageTimeout": "The operation timed out. Refresh the page and try again.",
                "accountClosed": "A conta está sendo fechada.",
                "invalidInputFourChances": "Parâmetro incorreto. Depois de mais 4 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "invalidInputThreeChances": "Parâmetro incorreto. Depois de mais 3 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "invalidInputTwoChances": "Parâmetro incorreto. Depois de mais 2 tentativas incorretas, o acesso será desabilitado por 15 minutos.",
                "invalidInputoneChances": "Parâmetro incorreto. Depois de mais 1 tentativa incorreta, o acesso será desabilitado por 15 minutos.",
                "loginReactivateFail": "A conta não foi ativada. O e-mail de ativação não pode ser enviado para essa conta. Tente novamente.",
                "pwdSame": "A nova senha não pode ser igual à senha antiga.",
                "initialPwdSame": "A nova senha não pode ser igual à senha inicial.",
                "historyPwdSame": "A nova senha não pode ser igual a uma senha antiga.",
                "copyrightNotice1": "© {0}, Copyright by HUAWEI CLOUD. All rights reserved. ",
                "copyrightNotice1_hk": "Copyright©{0} Huawei Services (Hong Kong) Co., Ltd.",
                "copyrightNotice2": "Todos os direitos reservados.",
                "copyrightNotice3": "Jiangsu licença ICP 09062682 número 13",
                "copyrightNotice4": "Jiangsu número B2-20130048",
                "copyrightNotice5": "Jiangsu licença de rede pública número 32011402010636",
                "legalNotice": "Aviso legal",
                "legalStatement": "Aviso legal",
                "siteTerms": "Site Terms",
                "privacyProtect": "Declaração de Privacidade",
                "privacyStrategyStatement": "Declaração de Privacidade",
                "reportAbuse": "Reportar abuso",
                "sa_nisr": "Política de Uso Aceitável",
                "sa_nisr_intl": "Política de Uso Aceitável",
                "sa_cua": "Contrato do Cliente do HUAWEI CLOUD",
                "sa_cua_intl": "Contrato do Cliente do HUAWEI CLOUD",
                "enterpriseSwitchTip": "Este modo de acesso aplica-se a usuários empresariais, ou seja, usuários criados por um administrador empresarial.",
                "personalSwitchTip": " Este modo de acesso aplica-se ao usuário empresarial, ou seja, o usuário criado durante o registro.",
                "usingOtherWaysLogin": "Usar outra conta para acessar",
                "otherWaysLogin": "Acesso de outra conta",
                "HWSdeveloper": "Aliança de Desenvolvedores da Huawei",
                "hwportal": "Site oficial da Huawei",
                "HWICTdeveloper": "Desenvolvedor de TIC da Huawei",
                "WeLink": "WeLink",
                "readAgree": "Li e concordo com ",
                "hwCloudAgreement": "Contrato do Cliente do HUAWEI CLOUD",
                "secretprotect": "Declaração de Privacidade",
                "hwCloudAgreementMobile": "Contrato do Cliente do HUAWEI CLOUD",
                "secretprotectMobile": " Declaração de Privacidade",
                "companyUserRegistration": "Registrar funcionário da empresa",
                "personalUserRegistration": "Registrar usuário",
                "companyAccountName": "Nome de usuário:",
                "userName": "Nome de usuário: ",
                "registerMail": "Endereço de e-mail:",
                "congratulationsSucceed": "Registro bem-sucedido.",
                "password": "Senha:",
                "registerMailStep3": "E-mail:",
                "passwordPlaceHolder": "Digite a senha.",
                "confirmPassword": "Confirmar senha: ",
                "confirmPasswordPlaceHolder": "Informe a senha novamente.",
                "companyName": "Empresa:",
                "contact": "Contato:",
                "phoneNum": "Número de telefone móvel: ",
                "phonePlaceHolder": "Informe o número de celular.",
                "msgCode": "Código de verificação SMS: ",
                "msgCodeTxt": "Enviar código",
                "msgPHTxt": "Código de verificação",
                "msgCodeTxtWait": "Re-enviar código ({0}s)",
                "msgCodeWrong": "O código de verificação por SMS está incorreto.",
                "region": "Região: ",
                "register.submit": "Registrar",
                "register.finish": "Concluir",
                "submit": "Avançar",
                "innerKeyWord": "As palavras-chave do sistema não são permitidas no início.",
                "accountNamePH": "Digite o nome do usuário.",
                "emailPH": "Informe seu endereço de e-mail.",
                "companyNamePH": "Informe o nome da sua empresa.",
                "mobileCompanyName": "(Opcional) Informe o nome da sua empresa.",
                "registerSuccess": "Registro bem-sucedido.",
                "pleaseCompleteInfo": "Para melhorar a segurança da conta, complete as informações da sua empresa.",
                "complete": "Complete",
                "companyInfo": "perfil da empresa",
                "rejectAndBack": "Voltar para",
                "homePage": "página inicial",
                "period": ".",
                "goTo": " Ir para",
                "myCredential": "Minhas credenciais",
                "completeUserInfo": "Completar informações pessoais.",
                "fpwd.findPasswd": "Restaurar senha",
                "fpwd.enterpriseName": "Nome da conta:",
                "fpwd.accountName": "Endereço de e-mail ou número de celular:",
                "fpwd.SMSVerifyCode": "Informe o código de verificação por SMS.",
                "fpwd.emailVerifyCode": "Informe o código de verificação do e-mail.",
                "fpwd.getCode": "Enviar código",
                "fpwd.confirmAccount": "Confirmar conta",
                "fpwd.resetPwd": "Restaurar senha",
                "fpwd.resetSuccess": "Concluir",
                "fpwd.findSuccess": "Senha reiniciada com sucesso.",
                "fpwd.newPasswd": "Nova senha:",
                "fpwd.confirmPasswd": "Confirmar senha:",
                "fpwd.enterpriseNamePH": "Informe o nome de conta.",
                "fpwd.accountNamePH": "Informe um endereço de e-mail ou número de telefone móvel.",
                "fpwd.verifyCodePH": "Informe o código.",
                "fpwd.confirmPasswdPH": "Informe a nova senha mais uma vez.",
                "fpwd.newPasswdPH": "Informe uma nova senha.",
                "fpwd.newPasswdPHApp": "Nova senha",
                "fpwd.nextStepBtn": "Avançar",
                "fpwd.backTo": "Voltar",
                "fpwd.titleDetail": "Informe as informações da conta.",
                "fpwd.titleIAMDetail": "Informe as informações do usuário do IAM.",
                "fpwd.multiUsersTip": "O número de celular está vinculado a várias contas. Selecione a conta para a qual você deseja redefinir a senha.",
                "fpwd.accountConfirm": "Verificação da conta",
                "fpwd.personalAccount": "Conta",
                "fpwd.IAMAccount": "Usuário do IAM",
                "fpwd.typePersonalTip": "Uma conta criada quando você se registrou no HUAWEI CLOUD usando um número de celular.",
                "fpwd.typeIAMTip": "Um usuário criado usando a conta do IAM.",
                "fpwd.accountOrEmailPH": "Nome da conta ou endereço de e-mail",
                "fpwd.IAMAccountPH": "Nome da conta do administrador",
                "fpwd.IAMAccountNamePH": "Nome de usuário do IAM, e-mail, número de celular",
                "fpwd.IAMAccountNamePHNew": "Nome de usuário do IAM, e-mail",
                "fpwd.identityVerification": "Verificação de identidade",
                "fpwd.identityVerificationDec": "Selecione um método de verificação de identidade.",
                "fpwd.passwordReset": "Restaurar senha",
                "fpwd.passwordResetDesc": "Defina uma nova senha.",
                "fpwd.step1.fpwdByPhone": "Use o número de celular",
                "fpwd.step1.fpwdByemail": "Use o nome da conta ou endereço de e-mail",
                "fpwd.step1.phoneAccountNamePH": "Número de celular",
                "fpwd.step2.verificationCodePH": "Informe o código de verificação.",
                "fpwd.step2.sendVerificationCode": "Enviar código",
                "fpwd.step2.unbindDesc": "Sua identidade não pode ser verificada porque nenhum endereço de e-mail ou número de celular foi vinculado à sua conta.",
                "fpwd.step2.unbindIAMDesc": "Sua identidade não pode ser verificada porque nenhum endereço de e-mail ou número de celular foi vinculado ao usuário do IAM.",
                "fpwd.step2.exceptionService": "If your mobile number or email address is unavailable, request the administrator to reset your password.",
                "fpwd.step2.sendEmailCode": "Endereço de e-mail ({0})",
                "fpwd.step2.sendMobileCode": "Número de celular ({0})",
                "fpwd.step2.unabledMethod": "Nenhum dos acima",
                "fpwd.step2.helpMsg": "Entre em contato com o atendimento ao cliente para receber ajuda.",
                "fpwd.step2.helpTel1": "China continental: +86 4000-955-988",
                "fpwd.step2.helpTel2": "Hong Kong, China: +852 800 931 122",
                "fpwd.retrieveTxt": "Re-enviar código ({0}s)",
                "fpwd.step3.showPwdTip": "Mostrar",
                "fpwd.step3.hidePwdTip": "Ocultar",
                "fpwd.goToLogin": "Acesso",
                "fpwd.successTxt": "Senha reiniciada com sucesso",
                "fpwd.loginCountdownTxt": "Você será redirecionado para a página de acesso em {0} s.",
                "domainuserAccountsLocked": "O endereço de e-mail da conta do usuário não foi ativada. Conclua a ativação clicando no link que foi enviado para seu e-mail.",
                "fpwd.sendCodeFailed": "O sistema está ocupado. Falha ao obter o código de verificação.",
                "fpwd.getCodeFail": "Você recebeu códigos de verificação 5 vezes. Tente novamente no próximo dia.",
                "wrong_sendCodeFailed": "Falha ao obter o código de verificação. Obtenha outro código de verificação.",
                "fpwd.invalidVerifyCode": "O código de verificação está incorreto. Tente novamente.",
                "fpwd.setPasswdFailed": "Falha ao definir a nova senha devido a uma exceção do servidor. Tente novamente.",
                "fpwd.ipLocked": "O endereço IP foi bloqueado.",
                "fpwd.MultipleIAMUserNameByMobile": "Use o e-mail para recuperar a senha, porque o número de celular está vinculado a vários usuários do IAM.",
                "fpwd.MultipleAccountNameByMobile": "Você precisa informar um nome de conta, porque o número de celular está vinculado a várias contas.",
                "fpwd.MultipleAccountNameByMobileError": "Não foi possível recuperar a senha usando esse número de celular, porque ele está vinculado a várias contas. Tente novamente usando o número em um computador ou com o endereço de e-mail para recuperar a senha pelo celular.",
                "fpwd.MultipleAccountsByMobileReminder": "O nome da conta precisa ser informado caso várias contas estejam usando o mesmo número de celular.",
                "fpwd.EnterCorrectEnterpriseAccount": "Informe um nome de conta que tenha sido registrado no HUAWEI CLOUD.",
                "fpwd.EnterCorrectMobile": "Informe um número de celular que tenha sido registrado no HUAWEI CLOUD.",
                "fpwd.EnterCorrectEnterpriseAccountAndMobile": "Informe um nome de conta ou número de celular que tenha sido registrado no HUAWEI CLOUD.",
                "fpwd.EnterCorrectEmail": "Informe um endereço de e-mail que tenha sido registrado no HUAWEI CLOUD.",
                "fpwd.EnterCorrectEnterpriseAccountAndEmail": "Informe um nome de conta e um endereço de e-mail corretos.",
                "fpwd.EnterCorrectEnterpriseVerificationCode": "Informe o código de verificação correto.",
                "operationTooFrequent": "As operações foram feitas frequentemente demais. Tente novamente mais tarde.",
                "fpwd.contactService": "Observação: Caso você não consiga acessar o celular ou o e-mail registrado, entre em contato com o Atendimento ao Cliente em {0} para receber ajuda., //4000-955-988, +7（495）800 1 800",
                "fpwd.contactHKService": "Observação: Caso você não tenha acesso ao e-mail registrado, entre em contato com o Atendimento ao Cliente em {0} para receber ajuda.",
                "fpwd.ErrorRegionAccount": "Insira uma conta válida da HUAWEI CLOUD.",
                "countryCodeSelect": "Selecione o código do país.",
                "bindPhone": "Número de celular:",
                "bindPhoneNum": "Número de celular:",
                "alreadyHaveAccount": "",
                "login": "Acesso",
                "loginNow": "Acesso",
                "safetyDegree": "Nível de segurança da senha:",
                "handsRegisterInfo": "Para utilizar o Serviço de Nuvem PDA da Huawei, clique ",
                "hansRegistration": "Registrar.",
                "filloutRegisterInfo": "Configurar informação de registro",
                "checkAccountInfo": "Adicionar informação sobre a conta",
                "registerSucceed": "Concluir",
                "successAccoutInfo": "Suas contas são: ",
                "descriptionInfo": "Você pode utilizar uma das contas anteriores para acessar.",
                "linkFailed": "O link expirou.",
                "linkFailedDetail": "Sua conta foi ativada ou o tempo de ativação esgotou.",
                "linkFailedHelp": "Tente ",
                "linkFailedLogin": "Acesso",
                "serverTimeout": "O tempo do servidor esgotou. Tente novamente mais tarde.",
                "mainMsg": "O e-mail de ativação foi enviado para: ",
                "secondMsg": "Você tem 24 horas para clicar no link do e-mail e completar a ativação.",
                "checkEmail": "Abrir e-mail agora",
                "didNotGetEmail": "Não recebeu o e-mail?",
                "checkSpamMail": "1. Veja a Lixeira.",
                "stillDidNotGetEmail": "2. Se ainda não recebeu o e-mail, ",
                "resendEmail": "envie o e-mail novamente.",
                "alwaysDidNotGetEmail": "3. Se você nunca conseguiu receber o e-mail, ",
                "changeMailbox": "mude o endereço de e-mail.",
                "replaceEmailTip": "O endereço de e-mail pode ser mudado uma vez a cada 24 horas. Confirme seu endereço de e-mail com cuidado.",
                "sendNewEmail": "Enviar",
                "alreadySend": "E-mail de ativação enviado.",
                "sendFailed": "Falha ao enviar o e-mail.",
                "inputEmail": "Informe seu endereço de e-mail.",
                "email": "E-mail:",
                "countToHomepage": "Redirecionando para a página de acesso em {0} segundos.",
                "registerFailed.emailRepeat": "Endereço de e-mail registrado.",
                "registerFailed.nameRepeat": "Nome de usuário registrado.",
                "registerFailed.mobileRepeat": "O número de celular foi registrado.",
                "registerFailed.nameCannotBegin": "O nome não pode começar com um dígito ou um traço-baixo (_).",
                "registerFailed.nameCannotContain": "São permitidas apenas letras, dígitos, hifens (-) e traços-baixos (_).",
                "registerSuccess.backToHomepage": "1. ",
                "registerSuccess.returnHomepage": "Página inicial",
                "registerSuccess.backToHomepageLink": "Voltar para a página inicial do HUAWEI CLOUD.",
                "registerSuccess.backToHomepageLinkP1": "Voltar para",
                "registerSuccess.backToHomepageLinkP2": "a página inicial do HUAWEI CLOUD.",
                "registerSuccess.second": "2.",
                "registerSuccess.goToBss": "Acesse ",
                "registerSuccess.goToBssFillInfo": " para completar as informações de registro. Depois, você receberá periodicamente mensagens de atividade de desconto dos serviços do HUAWEI CLOUD.",
                "registerSuccess.bssAccountInfo": "Centro do Usuário",
                "registerSuccess.redirecting": "Redirecionando...",
                "registerSuccess.redirecting.back": "Voltando para a página original em {0} segundos.",
                "registerSuccess.autoClose": "Esta página será fechada em {0} segundos.",
                "registerSuccess.browserPreventClose": "A configuração do seu navegador não permite que o sistema feche páginas automaticamente.",
                "registerSuccess.homepage": "Início",
                "registerSuccess.userCenter": "Centro do Usuário",
                "registerSuccess.consoleHome": "Console de Gerenciamento",
                "registerSuccess.helpCenter": "Ajuda",
                "resetPwd.title": "Primeiro acesso",
                "resetPwd.titleDetail": "Para melhorar a segurança da conta, insira uma nova senha.",
                "resetPwd.phone": "Número de celular verificado:",
                "resetPwd.mailbox": "Endereço de e-mail verificado:",
                "resetPwd.byPhone": "Verificar por celular",
                "resetPwd.byMailbox": "Verificar de e-mail",
                "resetPwd.smsMsgCode": "Código de verificação SMS: ",
                "resetPwd.emailMsgCode": "Código de verificação por e-mail:",
                "resetPwd.getSmsMsgCode": "Enviar código",
                "resetPwd.getEmailMsgCode": "Enviar código",
                "resetPwd.retrieveMsgCode": "Re-enviar código ({0}s)",
                "resetPwd.resetFailed": "Falha ao alterar senha.",
                "resetPwd.oldPasswd": "Senha antiga:",
                "resetPwd.newPasswd": "Nova senha:",
                "resetPwd.apiKeyTitle": "Alterar senha de API",
                "resetPwd.apiKeyDetail": "Para melhorar a segurança da conta, insira uma nova senha de API.",
                "resetPwd.apkKey": "Senha antiga de API:",
                "resetPwd.confirmNewPasswd": "Confirmar senha:",
                "resetPwd.resetPwdFailed": "A senha antiga é incorreta. Tente novamente.",
                "resetPwd.resetCount": "A senha antiga é incorreta. Se mais {0} tentativas falharem, você terá que acessar de novo.",
                "resetPwd.getCodeFail": "Erro ao obter os códigos de verificação mais de 5 vezes. Tente novamente após 15 minutos.",
                "resetPwd.InitPasswd": "Senha inicial:",
                "resetPwd.InitPasswdError": "A senha inicial está incorreta. Tente novamente.",
                "resetPwd.InitPasswdCount": "A senha inicial está incorreta. Se mais {0} tentativas falharem, você terá que acessar de novo.",
                "modifyPwdIntervalTimeLessThanMinValidTime": "Para alterar a senha, é necessário que tenha passado um período maior ou igual ao tempo de uso mínimo da senha. Clique em Cancelar para entrar no sistema.",
                "pwdModifyTitle": "Alterar senha",
                "pwdExpiredTitle": "A senha expirou",
                "pwdExpiringDesc": "A senha expirará em {0} dias. Altere-a imediatamente.",
                "pwdExpiredDesc": "Sua senha expirou. Altere-a.",
                "noRight": "Permissões insuficientes. Entre em contato com o administrador para conceder permissões.",
                "browserSupport": "O HUAWEI CLOUD funciona melhor com os seguintes navegadores",
                "browserSupport.chrome": "Chrome",
                "browserSupport.chromeVersion": "(36.0 ou posterior)",
                "browserSupport.firefox": "FireFox",
                "browserSupport.firefoxVersion": "(35.0 ou posterior)",
                "browserSupport.ie": "Internet Explorer",
                "browserSupport.ieVersion": "(9.0 ou posterior)",
                "reactivate.reactivateAccount": "Ativar conta",
                "reactivate.pleaseCheckEmail": "Sua conta não foi ativada. Por favor, entre no endereço de e-mail registrado e clique sobre o link do e-mail de registro para ativar sua conta.",
                "advertisement.txt": "Grátis as primeiras 100 vezes",
                "advertisement.buttonTxt": "Aplicar",
                "fphone.changePhoneNum": "Alterar número de celular",
                "fphone.changeSuccess": "Concluir",
                "fphone.registerEmail": "Endereço de e-mail verificado:",
                "fphone.registerEmailPH": "Informe um endereço de e-mail.",
                "fphone.emailVerifyCode": "Código de verificação por e-mail:",
                "fphone.getVerifyCodeByEmail": "Obter código de verificação por e-mail",
                "fphone.emailVerifyCodePH": "Informe o código.",
                "fphone.newPhoneNum": "Novo número de celular:",
                "fphone.newPhoneNumPH": "Informe um novo número de celular.",
                "fphone.smsVerifyCode": "Código de verificação por SMS:",
                "fphone.getVerifyCodeBySms": "Obter código de verificação por SMS",
                "fphone.smsVerifyCodePH": "Informe o código.",
                "fphone.changePhoneSuccess": "O número de celular foi alterado com sucesso.",
                "fphone.newPhoneNumInfo": "Novo número de celular:",
                "fphone.phoneRepeat": "O número de celular já existe.",
                "fphone.exceedMaxAccounts": "O número de contas vinculadas a esse número de celular atingiu o limite máximo permitido (6).",
                "mobileNumber": "celular:",
                "fphone.changeMobile": "Alterar número de celular",
                "sendSmsIntervalErr": "O número de tentativa para obter códigos de verificação excedeu o limite máximo. Tente novamente após 1 minuto.",
                "cookie.chromeDesc": "Selecione Configurações. Na página Configurações, clique em Mostrar configurações avançadas e selecione Configurações de conteúdo em Privacidade. Na caixa de diálogo Configurações de conteúdo, desmarque Bloquear cookie de terceiros e dados do site, selecione Permitir dados locais (recomendado) e clique em Concluir. Depois, reinicie o navegador e acesse novamente.",
                "cookie.firefoxDesc": "Clique em Opções e selecione Privacidade. Na página Privacidade, selecione Configurações personalizadas de histórico, desmarque Sempre usar o modo de navegação com privacidade, selecione Aceitar cookies de sites e clique em OK. Depois, reinicie o navegador e acesse novamente.",
                "cookie.ieDesc": "Selecione Ferramentas > Opções de Internet. Na caixa de diálogo Opções de Internet, clique na guia Privacidade. Na guia Privacidade, ajuste Bloquear todos os cookies para a opção mais baixa e clique em Salvar. Depois, reinicie o navegador e acesse novamente.",
                "cookie.chromeName": "Google Chrome:",
                "cookie.firefoxName": "Mozilla Firefox:",
                "cookie.ieName": "Internet Explorer:",
                "cookie.title": "Como eu ativo cookies no meu navegador?",
                "cookie.loginTip": "Acesse depois que os cookies estiverem ativados.",
                "cookie.startCookie": "Ativar cookies?",
                "verifyCode.intervalError": "Houve solicitações demais de códigos de verificação. Tente novamente após 1 minuto.",
                "verifyCode.invalid": "O código de verificação expirou. Clique em Enviar código para receber outro.",
                "verifyCode.error": "O código de verificação está incorreto. Tente novamente.",
                "verifyCode.locked": "Você excedeu o número máximo permitido de solicitações de código de verificação. Tente novamente no próximo dia.",
                "verifyCode.locked.custom": "Você excedeu o número máximo permitido de solicitações de código de verificação. Tente novamente após {0} minutos ou entre em contato com o atendimento ao cliente pelo telefone 4000-955-988.",
                "verifyCode.sendFailed": "Houve uma falha no envio do código de verificação. Obtenha outro.",
                "verifyCode.remainderCount": "Você tem {0} tentativas de verificação restando. Caso as tentativas restantes não sejam bem-sucedidas, um novo código de verificação só poderá ser gerado após um período específico.",
                "verifyCode.cantAcquire": "A função de solicitação de código de verificação foi bloqueada. Informe o último código de verificação obtido.",
                "verifyCode.emailInvalidAndSMSError": "O código de verificação por SMS está incorreto. Tente novamente com um código de verificação por e-mail válido.",
                "verifyCode.email.invalid": "O código de verificação por e-mail expirou. Obtenha outro.",
                "verifyCode.email.error": "O código de verificação por e-mail está incorreto. Tente novamente.",
                "verifyCode.sms.invalid": "O código de verificação por SMS expirou. Obtenha outro.",
                "verifyCode.sms.error": "O código de verificação por SMS está incorreto. Tente novamente.",
                "verifyCode.usernameRepeat": "O nome de usuário já existe. Informe outro.",
                "verifyCode.maxmiumSubUserNum": "O número de usuários atingiu o limite máximo.",
                "verifyCode.emailExist": "O endereço de e-mail já existe. Informe outro.",
                "loginVerification": "Verificação de acesso",
                "loginVerification.tips": "If you do not want the custom information to be displayed during login, contact the administrator."
        }, _defineProperty(_framework, "titles.loginVerification", "Verificação de acesso à nuvem"), _defineProperty(_framework, "loginVerification.presetLoginInfo", "Informações de acesso predefinidas"), _defineProperty(_framework, "loginVerification.warningInfo", "Se as informações exibidas são inconsistentes com as suas informações de acesso predefinidas, cancele o acesso."), _defineProperty(_framework, "loginVerification.checkBySMS", "Verificação por SMS"), _defineProperty(_framework, "loginVerification.SMSHasSentTo", "(O código de verificação por SMS foi enviado para o seu celular)"), _defineProperty(_framework, "loginVerification.pleaseClickAgain", "(Se você não o receber em 60s, clique em Enviar o código novamente.)"), _defineProperty(_framework, "loginVerification.userLoginInfo", "Informações de acesso"), _defineProperty(_framework, "loginVerification.lastSuccessTime", "Último acesso bem-sucedido"), _defineProperty(_framework, "loginVerification.lastFailedTime", "Último acesso com falha"), _defineProperty(_framework, "loginVerification.failedTimes", "Tentativas consecutivas de acesso com falha"), _defineProperty(_framework, "loginVerification.lockInfo", "Após {0} tentativas incorretas consecutivas, o usuário atual ficará bloqueado durante {1} minutos."), _defineProperty(_framework, "loginVerification.MFATitle", "Autenticação de acesso por MFA virtual"), _defineProperty(_framework, "loginVerification.MFAContext", "Informe o código de verificação de 6 dígitos gerado no aplicativo Authenticator., "), _defineProperty(_framework, "loginVerification.MFAHelp", "Descubra como conseguir o código de autenticação."), _defineProperty(_framework, "loginVerification.MFALabel", "Código de autenticação MFA"), _defineProperty(_framework, "loginVerification.MFANotUseTip", "O dispositivo de MFA virtual está indisponível?"), _defineProperty(_framework, "loginVerification.MFANotUseMessage1", "Entre em contato com o administrador do HUAWEI CLOUD da empresa para redefinir o dispositivo de MFA virtual."), _defineProperty(_framework, "loginVerification.MFANotUseMessage2", "Entre em contato com o atendimento ao cliente do HUAWEI CLOUD."), _defineProperty(_framework, "loginVerification.resetMFAHelpUrl", "<a href='{0}' target='_blank' rel='noopener noreferrer'>Learn how</a> to unbind or remove a virtual MFA device."), _defineProperty(_framework, "loginVerification.rememberMFALabel", "Remember me for 7 days"), _defineProperty(_framework, "loginVerification.rememberMFALabel.disabledTip", "Limited to 5 IAM users per browser. "), _defineProperty(_framework, "loginVerification.emailCheckTitle", "Autenticação de acesso por e-mail"), _defineProperty(_framework, "loginVerification.emailCheckContent", "(Um código de autenticação foi enviado para {0}.)"), _defineProperty(_framework, "loginVerification.emailCodeLabel", "Código de verificação por e-mail"), _defineProperty(_framework, "loginVerification.emailCodeTxt", "Enviar código"), _defineProperty(_framework, "loginVerification.verificationType", "Método de autenticação"), _defineProperty(_framework, "loginVerification.verificationTypeForPhone", "绑定手机号与验证方式"), _defineProperty(_framework, "loginVerification.verificationTypeForEmail", "绑定邮件地址与验证方式"), _defineProperty(_framework, "loginVerification.bindPhone", "Número de celular"), _defineProperty(_framework, "loginVerification.bindPhoneTips", "O administrador ativou a autenticação por celular. Por favor, informe um número de celular."), _defineProperty(_framework, "loginVerification.bindPhonePH", "Informe um número de celular."), _defineProperty(_framework, "loginVerification.bindEmail", "Endereço de e-mail"), _defineProperty(_framework, "loginVerification.bindEmailTips", "O administrador ativou a autenticação por e-mail. Por favor, informe um endereço de e-mail."), _defineProperty(_framework, "loginVerification.bindEmailPH", "Informe um endereço de e-mail."), _defineProperty(_framework, "loginVerification.verifyCode", "Código de verificação"), _defineProperty(_framework, "loginVerification.verifyCodeBtnTxt", "Enviar código"), _defineProperty(_framework, "loginVerification.verifyCodePH", "Código de 6 dígitos"), _defineProperty(_framework, "loginVerification.verifyCodeEmailPH", "Código de 6 dígitos"), _defineProperty(_framework, "loginVerification.sendCodeTxt", "O código de verificação foi enviado. Para garantir a segurança da conta, não o compartilhe com ninguém."), _defineProperty(_framework, "loginVerification.sendCodeFailed", "Houve uma falha ao enviar o código de verificação porque o sistema está ocupado."), _defineProperty(_framework, "loginVerification.validEmailOrPhone", "Informe um endereço de e-mail válido ou um número de celular."), _defineProperty(_framework, "loginVerification.retrieveTxt", "Re-enviar código ({0}s)"), _defineProperty(_framework, "loginVerification.otherAccount", "Usar outra conta"), _defineProperty(_framework, "loginVerification.goOnLogin", "OK"), _defineProperty(_framework, "loginVerification.title", "Vincular dispositivo de MFA virtual"), _defineProperty(_framework, "loginVerification.firstStep", "Etapa 1: Fazer o download e instalar o aplicativo Authenticator no seu celular."), _defineProperty(_framework, "loginVerification.firstStepIntroduction", "The authenticator app will prompt you to add your account."), _defineProperty(_framework, "loginVerification.secondStep", "Etapa 2: Configurar o aplicativo Authenticator."), _defineProperty(_framework, "loginVerification.secondStepIntroduction", "Abra o aplicativo Authenticator no seu smartphone. Escaneie o código QR ou informe a chave secreta a seguir no aplicativo para obter códigos de autenticação de seis dígitos."), _defineProperty(_framework, "loginVerification.username", "Nome de usuário"), _defineProperty(_framework, "loginVerification.domainname", "Nome da conta"), _defineProperty(_framework, "loginVerification.secretKey", "Chave secreta"), _defineProperty(_framework, "loginVerification.thirdStep", "Etapa 3: Informe os códigos de verificação."), _defineProperty(_framework, "loginVerification.thirdStepIntroduction", "Use o Authenticator para gerar dois códigos de autenticação consecutivos e informe-os aqui."), _defineProperty(_framework, "loginVerification.firstRegCode", "Código de autenticação 1"), _defineProperty(_framework, "loginVerification.secondRegCode", "Código de autenticação 2"), _defineProperty(_framework, "loginVerification.submitText", "OK"), _defineProperty(_framework, "loginVerification.bindMFASucceed", "Dispositivo de MFA virtual vinculado com sucesso."), _defineProperty(_framework, "loginVerification.mfaCodeError", "Código de verificação MFA incorreto. Informe outro código."), _defineProperty(_framework, "loginVerification.mfaCodeLocked", "Você tentou muitas vezes em um curto espaço de tempo. Tente novamente depois de 5 minutos."), _defineProperty(_framework, "bindAccount.title", "Vincular conta do HUAWEI CLOUD"), _defineProperty(_framework, "bindAccount.submit", "Registrar e vincular"), _defineProperty(_framework, "registerGiftSuffixMobile", "Itens populares"), _defineProperty(_framework, "bindAccount.remindCompleteInfo", "Informe os dados a seguir para registrar e vincular uma conta do HUAWEI CLOUD."), _defineProperty(_framework, "bindAccount.bindSuccess", " Registro concluído com sucesso. Você vinculou a conta do HUAWEI CLOUD."), _defineProperty(_framework, "bindAccount.HWSAccount", "Sua conta do HUAWEI CLOUD:"), _defineProperty(_framework, "bindAccount.timeRemind", "Após {0} segundos"), _defineProperty(_framework, "bindAccount.redirectPage", "Voltar para a página original"), _defineProperty(_framework, "validCountryCode", "Selecione um código de país válido."), _defineProperty(_framework, "registerGift", "Caso o registro tenha sido bem-sucedido, você pode usar cupons de dinheiro."), _defineProperty(_framework, "registerGiftAddress", "Usar cupons de dinheiro"), _defineProperty(_framework, "registerSuccess.goToGift", "Ir para "), _defineProperty(_framework, "registerSuccess.goToGiftFillInfo", " para usar cupons especiais de dinheiro para novos usuários."), _defineProperty(_framework, "usercompanyAccount", "Estas são as informações da sua conta:"), _defineProperty(_framework, "welcomeLogin.titleDetail", "Para a segurança da sua conta, defina uma senha."), _defineProperty(_framework, "welcomeEmail.title", "E-mail de boas-vindas"), _defineProperty(_framework, "welcomeEmail.linkTimeout", "Desculpe, sua conexão não é válida porque o tempo esgotou."), _defineProperty(_framework, "welcomeEmail.linkExpired", "Desculpe, sua conexão não está disponível."), _defineProperty(_framework, "welcomeEmail.resendEmail", "Clique aqui para enviar um novo e-mail de boas-vindas."), _defineProperty(_framework, "welcomeEmail.contactAdm", "Entre em contato com o administrador para enviar um novo e-mail de boas-vindas."), _defineProperty(_framework, "welcomeEmail.alreadySend", "Foi enviado um e-mail de boas-vindas."), _defineProperty(_framework, "titles.setPassword", "Senha definida do HUAWEI CLOUD"), _defineProperty(_framework, "titles.welcomeEmail", "E-mail de boas-vindas do HUAWEI CLOUD"), _defineProperty(_framework, "welcomeEmail.setPassword", "Definir senha"), _defineProperty(_framework, "dateFormate", "M/d/a HH:mm:ss"), _defineProperty(_framework, "sessionExpired", "Sua sessão expirou. Acesse novamente."), _defineProperty(_framework, "m.userNamePlaceHolder", "Nome de usuário/E-mail/Número de celular"), _defineProperty(_framework, "m.HongKongUserNamePlaceHolder", "Nome de usuário/E-mail"), _defineProperty(_framework, "m.accountNamePlaceHolder", "Nome de usuário/E-mail"), _defineProperty(_framework, "m.HongKongAccountNamePlaceHolder", "Nome de usuário/E-mail"), _defineProperty(_framework, "m.verifyCodePlaceHolder", "Verifique o código"), _defineProperty(_framework, "inValidCountryCode", "Selecione um código de país válido."), _defineProperty(_framework, "mobile.CountryCode", "+86 (China)"), _defineProperty(_framework, "authenticationInfo", "Algumas funções estão indisponíveis para usuários sem autenticação com nome verdadeiro."), _defineProperty(_framework, "authenticationForwardInfo", "Complete a autenticação com nome verdadeiro para ter uma experiência melhor de serviço."), _defineProperty(_framework, "authenticationForward", "autenticação com nome verdadeiro"), _defineProperty(_framework, "registerSuccess.goToAuthentication", "Você pode completar"), _defineProperty(_framework, "registerSuccess.authenticationInfo", "para ter uma avaliação grátis de 6 meses do pacote."), _defineProperty(_framework, "fpwd.findByEmail", "Redefinir senha usando o e-mail"), _defineProperty(_framework, "fpwd.findByPhone", "Redefinir senha usando o número de celular"), _defineProperty(_framework, "fpwd.accountNameByEmail", "E-mail registrado:"), _defineProperty(_framework, "fpwd.accountNameByPhone", "Número de celular registrado:"), _defineProperty(_framework, "fpwd.phoneAccountNamePH", "Informe um número de celular."), _defineProperty(_framework, "eChannelName", "Parceiro da Huawei Enterprise"), _defineProperty(_framework, "uniportalName", "Conta da Huawei"), _defineProperty(_framework, "moreLink", "Mais"), _defineProperty(_framework, "registerSuccess.authenticationForward", "Conclua a autenticação com nome verdadeiro"), _defineProperty(_framework, "homepageLink", "Início"), _defineProperty(_framework, "helpCenter", "Documentação"), _defineProperty(_framework, "cloudCommunity", "Comunidade da nuvem"), _defineProperty(_framework, "registerSuccess.goToUserZone", "Ir para "), _defineProperty(_framework, "registerSuccess.userZoneLink", "Nova zona de usuários"), _defineProperty(_framework, "registerSuccess.userZoneInfo", " para ter um desconto especial de 50% do pacote."), _defineProperty(_framework, "register.accountPlaceHolder", "Nome da conta"), _defineProperty(_framework, "register.passwordPlaceHolder", "Senha"), _defineProperty(_framework, "register.confirmPasswordPlaceHolder", "Confirmar senha"), _defineProperty(_framework, "register.phonePlaceHolder", "Número de celular"), _defineProperty(_framework, "register.msgCodePlaceHolder", "Código de verificação"), _defineProperty(_framework, "register.accountNameLength", "Informe de 5 a 32 caracteres."), _defineProperty(_framework, "register.bindACccountPlaceHolder", "Nome de domínio/Endereço de e-mail/Número de celular"), _defineProperty(_framework, "remindBindEmail.title", "Endereço de e-mail vinculado"), _defineProperty(_framework, "remindBindEmail.remindMsg", "Sua conta ainda não tem um endereço de e-mail vinculado. Vincular endereço de e-mail a:"), _defineProperty(_framework, "remindBindEmail.remindInfo1", "● Receber notificações quando os recursos da nuvem forem fornecidos, excluídos ou estiverem prestes a expirar."), _defineProperty(_framework, "remindBindEmail.remindInfo2", "● Verificar sua identidade quando estiver prestes a realizar operações importantes, como alteração de número de celular, redefinição de senhas e exclusão de ECSs."), _defineProperty(_framework, "remindBindEmail.bind", "Vincular agora"), _defineProperty(_framework, "remindBindEmail.nextBind", "Vincular mais tarde"), _defineProperty(_framework, "remindBindEmail.remind", "Informações"), _defineProperty(_framework, "remindBindEmail.remindHideInfo", "Vincule um endereço de e-mail em uma nova página."), _defineProperty(_framework, "remindBindEmail.remindHideFailde", "Se a vinculação não funcionar, tente novamente para "), _defineProperty(_framework, "remindBindEmail.remindHideFailde2", "vincular outro endereço de e-mail."), _defineProperty(_framework, "remindBindEmail.remindHideSuccess", "Vinculação concluída"), _defineProperty(_framework, "notify.openPage", "Please wait..."), _defineProperty(_framework, "notify.closeSecondBefore", "Operation Successful."), _defineProperty(_framework, "notify.closePage", "Operation successful. Please close the page"), _defineProperty(_framework, "registerFailed.accountNameRepeat", "O nome da conta foi registrado."), _defineProperty(_framework, "register.bindAccountPlaceHolder", "Nome da conta/Endereço de e-mail/Número de celular"), _defineProperty(_framework, "privacyPolicyUpdate", "Atualização da Declaração de Privacidade"), _defineProperty(_framework, "privacyTipPre", "Dear customer, we have updated the HUAWEI CLOUD Privacy Statement. We understand the importance of your privacy and are fully committed to protecting it. Please read the updated"), _defineProperty(_framework, "privacyTipSuf", "carefully to learn how we protect your personal data."), _defineProperty(_framework, "agreementBtnTxt", "Agree"), _defineProperty(_framework, "privacyAgreementNotAcceptedError", "Por favor, leia e concorde com a Declaração de Privacidade do HUAWEI CLOUD primeiro."), _defineProperty(_framework, "OIDC.errorDefault", "System error. Please contact the administrator."), _defineProperty(_framework, "OIDC.errorO001", "System error. Please try again."), _defineProperty(_framework, "OIDC.errorO002", "Invalid domain ID."), _defineProperty(_framework, "OIDC.errorO003", "Invalid identity provider ID."), _defineProperty(_framework, "OIDC.errorO004", "Invalid service URL."), _defineProperty(_framework, "OIDC.errorO005", "Cannot find the OpenID Connect configuration."), _defineProperty(_framework, "OIDC.errorO006", "Invaid OpenID configuration."), _defineProperty(_framework, "OIDC.errorO007", "Invalid ID Token."), _defineProperty(_framework, "OIDC.errorO008", "The State parameter is invalid."), _defineProperty(_framework, "OIDC.errorO009", "Invalid JWT."), _defineProperty(_framework, "OIDC.errorO010", "Acl check failed."), _defineProperty(_framework, "OIDC.errorO011", "Failed to obtain the IAM token based on the mapping rules. Check the mapping rules or contact the administrator."), _defineProperty(_framework, "OIDC.errorO012", "No reachable project to log in."), _defineProperty(_framework, "OIDC.errorO013", "Too many requests. Please try again later."), _defineProperty(_framework, "OIDC.errorO014", "Cannot access the console in the [program] access mode."), _defineProperty(_framework, "OIDC.errorO015", "Invalid error."), _defineProperty(_framework, "console_term_500Error_label", "The system is busy. Please try again later."), _defineProperty(_framework, "console_term_404Error_label", "Sorry! Failed to find the page."), _defineProperty(_framework, "console_term_401Error_label", "Sorry! The page has expired."), _defineProperty(_framework, "titles.loginReminder", "HUAWEI CLOUD – Login"), _defineProperty(_framework, "QRLogin.title1", "QR Login"), _defineProperty(_framework, "QRLogin.title2", "Log in to Huawei Cloud"), _defineProperty(_framework, "QRLogin.countDownTipPre1", "Please use the "), _defineProperty(_framework, "QRLogin.countDownTipPre2", "HUAWEI CLOUD APP"), _defineProperty(_framework, "QRLogin.countDownTipPre3", " to scan the QR code to log in "), _defineProperty(_framework, "QRLogin.remainingTime", "{0} seconds"), _defineProperty(_framework, "QRLogin.countDownTipSuffix", "QR code expires after "), _defineProperty(_framework, "QRLogin.QRCodeInvalid", "QR code has expired"), _defineProperty(_framework, "QRLogin.refresh", "refresh"), _defineProperty(_framework, "QRLogin.scanSuc", "Scan Successfully"), _defineProperty(_framework, "QRLogin.scanSucTip", "Please follow the prompts to confirm login on your phone"), _defineProperty(_framework, "QRLogin.loginFail", "Login Failed"), _defineProperty(_framework, "QRLogin.loginFailTipPre", "Please click "), _defineProperty(_framework, "QRLogin.loginFailTipSuffix", " and re-scan the QR code to log in"), _defineProperty(_framework, "QRLogin.downloadApp", "Download HUAWEI CLOUD App"), _defineProperty(_framework, "QRLogin.comma", ", "), _defineProperty(_framework, "QRLogin.loginReminder", "Login Reminder"), _defineProperty(_framework, "QRLogin.accountLogin", "Password Login"), _defineProperty(_framework, "hwId.cookieMsg", "Utilizamos cookies para melhorar o nosso site e a sua experiência de navegação. Ao continuar navegando em nosso site, você aceita a nossa política de cookies."), _defineProperty(_framework, "hwId.hwAccount", "HUAWEI ID"), _defineProperty(_framework, "hwId.privacyContent", "Durante o acesso, você concorda em fornecer à HUAWEI CLOUD as suas informações da conta e da rede para nos ajudar a oferecer uma experiência melhor. "), _defineProperty(_framework, "hwId.hwportal", "Conta do site oficial da Huawei"), _defineProperty(_framework, "hwId.eChannel", "Huawei Enterprise Partner"), _defineProperty(_framework, "hwId.casLogin.systemError", "Erro"), _defineProperty(_framework, "hwId.casLogin.systemErrorDesc", "Ocorreu um erro de sistema. Atualize a página ou entre em contato com o atendimento ao cliente por meio do seguinte endereço de e-mail: clientes@huaweicloud.com."), _defineProperty(_framework, "hwId.casLogin.accountError", "Erro"), _defineProperty(_framework, "hwId.casLogin.accountErrorDesc", "Sua conta não pode ser usada para acessar a HUAWEI CLOUD. Realize o acesso com outra conta."), _defineProperty(_framework, "hwId.casLogin.accountErrorLink", "Saiba mais"), _defineProperty(_framework, "hwId.casLogin.accountErrorUrl", "/en-us/iam_faq/iam_01_0006.html"), _defineProperty(_framework, "hwId.casLogin.loginError", "Erro"), _defineProperty(_framework, "hwId.casLogin.loginErrorDesc", "Você não pode usar sua conta para fazer login no HUAWEI CLOUD neste modo. Clique em HUAWEI ID Login e faça login."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorDesc", "Sua conta está registrada na Europa ou Rússia e, portanto, não pode ser usada para acessar a HUAWEI CLOUD. Realize o acesso usando uma conta registrada em outro país ou região."), _defineProperty(_framework, "hwId.casLogin.accountExternalErrorLink", "Saiba mais sobre a inviabilidade do acesso."), _defineProperty(_framework, "hwId.casLogin.accountTurkeyErrorLink", "Your current account is registered in [Turkey]. HUAWEI CLOUD does not support accounts in Turkey. Please <a href='{0}' target='_blank' rel='noopener noreferrer'>register for a HUAWEI CLOUD account</a> immediately, or log in with accounts in other region."), _defineProperty(_framework, "hwId.casLogin.inactivatedError", "Conta não ativada"), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc", "Sua conta não foi ativada. Ative sua conta dentro de 24 horas clicando no link de ativação que foi enviado para o endereço de e-mail vinculado a ela."), _defineProperty(_framework, "hwId.casLogin.inactivatedErrorDesc.noEmail", "Sua conta não pode ser usada para acessar os serviços da HUAWEI CLOUD, porque ela não foi ativada e não está vinculada a um endereço de e-mail. Realize o acesso com outra conta."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidError", "Serviços da HUAWEI CLOUD não ativados"), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc", "Os serviços da HUAWEI CLOUD não foram ativados para sua conta. Ative os serviços da HUAWEI CLOUD para sua conta dentro de 24 horas clicando no link de ativação que foi enviado para o endereço de e-mail vinculado a ela."), _defineProperty(_framework, "hwId.casLogin.inactivatedHwidErrorDesc.noEmail", "Você não pode usar os serviços da HUAWEI CLOUD, porque eles não foram habilitados para sua conta, e sua conta não está vinculada a um endereço de e-mail. Realize o acesso com outra conta."), _defineProperty(_framework, "hwId.casLogin.accessErrorDesc", "A HUAWEI CLOUD não pôde obter informações da sua conta. Realize o acesso usando outra conta."), _defineProperty(_framework, "hwId.refresh", "Atualizar"), _defineProperty(_framework, "hwId.cookies", "Cookies"), _defineProperty(_framework, "hwId.otherAccount", "Usar outra conta :"), _defineProperty(_framework, "hwId.otherAccount.h5", "Usar outra conta"), _defineProperty(_framework, "hwId.hwIdLogin", "Huawei Account Login"), _defineProperty(_framework, "hwId.accountPlaceHolder", "Nome do locatário ou nome da conta da HUAWEI CLOUD"), _defineProperty(_framework, "hwId.upgradeTitle", "Upgrade to HUAWEI ID and Get Access to All Huawei Services"), _defineProperty(_framework, 'hwId.upgradeDesc', 'You are logged in with a HUAWEI CLOUD account, which is just for HUAWEI CLOUD services. Upgrade your account to a HUAWEI ID to access the full range of Huawei services, including HUAWEI Developers, HUAWEI devices (such as HUAWEI Phones), Huawei Mobile Services (such as HUAWEI Mobile Cloud and HUAWEI Video). After upgrading, you\'ll be able to use your HUAWEI ID for all your HUAWEI CLOUD resources as well. '), _defineProperty(_framework, 'hwId.upgradeDescLink', 'Learn more'), _defineProperty(_framework, 'hwId.upgradeAgreements.pre', 'I understand that HUAWEI ID collects my account name, mobile number, email address, registration country/region, and login credentials, and I have read and agree to'), _defineProperty(_framework, "hwId.upgradeAgreements.userAgreement", "Contrato de Usuário da HUAWEI ID"), _defineProperty(_framework, "hwId.upgradeAgreements.and", " e a "), _defineProperty(_framework, "hwId.upgradeAgreements.privacyPolicy", "Declaração sobre o HUAWEI ID e a Privacidade"), _defineProperty(_framework, "hwId.upgradeAgreements.period", "."), _defineProperty(_framework, "hwId.upgradeBtnTxt", "Atualizar agora"), _defineProperty(_framework, "hwId.upgradeCancelBtnTxt", "Atualizar depois"), _defineProperty(_framework, "hwId.upgradePageTitle", "Atualização da conta - HUAWEI CLOUD"), _defineProperty(_framework, "hwId.upgradeGoBack", "Atualizar conta"), _defineProperty(_framework, "hwId.upgradeErrorTitle", "Erro no carregamento"), _defineProperty(_framework, "hwId.upgradeErrorDesc", "Erro de serviço. Entre em contato com o atendimento ao cliente."), _defineProperty(_framework, "hwId.upgradeErrorBtn", "OK"), _defineProperty(_framework, "hwId.forgetPwd", "Esqueceu a senha"), _defineProperty(_framework, "hwId.hwCloudAccount", "HUAWEI CLOUD Account"), _defineProperty(_framework, "hwId.hwCloudAccountLogin", "Acesso de conta"), _defineProperty(_framework, "fpwd.accountFpwdTitle", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.iamFpwdTitle", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.goAccountFpwd", "Reset HUAWEI CLOUD Account Password"), _defineProperty(_framework, "fpwd.goIAMFpwd", "Reset IAM User Password"), _defineProperty(_framework, "fpwd.step2.accountHelpMsg", "If you cannot perform verification using your mobile phone and email account currently, please call +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China). If you have already retrieved your password, log in now."), _defineProperty(_framework, "fpwd.step2.switchPhoneVerify", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step2.switchEmailVerify", "Email Address Verification"), _defineProperty(_framework, "fpwd.pwdValidateRule", "Password requirements:"), _defineProperty(_framework, "fpwd.pwdSafetyDegree", "Password strength:"), _defineProperty(_framework, "fpwd.selectUserTitle", "Select Account Name"), _defineProperty(_framework, "fpwd.step1.fpwdByEmail", "Account Name/Email Address Verification"), _defineProperty(_framework, "fpwd.step1.fpwdByPhone", "Mobile Number Verification"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH", "Mobile number"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder", "CAPTCHA code"), _defineProperty(_framework, "fpwd.accountOrEmailPH", "Account name or email address"), _defineProperty(_framework, "fpwd.IAMAccountPH", "Nome da conta do administrador"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew", "IAM user name or email address"), _defineProperty(_framework, "fpwd.step2.sendVerificationCode", "Send Code"), _defineProperty(_framework, "fpwd.confirmPasswdPH", "Enter the new password again."), _defineProperty(_framework, "fpwd.accountOrEmailPH.h5", "Account name or email address"), _defineProperty(_framework, "fpwd.step1.phoneAccountNamePH.h5", "Mobile number"), _defineProperty(_framework, "fpwd.IAMAccountPH.h5", "Nome da conta do administrador"), _defineProperty(_framework, "fpwd.IAMAccountNamePHNew.h5", "IAM user name or email address"), _defineProperty(_framework, "fpwd.verifyCodePlaceHolder.h5", "CAPTCHA code"), _defineProperty(_framework, "fpwd.newPasswdPH.h5", "Enter a new password."), _defineProperty(_framework, "fpwd.confirmPasswdPH.h5", "Enter the new password again."), _defineProperty(_framework, "fpwd.iamFpwdAccountError", "Please enter the correct IAM user name"), _defineProperty(_framework, "quickLogin.title", "Quick Login"), _defineProperty(_framework, "quickLogin.loginTip", "Log in through SMS or email verification."), _defineProperty(_framework, "quickLogin.accountInputPH", "Mobile number, email address, or account name"), _defineProperty(_framework, "quickLogin.smsCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.emailCodePH", "Verification code"), _defineProperty(_framework, "quickLogin.codeBtn", "	Send Code"), _defineProperty(_framework, "quickLogin.codeCountdown", "Resend Code ({0}s)"), _defineProperty(_framework, "quickLogin.mobileLogin", "Mobile Number Verification"), _defineProperty(_framework, "quickLogin.emailLogin", "Email Address Verification"), _defineProperty(_framework, "quickLogin.selectUsersTitle", "Select Account"), _defineProperty(_framework, "quickLogin.selectUsersTitle.h5", "Select Account"), _defineProperty(_framework, "quickLogin.notAllowed", "This account does not support quick login. Use another account."), _defineProperty(_framework, "quickLogin.smsCodeMsg", "Send a verification code to the mobile number {0}."), _defineProperty(_framework, "quickLogin.emailCodeMsg", "Send a verification code to the email address {0}."), _defineProperty(_framework, "quickLogin.noMobile", "This account is not associated with a mobile number. Log in using an email address."), _defineProperty(_framework, "quickLogin.noEmail", "This account is not associated with an email address. Log in using a mobile number."), _defineProperty(_framework, "quickLogin.qucikLoginTip", "This account has been upgraded to a HUAWEI ID. Log in through the HUAWEI ID login page."), _defineProperty(_framework, "quickLogin.notActivate", "This account is not activated, quick login is not allowed"), _defineProperty(_framework, "quickLogin.register", "Free Registration"), _defineProperty(_framework, "ssologin.title", "Selecionar provedor de identidade"), _defineProperty(_framework, "ssologin.btnTxt", "Acessar"), _defineProperty(_framework, "idpLogin.loginLink", "Usuário federado"), _defineProperty(_framework, "idpLogin.title", "Acesso de usuário federado"), _defineProperty(_framework, "idpLogin.h5SelectTip", "Selecionar provedor de identidade"), _defineProperty(_framework, "idpLogin.accountPh", "Nome da conta ou do locatário da HUAWEI CLOUD"), _defineProperty(_framework, "idpLogin.listPh", "Provedor de identidade"), _defineProperty(_framework, "idpLogin.goLogin", "Acessar"), _defineProperty(_framework, "idpLogin.goAccountLogin", "Conta da HUAWEI CLOUD"), _defineProperty(_framework, "idpLogin.noIdps", "Esta conta não está vinculada a qualquer provedor de identidade. Insira outro nome de conta ou de locatário."), _defineProperty(_framework, "idpLogin.domainNotExist", "Esta conta não existe. Insira outro nome de conta ou de locatário."), _defineProperty(_framework, 'selfManage.alertTip', 'The administrator has disabled Information Self-Management. If you need to modify your information, contact the administrator.'), _framework);
        function i18n(key) {
                return i18n.framework[key];
        };
        i18n.framework = framework;
        return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var framework = {
        "clientIpInvalid.helpUrl": "/pt-br/usermanual-iam/iam_07_0003.html"
    };

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var framework = {
        "title.error": "错误",
        "title.prompt": "提示",
        "title.confirm": "确认",
        "title.warn": "警告",

        "hasBindUniportal": "您的华为云帐号已升级为HUAWEI ID，请使用HUAWEI ID登录",

        "mobileLoginModel.intlIpTip": "仅支持中国大陆地区手机号。",
        "mobileLoginModel.mobileLogin": "手机号登录",
        "mobileLoginModel.accountLogin": "帐号/邮件地址登录",
        "mobileLoginModel.mobilePlaceHolder": "手机号",
        "mobileLoginModel.accountPlaceHolder": "帐号名/邮件地址",
        "mobileLoginModel.userPlaceHolder": "用户名/邮件地址",
        "mobileLoginModel.notRegisterTip": "当前手机号尚未注册华为云。",
        "mobileLoginModel.isMobileTip": "似乎输入的是手机号，建议切换为 ",
        "mobileLoginModel.registerNow": "立即注册",
        "mobileLoginModel.multiUsersTip": "当前手机号已绑定多个华为云帐号，请选择本次要登录的帐号。",
        "mobileLoginModel.operationTooFrequent": "您的操作过于频繁，请{0}分钟后重试。",
        "mobileLoginModel.invalidNumber": "输入值不是有效手机号。",
        "mobileLoginModel.retry": "重试",
        "mobileLoginModel.retrievePwd": "找回密码",
        "emailLoginModel.multiUsersTip": "当前邮件地址已绑定多个华为云帐号，请选择要登录的帐号名。",
        "fpwd.multiEmailUsersTip": "当前邮件地址绑定了多个华为云帐号，请选择本次要重置密码的帐号。",

        "loginRegistTip": "当前仅对受邀用户开放注册。",
        "activeAccount": "确认激活",
        "uniportalTip": "华为官网用户，华为企业业务合作伙伴，华为员工，ICT开发者等",
        "activeAccountMsg": "尊敬的华为用户，这是您首次登录华为云，您需要了解并同意华为云用户协议及隐私政策声明以完成业务激活。",
        "accountName": " 帐户名",
        "userNameTip": "用户名：",
        "searchBoxPlaceHolder": "请输入关键字",
        "submitBtnTxt": "确定",
        "cancelBtnTxt": "取消",
        "btnTxtOK": "确定",
        "btnTxtCancel": "取消",
        "btnTxtYes": "是",
        "btnTxtNo": "否",
        "logout": "退出",
        "connect": "和",
        "emptyStr": "--",
        "mobileMsgCodeTxt": "获取验证码",
        "mobilePasswordPlaceHolder": "密码",
        "blankTxt": "该项不能为空。",
        "emptyTxt": "该项不能为空且不能包含空格。",
        "nameBlankTxt": "该项不能为空。",
        "passwordEqual": "两次输入密码必须保持一致。",
        "validEmail": "请输入有效的邮件地址。",
        "validPhone": "请输入有效的手机号。",
        "maxLenTxt": "最长不能超过{0}个字符。",
        "minLenTxt": "最短不能少于{0}个字符。",
        "minMaxLenTxt": "{0}~{1}个字符。",
        "mobileMinMaxLenTxt": "{0}到{1}个字符",
        "phoneMaxLenTxt": "最长不能超过{0}位数字。",
        "msgCodeErrorInfo": "仅支持数字。",
        "nameContainsChar": "只能包含字母、数字或特殊字符(-_)且只能以字母或-开头。",
        "commonContainsChar": "只能包含大小写字母和数字。",
        "pwdNotUsernameOrInvert": "不能与用户名或倒序的用户名相同。",
        "pwdNotContsMobileOrEmail": "不能包含手机号或邮件地址。",
        "pwdNotContsMobile": "不能包含手机号。",
        "pwdcantContsMobileOrEmail": "密码不能包含手机号或邮件地址。",
        "pwdWeak": "您输入的密码可能存在泄漏风险，请更换其他密码。",
        "usernameNotPwdOrInvert": "不能与密码或倒序的密码相同。",
        "passwordChars": "至少包含以下字符中的{0}种：大写字母、小写字母、数字和特殊字符（~`! ?,.:; -_'\" ( ) { } [ ] /<>@# $% ^& * + |\\ =和空格）。",
        "mobilepasswordChars": "数字、大小写字母、特殊字符至少包含两种。",
        "mobilePasswordChars1": "至少包含以下两种：",
        "mobilePasswordChars2": "数字、大写字母、小写字母、特殊字符。",
        "validEmailOrPhone": "请输入有效的邮件地址或手机号。",
        "validAccountName": "请输入有效的帐号名。",
        "validPwd": "请输入有效的密码",
        "validAgency": "请输入有效代理名称",
        "validCheckCode": "验证码最长不能超过4个字符。",
        "tooMuchErrorCode": "验证码错误次数过多，请重新获取。",
        "pwdCannotEqualName": "密码不能与用户名或倒序的用户名相同。",
        "passwordPolicy.errorMsgOfRptChar": "密码中不允许出现 {0} 个以上连续相同的字符。",
        "inValidCcompanyName": "不能全是英文特殊字符、全是数字、全是空格、全是tab。",
        "companyNameLength": "最长不能超过32个字符。",
        "registerSucWarning": "在24小时内点击注册邮件地址中的链接，激活帐号。",
        "RegisterInfo": "已激活 立即体验",
        "accountTipInfo": "你的帐号信息如下：",
        "yes": "是",
        "no": "否",
        "iamUserTip": "如果管理员将您添加到华为云帐户，则您是IAM用户。",
        "registerFailed": "注册失败。",
        "recommended": "新手推荐",
        "strengthLow": "弱",
        "strengthMid": "中",
        "strengthHigh": "强",

        accountNameBlank: "帐号名不能为空。",
        userNameBlank: "用户名不能为空。",
        pwdBlank: "密码不能为空。",
        checkCodeBlank: "验证码不能为空。",

        backToHomepage: "返回首页",
        mobileHome: "首页",
        backTo: "返回",
        homepage: "首页",

        "isHwsUser": "该帐号是华为云（中国站）的帐号，请前往登录",
        "isHongKongUser": "该帐号是华为云（国际站）的帐号，请前往登录",
        "isRuUser": "该帐号是华为云（国际站）的帐号，请前往登录",
        "isHwsUser1": "该帐号是华为云（中国站）的帐号，请",
        "isHongKongUser1": "该帐号是华为云（国际站）的帐号，请",
        "isRuUser1": "该帐号是华为云（国际站）的帐号，请",
        "goLogin.hws": "前往登录",
        "goLogin.hk": "前往登录",
        "goLogin.ru": "前往登录",
        "toLogin.hws": "",
        "toLogin.hk": "",
        "toLogin.ru": "",

        "language": "简体中文",
        "lanuage.hk": "International",
        "lanuage.ch": "中国站",
        "language.zh-cn": "简体中文",
        "language.en-us": "English",
        "titles.login": "用户登录—华为云",
        "titles.resetPwd": "重置密码—华为云",
        "titles.fpwd": "找回密码—华为云",
        "titles.register": "用户注册—华为云",
        "titles.agencyRegister": "代理注册—华为云",
        "titles.reactivate": "重新激活—华为云",
        "titles.registerSuccess": "注册成功—华为云",
        "titles.fphone": "更换手机号",
        "titles.loginVerification": "登录验证—华为云",
        "titles.bindAccount": "首次登录—华为云",
        "titles.bindAccountSuccess": "注册成功（注册绑定）—华为云",

        registerFree: "注册",
        freeRegister: "免费注册",
        createDomain: "创建帐号",
        createDomainBtn: "创建并绑定",
        createSubUser: "创建IAM用户",
        createFailed: "创建失败。",
        bindDomain: "绑定帐号",
        createDomainLink: "创建帐号",
        bindDomainLink: "绑定帐号",
        bindFailed: "绑定失败。",
        bindRepeat: "您已绑定过其他合作伙伴帐号，不允许重复绑定。",
        "createDomain.remindCompleteInfo": "请您填写以下信息创建华为云帐号并进行绑定。已有帐号？",
        "bindDomain.remindCompleteInfo": "请您输入已有的华为云帐号信息并进行绑定。还没有帐号？",
        "createSubUserInfo": "请您填写以下信息创建华为云IAM用户帐号并进行绑定。",
        enterpriseUser: "IAM用户登录",
        enterpriseUserLogin: "IAM用户",
        personageUser: "帐号登录",
        enterpriseUser4Intl: "IAM用户登录 (国际站)",
        personageUser4Intl: "帐号登录 (国际站)",
        accountPlaceHolder: "帐号名",
        domainPlaceHolder: "代理帐号ID/名称",
        roleNamePlaceHolder: "代理名称",
        failedToswitchRole: "切换代理失败",
        switchSubmit: "切换角色",
        agencyDesc: "允许使用单个用户ID和密码跨帐号管理资源。AWS管理员配置角色并为您提供帐号和角色详细信息之后，您便可切换角色。",
        userNamePlaceHolder: "用户名/邮件地址/手机",
        HongKongUserNamePlaceHolder: "IAM用户名/邮件地址",
        accountNamePlaceHolder: "帐号名/邮件地址/手机",
        HongKongAccountNamePlaceHolder: "帐号名/邮件地址",
        accountTip: "帐号：",
        passwdPlaceHolder: "密码",
        iamPasswdPlaceHolder: "IAM用户密码",
        verifyCodePlaceHolder: "验证码",
        "GraphicsVerifyCodeLabel": "验证码：",
        GraphicsVerifyCode: "安全检查",
        InputGrapVerifyCodeInfo: "为了您的帐号安全，请输入图形验证码。（请切换为英文输入键盘）",
        GrapVerifyCodeFailed: "图形验证码输入错误或已失效，请重试。",
        "getVerifyCode": "点击重新获取验证码",
        loginSubmit: "登录",
        logining: "正在登录...",
        rememberName: "记住登录名",
        rememberLogin: "记住登录信息",
        forgetPwd: "忘记密码",
        mobileforgetPwd: "忘记密码",
        emaiNamePwd: "邮件地址验证错误。",
        phoneNamePwd: "手机号验证错误。",
        domainNamePwd: "帐号名验证错误。",
        wrongNamePwd: "帐号密码验证错误。",
        //输入框tip
        learnMore: "了解更多",
        iamAccountTip: "IAM用户所属帐号名称。",
        iamUsernameTip: "由帐号管理员在IAM中创建的IAM用户。",
        iamAccountTipHelp: "/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        iamUsernameTipHelp: "/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

        userNameMobliePH: "手机号",
        mobileNumberLogin: "使用 手机号 登录",
        noMobileLogin: "使用 帐号名/邮件地址 登录",
        phoneBlank: "手机号不能为空",

        wrongIPBlacklist: "检测到您的设备不安全，请更换设备登录",
        wrongIPFrequencyLimiting: "同一IP登录数量超限，请稍晚再登录",
        wrongEquipmentIDFrequencyLimiting: "同一设备登录数量超限，请稍晚再登录或更换设备登录",
        MachineOperation: "检测到您的设备不安全，请更换设备登录",

        emaiNamePwdChances: "邮件地址验证错误，再输错{0}次后需要重新登录。",
        phoneNamePwdChances: "手机号验证错误，再输错{0}次后需要重新登录。",
        domainNamePwdChances: "帐号名验证错误，再输错{0}次后需要重新登录。",
        wrongNamePwdChances: "帐号密码验证错误，再输错{0}次后需要重新登录。",
        wrongNamePwdFourChances: "身份验证信息错误，再输错4次该用户将被锁定15分钟。",
        wrongNamePwdThreeChances: "身份验证信息错误，再输错3次该用户将被锁定15分钟。",
        wrongNamePwdTwoChances: "身份验证信息错误，再输错2次该用户将被锁定15分钟。",
        wrongNamePwdoneChances: "身份验证信息错误，再输错1次该用户将被锁定15分钟。",
        userAccountsStopped: "用户已被停用,请联系管理员。",
        domainAccountsStopped: "帐号已被停用",
        userAccountsLocked: "用户名或密码错误达到5次，当前登录的IP地址已被锁定，请15分钟后重试。",
        clientIpInvalid: "您的管理员已设置了控制台ACL规则，禁止您所在的终端登录控制台。",
        userNotExist: "当前用户不存在，请联系管理员确认。",
        "clientIpInvalid.learnMore": "详情请查看",
        "clientIpInvalid.helpUrl": "/zh-cn/usermanual-iam/iam_07_0003.html",
        notAllowFpwd: "您不允许从本机找回密码。",
        warning: "警告",
        "systemException": "系统繁忙，请刷新页面后重试。",
        freqLocked: "尝试次数过多，请稍后重试。",
        wrongVerifyCode: "验证码错误或已失效。",
        invalidInput: "输入参数不合法。",
        serviceUrlInvalid: "登录失败，请<a href='/'>点击此处</a>重试。",
        maxSessionLimit: "该用户同时在线的会话数超过系统限制。",
        "multiUserInvalid": "您已成功登录，请刷新页面",
        "pageTimeout": "当前页面信息已失效，请刷新后重试。",
        "accountClosed": "您登录的帐户正在注销中",
        invalidInputFourChances: "输入参数不合法，再输错4次该用户将被锁定15分钟。",
        invalidInputThreeChances: "输入参数不合法，再输错3次该用户将被锁定15分钟。",
        invalidInputTwoChances: "输入参数不合法，再输错2次该用户将被锁定15分钟。",
        invalidInputoneChances: "输入参数不合法，再输错1次该用户将被锁定15分钟。",
        loginReactivateFail: "帐号尚未激活，发送激活邮件失败，请重试。",
        pwdSame: "新密码不能与旧密码相同。",
        initialPwdSame: "新密码不能与初始密码相同。",
        historyPwdSame: "新密码不能与历史密码相同。",
        copyrightNotice1: "©{0} Huaweicloud.com 版权所有",
        copyrightNotice1_hk: "版权所有 © 华为服务（香港）有限公司及其关联公司 {0} 保留一切权利",
        copyrightNotice2: "保留一切权利",
        copyrightNotice3: "黔ICP备20004760号-14",
        copyrightNotice4: "苏B2-20130048号",
        copyrightNotice5: "贵公网安备 52990002000093号",
        "legalNotice": "法律声明",
        "legalStatement": "法律声明",
        "reportAbuse": "举报不良信息",
        "sa_nisr": "可接受的使用政策",
        "sa_nisr_intl": "可接受使用政策",
        "siteTerms": "网站条款",
        "privacyProtect": "隐私政策声明",
        "privacyStrategyStatement": "隐私政策声明",
        "sa_cua": "华为云用户协议",
        "sa_cua_intl": "华为云用户协议",
        "enterpriseSwitchTip": "此登录模式适用于企业内用户，即由企业管理员创建的用户。",
        "personalSwitchTip": "此登录模式适用于帐号，即注册时同步创建的用户帐号。",
        "usingOtherWaysLogin": "使用其他帐号登录",
        "otherWaysLogin": "其他帐号登录",
        "HWSdeveloper": "华为终端开发者",
        "HWICTdeveloper": "华为ICT开发者",
        "hwportal": "华为官网帐号",
        "WeLink": "WeLink帐号",
        "mobilereadAgree": "我同意",
        readAgree: "我已阅读并同意",
        hwCloudAgreement: "《华为云用户协议》",
        secretprotect: "《隐私政策声明》",
        companyUserRegistration: "企业用户注册",
        personalUserRegistration: "用户注册",
        companyAccountName: "用户名：",
        userName: "用户名： ",
        "mobileRegisterMail": "激活邮件已发送至邮件地址：",
        registerMail: "注册邮件地址：",
        password: "密码： ",
        registerMailStep3: "邮 箱：",
        tipsAccount: "您的帐号信息如下：",
        passwordPlaceHolder: "请设置您的密码",
        confirmPassword: "确认密码： ",
        confirmPasswordPlaceHolder: "请再次输入您的密码",
        companyName: "公司名称： ",
        contact: "联系人： ",
        phoneNum: "手机： ",
        phonePlaceHolder: "请输入您的手机号",
        msgCode: "短信验证码： ",
        msgCodeTxt: "免费获取短信验证码",
        "msgPHTxt": "短信验证码",
        msgCodeTxtWait: "{0}秒后可重新获取",
        msgCodeWrong: "短信验证码错误。",
        region: "区域： ",
        "register.submit": "同意协议并注册",
        "register.finish": "完成",
        "register.mobilesubmit": "下一步",
        innerKeyWord: "不能使用系统内部关键字作为开头。",
        accountNamePH: "请设置您的用户名",
        "emailPH": "设置邮件地址",
        "mobileCompanyName": "请输入您的公司名(选填)",
        companyNamePH: "请输入您的公司名",
        "registerSuccess": "恭喜您，注册成功！",
        "pleaseCompleteInfo": "为了提高帐号的安全性，请及时完善您的公司信息。",
        "complete": "完善",
        "companyInfo": "公司信息",
        "rejectAndBack": "返回",
        "homePage": "首页",
        "period": "。",
        "goTo": "前往",
        "myCredential": "My Credential",
        "completeUserInfo": "完善个人信息 。",
        "fpwd.findPasswd": "找回密码",
        "fpwd.enterpriseName": "帐号名：",
        "fpwd.accountName": "注册邮件地址或手机：",
        "fpwd.SMSVerifyCode": "请输入短信验证码",
        "fpwd.emailVerifyCode": "请输入邮件验证码",
        "fpwd.getCode": "免费获取验证码",
        "fpwd.confirmAccount": "确认帐号",
        "fpwd.resetPwd": "重置密码",
        "fpwd.resetSuccess": "完成",
        "fpwd.findSuccess": "修改成功！",
        "fpwd.newPasswd": "新密码：",
        "fpwd.confirmPasswd": "确认密码：",
        "fpwd.enterpriseNamePH": "请输入帐号名",
        "fpwd.accountNamePH": "请输入邮件地址/手机",
        "fpwd.verifyCodePH": "请输入验证码",
        "fpwd.newPasswdPH": "请输入新密码",
        "fpwd.newPasswdPHApp": "新密码",
        "fpwd.nextStepBtn": "下一步",
        "fpwd.backTo": "上一步",

        "fpwd.titleDetail": "请输入您的华为云帐号信息",
        "fpwd.titleIAMDetail": "请输入IAM用户信息",
        "fpwd.multiUsersTip": "当前手机号绑定了多个华为云帐号，请选择本次要重置密码的帐号。",
        "fpwd.accountConfirm": "帐号确认",
        "fpwd.personalAccount": "帐号",
        "fpwd.IAMAccount": "IAM用户",
        "fpwd.typePersonalTip": "注册华为云时创建的帐号",
        "fpwd.typeIAMTip": "由帐号管理员在IAM中创建的用户",
        "fpwd.IAMAccountNamePH": "IAM用户名/邮件地址/手机",
        "fpwd.identityVerification": "身份验证",
        "fpwd.identityVerificationDec": "您希望以何种方式验证身份？",
        "fpwd.passwordReset": "密码重置",
        "fpwd.passwordResetDesc": "设置您的新密码",
        "fpwd.step1.fpwdByemail": "通过帐号/邮件地址找回",
        "fpwd.step2.verificationCodePH": "请输入验证码",
        "fpwd.step2.unbindDesc": "您的帐号没有绑定邮件地址或手机，无法验证您的身份。",
        "fpwd.step2.unbindIAMDesc": "您的IAM用户没有绑定邮件地址或手机，无法验证您的身份。",
        "fpwd.step2.exceptionService": "若该手机号/邮件地址不可用，请联系管理员为您重置密码",
        "fpwd.step2.sendEmailCode": "向邮件地址{0}发送验证码",
        "fpwd.step2.sendMobileCode": "向手机{0}发送验证码",
        "fpwd.step2.unabledMethod": "以上验证方式不可用",
        "fpwd.step2.helpMsg": "请联系人工客服获取帮助",
        "fpwd.step2.helpTel1": "中国大陆:  +86 4000-955-988",
        "fpwd.step2.helpTel2": "中国香港:  +852 800 931 122",
        "fpwd.retrieveTxt": "重新获取（{0}）",
        "fpwd.step3.showPwdTip": "点击显示密码",
        "fpwd.step3.hidePwdTip": "点击隐藏密码",
        "fpwd.goToLogin": "去登录",
        "fpwd.successTxt": "密码重置成功",
        "fpwd.loginCountdownTxt": "{0}秒后返回登录页",

        "resetPwd.apiKeyTitle": "修改API密码",
        "resetPwd.apiKeyDetail": "为了提高帐户的安全性，请您修改API密码。",
        "resetPwd.apkKey": "原API密码：",
        "domainuserAccountsLocked": "帐号邮件地址尚未激活，请前往邮箱完成验证。",
        "fpwd.sendCodeFailed": "系统繁忙，获取验证码失败。",
        "fpwd.getCodeFail": "验证码获取次数已达到上限5次，请于次日重试。",
        "wrong_sendCodeFailed": "验证码发送失败,请重新点击获取。",
        "fpwd.invalidVerifyCode": "验证码错误，请重新输入。",
        "fpwd.ipLocked": "IP已被锁定",
        "fpwd.MultipleIAMUserNameByMobile": "该手机号绑定了多个IAM用户，请通过邮件地址找回密码。",
        "fpwd.MultipleAccountNameByMobile": "该手机号绑定了多个帐号，请输入正确的帐号名。",
        "fpwd.MultipleAccountNameByMobileError": "该手机号绑定了多个帐号，手机端暂不支持在该情况下找回密码。请在电脑端通过浏览器操作，或者使用邮件地址找回密码。",
        "fpwd.MultipleAccountsByMobileReminder": "当多个帐号名使用同一个手机号时，该栏为必填项。",
        "fpwd.EnterCorrectEnterpriseAccount": "请输入正确的帐号名。",
        "fpwd.EnterCorrectMobile": "您输入的手机号不正确或未注册， 请重新输入。",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "请输入正确的帐号名和手机号。",
        "fpwd.EnterCorrectEmail": "请输入正确的邮件地址。",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "请输入正确的帐号名和邮件地址。",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "请输入正确的图形验证码。",
        "operationTooFrequent": "您的操作过于频繁，请稍后重试。",
        "fpwd.contactService": "提示：如果您手机和邮件地址均不可使用，请您联系人工客服{0}获取帮助。", //4000-955-988 // +7（495）800 1 800
        "fpwd.contactHKService": "提示：如果您的邮件地址不可使用，请您联系人工客服{0}获取帮助。",
        "fpwd.ErrorRegionAccount": "该帐号非华为云帐号",

        bindPhone: "绑定手机：",
        bindPhoneNum: "手 机：",
        "alreadyHaveAccount": "已有帐号，立即",
        "login": "登录",
        "loginNow": "立即登录",
        safetyDegree: "安全程度：",
        handsRegisterInfo: "使用华为掌上云服务的用户请点此",
        hansRegistration: "注册",
        filloutRegisterInfo: "填写注册信息",
        checkAccountInfo: "完善帐号信息",
        registerSucceed: "注册成功",
        congratulationsSucceed: "恭喜您注册成功！",
        successAccoutInfo: "您的帐号为：",
        descriptionInfo: "您可以使用用户名、绑定手机和电子邮箱作为登录名进行登录。",
        linkFailed: "对不起，此链接已失效。",
        linkFailedDetail: "可能您已经完成激活，或者超过有效激活时间。",
        linkFailedHelp: "您可以尝试",
        linkFailedLogin: "登录",
        serverTimeout: "对不起，服务器超时，请稍后再试。",
        mainMsg: "激活邮件已发送至邮件地址：",
        secondMsg: "请在24小时内点击注册邮件地址中链接，完成激活。",
        checkEmail: "立即打开邮件地址",
        "mobileCheckEmail": "已激活 立即体验",
        didNotGetEmail: "没有收到邮件？",
        checkSpamMail: "1、请检查是否在垃圾邮件中",
        stillDidNotGetEmail: "2、如果还没收到，",
        resendEmail: "重新发送邮件",
        alwaysDidNotGetEmail: "3、一直收不到，",
        changeMailbox: "请更换邮件地址",
        replaceEmailTip: "24小时内仅允许更换一次邮件地址，请仔细核对输入的邮件地址。",
        sendNewEmail: "发送激活邮件",
        alreadySend: "激活邮件已重新发送。",
        sendFailed: "邮件发送失败。",
        inputEmail: "请输入您的邮件地址",
        "email": "邮件地址： ",
        countToHomepage: "{0}秒后返回登录页面",
        "registerFailed.emailRepeat": "该邮件地址已被注册。",
        "registerFailed.nameRepeat": "该用户名已被注册。",
        "registerFailed.mobileRepeat": "该手机号已被注册。",
        "registerFailed.nameCannotBegin": "不能以数字或_开头。",
        "registerFailed.nameCannotContain": "只能包含：字母、数字或-_字符。",

        "registerSuccess.backToHomepage": "1、",
        "registerSuccess.returnHomepage": "返回首页",
        "usercompanyAccount": "您的帐号信息如下:",
        "registerSuccess.backToHomepageLink": "返回首页",
        "registerSuccess.backToHomepageLinkP1": "返回",
        "registerSuccess.backToHomepageLinkP2": "华为云",
        "registerSuccess.second": "2、",
        "registerSuccess.goToBss": "前往",
        "registerSuccess.goToBssFillInfo": "补全注册信息，您将定期收到华为云优惠活动消息。",
        "registerSuccess.bssAccountInfo": "用户中心",
        "registerSuccess.redirecting": "正在为您跳转...",
        "registerSuccess.redirecting.back": "{0}秒后自动返回原页面",
        "registerSuccess.autoClose": "{0}s后自动关闭本页面。",
        "registerSuccess.browserPreventClose": "当前浏览器设置不允许系统自动关闭页面。",
        "registerSuccess.homepage": "首页",
        "registerSuccess.userCenter": "用户中心",
        "registerSuccess.consoleHome": "管理控制台",
        "registerSuccess.helpCenter": "帮助中心",

        "resetPwd.title": "首次登录",
        "resetPwd.titleDetail": "为了提高帐号的安全性，请您修改密码。",
        "resetPwd.phone": "已验证手机：",
        "resetPwd.mailbox": "已验证邮件地址：",
        "resetPwd.byPhone": "通过手机号验证",
        "resetPwd.byMailbox": "通过已验证邮件地址验证",
        "resetPwd.smsMsgCode": "短信验证码：",
        "resetPwd.emailMsgCode": "邮件验证码：",
        "resetPwd.getSmsMsgCode": "免费获取短信验证码",
        "resetPwd.getEmailMsgCode": "免费获取邮件验证码",
        "resetPwd.retrieveMsgCode": "{0}秒后可以重新获取",
        "resetPwd.resetFailed": "密码修改失败。",
        "resetPwd.oldPasswd": "原密码：",
        "resetPwd.newPasswd": "新密码：",
        "resetPwd.confirmNewPasswd": "确认新密码：",
        "resetPwd.resetPwdFailed": "原密码错误，请重试。",
        "resetPwd.getCodeFail": "验证码获取次数达到上限5次，请15分钟后重试",
        "resetPwd.resetCount": "原密码错误，再输错{0}次后需要重新登录。",
        "resetPwd.InitPasswd": "初始密码：",
        "resetPwd.InitPasswdError": "初始密码错误，请重试。",
        "resetPwd.InitPasswdCount": "初始密码错误，再输错{0}次后需要重新登录。",
        "modifyPwdIntervalTimeLessThanMinValidTime": "修改密码时间间隔小于密码必须使用的最短时间，请在密码必须使用的最短时间过后再修改，点击“取消”进入系统。",
        "pwdModifyTitle": "修改密码",
        "pwdExpiredTitle": "密码已经过期",
        "pwdExpiringDesc": "您的密码{0}天后过期，请及时修改密码。",
        "pwdExpiredDesc": "您的密码已过期，请修改密码。",
        "noRight": "您的权限不足，请联系您的管理员增加权限。",

        "browserSupport": "请使用以下浏览器访问华为云",
        "browserSupport.chrome": "Chrome",
        "browserSupport.chromeVersion": "（36.0及以上）",
        "browserSupport.firefox": "FireFox",
        "browserSupport.firefoxVersion": "（35.0及以上）",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "（9.0及以上）",
        "countryCodeSelect": "请选择国家码",
        "reactivate.reactivateAccount": "激活帐号",
        "reactivate.pleaseCheckEmail": "您的帐号还未激活，请您登录注册邮件地址，点击激活邮件中的链接激活您的帐号。",
        "advertisement.txt": "免费试用，每日限额100",
        "advertisement.buttonTxt": "立即申请",
        "fphone.changePhoneNum": "更换手机号",
        "fphone.changeSuccess": "完成",
        "fphone.registerEmail": "已验证邮件地址：",
        "fphone.registerEmailPH": "请输入邮件地址",
        "fphone.emailVerifyCode": "邮件验证码：",
        "fphone.getVerifyCodeByEmail": "获取邮件验证码",
        "fphone.emailVerifyCodePH": "请输入邮件验证码",
        "fphone.newPhoneNum": "新手机号：",
        "fphone.newPhoneNumPH": "请输入新手机号",
        "fphone.smsVerifyCode": "短信验证码：",
        "fphone.getVerifyCodeBySms": "获取短信验证码",
        "fphone.smsVerifyCodePH": "请输入短信验证码",
        "fphone.changePhoneSuccess": "手机号更换成功！",
        "fphone.newPhoneNumInfo": "新的手机号：",
        "fphone.phoneRepeat": "该手机号已存在。",
        "fphone.exceedMaxAccounts": "该手机号已绑定6个帐号。",
        "mobileNumber": "手机号：",
        "fphone.changeMobile": "更换手机号",
        "sendSmsIntervalErr": "您的验证码请求过于频繁，请一分钟后再试。",
        "cookie.chromeDesc": "点击浏览器“设置”——“显示高级设置”——“隐私设置”——“内容设置”——取消“阻止第三方cookie和网站数据”——选择“允许设置本地数据（推荐）”——点击“完成”——重启浏览器即可正常登录。",
        "cookie.firefoxDesc": "点击浏览器“选项”——选择“隐私”——“自定义历史记录设置”，取消“始终使用隐私浏览模式”，勾选“接受来自站点的cookie”——点击“确定”——重启浏览器即可生效。",
        "cookie.ieDesc": "点击浏览器“工具”——“internet选项”——“隐私”——将“阻止所有cookie”调低级别——点击“保存”——重启浏览器即可正常登录。",
        "cookie.chromeName": "Chrome浏览器:",
        "cookie.firefoxName": "Firefox浏览器:",
        "cookie.ieName": "IE浏览器:",
        "cookie.title": "如何开启浏览器cookie？",
        "cookie.loginTip": "开启cookie之后才能登录。",
        "cookie.startCookie": "如何开启？",

        "verifyCode.intervalError": "您的验证码请求过于频繁，请一分钟后再试。",
        "verifyCode.invalid": "验证码已失效，请点击重新获取。",
        "verifyCode.error": "验证码错误，请重新输入。",
        "verifyCode.locked": "获取验证码功能已被锁定，请于次日重试。",
        "verifyCode.locked.custom": "获取验证码功能已被锁定，请{0}分钟后重试或者联系人工客服4000-955-988获取帮助。",
        "verifyCode.sendFailed": "验证码发送失败,请重新获取。",
        "verifyCode.remainderCount": "再请求获取验证码{0}次，该功能将被锁定。",
        "verifyCode.cantAcquire": "获取验证码功能已被锁定，请输入最后一次获取的验证码。",
        "verifyCode.emailInvalidAndSMSError": "短信验证码错误，请重新输入并重新获取有效的邮件验证码。",
        "verifyCode.email.invalid": "邮件验证码已失效，请点击重新获取。",
        "verifyCode.email.error": "邮件验证码错误，请重新输入。",
        "verifyCode.sms.invalid": "短信验证码已失效，请点击重新获取。",
        "verifyCode.sms.error": "短信验证码错误，请重新输入。",
        "verifyCode.usernameRepeat": "用户名已存在，请重新输入。",
        "verifyCode.maxmiumSubUserNum": "用户数量已达到上限。",
        "verifyCode.emailExist": "邮件地址已存在,请重新输入。",

        "loginVerification": "登录验证",
        "loginVerification.tips": "该提示由您的管理员开启，如需关闭，请联系您的管理员。",
        "loginVerification.presetLoginInfo": "预设登录信息",
        "loginVerification.warningInfo": "如果以上文字与您预设的登录信息不一致，请取消本次登录",
        "loginVerification.checkBySMS": "手机短信验证",
        "loginVerification.SMSHasSentTo": "(短信验证码将发送至您的手机)",
        "loginVerification.pleaseClickAgain": "（如60秒内未收到验证码，请重新点击获取）",
        "loginVerification.userLoginInfo": "用户登录信息",
        "loginVerification.lastSuccessTime": "上次登录成功时间",
        "loginVerification.lastFailedTime": "上次登录失败时间",
        "loginVerification.failedTimes": "当前连续登录失败次数",
        "loginVerification.lockInfo": "连续{0}次登录失败，当前用户将被锁定{1}分钟",

        "loginVerification.MFATitle": "虚拟MFA登录验证",
        "loginVerification.MFAContext": "请输入您从Authenticator应用程序中获取6位的MFA验证码。",
        "loginVerification.MFAHelp": "如何获取MFA验证码？",
        "loginVerification.MFALabel": "MFA验证码：",
        "loginVerification.MFANotUseTip": "MFA设备不可用？",
        "loginVerification.MFANotUseMessage1": "您可以联系您公司的华为云管理员重置虚拟MFA设备。", //子用户
        "loginVerification.MFANotUseMessage2": "请联系华为云客服人员。", //租户
        "loginVerification.resetMFAHelpUrl": "<a href='{0}' target='_blank' rel='noopener noreferrer'>如何解绑、重置虚拟MFA？</a>",
        "loginVerification.rememberMFALabel": "7天内无需再次验证",
        "loginVerification.rememberMFALabel.disabledTip": "为了您的帐号安全，同一浏览器仅支持5个用户同时开启“7天内无需再次验证”",

        "loginVerification.emailCheckTitle": "邮箱登录验证",
        "loginVerification.emailCheckContent": "（邮件验证码将发送至您的邮箱：{0}）",
        "loginVerification.emailCodeLabel": "邮件验证码：",
        "loginVerification.emailNotCode": "邮箱不可用",
        "loginVerification.emailCodeTxt": "免费获取邮件验证码",
        "loginVerification.verificationType": "验证方式",
        "loginVerification.verificationTypeForPhone": "绑定手机号与验证方式",
        "loginVerification.verificationTypeForEmail": "绑定邮件地址与验证方式",
        "loginVerification.bindPhone": "绑定手机",
        "loginVerification.bindPhoneTips": "管理员已指定您的验证方式为手机验证，请输入您要绑定的手机号。",
        "loginVerification.bindPhonePH": "请输入要绑定的手机号",
        "loginVerification.bindEmail": "绑定邮箱",
        "loginVerification.bindEmailTips": "管理员已指定您的验证方式为邮箱验证，请输入您要绑定的邮箱。",
        "loginVerification.bindEmailPH": "请输入要绑定的邮箱",
        "loginVerification.verifyCode": "验证码",
        "loginVerification.verifyCodeBtnTxt": "获取验证码",
        "loginVerification.verifyCodePH": "6位数字验证码",
        "loginVerification.verifyCodeEmailPH": "6位数字验证码",
        "loginVerification.sendCodeTxt": "验证码已发送，请勿泄露与他人。",
        "loginVerification.sendCodeFailed": "系统繁忙，获取验证码失败。",
        "loginVerification.validEmailOrPhone": "您输入的邮箱或手机号不可用。",
        "loginVerification.retrieveTxt": "重新获取（{0}）",
        "loginVerification.otherAccount": "切换其他帐号",
        "loginVerification.goOnLogin": "继续登录",
        "loginVerification.title": "绑定虚拟MFA",
        "loginVerification.firstStep": "第一步：请扫描下方二维码下载“华为云”手机应用程序",
        "loginVerification.firstStepIntroduction": "如已下载华为云，请确保您使用的是最新版本。如果您已安装其他MFA应用程序（如 Authenticator），请根据应用程序指引添加用户。",
        "loginVerification.secondStep": "第二步：获取动态码",
        "loginVerification.secondStepIntroduction": "请在手机中打开华为云，选择“控制台-MFA-添加-扫码添加”，扫描下方二维码添加帐号后获取虚拟MFA动态码；或选择“手动输入”，输入下方密钥信息获取虚拟MFA动态码。",
        "loginVerification.username": "IAM用户名",
        "loginVerification.domainname": "帐号名",
        "loginVerification.secretKey": "密钥",
        "loginVerification.thirdStep": "第三步：输入动态码",
        "loginVerification.thirdStepIntroduction": "请输入您从华为云应用程序中获取的连续两组虚拟MFA动态码。",
        "loginVerification.firstRegCode": "第一组验证码",
        "loginVerification.secondRegCode": "第二组验证码",
        "loginVerification.submitText": "确认绑定",
        "loginVerification.bindMFASucceed": "恭喜绑定成功！",
        "loginVerification.mfaCodeError": "MFA验证码校验不通过，请重试！",
        "loginVerification.mfaCodeLocked": "验证码错误次数过多，当前用户已被锁定，请5分钟后重试。",

        "bindAccount.title": "绑定华为云帐号",
        "bindAccount.submit": "注册并绑定",
        "bindAccount.remindCompleteInfo": " 请您补全以下信息，注册华为云帐号并进行绑定。",
        "bindAccount.bindSuccess": " 注册成功！并已绑定华为云帐号",
        "bindAccount.HWSAccount": "您的华为云帐号为：",
        "bindAccount.timeRemind": "{0}秒后自动",
        "bindAccount.redirectPage": "返回原页面",
        "validCountryCode": "请选择有效的国家码",
        "registerGift": "注册成功即可领取超值代金券",
        "registerGiftAddress": "领取代金券",
        "registerGiftSuffixMobile": "领取代金券",
        "registerSuccess.goToGift": "前往",
        "registerSuccess.goToGiftFillInfo": "即可领取新用户专享代金券",

        "welcomeLogin.titleDetail": "为了保障您的帐号安全，请您设置密码。",
        "welcomeEmail.title": "欢迎邮件",
        "welcomeEmail.linkTimeout": "对不起，此链接由于超时已经失效。",
        "welcomeEmail.linkExpired": "对不起，此链接已不可用。",
        "welcomeEmail.resendEmail": "点击此链接重新发送欢迎邮件",
        "welcomeEmail.contactAdm": "请您联系管理员，重新发送欢迎邮件。",
        "welcomeEmail.alreadySend": "欢迎邮件已重新发送。",
        "titles.setPassword": "设置密码—华为云",
        "titles.welcomeEmail": "欢迎邮件—华为云",
        "welcomeEmail.setPassword": "设置密码",
        "dateFormate": "y/M/d HH:mm:ss",
        "sessionExpired": "会话已失效，请重新登录。",
        "m.userNamePlaceHolder": "用户名/邮箱/手机号",
        "m.HongKongUserNamePlaceHolder": "用户名/邮箱",
        "m.accountNamePlaceHolder": "帐号名/邮箱",
        "m.HongKongAccountNamePlaceHolder": "帐号名/邮箱",
        "m.verifyCodePlaceHolder": "验证码",
        "inValidCountryCode": "请选择有效的国家码",
        "mobile.CountryCode": "+86(中国)",
        "authenticationInfo": "未实名认证的用户，部分功能的使用将受到限制。",
        "authenticationForwardInfo": "为了方便您的使用，请您进行实名认证。",
        "authenticationForward": "实名认证",
        "registerSuccess.goToAuthentication": "完成",
        "registerSuccess.authenticationInfo": "，即可获取6个月免费套餐试用资格。",
        "fpwd.findByEmail": "通过邮箱找回密码",
        "fpwd.findByPhone": "通过手机找回密码",
        "fpwd.accountNameByEmail": "已验证邮箱：",
        "fpwd.accountNameByPhone": "注册手机号：",
        "fpwd.phoneAccountNamePH": "请输入手机号",
        "eChannelName": "华为企业业务合作伙伴",
        "uniportalName": "华为官网帐号",
        "moreLink": "更多",
        "registerSuccess.authenticationForward": "前往实名认证",
        "homepageLink": "首页",
        "helpCenter": "文档",
        "cloudCommunity": "云社区",
        "registerSuccess.goToUserZone": "即刻前往",
        "registerSuccess.userZoneLink": "新用户专区",
        "registerSuccess.userZoneInfo": "，领取专属5折套餐福利。",
        "register.accountPlaceHolder": "请设置您的帐号名",
        "register.passwordPlaceHolder": "请设置您的密码",
        "register.confirmPasswordPlaceHolder": "请再次输入密码",
        "register.phonePlaceHolder": "请输入您的手机号",
        "register.msgCodePlaceHolder": "请输入短信验证码",
        "register.accountNameLength": "5-32个字符",
        "register.bindACccountPlaceHolder": "用户名/邮件地址/手机号",

        "remindBindEmail.title": "绑定邮件地址提醒",
        "remindBindEmail.remindMsg": "您的帐号未绑定邮件地址，请绑定您的邮件地址，以便完成以下操作。",
        "remindBindEmail.remindInfo1": "1、接收云服务开通、到期、删除等重要通知提醒；",
        "remindBindEmail.remindInfo2": "2、重要操作的身份验证，如更改手机号、找回帐号密码、删除云主机等。",
        "remindBindEmail.bind": "立即绑定",
        "remindBindEmail.nextBind": "下次再说",
        "remindBindEmail.remind": "提示",
        "remindBindEmail.remindHideInfo": "请在新标签页绑定电子邮箱。",
        "remindBindEmail.remindHideFailde": "若绑定失败，请尝试",
        "remindBindEmail.remindHideFailde2": "重新绑定",
        "remindBindEmail.remindHideSuccess": "已完成绑定",

        "notify.openPage": "正在执行，请稍等......",
        "notify.closeSecondBefore": "操作成功",
        "notify.closePage": "您已操作成功，请直接关闭当前页面。",

        "registerFailed.accountNameRepeat": "该帐号名已被注册。",
        "register.bindAccountPlaceHolder": "帐号名/邮件地址/手机号",

        "privacyPolicyUpdate": "隐私政策声明更新",
        "privacyTipPre": "尊敬的华为云用户，华为云《隐私政策声明》已更新。华为云深知隐私对您的重要性，并充分尊重您的隐私。请您花一些时间熟悉更新后的",
        "privacyTipSuf": "，了解华为云如何保护您的个人信息。",
        "agreementBtnTxt": "同意",
        "privacyAgreementNotAcceptedError": "请先阅读并同意华为云《隐私政策声明》。",

        "OIDC.errorDefault": "系统繁忙，请联系管理员",
        "OIDC.errorO001": "系统繁忙，请稍后再试",
        "OIDC.errorO002": "无效的请求参数：\"domain_id\"",
        "OIDC.errorO003": "无效的请求参数：\"idp\"",
        "OIDC.errorO004": "无效的请求参数：\"service\"",
        "OIDC.errorO005": "很遗憾，没有找到可用的OpenId Connect配置",
        "OIDC.errorO006": "无效的OpenId Connect配置",
        "OIDC.errorO007": "无效的请求参数：\"id_token\"",
        "OIDC.errorO008": "无效的请求参数：\"state\"",
        "OIDC.errorO009": "无效的JWT",
        "OIDC.errorO010": "访问控制校验失败",
        "OIDC.errorO011": "很遗憾，根据您提供的映射规则，无法获取可用的IAM令牌",
        "OIDC.errorO012": "很遗憾，找不到可登录的项目",
        "OIDC.errorO013": "访问过于频繁，请稍后再试",
        "OIDC.errorO014": "编程访问模式下无法访问控制台",
        "OIDC.errorO015": "无效错误信息",
        "console_term_500Error_label": "系统繁忙，请稍后再试",
        "console_term_404Error_label": "很遗憾，地球我都找遍了，还是没发现您要的页面",
        "console_term_401Error_label": "很遗憾，您访问的页面已失效",
        "titles.loginReminder": "登录提醒—华为云",

        //扫码登录需求相关词条
        "QRLogin.title1": "扫码登录",
        "QRLogin.title2": "登录华为云",
        "QRLogin.countDownTipPre1": "请使用",
        "QRLogin.countDownTipPre2": "华为云APP",
        "QRLogin.countDownTipPre3": "扫描二维码登录",
        "QRLogin.remainingTime": "{0}秒",
        "QRLogin.countDownTipSuffix": "后二维码失效",
        "QRLogin.QRCodeInvalid": "二维码已失效",
        "QRLogin.refresh": "刷新",
        "QRLogin.scanSuc": "扫描成功",
        "QRLogin.scanSucTip": "请在手机上根据提示确认登录",
        "QRLogin.loginFail": "登录失败",
        "QRLogin.loginFailTipPre": "请点击",
        "QRLogin.loginFailTipSuffix": "后，重新扫描二维码登录",
        "QRLogin.downloadApp": "手机下载华为云APP",
        "QRLogin.comma": "，",
        "QRLogin.loginReminder": "登录提醒",
        "QRLogin.accountLogin": "密码登录",

        //统一ID相关
        "hwId.cookieMsg": "我们使用cookie来改善我们的网址和您的体验，继续浏览我们的网址即表示您接受我们的cookie政策。",
        "hwId.hwAccount": "华为帐号",
        "hwId.privacyContent": "我们为您提供华为帐号服务，在登录过程中会使用到您的帐号和网络信息提升登录体验。",
        "hwId.hwportal": "华为官网帐号",
        "hwId.eChannel": "华为企业合作伙伴",
        "hwId.casLogin.systemError": "系统异常",
        "hwId.casLogin.systemErrorDesc": "服务系统异常，请刷新当前页面。 若刷新没反应，请联系人工客服获取帮助：中国大陆 +86 4000 955 988、中国香港 +852 800 931 122。",
        "hwId.casLogin.accountError": "帐号异常",
        "hwId.casLogin.accountErrorDesc": "您当前帐号暂时无法使用华为云服务，请更换其他帐号登录。",
        "hwId.casLogin.accountErrorLink": "了解无法使用",
        "hwId.casLogin.accountErrorUrl": "/zh-cn/iam_faq/iam_01_0006.html",
        "hwId.casLogin.loginError": "登录异常",
        "hwId.casLogin.loginErrorDesc": "您帐号不适用于当前的登录方式，请用华为帐号登录",
        "hwId.casLogin.accountExternalErrorDesc": "您当前帐号的注册地为【欧洲或俄罗斯】，华为云暂时不支持以上地域的帐号，请更换其他地域的帐号登录。",
        "hwId.casLogin.accountExternalErrorLink": "了解无法登录的原因",
        "hwId.casLogin.accountTurkeyErrorLink": "您当前的华为帐号注册地为【土耳其】，华为云暂时不支持该地域的华为账户。建议您<a href='{0}' target='_blank' rel='noopener noreferrer'>立即注册</a>华为云帐号，或使用其他地域的华为帐号进行登录。",
        "hwId.casLogin.inactivatedError": "帐号未激活",
        "hwId.casLogin.inactivatedErrorDesc": "您的帐号尚未激活，系统已自动发送激活邮件到您的注册邮件地址，请在24小时内前往点击邮件地址中的链接完成激活。",
        "hwId.casLogin.inactivatedErrorDesc.noEmail": "您的帐号尚未激活且无邮件地址，暂时无法使用华为云服务，请更换其他帐号重新登录。",
        "hwId.casLogin.inactivatedHwidError": "华为云业务未激活",
        "hwId.casLogin.inactivatedHwidErrorDesc": "您的华为云业务未激活，系统已自动发送激活邮件到您的注册邮件地址，请在24小时内前往点击邮件地址中的链接完成激活。",
        "hwId.casLogin.inactivatedHwidErrorDesc.noEmail": "您的华为云业务尚未激活且无邮件地址，暂时无法使用华为云服务，请更换其他帐号重新登录。",
        "hwId.casLogin.accessErrorDesc": "华为云没有权限获取您当前帐号的信息，暂不支持此帐号登录，请更换其他帐号登录。",
        "hwId.refresh": "刷新",
        "hwId.cookies": "Cookies",
        "hwId.otherAccount": "其他登录方式 ：",
        "hwId.otherAccount.h5": "其他登录方式",
        "hwId.hwIdLogin": "华为帐号登录",
        "hwId.accountPlaceHolder": "租户名/原华为云帐号",

        //统一ID找回密码页面改造
        "fpwd.accountFpwdTitle": "华为云找回密码",
        "fpwd.iamFpwdTitle": "IAM用户找回密码",
        "fpwd.goAccountFpwd": "华为云帐号",
        "fpwd.goIAMFpwd": "IAM用户",
        "fpwd.step2.accountHelpMsg": "以上验证方式不可用，请联系人工客服获取帮助：中国大陆+86 4000955 988、中国香港 +852 800 931 122，若已找回密码，可前往登录。",
        "fpwd.step2.switchPhoneVerify": "更换手机号验证",
        "fpwd.step2.switchEmailVerify": "更换邮件地址验证",
        "fpwd.pwdValidateRule": "密码需满足以下要求：",
        "fpwd.pwdSafetyDegree": "密码强度：",
        "fpwd.selectUserTitle": "请选择本次找回密码的帐号",
        "fpwd.step1.fpwdByEmail": "帐号名/邮件地址找回",
        "fpwd.step1.fpwdByPhone": "手机号找回",
        "fpwd.step1.phoneAccountNamePH": "请输入手机号",
        "fpwd.verifyCodePlaceHolder": "请输入图形验证码",
        "fpwd.accountOrEmailPH": "请输入帐号名/邮件地址",
        "fpwd.IAMAccountPH": "请输入管理员帐号",
        "fpwd.IAMAccountNamePHNew": "请输入IAM用户名/邮件地址",
        "fpwd.step2.sendVerificationCode": "获取验证码",
        "fpwd.confirmPasswdPH": "请确认新密码",
        "fpwd.accountOrEmailPH.h5": "帐号名/邮件地址",
        "fpwd.step1.phoneAccountNamePH.h5": "手机号",
        "fpwd.IAMAccountPH.h5": "管理员帐号",
        "fpwd.IAMAccountNamePHNew.h5": "IAM用户名/邮件地址",
        "fpwd.verifyCodePlaceHolder.h5": "图形验证码",
        "fpwd.newPasswdPH.h5": "新密码",
        "fpwd.confirmPasswdPH.h5": "请确认新密码",
        "fpwd.iamFpwdAccountError": "请输入正确的IAM用户名",

        //统一ID升级提示页面
        "hwId.upgradeTitle": "华为云帐号升级",
        'hwId.upgradeDesc': "\u60A8\u5F53\u524D\u767B\u5F55\u7684\u534E\u4E3A\u4E91\u5E10\u53F7\u4EC5\u7528\u4E8E\u8BBF\u95EE\u534E\u4E3A\u4E91\uFF0C\u5EFA\u8BAE\u7ACB\u5373\u5347\u7EA7\u4E3A\u534E\u4E3A\u5E10\u53F7\uFF0C\u5373\u53EF\u4F7F\u7528\u4E00\u4E2A\u5E10\u53F7\u8BBF\u95EE\u534E\u4E3A\u4E91\u3001\u534E\u4E3A\u5F00\u53D1\u8005\u8054\u76DF\u3001\u534E\u4E3A\u7EC8\u7AEF\uFF08\u5982\uFF1A\u534E\u4E3A\u624B\u673A\uFF09\u3001\n            \u534E\u4E3A\u7EC8\u7AEF\u4E91\u670D\u52A1\uFF08\u5982\uFF1A\u4E91\u7A7A\u95F4\u3001\u534E\u4E3A\u89C6\u9891\uFF09\u7B49\u66F4\u591A\u534E\u4E3A\u670D\u52A1\u3002\u5347\u7EA7\u540E\uFF0C\u8BF7\u4F7F\u7528\u534E\u4E3A\u5E10\u53F7\u4E0E\u5BC6\u7801\u767B\u5F55\u8BBF\u95EE\u534E\u4E3A\u4E91\uFF0C\u539F\u6709\u534E\u4E3A\u4E91\u8D44\u6E90\u4E0D\u53D7\u5F71\u54CD\u3002\u66F4\u591A\u8BE6\u60C5\u8BF7",
        'hwId.upgradeDescLink': '查看公告',
        'hwId.upgradeAgreements.pre': '我同意华为帐号获取我的以下信息：帐号名、手机号、邮件地址、注册国家/地区、登录凭证，我已阅读并同意',
        "hwId.upgradeAgreements.userAgreement": "华为帐号用户协议",
        "hwId.upgradeAgreements.and": "和",
        "hwId.upgradeAgreements.privacyPolicy": "关于华为帐号与隐私的声明",
        "hwId.upgradeAgreements.period": "。",
        "hwId.upgradeBtnTxt": "立即升级",
        "hwId.upgradeCancelBtnTxt": "暂不升级",
        "hwId.upgradePageTitle": "帐号升级——华为云",
        "hwId.upgradeGoBack": "帐号升级",
        "hwId.upgradeErrorTitle": "加载失败",
        "hwId.upgradeErrorDesc": "服务出错了，请联系客服处理",
        "hwId.upgradeErrorBtn": "知道了",
        "hwId.forgetPwd": "忘记密码",
        "hwId.hwCloudAccount": "华为云帐号",
        "hwId.hwCloudAccountLogin": "华为云帐号登录",

        // 快捷登录
        "quickLogin.title": "快捷登录",
        "quickLogin.loginTip": "欢迎使用华为云快捷登录，您可以通过手机/邮件验证码登录华为云",
        "quickLogin.accountInputPH": "手机号/邮件地址/帐号名",
        "quickLogin.smsCodePH": "短信验证码",
        "quickLogin.emailCodePH": "邮件地址验证码",
        "quickLogin.codeBtn": "获取验证码",
        "quickLogin.codeCountdown": "{0}s后重新获取",
        "quickLogin.mobileLogin": "手机号验证",
        "quickLogin.emailLogin": "邮件地址验证",
        "quickLogin.selectUsersTitle": "选择本次登录的帐号",
        "quickLogin.selectUsersTitle.h5": "请选择本次登录的帐号",
        "quickLogin.notAllowed": "该帐号不支持快捷登录，请使用其他帐号登录",
        "quickLogin.smsCodeMsg": "向您的手机号{0}发送验证码",
        "quickLogin.emailCodeMsg": "向您的邮件地址{0}发送验证码",
        "quickLogin.noMobile": "监测到您帐号尚未绑定手机号，请使用邮件地址验证",
        "quickLogin.noEmail": "监测到您帐号尚未绑定邮件地址，请使用手机号验证",
        "quickLogin.qucikLoginTip": "已升级的华为云帐号暂不支持登录，请使用华为帐号登录",
        "quickLogin.notActivate": "当前帐号未激活，不允许使用快捷登录",
        "quickLogin.register": "注册",

        "ssologin.title": "选择要访问的身份提供商",
        "ssologin.btnTxt": "立即访问",

        "idpLogin.loginLink": "企业联邦用户",
        "idpLogin.title": "企业联邦身份登录",
        "idpLogin.h5SelectTip": "请选择本次身份供应商名称",
        "idpLogin.accountPh": "原华为云帐号名/租户名",
        "idpLogin.listPh": "身份提供商名称",
        "idpLogin.goLogin": "前往登录",
        "idpLogin.goAccountLogin": "华为云帐号",
        "idpLogin.noIdps": "该帐号检索不到身份供应商，请使用其他华为云帐号名/租户名登录",
        "idpLogin.domainNotExist": "该帐号不存在，请使用其他华为云帐号名/租户名登录",

        'selfManage.alertTip': '管理员已关闭“自主管理用户属性”，不支持IAM用户修改基本信息。如需修改，请联系管理员。'
    };

    function i18n(key) {
        return i18n.framework[key];
    }
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var framework = {};

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_node_modules_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_node_modules_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_node_modules_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_lib_theme_hws_css_tiny_min_css__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_lib_theme_hws_css_tiny_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_lib_theme_hws_css_tiny_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_lib_theme_hws_css_tiny_plus_min_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_lib_theme_hws_css_tiny_plus_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_lib_theme_hws_css_tiny_plus_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_lib_theme_hws_css_tinyext_min_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_lib_theme_hws_css_tinyext_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_lib_theme_hws_css_tinyext_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_custom_css_pageframework_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_custom_css_pageframework_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_custom_css_pageframework_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_custom_css_widgets_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_custom_css_widgets_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_custom_css_widgets_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cssLoader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cssLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__cssLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routerConfig__ = __webpack_require__(115);










function getSecurityPolicy() {
    var defaultPolicy = {
        'accountpolicy': {
            'username_minlen': 5,
            'username_maxlen': 32,
            'username_contains_char': '^[a-zA-Z\\-][0-9a-zA-Z\\_\\-]+$'
        },
        'passwordpolicy': {
            'password_minlen': 6,
            'password_maxlen': 32,
            'pwd_not_is_the_username_or_invert': 'true',
            'password_char_combination': 2
        }
    };
    this.securityPolicy = defaultPolicy;
};

angular.module("tiny", []);
var myApp = angular.module("authui.config", ["ui.router", "wcc", "tiny"]);
getSecurityPolicy.call(myApp);
myApp.factory('securityPolicy', function () {
    return myApp.securityPolicy;
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__routerConfig__["a" /* routerConfig */])(myApp);

// 初始化埋点
statistics({
    'ga': true,
    'hws': true,
    's99click': true,
    'ltbt': false,
    'baidu': false,
    'cloudbi': true
});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(3), __webpack_require__(6), __webpack_require__(15), __webpack_require__(23), __webpack_require__(11), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils) {
    "use strict";

    var casLoginErrorCtrl = function casLoginErrorCtrl($scope, $sce, $filter, $interval, $timeout) {
        document.title = i18n("titles.login");
        $scope.i18n = i18n;
        $scope.systemErrorLink = "caslogin_system_error_link";
        $scope.accountErrorLink = iamUtils.CONFIG.helpCenterUrl + i18n("hwId.casLogin.accountErrorUrl");
        $scope.turkeyErrorLink = iamUtils.CONFIG.cbcRegUrlIntl + "&hwcloud=1";
        $scope.hwidLogoutLink = "https://id1.cloud.huawei.com/AMW/logout";

        $scope.cssFile = getCssFile();

        $scope.systemErrorMsgObj = ["400", "408"];
        $scope.loginErrorMsgObj = ["404", "500"];
        $scope.externalMsgObj = ["401"];
        $scope.turkeyMsgObj = ["4011"];
        $scope.inactivatedMsgObj = ["402", "403"]; //402无邮箱未激活 403有邮箱未激活
        $scope.inactivatedHwidMsgObj = ["441", "442"]; //华为帐号绑定的华为云 441有邮箱未激活 442无邮箱未激活 
        $scope.accessErrorMsgObj = ["409"];

        $scope.model = {
            isMobile: window.outerWidth > 375 ? false : true,
            errorType: "",
            errorTitle: "",
            errorContent: "",
            errorLinkTxtPre: "",
            errorLinkTxt: "",
            errorLink: "",
            loginBtnTxt: "",
            loginBtnClick: ""
        };

        function getCssFile() {
            // 样式文件加载
            var cssFileArr = {
                "zh-cn": "/authui/public/custom/css/casLoginError.css",
                "en-us": "/authui/public/custom/css/casLoginError.css",
                "es-us": "/authui/public/custom/css/casLoginError.css",
                "pt-br": "/authui/public/custom/css/casLoginError.css"
            };
            return cssFileArr[window.language];
        }

        function initPage() {
            var errorCode = iamUtils.getUrlParams()["errorCode"];
            var service = iamUtils.getUrlParams()["service"];
            if (errorCode && $scope.systemErrorMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "systemError";
                $scope.model.errorTitle = i18n('hwId.casLogin.systemError');
                $scope.model.errorContent = i18n('hwId.casLogin.systemErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('hwId.refresh');
                if (errorCode === "408") {
                    $scope.model.loginBtnClick = function () {
                        window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                    };
                } else {
                    $scope.model.loginBtnClick = function () {
                        iamUtils.redirect2Login();
                    };
                }
            } else if (errorCode && $scope.loginErrorMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.accountError');
                $scope.model.errorContent = i18n('hwId.casLogin.accountErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = i18n('hwId.casLogin.accountErrorLink');
                $scope.model.errorLink = $scope.accountErrorLink;
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                };
            } else if (errorCode && $scope.externalMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.accountExternalErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = $scope.accountErrorLink;
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                };
            } else if (errorCode && $scope.turkeyMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = iamUtils.i18nFormat(i18n("hwId.casLogin.accountTurkeyErrorLink"), $scope.turkeyErrorLink);
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                };
            } else if (errorCode && $scope.inactivatedMsgObj.indexOf(errorCode) > -1) {
                if (errorCode === "403") {
                    $scope.model.errorType = "inactivatedError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedErrorDesc');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('hwId.upgradeErrorBtn');
                    $scope.model.loginBtnClick = function () {
                        iamUtils.redirect2Login();
                    };
                } else {
                    $scope.model.errorType = "inactivatedError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.accountError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedErrorDesc.noEmail');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('goLogin.hws');
                    $scope.model.loginBtnClick = function () {
                        iamUtils.redirect2Login();
                    };
                }
            } else if (errorCode && $scope.inactivatedHwidMsgObj.indexOf(errorCode) > -1) {
                if (errorCode === "441") {
                    $scope.model.errorType = "inactivatedHwidError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedHwidError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedHwidErrorDesc');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('hwId.upgradeErrorBtn');
                    $scope.model.loginBtnClick = function () {
                        window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                    };
                } else {
                    $scope.model.errorType = "inactivatedHwidError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedHwidError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedHwidErrorDesc.noEmail');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('goLogin.hws');
                    $scope.model.loginBtnClick = function () {
                        window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                    };
                }
            } else if (errorCode && $scope.accessErrorMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "accessError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.accessErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                };
            } else {
                $scope.model.errorType = "loginError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.loginErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    iamUtils.redirect2Login();
                };
            }
            $scope.model.errorContent = $sce.trustAsHtml($scope.model.errorContent);
        }

        // 页面初始化
        initPage();
    };

    casLoginErrorCtrl = ["$scope", "$sce", "$filter", "$interval", "$timeout", casLoginErrorCtrl];var casLoginErrorModule = angular.module('authui.config');
    casLoginErrorModule.controller('authui.casLoginError.ctrl', casLoginErrorCtrl);

    return casLoginErrorCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(127)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, CloseCookie) {
    "use strict";

    var ctrl = function ctrl($scope) {

        CloseCookie.call(this, $scope, i18n, iamUtils);
    };

    ctrl = ["$scope", ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.closecookie.ctrl', ctrl);
    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils) {
    "use strict";

    function ErrorController($scope) {
        var images = {
            error_401: __webpack_require__(307),
            error_404: __webpack_require__(308),
            error_500: __webpack_require__(309)
        };
        var errorCodeMap = {
            'O001': i18n('OIDC.errorO001'),
            'O002': i18n('OIDC.errorO002'),
            'O003': i18n('OIDC.errorO003'),
            'O004': i18n('OIDC.errorO004'),
            'O005': i18n('OIDC.errorO005'),
            'O006': i18n('OIDC.errorO006'),
            'O007': i18n('OIDC.errorO007'),
            'O008': i18n('OIDC.errorO008'),
            'O009': i18n('OIDC.errorO009'),
            'O010': i18n('OIDC.errorO010'),
            'O011': i18n('OIDC.errorO011'),
            'O012': i18n('OIDC.errorO012'),
            'O013': i18n('OIDC.errorO013'),
            'O014': i18n('OIDC.errorO014'),
            'O015': i18n('OIDC.errorO015'),
            '401': i18n('console_term_401Error_label'),
            '404': i18n('console_term_404Error_label'),
            '500': i18n('console_term_500Error_label'),
            'L0001': i18n('clientIpInvalid'),
            'L0002': i18n('userNotExist')
        };
        var params = getParams();

        //存在错误码
        $scope.errorCode = params.error_code;
        if (params.error_code) {
            if (errorCodeMap[params.error_code]) {
                $scope.errorMsg = errorCodeMap[params.error_code];
            } else if (params.error_description) {
                $scope.errorMsg = params.error_description;
            } else {
                //存在非已知错误码，但是没有error_description
                $scope.errorMsg = i18n('OIDC.errorDefault');
            }
        } else {
            window.location.replace(iamUtils.CONFIG.homepageUrl);
        }

        if (params.error_code === '401') {
            $scope.errorImg = images.error_401;
        } else if (params.error_code === '404') {
            $scope.errorImg = images.error_404;
        } else if (params.error_code === '500') {
            $scope.errorImg = images.error_500;
        } else {
            $scope.errorImg = images.error_401;
        }
    };

    function getParams() {
        var search = window.location.search;
        if (!search || search.charAt(0) !== '?') {
            return {};
        } else {
            search = search.slice(1);
        }
        var result = {};
        var splitted = search.split('&');
        var index, item;
        for (index = 0; index < splitted.length; index++) {
            item = splitted[index].split('=');
            if (item.length === 2 && item[0] && item[1]) {
                try {
                    result[item[0]] = decodeURIComponent(item[1]).replace(/\+/g, ' ');
                } catch (e) {}
            }
        }
        return result;
    }

    ErrorController = ["$scope", ErrorController];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.error.ctrl', ErrorController);

    return ErrorController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(161), __webpack_require__(128), __webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, Step, FPhoneController, iamHttpService, util) {
    'use strict';

    var viewModel = [{
        title: i18n('fpwd.confirmAccount'),
        imgClz: 'step_img step1_img',
        imgClzHL: 'step_img step1_img_hl'
    }, {
        title: i18n('fphone.changePhoneNum'),
        imgClz: 'step_img step2_img',
        imgClzHL: 'step_img step2_img_hl'
    }, {
        title: i18n('fpwd.resetSuccess'),
        imgClz: 'step_img step3_img',
        imgClzHL: 'step_img step3_img_hl'
    }];
    var step = new Step('step', viewModel);
    step.goToStep(1);

    var ctrl = function ctrl($scope, securityPolicy, $compile) {
        try {
            var userType = getQueryString('UserType');
            iamUtils.initialCloudBI('/authui/public/custom/findPhone.html?UserType=' + userType + '#/fphone', { C1: 'IAM-Login-' + userType + '-fphone' });
        } catch (e) {
            console.dir(e);
        }

        FPhoneController.call(this, $scope, $compile, i18n, iamUtils, step, securityPolicy);
        $scope.model.findPhoneValidator = iamUtils.validator.phoneAddIntl();
        $.extend(true, $scope.model, {
            onPhoneChange: function onPhoneChange(event, value) {
                $('#phoneError').empty();
                limitLength($scope.model.newPhoneNumId, value, 11);
            },
            disable: false
        });
    };

    function getQueryString(param) {
        var reg = '(^|&)' + param + '=([^&]*)(&|$)';
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    $.extend(ctrl.prototype, FPhoneController.prototype);

    ctrl.prototype.validatePhoneLength = function (value) {
        var pattern = /^\d*$/;
        return pattern.test(value);
    };

    ctrl.prototype.isKeyExisted = function ($scope, iamHttpService, type, countryCode, value, errorTxt, txtFielId, errorInfoid) {
        var userType = getQueryString('UserType');
        $scope.dft = $.Deferred();
        iamHttpService.post({
            url: '/authui/fphone/exists',
            params: {
                domainName: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                countryCode: countryCode,
                mobile: value,
                email: $('#' + $scope.model.registerEmailId).widget().getValue()
            }
        }).then(function (data) {
            //             roll back multiple account user share one phone number
            //	        	   if(userType === "p") {
            //	        		   if(data.count >= 6) {
            //	        			   addErrorInfo(i18n("fphone.exceedMaxAccounts"), txtFielId, errorInfoid);
            //		                    $scope.dft.reject();
            //	        		   }else {
            //	        			   showOkImg(txtFielId, errorInfoid);
            //		                   $scope.dft.resolve();
            //	        		   }
            //	        	   }else {
            if (data.count) {
                addErrorInfo(i18n('fphone.phoneRepeat'), txtFielId, errorInfoid, '');
                $scope.dft.reject();
            } else {
                showOkImg(txtFielId, errorInfoid);
                $scope.dft.resolve();
            }
            //	        	   }
        }, function (data) {
            addErrorInfo(i18n('systemException'), txtFielId, errorInfoid, '');
            $scope.dft.resolve();
        });
    };

    function limitLength(fieldId, value, length) {
        if (value.length > length) {
            $('#' + fieldId).val(value.substring(0, length));
        }
    }

    function addErrorInfo(errorTxt, txtFielId, errorInfoid, newLine) {
        util.removeErrorInfo(errorInfoid);
        var imgSrc = __webpack_require__(10);
        var errorDomFragment = newLine + '<img src="' + imgSrc + '"><span>' + errorTxt + '</span>';
        $(errorInfoid).html(errorDomFragment)
        //显示错误信息时换行显示
        .css('display', 'block');
        var tempNewPhoneNum = $('#' + txtFielId);
        if (tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.addClass('tiny-input-text valid_error_input');
        } else {
            tempNewPhoneNum.find('input').addClass('tiny-input-text valid_error_input');
        }
    }

    function showOkImg(txtFielId, infoid) {
        util.removeErrorInfo(infoid);
        var tempNewPhoneNum = $('#' + txtFielId);
        if (tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.removeClass('valid_error_input');
        } else {
            tempNewPhoneNum.find('input').removeClass('valid_error_input');
        }
        var imgSrc = __webpack_require__(27);
        var imgDom = '<img src="' + imgSrc + '"/>';
        $(infoid).html(imgDom)
        //显示对号时, 不换行
        .css('display', 'inline-block');
    }

    ctrl = ['$scope', 'securityPolicy', '$compile', ctrl];

    var _IAMLocation = window._IAMLocation = window._IAMLocation || '';
    _IAMLocation = '&step=1';
    try {
        sendToGA();
    } catch (e) {}

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.fphone.ctrl', ctrl);
    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(11), __webpack_require__(5), __webpack_require__(4), __webpack_require__(72), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, cookieOp, utils, iamHttpService, perVerifycodeUtilNew, GrahicVerifyWindow) {
    'use strict';

    var _securityPolicy;
    function CustomerFPwdController($scope, securityPolicy, $compile, $interval, $state) {
        _securityPolicy = securityPolicy;
        $scope.i18n = i18n;
        $scope.ipIsInternational = iamUtils.ipIsInternational();
        document.title = i18n('titles.fpwd');
        try {
            var userType = getQueryString('UserType');
            iamUtils.initialCloudBI('/authui/public/custom/findPwd.html?UserType=' + userType + '#/fpwd', { C1: 'IAM-Login-' + userType + '-fpwd' });
        } catch (e) {
            console.dir(e);
        }
        $scope.model = {
            isMobile: window.outerWidth > 500 ? false : true,
            currentStep: 1,
            isCompany: iamUtils.getUrlParams()['UserType'] === 'e', //是否是IAM用户找回密码
            fpwdErrorMsg: '',
            findMethod: 'name', //主帐号找回密码的方式：name/phone
            inputWidth: 380,
            inputHeight: 40,
            // 步骤按钮
            submitBtnTxt: i18n('submitBtnTxt'),
            cancelBtnTxt: i18n('cancelBtnTxt'),
            stepLastBtnTxt: i18n('fpwd.backTo'),
            stepNextBtnTxt: i18n('fpwd.nextStepBtn'),
            doLoginBtnTxt: i18n('fpwd.goToLogin'),
            emailRegExp: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
            // userexists接口返回的用户信息
            userId: '',
            domainId: '',
            isDomain: '',
            canNextStep: true, //是否可以进行下一步
            authToken: '', //validate接口返回的数据
            //帐号密码策略相关信息
            contSameCharLen: 0,
            maxSameChars: '',
            pwdMinLen: 6,
            name: '',
            containsChars: i18n('passwordChars'),
            validTip: __webpack_require__(41),
            validSuc: __webpack_require__(66),
            validFail: __webpack_require__(68),
            //主账号子账号找回密码切换
            typeChangeHandler: function typeChangeHandler() {
                resetPage($scope); // 页面内容重置
                $scope.model.isCompany = !$scope.model.isCompany;
            },
            //帐号名或手机找回切换
            methodChangeHandler: function methodChangeHandler(method) {
                resetPage($scope); // 页面内容重置
                $scope.model.findMethod = $scope.model.findMethod === 'phone' ? 'name' : 'phone';
            }
        };

        //主帐号找回密码 帐号名输入框
        $scope.personalAccountInput = {
            id: 'personalAccount',
            value: '',
            maxLength: 255,
            ph: $scope.model.isMobile ? i18n('fpwd.accountOrEmailPH.h5') : i18n('fpwd.accountOrEmailPH'),
            style: {
                height: $scope.model.inputHeight
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'personalAccountBlur', $scope.personalAccountInput.value);
            },
            change: function change() {
                $scope.model.fpwdErrorMsg = '';
            }

            //主帐号找回密码 国家码选择及手机号输入框
        };$scope.phoneInput = {
            countryCodeSelectId: 'countryCodeSelectId',
            countryCodeOptions: [],
            defaultOption: {},
            selectDisabled: true,
            selectStyle: {
                height: $scope.model.inputHeight,
                width: '129px'
            },
            selectChange: function selectChange() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_accountPhone_CountryCode', $scope.phoneInput.defaultOption.id);
            },
            phoneInputId: 'phoneInputId',
            phonePH: $scope.model.isMobile ? i18n('fpwd.step1.phoneAccountNamePH.h5') : i18n('fpwd.step1.phoneAccountNamePH'),
            phoneValue: '',
            oldPhoneValue: '',
            focused: false,
            phoneInputStyle: {
                width: 250,
                height: $scope.model.inputHeight
            },
            phoneMaxLength: 11,
            phoneBlur: function phoneBlur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'mobileBlur', $scope.phoneInput.phoneValue);
                // 手机号查找获取用户
                if (phoneValidator($scope)) {
                    mobileExist($scope);
                }
                $scope.phoneInput.phoneTipShow = false;
                $scope.phoneInput.focused = false;
            },
            phoneFocus: function phoneFocus() {
                $scope.phoneInput.phoneTipShow = true;
                $scope.phoneInput.focused = true;
            },
            phoneChange: function phoneChange() {
                $scope.model.fpwdErrorMsg = '';
                $scope.IAMVerifyCode.checkCode = '';
                phoneValidator($scope);
            },
            phoneTipId: 'phoneTipId',
            phoneTipShow: false,
            phoneErrorContent: ''

            // 手机号多用户下拉选择框
        };$scope.mobileUsers = {
            id: 'mobileUsers',
            show: false,
            style: {
                width: '320px',
                height: $scope.model.inputHeight
            },
            selectOptions: [],
            defaultOption: {},
            showOptions: false,
            focus: function focus() {
                $scope.mobileUsers.showOptions = true;
            },
            blur: function blur() {
                if (!$scope.model.isMobile) {
                    $scope.mobileUsers.showOptions = false;
                }
            },
            click: function click() {
                $scope.mobileUsers.showOptions = true;
            },
            maskClick: function maskClick($event) {
                $scope.mobileUsers.showOptions = false;
                $event.stopPropagation();
            },
            select: function select(option) {
                setTimeout(function () {
                    $scope.mobileUsers.defaultOption = option;
                    $scope.mobileUsers.showOptions = false;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, 10);
            }
        };

        // IAM 帐号名输入框
        $scope.IAMAccountInput = {
            id: 'IAMAccount',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.IAMAccountPH.h5') : i18n('fpwd.IAMAccountPH'),
            maxLength: 255,
            style: {
                height: 40
            },
            change: function change() {
                $scope.model.fpwdErrorMsg = '';
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'IAMAccountBlur', $scope.IAMAccountInput.value);
            }
        };

        // IAM 用户名输入框
        $scope.IAMUsernameInput = {
            id: 'IAMUser',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.IAMAccountNamePHNew.h5') : i18n('fpwd.IAMAccountNamePHNew'),
            style: {
                height: 40
            },
            maxLength: 255,
            change: function change() {
                $scope.model.fpwdErrorMsg = '';
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'IAMUserBlur', $scope.IAMUsernameInput.value);
                send2CloudBISafe('input', 'iamUserFpwd', '', 'operation_iam_iamUserFpwd_step1');
            }
        };

        // 图形验证码
        $scope.IAMVerifyCode = {
            checkCodeId: 'checkCodeId',
            checkCode: '',
            maxLength: 4,
            style: {
                height: $scope.model.inputHeight
            },
            focused: false,
            checkCodePH: $scope.model.isMobile ? i18n('fpwd.verifyCodePlaceHolder.h5') : i18n('fpwd.verifyCodePlaceHolder'),
            checkCodeTip: i18n('getVerifyCode'),
            verifycode: '/authui/verifycode?index=4&alt=' + Math.random(),
            preValidVerifyCode: function preValidVerifyCode() {
                var failResultId = 'verifyCodeVaildResult';
                var verifyCodeId = $scope.IAMVerifyCode.checkCodeId;
                perVerifycodeUtilNew.preValidVerifyCodeNew(failResultId, verifyCodeId, $scope.IAMVerifyCode.checkCode, '4', preValidCallback, iamHttpService);
            },
            preValidVerifyCodeBlur: function preValidVerifyCodeBlur() {
                $scope.IAMVerifyCode.focused = false;
                send2CloudBISafe('input', 'change', 'login_company_personal_VerifyCode', $scope.IAMVerifyCode.checkCode);
            },
            focus: function focus() {
                $scope.IAMVerifyCode.focused = true;
            },
            getVerifyCode: function getVerifyCode() {
                send2CloudBISafe('button', 'click', 'login_company_getVerifyCode', '');
                var verifyCodeImg = $('#inputVerifyCodeImg')[0];
                if (verifyCodeImg) {
                    verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
                }
                $scope.IAMVerifyCode.checkCode = '';
                $('#validresultImg').hide();
            }
        };

        // 第二步 获取验证码
        $scope.authMethod = {
            hasPhone: false,
            phoneObj: {},
            hasEmail: false,
            emailObj: {},
            selectMethod: '',
            selectObj: {},
            authMethodChange: function authMethodChange() {
                $scope.authVerifyCode.value = '';
                if ($scope.authMethod.selectMethod === 'phone') {
                    $scope.authMethod.selectMethod = 'email';
                    $scope.authMethod.selectObj = $scope.authMethod.emailObj;
                } else {
                    $scope.authMethod.selectMethod = 'phone';
                    $scope.authMethod.selectObj = $scope.authMethod.phoneObj;
                }
            },
            retrieveVerifyCode: false,
            retrieveVerifyCodeTxt: '',
            sendVerifyCodeClick: function sendVerifyCodeClick() {
                send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_getMsgCode', '');
                if ($scope.authMethod.retrieveVerifyCode) {
                    return;
                }
                $scope.authVerifyCode.value = '';

                iamHttpService.get({
                    url: '/rest/authui/verifycode/needverify',
                    params: {
                        scene: 'findpwd',
                        userid: $scope.model.userId,
                        domainid: $scope.model.domainId,
                        type: $scope.authMethod.selectMethod,
                        isdomain: $scope.model.isDomain
                    }
                }).then(function (data) {
                    var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                    if (data.needVerify) {
                        $scope.graphicVerifyCodeModal.show(function (verifyCode) {
                            retrieveCountdown($scope, $interval);
                            setTimeout(sendVerifyCode($scope, verifyCode), 200);
                        });
                    } else {
                        retrieveCountdown($scope, $interval);
                        setTimeout(function () {
                            sendVerifyCode($scope, null);
                        }, 200);
                    }
                }, function () {
                    $('#sendVerifyCode').removeClass('disabled');
                    iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'popupMsg');
                });
            }
            // 手机邮箱验证码输入框
        };$scope.authVerifyCode = {
            id: 'authVerifyCodeId',
            value: '',
            ph: i18n('loginVerification.verifyCodePH'),
            style: {
                height: 36
            },
            maxLength: '6',
            errorContent: '',
            tipId: 'authVerifyCodeTipId',
            tipShow: false,
            focus: function focus() {
                $scope.authVerifyCode.tipShow = true;
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_msgCodeBlur', $scope.authVerifyCode.value);
                $scope.authVerifyCode.tipShow = false;
            },
            change: function change() {
                $scope.authVerifyCode.verifycodeErrorInfo = '';
                $scope.authVerifyCode.validate();
            },
            validate: function validate() {
                if (!$scope.authVerifyCode.value || $scope.authVerifyCode.value.trim().length === 0) {
                    $scope.authVerifyCode.errorContent = i18n('emptyTxt');
                    return false;
                }
                var reg = /^[a-zA-Z0-9]*$/;
                if (!reg.test($scope.authVerifyCode.value)) {
                    $scope.authVerifyCode.errorContent = i18n('commonContainsChar');
                    return false;
                }
                $scope.authVerifyCode.errorContent = '';
                return true;
            },
            verifycodeErrorInfo: ''
        };

        // 图形验证码弹窗
        $scope.graphicVerifyCodeModal = {
            isShow: false,
            verifyCode: '',
            verifyCodeSrc: '',
            verifyCodeIndex: 3,
            verifyStatus: '', // 'success' | 'fail',
            confirmCallback: null,
            getVerifyCode: function getVerifyCode() {
                this.verifyCode = '';
                this.verifyStatus = '';
                var index = $scope.graphicVerifyCodeModal.verifyCodeIndex;
                return "/authui/verifycode?index=" + index + "&alt=" + Math.random();
            },

            onValidated: function onValidated() {},
            init: function init() {
                $scope.graphicVerifyCodeModal.verifyCodeSrc = this.getVerifyCode();
                this.verifyStatus = '';
                this.verifyCode = '';
            },
            show: function show(callback) {
                this.init();
                this.isShow = true;
                this.confirmCallback = callback;
                $scope.$evalAsync();
            },
            destroy: function destroy() {
                this.isShow = false;
            },
            verify: function verify() {
                var _this = this;

                iamHttpService.post({
                    url: "/authui/preValidVerifycode",
                    params: {
                        index: this.verifyCodeIndex,
                        verifycode: this.verifyCode
                    }
                }).then(function (data) {
                    if (data === 'success') {
                        _this.verifyStatus = 'success';
                    } else {
                        _this.init();
                    }
                    $scope.$evalAsync();
                }, function (err) {
                    iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fpwdPopupMsg');
                });
            },
            onVerifyCodeChange: function onVerifyCodeChange() {
                this.verifyStatus = '';
                if (this.verifyCode.length === 4) {
                    this.verify();
                } else {
                    this.verifyStatus = 'fail';
                }
            },
            onConfirm: function onConfirm() {
                if (this.verifyStatus !== 'success') {
                    $('#fpwd-graphics-input').focus();
                    return;
                }
                if (this.confirmCallback) {
                    this.confirmCallback(this.verifyCode);
                }
                this.destroy();
            },
            onCancel: function onCancel() {
                this.destroy();
            }
        };

        // 密码输入框
        $scope.passwordInput = {
            id: 'newPasswdId',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.newPasswdPH.h5') : i18n('fpwd.newPasswdPH'),
            pwdVisible: false,
            maxLength: _securityPolicy.passwordpolicy.password_maxlen,
            isCorrect: true, //是否符合密码要求
            isWeakPassword: false,
            lowPasswords: [],
            tipId: 'passwordTipId',
            tipShow: false,
            h5TipId: 'h5PasswordTipId',
            style: {
                height: $scope.model.inputHeight
            },
            change: function change() {
                if ($scope.passwordInput.lowPasswords.indexOf($scope.passwordInput.value) > -1) {
                    $scope.passwordInput.isWeakPassword = true;
                } else {
                    $scope.passwordInput.isWeakPassword = false;
                }
                $scope.model.fpwdErrorMsg = '';
                $scope.confirmPasswordInput.value = '';
                showTip($scope);
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + $scope.passwordInput.id, '***');
                showTip($scope);
                $scope.passwordInput.tipShow = false;
                $scope.passwordInput.isWeakPassword = false;
                if ($scope.passwordInput.isCorrect) {
                    passwdAsynCheck($scope);
                }
            },
            focus: function focus() {
                $scope.passwordInput.tipShow = true;
            },
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.passwordInput.pwdVisible = !$scope.passwordInput.pwdVisible;
                var type = $scope.passwordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.passwordInput.id).attr('type', type);
            }
        };

        // 确认密码输入框
        $scope.confirmPasswordInput = {
            id: 'confirmPasswdId',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.confirmPasswdPH.h5') : i18n('fpwd.confirmPasswdPH'),
            pwdVisible: false,
            tipId: 'confirmPasswordTipId',
            tipContent: '',
            tipShow: false,
            style: {
                height: $scope.model.inputHeight
            },
            change: function change() {
                if (!$scope.confirmPasswordInput.value || $scope.confirmPasswordInput.value.length === 0) {
                    $scope.confirmPasswordInput.tipContent = i18n('blankTxt');
                } else if ($scope.confirmPasswordInput.value !== $scope.passwordInput.value) {
                    $scope.confirmPasswordInput.tipContent = i18n('passwordEqual');
                } else {
                    $scope.confirmPasswordInput.tipContent = '';
                }
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_re_***', '***');
                $scope.confirmPasswordInput.tipShow = false;
            },
            focus: function focus() {
                $scope.confirmPasswordInput.tipShow = true;
            },
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.confirmPasswordInput.pwdVisible = !$scope.confirmPasswordInput.pwdVisible;
                var type = $scope.confirmPasswordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.confirmPasswordInput.id).attr('type', type);
            }
        };

        $scope.step4Model = {
            resultImg: __webpack_require__(67),
            loginCountdownTxt: ''

            // 回到登录页面
        };$scope.redirect2Login = function () {
            $state.go('login');
        };

        //第一步确认按钮 
        $scope.step1NextHandler = function () {
            if ($scope.model.isCompany) {
                send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep1', 'operation_iam_iamUserFpwd_step2');
            }
            // 校验是否能下一步
            if (($scope.personalAccountInput.value === '' || $scope.IAMVerifyCode.checkCode === '') && ($scope.phoneInput.phoneValue === '' || $scope.IAMVerifyCode.checkCode === '') && ($scope.IAMAccountInput.value === '' || $scope.IAMUsernameInput.value === '' || $scope.IAMVerifyCode.checkCode === '')) {
                return;
            }
            if ($scope.IAMVerifyCode.checkCode.length < 4) {
                $scope.IAMVerifyCode.getVerifyCode();
                iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseVerificationCode'), '', 'fpwdPopupMsg');
                return;
            }
            // 手机找回场景下 需要校验手机号是否有错误
            if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                var phoneInputObj = $('#' + $scope.phoneInput.id);
                if (!phoneValidator($scope)) {
                    phoneInputObj.focus();
                    return;
                }
            }

            // 通过帐号名或者邮箱查询用户绑定的手机或者邮箱 
            getUserAuthMethod($scope);
        };
        //第二步确认按钮 
        $scope.step2NextHandler = function () {
            send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep2', '');
            // 校验是否能下一步
            if ($scope.authVerifyCode.value === '') {
                return;
            }

            if (!$scope.model.canNextStep) {
                return;
            }
            $scope.model.canNextStep = false;
            // 身份验证
            checkAuthVerifyCode($scope);
        };
        //第三步确认按钮
        $scope.step3NextHandler = function () {
            send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep3', '');
            // 校验是否能下一步
            if (!$scope.passwordInput.value || !$scope.passwordInput.isCorrect) {
                $('#' + $scope.passwordInput.id).focus();
                return;
            }
            if (!$scope.confirmPasswordInput.value || $scope.confirmPasswordInput.tipContent) {
                $('#' + $scope.confirmPasswordInput.id).focus();
                return;
            }
            // 修改密码提交
            modifyPwd($scope, $state, $interval);
        };

        $scope.initTipPosition = initTipPosition;

        function preValidCallback() {
            $scope.IAMVerifyCode.checkCode = '';
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        // 获取国家码
        getCountryCode($scope);
        initIAMInput($scope);

        // 监听窗口大小修改isMobile变量
        window.onresize = function () {
            $scope.model.isMobile = window.outerWidth > 500 ? false : true;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            setTimeout(function () {
                if (!$scope.model.isMobile) {
                    if ($scope.model.currentStep === 1 && !$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                        initTipPosition($scope.phoneInput.phoneInputId, $scope.phoneInput.phoneTipId);
                    } else if ($scope.model.currentStep === 2) {
                        initTipPosition($scope.authVerifyCode.id, $scope.authVerifyCode.tipId);
                    } else if ($scope.model.currentStep === 3) {
                        initTipPosition($scope.passwordInput.id, $scope.passwordInput.tipId, 'right-top');
                        initTipPosition($scope.confirmPasswordInput.id, $scope.confirmPasswordInput.tipId, 'right-top');
                    }
                }
            }, 100);
        };
    };

    function phoneValidator($scope) {
        if (!$scope.phoneInput.phoneValue || $scope.phoneInput.phoneValue.length === 0) {
            $scope.phoneInput.phoneErrorContent = i18n('blankTxt');
            return false;
        }
        var reg = /^1\d{10}$/;
        if (!reg.test($scope.phoneInput.phoneValue)) {
            $scope.phoneInput.phoneErrorContent = i18n('mobileLoginModel.invalidNumber');
            return false;
        }
        $scope.phoneInput.phoneErrorContent = '';
        return true;
    }

    function send2CloudBISafe() {
        try {
            send2CloudBI.apply(null, arguments);
        } catch (e) {
            console.dir(e);
        }
    }

    function getCountryCode($scope) {
        iamHttpService.get({
            url: '/authui/getCountryCode',
            params: {}
        }).then(function (data) {
            data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            var codeList = data['codeArray'];
            var defaultCode = data['defaultCode'];
            if (codeList.length) {
                codeList = codeList.sort(iamUtils.SortArray('label'));
                $scope.phoneInput.countryCodeOptions = codeList;
                codeList.forEach(function (item) {
                    if (item.id === defaultCode) {
                        $scope.phoneInput.defaultOption = item;
                    }
                });
            }
            $scope.$evalAsync();
        }, function () {
            // getCountryCode接口报错 //todo
        });
    }

    function initTipPosition(eleId, tipId, position) {
        setTimeout(function () {
            if (position === 'right-top') {
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('top', pos.top);
                tip.css('left', pos.left + ele.outerWidth() + 14);
            } else if (position === 'bottom-left') {
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('top', pos.top + ele.outerHeight() + 14);
                tip.css('left', pos.left);
            } else {
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('left', pos.left);
                tip.css('top', pos.top - tip.outerHeight() - 34);
            }
        }, 100);
    }

    // 手机号查找获取用户
    function mobileExist($scope) {
        if ($scope.phoneInput.oldPhoneValue == $scope.phoneInput.phoneValue) {
            return;
        }
        if ($scope.phoneInput.phoneValue == '') {
            $scope.mobileUsers.show = false;
            $scope.model.fpwdErrorMsg = '';
            $scope.phoneInput.oldPhoneValue = '';
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            return;
        }
        // 调用接口前先清除已有的下拉框数据
        $scope.mobileUsers.show = false;
        $scope.mobileUsers.selectOptions = [];

        iamHttpService.post({
            url: '/authui/findowner',
            params: {
                type: 'mobile',
                value: $scope.phoneInput.phoneValue,
                source: 'fpwd'
            }
        }).then(function (data) {
            // 记录旧值 防止多次请求
            $scope.phoneInput.oldPhoneValue = $scope.phoneInput.phoneValue;
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                var count = data.count;
                if (count > 1) {
                    // 多帐号
                    $scope.mobileUsers.show = true;
                    $scope.mobileUsers.selectOptions = data.users;
                    $scope.mobileUsers.defaultOption = $scope.mobileUsers.selectOptions[0];
                } else if (count === 1) {
                    // 单帐号
                    $scope.mobileUsers.show = false;
                    $scope.model.fpwdErrorMsg = '';
                    $scope.mobileUsers.defaultOption = data.users[0];
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            } else {
                // 请求返回错误
                if (data.message === 'addrFrequencyHitMax') {
                    $scope.model.fpwdErrorMsg = iamUtils.i18nFormat(i18n('mobileLoginModel.operationTooFrequent'), 5);
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 查询用户是否存在 并且获取可用的身份验证方式
    function getUserAuthMethod($scope) {
        var phonePattern = /^1\d{10}$/;
        var emailpattern = $scope.model.emailRegExp;

        var params = {};
        if (!$scope.model.isCompany && $scope.model.findMethod === 'name') {
            // 租户方式 帐号邮箱找回
            params = {
                type: emailpattern.test($scope.personalAccountInput.value) ? 'email' : 'name',
                userType: 'p',
                value: $scope.personalAccountInput.value.trim(),
                verifyCode: $scope.IAMVerifyCode.checkCode
            };
        } else if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
            // 租户方式 手机号找回
            params = {
                type: 'id',
                userType: 'p',
                value: $scope.mobileUsers.defaultOption.domain_id,
                verifyCode: $scope.IAMVerifyCode.checkCode
            };
        } else if ($scope.model.isCompany) {
            // 子用户方式
            var type;
            if (emailpattern.test($scope.IAMUsernameInput.value)) {
                type = 'email';
            } else if (phonePattern.test($scope.IAMUsernameInput.value)) {
                type = 'mobile';
            } else {
                type = 'name';
            }
            params = {
                type: type,
                userType: 'e',
                value: $scope.IAMUsernameInput.value.trim(),
                domainName: $scope.IAMAccountInput.value.trim(),
                verifyCode: $scope.IAMVerifyCode.checkCode
            };
        }

        iamHttpService.post({
            url: '/authui/fpwd/userexists',
            params: params
        }).then(function (data) {
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.code == 200) {
                if (data.result.email === '' && data.result.phone === '') {
                    // todo 未绑定邮箱或者手机
                    $scope.model.fpwdErrorMsg = !$scope.model.isCompany ? i18n('fpwd.step2.unbindDesc') : i18n('fpwd.step2.unbindIAMDesc');
                    $scope.IAMVerifyCode.getVerifyCode();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    return;
                } else {
                    // 存在绑定有邮箱或者手机
                    $scope.model.fpwdErrorMsg = '';
                    if (data.result.email !== '') {
                        $scope.authMethod.hasEmail = true;
                        $scope.authMethod.emailObj = {
                            authMethodText: iamUtils.i18nFormat(i18n('fpwd.step2.sendEmailCode'), data.result.email),
                            changeAuthMethodText: i18n('fpwd.step2.switchPhoneVerify'),
                            retrieveVerifyCode: false,
                            retrieveVerifyCodeTxt: ''
                        };
                    }
                    if (data.result.phone !== '') {
                        if (data.result.phone.indexOf('-') > 0) {
                            data.result.phone = data.result.phone.replace(/^0*/, '+');
                            data.result.phone = data.result.phone.replace(/-/, ' ');
                        }
                        $scope.authMethod.hasPhone = true;
                        $scope.authMethod.phoneObj = {
                            authMethodText: iamUtils.i18nFormat(i18n('fpwd.step2.sendMobileCode'), data.result.phone),
                            changeAuthMethodText: i18n('fpwd.step2.switchEmailVerify'),
                            retrieveVerifyCode: false,
                            retrieveVerifyCodeTxt: ''
                        };
                    }
                    // 默认选择邮箱
                    if ($scope.authMethod.hasEmail) {
                        $scope.authMethod.selectMethod = 'email';
                        $scope.authMethod.selectObj = $scope.authMethod.emailObj;
                    } else {
                        $scope.authMethod.selectMethod = 'phone';
                        $scope.authMethod.selectObj = $scope.authMethod.phoneObj;
                    }
                    // 获取用户信息
                    $scope.model.userId = data.result.userid;
                    $scope.model.domainId = data.result.domainid;
                    $scope.model.isDomain = data.result.isdomain;
                }
                goToStep($scope, 2);
            } else {
                if (data.code == 500) {
                    if (data.result === 'addrFrequencyHitMax') {
                        $scope.model.fpwdErrorMsg = iamUtils.i18nFormat(i18n('mobileLoginModel.operationTooFrequent'), 15);
                    } else {
                        // 系统繁忙
                        $scope.model.fpwdErrorMsg = i18n('systemException');
                    }
                } else if (data.code == 432) {
                    $scope.model.fpwdErrorMsg = i18n('pageTimeout');
                } else if (data.code === 400 && data.result === 'this domain is another region') {
                    $scope.model.fpwdErrorMsg = i18n('fpwd.ErrorRegionAccount');
                } else {
                    if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.EnterCorrectMobile');
                    } else if (!$scope.model.isCompany) {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.EnterCorrectEnterpriseAccount');
                    } else {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.iamFpwdAccountError');
                    }
                }
                $scope.IAMVerifyCode.getVerifyCode();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    function goToStep($scope, step) {
        $scope.model.currentStep = step;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    // 重新发送验证码倒计时
    function retrieveCountdown($scope, $interval) {
        var selectObj = $scope.authMethod.selectObj;
        selectObj.retrieveVerifyCode = true;
        var second = 60;
        selectObj.retrieveVerifyCodeTxt = iamUtils.i18nFormat(i18n('fpwd.retrieveTxt'), second);
        var timerHandler;
        timerHandler = $interval(function () {
            second--;
            if (second <= 0) {
                $interval.cancel(timerHandler);
                selectObj.retrieveVerifyCode = false;
            } else {
                selectObj.retrieveVerifyCodeTxt = iamUtils.i18nFormat(i18n('fpwd.retrieveTxt'), second);
            }
        }, 1000);
    }

    // 发送验证码
    function sendVerifyCode($scope, verifyCode) {
        var params = {
            type: $scope.authMethod.selectMethod,
            isdomain: $scope.model.isDomain,
            userid: $scope.model.userId,
            domainid: $scope.model.domainId,
            countryCode: '0086', // 该接口国家码参数仅作为默认值，在auth后端从manager取手机号没有国家码的情况下使用
            graphicsVerifyCode: verifyCode
        };

        iamHttpService.post({
            url: '/authui/fpwd/verifyCode',
            params: params
        }).then(function (data) {
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.retcode == 200) {} else if (data.retcode == 405) {
                // IP被锁
                iamUtils.MESSAGE.ERROR(i18n('fpwd.ipLocked'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 406) {
                // 图形验证码输入错误或已失效，请重试
                iamUtils.MESSAGE.ERROR(i18n('GrapVerifyCodeFailed'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 411) {
                // 频率过快
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 412) {
                // 锁定
                var lockedMsg = i18n('verifyCode.locked');
                if (data.lockDuration && data.lockDuration !== -1) {
                    lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                }
                iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fpwdPopupMsg');
            } else {
                // 验证码发送失败,请重新点击获取
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fpwdPopupMsg');
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 用户选择身份验证方式之后验证码的校验
    function checkAuthVerifyCode($scope) {
        var params = {
            domain_id: $scope.model.domainId,
            user_id: $scope.model.userId,
            autchcode: $scope.authVerifyCode.value,
            type: $scope.authMethod.selectMethod,
            isdomain: $scope.model.isDomain
        };
        iamHttpService.post({
            url: '/authui/fpwd/authcode/validate',
            params: params
        }).then(function (data) {
            $scope.model.canNextStep = true;
            // 清除错误提示
            $scope.model.fpwdErrorMsg = '';
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                // 验证码校验通过
                $scope.model.authToken = data.token;
                getPwdMinLen($scope);
                goToStep($scope, 3);
                var tipId = $scope.model.isMobile ? $scope.passwordInput.h5TipId : $scope.passwordInput.tipId;
                createPwdValidateTip(tipId, utils.i18nFormat(i18n('minMaxLenTxt'), _securityPolicy.passwordpolicy.password_minlen, _securityPolicy.passwordpolicy.password_maxlen), utils.i18nFormat($scope.model.containsChars, _securityPolicy.passwordpolicy.password_char_combination), $scope.model.maxSameChars, i18n('pwdNotUsernameOrInvert'), null, i18n);
            } else {
                $scope.model.authVerifyCodeValue = '';
                if (data.status == '414' || data.status == '400') {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('verifyCode.invalid');
                } else if (data.status == '415') {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('verifyCode.error');
                } else {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('systemException');
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            $scope.model.canNextStep = true;
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 触发出密码校验提示框 //todo
    function getPwdMinLen($scope) {
        var promise = iamHttpService.post({
            url: '/authui/fpwd/policy',
            params: {
                domain_id: $scope.model.domainId,
                user_id: $scope.model.userId,
                token: $scope.model.authToken
            },
            mask: true,
            async: false
        });
        promise.then(function (data) {
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            $scope.model.contSameCharLen = data.cont_same_char_len;
            $scope.model.maxSameChars = $scope.model.contSameCharLen != 0 ? utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'), data.cont_same_char_len) : null;
            $scope.model.pwdMinLen = data.password_minlen;
            _securityPolicy.passwordpolicy.password_minlen = data.password_minlen;
            _securityPolicy.passwordpolicy.password_char_combination = data.password_char_combination;
            $scope.model.name = data.name;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function (data) {
            $scope.model.contSameCharLen = 0;
            $scope.model.maxSameChars = null;
            $scope.model.pwdMinLen = _securityPolicy.passwordpolicy.password_minlen;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    // 根据tipID在对应的tip div中添加密码校验提示
    function createPwdValidateTip(tipId, number, chars, maxSameChars, notEqualName, notContsMobile) {
        var defaultImg = __webpack_require__(41);
        var tip = '<div class=\'tip-div\'>\n                        <div class=\'tootip-div\'>\n                            <img id=\'minLenId\' class=\'tootip-img\' src=\'' + defaultImg + '\'></img>&nbsp;&nbsp;\n                            <div>' + number + '</div>\n                        </div>\n                        <div class=\'tootip-div\'>\n                            <img id=\'containsCharsId\' class=\'tootip-img\' src=\'' + defaultImg + '\'></img>&nbsp;&nbsp;                            <div>' + chars + '</div>\n                        </div>';
        if (maxSameChars) {
            tip += '<div id=\'maxSameCharsLabel\' class=\'tootip-div\'>                        <img id=\'maxSameCharsId\' class=\'tootip-img\' src=\'' + defaultImg + '\'></img>&nbsp;&nbsp;                        <div>' + maxSameChars + '</div>                    </div>';
        }
        if (notEqualName) {
            tip += '<div class=\'tootip-div\'>                        <img id=\'notNameId\' class=\'tootip-img\' src=\'' + defaultImg + '\'></img>&nbsp;&nbsp;                        <div>' + notEqualName + '</div>                    </div>';
        }
        if (notContsMobile) {
            tip += '<div class=\'tootip-div\'>                        <img id=\'notContsId\' class=\'tootip-img\' src=\'' + defaultImg + '\'></img>&nbsp;&nbsp;                        <div>' + notContsMobile + '</div>                    </div>';
        }
        tip += '<div class=\'safetyDegreeDiv\'>\n                    <div class=\'safetyDegree\'>' + i18n('safetyDegree') + '</div>\n                    <div id=\'strengthLowCircle0\' class=\'strengthLowCircle\'></div>\n                    <div id=\'strengthLow\' class=\'passwordStrength\' style=\'\'></div>\n                    <div id=\'strengthLowCircle1\' class=\'strengthLowCircle\'></div>\n                    <div id=\'strengthMid\' class=\'passwordStrength\' style=\'\'></div>\n                    <div id=\'strengthMidCircle\' class=\'strengthLowCircle\'></div>\n                    <div id=\'strengthHigh\' class=\'passwordStrength\' style=\'\'></div>\n                    <div id=\'strengthHighCircle\' class=\'strengthLowCircle\'></div>\n                    <div id=\'strengthflag\'></div>\n                </div>\n            </div>';
        var tipDom = $(tip);
        $('#' + tipId + ' .iam-ti-tooltip-content:first').append(tipDom);
    }

    // 校验密码并修改密码提示内容
    function showTip($scope) {
        var password = $scope.passwordInput.value;
        var isBlank = password.length == 0;
        var minLenResult = password.length >= _securityPolicy.passwordpolicy.password_minlen && password.length <= 32;
        var containsCharsResult = utils.validatePasswdChar(password, _securityPolicy.passwordpolicy.password_char_combination);
        var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen); //相同字符连续出现的长度不大于contSameCharLen
        var validatePasswdName = utils.validatePasswdNameSHA256(password, $scope.model.name); //是否是用户名或反转用户名
        $scope.passwordInput.isCorrect = !isBlank && minLenResult && containsCharsResult && maxSameCharsResult && validatePasswdName;
        changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope); //修改密码策略项前的图标
        var level = 'low';
        if (!$scope.model.isWeakPassword || !minLenResult) {
            if (password == '') {
                level = '';
            } else {
                level = utils.getPwdStrengthLevel(password);
            }
        }
        setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', level, i18n);
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
        change2ResultEach($scope, 'minLenId', minLenResult);
        change2ResultEach($scope, 'containsCharsId', containsCharsResult);
        change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
        change2ResultEach($scope, 'notNameId', validatePasswdName);
        if (isBlank) {
            $('#containsCharsId').attr('src', $scope.model.validTip);
            $('#minLenId').attr('src', $scope.model.validTip);
            $('#maxSameCharsId').attr('src', $scope.model.validTip);
            $('#notNameId').attr('src', $scope.model.validTip);
        }
    }

    function change2ResultEach($scope, id, result) {
        if (result) {
            $('#' + id).attr('src', $scope.model.validSuc);
        } else {
            $('#' + id).attr('src', $scope.model.validFail);
        }
    }

    function setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n) {
        var defaultColor = '#e2e2e2';
        var lowColor = '#ff4c4c';
        var midColor = '#ff6a00';
        var highColor = '#0a9e00';
        var low;
        var lowCircle;
        var mid;
        var midCircle;
        var high;
        var highCircle;
        var flagStr = '';
        switch (level) {
            case 'high':
                low = lowCircle = mid = midCircle = high = highCircle = highColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthHigh');
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
                break;
            case 'low':
                low = lowCircle = lowColor;
                mid = midCircle = high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthLow');
                $('#' + lowId)[0].style.height = '2px';
                $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
                break;
            case 'mid':
                low = lowCircle = mid = midCircle = midColor;
                high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthMid');
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = '2px';
                $('#' + highId)[0].style.height = '2px';
                break;
            default:
                low = lowCircle = mid = midCircle = high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;';
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
        }
        if ($('#' + flag).size() != 0) {
            $('#' + flag)[0].innerHTML = flagStr;
        }
        if ($('#' + lowId).size() != 0) {
            $('#' + lowId)[0].style.background = low;
            $('#' + lowId + 'Circle0')[0].style.background = lowCircle;
            $('#' + lowId + 'Circle1')[0].style.background = lowCircle;
            $('#' + midId)[0].style.background = mid;
            $('#' + midId + 'Circle')[0].style.background = midCircle;
            $('#' + highId)[0].style.background = high;
            $('#' + highId + 'Circle')[0].style.background = highCircle;
        }
    }

    // 弱密码校验
    function passwdAsynCheck($scope) {
        iamHttpService.post({
            url: '/authui/passwdAsynCheck',
            params: {
                pvvd: $scope.passwordInput.value,
                isCheckByName: 'false',
                token: typeof $scope.model.authToken !== 'undefined' ? $scope.model.authToken : ''
            }
        }).then(function (data) {
            if (data.result === true) {
                $scope.model.fpwdErrorMsg = '';
            } else {
                if (data.error_code === '1000') {
                    $scope.model.fpwdErrorMsg = i18n('invalidInput');
                } else if (data.error_code === '1001') {
                    $scope.model.fpwdErrorMsg = i18n('pwdNotUsernameOrInvert');
                } else if (data.error_code === '1002') {
                    $scope.model.fpwdErrorMsg = i18n('pwdNotContsMobileOrEmail');
                } else if (data.error_code === '1003') {
                    $scope.passwordInput.isWeakPassword = true;
                    $scope.model.fpwdErrorMsg = i18n('pwdWeak');
                    $scope.passwordInput.lowPasswords.push($scope.passwordInput.value);
                } else if (data === 'checkVerifyCode4Forbidden') {
                    $scope.model.fpwdErrorMsg = i18n('freqLocked');
                } else {
                    $scope.model.fpwdErrorMsg = i18n('systemException');
                }
            }
        }, function () {
            $scope.model.fpwdErrorMsg = i18n('systemException');
        });
    }

    // 修改密码提交
    function modifyPwd($scope, $state, $interval) {
        if ($scope.model.isCompany) {
            send2CloudBISafe('input', 'iamUserFpwd', '', 'operation_iam_iamUserFpwd_step3');
        }
        iamHttpService.post({
            url: '/authui/fpwd/reset',
            params: {
                domain_id: $scope.model.domainId,
                user_id: $scope.model.userId,
                token: $scope.model.authToken,
                password: $scope.passwordInput.value,
                level: iamUtils.getPwdStrengthLevel($scope.passwordInput.value),
                type: $scope.authMethod.selectMethod
            }
        }).then(function (data) {
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                if ($scope.model.isCompany) {
                    send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_reset', 'operation_iam_iamUserFpwd_success');
                }
                // 重置成功后记录被修改的帐号cookie
                recordCookie($scope);
                goToStep($scope, 4);
                loginCountdown($scope, $state, $interval);
            } else {
                deleteCookie();
                if (data.status == '403') {
                    // 访问太频繁或者token不对
                    $scope.model.fpwdErrorMsg = i18n('systemException');
                } else if (data.status == '400') {
                    // 密码不对
                    $scope.model.fpwdErrorMsg = i18n('pwdWeak');
                } else if (data.status == '401') {
                    // 已关闭自主管理用户属性
                    $scope.model.fpwdErrorMsg = i18n('selfManage.alertTip');
                } else {
                    $scope.model.fpwdErrorMsg = data.msg;
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            deleteCookie();
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    function recordCookie($scope) {
        deleteCookie();
        cookieOp.addCookie('findPwdEnd', 'ok', cookieOp.DEFAULT_EXPIRES_TIME);
        if (!$scope.model.isCompany) {
            // 个人帐号
            if ($scope.model.findMethod === 'phone') {
                cookieOp.addCookie('loginType', 'mobile', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('countryCode', $scope.phoneInput.defaultOption.id, cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('mobile', $scope.phoneInput.phoneValue.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
            if ($scope.model.findMethod === 'name') {
                cookieOp.addCookie('loginType', 'personal', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('personalAccount', $scope.personalAccountInput.value, cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else {
            // IAM用户
            cookieOp.addCookie('loginType', 'company', cookieOp.DEFAULT_EXPIRES_TIME);
            cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
        }
    }

    function deleteCookie() {
        cookieOp.delCookie('findPwdEnd');
        cookieOp.delCookie('loginType');
        cookieOp.delCookie('countryCode');
        cookieOp.delCookie('mobile');
        cookieOp.delCookie('personalAccount');
        cookieOp.delCookie('IAMAccount');
        cookieOp.delCookie('IAMUsername');
    }

    // 登录倒计时
    function loginCountdown($scope, $state, $interval) {
        var second = 5;
        $scope.step4Model.loginCountdownTxt = iamUtils.i18nFormat(i18n('fpwd.loginCountdownTxt'), second);
        var timerHandler;
        timerHandler = $interval(function () {
            second--;
            // 1.如果在倒计时结束前离开了找回密码页面 则注销掉该执行
            if ($state.current.name !== 'fpwd') {
                $interval.cancel(timerHandler);
            }
            if (second <= 0) {
                $interval.cancel(timerHandler);
                // 2.如果在倒计时结束时还是找回密码页面 则跳转到登录页面
                if ($state.current.name === 'fpwd') {
                    iamUtils.redirect2Login();
                }
            } else {
                $scope.step4Model.loginCountdownTxt = iamUtils.i18nFormat(i18n('fpwd.loginCountdownTxt'), second);
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, 1000);
    }

    function getQueryString(param) {
        var reg = '(^|&)' + param + '=([^&]*)(&|$)';
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    function resetPage($scope) {
        // 清除错误提示
        $scope.model.fpwdErrorMsg = '';

        // 清除已输入内容
        $scope.personalAccountInput.value = '';
        $scope.phoneInput.phoneValue = '';
        $scope.IAMAccountInput.value = '';
        $scope.IAMUsernameInput.value = '';
        $scope.IAMVerifyCode.checkCode = '';
        $('#verifyCodeVaildResult').hide();

        // 去除多帐号下拉选择框
        $scope.mobileUsers.show = false;
        $scope.mobileUsers.showOptions = false;

        // 重新获取图形验证码
        setTimeout(function () {
            $scope.IAMVerifyCode.getVerifyCode();
        }, 200);
    }

    //通过cookie来设置输入框初始值
    function initIAMInput($scope) {
        if ($scope.model.isCompany && cookieOp.getCookie('loginType') === 'company') {
            $scope.IAMAccountInput.value = cookieOp.getCookie('IAMAccount');
            $scope.IAMUsernameInput.value = cookieOp.getCookie('IAMUsername');
        }
    }
    CustomerFPwdController = ['$scope', 'securityPolicy', '$compile', '$interval', '$state', CustomerFPwdController];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.fpwd.ctrl', CustomerFPwdController);

    return CustomerFPwdController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(129), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, BFController, cookieOp) {
    var ctrl = ["$scope", "$state", function ($scope, $state) {

        $scope.i18n = i18n;
        $scope.model = {
            ipIsInternational: iamUtils.ipIsInternational(),
            homepageUrl: iamUtils.ipIsInternational() ? iamUtils.CONFIG.HongKongHomepageUrl : iamUtils.CONFIG.homepageUrl,
            userCenterUrl: iamUtils.CONFIG.userCenterUrl,
            consoleHomeUrl: iamUtils.CONFIG.consoleHomeUrl,
            helpCenterUrl: iamUtils.CONFIG.helpCenterUrl,
            bssAccountInfoUrl: iamUtils.CONFIG.bssAccountInfoUrl,
            styleOfSite: iamUtils.isShowByStyleOfSite(),
            cloudCommunityUrl: "https://portal.huaweicloud.com/ydcomm",
            currentLanguage: window.language,
            // currentLanguageStyle:iamUtils.isShowByStyleOfSite() ? i18n('language') : iamUtils.ipIsInternational() ? i18n('lanuage.hk') : i18n('lanuage.ch'),
            currentLanguageStyle: "",
            loginUrl: "/authui/?locale=" + window.language + (iamUtils.getUrlParams()["service"] ? "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]) : ""),
            isShowLogoutInResetPwdPage: false,
            logoutUrl: "/authui/logout?locale=" + window.language + (iamUtils.getUrlParams()["service"] ? "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]) : ""),
            ZBJLogoSrc: __webpack_require__(337),
            xAccountType: iamUtils.getUrlParams()["xAccountType"] ? iamUtils.getUrlParams()["xAccountType"].toLowerCase() : "",
            languageIcon: iamUtils.isShowByStyleOfSite() ? __webpack_require__(64) : window.language == "zh-cn" ? __webpack_require__(97) : __webpack_require__(96),
            showCookie: true, // 是否显示底部cookie提示
            isMobile: window.outerWidth > 500 ? false : true,
            isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true
        };

        if ($scope.model.ipIsInternational) {
            $scope.model.copyRight = iamUtils.i18nFormat(i18n('copyrightNotice1_hk'), new Date().getFullYear());
        } else {
            $scope.model.copyRight = iamUtils.i18nFormat(i18n('copyrightNotice1'), new Date().getFullYear());
        }

        if ($scope.model.currentLanguage == "zh-cn") {
            $scope.model.currentLanguageStyle = "简体中文";
        } else if ($scope.model.currentLanguage == "en-us") {
            $scope.model.currentLanguageStyle = "English";
        } else if ($scope.model.currentLanguage == "es-us") {
            $scope.model.currentLanguageStyle = "Español";
        } else if ($scope.model.currentLanguage == "pt-br") {
            $scope.model.currentLanguageStyle = "Português";
        }

        $scope.model.mouseOnLanguageChangeArea = function () {
            $("#languageSwitch").addClass("hoverClass");
            var imagepath = "";
            if (iamUtils.isShowByStyleOfSite() == true) {
                imagepath = __webpack_require__(331);
            } else {
                if (window.language == "zh-cn") {
                    imagepath = __webpack_require__(334);
                } else {
                    imagepath = __webpack_require__(333);
                }
            }
            $("#languageSwitch img").attr('src', imagepath);
            currentLanguageColor();
        };
        $scope.model.mouseLeaveLanguageChangeArea = function () {
            var imagepath = "";
            if (iamUtils.isShowByStyleOfSite() == true) {
                imagepath = __webpack_require__(64);
            } else {
                if (window.language == "zh-cn") {
                    imagepath = __webpack_require__(97);
                } else {
                    imagepath = __webpack_require__(96);
                }
            }
            $("#languageSwitch img").attr('src', imagepath);
        };

        $scope.model.mouseLeaveLanguagesItems = function () {
            $("#languages").css('display', 'none');
            $("#languages").css('color', '#888888');
        };

        $scope.model.toFacebook = function () {
            window.open("https://www.facebook.com/dc3data");
        };

        $scope.model.mouseLeaveLoginPageLanguagesItems = function () {
            $("#loginPageLanguages").css('display', 'none');
            $("#loginPageLanguages").css('color', '#888888');
            $("#languageSwitch").removeClass("hoverClass");
        };

        $scope.model.changeLanguage = function (id) {
            if (id.indexOf("ch") !== -1) {
                refreshPage(id.substring(3), $scope);
            }

            send2CloudBISafe("input", "change", "login_" + "changeLanguage", id);
        };

        $scope.BiEvent = function () {
            try {
                var tempGa = $.extend([], arguments);
                tempGa[tempGa.length - 1] = 1;

                ga.apply(null, tempGa);
                var temp = $.extend([], arguments);
                send2CloudBI.apply(null, temp.slice(2));
            } catch (e) {
                console.dir(e);
            }
        };

        function currentLanguageColor() {
            if (iamUtils.isShowByStyleOfSite() == false) {
                if ($scope.model.currentLanguage == "zh-cn") {
                    $scope.model.currentLanguageStyle = "简体中文";
                    $("#ch-zh-cn").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "en-us") {
                    $scope.model.currentLanguageStyle = "English";
                    $("#ch-en-us").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "es-us") {
                    $scope.model.currentLanguageStyle = "Español";
                    $("#ch-es-us").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "pt-br") {
                    $scope.model.currentLanguageStyle = "Português";
                    $("#ch-pt-br").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                }
            }
        }

        function refreshPage(language, $scope) {
            var searchStr = window.location.search.substring(1);
            if (searchStr === "") {
                window.location.search = "locale=" + language;
            } else {
                var newSearchStr = "";
                var params = searchStr.split("&");
                var needAddLocale = true;
                // 取出URL中的locale参数，替换为新的语言
                for (var index = 0; index < params.length; index++) {
                    var key = params[index].substring(0, params[index].indexOf("="));
                    if ("locale" === key) {
                        var value = params[index].substring(params[index].indexOf("=") + 1);
                        params[index] = key + "=" + language;
                        needAddLocale = false;
                    }
                    if (index === 0) {
                        newSearchStr += params[index];
                    } else {
                        newSearchStr += "&" + params[index];
                    }
                }
                if (needAddLocale) {
                    newSearchStr += "&locale=" + language;
                }
                window.location.search = newSearchStr;
            }
        }
        function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e);
            }
        }

        if (iamUtils.CONFIG.styleOfSite == "Russia") {
            //$scope.model.logoSrc = require("custom/images/logo_en-us.png");
            $scope.model.logoSrc = __webpack_require__(100);

            $scope.model.languages = {
                "1_en": {
                    key: "en-us",
                    value: "English"
                }
            };

            var helpCenterUrl = iamUtils.CONFIG.helpCenterUrl;
            $scope.model.helpCenterUrl = helpCenterUrl != "" && helpCenterUrl != "undefined" ? helpCenterUrl : "http://support.huaweicloud.com/en-us/";
        } else {
            $scope.model.languages = {
                "1_zh": {
                    key: "zh-cn",
                    value: "简体中文"
                },
                "2_en": {
                    key: "en-us",
                    value: "English"
                }
            };

            if (window.language === 'zh-cn') {
                /*替换最新logo*/
                // $scope.model.logoSrc = require("custom/images/logo.svg");
                $scope.model.helpCenterUrl = iamUtils.ipIsInternational() ? "https://support-intl.huaweicloud.com/zh-cn/" : "http://support.huaweicloud.com/";
            } else {
                // $scope.model.logoSrc = require("custom/images/logo-en.svg");
                $scope.model.helpCenterUrl = iamUtils.ipIsInternational() ? "https://support-intl.huaweicloud.com/" : "http://support.huaweicloud.com/en-us/";
            }

            $scope.model.loginPageLanguages = {
                "1_zh": {
                    key: "ch-zh-cn",
                    value: "简体中文"
                },
                "2_en": {
                    key: "ch-en-us",
                    value: "English"
                },
                "3_es": {
                    key: "ch-es-us",
                    value: "Español"
                },
                "4_pt": {
                    key: "ch-pt-br",
                    value: "Português"
                }

            };
            if (window.language === 'zh-cn' && !$scope.model.isLiteSDK) {
                $scope.model.logoSrc = __webpack_require__(100);
            } else if (!$scope.model.isLiteSDK) {
                $scope.model.logoSrc = __webpack_require__(336);
            }
        }

        $scope.footer = {};
        $scope.model.showICP = false;
        $scope.model.showICP = $scope.model.currentLanguage == 'zh-cn' ? true : false;
        $scope.swapICP = function () {
            $scope.model.showICP = !$scope.model.showICP;
        };

        var footerModel = {
            // 法律声明 国内IP下显示
            legalNotice: {
                "zh-cn": $scope.model.ipIsInternational ? "" : "https://www.huaweicloud.com/declaration/statement.html",
                "en-us": $scope.model.ipIsInternational ? "" : "https://www.huaweicloud.com/en-us/declaration/statement.html",
                "es-us": $scope.model.ipIsInternational ? "" : "https://www.huaweicloud.com/en-us/declaration/statement.html",
                "pt-br": $scope.model.ipIsInternational ? "" : "https://www.huaweicloud.com/en-us/declaration/statement.html"
            },
            // 网站条款 海外IP下显示
            siteTerms: {
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/statement.html" : "",
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : "",
                "es-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : "",
                "pt-br": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : ""
            },
            // 隐私政策
            privacyProtect: {
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_prp.html" : "https://www.huaweicloud.com/declaration/sa_prp.html",
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : "https://www.huaweicloud.com/en-us/declaration/sa_prp.html",
                "es-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : "https://www.huaweicloud.com/en-us/declaration/sa_prp.html",
                "pt-br": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : "https://www.huaweicloud.com/en-us/declaration/sa_prp.html"
            },
            reportAbuse: {
                "en-us": $scope.model.ipIsInternational ? "http://portal-intl.huaweicloud.com/feedback?type=jubao" : "https://portal.huaweicloud.com/en-us/feedback?type=jubao",
                "zh-cn": $scope.model.ipIsInternational ? "http://portal-intl.huaweicloud.com/zh-cn/feedback?type=jubao" : "https://portal.huaweicloud.com/feedback?type=jubao"
            },
            sa_nisr: {
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/declaration/sa_nisr.html" : "http://www.huaweicloud.com/en-us/declaration/sa_nisr.html",
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_nisr.html" : "http://www.huaweicloud.com/declaration/sa_nisr.html"
            },
            sa_cua: {
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/declaration/sa_cua.html" : "http://www.huaweicloud.com/en-us/declaration/sa_cua.html",
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_cua.html" : "http://www.huaweicloud.com/declaration/sa_cua.html"
            },
            cookies: {
                "en-us": $scope.model.ipIsInternational ? "https://www.huaweicloud.com/intl/en-us/declaration/sa_cookies.html" : "https://www.huaweicloud.com/declaration/sa_cookies.html",
                "zh-cn": $scope.model.ipIsInternational ? "https://www.huaweicloud.com/intl/zh-cn/declaration/sa_cookies.html" : "https://www.huaweicloud.com/declaration/sa_cookies.html",
                "es-us": $scope.model.ipIsInternational ? "https://www.huaweicloud.com/intl/es-us/declaration/sa_cookies.html" : "https://www.huaweicloud.com/declaration/sa_cookies.html",
                "pt-br": $scope.model.ipIsInternational ? "https://www.huaweicloud.com/intl/pt-br/declaration/sa_cookies.html" : "https://www.huaweicloud.com/declaration/sa_cookies.html"
            }
        };

        var footerModelRussia = {
            paymentMethods: {
                "en-us": "https://www.huaweicloud.ru/payments.html",
                "zh-cn": "https://www.huaweicloud.ru/payments.html"
            },
            userAgreement: {
                "en-us": "https://www.huaweicloud.ru/agreement.html",
                "zh-cn": "https://www.huaweicloud.ru/agreement.html"
            },
            contactUs: {
                "en-us": "https://www.huaweicloud.ru/contacts.html",
                "zh-cn": "https://www.huaweicloud.ru/contacts.html"
            },
            privacyPolicy: {
                "en-us": "https://www.huaweicloud.ru/privacy.html",
                "zh-cn": "https://www.huaweicloud.ru/privacy.html"
            },
            cookies: {
                "en-us": "https://www.huaweicloud.ru/cookies.html",
                "zh-cn": "https://www.huaweicloud.ru/cookies.html"
            }
        };

        if (iamUtils.CONFIG.styleOfSite == "Russia") {

            for (var link in footerModelRussia) {
                if (Object.prototype.hasOwnProperty.call(footerModelRussia, link)) {
                    $scope.footer[link] = footerModelRussia[link][window.language];
                }
            }
        } else {
            for (var link in footerModel) {
                if (Object.prototype.hasOwnProperty.call(footerModel, link)) {
                    $scope.footer[link] = footerModel[link][window.language];
                }
            }
        }

        if (!$scope.model.isMobile) {
            if ($state.is("login") || $state.is("hwIDLogin")) {
                addBackgroundForLogin();
            } else {
                addBackground();
            }
        }

        function addBackgroundForLogin() {
            var imgpath = __webpack_require__(315);
            $("#content").css("background-image", "url(" + imgpath + ")");
            $("#content").css("background-size", "cover");
        }
        function addBackground() {
            var imgpath = __webpack_require__(314);
            $("#content").css("background-image", "url(" + imgpath + ")");
            $("#content").css("background-size", "cover");
        }

        $scope.cookieClick = function () {
            window.location.href = $scope.footer.cookies;
        };
        $scope.hideCookieMsg = function () {
            cookieOp.addCookie("hideIAMCookieMsg", "true", cookieOp.DEFAULT_EXPIRES_TIME);
            $scope.model.showCookie = false;
        };
        function initCookieMsg() {
            if (cookieOp.getCookie("hideIAMCookieMsg") && cookieOp.getCookie("hideIAMCookieMsg") === "true") {
                $scope.model.showCookie = false;
            }
        }
        initCookieMsg();
        //如果是litesdk则不显示语言栏
        function isLiteSDK() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.indexOf("hwidoauthsdk_ver") > -1) {
                $("#banner").css('display', 'none');
                $('#banner').append("<style>#loginForm .loginTypeDiv{margin-top:0 !important}#content:before{padding-top: 0px}</style>");
            }
        }
        isLiteSDK();

        BFController.call(this, $scope);
    }];

    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(3), __webpack_require__(6), __webpack_require__(15), __webpack_require__(23), __webpack_require__(11), __webpack_require__(5), __webpack_require__(61)], __WEBPACK_LOCAL_MODULE_0__ = (function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils, QRCode) {
    'use strict';

    var QRCODE_VALID_TIME = 120; //二维码失效时间，单位秒
    var loginCtrl = function loginCtrl($scope, $sce, $filter, $interval, $timeout, securityPolicy, $state) {
        $scope.$sce = $sce;
        if (localStorage.getItem('fromUpgrade') === 'true') {
            var service = utils.getUrlParams().service;
            service !== undefined ? service = 'https://auth.huaweicloud.com/authui/logout?service=' + service : service = 'https://auth.huaweicloud.com/authui/logout';
            var redirectUrl = 'https://id1.cloud.huawei.com/AMW/logout' + '?service=' + service;
            window.location.href = redirectUrl;
            localStorage.removeItem('fromUpgrade');
            return;
        }
        if (window.navigator.userAgent.toLowerCase().indexOf('hwidoauthsdk_ver') === -1) {
            document.title = i18n('titles.login');
        }

        try {
            iamUtils.initialCloudBI('/authui/#/login', { C1: 'IAM-Login' });
        } catch (e) {
            console.dir(e);
        }

        window.TinyMonitor && window.TinyMonitor.reportCustomTime('rtti', 'IAM-Login', 1);
        if (!window.TinyMonitor) {
            var interval = setInterval(function () {
                if (window.TinyMonitor) {
                    window.TinyMonitor.reportCustomTime('rtti', 'IAM-Login', 1);
                    clearInterval(interval);
                }
            }, 1000);
        }

        isLogin($scope); // 判断是否已经有登录
        getSDKBaseInfo($scope);

        $scope.i18n = i18n;
        $scope.securityPolicy = securityPolicy;
        $scope.ipIsInternational = iamUtils.ipIsInternational(); // 是否为国际IP
        $scope.cbcRiskcheckAddress = 'https://res.hc-cdn.com/riskcontrol-accountguard/1.0.7/riskIntegrated/cn/accountguard.js?t=' + new Date().getTime();
        $scope.model = {
            language: window.language,
            isMobile: window.outerWidth > 500 ? false : true,
            isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf('hwidoauthsdk_ver') === -1 ? false : true,
            isCompany: false, //是否是IAM用户登录,true:IAM用户，false:帐号
            loginType: 'account',
            // 国家码相关
            defaultCode: '0086',
            privacyLink: '', //隐私信息了解更多链接地址，通过js-sdk获取
            showCookie: true, // 是否显示底部cookie提示
            sdkLoading: true,
            registUrl: getRegistUrl($scope),
            hasHwCloudLink: iamUtils.CONFIG.hasHwCloudLink === 'true',
            chkTxt: i18n('rememberName'),
            rememberChecked: cookieOp.getCookie('rememberChecked') ? true : false,
            rememberCheckedChange: function rememberCheckedChange() {
                $scope.model.rememberChecked = !$scope.model.rememberChecked;
            }
        };

        $scope.domainErrorMsgObj = {
            'accountNameBlank': i18n('accountNameBlank'),
            'domainWrong': i18n('wrongNamePwd')
        };

        $scope.usernameErrorMsgObj = {
            'userNameBlank': i18n('userNameBlank'),
            'domainWrong': i18n('wrongNamePwd')
        };

        $scope.nameOrPwdErrorMsgObj = {
            '401': i18n('wrongNamePwd'),
            '402': i18n('wrongNamePwdoneChances'),
            '403': i18n('wrongNamePwdTwoChances'),
            '404': i18n('wrongNamePwdThreeChances'),
            '405': i18n('wrongNamePwdFourChances'),
            '412': i18n('loginReactivateFail'),
            '413': i18n('userAccountsLocked'),
            '414': i18n('domainuserAccountsLocked'),
            '415': i18n('userAccountsLocked')
        };

        $scope.pwdErrorMsgObj = {
            '406': i18n('invalidInput'),
            '407': i18n('invalidInputoneChances'),
            '408': i18n('invalidInputTwoChances'),
            '409': i18n('invalidInputThreeChances'),
            '410': i18n('invalidInputFourChances'),
            '420': i18n('userAccountsStopped'),
            '423': i18n('serviceUrlInvalid'),
            '424': i18n('maxSessionLimit'),
            '427': i18n('multiUserInvalid'),
            '428': i18n('accountClosed'),
            '430': i18n('hasBindUniportal'),
            '432': i18n('pageTimeout'),
            '508121000': i18n('wrongIPBlacklist'),
            '508121001': i18n('wrongIPFrequencyLimiting'),
            '508121002': i18n('wrongEquipmentIDFrequencyLimiting'),
            '508121003': i18n('MachineOperation'),
            'pwdBlank': i18n('pwdBlank')
        };

        $scope.verifycodeErrorMsgObj = {
            '411': i18n('wrongVerifyCode'),
            '418': i18n('verifyCode.error'),
            '419': i18n('verifyCode.invalid'),
            'checkCodeBlank': i18n('checkCodeBlank')
        };

        $scope.errorMsgObj = {
            '417': i18n('systemException'),
            'IAM.0012': i18n('operationTooFrequent'),
            'IAM.0004': i18n('pageTimeout'),
            'IAM.1063': i18n('wrongVerifyCode'),
            'IAM.1065': i18n('domainAccountsStopped'),
            'IAM.1066': i18n('quickLogin.notActivate'),
            'IAM.0018': i18n('invalidInput'),
            'IAM.0007': i18n('invalidInput'),
            'noIdps': i18n('idpLogin.noIdps'),
            'operationTooFrequent': i18n('operationTooFrequent'),
            'domainNotExist': i18n('idpLogin.domainNotExist'),
            'idpIpLock': i18n('mobileLoginModel.operationTooFrequent')
        };

        $scope.getErrorInfo = function (errorCode) {
            return $scope.errorMsgObj[errorCode] || i18n('systemException');
        };

        // IAM用户登录方式下 帐号名输入框
        $scope.IAMAccountInput = {
            id: 'IAMAccountInputId',
            value: '',
            oldValue: '',
            focused: false,
            ph: i18n('hwId.accountPlaceHolder'),
            disable: false,
            maxLength: 255,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight
            },
            clear: function clear() {
                $scope.IAMAccountInput.value = '';
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function change() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = '';
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'login_company_accountName', $scope.IAMAccountInput.value.trim());
                if (!$scope.IAMAccountInput.value || $scope.IAMAccountInput.value === $scope.IAMAccountInput.oldValue) {
                    return;
                }
                $scope.IAMAccountInput.value = $scope.IAMAccountInput.value.trim();
                $scope.IAMAccountInput.oldValue = $scope.IAMAccountInput.value;
                loginVerify($scope);
                hideErrorMsg($scope);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $('#' + $scope.IAMAccountInput.id)[0].focus();
                }, 100);
            }
        };

        // IAM用户登录方式下 用户名输入框
        $scope.IAMUsernameInput = {
            type: 'text',
            id: 'IAMUsernameInputId',
            value: '',
            oldValue: '',
            focused: false,
            ph: i18n('HongKongUserNamePlaceHolder'),
            disable: false,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight
            },
            maxLength: 255,
            clear: function clear() {
                $scope.IAMUsernameInput.value = '';
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function change() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = '';
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            blur: function blur() {
                send2CloudBISafe('input', 'change', 'login_company_userName', $scope.IAMUsernameInput.value.trim());
                if (!$scope.IAMUsernameInput.value || $scope.IAMUsernameInput.value === $scope.IAMUsernameInput.oldValue) {
                    return;
                }
                $scope.IAMUsernameInput.value = $scope.IAMUsernameInput.value.trim();
                $scope.IAMUsernameInput.oldValue = $scope.IAMUsernameInput.value;
                loginVerify($scope);
                hideErrorMsg($scope);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $('#' + $scope.IAMUsernameInput.id)[0].focus();
                }, 100);
            }
        };

        // IAM用户登录方式下 密码输入框
        $scope.IAMPasswordInput = {
            type: 'password',
            id: 'IAMPasswordInputId',
            value: '',
            focused: false,
            ph: i18n('iamPasswdPlaceHolder'),
            pwdVisible: false,
            maxLength: 128,
            style: {
                width: iamUtils.layout.loginInputFiledWidth,
                height: iamUtils.layout.loginInputFieldHeight
            },
            pwdValidator: [iamUtils.validator.childValidator.limitLength(128)],
            pwdFocused: false,
            change: function change() {
                hideErrorMsg($scope);
                setLoginBtn($scope);
            },
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.IAMPasswordInput.pwdVisible = !$scope.IAMPasswordInput.pwdVisible;
                var type = $scope.IAMPasswordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.IAMPasswordInput.id).attr('type', type);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $('#' + $scope.IAMPasswordInput.id)[0].focus();
                }, 100);
            },
            pwdBlur: function pwdBlur() {
                send2CloudBISafe('input', 'change', 'login_company_password', '***');
            }
        };

        // IAM用户登录方式下 图形验证码
        $scope.IAMVerifyCode = {
            isNeedVerifyCode: false,
            checkCodeId: 'checkCodeId',
            checkCode: '',
            maxLength: 4,
            focused: false,
            style: {
                width: '240px',
                height: iamUtils.layout.loginInputFieldHeight
            },
            checkCodePH: i18n('verifyCodePlaceHolder'),
            checkCodeTip: i18n('getVerifyCode'),
            verifycode: '/authui/verifycode?index=1&alt=' + Math.random(),
            preValidVerifyCode: function preValidVerifyCode() {
                var img = $('#validresultImg');
                perVerifycodeUtil.preValidVerifyCode(img, $scope.IAMVerifyCode.checkCode, '1', preValidCallback, iamHttpService, i18n);
                setLoginBtn($scope);
            },
            preValidVerifyCodeBlur: function preValidVerifyCodeBlur() {
                send2CloudBISafe('input', 'change', 'login_company_personal_VerifyCode', $scope.IAMVerifyCode.checkCode);
                $scope.IAMVerifyCode.focused = false;
            },
            focus: function focus() {
                $scope.IAMVerifyCode.focused = true;
            },
            getVerifyCode: function getVerifyCode() {
                send2CloudBISafe('button', 'click', 'login_company_getVerifyCode', '');
                var verifyCodeImg = $('#inputVerifyCodeImg')[0];
                if (verifyCodeImg) {
                    verifyCodeImg.src = '/authui/verifycode?index=1&alt=' + Math.random();
                }
                $scope.IAMVerifyCode.checkCode = '';
                $('#validresultImg').hide();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        };

        // IAM用户登录按钮
        $scope.loginBtn = {
            submitBtnText: i18n('loginSubmit'),
            disable: false,
            loginClick: function loginClick() {
                send2CloudBISafe('button', 'click', 'login_company', '');
                onSubmitBtnClick($scope);
            }
        };

        // IAM用户登录报错信息
        $scope.IAMLoginErrorMsg = {
            show: false,
            content: '',
            goLoginShow: false,
            goLoginHref: 'https://' + 'auth-intl.huaweicloud.com' + '/authui/?locale=' + window.language,
            goLoginContent: '',
            domainError: false,
            usernameError: false,
            pwdError: false,
            nameOrPwdError: false,
            verifycodeError: false

            // 扫码登录相关
        };$scope.QRLoginModel = {
            hasQRLogin: (iamUtils.CONFIG.hasQrlogin === 'true' ? true : false) && !$scope.model.isMobile && !$scope.model.isLiteSDK && $scope.model.language === 'zh-cn',
            isQRLogin: false,
            QRLoginTitle: i18n('QRLogin.title1'),
            remainingTime: iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME),
            countDownTipSuffix: i18n('QRLogin.countDownTipSuffix'),
            countDownInterval: null,
            pollingInterval: null,
            QRCodeInvalid: false,
            QRCodeStatus: 'new', //new, authorizing, refused, authorized
            downloadUrl: getDownloadUrl(),
            clientKey: '', //二维码标识
            QRLoginTypeSwitch: function QRLoginTypeSwitch(isQRLogin) {
                if ($scope.QRLoginModel.isQRLogin === isQRLogin) return;
                $scope.QRLoginModel.isQRLogin = isQRLogin;
                if ($scope.QRLoginModel.isQRLogin) {
                    //切换到扫码登录
                    send2CloudBISafe(iamUtils.pages.login, 'click_QRLogin');
                    QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe);
                } else {
                    //切换到账号登录
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            },
            refreshQRCode: function refreshQRCode() {
                QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe);
            }

            // 快捷登录start
        };$scope.quickLoginModel = {
            hasQuickLogin: false,
            loginTip: i18n('quickLogin.loginTip'),
            showSelectStep: false,
            loginType: 'mobile',
            loginTypeChange: function loginTypeChange(type) {
                $scope.quickLoginCode.error = '';
                if (type == 'email') {
                    $scope.quickLoginModel.loginType = 'email';
                    $scope.quickLoginCode.ph = i18n('quickLogin.emailCodePH');
                } else {
                    $scope.quickLoginModel.loginType = 'mobile';
                    $scope.quickLoginCode.ph = i18n('quickLogin.smsCodePH');
                }
            }

            // 快捷登录 手机、邮箱、账号名输入框
        };$scope.quickAccountInput = {
            id: 'quickAccountInputId',
            value: '',
            oldValue: '',
            type: '',
            focused: false,
            error: '',
            ph: i18n('quickLogin.accountInputPH'),
            disable: false,
            maxLength: 255,
            style: {
                height: iamUtils.layout.loginInputFieldHeight
            },
            clear: function clear() {
                $scope.quickAccountInput.value = '';
                $scope.quickAccountInput.oldValue = '';
                $scope.quickAccountInput.error = '';
                $scope.quickLoginUsers.hasDropdown = false;
                $scope.quickLoginCode.reset();
                $scope.quickLoginModel.loginTip = i18n('quickLogin.loginTip');
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            },
            change: function change() {
                $scope.quickAccountInput.oldValue = '';
                $scope.quickAccountInput.error = '';
                $scope.quickLoginCode.reset();
                $scope.quickLoginModel.loginTip = i18n('quickLogin.loginTip');
                if ($scope.quickLoginUsers.hasSelected) {
                    $scope.quickLoginUsers.hasSelected = false;
                    $scope.quickLoginUsers.hasDropdown = false;
                    $scope.quickAccountInput.clear();
                }
            },
            focus: function focus() {
                $scope.quickAccountInput.focused = true;
            },
            blur: function blur() {
                $scope.quickAccountInput.focused = false;
                if ($scope.quickAccountInput.value == '' || $scope.quickAccountInput.oldValue == $scope.quickAccountInput.value || $scope.quickLoginUsers.hasSelected) {
                    return;
                }
                var type = 'name';
                var emailPattern = iamUtils.EmailRegex;
                var phonePattern = /^[0-9]\d*$/;
                if (phonePattern.test($scope.quickAccountInput.value)) {
                    type = 'mobile';
                } else if (emailPattern.test($scope.quickAccountInput.value)) {
                    type = 'email';
                }
                getUserList($scope, type);
            },
            getFocus: function getFocus() {}
        };

        // 快捷登录方式下 验证码
        $scope.quickLoginCode = {
            id: 'quickLoginCodeId',
            value: '',
            focused: false,
            emailBtnDisabled: true,
            mobileBtnDisabled: true,
            emailInterval: {},
            mobileInterval: {},
            emailBtnTxt: i18n('quickLogin.codeBtn'),
            mobileBtnTxt: i18n('quickLogin.codeBtn'),
            error: '',
            style: {
                width: '240px',
                height: iamUtils.layout.loginInputFieldHeight
            },
            ph: i18n('quickLogin.smsCodePH'),
            focus: function focus() {
                $scope.quickLoginCode.focused = true;
            },
            blur: function blur() {
                $scope.quickLoginCode.focused = false;
            },
            change: function change() {
                $scope.quickLoginCode.error = '';
            },
            reset: function reset() {
                $scope.quickLoginCode.value = '';
                $scope.quickLoginCode.error = '';
                $scope.quickLoginCode.emailBtnDisabled = true;
                $scope.quickLoginCode.mobileBtnDisabled = true;
                $scope.quickLoginCode.emailBtnTxt = i18n('quickLogin.codeBtn');
                $scope.quickLoginCode.mobileBtnTxt = i18n('quickLogin.codeBtn');
                $interval.cancel($scope.quickLoginCode.emailInterval);
                $interval.cancel($scope.quickLoginCode.mobileInterval);
            },
            getVerifyCode: function getVerifyCode() {
                var type = $scope.quickLoginModel.loginType;
                if (type === 'mobile' && $scope.quickLoginCode.mobileBtnDisabled) {
                    return;
                }
                if (type === 'email' && $scope.quickLoginCode.emailBtnDisabled) {
                    return;
                }
                if (type === 'mobile' && !$scope.quickLoginUsers.selectedUser.mobile) {
                    $scope.quickLoginModel.loginTip = i18n('quickLogin.noMobile');
                    return;
                }
                if (type === 'email' && !$scope.quickLoginUsers.selectedUser.email) {
                    $scope.quickLoginModel.loginTip = i18n('quickLogin.noEmail');
                    return;
                }
                $scope.quickLoginCode.error = '';
                var params = {
                    type: type,
                    userId: $scope.quickLoginUsers.selectedUser.userid
                };
                if (type === 'mobile') {
                    $scope.quickLoginCode.mobileBtnDisabled = true;
                } else {
                    $scope.quickLoginCode.emailBtnDisabled = true;
                }
                iamHttpService.get({
                    url: '/authui/sendlogincode',
                    params: params
                }).then(function (data) {
                    quickLoginCountDown($scope, $interval, iamUtils);
                    if (params.type === 'mobile') {
                        $scope.quickLoginModel.loginTip = iamUtils.i18nFormat(i18n('quickLogin.smsCodeMsg'), $scope.quickLoginUsers.selectedUser.mobile);
                    } else {
                        $scope.quickLoginModel.loginTip = iamUtils.i18nFormat(i18n('quickLogin.emailCodeMsg'), $scope.quickLoginUsers.selectedUser.email);
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, function (data) {
                    var response = _typeof(data.responseText) === 'object' ? data.responseText : $.parseJSON(data.responseText);
                    $scope.quickLoginCode.error = $scope.getErrorInfo(response.error_code);
                    if (type === 'mobile') {
                        $scope.quickLoginCode.mobileBtnDisabled = false;
                    } else {
                        $scope.quickLoginCode.emailBtnDisabled = false;
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }
        };

        // 快捷登录按钮
        $scope.quickLoginBtn = {
            submitBtnText: i18n('loginSubmit'),
            disable: false,
            loginClick: function loginClick() {
                if (!$scope.quickAccountInput.value || !$scope.quickLoginCode.value || $scope.quickAccountInput.error || $scope.quickLoginCode.error) {
                    return;
                }
                var params = {
                    userId: $scope.quickLoginUsers.selectedUser.userid,
                    verifycode: $scope.quickLoginCode.value,
                    type: $scope.quickLoginModel.loginType
                };
                iamHttpService.post({
                    url: '/authui/emergencyLogin',
                    params: params
                }).then(function (data) {
                    var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                    if (data.loginResult === 'success') {
                        var redirectUrl;
                        var redirectUrlArr = data.redirectUrl.split('?');
                        if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                            var hash = redirectUrlArr[0].replace('/authui/', '').replace('.html', '');
                            if (redirectUrlArr.length > 1) {
                                redirectUrl = '?' + redirectUrlArr[1] + '#/' + hash;
                            } else {
                                redirectUrl = '#/' + hash;
                            }
                        } else {
                            redirectUrl = data.redirectUrl;
                        }
                        window.location.href = redirectUrl;
                    } else {
                        if (data.error_code == 'IAM.1063') {
                            $scope.quickLoginCode.error = $scope.getErrorInfo(data.error_code);
                        } else {
                            $scope.quickAccountInput.error = $scope.getErrorInfo(data.error_code);
                        }
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, function (data) {
                    var response = _typeof(data.responseText) === 'object' ? data.responseText : $.parseJSON(data.responseText);
                    if (response.error_code == 'IAM.1063') {
                        $scope.quickLoginCode.error = $scope.getErrorInfo(response.error_code);
                    } else {
                        $scope.quickAccountInput.error = $scope.getErrorInfo(response.error_code);
                    }
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }
        };

        $scope.quickLoginUsers = {
            btnId: 'selectUserBtnId',
            btnText: i18n('submitBtnTxt'),
            hasSelected: false,
            selectedUser: {},
            selectedUserTemp: {},
            options: [],
            hasDropdown: false,
            dropdownOpen: false,
            back: function back() {
                $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                $scope.quickLoginModel.showSelectStep = false;
            },
            select: function select(option) {
                $scope.quickLoginUsers.selectedUserTemp = option;
            },
            dropdownSelect: function dropdownSelect(option) {
                if ($scope.quickLoginUsers.selectedUser.userid !== option.userid) {
                    $scope.quickLoginUsers.selectedUser = option;
                    $scope.quickLoginUsers.selectedUserTemp = option;
                    $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                    $scope.quickLoginCode.error = '';
                    $scope.quickLoginUsers.dropdownOpen = false;
                }
            },
            H5DropdownSelect: function H5DropdownSelect(option) {
                $scope.quickLoginUsers.selectedUserTemp = option;
            },
            H5DropdownSubmit: function H5DropdownSubmit($event) {
                $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.selectedUserTemp;
                $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                $scope.quickLoginCode.error = '';
                $scope.quickLoginUsers.dropdownOpen = false;
                $event.stopPropagation();
            },
            dropdownBtnClick: function dropdownBtnClick() {
                $scope.quickLoginUsers.dropdownOpen = !$scope.quickLoginUsers.dropdownOpen;
            },

            closeDropdown: function closeDropdown() {
                $scope.quickLoginUsers.dropdownOpen = false;
            },
            btnClick: function btnClick() {
                $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.selectedUserTemp;
                $scope.quickAccountInput.value = $scope.quickLoginUsers.selectedUser.name;
                $scope.quickLoginUsers.hasSelected = true;
                $scope.quickLoginModel.showSelectStep = false;
                $scope.quickLoginUsers.hasDropdown = $scope.quickLoginUsers.options.length > 1;
            },
            maskClick: function maskClick($event) {
                $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                $scope.quickLoginUsers.dropdownOpen = false;
                $event.stopPropagation();
            }

            //快捷登录end

            // 联合用户登录start
        };$scope.idpAccountInput = {
            id: 'idpAccountInputId',
            value: '',
            oldValue: '',
            error: '',
            focused: false,
            ph: i18n('idpLogin.accountPh'),
            maxLength: 64,
            domainId: '',
            style: {
                height: iamUtils.layout.loginInputFieldHeight
            },
            change: function change() {
                $scope.idpAccountInput.oldValue = '';
                $scope.idpAccountInput.error = '';
                $scope.idpSelect.selectOptions = [];
                $scope.idpSelect.defaultOption = {
                    name: i18n('idpLogin.listPh')
                };
                $scope.idpSelect.disable = true;
            },
            blur: function blur() {
                if ($scope.idpAccountInput.value === '' || $scope.idpAccountInput.value === $scope.idpAccountInput.oldValue) return;
                getIDPs($scope);
            }

            // 手机号多用户下拉选择框
        };$scope.idpSelect = {
            id: 'idpSelect',
            disable: true,
            selectOptions: [],
            preOption: {},
            defaultOption: {
                name: i18n('idpLogin.listPh')
            },
            showOptions: false,
            focus: function focus() {
                if ($scope.idpSelect.disable) return;
                $scope.idpSelect.showOptions = true;
                if ($scope.model.isMobile) $scope.idpSelect.preOption = $scope.idpSelect.defaultOption;
            },
            blur: function blur() {
                if (!$scope.model.isMobile) {
                    $scope.idpSelect.showOptions = false;
                }
            },
            click: function click() {
                if ($scope.idpSelect.disable) return;
                $scope.idpSelect.showOptions = !$scope.idpSelect.showOptions;
                if ($scope.model.isMobile) $scope.idpSelect.preOption = $scope.idpSelect.defaultOption;
            },
            maskClick: function maskClick($event) {
                $scope.idpSelect.showOptions = false;
                if ($scope.model.isMobile) $scope.idpSelect.defaultOption = $scope.idpSelect.preOption;
                $event.stopPropagation();
            },
            h5SubmitClick: function h5SubmitClick() {
                $scope.idpSelect.showOptions = false;
            },
            select: function select(option) {
                setTimeout(function () {
                    $scope.idpSelect.defaultOption = option;
                    $scope.idpSelect.showOptions = $scope.model.isMobile;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, 10);
            }
        };

        // 快捷登录按钮
        $scope.idpLoginBtn = {
            submitBtnText: i18n('idpLogin.goLogin'),
            disable: false,
            loginClick: function loginClick() {
                if (!$scope.idpAccountInput.value || $scope.idpAccountInput.error || $scope.idpSelect.disable) return;
                if ($scope.model.rememberChecked) {
                    var cookieObj = {
                        domainName: $scope.idpAccountInput.value,
                        selectedIdpId: $scope.idpSelect.defaultOption.id
                    };
                    cookieOp.addCookie('rememberChecked', 'true', cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie('enterprise_idp', JSON.stringify(cookieObj), cookieOp.DEFAULT_EXPIRES_TIME);
                } else {
                    cookieOp.delCookie('enterprise_idp');
                    cookieOp.delCookie('rememberChecked');
                }
                var url = 'https://auth.huaweicloud.com/authui/federation/websso?domain_id=' + $scope.idpAccountInput.domainId + '&idp=' + $scope.idpSelect.defaultOption.id + '&protocol=' + $scope.idpSelect.defaultOption.protocol.toLowerCase();
                var service = iamUtils.getUrlParams()['service'];
                if (service) {
                    url += '&service=' + encodeURIComponent(service);
                }
                window.location.href = url;
            }
        };
        // 联合用户登录end


        //悬浮在IAM账号用户名输入框时，显示tip
        $scope.bindIAMAccountTip = function () {
            var tip = i18n('iamAccountTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamAccountTipHelp');
                tip += iamUtils.i18nFormat('<a href=\'{0}\' target=\'_blank\'  tabindex=\'-1\'>{1}</a>', url, i18n('learnMore'));
            }
            $timeout(function () {
                showTooltip($('#IAMAccountInputId'), tip);
            });
        };

        $scope.bindIAMUsernameTip = function () {
            var tip = i18n('iamUsernameTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamUsernameTipHelp');
                tip += iamUtils.i18nFormat('<a href=\'{0}\' target=\'_blank\' tabindex=\'-1\'>{1}</a>', url, i18n('learnMore'));
            }
            $timeout(function () {
                showTooltip($('#IAMUsernameInputId'), tip);
            });
        };

        $scope.BiEvent = function () {
            try {
                var tempGa = $.extend([], arguments);
                tempGa[tempGa.length - 1] = 1;

                ga.apply(null, tempGa);
                var temp = $.extend([], arguments);
                send2CloudBISafe.apply(null, temp.slice(2));
            } catch (e) {
                console.dir(e);
            }
            return false;
        };

        $scope.goHwAccountLogin = function () {
            $scope.model.loginType = 'account';
            cookieOp.addCookie('last.login.type', 'account', cookieOp.DEFAULT_EXPIRES_TIME);
        };

        $scope.goIAMLogin = function () {
            send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step1', '', 'operation_iam_iamUserLogin_step1');
            if ($scope.model.isLiteSDK) {
                //liteSDK拉起自己的IAM用户登录页面
                if (window.webLoader) {
                    window.webLoader.intoApp('iam_login');
                }
            } else {
                $scope.model.loginType = 'iam';
                cookieOp.addCookie('last.login.type', 'iam', cookieOp.DEFAULT_EXPIRES_TIME);
            }
        };

        $scope.goIDPLogin = function () {
            $scope.model.loginType = 'idp';
            cookieOp.addCookie('last.login.type', 'idp', cookieOp.DEFAULT_EXPIRES_TIME);
        };
        $scope.hwportalLogin = function () {
            var url = '';
            var service = iamUtils.getUrlParams()['service'];
            if (service) {
                url = '/authui/saml/login?xAccountType=hwportal&service=' + encodeURIComponent(service);
            } else {
                url = '/authui/saml/login?xAccountType=hwportal';
            }
            window.location.href = url;
        };
        $scope.eChannelLogin = function () {
            var url = '/authui/saml/login?xAccountType=eChannel';
            if ($scope.ipIsInternational) {
                url = iamUtils.CONFIG.hkUserCenterUrl ? '/authui/saml/login?xAccountType=eChannel&service=' + encodeURIComponent(iamUtils.CONFIG.hkUserCenterUrl + '/#/userindex/allview') : url;
            } else {
                url = iamUtils.CONFIG.userCenterUrl ? '/authui/saml/login?xAccountType=eChannel&service=' + encodeURIComponent(iamUtils.CONFIG.userCenterUrl + '/#/userindex/allview') : url;
            }
            window.location.href = url;
        };

        $scope.originalLogin = function () {
            if ($scope.model.isLiteSDK) {
                //liteSDK拉起自己的华为云帐号登录页面
                if (window.webLoader) {
                    window.webLoader.intoApp('account_login');
                }
                return;
            }
            var params = window.location.search;
            if (params) {
                params += '&quickLogin=true';
            } else {
                params = '?quickLogin=true';
            }
            var url = '/authui/login.html' + params;
            if (iamUtils.CONFIG.hasHwid === 'true') {
                url += '#/login2';
            } else {
                url += '#/login';
            }
            window.location.href = url;
        };

        $scope.goFpwd = function (send, event, button, click, login_fpwd) {
            var fpwdURI = getFpwdUrl($scope);
            $scope.BiEvent(send, event, button, click, login_fpwd, fpwdURI);
            window.location.href = fpwdURI;
        };

        var send2CloudBISafe = function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e);
            }
        };

        function preValidCallback() {
            $scope.IAMVerifyCode.checkCode = '';
            $scope.$apply();
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=1&alt=' + Math.random();
            }
        }

        if (!$scope.model.isLiteSDK) {
            //liteSDK不再需要IAM用户登录
            // 回车键自动登录
            $(document).keydown(function (event) {
                if (event.keyCode === 13) {
                    var id = $(document.activeElement).attr('id');
                    if ($scope.IAMVerifyCode.isNeedVerifyCode && id === 'checkCodeId' || id === 'IAMUsernameInputId' || id === 'IAMPasswordInputId' || id === 'IAMAccountInputId' || id === 'loginBtn') {
                        $scope.loginBtn.loginClick();
                        $scope.$apply();
                    }
                }
            });
            if (!$scope.model.isMobile) {
                createAdvScript($scope, send2CloudBISafe);
            } // 广告页
            initUserType($scope);
            loadRiskJs($scope.cbcRiskcheckAddress);
            setLoginBtn($scope);
        }

        window.onresize = function () {
            $scope.model.isMobile = window.outerWidth > 500 ? false : true;
            $scope.QRLoginModel.hasQRLogin = iamUtils.CONFIG.hasQrlogin && !$scope.model.isMobile && !$scope.model.isLiteSDK && $scope.model.language === 'zh-cn';
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };

        // 设置默认广告位图片
        $scope.defaultLoginAdv = function () {
            var pageImgSrc = '';
            var pageImgHref = '';
            if ($scope.ipIsInternational) {
                // 国际IP
                switch (window.language) {
                    case 'zh-cn':
                        pageImgSrc = __webpack_require__(99);
                        pageImgHref = 'https://activity.huaweicloud.com/intl/zh-cn/free_packages/index.html';
                        break;
                    case 'en-us':
                        pageImgSrc = __webpack_require__(335);
                        pageImgHref = 'https://activity.huaweicloud.com/intl/en-us/free_packages/index.html';
                        break;
                    default:
                        pageImgSrc = __webpack_require__(99);
                        pageImgHref = 'https://activity.huaweicloud.com/intl/zh-cn/free_packages/index.html';
                        break;
                }
            } else {
                // 国内IP
                switch (window.language) {
                    case 'zh-cn':
                        pageImgSrc = __webpack_require__(65);
                        pageImgHref = 'https://www.huaweicloud.com/mobile_app/hwapp.html';
                        break;
                    case 'en-us':
                        pageImgSrc = __webpack_require__(98);
                        pageImgHref = 'https://activity.huaweicloud.com/intl/en-us/free_packages/index.html';
                        break;
                    default:
                        pageImgSrc = __webpack_require__(65);
                        pageImgHref = 'https://www.huaweicloud.com/mobile_app/hwapp.html';
                        break;
                }
            }
            document.getElementById('loginAdv').innerHTML = '<a href=\'' + pageImgHref + '\' target=\'_blank\' rel=\'noopener noreferrer\'><img id=\'loginAdImgDefault\' style=\'display:none\' src=\'' + pageImgSrc + '\'></a>';
            setTimeout(function () {
                if ($('#loginAdImgDefault')) {
                    $('#loginAdImgDefault').show();
                }
            }, 1000);
        };
        $scope.defaultLoginAdv();
    };

    function onSubmitBtnClick($scope) {
        // 校验不通过 不可提交
        if ($scope.loginBtn.disable) {
            return;
        }
        send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step2', '', 'operation_iam_iamUserLogin_step2');
        disabledLoginBtn($scope); //登录按钮置灰
        hideErrorMsg($scope);
        // recordLoginType($scope); // 记录登录方式到cookie
        cookieOp.delCookie('enterprise_idp');
        recordUserType($scope.model.loginType === 'iam'); // 记录 accountType，与更换手机号等页面兼容: BUG2019111401458
        var countryCode = $scope.model.defaultCode;
        if (countryCode === undefined) {
            countryCode = '';
        }
        var checkCode = $scope.IAMVerifyCode.isNeedVerifyCode ? $('#' + $scope.IAMVerifyCode.checkCodeId).val() : '';
        var passwd = $scope.IAMPasswordInput.value;
        if ($scope.IAMAccountInput.value === 'op_service') {
            $scope.IAMAccountInput.value = '';
            $scope.IAMUsernameInput.value = '';
            $scope.IAMPasswordInput.value = '';
            showErrAndRefCode($scope, 'domainWrong');
            return;
        }
        if (isValUnvalid($scope.IAMAccountInput.value)) {
            showErrAndRefCode($scope, 'accountNameBlank');
            return;
        }
        if (isValUnvalid($scope.IAMUsernameInput.value)) {
            showErrAndRefCode($scope, 'userNameBlank');
            return;
        }
        if (isValUnvalid(passwd)) {
            showErrAndRefCode($scope, 'pwdBlank');
            return;
        }
        if ($scope.IAMVerifyCode.isNeedVerifyCode && (isValUnvalid(checkCode) || checkCode.length > 4)) {
            showErrAndRefCode($scope, 'checkCodeBlank');
            return;
        }
        if (passwd.length > $scope.securityPolicy.passwordpolicy.password_maxlen) {
            $scope.IAMPasswordInput.value = '';
            showErrAndRefCode($scope, 'domainWrong');
            return;
        }

        var loginPostParams = {
            'userpasswordcredentials.domain': encodeURIComponent($scope.IAMAccountInput.value),
            'userpasswordcredentials.domainType': 'name',
            'userpasswordcredentials.username': encodeURIComponent($scope.IAMUsernameInput.value),
            'userpasswordcredentials.countryCode': countryCode,
            'userpasswordcredentials.verifycode': checkCode,
            'userpasswordcredentials.password': encodeURIComponent(passwd),
            'userpasswordcredentials.companyLogin': true,
            'userpasswordcredentials.userInfoType': getUserNameType($scope.IAMUsernameInput.value),
            'userpasswordcredentials.riskMonitorJson': JSON.stringify({
                'devID': get_Cookie('cbc-sid'),
                'hwMeta': document.getElementById('cbc-hwmeta') ? document.getElementById('cbc-hwmeta').value : ''
            }),
            __checkbox_warnCheck: 'true',
            'isAjax': 'true',
            Submit: 'Login'
        };
        doLogin('/authui/validateUser.action' + filterSearch(), loginPostParams);

        function doLogin(URL, PARAMS) {
            iamHttpService.post({
                url: URL,
                params: PARAMS
            }).then(function (data) {
                data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (data.loginResult === 'success') {
                    recordLoginCookie($scope, countryCode, 'forLogin'); // 登录成功后记录cookie
                    send2CloudBI(iamUtils.pages.login, 'iamUserLogin.success', '', 'operation_iam_iamUserLogin_success');
                    var redirectUrl;
                    var redirectUrlArr = data.redirectUrl.split('?');
                    if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                        var hash = redirectUrlArr[0].replace('/authui/', '').replace('.html', '');
                        if (redirectUrlArr.length > 1) {
                            redirectUrl = '?' + redirectUrlArr[1] + '#/' + hash;
                        } else {
                            redirectUrl = '#/' + hash;
                        }
                    } else {
                        redirectUrl = data.redirectUrl;
                    }
                    window.location.href = redirectUrl;
                } else if (data.loginResult === 'failed') {
                    recordLoginCookie($scope, countryCode, 'forFindPwd'); // 登录失败时 记录当前的帐号cookie 方便用户点击忘记密码时 回填在页面
                    if (data.authFailed === true) {
                        loginVerify($scope);
                    }
                    $scope.IAMPasswordInput.value = '';
                    showErrAndRefCode($scope, data.errorCode);
                    if (window.cbchwcap && window.cbchwcap.reload) {
                        window.cbchwcap.reload();
                    }
                } else {
                    $scope.IAMPasswordInput.value = '';
                    showErrAndRefCode($scope, '417');
                    if (window.cbchwcap && window.cbchwcap.reload) {
                        window.cbchwcap.reload();
                    }
                }
            }, function () {
                $scope.IAMPasswordInput.value = '';
                showErrAndRefCode($scope, '417');
                if (window.cbchwcap && window.cbchwcap.reload) {
                    window.cbchwcap.reload();
                }
            });
        }
    }

    function filterSearch() {
        var newSearch = '';
        var searchStr = window.location.search.substring(1);
        var params = searchStr.split('&');
        for (var index = 0; index < params.length; index++) {
            if (params[index].indexOf('=') !== -1) {
                var key = params[index].substring(0, params[index].indexOf('='));
                if (key === 'service') {
                    var service = params[index];
                    if (service.indexOf('hwclouds') !== -1) {
                        service = service.replace(/hwclouds/g, 'huaweicloud');
                    }
                    newSearch = newSearch + '&' + service;
                } else if (key !== 'step') {
                    newSearch = newSearch + '&' + params[index];
                }
            }
        }
        return newSearch === '' ? '' : '?' + newSearch.substring(1);
    }

    function get_Cookie(e) {
        var n,
            t = '',
            r = document['getElementById']('JSdev');
        if (r && !t) try {
            n = r.getsid() || '', t = n;
        } catch (o) {}
        try {
            window['localStorage'] && !t && (n = localStorage[e] || '', t = n);
        } catch (o) {}
        if (window['navigator']['cookieEnabled'] && !t) {
            var i = document['cookie']['indexOf'](e + '=');
            if (-1 != i) {
                i += e.length + 1;
                var a = document['cookie']['indexOf'](';', i);
                -1 == a && (a = document['cookie']['length']), n = decodeURIComponent(document['cookie']['substring'](i, a)) || '', t = n;
            }
        }

        return t;
    }

    // 检查登录使用的帐号是否需要填写图形验证码
    function loginVerify($scope) {
        if (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value) {
            $scope.IAMVerifyCode.isNeedVerifyCode = false;
            return;
        }
        var params;
        var IAMUsername = $scope.IAMUsernameInput.value.trim();
        var type = getUserNameType(IAMUsername);
        if (type === 'mobile') {
            var countryCode = $scope.model.defaultCode;
            IAMUsername = countryCode + '-' + IAMUsername;
        };
        params = {
            userName: IAMUsername,
            userType: type,
            accountName: $scope.IAMAccountInput.value ? encodeURIComponent($scope.IAMAccountInput.value) : ''
        };
        iamHttpService.post({
            url: '/authui/login/verify',
            params: params
        }).then(function (data) {
            $scope.IAMVerifyCode.isNeedVerifyCode = data.needVerify;
            $scope.$apply();
        }, function () {
            $scope.IAMVerifyCode.isNeedVerifyCode = true;
            $scope.$apply();
        });
    }

    // 展示错误信息，刷新图形验证码，恢复登录按钮
    function showErrAndRefCode($scope, errorScene) {
        showErrorMsg($scope, errorScene);
        refreshVerifyCode($scope);
        restoreLoginBtn($scope);
    }

    function createAdvScript($scope, send2CloudBISafe) {
        var loginAdv = document.getElementById('loginAdv');
        if (iamUtils.isShowByStyleOfSite() && loginAdv) {
            $('#loginAdv').empty();
            $('#loginAdv').append('<img id=\'loginlogo\'  />');
            $('#loginlogo').attr('src', getLogoOfRussia());
            return;
        }
        var pos = iamUtils.getUrlParams()['pos'];
        if (pos === '' || pos === undefined) {
            pos = 'login';
        }
        var oScript = document.createElement('script');
        oScript.type = 'text/javascript';
        var getAdApi = 'https://portal.huaweicloud.com/rest/cbc/portalapppublishservice/v1/ad/disp';
        var pos = '';
        var comp = '';
        if (loginAdv) {
            if ($scope.ipIsInternational) {
                // 国际IP
                switch (window.language) {
                    case 'zh-cn':
                        pos = 'www.huaweicloud.com/ad/login_board_en-zh.html';
                        comp = 'pep-ad-img_1620800848076';
                        break;
                    case 'en-us':
                        pos = 'www.huaweicloud.com/ad/login_board_en-us.html';
                        comp = 'pep-ad-img_1620800987830';
                        break;
                    default:
                        pos = 'www.huaweicloud.com/ad/login_board_en-us.html';
                        comp = 'pep-ad-img_1620800987830';
                        break;
                }
            } else {
                // 国内IP
                switch (window.language) {
                    case 'zh-cn':
                        pos = 'www.huaweicloud.com/ad/login_board.html';
                        comp = 'pep-ad-img_1619667657367';
                        break;
                    case 'en-us':
                        pos = 'www.huaweicloud.com/ad/login_board_ch-us.html';
                        comp = 'pep-ad-img_1620800651862';
                        break;
                    default:
                        pos = 'www.huaweicloud.com/ad/login_board_ch-us.html';
                        comp = 'pep-ad-img_1620800651862';
                        break;
                }
            }
            oScript.src = getAdApi + '?pos=' + pos + '&comp=' + comp + '&containerId=loginAdv&st=' + Math.random();
            loginAdv.appendChild(oScript);
        }
    }

    function initUserType($scope) {
        var idUrl = iamUtils.getUrlParams()['id'];
        // 根据url中是否带有id参数区分是否使用了 IAM用户登录链接
        if (idUrl === undefined) {
            // 上次登录的情形会被cookie last.login.type记录 默认区分 个人帐号和IAM用户登录方式
            if (cookieOp.getCookie('last.login.type') && cookieOp.getCookie('last.login.type') === 'iam') {
                $scope.model.loginType = 'iam';
                initIAMInput($scope);
                send2CloudBI(iamUtils.pages.login, 'iamUserLogin.step1', '', 'operation_iam_iamUserLogin_step1');
            } else if (cookieOp.getCookie('last.login.type') && cookieOp.getCookie('last.login.type') === 'idp') {
                $scope.model.loginType = 'idp';
            } else {
                $scope.model.loginType = 'account';
            }
        } else {
            $scope.model.loginType = 'iam';
            $scope.IAMAccountInput.value = encodeURIComponent(idUrl);
            $scope.IAMAccountInput.disable = true;
            $scope.IAMUsernameInput.value = '';
            $scope.IAMUsernameInput.getFocus();
            $scope.IAMPasswordInput.value = '';
            // 不记住登录名
            $scope.model.rememberChecked = false;
        }

        // 初始化企业联邦登录表单
        if (cookieOp.getCookie('rememberChecked') === 'true') {
            $scope.model.rememberChecked = true;
            try {
                var cookieObj = JSON.parse(cookieOp.getCookie('enterprise_idp'));
                if (cookieObj) {
                    $scope.idpAccountInput.value = cookieObj.domainName;
                    getIDPs($scope, cookieObj.selectedIdpId);
                }
            } catch (err) {}
        }

        if (!$scope.$$phase) {
            $scope.$apply();
        }
        return;
    }

    function isLogin($scope) {
        $.ajax({
            'type': 'GET',
            'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
            'url': '/authui/isLogin',
            'async': true,
            'success': function success(data) {
                data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (data.result === 'islogin' && data.code === 201 && data.status === 'success') {
                    // 说明已经有会话登录 重定向一次
                    window.location.href = '/authui/' + window.location.search;
                }
                if (data.code === 403) {
                    $scope.quickLoginModel.hasQuickLogin = true;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            },
            'error': function error() {
                showErrorMsg($scope, '417');
                setTimeout(function () {
                    hideErrorMsg($scope);
                }, 10000);
            }
        });
    }

    function disabledLoginBtn($scope) {
        var loginBtn = $('#loginBtn');
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n('logining'));
        $scope.loginBtn.disable = true;
    }

    function restoreLoginBtn($scope) {
        var loginBtn = $('#loginBtn');
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n('loginSubmit'));
        setLoginBtn($scope);
    }

    // 设置登录按钮的状态
    function setLoginBtn($scope) {
        if (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value || !$scope.IAMPasswordInput.value) {
            $scope.loginBtn.disable = true;
            return;
        }
        if ($scope.IAMVerifyCode.isNeedVerifyCode && !$scope.IAMVerifyCode.checkCode) {
            $scope.loginBtn.disable = true;
            return;
        }
        if ($scope.IAMLoginErrorMsg.show) {
            $scope.loginBtn.disable = true;
            return;
        }
        $scope.loginBtn.disable = false;
        return;
    }

    function refreshVerifyCode($scope) {
        if ($scope.IAMVerifyCode.isNeedVerifyCode) {
            $scope.IAMVerifyCode.getVerifyCode();
        }
    }

    function getUserNameType(userName) {
        var emailPattern = iamUtils.EmailRegex;
        var phonePattern = /^[0-9]\d*$/;
        if (emailPattern.test(userName)) {
            return 'email';
        } else if (phonePattern.test(userName)) {
            return 'mobile';
        } else {
            return 'name';
        }
    };

    function showErrorMsg($scope, errorCode) {
        if (errorCode && $scope.domainErrorMsgObj[errorCode]) {
            // 帐号名输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.domainErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.domainError = true;
        } else if (errorCode && $scope.usernameErrorMsgObj[errorCode]) {
            // IAM用户名输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.usernameErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.usernameError = true;
        } else if (errorCode && $scope.pwdErrorMsgObj[errorCode]) {
            // 密码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.pwdErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.pwdError = true;
        } else if (errorCode && $scope.nameOrPwdErrorMsgObj[errorCode]) {
            // IAM用户名及密码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.nameOrPwdErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.nameOrPwdError = true;
        } else if (errorCode && $scope.verifycodeErrorMsgObj[errorCode]) {
            // 图形验证码输入框报错
            $scope.IAMLoginErrorMsg.content = $scope.verifycodeErrorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.verifycodeError = true;
        } else if (errorCode && $scope.errorMsgObj[errorCode]) {
            // 其他系统报错
            $scope.IAMLoginErrorMsg.content = $scope.errorMsgObj[errorCode];
            // $scope.IAMLoginErrorMsg.show = true;
        } else if (errorCode) {
            if (errorCode == i18n('isRuUser')) {
                $scope.IAMLoginErrorMsg.content = i18n('isRuUser1');
                $scope.IAMLoginErrorMsg.goLoginShow = true;
                $scope.IAMLoginErrorMsg.goLoginHref = 'https://' + 'auth-intl.huaweicloud.com' + '/authui/?locale=' + window.language;
                $scope.IAMLoginErrorMsg.goLoginContent = i18n('goLogin.ru');
            } else if (errorCode == 416) {
                $scope.IAMLoginErrorMsg.content = i18n('clientIpInvalid');
                $scope.IAMLoginErrorMsg.goLoginShow = true;
                $scope.IAMLoginErrorMsg.goLoginHref = iamUtils.CONFIG.helpCenterUrl + i18n('clientIpInvalid.helpUrl');
                $scope.IAMLoginErrorMsg.goLoginContent = i18n('clientIpInvalid.learnMore');
            } else {
                $scope.IAMLoginErrorMsg.content = errorCode;
            }
            // $scope.IAMLoginErrorMsg.show = true;
        }

        $scope.IAMLoginErrorMsg.content = $scope.$sce.trustAsHtml($scope.IAMLoginErrorMsg.content);

        $scope.IAMLoginErrorMsg.show = true;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function hideErrorMsg($scope) {
        $scope.IAMLoginErrorMsg.show = false;
        $scope.IAMLoginErrorMsg.goLoginShow = false;
        $scope.IAMLoginErrorMsg.domainError = false;
        $scope.IAMLoginErrorMsg.usernameError = false;
        $scope.IAMLoginErrorMsg.pwdError = false;
        $scope.IAMLoginErrorMsg.nameOrPwdError = false;
        $scope.IAMLoginErrorMsg.verifycodeError = false;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function isValUnvalid(value) {
        return value === '' || value === undefined;
    }

    function showTooltip(ele, content) {

        var tipHtml = '<div class="iam-name-tooltip" \
                                style="display: block;" tabindex="-1"> \
                                <div class="iam-ti-tooltip-content"  \
                                style="overflow-y: auto; padding: 1px; white-space: normal;"> \
                                TIP_CONTENT</div></div>'.replace('TIP_CONTENT', content);

        var tip;
        var isShown = false;

        var addTip = function addTip() {
            tip = $(tipHtml);
            tip.css('left', 0);
            tip.css('width', ele.outerWidth());
            ele.parent().append(tip);
            tip.css('top', ele.outerHeight());
            tip.mouseleave(function () {
                tip && tip.remove();
            });
            isShown = true;
        };

        ele.mouseenter(function () {
            //光标进入元素区域，显示tip
            setTimeout(function () {
                if (ele.is(':hover') && !isShown && !ele.val()) {
                    addTip();
                }
            }, 500);
        }).mouseleave(function () {
            //若光标移动到tip上，不自动消失
            setTimeout(function () {
                if (!tip.is(':hover')) {
                    isShown = false;
                    tip && tip.remove();
                }
            }, 300);
        }).on('keyup', function (e) {
            //回车后移除tip
            setTimeout(function () {
                if (e.which == 13 || ele.val()) {
                    isShown = false;
                    tip && tip.remove();
                } else if (ele.is(':hover') && !isShown) {
                    addTip();
                }
            });
        }).click(
        //兼容移动端触摸场景
        function () {
            if (ele.is(':hover') && !isShown && !ele.val()) {
                addTip();
            }
        }).blur(function () {
            tip && !tip.is(':hover') && tip.remove();
            isShown = false;
        });
    }

    function recordUserType(isCompany) {
        var value = isCompany ? 'company' : 'personal';
        cookieOp.addCookie('accountType', value, cookieOp.DEFAULT_EXPIRES_TIME);
    }

    function recordLoginCookie($scope, countryCode, type) {
        // 登录方式的cookie
        cookieOp.delCookie('loginType');
        // 记住登录名的cookie
        cookieOp.delCookie('rememberChecked');
        // 帐号登录方式时主帐号
        cookieOp.delCookie('personalAccount');
        // IAM登录方式 主帐号
        cookieOp.delCookie('IAMAccount');
        // IAM登录方式 子用户
        cookieOp.delCookie('IAMUsername');
        // IAM登录方式 子用户是手机时
        cookieOp.delCookie('countryCode');
        cookieOp.delCookie('mobile');
        if (type === 'forFindPwd') {
            // 登录失败时 为找回密码页面记录cookie
            if ($scope.model.loginType === 'iam') {
                cookieOp.addCookie('loginType', 'company', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else if (type === 'forLogin') {
            // 登录之后清除标记了找回密码方式的cookie
            cookieOp.delCookie('findPwdEnd');
            if ($scope.model.rememberChecked && $scope.model.loginType === 'iam') {
                // IAM用户登录方式
                cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('rememberChecked', true, cookieOp.DEFAULT_EXPIRES_TIME);
            }
        }
    }

    function getFpwdUrl($scope) {
        var serviceParam = '';
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
            serviceParam = '&service=' + encodeURIComponent(service);
        }
        return '/authui/login.html?locale=' + window.language + '&UserType=' + ($scope.model.loginType === 'iam' ? 'e' : 'p') + serviceParam + '#/fpwd';
    }

    // 调用authui/getSDKBaseInfo接口获取js-sdk的url及配置信息
    function getSDKBaseInfo($scope) {
        var params = {
            flowType: 'unionLogin'
        };
        if (utils.getUrlParams().service) {
            params.service = utils.getUrlParams().service;
        }
        iamHttpService.get({
            url: '/authui/getSDKBaseInfo',
            params: params
        }).then(function (data) {
            data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.isSuccess === 1) {
                data.businessConfig = _typeof(data.businessConfig) === 'object' ? data.businessConfig : $.parseJSON(data.businessConfig);
                var baseConfig = {
                    'isSuccess': '1',
                    'pageTokenKey': data.pageTokenKey,
                    'pageToken': data.pageToken,
                    'jsSdkUrl': data.jsSdkUrl,
                    'hwidConfig': data.hwidConfig
                };
                $scope.model.privacyLink = data.businessConfig.unifiedIDPrivacyUrl; //隐私链接
                baseConfig.businessConf = {
                    flowType: 'unionLogin', //使用场景unionLogin
                    clientType: $scope.model.isMobile || $scope.model.isLiteSDK ? 'mobileWap' : 'pcWeb', //手机还是pc
                    showType: 'page', // 展示方式
                    loginCallback: function loginCallback() {
                        postRiskData();
                        recordUserType($scope.model.loginType === 'iam');
                    },
                    mountedCallback: function mountedCallback() {
                        $scope.model.sdkLoading = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                };
                delete window.hwidSDK; //避免对二次渲染产生影响
                loadJsSDK($scope, baseConfig);
            } else {
                $scope.model.sdkLoading = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            $scope.model.sdkLoading = false;
        });
    }

    // 获取js-sdk并渲染登录框
    function loadJsSDK($scope, baseConfig) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (script.readyState) {
            // IE
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    try {
                        script.onreadystatechange = null;
                        hwidSDK.init(baseConfig);
                    } catch (e) {
                        $scope.model.sdkLoading = false;
                    }
                }
            };
        } else {
            // 其他浏览器
            script.onload = function () {
                try {
                    hwidSDK.init(baseConfig);
                } catch (e) {
                    $scope.model.sdkLoading = false;
                }
            };
            script.onerror = function () {
                $scope.model.sdkLoading = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            };
        }
        script.src = baseConfig.jsSdkUrl;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    //加载cbc风控组件
    function loadRiskJs(url) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    // 传递风控数据
    function postRiskData() {
        var params = {
            'devID': get_Cookie('cbc-sid'),
            'hwMeta': document.getElementById('cbc-hwmeta') ? document.getElementById('cbc-hwmeta').value : ''
        };
        iamHttpService.post({
            url: '/authui/riskData',
            params: params
        }).then(function (data) {
            // 不管成功还是失败不做任何操作，不阻塞后面的进程               
        }, function () {
            // 不管成功还是失败不做任何操作，不阻塞后面的进程
        });
    }

    // 获取下载APP链接
    function getDownloadUrl() {
        return 'https://www.huaweicloud.com/mobile_app/hwapp.html';
    }

    // 获取登录凭证并生成二维码
    function QRCodeInit($scope, $timeout, $interval, iamUtils, send2CloudBISafe) {
        $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title1');
        $scope.QRLoginModel.QRCodeStatus = 'new';
        $scope.QRLoginModel.QRCodeInvalid = false;
        iamHttpService.get({
            url: '/authui/qrcode',
            cache: false,
            params: {}
        }).then(function (data) {
            data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            $scope.QRLoginModel.clientKey = data.client_key;
            $timeout(function () {
                var loginQRCodeDiv = document.querySelector('#loginQRCodeDiv');
                loginQRCodeDiv.innerHTML = '';
                QRCode.toCanvas(loginQRCodeDiv, data.qrcode_content, {
                    margin: 0,
                    width: 260
                });
            }, 0);
            countDown($scope, $interval, iamUtils);
            pollingCodeStatus($scope, $interval, iamUtils, send2CloudBISafe);
        }, function () {
            // 异常情况
            $scope.QRLoginModel.QRCodeInvalid = true;
            $scope.$apply();
        });
    }

    // 二维码失效时间倒计时
    function countDown($scope, $interval, iamUtils) {
        var count = 0;
        $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME - count);
        $interval.cancel($scope.QRLoginModel.countDownInterval);
        $scope.QRLoginModel.countDownInterval = $interval(function () {
            count++;
            if (count < QRCODE_VALID_TIME) {
                $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n('QRLogin.remainingTime'), QRCODE_VALID_TIME - count);
            } else {
                $scope.QRLoginModel.QRCodeInvalid = true;
                $interval.cancel($scope.QRLoginModel.countDownInterval);
                $interval.cancel($scope.QRLoginModel.pollingInterval);
            }
        }, 1000);
    }

    // 轮询登录状态 
    function pollingCodeStatus($scope, $interval, iamUtils, send2CloudBISafe) {
        var params = {};
        params.client_key = $scope.QRLoginModel.clientKey;
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
            params.redirect_url = service;
        }
        $interval.cancel($scope.QRLoginModel.pollingInterval);
        $scope.QRLoginModel.pollingInterval = $interval(function () {
            iamHttpService.get({
                url: '/authui/qrcode/status',
                cache: false,
                params: params
            }).then(function (data) {
                data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (data.error_code && data.error_code == '427') {
                    window.location.href = '/authui/' + window.location.search;
                } else if (data.status == 'authorizing') {
                    send2CloudBISafe(iamUtils.pages.login, 'click_scanQRCode');
                    $scope.QRLoginModel.QRCodeStatus = 'authorizing';
                    $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title2');
                    $interval.cancel($scope.QRLoginModel.countDownInterval);
                } else if (data.status == 'refused' || data.status == 'expired') {
                    $scope.QRLoginModel.QRCodeStatus = 'refused';
                    $scope.QRLoginModel.QRLoginTitle = i18n('QRLogin.title2');
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                } else if (data.status == 'authorized') {
                    window.location.href = data.redirect_url;
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            }, function () {});
        }, 3000);
    }

    function getRegistUrl($scope) {
        var service_url = iamUtils.getUrlParams()['service'];
        var registUrl = $scope.ipIsInternational ? iamUtils.CONFIG.cbcRegUrlIntl : iamUtils.CONFIG.cbcRegUrl;
        registUrl += '&hwid=login';
        registUrl += service_url ? '&service=' + encodeURIComponent(service_url) : '';
        return registUrl;
    }

    //根据输入获取用户列表
    function getUserList($scope, type) {
        var params = {
            type: type,
            value: $scope.quickAccountInput.value
        };
        iamHttpService.post({
            url: '/authui/checkexist',
            params: params
        }).then(function (data) {
            var data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                // 记录旧值 防止多次请求
                $scope.quickAccountInput.oldValue = $scope.quickAccountInput.value;
                if (data.count == 0) {
                    $scope.quickAccountInput.error = i18n('fpwd.EnterCorrectEnterpriseAccount');
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    return;
                }
                //过滤出已绑定了手机或邮箱的账号
                $scope.quickLoginUsers.options = [];
                for (var i = 0; i < data.users.length; i++) {
                    if (data.users[i].mobile || data.users[i].email) {
                        $scope.quickLoginUsers.options.push(data.users[i]);
                    }
                }
                if ($scope.quickLoginUsers.options.length > 1) {
                    $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.options[0];
                    $scope.quickLoginUsers.selectedUserTemp = $scope.quickLoginUsers.selectedUser;
                    $scope.quickLoginUsers.btnClick();
                    //只有输入手机的情况才需要到选择用户页面
                    if (params.type === 'mobile') {
                        if ($scope.model.isMobile) {
                            $scope.quickLoginUsers.dropdownOpen = true;
                        } else {
                            $scope.quickLoginModel.showSelectStep = true;
                        }
                    }
                } else if ($scope.quickLoginUsers.options.length == 1) {
                    $scope.quickLoginUsers.selectedUser = $scope.quickLoginUsers.options[0];
                } else {
                    $scope.quickAccountInput.error = i18n('quickLogin.notAllowed');
                }
                if ($scope.quickLoginUsers.options.length > 0) {
                    $scope.quickLoginCode.mobileBtnDisabled = false;
                    $scope.quickLoginCode.emailBtnDisabled = false;
                    setQuickLoginType($scope, type);
                }
            } else {
                // 请求返回错误
                $scope.quickAccountInput.error = i18n('systemException');
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function () {
            $scope.quickAccountInput.error = i18n('systemException');
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    //根据用户切换验证方式
    function setQuickLoginType($scope, type) {
        if (type === 'name') {
            if ($scope.quickLoginUsers.selectedUser.mobile) {
                $scope.quickLoginModel.loginTypeChange('mobile');
            } else {
                $scope.quickLoginModel.loginTypeChange('email');
            }
        } else {
            if (type === 'mobile' && $scope.quickLoginModel.loginType === 'email') {
                $scope.quickLoginModel.loginTypeChange('mobile');
            } else if (type === 'email' && $scope.quickLoginModel.loginType === 'mobile') {
                $scope.quickLoginModel.loginTypeChange('email');
            }
        }
    }

    //快捷登录验证码倒计时
    function quickLoginCountDown($scope, $interval, iamUtils) {
        var type = $scope.quickLoginModel.loginType;
        if (type === 'email') {
            var count = 0;
            $scope.quickLoginCode.emailBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
            $scope.quickLoginCode.emailBtnDisabled = true;
            $interval.cancel($scope.quickLoginCode.emailInterval);
            $scope.quickLoginCode.emailInterval = $interval(function () {
                count++;
                if (count < 60) {
                    $scope.quickLoginCode.emailBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
                } else {
                    $scope.quickLoginCode.emailBtnDisabled = false;
                    $scope.quickLoginCode.emailBtnTxt = i18n('quickLogin.codeBtn');
                }
            }, 1000);
        } else {
            var count = 0;
            $scope.quickLoginCode.mobileBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
            $scope.quickLoginCode.mobileBtnDisabled = true;
            $interval.cancel($scope.quickLoginCode.mobileInterval);
            $scope.quickLoginCode.mobileInterval = $interval(function () {
                count++;
                if (count < 60) {
                    $scope.quickLoginCode.mobileBtnTxt = iamUtils.i18nFormat(i18n('quickLogin.codeCountdown'), 60 - count);
                } else {
                    $scope.quickLoginCode.mobileBtnDisabled = false;
                    $scope.quickLoginCode.mobileBtnTxt = i18n('quickLogin.codeBtn');
                }
            }, 1000);
        }
    }

    //通过domainName获取idp列表
    function getIDPs($scope, defaultSelectId) {
        iamHttpService.post({
            url: '/authui/identityProviders',
            params: {
                domain_name: encodeURIComponent($scope.idpAccountInput.value)
            }
        }).then(function (data) {
            data = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
            $scope.idpSelect.selectOptions = [];
            $scope.idpAccountInput.domainId = data.domain_id;
            $scope.idpAccountInput.oldValue = $scope.idpAccountInput.value;
            for (var i = 0; i < data.identity_providers.length; i++) {
                $scope.idpSelect.selectOptions.push({
                    name: data.identity_providers[i].id,
                    id: data.identity_providers[i].id,
                    protocol: data.identity_providers[i].protocol
                });
                if (data.identity_providers[i].id === defaultSelectId) {
                    $scope.idpSelect.defaultOption = $scope.idpSelect.selectOptions[$scope.idpSelect.selectOptions.length - 1];
                }
            }
            if ($scope.idpSelect.selectOptions.length === 0) {
                $scope.idpAccountInput.error = $scope.errorMsgObj['noIdps'];
            } else {
                if (!$scope.idpSelect.defaultOption.id) {
                    $scope.idpSelect.defaultOption = $scope.idpSelect.selectOptions[0];
                }
                $scope.idpSelect.disable = false;
            }

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function (data) {
            var response = _typeof(data.responseText) === 'object' ? data.responseText : $.parseJSON(data.responseText);
            if (response.error_code === 'IAM.0004') response.error_code = 'noIdps';
            if (response.lock_time) response.error_code = 'idpIpLock';
            $scope.idpAccountInput.error = $scope.getErrorInfo(response.error_code);
            if (response.lock_time) $scope.idpAccountInput.error = iamUtils.i18nFormat($scope.idpAccountInput.error, response.lock_time);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    function initIAMInput($scope) {
        if ($scope.model.loginType === 'iam' && (cookieOp.getCookie('findPwdEnd') === 'ok' || cookieOp.getCookie('rememberChecked'))) {
            $scope.IAMAccountInput.value = cookieOp.getCookie('IAMAccount');
            $scope.IAMUsernameInput.value = cookieOp.getCookie('IAMUsername');
            loginVerify($scope);
        }
    }

    loginCtrl = ['$scope', '$sce', '$filter', '$interval', '$timeout', 'securityPolicy', '$state', loginCtrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.login.ctrl', loginCtrl);

    return loginCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__))), !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(23), __webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (cookieOp, perVerifycodeUtil, iamHttpService, utils) {
    "use strict";

    var i18n, iamUtils, me, $state;

    function LoginController($scope, $timeout, securityPolicy, _i18n, _iamUtils, _$state) {
        $state = _$state;
        i18n = _i18n;
        iamUtils = _iamUtils;
        me = this;

        $scope.goLoginType = "HWS";

        document.title = i18n("titles.login");

        $scope.i18n = i18n;
        $scope.securityPolicy = securityPolicy;

        // 是否为国际IP
        $scope.ipIsInternational = iamUtils.ipIsInternational();

        function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e);
            }
        }

        $scope.model = {
            // 密码的显示与隐藏
            pwdVisible: false,
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.model.pwdVisible = !$scope.model.pwdVisible;
                var type = $scope.model.pwdVisible ? "text" : "password";
                $("#pwdId>input").attr("type", type);
            },

            width: iamUtils.layout.inputFiledWidth,
            widthHalf: "49%",
            height: iamUtils.layout.inputFieldHeight,
            optionWidth: "110px",
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            scrollHeight: iamUtils.layout.scrollHeight,
            homepageUrl: iamUtils.CONFIG.homepageUrl,
            pageImgSrc: me.getPageImgSrc(),
            submitBtnText: i18n('loginSubmit'),
            maxLength: 4,
            userNamePH: me.getLastLoginUserType() === "company" ? i18n("userNamePlaceHolder") : i18n("accountNamePlaceHolder"),
            userNamePH_HK: me.getLastLoginUserType() === "company" ? i18n("HongKongUserNamePlaceHolder") : i18n("HongKongAccountNamePlaceHolder"),
            currentUserType: i18n("enterpriseUser"),
            otherUserType: i18n("personageUser"),
            countryCode: "",
            codeJson: "",
            codeArray: [],
            defaultCode: "",
            goLogin: "",
            goLogin1: "",
            matchMethod: function matchMethod(keyword, op) {
                keyword = keyword.trim();
                if (op.toLowerCase().indexOf(keyword.toLowerCase()) >= 0 || keyword == "00" + op.substring(op.indexOf("+") + 1, op.indexOf(")"))) {
                    return true;
                }
            },
            isCompany: me.getLastLoginUserType() === "company",
            accountNameId: "accountNameId",
            accountNamePH: i18n("accountPlaceHolder"),
            accountFocused: this.isCompany ? true : false,
            lastAccountName: iamUtils.needRecordUsername ? cookieOp.getCookie("account") : "",
            userNameId: "userNameId",
            // nameFocused: false,
            userNameCookie: iamUtils.needRecordUsername,
            lastUserName: iamUtils.needRecordUsername ? cookieOp.getCookie("name") : "",
            codeSelectId: "codeSelectId",
            mobileNumberLogin: i18n('mobileNumberLogin'),
            noMobileLogin: i18n("noMobileLogin"),
            mobileLogin: false,
            phoneIAMFocused: false,
            phoneMaxLength: 225,
            tipPosition: "top",
            lastPhoneAccountName: iamUtils.needRecordUsername ? cookieOp.getCookie("mobile") : "",
            pwdId: "pwdId",
            pwdPH: i18n("passwdPlaceHolder"),
            pwdType: "password",
            pwdFocused: false,
            pwdChange: function pwdChange() {
                var val = $("#" + $scope.model.pwdId + ">input").length > 0 ? $("#" + $scope.model.pwdId + ">input").val() : "";
                var pwdInputObj = $("#" + $scope.model.pwdId + ">input");
                //firefox bug: type first character and change input type, cursor will jump forward,so move it end.
                if (val.length === 1) {
                    if (pwdInputObj.length > 0) {
                        var input = pwdInputObj[0];

                        if (input.createTextRange) {
                            //IE
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.move('character', 1);
                            range.select();
                        } else if (input.setSelectionRange) //other browsers
                            {
                                input.setSelectionRange(1, 1);
                                input.focus();
                            }
                    }
                }
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $timeout(function () {
                    $scope.$digest();
                });
            },
            pwdBlur: function pwdBlur() {
                send2CloudBISafe("input", "change", "login_" + ($scope.model.isCompany ? 'company' : 'personal') + "_password", "***");
            },
            checkCodeId: "checkCodeId",
            checkCodePH: i18n("verifyCodePlaceHolder"),
            checkCodeTip: i18n("getVerifyCode"),
            initRandom: Math.random(),
            chkTxt: i18n("rememberName"),
            chkId: "chkId",
            // 记住登录名国内IP默认勾选 海外IP根据cookie
            rememberChecked: $scope.ipIsInternational ? cookieOp.getCookie("rememberChecked") ? true : false : true,
            checkCodeErrorMsg: "",
            isSubmitBtnDisabled: false,
            verifycode: "/authui/verifycode?index=1&alt=" + Math.random(),
            isNeedVerifyCode: false,
            isCookieEnable: navigator.cookieEnabled,
            cookieURL: getCookieURL(me.getLastLoginUserType() === "company"),
            areaCodeDisabled: false,
            countryCodeValue: "",
            checkErrorInfo: "",
            errorMsgObj: {
                "401": i18n("wrongNamePwd"),
                "402": i18n("wrongNamePwdoneChances"),
                "403": i18n("wrongNamePwdTwoChances"),
                "404": i18n("wrongNamePwdThreeChances"),
                "405": i18n("wrongNamePwdFourChances"),
                "406": i18n("invalidInput"),
                "407": i18n("invalidInputoneChances"),
                "408": i18n("invalidInputTwoChances"),
                "409": i18n("invalidInputThreeChances"),
                "410": i18n("invalidInputFourChances"),
                "411": i18n("wrongVerifyCode"),
                "412": i18n("loginReactivateFail"),
                "413": i18n("userAccountsLocked"),
                "414": i18n("domainuserAccountsLocked"),
                "415": i18n("userAccountsLocked"),
                "417": i18n("systemException"),
                "418": i18n("verifyCode.error"),
                "419": i18n("verifyCode.invalid"),
                "420": i18n("userAccountsStopped"),
                "423": i18n("serviceUrlInvalid"),
                "424": i18n("maxSessionLimit"),
                "427": i18n("multiUserInvalid"),
                "428": i18n("accountClosed"),
                "430": i18n("hasBindUniportal"),
                "432": i18n("pageTimeout"),
                "508121000": i18n("wrongIPBlacklist"),
                "508121001": i18n("wrongIPFrequencyLimiting"),
                "508121002": i18n("wrongEquipmentIDFrequencyLimiting"),
                "508121003": i18n("MachineOperation")

            }
        };

        $(document).keydown(function (event) {
            if (event.keyCode === 13) {
                var id = me.getActiveElementId();
                if ($(document.activeElement).attr("id") === "loginBtn" || $scope.model.isNeedVerifyCode && id === "checkCodeId" || id === "personalAccountInputId" || id === "personalPasswordInputId" || id === "mobilePasswordInputId" || id === "IAMAccountInputId" || id === "IAMUsernameInputId" || id === "IAMPasswordInputId") {
                    $scope.loginClick();
                    $scope.$apply();
                }
            }
        });

        $scope.model.codeSelectWidth = "115px";
        $scope.model.codeInputWidth = "165px";
        $scope.model.registUrl = getRegistUrl();
        $scope.model.checkFlag = false;

        initCountryCode($scope, initUserType);
        $scope.model.countryCodeValidator = iamUtils.validator.countryCode($scope.model.codeArray);

        $scope.loginClick = function () {
            send2CloudBISafe("button", "click", "login_" + ($scope.model.isCompany ? 'company' : 'personal'), '');
            me.onSubmitBtnClick($scope);
        };

        $scope.BiEvent = function () {
            try {
                var tempGa = $.extend([], arguments);
                tempGa[tempGa.length - 1] = 1;

                ga.apply(null, tempGa);
                var temp = $.extend([], arguments);
                send2CloudBI.apply(null, temp.slice(2));
            } catch (e) {
                console.dir(e);
            }
            return false;
        };

        $scope.model.getVerifyCode = function () {
            send2CloudBISafe("button", "click", "login_" + ($scope.model.isCompany ? 'company' : 'personal') + "_getVerifyCode", '');
            var verifyCodeImg = $("#inputVerifyCodeImg")[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = "/authui/verifycode?index=1&alt=" + Math.random();
            }
            $scope.model.checkCode = "";
            $("#validresultImg").hide();
        };

        showErrorMsg($scope, $("#loginServerErrorMsg")[0].innerHTML);

        $("#ownerLogin").on("mousedown keydown", function (event) {
            if (event.button == 0 || event.keyCode == 13) {
                $scope.model.isCompany = false;
                $scope.model.defaultValue = $scope.model.defaultCode;
                $scope.model.isIAMUserLogin = true;
                me.onUserTypeChange($scope, $timeout);
                $("#validresultImg").hide();
            }
        });
        $("#subUserLogin").on("mousedown keydown", function (event) {
            if (event.button == 0 || event.keyCode == 13) {
                $scope.model.isCompany = true;
                $scope.model.defaultValue = $scope.model.defaultCode;
                $scope.model.isIAMUserLogin = false;
                me.onUserTypeChange($scope, $timeout);
                $scope.$digest();
                $("#validresultImg").hide();
            }
        });

        //支持tab+enter键切换
        $("#typeSwitchBtn").on("keydown", function (event) {
            if (event.keyCode === 13) {
                $scope.mobileLoginModel.switchTypeClick({ which: 1 });
                $scope.$apply();
            }
        });

        $scope.model.preValidVerifyCode = function (event, value) {
            var img = $("#validresultImg");
            perVerifycodeUtil.preValidVerifyCode(img, value, "1", preValidCallback, iamHttpService, i18n);
        };

        $scope.model.preValidVerifyCodeBlur = function (event, value) {
            send2CloudBISafe("input", "change", "login_" + ($scope.model.isCompany ? 'company' : 'personal') + "_VerifyCode", $scope.model.checkCode);
        };

        $scope.model.rememberCheckedChange = function (event, value) {
            send2CloudBISafe("input", "change", "login_" + ($scope.model.isCompany ? 'company' : 'personal') + "_rememberChecked", $scope.model.rememberChecked);
        };

        function preValidCallback() {
            $scope.model.checkCode = "";
            $scope.$apply();
            var verifyCodeImg = $("#inputVerifyCodeImg")[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = "/authui/verifycode?index=1&alt=" + Math.random();
            }
        }

        $scope.model.accountValidator = [iamUtils.validator.childValidator.limitLength(255)];
        $scope.model.userValidator = [iamUtils.validator.childValidator.limitLength(255)];
        $scope.model.pwdValidator = [iamUtils.validator.childValidator.limitLength(128)];
        $scope.model.checkCodeValidator = [iamUtils.validator.childValidator.limitLength(4)];

        //$scope.defaultLoginAdv();

        $scope.defaultLoginAdv = function () {
            document.getElementById("loginAdv").innerHTML = "<img id='loginAdImgDefault' style='display:none' src='" + $scope.model.pageImgSrc + "'>";
            setTimeout(function () {
                if ($("#loginAdImgDefault")) {
                    $("#loginAdImgDefault").show();
                }
            }, 1000);

            document.getElementById("loginAdv").onclick = function () {
                send2CloudBISafe("input", "change", "login_" + ($scope.model.isCompany ? 'company' : 'personal') + "_loginAdv", $scope.model.pageImgSrc);
            };
        };

        $scope.defaultLoginAdv();
    }

    LoginController.prototype.getActiveElementId = function () {
        return $(document.activeElement.parentNode).attr("id");
    };

    function getCookieURL(isCurCompany) {
        // return "/authui/login.html?locale=" + window.language + "&UserType=" + (isCurCompany ? "e" : "p") + getServiceFromUrl() + "#/closecookie";
        return "#/closecookie?locale=" + window.language + "&UserType=" + (isCurCompany ? "e" : "p") + getServiceFromUrl();
    }

    function getServiceFromUrl() {
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            return "&service=" + encodeURIComponent(service);
        }
        return "";
    }

    function getRegistUrl() {
        var callbackUrl = window.location.search;
        var registUrl = "/authui/auth.html?locale=" + window.language + getServiceFromUrl() + "#/register";

        //将BP注册入口集成到IAM登陆界面
        if (decodeURIComponent(callbackUrl).indexOf("//bp.huaweicloud.com") != -1) {
            registUrl = "https://bp.huaweicloud.com/customer/account/registera";
        }
        return registUrl;
    }

    function initCountryCode($scope, callback) {
        var codeArray = [];
        iamHttpService.get({
            url: "/authui/getCountryCode",
            params: {}
        }).then(function (data) {
            data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : $.parseJSON(data);
            var codeList = data["codeArray"];
            var defaultCode = data["defaultCode"];
            if (codeList.length) {
                codeList = codeList.sort(iamUtils.SortArray('label'));
                $scope.model.codeJson = codeList;
                $scope.model.defaultValue = iamUtils.getCountryValue(codeList, defaultCode);
                $scope.model.defaultCode = iamUtils.getCountryValue(codeList, defaultCode);
                $scope.model.countryCodeValue = $scope.model.defaultValue;
                for (var item in codeList) {
                    if (codeList[item].id === defaultCode) {
                        codeArray.push(codeList[item].label);
                    }
                }
                $scope.model.codeValues = codeArray;
                callback($scope);
            }
        }, function () {
            callback($scope);
        });
        $scope.model.codeArray = codeArray;
    }
    LoginController.getServiceFromUrl = getServiceFromUrl;

    LoginController.prototype.getLastLoginUserType = function () {
        var loginType = cookieOp.getCookie("loginType");
        if (loginType === undefined) {
            return "";
        } else {
            return loginType;
        }
    };

    function recordLoginType($scope) {
        // 如果未勾选 记住登录名 则不记录上次的登录方式
        if ($scope.model.rememberChecked) {
            var value = $scope.model.isCompany ? "company" : "personal";
            if ($scope.model.mobileLogin) {
                value = "mobile";
            }
            cookieOp.addCookie("loginType", value, cookieOp.DEFAULT_EXPIRES_TIME);
        }
    }

    function recordUserType(isCompany) {
        var value = isCompany ? "company" : "personal";
        cookieOp.addCookie("accountType", value, cookieOp.DEFAULT_EXPIRES_TIME);
    }

    function recordLoginCookie($scope, countryCode, type) {
        if (type === "forLogin") {
            // 登录成功时 为登录页面记录cookie
            if (!$scope.model.userNameCookie) {
                return;
            }
            // 登录之后清除标记了找回密码方式的cookie
            cookieOp.delCookie("findPwdEnd");

            if ($scope.model.rememberChecked) {
                if ($scope.model.isCompany) {
                    // IAM用户登录方式
                    cookieOp.addCookie("IAMAccount", $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie("IAMUsername", $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                } else {
                    // 个人帐号登录方式
                    if (!$scope.model.mobileLogin) {
                        // 帐号邮箱登录
                        cookieOp.addCookie("personalAccount", $scope.personalAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    } else {
                        // 手机登录
                        cookieOp.addCookie("countryCode", countryCode, cookieOp.DEFAULT_EXPIRES_TIME);
                        cookieOp.addCookie("mobile", $scope.mobileInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    }
                }
                cookieOp.addCookie("rememberChecked", true, cookieOp.DEFAULT_EXPIRES_TIME);
                // cookieOp.addCookie("rememberIsPhoneAccountName", mobileLogin, cookieOp.DEFAULT_EXPIRES_TIME);
            } else {
                // 登录方式的cookie
                cookieOp.delCookie("loginType");
                // 记住登录名的cookie
                cookieOp.delCookie("rememberChecked");
                // 帐号登录方式时主帐号
                cookieOp.delCookie("personalAccount");
                // IAM登录方式 主帐号
                cookieOp.delCookie("IAMAccount");
                // IAM登录方式 子用户
                cookieOp.delCookie("IAMUsername");
                // IAM登录方式 子用户是手机时
                cookieOp.delCookie("countryCode");
                cookieOp.delCookie('mobile');
            }
        } else if (type === "forFindPwd") {

            // 登录方式的cookie
            cookieOp.delCookie("loginType");
            // 记住登录名的cookie
            cookieOp.delCookie("rememberChecked");
            // 帐号登录方式时主帐号
            cookieOp.delCookie("personalAccount");
            // IAM登录方式 主帐号
            cookieOp.delCookie("IAMAccount");
            // IAM登录方式 子用户
            cookieOp.delCookie("IAMUsername");
            // IAM登录方式 子用户是手机时
            cookieOp.delCookie("countryCode");
            cookieOp.delCookie('mobile');

            // 登录失败时 为找回密码页面记录cookie
            var loginType = $scope.model.mobileLogin ? "mobile" : $scope.model.isCompany ? "company" : "personal";
            if ($scope.model.mobileLogin) {
                cookieOp.addCookie("loginType", "mobile", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("countryCode", countryCode, cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("mobile", $scope.mobileInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            } else if (!$scope.model.isCompany) {
                cookieOp.addCookie("loginType", "personal", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("personalAccount", $scope.personalAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            } else if ($scope.model.isCompany) {
                cookieOp.addCookie("loginType", "company", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("IAMAccount", $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("IAMUsername", $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else {
            // default
        }
    }

    function isValUnvalid(value) {
        return value === "" || value === undefined;
    }

    LoginController.prototype.showErrorTip = function (id, $scope) {
        var msgParentDom = $("#checkError");
        msgParentDom.show();
        var serverError = $("#serverError");
        serverError.hide();

        var id2ErrInfo = {
            "accountNameBlank": i18n('accountNameBlank'),
            "userNameBlank": i18n('userNameBlank'),
            "pwdBlank": i18n('pwdBlank'),
            "checkCodeBlank": $scope.model.checkCodeErrorMsg,
            "domainWrong": i18n('wrongNamePwd'),
            "smsCodeError": $scope.model.smsCodeError,
            "inValidCountryCode": i18n('inValidCountryCode'),
            "phoneBlank": i18n('phoneBlank')
        };

        $scope.model.checkErrorInfo = "";
        if (id2ErrInfo[id]) {
            $scope.model.checkErrorInfo = id2ErrInfo[id];
        }
    };

    LoginController.prototype.disabledLoginBtn = function ($scope) {
        var loginBtn = $("#loginBtn");
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n("logining"));
        loginBtn.removeClass("loginBtn");
        loginBtn.addClass("loginBtnDisabled");
        $scope.model.isSubmitBtnDisabled = true;
    };

    LoginController.prototype.restoreBtn = function ($scope) {
        var loginBtn = $("#loginBtn");
        var btnText = loginBtn.children()[0];
        loginBtn.removeClass("loginBtnDisabled");
        loginBtn.addClass("loginBtn");
        $(btnText).html(i18n("loginSubmit"));
        $scope.model.isSubmitBtnDisabled = false;
    };

    LoginController.prototype.onSubmitBtnClick = function ($scope) {

        if (!window.tinyWidget.UnifyValid.FormValid($("#loginForm"))) {
            // 校验不通过 不可提交
            return;
        }
        var model = $scope.model;
        var securityPolicy = $scope.securityPolicy;

        if ($scope.model.isSubmitBtnDisabled) {
            return;
        }
        me.disabledLoginBtn($scope);

        // 记录登录方式到cookie
        recordLoginType($scope);
        cookieOp.delCookie("enterprise_idp");

        // 记录 accountType，与更换手机号等页面兼容: https://wa.vision.huawei.com/#/product/domains/6205/issues/version/list/bug/BUG2019111401458
        recordUserType(model.isCompany);

        var accountName = model.accountName === undefined ? "" : model.accountName.trim();
        model.userName = iamUtils.getTrimValue(model.userNameId);
        var userName = model.userName === undefined ? "" : model.userName.trim();
        var mobileValue = $scope.mobileInput.value === undefined ? "" : $scope.mobileInput.value.trim();

        var countryCode = iamUtils.getCodeValue(model.codeJson, model.defaultValue);
        if (!model.isCompany && model.mobileLogin) {
            countryCode = iamUtils.getCodeValue(model.codeJson, $("#codeSelectId").widget().getValue());
            if (countryCode === undefined) {
                me.showErrorTip("inValidCountryCode", $scope);
                me.restoreBtn($scope);
                return;
            }
        }
        if (countryCode === undefined) {
            countryCode = "";
        }

        var checkCode = model.isNeedVerifyCode ? $("#" + model.checkCodeId).widget().getValue() : "";

        var isCmpyLogin = model.isCompany;

        // 定义传参时用到的密码字段
        var passwd = "";

        // 区分主帐号登录 与 IAM子用户登录
        if (!model.isCompany) {
            // 个人帐号登录
            if (model.mobileLogin) {
                // 区分手机号登录
                passwd = $scope.mobilePasswordInput.value;
                if (isValUnvalid($scope.mobileInput.value)) {
                    me.showErrorTip("phoneBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
                if (isValUnvalid(passwd)) {
                    me.showErrorTip("pwdBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
            } else {
                // 非手机号登录 判断非空
                passwd = $scope.personalPasswordInput.value;
                // 修复自动填充帐号密码时 触发到了个人帐号输入框personalAccountInput的change事件 导致存储密码的变量值被清空的bug
                if ($("#" + $scope.personalPasswordInput.id + ">input").val() !== "") {
                    passwd = $("#" + $scope.personalPasswordInput.id + ">input").val();
                }
                // 修复自动填充时帐号名为空的错误场景
                if ($("#" + $scope.personalAccountInput.id + ">input").val() !== "") {
                    $scope.personalAccountInput.value = $("#" + $scope.personalAccountInput.id + ">input").val();
                }
                if (isValUnvalid($scope.personalAccountInput.value)) {
                    me.showErrorTip("accountNameBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
                if (isValUnvalid(passwd)) {
                    me.showErrorTip("pwdBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
            }
        } else {
            // IAM子用户方式登录
            passwd = $scope.IAMPasswordInput.value;
            if ($scope.IAMAccountInput.value === "op_service") {
                me.showErrorTip("domainWrong", $scope);
                $scope.IAMAccountInput.value = "";
                $scope.IAMUsernameInput.value = "";
                model.pwd = "";
                model.checkCode = "";
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }
            if (isValUnvalid($scope.IAMAccountInput.value)) {
                me.showErrorTip("accountNameBlank", $scope);
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }

            if (isValUnvalid($scope.IAMUsernameInput.value)) {
                me.showErrorTip("userNameBlank", $scope);
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }

            if (isValUnvalid(passwd)) {
                me.showErrorTip("pwdBlank", $scope);
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }
        }

        if ($("#verifyCode").is(":visible") && isValUnvalid(checkCode)) {
            model.checkCodeErrorMsg = i18n('checkCodeBlank');
            me.showErrorTip("checkCodeBlank", $scope);
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        //非空校验完后校验输入参数是否合法
        if ($("#verifyCode").is(":visible") && !checkCodeLength(checkCode)) {
            model.checkCodeErrorMsg = i18n('validCheckCode');
            me.showErrorTip("checkCodeBlank", $scope);

            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        if (!checkUserOrEmailOrPhone(userName)) {
            me.showErrorTip("domainWrong", $scope);

            model.userName = "";
            model.pwd = "";
            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        if (!checkPwd(passwd)) {
            me.showErrorTip("domainWrong", $scope);
            model.pwd = "";
            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }
        // clearSensitiveInfo();

        // 增加对输入手机号登录的兼容
        var phonePatternRegex = /^1\d{10}$/;
        if (phonePatternRegex.test($scope.personalAccountInput.value) && !model.isCompany && !model.mobileLogin && !$scope.ipIsInternational) {
            // 如果输入是手机号格式 且 非子用户登录
            iamHttpService.post({
                url: "/authui/findowner",
                params: {
                    type: "mobile",
                    value: $scope.personalAccountInput.value
                }
            }).then(function (data) {
                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                if (data.result === "success") {
                    var count = data.count;
                    if (count > 0) {
                        // 已经注册 区分单个帐号多个帐号的显示逻辑
                        if (count > 1) {
                            // 多帐号时 切换到手机登录
                            $scope.mobileInput.value = $scope.personalAccountInput.value;
                            $scope.personalAccountInput.value = "";
                            $scope.mobileLoginModel.isMobilePattern = false;
                            $scope.model.mobileLogin = true;
                            $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                            $scope.mobileLoginModel.showMobileSelect = true;

                            // 处理数据格式用以适配控件
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i == 0) {
                                    $scope.mobileLoginModel.loginUserId = data.users[i].id;
                                    $scope.mobileLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }
                            $scope.model.pwd = "";

                            $scope.mobileUsers.selectOptions = data.users;
                            $scope.$apply();
                            // 重新渲染之后得到控件 设置默认值
                            $("#mobileUsers").widget().opChecked("1");
                            // 再启用登录按钮
                            me.restoreBtn($scope);
                        } else {
                            // 单帐号
                            getRiskMonitor();
                        }
                    } else {
                        getRiskMonitor();
                    }
                } else {
                    // 请求返回错误
                    if (data.message === "addrFrequencyHitMax") {
                        $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                        $scope.model.pwd = "";
                        $("#checkError").hide();
                        $("#serverError").show();
                        $scope.$apply();
                        // 再启用登录按钮
                        me.restoreBtn($scope);
                    }
                }
            }, function () {
                showErrorMsg($scope, "417");
                window.hwcap.reload();
                // 再启用登录按钮
                me.restoreBtn($scope);
            });
        } else {
            getRiskMonitor();
        }

        function getRiskMonitor() {
            var hwmeta = document.getElementById("hwmeta") ? document.getElementById("hwmeta").value : "";

            var params = {
                _domain: "",
                _domainType: "",
                _username: "",
                _countryCode: countryCode,
                _verifycode: checkCode,
                _password: encodeURIComponent(passwd),
                _companyLogin: isCmpyLogin,
                _userInfoType: ""
            };

            if (model.isCompany) {
                // 子用户方式登录
                params._domainType = "name";
                params._username = encodeURIComponent($scope.IAMUsernameInput.value);
                params._domain = encodeURIComponent($scope.IAMAccountInput.value);
                params._userInfoType = me.getUserNameType($scope.IAMUsernameInput.value);
            } else {
                if (model.mobileLogin) {
                    // 当手机号登录
                    params._domain = $scope.mobileLoginModel.loginUserDomainId;
                    params._domainType = "id";
                    params._username = $scope.mobileLoginModel.loginUserId;
                    params._userInfoType = "id";
                } else if (me.getUserNameType($scope.personalAccountInput.value) === "email" && $scope.emailUsers.selectOptions.length > 0) {
                    // 主帐号邮箱方式登录
                    params._domain = $scope.emailLoginModel.loginUserDomainId;
                    params._domainType = "id";
                    params._username = $scope.emailLoginModel.loginUserId;
                    params._userInfoType = "id";
                } else {
                    // 主帐号方式登录
                    params._domainType = "name";
                    params._username = encodeURIComponent($scope.personalAccountInput.value);
                    params._domain = "";
                    params._userInfoType = me.getUserNameType($scope.personalAccountInput.value);
                }
            }

            var loginPostParams = {
                "userpasswordcredentials.domain": params._domain,
                "userpasswordcredentials.domainType": params._domainType,
                "userpasswordcredentials.username": params._username,
                "userpasswordcredentials.countryCode": params._countryCode,
                "userpasswordcredentials.verifycode": params._verifycode,
                "userpasswordcredentials.password": params._password,
                "userpasswordcredentials.companyLogin": params._companyLogin,
                "userpasswordcredentials.userInfoType": params._userInfoType,
                "userpasswordcredentials.riskMonitorJson": JSON.stringify({
                    "devID": get_Cookie("cbc-sid"),
                    "hwMeta": hwmeta ? hwmeta : ""
                }),
                __checkbox_warnCheck: "true",
                "isAjax": "true",
                Submit: "Login"
            };

            doLogin('/authui/validateUser.action' + filterSearch(), loginPostParams);
            return;
        }

        function timetrans() {
            var date = new Date();
            var Y = date.getFullYear();
            var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return '' + Y + M + D + h + m + s;
        }

        function doLogin(URL, PARAMS) {
            iamHttpService.post({
                url: URL,
                params: PARAMS
            }).then(function (data) {
                if (data.loginResult === "success") {

                    // 登录成功后记录cookie
                    recordLoginCookie($scope, countryCode, "forLogin");

                    var redirectUrl;
                    var redirectUrlArr = data.redirectUrl.split("?");
                    if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                        var hash = redirectUrlArr[0].replace("/authui/", "").replace(".html", "");
                        if (redirectUrlArr.length > 1) {
                            redirectUrl = "?" + redirectUrlArr[1] + "#/" + hash;
                        } else {
                            redirectUrl = "#/" + hash;
                        }
                    } else {
                        redirectUrl = data.redirectUrl;
                    }
                    window.location.href = redirectUrl;
                } else if (data.loginResult === "failed") {

                    // 登录失败时 记录当前的帐号cookie 方便用户点击忘记密码时 回填在页面
                    recordLoginCookie($scope, countryCode, "forFindPwd");

                    if (data.authFailed === true) {
                        if ($scope.model.mobileLogin === false) {
                            me.loginVerify($scope);
                        } else {
                            me.loginVerify($scope);
                        }
                    }
                    showErrorMsg($scope, data.errorCode);
                    window.hwcap.reload();
                    me.restoreBtn($scope);
                } else {
                    showErrorMsg($scope, "417");
                    window.hwcap.reload();
                    me.restoreBtn($scope);
                }
            }, function () {
                showErrorMsg($scope, "417");
                window.hwcap.reload();
                me.restoreBtn($scope);
            });
        }

        function filterSearch() {
            var newSearch = "";
            var searchStr = window.location.search.substring(1);
            var params = searchStr.split("&");
            for (var index = 0; index < params.length; index++) {
                if (params[index].indexOf("=") !== -1) {
                    var key = params[index].substring(0, params[index].indexOf("="));
                    if (key === "service") {
                        var service = params[index];
                        if (service.indexOf("hwclouds") !== -1) {
                            service = service.replace(/hwclouds/g, "huaweicloud");
                        }
                        newSearch = newSearch + "&" + service;
                    } else if (key !== "step") {
                        newSearch = newSearch + "&" + params[index];
                    }
                }
            }
            return newSearch === "" ? "" : "?" + newSearch.substring(1);
        }

        function clearSensitiveInfo() {
            $scope.personalPasswordInput.value = new Array($scope.personalPasswordInput.value.length + 1).join("*");
            $scope.mobilePasswordInput.value = new Array($scope.mobilePasswordInput.value.length + 1).join("*");
            $scope.IAMPasswordInput.value = new Array($scope.IAMPasswordInput.value.length + 1).join("*");
        }

        function checkAccount(value) {
            var maxLength = securityPolicy.accountpolicy.username_maxlen;
            if (value.length > maxLength) {
                return false;
            }
            var userPattern = new RegExp(securityPolicy.accountpolicy.username_contains_char);
            return userPattern.test(value);
        }

        function checkUserOrEmailOrPhone(value) {
            var maxLength = 255; //取邮箱、手机、用户名的最大值：邮箱255
            if (value.length > maxLength) {
                return false;
            }

            //var userPattern = new RegExp(securityPolicy.accountpolicy.username_contains_char);
            var emailPattern = iamUtils.EmailRegex;
            var phonePattern = /^[0-9]\d*$/;

            if (phonePattern.test(value)) {
                return true;
            }
            if (emailPattern.test(value)) {
                return true;
            }
            if (value.indexOf("@") != -1) {
                return false;
            } else {
                return true;
            }

            //return userPattern.test(value) || emailPattern.test(value) || phonePattern.test(value);
        }

        function checkPwd(value) {
            var maxLength = securityPolicy.passwordpolicy.password_maxlen;
            if (value.length > maxLength) {
                return false;
            }
            return true;
        }

        function checkCodeLength(vaule) {
            var maxLength = 4; //图片验证码长度为4
            if (vaule.length > maxLength) {
                return false;
            }
            return true;
        }

        function showServerError() {
            var msgParentDom = $("#checkError");
            msgParentDom.hide();
            var serverError = $("#serverError");
            serverError.show();
        }
    };

    LoginController.prototype.onUserTypeChange = function ($scope, $timeout) {
        $timeout(function () {
            // 如果url中未带有id参数则说明没有使用IAM用户登录链接 该场景下才需清空输入框
            if (iamUtils.getUrlParams()["id"] === undefined) {
                $scope.IAMAccountInput.value = "";
            }
            $scope.IAMUsernameInput.value = "";
            $scope.IAMPasswordInput.value = "";
            $scope.IAMPasswordInput.pwdVisible = false;
            $scope.personalAccountInput.value = "";
            $scope.personalAccountInput.oldValue = "";
            $scope.personalPasswordInput.value = "";
            $scope.personalPasswordInput.pwdVisible = false;
            $scope.emailLoginModel.showEmailSelect = false;

            $scope.model.accountName = "";
            $scope.model.lastAccountName = "";
            $scope.model.userName = "";
            $scope.model.lastUserName = "";
            $scope.model.PhoneAccountName = "";
            $scope.model.lastPhoneAccountName = "";
            $scope.model.pwd = "";
            $scope.model.checkCode = "";
            $scope.model.rememberChecked = false;
            $scope.model.pwdFocused = false;

            if ($scope.model.isCompany) {
                $scope.IAMAccountInput.getFocus();
            } else {
                $scope.personalAccountInput.getFocus();
            }
            if (!$scope.model.userNameCookie) {
                $("#checkError").hide();
                $("#serverError").hide();
                return;
            }

            if (countryCode) {
                $scope.model.defaultValue = iamUtils.getCountryValue($scope.model.codeJson, countryCode);
            }

            var lastLoginType = cookieOp.getCookie("loginType");
            var countryCode = cookieOp.getCookie("countryCode");
            // 是否记住登录名
            var rememberChecked = cookieOp.getCookie("rememberChecked");

            me.loginCheck($scope);

            $("#checkError").hide();
            $("#serverError").hide();
        });
    };

    function refreshVerifyCode(model) {
        if (model.isNeedVerifyCode) {
            model.getVerifyCode();
        }
    }

    function showErrorMsg($scope, errorCode) {
        if (me.showStatus !== undefined) {
            me.showStatus(errorCode);
        }
        //将原有的错误信息清空
        $scope.model.serverError = "";
        $scope.model.goLogin = "";
        $scope.model.goLogin1 = "";
        if (errorCode && $scope.model.errorMsgObj[errorCode]) {
            $scope.model.serverError = $scope.model.errorMsgObj[errorCode];
        } else if (errorCode) {
            if (errorCode == i18n("isHongKongUser")) {
                $scope.model.serverError = i18n("isHongKongUser1");
                $scope.model.goLogin = i18n("goLogin.hk");
                $scope.model.goLogin1 = i18n("toLogin.hk");
                $scope.goLoginType = "HK";
            } else if (errorCode == i18n("isHwsUser")) {
                $scope.model.serverError = i18n("isHwsUser1");
                $scope.model.goLogin = i18n("goLogin.hws");
                $scope.model.goLogin1 = i18n("toLogin.hws");
                $scope.goLoginType = "HWS";
            } else if (errorCode == i18n("isRuUser")) {
                $scope.model.serverError = i18n("isRuUser1");
                $scope.model.goLogin = i18n("goLogin.ru");
                $scope.model.goLogin1 = i18n("toLogin.ru");
                $scope.goLoginType = "RU";
            } else if (errorCode == "416") {
                $scope.model.serverError = i18n("clientIpInvalid");
                $scope.model.goLogin = i18n("clientIpInvalid.learnMore");
                $scope.model.goLogin1 = "";
                $scope.goLoginType = "ACL";
            } else {
                $scope.model.serverError = errorCode;
            }
        }

        $("#checkError").hide();
        if (errorCode !== "") {
            $("#serverError").show();
        }
        // 清除密码输入框
        resetPwdInput($scope);

        refreshVerifyCode($scope.model);
        $scope.$evalAsync();
    }

    // 清除密码输入框
    function resetPwdInput($scope) {
        if ($scope.personalPasswordInput) {
            $scope.personalPasswordInput.value = "";
        }
        if ($scope.mobilePasswordInput) {
            $scope.mobilePasswordInput.value = "";
        }
        if ($scope.IAMPasswordInput) {
            $scope.IAMPasswordInput.value = "";
        }
    }

    function get_Cookie(e) {
        var n,
            t = "",
            r = document["getElementById"]("JSdev");
        if (r && !t) try {
            n = r.getsid() || "", t = n;
        } catch (o) {}
        try {
            window["localStorage"] && !t && (n = localStorage[e] || "", t = n);
        } catch (o) {}
        if (window["navigator"]["cookieEnabled"] && !t) {
            var i = document["cookie"]["indexOf"](e + "=");
            if (-1 != i) {
                i += e.length + 1;
                var a = document["cookie"]["indexOf"](";", i);
                -1 == a && (a = document["cookie"]["length"]), n = decodeURIComponent(document["cookie"]["substring"](i, a)) || "", t = n;
            }
        }

        return t;
    }

    function initUserType($scope) {
        var enterpriseUser = i18n("enterpriseUser");
        var personageUser = i18n("personageUser");
        $scope.model.currentUserType = $scope.model.isCompany ? enterpriseUser : personageUser;
        $scope.model.otherUserType = $scope.model.isCompany ? personageUser : enterpriseUser;

        var idUrl = iamUtils.getUrlParams()["id"];

        // 根据url中是否带有id参数区分是否使用了 IAM用户登录链接
        if (idUrl === undefined) {
            // 上次登录的情形会被cookie记录 默认区分 个人帐号和IAM用户登录方式
            if (me.getLastLoginUserType() === "company") {
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.IAMAccountInput.value = cookieOp.getCookie("IAMAccount");
                    $scope.IAMUsernameInput.value = cookieOp.getCookie("IAMUsername");
                    $scope.IAMPasswordInput.value = "";
                    $scope.IAMPasswordInput.getFocus();
                } else {
                    $scope.IAMAccountInput.getFocus();
                }
            } else if (me.getLastLoginUserType() === "mobile" && !$scope.ipIsInternational) {
                $scope.model.mobileLogin = true;
                $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.mobileInput.value = cookieOp.getCookie("mobile");
                    $scope.mobileBlur();
                    $scope.mobilePasswordInput.value = "";
                    $scope.mobilePasswordInput.getFocus();
                } else {
                    $scope.mobileInput.focused = true;
                }
            } else if (me.getLastLoginUserType() === "personal") {
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.personalAccountInput.value = cookieOp.getCookie("personalAccount");
                    $scope.personalPasswordInput.value = "";
                    $scope.personalPasswordInput.getFocus();
                } else {
                    $scope.personalAccountInput.getFocus();
                }
            } else if (me.getLastLoginUserType() === "idp") {
                $scope.model.isIdpLogin = true;
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("enterprise_idp")) {
                    try {
                        var cookieObj = JSON.parse(cookieOp.getCookie("enterprise_idp"));
                        if (cookieObj) {
                            $scope.idpAccountInput.value = cookieObj.domainName;
                            $scope.getIDPs($scope, cookieObj.selectedIdpId);
                        }
                    } catch (err) {}
                }
            } else {
                $scope.personalAccountInput.getFocus();
                // 如果未保存上次登录的cookie 则国内IP默认设置为手机号登录方式
                if (!$scope.ipIsInternational) {
                    /* 暂时不使用默认手机号登录方式
                    // setMobileLogin();
                    $scope.model.isCompany = false;
                    $scope.model.mobileLogin = true;
                    // $scope.model.lastUserName = "";
                    $scope.model.areaCodeDisabled = true;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                     $scope.mobileInput.oldValue = "";
                    $scope.mobileInput.value = "";
                    $scope.mobileInput.getFocus();
                    $scope.mobilePasswordInput.value = "";
                    */
                }
            }
        } else {
            $scope.model.isCompany = true;
            $scope.IAMAccountInput.value = encodeURIComponent(idUrl);
            $scope.IAMAccountInput.disable = true;
            $scope.IAMUsernameInput.value = "";
            $scope.IAMUsernameInput.getFocus();
            $scope.IAMPasswordInput.value = "";
            // 不记住登录名
            $scope.model.rememberChecked = false;
        }

        if (!$scope.$$phase) {
            $scope.$apply();
        }
        return;
    }

    LoginController.prototype.loginCheck = function ($scope) {
        if ($scope.model.isCompany && (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value)) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        if (!$scope.model.isCompany && !$scope.personalAccountInput.value) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        if ($scope.model.mobileLogin && !$scope.mobileInput.value) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        me.loginVerify($scope);
    };

    // 检查登录使用的帐号是否需要填写图形验证码
    LoginController.prototype.loginVerify = function ($scope) {
        var params;
        if (!$scope.model.isCompany) {
            // 个人帐号登录方式
            if ($scope.model.mobileLogin) {
                // 手机号登录方式
                params = {
                    userName: $scope.mobileLoginModel.loginUserId,
                    userType: "id",
                    accountName: $scope.mobileLoginModel.loginUserDomainId
                };
            } else {
                // 帐号邮箱登录方式 需要兼容填写了手机号的登录
                var personalAccount = $scope.personalAccountInput.value.trim();
                var type = me.getUserNameType(personalAccount);
                if (type === "email") {
                    // 邮箱登录
                    params = {
                        userName: $scope.emailLoginModel.loginUserId,
                        userType: "id",
                        accountName: $scope.emailLoginModel.loginUserDomainId
                    };
                } else {
                    if (type === "mobile") {
                        var countryCode = $("#codeSelectId").length > 0 ? iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()) : iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                        personalAccount = countryCode + "-" + personalAccount;
                    }
                    params = {
                        userName: personalAccount,
                        userType: type,
                        accountName: ""
                    };
                }
            }
        } else {
            // IAM子用户登录方式
            var IAMUsername = $scope.IAMUsernameInput.value.trim();
            var type = me.getUserNameType(IAMUsername);
            if (type === "mobile") {
                var countryCode = $("#codeSelectId").length > 0 ? iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()) : iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                IAMUsername = countryCode + "-" + IAMUsername;
            }
            params = {
                userName: IAMUsername,
                userType: type,
                accountName: $scope.IAMAccountInput.value ? encodeURIComponent($scope.IAMAccountInput.value) : ""
            };
        }

        iamHttpService.post({
            url: "/authui/login/verify",
            params: params
        }).then(function (data) {
            if ($scope.model.mobileLogin === true && $scope.mobileInput.value === undefined) {
                $scope.model.isNeedVerifyCode = false;
            } else {
                $scope.model.isNeedVerifyCode = data.needVerify;
            }
            $scope.$apply();
        }, function () {
            $scope.model.isNeedVerifyCode = true;
            $scope.$apply();
        });
    };
    LoginController.prototype.getUserNameType = function (userName) {
        var emailPattern = iamUtils.EmailRegex;
        var phonePattern = /^[0-9]\d*$/;
        if (emailPattern.test(userName)) {
            return "email";
        } else if (phonePattern.test(userName)) {
            return "mobile";
        } else {
            return "name";
        }
    };

    LoginController.prototype.getPageImgSrc = function () {
        if (window.language === "zh-cn") {
            return __webpack_require__(65);
        } else {
            return __webpack_require__(98);
        }
    };

    return LoginController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(11), __webpack_require__(6), __webpack_require__(150), __webpack_require__(4), __webpack_require__(61)], __WEBPACK_LOCAL_MODULE_0__ = (function (i18n, cookieOp, iamUtils, LoginController, iamHttpService, QRCode) {
    "use strict";

    var me;
    var QRCODE_VALID_TIME = 120; //二维码失效时间，单位秒
    function CustomerLoginController($scope, $timeout, securityPolicy, $state, $sce, $interval) {

        $scope.$sce = $sce;
        // 判断是否已经有登录 
        $.ajax({
            "type": "GET",
            "contentType": "application/x-www-form-urlencoded; charset=UTF-8",
            "url": "/authui/isLogin",
            "async": true,
            "success": function success(data) {
                data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                if (data.result === "islogin" && data.code === 201 && data.status === "success") {
                    // 说明已经有会话登录 重定向一次
                    window.location.href = "/authui/" + window.location.search;
                }
            },
            "error": function error() {
                $scope.model.serverError = i18n("systemException");
                setTimeout(function () {
                    $scope.model.serverError = "";
                }, 10000);
            }
        });

        // 样式文件加载
        var cssFileArr = {
            "zh-cn": "/authui/public/custom/css/zh-cn/loginpage.css",
            "en-us": "/authui/public/custom/css/en-us/loginpage.css",
            "es-us": "/authui/public/custom/css/es-us/loginpage.css",
            "pt-br": "/authui/public/custom/css/pt-br/loginpage.css"
        };
        $scope.cssFile = cssFileArr[window.language];

        var blueImg = "/authui/public/custom/images/blue_triangle.png";
        var grayImg = "/authui/public/custom/images/gray_triangle.png";
        me = this;
        try {
            iamUtils.initialCloudBI("/authui/#/login", { C1: "IAM-Login" });
        } catch (e) {
            console.dir(e);
        }

        LoginController.call(this, $scope, $timeout, securityPolicy, i18n, iamUtils, $state);
        createAdvScript();

        if (getQueryString("UserType")) {
            // 是否指定了IAM用户登录
            $scope.model.isCompany = getQueryString("UserType") === "e" ? true : false;
        }

        $scope.model.homepageUrl = $scope.ipIsInternational ? iamUtils.CONFIG.HongKongHomepageUrl : iamUtils.CONFIG.homepageUrl;
        $scope.model.currentLanguage = window.language;
        $scope.model.fromQuickLogin = getQueryString("quickLogin") === "true"; //标记来源是否是快捷登录
        $scope.model.quickLoginUrl = getQuickLoginUrl();
        // RR2020021101004
        $scope.model.WeLinkUrl = getWeLinkUrl();
        $scope.model.isIdpLogin = false;

        $scope.model.registUrl = getRegistUrl($scope);
        $scope.model.vmallUrl = getVmallUrl();
        $scope.model.hwportalUrl = getHwPortalUrl();
        $scope.model.eChannelUrl = getEchannelUrl();
        $scope.model.uniportalUrl = getUniportalUrl();
        $scope.model.openEchannel = true;
        $scope.model.isIAMUserLogin = cookieOp.getCookie("accountType") === "company" ? false : true;
        $scope.model.hwdeveloperUrl = getHwDeveloperUrl();
        $scope.model.areaCodeDisabled = true;
        $scope.model.matchMethod = 'any-nocap';
        $scope.model.inputFieldHeight = "36px";
        $scope.model.codeInputWidth = "220px";
        $scope.model.phoneInputWidth = "205px";
        $scope.model.moreLinkIsShow = false;
        $scope.model.listImg = grayImg;
        $scope.model.width = 320;
        $scope.model.height = 36;
        $scope.model.isUsePhone = true;
        $scope.model.listStyle = "display:none";
        $scope.model.registTip = {
            "content": i18n("loginRegistTip"),
            "position": "top",
            "auto": "true"
        };

        $scope.model.uniportalTip = {
            "content": i18n("uniportalTip"),
            "position": "right",
            "auto": "true"
        };

        $scope.model.accountNamePH = i18n("accountPlaceHolder");
        $scope.model.personageUser = i18n("hwId.hwCloudAccountLogin");
        $scope.model.enterpriseUser = i18n("enterpriseUser");
        $scope.model.chkTxt = i18n("rememberName");
        $scope.model.errorMsgObj = {
            "401": $scope.ipIsInternational && i18n("wrongNamePwd4Intl") ? i18n("wrongNamePwd4Intl") : i18n("wrongNamePwd"),
            "402": $scope.ipIsInternational && i18n("wrongNamePwdoneChances4Intl") ? i18n("wrongNamePwdoneChances4Intl") : i18n("wrongNamePwdoneChances"),
            "403": $scope.ipIsInternational && i18n("wrongNamePwdTwoChances4Intl") ? i18n("wrongNamePwdTwoChances4Intl") : i18n("wrongNamePwdTwoChances"),
            "404": $scope.ipIsInternational && i18n("wrongNamePwdThreeChances4Intl") ? i18n("wrongNamePwdThreeChances4Intl") : i18n("wrongNamePwdThreeChances"),
            "405": i18n("wrongNamePwdFourChances"),
            "406": i18n("invalidInput"),
            "407": i18n("invalidInputoneChances"),
            "408": i18n("invalidInputTwoChances"),
            "409": i18n("invalidInputThreeChances"),
            "410": i18n("invalidInputFourChances"),
            "411": i18n("wrongVerifyCode"),
            "412": i18n("loginReactivateFail"),
            "413": i18n("userAccountsLocked"),
            "414": i18n("domainuserAccountsLocked"),
            "415": i18n("userAccountsLocked"),
            "417": i18n("systemException"),
            "418": i18n("verifyCode.error"),
            "419": i18n("verifyCode.invalid"),
            "420": i18n("userAccountsStopped"),
            "423": i18n("serviceUrlInvalid"),
            "424": i18n("maxSessionLimit"),
            "427": i18n("multiUserInvalid"),
            "428": i18n("accountClosed"),
            "430": i18n("hasBindUniportal"),
            "432": i18n("pageTimeout"),
            "508121000": i18n("wrongIPBlacklist"),
            "508121001": i18n("wrongIPFrequencyLimiting"),
            "508121002": i18n("wrongEquipmentIDFrequencyLimiting"),
            "508121003": i18n("MachineOperation"),
            "IAM.0012": i18n("operationTooFrequent"),
            "IAM.0004": i18n("pageTimeout"),
            "IAM.1063": i18n("wrongVerifyCode"),
            "IAM.1065": i18n("domainAccountsStopped"),
            "IAM.1066": i18n("quickLogin.notActivate"),
            "IAM.0018": i18n("invalidInput"),
            "IAM.0007": i18n("invalidInput"),
            "noIdps": i18n("idpLogin.noIdps"),
            "operationTooFrequent": i18n("operationTooFrequent"),
            "domainNotExist": i18n("idpLogin.domainNotExist"),
            "idpIpLock": i18n("mobileLoginModel.operationTooFrequent")
        };
        $(document).keydown(function (event) {
            if (event.keyCode === 13) {
                var id = $(document.activeElement).attr("id");
                if ($scope.model.isNeedVerifyCode && id === "checkCodeId" || id === "userNameId" || id === "pwdId" || id === "accountNameId" || id === "loginBtn") {
                    $scope.loginClick();
                    $scope.$apply();
                }
            }
        });

        $("#goLogin").click(function () {
            if ($scope.goLoginType == "HWS") {
                window.location.href = "https://" + 'auth.huaweicloud.com' + "/authui/?locale=" + window.language;
            } else if ($scope.goLoginType == "HK") {
                window.location.href = "https://" + 'auth-intl.huaweicloud.com' + "/authui/?locale=" + window.language;
            } else if ($scope.goLoginType == "ACL") {
                window.location.href = iamUtils.CONFIG.helpCenterUrl + i18n('clientIpInvalid.helpUrl');
            } else {
                window.location.href = "https://" + 'auth-intl.huaweicloud.com' + "/authui/?locale=" + window.language;
            }
        });

        /*** 手机号登录需求相关代码均在下方直到 END ***/

        function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e);
            }
        }

        //悬浮在IAM帐号用户名输入框时，显示tip
        $scope.bindIAMAccountTip = function () {
            var tip = i18n('iamAccountTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamAccountTipHelp');
                tip += iamUtils.i18nFormat("<a href='{0}' target='_blank'>{1}</a>", url, i18n('learnMore'));
            }
            $timeout(function () {
                iamUtils.showTooltip($('#IAMAccountInputId'), tip);
            });
        };

        $scope.bindIAMUsernameTip = function () {
            var tip = i18n('iamUsernameTip');
            if (iamUtils.CONFIG.helpCenterUrl) {
                var url = iamUtils.CONFIG.helpCenterUrl + i18n('iamUsernameTipHelp');
                tip += iamUtils.i18nFormat("<a href='{0}' target='_blank'>{1}</a>", url, i18n('learnMore'));
            }
            $timeout(function () {
                iamUtils.showTooltip($('#IAMUsernameInputId'), tip);
            });
        };

        $scope.goFindPwd = function (send, event, button, click, login_fpwd) {
            var fpwdURI = getFpwdUrl();
            $scope.BiEvent(send, event, button, click, login_fpwd, fpwdURI);
            window.location.href = fpwdURI;
        };

        // 个人帐号登录方式下 帐号名邮箱输入框
        $scope.personalAccountInput = {
            id: "personalAccountInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("mobileLoginModel.accountPlaceHolder"),
            change: function change() {
                // 内容修改则清空密码
                $scope.personalPasswordInput.value = "";
                // 清空邮箱多用户选择框
                $scope.emailLoginModel.showEmailSelect = false;
                $scope.personalAccountInput.oldValue = "";
            },
            blur: function blur() {
                send2CloudBISafe("input", "change", "login_personal_userName", $scope.personalAccountInput.value);
                if ($scope.model.fromQuickLogin && $scope.model.serverError == i18n("quickLogin.qucikLoginTip")) {
                    $scope.model.serverError = "";
                }
                $scope.personalAccountInput.value = $scope.personalAccountInput.value.trim();
                // 判断是否是邮箱登录            
                var emailPattern = iamUtils.EmailRegex;
                if (emailPattern.test($scope.personalAccountInput.value)) {
                    $("#serverError").hide();
                    $("#checkError").hide();
                    // 若为邮箱，多用户处理            
                    $scope.emailLoginModel.emailExist();
                } else {
                    // 原逻辑            
                    // 增加对输入帐号名是否为手机号的提示 仅在国内IP时使用            
                    if (!$scope.ipIsInternational) {
                        var phonePatternRegex = /^1\d{10}$/;
                        if (phonePatternRegex.test($scope.personalAccountInput.value)) {
                            $("#isMobileTip").show();
                            $scope.mobileLoginModel.isMobilePattern = true;
                        } else {
                            $("#isMobileTip").hide();
                            $scope.mobileLoginModel.isMobilePattern = false;
                        }
                    }
                    if (!$scope.personalAccountInput.value || $scope.personalAccountInput.value === $scope.personalAccountInput.oldValue) {
                        return;
                    }
                    $("#serverError").hide();
                    $("#checkError").hide();
                    $scope.personalAccountInput.oldValue = $scope.personalAccountInput.value;
                    me.loginCheck($scope);
                }
            },
            focus: function focus() {
                if ($scope.model.fromQuickLogin && !$scope.model.serverError) {
                    $scope.model.serverError = i18n("quickLogin.qucikLoginTip");
                }
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $("#" + $scope.personalAccountInput.id + ">input")[0].focus();
                }, 100);
            }
            // 个人帐号登录方式下 密码输入框
        };$scope.personalPasswordInput = {
            type: "password",
            id: "personalPasswordInputId",
            value: "",
            ph: i18n("passwdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.personalPasswordInput.pwdVisible = !$scope.personalPasswordInput.pwdVisible;
                var type = $scope.personalPasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.personalPasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $scope.personalAccountInput.blur();
                    $("#" + $scope.personalPasswordInput.id + ">input")[0].focus();
                }, 100);
            }

            // 手机号登录方式下 手机号输入框
        };$scope.mobileInput = {
            type: "text",
            id: "mobileInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("mobileLoginModel.mobilePlaceHolder"),
            getFocus: function getFocus() {
                setTimeout(function () {
                    $("#" + $scope.mobileInput.id + ">input")[0].focus();
                }, 100);
            }
            // 手机号登录方式下 密码输入框
        };$scope.mobilePasswordInput = {
            type: "password",
            id: "mobilePasswordInputId",
            value: "",
            ph: i18n("passwdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.mobilePasswordInput.pwdVisible = !$scope.mobilePasswordInput.pwdVisible;
                var type = $scope.mobilePasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.mobilePasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $("#" + $scope.mobilePasswordInput.id + ">input")[0].focus();
                }, 100);
            }

            // IAM用户登录方式下 帐号名输入框
        };$scope.IAMAccountInput = {
            id: "IAMAccountInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("accountPlaceHolder"),
            disable: false,
            change: function change() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = "";
            },
            blur: function blur() {
                send2CloudBISafe("input", "change", "login_company_accountName", $scope.IAMAccountInput.value.trim());
                if (!$scope.IAMAccountInput.value || $scope.IAMAccountInput.value === $scope.model.lastAccountName) {
                    return;
                }
                $scope.IAMAccountInput.value = $scope.IAMAccountInput.value.trim();
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $scope.model.lastAccountName = $scope.IAMAccountInput.value;
                me.loginCheck($scope);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $("#" + $scope.IAMAccountInput.id + ">input")[0].focus();
                }, 100);
            }
            // IAM用户登录方式下 用户名输入框
        };$scope.IAMUsernameInput = {
            type: "text",
            id: "IAMUsernameInputId",
            value: "",
            oldValue: "",
            focused: false,
            ph: i18n("userNamePlaceHolder"),
            phIntl: i18n("HongKongUserNamePlaceHolder"),
            disable: false,
            change: function change() {
                // 内容修改则清空密码
                $scope.IAMPasswordInput.value = "";
            },
            blur: function blur() {
                send2CloudBISafe("input", "change", "login_company_userName", $scope.IAMUsernameInput.value.trim());
                if (!$scope.IAMUsernameInput.value || $scope.IAMUsernameInput.value === $scope.IAMUsernameInput.oldValue) {
                    return;
                }
                $scope.IAMUsernameInput.value = $scope.IAMUsernameInput.value.trim();
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $scope.IAMUsernameInput.oldValue = $scope.IAMUsernameInput.value;
                me.loginCheck($scope);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $("#" + $scope.IAMUsernameInput.id + ">input")[0].focus();
                }, 100);
            }
            // IAM用户登录方式下 密码输入框
        };$scope.IAMPasswordInput = {
            type: "password",
            id: "IAMPasswordInputId",
            value: "",
            focused: false,
            ph: i18n("iamPasswdPlaceHolder"),
            pwdVisible: false,
            pwdVisibleFunc: function pwdVisibleFunc() {
                $scope.IAMPasswordInput.pwdVisible = !$scope.IAMPasswordInput.pwdVisible;
                var type = $scope.IAMPasswordInput.pwdVisible ? "text" : "password";
                $("#" + $scope.IAMPasswordInput.id + ">input").attr("type", type);
            },
            getFocus: function getFocus() {
                setTimeout(function () {
                    $scope.IAMAccountInput.blur();
                    $("#" + $scope.IAMPasswordInput.id + ">input")[0].focus();
                }, 100);
            }
            // 手机号登录切换功能相关变量 防止变量名冲突
        };$scope.mobileLoginModel = {
            intlIpTip: i18n("mobileLoginModel.intlIpTip"),
            switchTypeLabel: i18n("mobileLoginModel.mobileLogin"),
            mobileCheckLoading: false,
            showMobileErrorMsg: false,
            showMobileSelect: false,
            countryCode: "",
            selectedUser: {},
            loginUserId: "",
            loginUserDomainId: "",
            registUrl: "",
            isMobilePattern: false,
            isMobileTip: i18n("mobileLoginModel.isMobileTip"),
            notRegisterTip: i18n("mobileLoginModel.notRegisterTip"),
            registerNow: i18n("mobileLoginModel.registerNow"),
            multiUsersTip: i18n("mobileLoginModel.multiUsersTip"),
            mobileValidator: [{
                "validFn": "required"
            }, {
                "validFn": "regularCheck",
                "params": "/^1\\d{10}$/",
                "errorDetail": i18n("mobileLoginModel.invalidNumber")
            }],
            initSwitchType: function initSwitchType() {
                // 初始化手机号登录切换按钮
                $scope.mobileInput.oldValue = "";
                $scope.model.mobileLogin = false;
                $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.mobileLogin");
                $scope.model.mobileLogin = false;
                $scope.model.userNamePH = $scope.model.isCompany ? i18n("mobileLoginModel.userPlaceHolder") : i18n("mobileLoginModel.accountPlaceHolder");
                $scope.mobileLoginModel.showMobileErrorMsg = false;
                $scope.mobileLoginModel.showMobileSelect = false;
            },
            switchTypeClick: function switchTypeClick(event) {
                $("#isMobileTip").hide();
                $("#checkError").hide();
                $("#serverError").hide();
                if (event.which !== 1) {
                    // 不是左键触发
                    return false;
                }
                // 切换手机号登录
                $scope.model.isNeedVerifyCode = false;
                $scope.model.lastUserName = "";
                $scope.mobileInput.oldValue = "";
                // 如果在主界面输入了手机格式 点击切换过来之后 不清空填写的手机号 并且触发手机号校验
                if ($scope.mobileLoginModel.isMobilePattern) {
                    $scope.mobileLoginModel.isMobilePattern = false;
                    $scope.mobileInput.value = $scope.personalAccountInput.value;
                    $scope.personalAccountInput.value = "";
                    $scope.mobileBlur();
                } else {
                    $scope.mobileInput.value = "";
                }
                $scope.model.userName = "";
                $scope.personalPasswordInput.value = "";
                $scope.personalPasswordInput.pwdVisible = false;
                $scope.mobilePasswordInput.value = "";
                $scope.mobilePasswordInput.pwdVisible = false;
                $scope.model.mobileLogin = !$scope.model.mobileLogin;
                if ($scope.model.mobileLogin) {
                    // 使用手机号登录
                    $scope.mobileInput.getFocus();
                    $scope.model.areaCodeDisabled = true;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                    $scope.model.mobileLogin = true;
                    $scope.personalAccountInput.value = "";
                    $scope.personalAccountInput.oldValue = "";
                    $scope.emailLoginModel.showEmailSelect = false;
                } else {
                    $scope.personalAccountInput.getFocus();
                    $scope.mobileLoginModel.showMobileErrorMsg = false;
                    $scope.mobileLoginModel.showMobileSelect = false;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.mobileLogin");
                    $scope.model.mobileLogin = false;
                    $scope.model.userNamePH = i18n("mobileLoginModel.accountPlaceHolder");
                }
            },
            mobileExist: function mobileExist() {
                // 查询手机是否注册
                if ($scope.mobileInput.value == "" || $scope.mobileInput.oldValue == $scope.mobileInput.value) {
                    return;
                }
                $scope.mobileLoginModel.mobileCheckLoading = true;
                iamHttpService.post({
                    url: "/authui/findowner",
                    params: {
                        type: "mobile",
                        value: $scope.mobileInput.value
                    }
                }).then(function (data) {
                    // 记录旧值 防止多次请求
                    $scope.mobileInput.oldValue = $scope.mobileInput.value;

                    var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.mobileInput.focused = false;
                    if (data.result === "success") {
                        var count = data.count;
                        if (count > 0) {
                            // 已经注册 区分单个帐号多个帐号的显示逻辑
                            $scope.mobileLoginModel.showMobileErrorMsg = false;
                            $scope.model.pwd = "";
                            // 处理数据格式用以适配控件
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i == 0) {
                                    $scope.mobileLoginModel.loginUserId = data.users[i].id;
                                    $scope.mobileLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }

                            if (count > 1) {
                                // 多帐号
                                $scope.mobileLoginModel.showMobileSelect = true;
                                $scope.mobileUsers.selectOptions = data.users;
                                $scope.$apply();
                                // 重新渲染之后得到控件 设置默认值
                                $("#mobileUsers").widget().opChecked("1");
                            } else {
                                // 单帐号
                                $scope.$apply();
                            }

                            // 查询是否需要验证码
                            $scope.mobileLoginVerify();
                        } else {
                            // 未注册
                            $scope.mobileLoginModel.showMobileErrorMsg = true;
                            $("#checkErrorInfo").hide();
                            // 拼接注册链接
                            var countryCode = $("#codeSelectId").length > 0 ? iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()) : iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                            $scope.mobileLoginModel.registUrl = "https://reg.huaweicloud.com" + "/registerui/register.html?locale=zh-cn&locateType=mobile&areacode=" + countryCode + "&locateId=" + $scope.mobileInput.value;
                            $scope.$apply();
                        }
                    } else {
                        // 请求返回错误
                        if (data.message === "addrFrequencyHitMax") {
                            $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                            $scope.model.pwd = "";
                            $("#checkError").hide();
                            $("#serverError").show();
                            $scope.$apply();
                        }
                    }
                }, function () {
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.model.serverError = $scope.model.errorMsgObj["417"];
                    $("#checkError").hide();
                    $("#serverError").show();
                    $scope.$apply();
                });
            }
        };

        // 邮箱登录相关model            
        $scope.emailLoginModel = {
            loginUserId: "",
            loginUserDomainId: "",
            emailCheckLoading: "",
            showEmailSelect: false,
            emailExist: function emailExist() {
                // 查询邮箱            
                if ($scope.personalAccountInput.value == "" || $scope.personalAccountInput.oldValue == $scope.personalAccountInput.value) {
                    return;
                }
                $scope.emailLoginModel.emailCheckLoading = true;
                iamHttpService.post({
                    url: "/authui/findowner",
                    params: {
                        type: "email",
                        value: $scope.personalAccountInput.value
                    }
                }).then(function (data) {
                    // 记录旧值 防止多次请求            
                    $scope.personalAccountInput.oldValue = $scope.personalAccountInput.value;

                    var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : $.parseJSON(data);
                    $scope.emailLoginModel.emailCheckLoading = false;
                    if (data.result === "success") {
                        var boundAccountCount = data.count;
                        if (boundAccountCount > 0) {
                            // 已经注册 区分单个帐号多个帐号的显示逻辑            
                            $scope.emailLoginModel.showEmailErrorMsg = false;
                            $scope.model.pwd = "";
                            // 处理数据格式用以适配控件            
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i == 0) {
                                    $scope.emailLoginModel.loginUserId = data.users[i].id;
                                    $scope.emailLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }

                            $scope.emailUsers.selectOptions = data.users;
                            if (boundAccountCount > 1) {
                                // 多帐号            
                                $scope.emailLoginModel.showEmailSelect = true;
                                $scope.$apply();
                                // 重新渲染之后得到控件 设置默认值            
                                $("#emailUsers").widget().opChecked("1");
                            } else {
                                // 单帐号            
                                $scope.$apply();
                            }

                            // 查询是否需要验证码                        
                            me.loginVerify($scope);
                        } else {
                            $scope.emailUsers.selectOptions = [];
                            $scope.$apply();
                        }
                    } else {
                        // 请求返回错误            
                        if (data.message === "addrFrequencyHitMax") {
                            $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                            $scope.model.pwd = "";
                            $("#checkError").hide();
                            $("#serverError").show();
                            $scope.$apply();
                        }
                    }
                }, function () {
                    $scope.mobileLoginModel.mobileCheckLoading = false;
                    $scope.model.serverError = $scope.model.errorMsgObj["417"];
                    $("#checkError").hide();
                    $("#serverError").show();
                    $scope.$apply();
                });
            }
        };

        // 获取cbc携带过来的get参数
        if (getQueryString("userInfoType") === "mobile" && getQueryString("mobile").length > 0) {
            $scope.model.mobileLogin = true;
            $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
            $scope.model.mobileLogin = true;
            // $scope.model.userNamePH = i18n("mobileLoginModel.mobilePlaceHolder");
            $scope.mobileInput.value = getQueryString("mobile");
            $scope.mobileLoginModel.countryCode = getQueryString("countryCode");
            // getCountryCode($scope);
            // 调用接口判断是否注册
            $scope.mobileLoginModel.mobileExist();
        } else {
            $scope.mobileLoginModel.initSwitchType();
        }

        // 下拉框定义
        $scope.mobileUsers = {
            id: "mobileUsers",
            width: "320px",
            scrollHeight: 200,
            inputFieldHeight: "38px",
            mode: "single",
            selectOptions: [],
            select: function select(selectId, label) {
                $scope.mobileLoginModel.selectedUser = this.getSelectedUser(selectId, label);
                $scope.mobileLoginModel.loginUserId = $scope.mobileLoginModel.selectedUser.id;
                $scope.mobileLoginModel.loginUserDomainId = $scope.mobileLoginModel.selectedUser.domain_id;
                // 切换用户清空密码
                $scope.model.pwd = "";
                // 查询是否需要验证码
                $scope.mobileLoginVerify();
                $scope.$apply();
            },
            getSelectedUser: function getSelectedUser(selectId, label) {
                for (var i = this.selectOptions.length - 1; i >= 0; i--) {
                    var user = this.selectOptions[i];
                    if (user.selectId == selectId && user.label == label) {
                        return user;
                    }
                }
            }

            // 邮箱用户选择下拉框定义            
        };$scope.emailUsers = {
            id: "emailUsers",
            width: "320px",
            scrollHeight: 200,
            inputFieldHeight: "38px",
            mode: "single",
            selectOptions: [],
            select: function select(selectId, label) {
                $scope.emailLoginModel.selectedUser = this.getSelectedUser(selectId, label);
                $scope.emailLoginModel.loginUserId = $scope.emailLoginModel.selectedUser.id;
                $scope.emailLoginModel.loginUserDomainId = $scope.emailLoginModel.selectedUser.domain_id;
                // 切换用户清空密码            
                $scope.model.pwd = "";
                // 查询是否需要验证码            
                me.loginVerify($scope);
                $scope.$apply();
            },
            getSelectedUser: function getSelectedUser(selectId, label) {
                for (var i = this.selectOptions.length - 1; i >= 0; i--) {
                    var user = this.selectOptions[i];
                    if (user.selectId == selectId && user.label == label) {
                        return user;
                    }
                }
            }

            // 联合用户登录start
        };$scope.idpAccountInput = {
            id: "idpAccountInputId",
            value: "",
            oldValue: "",
            error: "",
            focused: false,
            ph: i18n("idpLogin.accountPh"),
            maxLength: 255,
            domainId: "",
            style: {
                height: iamUtils.layout.loginInputFieldHeight
            },
            change: function change() {
                $scope.idpAccountInput.oldValue = '';
                $scope.idpAccountInput.error = '';
                $scope.idpSelect.selectOptions = [];
                $scope.idpSelect.disable = true;
                $scope.idpSelect.selected = {};
                $scope.idpSelect.defaultSelectId = '';
            },
            blur: function blur() {
                if ($scope.idpAccountInput.value === "" || $scope.idpAccountInput.value === $scope.idpAccountInput.oldValue) return;
                $scope.getIDPs($scope);
            }

            // 手机号多用户下拉选择框
        };$scope.idpSelect = {
            id: "idpSelect",
            disable: true,
            selectOptions: [],
            selected: {},
            defaultSelectId: '',
            width: '304px',
            scrollHeight: '',
            inputFieldHeight: '',
            ph: i18n("idpLogin.listPh"),
            select: function select(selectId) {
                for (var i = 0; i < $scope.idpSelect.selectOptions.length; i++) {
                    if ($scope.idpSelect.selectOptions[i].selectId === selectId) {
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[i];
                        break;
                    }
                }
            }
        };

        // 快捷登录按钮
        $scope.idpLoginBtn = {
            submitBtnText: i18n('idpLogin.goLogin'),
            disable: false,
            loginClick: function loginClick() {
                if (!$scope.idpAccountInput.value || $scope.idpAccountInput.error || $scope.idpSelect.disable) return;
                cookieOp.addCookie("loginType", "idp", cookieOp.DEFAULT_EXPIRES_TIME);
                if ($scope.model.rememberChecked) {
                    var cookieObj = {
                        domainName: $scope.idpAccountInput.value,
                        selectedIdpId: $scope.idpSelect.selected.selectId
                    };
                    cookieOp.addCookie("enterprise_idp", JSON.stringify(cookieObj), cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie("rememberChecked", true, cookieOp.DEFAULT_EXPIRES_TIME);
                } else {
                    cookieOp.delCookie("enterprise_idp");
                    cookieOp.delCookie("rememberChecked");
                }
                var url = "https://auth.huaweicloud.com/authui/federation/websso?domain_id=" + $scope.idpAccountInput.domainId + "&idp=" + $scope.idpSelect.selected.selectId + "&protocol=" + $scope.idpSelect.selected.protocol.toLowerCase();
                var service = iamUtils.getUrlParams()['service'];
                if (service) {
                    url += '&service=' + encodeURIComponent(service);
                }
                window.location.href = url;
            }
        };

        $scope.goAccountLogin = function () {
            $scope.model.isCompany = false;
            $scope.model.isIdpLogin = false;
        };

        $scope.goIAMLogin = function () {
            $scope.model.isCompany = true;
            $scope.model.isIdpLogin = false;
        };

        $scope.goIdpLogin = function () {
            $scope.model.isIdpLogin = true;
        };

        //通过domainName获取idp列表
        $scope.getIDPs = function ($scope, defaultSelectId) {
            iamHttpService.post({
                url: "/authui/identityProviders",
                params: {
                    domain_name: encodeURIComponent($scope.idpAccountInput.value)
                }
            }).then(function (data) {
                data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : JSON.parse(data);
                $scope.idpSelect.selectOptions = [];
                $scope.idpAccountInput.domainId = data.domain_id;
                $scope.idpAccountInput.oldValue = $scope.idpAccountInput.value;
                for (var i = 0; i < data.identity_providers.length; i++) {
                    $scope.idpSelect.selectOptions.push({
                        label: data.identity_providers[i].id,
                        selectId: data.identity_providers[i].id,
                        protocol: data.identity_providers[i].protocol
                    });
                    if (data.identity_providers[i].id === defaultSelectId) {
                        $scope.idpSelect.defaultSelectId = data.identity_providers[i].id;
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[$scope.idpSelect.selectOptions.length - 1];
                    }
                }
                if ($scope.idpSelect.selectOptions.length === 0) {
                    $scope.idpAccountInput.error = $scope.model.errorMsgObj['noIdps'];
                } else {
                    if (!$scope.idpSelect.selected.selectId) {
                        $scope.idpSelect.defaultSelectId = $scope.idpSelect.selectOptions[0].selectId;
                        $scope.idpSelect.selected = $scope.idpSelect.selectOptions[0];
                    }
                    $scope.idpSelect.disable = false;
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }, function (data) {
                var response = _typeof(data.responseText) === "object" ? data.responseText : $.parseJSON(data.responseText);
                if (response.error_code === "IAM.0004") response.error_code = "noIdps";
                if (response.lock_time) response.error_code = "idpIpLock";
                $scope.idpAccountInput.error = $scope.getErrorInfo(response.error_code);
                if (response.lock_time) $scope.idpAccountInput.error = iamUtils.i18nFormat($scope.idpAccountInput.error, response.lock_time);
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
        };

        $scope.getErrorInfo = function (errorCode) {
            return $scope.model.errorMsgObj[errorCode] || i18n("systemException");
        };

        // 监听 $scope.model.isCompany 变量, 每次切换登录方式初始化手机登录按钮
        $scope.$watch('model.isCompany', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.mobileLoginModel.initSwitchType();
            }
            if (newValue === true) {
                $scope.model.userNamePH = i18n('userNamePlaceHolder');
            }
        });
        $scope.mobileBlur = function () {
            $("#checkError").hide();
            $("#serverError").hide();
            if (!window.tinyWidget.UnifyValid.FormValid($("#loginForm"))) {
                // 检查表单中的校验模块 是否通过
                return;
            } else {
                $scope.mobileLoginModel.mobileExist();
            }
        };
        $scope.mobileChange = function () {
            $("#checkError").hide();
            $("#serverError").hide();
            $scope.mobilePasswordInput.value = "";
            $scope.mobileInput.oldValue = "";
            $scope.mobileLoginModel.showMobileErrorMsg = false;
            $scope.mobileLoginModel.showMobileSelect = false;
            $scope.$apply();
        };
        $scope.mobileLoginVerify = function () {
            iamHttpService.post({
                url: "/authui/login/verify",
                params: {
                    userName: $scope.mobileLoginModel.loginUserId,
                    userType: "id",
                    accountName: $scope.mobileLoginModel.loginUserDomainId
                }
            }).then(function (data) {
                $scope.model.isNeedVerifyCode = data.needVerify;
                $scope.$apply();
            }, function () {
                $scope.model.isNeedVerifyCode = true;
                $scope.$apply();
            });
        };
        /*** END 手机号登录需求相关代码 ***/

        function getRegistUrl() {
            var service_url = iamUtils.getUrlParams()['service'];
            var registUrl = $scope.ipIsInternational ? iamUtils.CONFIG.cbcRegUrlIntl : iamUtils.CONFIG.cbcRegUrl;
            registUrl += "&hwid=login";
            registUrl += service_url ? "&service=" + encodeURIComponent(service_url) : "";
            return registUrl;
        }

        function getFpwdUrl() {
            return "/authui/login.html?locale=" + window.language + "&UserType=" + ($scope.model.isCompany ? "e" : "p") + LoginController.getServiceFromUrl() + "#/fpwd";
        }

        function createAdvScript() {
            var loginAdv = document.getElementById("loginAdv");

            // if( $scope.ipIsInternational && loginAdv){
            //     $("#loginAdv").empty();
            //     $("#loginAdv").append("<img id='loginlogo' style='margin-left:40px' />");
            //     $("#loginlogo").attr("src",getLoginLogo());
            //     return;
            // }

            if (iamUtils.isShowByStyleOfSite() && loginAdv) {
                $("#loginAdv").empty();
                $("#loginAdv").append("<img id='loginlogo'  />");
                $("#loginlogo").attr("src", getLogoOfRussia());
                return;
            }

            var oScript = document.createElement("script");
            oScript.type = "text/javascript";
            var getAdApi = "https://portal.huaweicloud.com/rest/cbc/portalapppublishservice/v1/ad/disp";
            var pos = "";
            var comp = "";
            if (loginAdv) {
                if ($scope.ipIsInternational) {
                    // 国际IP
                    switch (window.language) {
                        case "zh-cn":
                            pos = "www.huaweicloud.com/ad/login_board_en-zh.html";
                            comp = "pep-ad-img_1620800848076";
                            break;
                        case "en-us":
                            pos = "www.huaweicloud.com/ad/login_board_en-us.html";
                            comp = "pep-ad-img_1620800987830";
                            break;
                        default:
                            pos = "www.huaweicloud.com/ad/login_board_en-us.html";
                            comp = "pep-ad-img_1620800987830";
                            break;
                    }
                } else {
                    // 国内IP
                    switch (window.language) {
                        case "zh-cn":
                            pos = "www.huaweicloud.com/ad/login_board.html";
                            comp = "pep-ad-img_1619667657367";
                            break;
                        case "en-us":
                            pos = "www.huaweicloud.com/ad/login_board_ch-us.html";
                            comp = "pep-ad-img_1620800651862";
                            break;
                        default:
                            pos = "www.huaweicloud.com/ad/login_board_ch-us.html";
                            comp = "pep-ad-img_1620800651862";
                            break;
                    }
                }
                oScript.src = getAdApi + "?pos=" + pos + "&comp=" + comp + "&containerId=loginAdv&st=" + Math.random();
                loginAdv.appendChild(oScript);
            }
        }

        function getEchannelUrl() {
            var defaultUrl = "/authui/saml/login?xAccountType=eChannel";
            if ($scope.ipIsInternational) {
                return iamUtils.CONFIG.hkUserCenterUrl ? "/authui/saml/login?xAccountType=eChannel&service=" + encodeURIComponent(iamUtils.CONFIG.hkUserCenterUrl + "/#/userindex/allview") : defaultUrl;
            } else {
                return iamUtils.CONFIG.userCenterUrl ? "/authui/saml/login?xAccountType=eChannel&service=" + encodeURIComponent(iamUtils.CONFIG.userCenterUrl + "/#/userindex/allview") : defaultUrl;
            }
        }

        function getVmallServiceFromUrl() {
            var service = iamUtils.getUrlParams()["service"];
            var loginjsp = iamUtils.CONFIG.vmallCASUrl + "/oauth2/portal/login.jsp";
            var vmall = window.location.protocol + "//" + window.location.host + "/rest/authui/vmall/otherlogin";
            var homepage_intl = $scope.ipIsInternational ? "intl.huaweicloud.com" : "www.huaweicloud.com";
            if (service !== undefined) {
                vmall = vmall + "?service=" + encodeURIComponent(service);
            } else {
                vmall = vmall + "?service=" + encodeURIComponent("http://" + homepage_intl);
            }

            return "&service=" + encodeURIComponent(vmall) + "&loginUrl=" + encodeURIComponent(loginjsp);
        }

        function getVmallUrl() {
            return iamUtils.CONFIG.vmallCASUrl + "/CAS/remoteLogin?lang=" + window.language + "&validated=true&submit=true" + getVmallServiceFromUrl() + "&loginChannel=53000000&reqClientType=53";
        }

        // 扫码登录需求相关
        $scope.QRLoginModel = {
            hasQRLogin: iamUtils.CONFIG.hasQrlogin === "true" ? true : false,
            QRLoginType: false,
            QRLoginTitle: i18n("QRLogin.title1"),
            showTip: false,
            langIsCh: window.language === "zh-cn", //暂时只有中文页面显示二维码登录
            countDownTipPre: i18n("QRLogin.countDownTipPre"),
            remainingTime: window.language === "zh-cn" ? iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME) : "",
            countDownTipSuffix: i18n("QRLogin.countDownTipSuffix"),
            countDownInterval: null,
            showTipTimer: null,
            pollingInterval: null,
            QRCodeInvalid: false,
            QRCodeStatus: "new", //new, authorizing, refused, authorized
            downloadUrl: getDownloadUrl(),
            clientKey: "", //二维码标识
            QRLoginTypeSwitch: function QRLoginTypeSwitch() {
                $scope.QRLoginModel.QRLoginType = !$scope.QRLoginModel.QRLoginType;
                if ($scope.QRLoginModel.QRLoginType) {
                    //切换到扫码登录
                    send2CloudBISafe(iamUtils.pages.login, "click_QRLogin");
                    QRCodeInit();
                } else {
                    //切换到帐号登录
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
                showLoginTypeTip();
            },
            refreshQRCode: function refreshQRCode() {
                QRCodeInit();
            }

            // 获取登录凭证并生成二维码
        };function QRCodeInit() {
            $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title1");
            $scope.QRLoginModel.QRCodeStatus = "new";
            $scope.QRLoginModel.QRCodeInvalid = false;
            iamHttpService.get({
                url: "/authui/qrcode",
                cache: false,
                params: {}
            }).then(function (data) {
                data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                $scope.QRLoginModel.clientKey = data.client_key;
                $timeout(function () {
                    var loginQRCodeDiv = document.querySelector('#loginQRCodeDiv');
                    loginQRCodeDiv.innerHTML = "";
                    QRCode.toCanvas(loginQRCodeDiv, data.qrcode_content, {
                        margin: 0,
                        width: 160
                    });
                }, 0);
                countDown();
                pollingCodeStatus();
            }, function () {
                // 异常情况
                $scope.QRLoginModel.QRCodeInvalid = true;
                $scope.$apply();
            });
        }

        // 显示帐号登录tip，并在5秒后隐藏
        function showLoginTypeTip() {
            $timeout.cancel($scope.QRLoginModel.showTipTimer);
            $scope.QRLoginModel.showTip = true;
            $scope.QRLoginModel.showTipTimer = $timeout(function () {
                $scope.QRLoginModel.showTip = false;
            }, 5000);
        }

        // 二维码失效时间倒计时
        function countDown() {
            var count = 0;
            $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME - count);
            $interval.cancel($scope.QRLoginModel.countDownInterval);
            $scope.QRLoginModel.countDownInterval = $interval(function () {
                count++;
                if (count < QRCODE_VALID_TIME) {
                    $scope.QRLoginModel.remainingTime = iamUtils.i18nFormat(i18n("QRLogin.remainingTime"), QRCODE_VALID_TIME - count);
                } else {
                    $scope.QRLoginModel.QRCodeInvalid = true;
                    $interval.cancel($scope.QRLoginModel.countDownInterval);
                    $interval.cancel($scope.QRLoginModel.pollingInterval);
                }
            }, 1000);
        }

        // 轮询登录状态 
        function pollingCodeStatus() {
            var params = {};
            params.client_key = $scope.QRLoginModel.clientKey;
            var service = iamUtils.getUrlParams()["service"];
            if (service) {
                params.redirect_url = service;
            }
            $interval.cancel($scope.QRLoginModel.pollingInterval);
            $scope.QRLoginModel.pollingInterval = $interval(function () {
                iamHttpService.get({
                    url: "/authui/qrcode/status",
                    cache: false,
                    params: params
                }).then(function (data) {
                    data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                    if (data.error_code && data.error_code == "427") {
                        location.reload();
                    } else if (data.status == "authorizing") {
                        send2CloudBISafe(iamUtils.pages.login, "click_scanQRCode");
                        $scope.QRLoginModel.QRCodeStatus = "authorizing";
                        $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title2");
                        $interval.cancel($scope.QRLoginModel.countDownInterval);
                    } else if (data.status == "refused" || data.status == "expired") {
                        $scope.QRLoginModel.QRCodeStatus = "refused";
                        $scope.QRLoginModel.QRLoginTitle = i18n("QRLogin.title2");
                        $interval.cancel($scope.QRLoginModel.pollingInterval);
                    } else if (data.status == "authorized") {
                        window.location.href = data.redirect_url;
                        $interval.cancel($scope.QRLoginModel.pollingInterval);
                    }
                }, function () {});
            }, 3000);
        }

        // 获取下载APP链接
        function getDownloadUrl() {
            return "https://www.huaweicloud.com/mobile_app/hwapp.html";
        }

        showLoginTypeTip();
        // 扫码登录END

        initFromQuickLogin($scope);
    }

    $.extend(CustomerLoginController.prototype, LoginController.prototype);

    CustomerLoginController.prototype.countryCodeProcess = function ($scope, userType) {};

    //获取香港国际站的页面大logo
    function getLoginLogo() {
        if (window.language === "zh-cn") {
            return "/authui/public/custom/images/login_logo_zh_cn.png";
        } else if (window.language === "en-us") {
            return "/authui/public/custom/images/login_logo_en_us.png";
        } else if (window.language === "es-us") {
            return "/authui/public/custom/images/login_logo_es_us.png";
        } else if (window.language === "pt-br") {
            return "/authui/public/custom/images/login_logo_pt_br.png";
        } else {
            return "/authui/public/custom/images/login_logo_en_us.png";
        }
    }

    // Russia 
    function getLogoOfRussia() {
        return "/authui/public/custom/images/loginimg_en-us.png";
    }

    function getHwPortalUrl() {
        var service = iamUtils.getUrlParams()['service'];
        if (service) {
            return '/authui/saml/login?xAccountType=hwportal&service=' + encodeURIComponent(service);
        } else {
            return '/authui/saml/login?xAccountType=hwportal';
        }
    }

    function getHwDeveloperUrl() {
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            return "/authui/saml/login?xAccountType=hwdeveloper&service=" + encodeURIComponent(service);
        } else {
            return "/authui/saml/login?xAccountType=hwdeveloper";
        }
    }

    function getUniportalUrl() {
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            return "/authui/saml/login?xAccountType=uniportal&service=" + encodeURIComponent(service);
        } else {
            return "/authui/saml/login?xAccountType=uniportal";
        }
    }

    // RR2020021101004
    function getWeLinkUrl() {
        var url = "/authui/oAuthLogin?idp=welink";
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            // 如果url中存在 service 则使用 url中的 service
            url = url + "&service=" + encodeURIComponent(service);
        } else {
            // 否则使用 welink提供的配置项
            url = url + "&service=" + encodeURIComponent("https://www.huaweicloud.com/product/welink.html");
        }

        if (true) {
            url = url + "&errorPage=" + encodeURIComponent("https://welink.huaweicloud.com/wecode/error.html");
        }

        return url;
    }

    // 获取get参数
    function getQueryString(param) {
        var reg = "(^|[&|?])" + param + "=([^&|#]*)(&|#|$)";
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    function initFromQuickLogin($scope) {
        if ($scope.model.fromQuickLogin) {
            $scope.model.moreLinkIsShow = true;
        }
    }

    function getQuickLoginUrl() {
        var url = "/authui/login.html";
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            // 如果url中存在 service 则使用 url中的 service
            url = url + "?service=" + encodeURIComponent(service);
        }
        if (iamUtils.CONFIG.hasHwid === "true") {
            return url + "#/login";
        } else {
            return url + "#/hwIDLogin";
        }
    }

    CustomerLoginController = ["$scope", "$timeout", "securityPolicy", "$state", "$sce", "$interval", CustomerLoginController];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.login2.ctrl', CustomerLoginController);
    return loginModule;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__))), !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(3), __webpack_require__(6), __webpack_require__(15), __webpack_require__(130), __webpack_require__(70), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, i18n, iamUtils, iamEnv, verifyCtr, htmlTransformer, QRCode) {
    "use strict";

    var ipIsInternational = iamUtils.ipIsInternational();
    var loginVerificationCtrl = function loginVerificationCtrl($scope, $sce, $filter, $interval) {
        this.timeFormat = "yyyy-MM-dd HH:mm:ss";
        if (ipIsInternational) {
            if (window.language && window.language !== "en-us") {
                $scope.mfaHelp = "https://support-intl.huaweicloud.com/" + window.language + "/iam_faq/iam_01_0001.html";
            } else {
                $scope.mfaHelp = "https://support-intl.huaweicloud.com/iam_faq/iam_01_0001.html";
            }
        } else {
            if (window.language && window.language !== "zh-cn") {
                $scope.mfaHelp = "https://support.huaweicloud.com/" + window.language + "/iam_faq/iam_01_0001.html";
            } else {
                $scope.mfaHelp = "https://support.huaweicloud.com/iam_faq/iam_01_0001.html";
            }
        }

        $scope.isSupport = true;
        try {
            iamUtils.initialCloudBI("/authui/public/custom/loginVerification.html#/loginVerification", { C1: "IAM-Login-Verificcation" });
        } catch (e) {
            console.dir(e);
        }

        // const cssMap = {
        //     'zh-cn': require('custom/css/zh-cn/loginVerification.css'),
        //     'en-us': require('custom/css/en-us/loginVerification.css'),
        //     'pt-br': require('custom/css/pt-br/loginVerification.css'),
        //     'es-us': require('custom/css/es-us/loginVerification.css'),
        // }

        // debugger;

        // $scope.cssFile = cssMap[window.language];

        $scope.countryCodeModel = {
            height: "32px",
            tipPosition: "top",
            countryCodeSelectId: "countryCodeSelectId",
            disable: false,
            defaultCodeValue: "",
            countryCodeList: [],
            countryCodeArray: [],
            countryCodeValue: "",
            codeSelectWidth: "140px",
            countryCodeSelect: function countryCodeSelect() {
                $scope.countryCodeModel.defaultCodeValue = $("#" + $scope.countryCodeModel.countryCodeSelectId).widget().getValue();
            }

            /* 身份验证需求相关 */
        };function send2CloudBISafe() {
            try {
                send2CloudBI.apply(null, arguments);
            } catch (e) {
                console.dir(e);
            }
        }
        this.productTypeIsHWS = true;
        $scope.authModel = {
            tipPosition: "top",
            tipWidth: "250px",

            // 绑定手机相关
            defaultValue: "",
            countryCodeList: "",
            countryValue: "",
            completeMobile: "",
            haveBindPhone: false,
            bindPhoneId: "bindPhoneId",
            bindPhoneInputWidth: window.language == "zh-cn" ? "215px" : "215px",
            bindPhoneInputHeight: "32px",
            bindPhonePH: i18n("loginVerification.bindPhonePH"),
            bindPhoneValidator: iamUtils.validator.phoneAddIntl(),

            // 绑定邮箱相关
            haveBindEmail: false,
            bindEmailId: "bindEmailId",
            bindEmailInputWidth: "250px",
            bindEmailInputHeight: "32px",
            bindEmailPH: i18n("loginVerification.bindEmailPH"),
            bindEmailValidator: iamUtils.validator.email(),

            // 绑定虚拟MFA相关
            resetMFAHelpUrl: getResetMFAHelpUrl(),
            havaBindMFA: false,
            showBindMFA: false,
            disabledMFASubmitBtn: true,
            MFACodeInputWidth: "300px",
            MFACodeInputHeight: "32px",
            domainName: "",
            userName: "",
            secretKey: "",
            serialNumber: "",
            firstMFACodeId: "firstMFACodeId",
            firstMFACodeValue: "",
            secondMFACodeId: "secondMFACodeId",
            secondMFACodeValue: "",

            // 7天内无需验证虚拟MFA
            rememberMFA: false,
            rememberMFADisabled: false,
            showrememberMFACheckbox: false,
            rememberMFALabel: i18n('loginVerification.rememberMFALabel'),
            goBindMFA: function goBindMFA() {
                $scope.authModel.showBindMFA = true;
                // 获取绑定MFA信息和二维码
                iamHttpService.get({
                    url: "/authui/getMfaBindingInfo",
                    mask: true
                }).then(function (data) {
                    var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                    if (data.retinfo == "success") {
                        $scope.authModel.MFAErrorTxt = "";
                        $scope.authModel.domainName = data.domainName;
                        $scope.authModel.userName = data.username;
                        $scope.authModel.secretKey = data.secretKey;
                        $scope.authModel.serialNumber = data.serialNumber;
                        var content = "otpauth://totp/huawei:" + data.username + "?secret=" + data.secretKey;
                        var MFAQRCodeDiv = document.querySelector('#MFAQRCodeDiv');
                        MFAQRCodeDiv.innerHTML = "";
                        QRCode.toCanvas(MFAQRCodeDiv, content, {
                            margin: 0,
                            width: 120
                        });
                    } else {
                        $scope.authModel.MFAErrorTxt = i18n("systemException");
                    }
                    $scope.$apply();
                }, function () {
                    $scope.authModel.MFAErrorTxt = i18n("systemException");
                    $scope.$apply();
                });
            },
            MFACodeChange: function MFACodeChange(event, value) {
                if ($scope.authModel.firstMFACodeValue.length > 0 && $scope.authModel.secondMFACodeValue.length > 0) {
                    $scope.authModel.disabledMFASubmitBtn = false;
                    // 擦除错误提示
                    $scope.authModel.MFAErrorTxt = "";
                } else {
                    $scope.authModel.disabledMFASubmitBtn = true;
                }
            },
            submitBindMFA: function submitBindMFA() {
                bindVirtualMFA($scope, iamHttpService);
            },
            cancelBindMFA: function cancelBindMFA() {
                $scope.authModel.showBindMFA = false;
            },

            // 验证码输入框
            verifyCodeId: "verifyCodeId",
            verifyCodeInputWidth: "145px",
            verifyCodeInputHeight: "32px",
            verifyCodePH: i18n("loginVerification.verifyCodePH"),
            verifyCodeEmailPH: i18n("loginVerification.verifyCodeEmailPH"),
            verifyCodeBtnTxt: i18n("loginVerification.verifyCodeBtnTxt"),
            verifyCodeBlur: function verifyCodeBlur() {},
            verifyCodeChange: function verifyCodeChange(event, value) {
                $scope.model.actionError = "";
                if (value.length > 0) {
                    $scope.authModel.disabledSubmitBtn = false;
                } else {
                    $scope.authModel.disabledSubmitBtn = true;
                }
            },
            smsCodeValidator: iamUtils.validator.smsMsgCode(),
            emailCodeValidator: iamUtils.validator.msgCodeForHC(),
            mfaValidator: iamUtils.validator.mfaCode(),
            sendCodeSuccess: false,
            sendCodeTxt: i18n("loginVerification.sendCodeTxt"),
            // 未绑定手机和邮箱时获取验证码
            getVerifyCode: function getVerifyCode() {
                if ($scope.model.verificationType === 'sms') {
                    $scope.authModel.haveBindPhone ? getBoundVerifyCode($scope, iamHttpService) : getUnbindVerifyCode($scope, iamHttpService);
                } else if ($scope.model.verificationType === 'email') {
                    $scope.authModel.haveBindEmail ? getBoundVerifyCode($scope, iamHttpService) : getUnbindVerifyCode($scope, iamHttpService);
                } else {
                    $scope.model.actionError = i18n("systemException");
                }
            },
            // 继续登录
            disabledSubmitBtn: true,
            submitBtn: function submitBtn() {
                submitLogin($scope, iamUtils, iamEnv);
            },

            isSendSmsCodeFailed: false,
            keypress: function keypress(event) {
                if (event.keyCode === 13) {
                    $scope.authModel.submitBtn();
                }
            },
            bindMFAKeypress: function bindMFAKeypress(event) {
                if (event.keyCode === 13) {
                    $scope.authModel.submitBindMFA();
                }
            }
        };

        getCountryCode();

        $scope.authModel.rememberMFADisabled = !isRememberMFASupported();

        // 未绑定手机或邮箱时获取验证码
        function getUnbindVerifyCode($scope, iamHttpService) {
            var countryCode = iamUtils.getCodeValue($scope.countryCodeModel.countryCodeList, $scope.countryCodeModel.defaultCodeValue);
            //  绑定手机或邮箱前发送验证码
            var params = {};
            var bindPhoneValue = $("#" + $scope.authModel.bindPhoneId + ">input").val();
            switch ($scope.model.verificationType) {
                case "sms":
                    params = { mobile: countryCode + "-" + bindPhoneValue };break;
                case "email":
                    params = { email: $scope.authModel.bindEmailValue };break;
                default:
                    params = {};break;
            }
            var config = {
                url: "/authui/sendBindCode",
                mask: true,
                params: params
            };
            var promise = iamHttpService.post(config);
            promise.then(function (data) {
                // 擦除错误提示
                $scope.model.actionError = "";

                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                if (data.retinfo === 'success') {
                    // 验证码发送成功
                    $scope.authModel.sendCodeSuccess = true;
                    retrieveCountdown();
                } else {
                    // 验证码发送失败
                    $scope.authModel.sendCodeSuccess = false;
                    if (data.retcode == 400) {
                        // 您输入的邮箱或手机号不可用。
                        $scope.model.actionError = i18n("loginVerification.validEmailOrPhone");
                    } else if (data.retcode == 401) {
                        // 操作过于频繁
                        $scope.model.actionError = i18n("operationTooFrequent");;
                    } else if (data.retcode == 402) {
                        // 获取验证码功能已被锁定
                        $scope.model.actionError = i18n("verifyCode.locked");;
                    } else if (data.retcode == 503) {
                        // 服务器发送手机或email失败。如其他号码则未知异常
                        $scope.model.actionError = i18n("loginVerification.sendCodeFailed");
                    } else {
                        $scope.model.actionError = i18n("systemException");
                    }
                }
                $scope.$apply();
            }, function () {
                // 接口错误
                $scope.authModel.disabledSubmitBtn = true;
                $scope.model.actionError = i18n("systemException");
                $scope.$apply();
            });
        }

        // 已绑定手机或邮箱时获取验证码
        function getBoundVerifyCode($scope, iamHttpService) {
            if ($scope.model.verificationType) {
                send2CloudBISafe("button", "click", "login_verification_" + $scope.model.verificationType, '');
            }

            iamHttpService.post({
                url: "/authui/sendLoginSms",
                params: {}
            }).then(function (data) {
                // 擦除错误提示
                $scope.model.actionError = "";

                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                if (data.result === "success") {
                    var remainderCount = data.remainderCount;
                    if (remainderCount >= 0) {
                        var content = remainderCount == 0 ? i18n("verifyCode.cantAcquire") : iamUtils.i18nFormat(i18n("verifyCode.remainderCount"), remainderCount);
                        $scope.model.actionError = content;
                        if (remainderCount > 0) {
                            retrieveCountdown();
                        } else {
                            $scope.$apply();
                        }
                    } else {
                        // 验证码发送成功
                        $scope.authModel.sendCodeSuccess = true;
                        retrieveCountdown();
                    }
                    return;
                } else if (data.result === "faster") {
                    $scope.model.actionError = i18n("verifyCode.intervalError");
                } else if (data.result === "locked") {
                    var lockedMsg = i18n("verifyCode.locked");
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n("verifyCode.locked.custom"), data.lockDuration);
                    }
                    $scope.model.actionError = lockedMsg;
                } else if (data.result === "error") {
                    $scope.model.actionError = i18n("verifyCode.sendFailed");
                }
            }, function (data) {
                if (data.status == 403) {
                    var btnBack2Login = [{
                        key: "btnwed12",
                        label: i18n("btnTxtOK"),
                        accessKey: '3',
                        focused: true,
                        handler: function handler(event) {
                            iamUtils.redirect2Login();
                        }
                    }];
                    iamUtils.MESSAGE.ERROR(i18n("sessionExpired"), "", "popupMsg", btnBack2Login, iamUtils.redirect2Login);
                } else {
                    $scope.model.actionError = i18n("systemException");
                }
            });
        }

        //为用户绑定虚拟MFA
        function bindVirtualMFA($scope, iamHttpService) {
            if ($scope.authModel.disabledMFASubmitBtn) {
                return;
            }
            $scope.authModel.disabledMFASubmitBtn = true;
            var config = {
                url: "/authui/bindMfa",
                mask: true,
                params: {
                    serialNumber: $scope.authModel.serialNumber,
                    firstRegCode: $("#" + $scope.authModel.firstMFACodeId + ">input").val(),
                    secondRegCode: $("#" + $scope.authModel.secondMFACodeId + ">input").val()
                }
            };
            var promise = iamHttpService.post(config);
            promise.then(function (data) {
                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                if (data.retinfo === 'success') {
                    if (data.retcode == 0) {
                        // 绑定成功
                        $scope.authModel.showBindMFA = false;
                        $scope.authModel.havaBindMFA = true;
                        iamUtils.MESSAGE.PROMPT(i18n("loginVerification.bindMFASucceed"), "", "popupMsg");
                    } else if (data.retcode == -1) {
                        // MFA验证码错误
                        $scope.authModel.MFAErrorTxt = i18n("loginVerification.mfaCodeError");
                    } else {
                        // 系统繁忙
                        $scope.authModel.MFAErrorTxt = i18n("systemException");
                    }
                    $scope.$apply();
                } else {
                    $scope.authModel.disabledMFASubmitBtn = true;
                    $scope.authModel.MFAErrorTxt = i18n("systemException");
                    $scope.$apply();
                }
            }, function () {
                // 接口错误
                $scope.authModel.disabledMFASubmitBtn = true;
                $scope.authModel.MFAErrorTxt = i18n("systemException");
                $scope.$apply();
            });
        }

        // 继续登录
        function submitLogin($scope, iamUtils, iamEnv) {
            send2CloudBISafe("button", "click", "login_verification_" + $scope.model.verificationType + "_nextStep", '');
            if (!iamUtils.unifyValid.FormValid($("#verifyCodeId"))) {
                iamUtils.unifyValid.focusFirst($("#verifyCodeId"));
                return;
            }

            if ($scope.authModel.disabledSubmitBtn) {
                return;
            } else {
                $scope.authModel.disabledSubmitBtn = !$scope.authModel.disabledSubmitBtn;
            }

            if (iamEnv.isPublishEnv()) {
                var temp = document.createElement("form");
                if (window.location.search === "") {
                    temp.action = "/authui/validateUser";
                } else {
                    temp.action = "/authui/validateUser?" + window.location.search.substring(1, window.location.search.length);
                }
                temp.method = "post";
                temp.style.display = "none";
                if ($scope.model.verificationType !== "" && $scope.model.verificationType !== "none") {

                    var opt = document.createElement("textarea");
                    opt.name = "smsCode";
                    // 修复验证位数获取错误的bug
                    // opt.value = $scope.authModel.verifyCodeValue;
                    opt.value = $("#" + $scope.authModel.verifyCodeId + ">input").val();
                    temp.appendChild(opt);
                }
                // 如果是手机验证
                if ($scope.model.verificationType === "sms") {
                    var mobile = document.createElement("textarea");
                    mobile.name = "mobile";
                    var countryCode = iamUtils.getCodeValue($scope.countryCodeModel.countryCodeList, $scope.countryCodeModel.defaultCodeValue);
                    var bindPhoneValue = $("#" + $scope.authModel.bindPhoneId + ">input").val();
                    mobile.value = countryCode + "-" + bindPhoneValue;
                    temp.appendChild(mobile);
                }
                // 如果是邮箱验证
                if ($scope.model.verificationType === "email") {
                    var email = document.createElement("textarea");
                    email.name = "email";
                    email.value = $scope.authModel.bindEmailValue;
                    temp.appendChild(email);
                }

                if ($scope.model.verificationType === 'vmfa') {
                    // 如果是vmfa验证
                    var rememberMFAOpt = document.createElement("textarea");
                    rememberMFAOpt.name = "rememberMFA";
                    rememberMFAOpt.value = $scope.authModel.rememberMFA;
                    temp.appendChild(rememberMFAOpt);
                }
                // step
                var step = document.createElement("textarea");
                step.name = "step";
                step.value = "afterAntiPhishing";
                temp.appendChild(step);
                // IAMCSRF
                var IAMCSRFClient = document.createElement("textarea");
                IAMCSRFClient.name = "IAMCSRF";
                IAMCSRFClient.value = $("#IAMCSRFClient").text();
                temp.appendChild(IAMCSRFClient);

                //isSupport 为true 为新接口
                if ($scope.isSupport) {
                    var isSupport = document.createElement("textarea");
                    isSupport.name = "isSupport";
                    isSupport.value = true;
                    temp.appendChild(isSupport);
                }

                // 统一ID兼容
                if (iamUtils.getUrlParams()['isFromID']) {
                    var opt = document.createElement("textarea");
                    opt.name = "isFromID";
                    opt.value = iamUtils.getUrlParams()['isFromID'];
                    temp.appendChild(opt);
                }

                document.body.appendChild(temp);
                temp.submit();
            } else {
                iamHttpService.post({
                    url: "/authui/validateUser",
                    params: {}
                }).then(function (data) {
                    if (data.loginResult === "success") {
                        window.location.href = data.redirectUrl;
                        return;
                    }
                }, function (data) {});
            }
        }

        // 获取国家码 暂时注释
        function getCountryCode() {
            iamHttpService.get({
                url: "/authui/getCountryCode",
                async: false,
                params: {}
            }).then(function (data) {
                var data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
                var codeList = data["codeArray"];
                var defaultCode = data["defaultCode"];
                var codeArray = [];
                if (codeList.length) {
                    codeList = codeList.sort(iamUtils.SortArray('label'));
                    $scope.authModel.defaultValue = iamUtils.getCountryValue(codeList, defaultCode);
                    $scope.authModel.countryCodeList = codeList;
                    $scope.countryCodeModel.defaultCodeValue = iamUtils.getCountryValue(codeList, defaultCode);
                    $scope.countryCodeModel.countryCodeList = codeList;
                    for (var item in codeList) {
                        $scope.countryCodeModel.countryCodeArray.push(codeList[item].label);
                    }
                }
            }, function () {});
        }

        // 倒计时
        function retrieveCountdown() {
            var second = 60;
            $scope.authModel.retrieveTxt = iamUtils.i18nFormat(i18n('loginVerification.retrieveTxt'), second);
            var timerHandler;
            timerHandler = $interval(function () {
                second--;
                if (second < 0) {
                    $interval.cancel(timerHandler);
                    $scope.authModel.sendCodeSuccess = false;
                } else {
                    $scope.authModel.retrieveTxt = iamUtils.i18nFormat(i18n('loginVerification.retrieveTxt'), second);
                    $scope.authModel.sendCodeSuccess = true;
                }
            }, 1000);
        }
        /* END */

        function getResetMFAHelpUrl() {
            var _url = "";
            if (ipIsInternational) {
                // 国际IP 
                if (window.language) {
                    _url = "/intl/" + window.language + "/iam_faq/iam_01_0004.html";
                } else {
                    _url = "/intl/en-us/iam_faq/iam_01_0004.html";
                }
            } else {
                // 国内IP
                if (window.language && window.language === "zh-cn") {
                    _url = "/iam_faq/iam_01_0004.html";
                } else {
                    _url = "/en-us/iam_faq/iam_01_0004.html";
                }
            }
            _url = "https://support.huaweicloud.com" + _url;

            return $sce.trustAsHtml(htmlTransformer.htmlDecode(iamUtils.i18nFormat(i18n('loginVerification.resetMFAHelpUrl'), _url)));
        }

        // 是否支持vmfa七天无需再次验证
        function isRememberMFASupported() {
            var mfaCookieArr = document.cookie.match(/rememberMFA_/g);
            return !mfaCookieArr || mfaCookieArr.length < 5;
        }

        verifyCtr.call(this, $scope, $sce, i18n, iamUtils, iamEnv, $filter, $interval);
    };

    $.extend(loginVerificationCtrl.prototype, verifyCtr.prototype);
    loginVerificationCtrl = ['$scope', '$sce', '$filter', '$interval', loginVerificationCtrl];
    var loginVerificationModule = angular.module('authui.config');
    loginVerificationModule.controller('authui.loginVerification.ctrl', loginVerificationCtrl);

    return loginVerificationCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(4), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, iamHttpService, GrahicVerifyWindow) {
    "use strict";

    var ctrl = function ctrl($scope, securityPolicy) {
        $scope.i18n = i18n;
        document.title = i18n("titles.bindAccount");

        $scope.model = {
            url: sessionStorage.getItem("url"),
            bindRequest: sessionStorage.getItem("bindRequest"),
            Signature: sessionStorage.getItem("Signature"),
            SigAlg: sessionStorage.getItem("SigAlg"),
            loading: true
        };
        init($scope, iamUtils);
    };

    function init($scope, iamUtils) {
        var form = document.getElementById("notify_form");
        form.setAttribute("action", $scope.model.url);
        document.getElementById("bindRequest").value = $scope.model.bindRequest;
        document.getElementById("Signature").value = $scope.model.Signature;
        document.getElementById("SigAlg").value = $scope.model.SigAlg;
        form.submit();
        document.getElementById("notify_result").onload = function () {
            setTimeout(function () {
                $scope.model.loading = false;
                $scope.$apply();
            }, 1000);
        };
    }

    var dvpRegisterModule = angular.module('authui.config');
    ctrl = ["$scope", "securityPolicy", ctrl];
    dvpRegisterModule.controller('authui.notify.ctrl', ctrl);
    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(131)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, updateCtrl) {
    "use strict";

    var privacyUpdateCtrl = function privacyUpdateCtrl($scope) {
        updateCtrl.call(this, $scope);

        // 隐私政策声明链接区分国内站和国际站
        $scope.model.privacyAgreement = window.ipIsInternational ? "https://intl.huaweicloud.com/" + window.language + "/declaration/sa_prp.html" : window.language === "zh-cn" ? "https://www.huaweicloud.com/declaration/sa_prp.html" : "https://www.huaweicloud.com/en-us/declaration/sa_prp.html";
    };
    var privacyUpdateModule = angular.module('authui.config');
    privacyUpdateCtrl = ['$scope', privacyUpdateCtrl];
    privacyUpdateModule.controller('authui.privacyUpdate.ctrl', privacyUpdateCtrl);
    return privacyUpdateCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(11), __webpack_require__(132)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, cookieOp, ResetPwd) {
    'use strict';

    function CustomizedResetPwd($scope, securityPolicy) {

        ResetPwd.call(this, $scope, securityPolicy, i18n, iamUtils);

        try {
            _ozprm = 'userid=' + cookieOp.getCookie('userId');
            cookieOp.delCookie('userId');
            // require(["https://sstatic.huaweicloud.com/static/js/o_code.js"]);
        } catch (e) {}
    };
    ResetPwd.prototype.customizedInitResetPage = function ($scope, userInfo) {
        var me = this;
        var ipIsInternational = iamUtils.ipIsInternational();
        if (!ipIsInternational) return;
        $scope.model.verifyTypeValue = userInfo.email;
        $scope.model.verifyTypeLabel = i18n('resetPwd.mailbox');
        $scope.model.msgCodeLabel = i18n('resetPwd.emailMsgCode');
        $scope.model.verifyTypeBtn = i18n('resetPwd.byPhone');
        $scope.model.emailMsgCodeBtnHandler = me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), true);
        $scope.model.smsMsgCodeBtnHandler = me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), false);
        $scope.model.verifyType = 'email';
    };
    $.extend(CustomizedResetPwd.prototype, ResetPwd.prototype);
    //当前用户是香港国际站点的用户时

    CustomizedResetPwd = ['$scope', 'securityPolicy', CustomizedResetPwd];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.resetPwd.ctrl', CustomizedResetPwd);

    return CustomizedResetPwd;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(6), __webpack_require__(11), __webpack_require__(5), __webpack_require__(4), __webpack_require__(72), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n, iamUtils, cookieOp, utils, iamHttpService, perVerifycodeUtilNew, GrahicVerifyWindow) {
    'use strict';

    function SsologinController($scope, securityPolicy, $compile, $interval, $state) {
        $scope.i18n = i18n;
        document.title = i18n('titles.login');
        $scope.model = {
            redirectUrl: '',
            ssoType: '',
            xUserId: '',
            domainList: [],
            selectedDomain: '',
            selectedId: '',
            select: function select(domain, id) {
                $scope.model.selectedDomain = domain;
                $scope.model.selectedId = id;
            },
            btnClick: function btnClick() {
                if (!$scope.model.selectedDomain || !$scope.model.selectedId) return;
                var selectedDomain = encodeURIComponent($scope.model.selectedDomain);
                var selectedId = encodeURIComponent($scope.model.selectedId);
                var url = 'https://auth.huaweicloud.com/authui/multi-tenant/samlLogin?domain_id=' + selectedDomain + '&idp_id=' + selectedId;
                if ($scope.model.redirectUrl) {
                    url += '&redirect_url=' + encodeURIComponent($scope.model.redirectUrl);
                }
                if ($scope.model.ssoType) {
                    url += '&sso_type=' + $scope.model.ssoType;
                }
                if ($scope.model.xUserId) {
                    url += '&xuser_id=' + $scope.model.xUserId;
                }
                window.location.href = url;
            }
        };

        initPage($scope);
    };

    function initPage($scope) {
        $scope.model.redirectUrl = iamUtils.getUrlParams()['redirect_url'];
        $scope.model.ssoType = iamUtils.getUrlParams()['sso_type'];
        $scope.model.xUserId = iamUtils.getUrlParams()['xuser_id'];
        var idpJsonStr = iamUtils.getUrlParams()['idp'];
        idpJsonStr = decodeURIComponent(idpJsonStr);
        var domainList;
        try {
            domainList = JSON.parse(idpJsonStr);
        } catch (e) {
            iamUtils.redirect2Login();
        }
        $scope.model.domainList = [];
        for (var i = 0; i < domainList.length; i++) {
            if (domainCheck(domainList[i])) $scope.model.domainList.push(domainList[i]);
        }
        if ($scope.model.domainList.length <= 0) {
            iamUtils.redirect2Login();
        }
    }

    //校验是否合法
    function domainCheck(domainObj) {
        if (!domainObj.domain_name || !domainObj.domain_id || !domainObj.idp_id) return false;
        var idps = domainObj.idp_id;
        domainObj.idp_id = [];
        for (var i = 0; i < idps.length; i++) {
            if (idps[i] && domainObj.idp_id.indexOf(idps[i]) === -1) domainObj.idp_id.push(idps[i]);
        }
        if (domainObj.idp_id.length <= 0) return false;
        return true;
    }

    SsologinController = ['$scope', 'securityPolicy', '$compile', '$interval', '$state', SsologinController];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.ssologin.ctrl', SsologinController);

    return SsologinController;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(3), __webpack_require__(6), __webpack_require__(15), __webpack_require__(23), __webpack_require__(11), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils) {
    "use strict";

    var upgradeCtrl = function upgradeCtrl($scope, $sce, $filter, $interval, $timeout) {
        if (window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1) {
            document.title = i18n("hwId.upgradePageTitle");
        }

        try {
            var isOptional = iamUtils.getUrlParams()['upgradeType'] === 'optional' ? 'optional' : 'notOptional';
            iamUtils.initialCloudBI("/authui/public/custom/login.html?upgradeType=" + isOptional + "#/upgrade", { C1: "IAM-Login-" + isOptional + "-upgrade" });
        } catch (e) {
            console.dir(e);
        }

        $scope.i18n = i18n;

        $scope.model = {
            isMobile: window.outerWidth > 768 && window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true,
            isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") > -1,
            agree: false, //是否同意协议
            isUpgrading: false, //开始升级
            isOptional: false, //是否可选升级
            migrateToken: iamUtils.getUrlParams()['migrateToken'],
            srcInnerUID: "",
            errorMsg: "",
            upgradeError: false,
            sdkLoading: true,
            upgradeSuccess: false,
            upgradeDescLink: iamUtils.CONFIG.upgradeDescLink,
            userAgreementLink: getUserAgreementLink(),
            privacyPolicyLink: getPrivacyPolicyLink()
        };

        $scope.agreeClick = function () {
            $scope.model.agree = !$scope.model.agree;
            window.scrollTo(0, document.documentElement.scrollHeight);
        };

        $scope.goUpgrade = function () {
            if (!$scope.model.agree) {
                return;
            }
            send2CloudBISafe(iamUtils.pages.upgrade, "click_upgrade");
            $scope.model.isUpgrading = true;
            getSDKBaseInfo($scope);
        };

        $scope.cancelUpgrade = function () {
            send2CloudBISafe(iamUtils.pages.upgrade, "click_cancelUpgrade");
            if (window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") > -1) {
                window.location.href = "https://" + 'auth.huaweicloud.com' + "/authui/appNoUpgradeLogin";
                return;
            }
            window.location.href = "/authui/" + window.location.search;
        };

        $scope.upgradeGoBack = function () {
            window.location.reload();
        };

        initPage($scope);
    };

    // 调用authui/getSDKBaseInfo接口获取js-sdk的url及配置信息
    function getSDKBaseInfo($scope) {
        var params = {
            flowType: "migrate",
            migrateToken: $scope.model.migrateToken
        };
        if (utils.getUrlParams().service) {
            params.service = utils.getUrlParams().service;
        }
        iamHttpService.get({
            url: "/authui/getSDKBaseInfo",
            params: params
        }).then(function (data) {
            data = (typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" ? data : $.parseJSON(data);
            if (data.isSuccess === 1) {
                var baseConfig = {
                    "isSuccess": "1",
                    "pageTokenKey": data.pageTokenKey,
                    "pageToken": data.pageToken,
                    "jsSdkUrl": data.jsSdkUrl,
                    "hwidConfig": data.hwidConfig
                };
                baseConfig.businessConf = {
                    flowType: "migrate", //迁移流程
                    clientType: $scope.model.isMobile ? "mobileWap" : "pcWeb", //手机还是pc
                    showType: "page", // 展示方式
                    migrateToken: $scope.model.migrateToken,
                    innerUid: data.innerUid,
                    srcAcctType: 1,
                    migrateSenceId: 0,
                    sucCallbackFn: function sucCallbackFn() {
                        $(".upgradeGoBack").hide();
                        $scope.model.upgradeSuccess = true;
                        if ($scope.model.isOptional) {
                            window.addEventListener('popstate', function () {
                                history.pushState(null, null, document.URL);
                            });
                        }
                    },
                    failCallbackFn: function failCallbackFn() {
                        $(".upgradeGoBack").hide();
                    },
                    bsFailUrl: getBsFailUrl($scope)
                };
                monitorSDKLoading($scope);
                loadJsSDK(baseConfig, $scope);
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            } else {
                $scope.model.upgradeError = true;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            $scope.model.upgradeError = true;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    // 获取js-sdk并渲染登录框
    function loadJsSDK(baseConfig, $scope) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (script.readyState) {
            // IE
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    hwidSDK.init(baseConfig);
                }
            };
        } else {
            // 其他浏览器
            script.onload = function () {
                hwidSDK.init(baseConfig);
            };
        }
        script.src = baseConfig.jsSdkUrl;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    function initPage($scope) {
        if (iamUtils.getUrlParams()['upgradeType'] && iamUtils.getUrlParams()['upgradeType'] === 'optional') {
            $scope.model.isOptional = true;
            $scope.model.agree = false;
        }
        if (!$scope.model.isOptional) {
            if (window.history && window.history.pushState) {
                var service = utils.getUrlParams().service;
                service !== undefined ? service = "https://auth.huaweicloud.com/authui/logout?service=" + service : service = "https://auth.huaweicloud.com/authui/logout";
                var redirectUrl = "https://id1.cloud.huawei.com/AMW/logout" + "?service=" + service;
                var state = {
                    title: "upgrade",
                    url: redirectUrl
                };
                window.history.pushState(state, "title", "#/upgrade");
                window.addEventListener('popstate', function () {
                    if ($scope.model.upgradeSuccess) {
                        history.pushState(null, null, document.URL);
                    } else {
                        localStorage.removeItem("fromUpgrade");
                        window.location.href = redirectUrl;
                    }
                });
                localStorage.fromUpgrade = "true";
                window.addEventListener('keydown', function () {
                    localStorage.removeItem("fromUpgrade");
                });
                window.addEventListener('click', function () {
                    localStorage.removeItem("fromUpgrade");
                });
            }
        }
        if ($scope.model.isLiteSDK) {
            if (window.webLoader && window.webLoader.setForbiddenGoBackUrl) {
                var service = "https://auth.huaweicloud.com/authui/login.html?locale=zh-cn";
                var redirectUrl = "https://auth.huaweicloud.com/authui/logout" + "?service=" + service;
                window.webLoader.setForbiddenGoBackUrl(window.location.href);
                window.goBack = function () {
                    window.location.href = redirectUrl;
                };
            }
        }
    }

    function send2CloudBISafe() {
        try {
            send2CloudBI.apply(null, arguments);
        } catch (e) {
            console.dir(e);
        }
    }

    function monitorSDKLoading($scope) {
        var container = document.getElementById('hwidsdk_mudule_container');
        var mutationObserver = new MutationObserver(function () {
            $scope.model.sdkLoading = false;
            mutationObserver.disconnect();
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
        mutationObserver.observe(container, {
            childList: true,
            subtree: true
        });
    }

    function getUserAgreementLink() {
        var link = "https://consumer.huawei.com/minisite/cloudservice/id/terms.htm" + "?branchid=1";
        link += "&language=" + window.language;
        link += "&country=" + (iamUtils.ipIsInternational() ? "HK" : "CN");
        return link;
    }

    function getPrivacyPolicyLink() {
        var link = "https://consumer.huawei.com/minisite/cloudservice/id/privacy-statement.htm" + "?branchid=1";
        link += "&language=" + window.language;
        link += "&country=" + (iamUtils.ipIsInternational() ? "HK" : "CN");
        return link;
    }

    function getBsFailUrl($scope) {
        var bsFailUrl = iamUtils.CONFIG.homepageUrl;
        if ($scope.model.isLiteSDK) {
            bsFailUrl = "https://auth.huaweicloud.com/authui/casLogin?error=1107&error_description=access+denied";
        }
        return bsFailUrl;
    }

    upgradeCtrl = ["$scope", "$sce", "$filter", "$interval", "$timeout", upgradeCtrl];
    var upgradeModule = angular.module('authui.config');
    upgradeModule.controller('authui.upgrade.ctrl', upgradeCtrl);

    return upgradeCtrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18n) {
    "use strict";

    var ctrl = function ctrl($scope, $compile) {
        document.title = i18n("titles.welcomeEmail");
        $scope.i18n = i18n;
        $scope.model = {};
        $("#failedContainer").css({ "background-color": "#F4F4F4", "margin-top": "100px" });
        $("#failedContent").css("background-color", "#F4F4F4");
    };

    ctrl = ["$scope", "$compile", ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller("authui.welEmailFailed.ctrl", ctrl);

    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(3), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (iamHttpService, i18n, iamUtils) {
    "use strict";

    var ctrl = function ctrl($scope, $compile) {
        document.title = i18n("titles.welcomeEmail");
        $scope.i18n = i18n;
        $scope.model = {};

        $scope.resendEmail = function () {
            iamHttpService.post({
                url: "/rest/authui/welcome/resendEmail",
                mask: true
            }).then(function (data) {
                if (data.retinfo === "success") {
                    iamUtils.MESSAGE.PROMPT(i18n("welcomeEmail.alreadySend"), "", "popupMsg");
                } else if (data.retinfo === "failed") {
                    iamUtils.MESSAGE.ERROR(i18n("sendFailed"), "", "popupMsg");
                } else {
                    redirect2Login();
                }
            }, function (data) {
                iamUtils.MESSAGE.ERROR(i18n("sendFailed"), "", "popupMsg");
            });
        };

        function redirect2Login() {
            var service = iamUtils.getUrlParams()["service"];
            if (service) {
                window.location.href = "/authui/?locale=" + window.language + "&service=" + iamUtils.getUrlParams()["service"];
            } else {
                window.location.href = "/authui/?locale=" + window.language;
            }
        }

        $("#failedContainer").css({ "background-color": "#F4F4F4", "margin-top": "100px" });
        $("#failedContent").css("background-color", "#F4F4F4");
    };

    ctrl = ["$scope", "$compile", ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller("authui.welEmailResend.ctrl", ctrl);

    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(4), __webpack_require__(3), __webpack_require__(6), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (cookieOp, iamHttpService, i18n, iamUtils, utils) {
    'use strict';

    var ctrl = function ctrl($scope, securityPolicy) {
        $scope.i18n = i18n;
        document.title = i18n('titles.setPassword');
        $scope.model = {
            width: '100%',
            pwdTip: utils.buildTip(null, null, null, null, null, i18n),
            height: iamUtils.layout.inputFieldHeight,
            type: 'password',
            passwordId: 'passwordId',
            confirmPasswordId: 'confirmPasswordId',
            password: '',
            confirmPassword: '',
            lowPasswords: [],
            maxPwdLength: securityPolicy.passwordpolicy.password_maxlen,
            'lastWeakPasswdLvl': '',
            'validTip': '/authui/public/custom/images/default.png',
            'validSuc': __webpack_require__(66),
            'validFail': __webpack_require__(68),
            onPasswordFocus: function onPasswordFocus() {
                var value = $('#' + $scope.model.passwordId).widget().getValue();
                if (value !== '') {
                    validatePwdAll(value, securityPolicy, $scope);
                } else {
                    utils.addErrorTip(i18n('blankTxt'), '#PasswordError');
                }
            },
            onPasswordChange: function onPasswordChange(event, value) {
                if ($scope.model.lowPasswords.indexOf(value) > -1) {
                    $scope.model.isWeakPassword = true;
                } else {
                    $scope.model.isWeakPassword = false;
                }
                $scope.model.confirmPassword = '';
                $scope.$apply();
                var removeObj = utils.getInputObj($scope.model.passwordId);
                removeObj.removeClass('valid_error_input');
                utils.removeErrorInfo('#PasswordError');
                validatePwdAll(value, securityPolicy, $scope);
            },
            passwordBlur: function passwordBlur() {
                $scope.model.isWeakPassword = false;
                var value = $('#' + $scope.model.passwordId).widget().getValue();
                var retObj = utils.validatePasswdChar(value);
                var retMinLenth = value.length >= $scope.model.pwdMinLen;
                var retObjCharTimes = utils.maxRptCharTimes(value, $scope.model.contSameCharLen);
                var containsCharsResult = utils.validatePasswdChar(value, securityPolicy.passwordpolicy.password_char_combination);
                if (retObj && retMinLenth && retObjCharTimes && containsCharsResult) {
                    passwdAsynCheck($scope);
                    $scope.model.passwdDtd.fail(function () {
                        password2error($scope);
                        if ($scope.model.passwdErr !== i18n('pwdNotUsernameOrInvert')) {
                            utils.addErrorTip($scope.model.passwdErr, '#PasswordError');
                        }
                        return;
                    }).done(function () {
                        var removeObj = utils.getInputObj($scope.model.passwordId);
                        removeObj.removeClass('valid_error_input');
                    });
                } else {
                    password2error($scope);
                }
            },
            onConfirmPasswordBlur: function onConfirmPasswordBlur() {
                var value = $('#' + $scope.model.confirmPasswordId).widget().getValue();
                var retObj = iamUtils.directValidator.confirmPwd(value, $scope.model.passwordId);
                if (retObj.result) {
                    utils.removeErrorInfo('#confirmPasswordError');
                    var removeObj = utils.getInputObj($scope.model.confirmPasswordId);
                    removeObj.removeClass('valid_error_input');
                } else {
                    //$("#" + $scope.model.confirmPasswordId).addClass("valid_error_input");
                    var pwdObj = $('#' + $scope.model.confirmPasswordId); //兼容tiny1.48.1和之前的老版本
                    if (pwdObj[0].tagName === 'INPUT') {
                        pwdObj.addClass('valid_error_input');
                    } else {
                        pwdObj.find('input').addClass('valid_error_input');
                    }
                    utils.addErrorTip(retObj.errorInfo, '#confirmPasswordError');
                }
            }
        };
        getPasswordPolicy($scope, iamHttpService, securityPolicy);
        $scope.model.pwdMinLenDtd.done(function () {
            var contSameCharLenTips = null;
            if ($scope.model.contSameCharLen !== 0) {
                contSameCharLenTips = utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'), $scope.model.contSameCharLen);
            }
            $scope.model.pwdTip = utils.buildTip(utils.i18nFormat(i18n('minMaxLenTxt'), $scope.model.pwdMinLen, securityPolicy.passwordpolicy.password_maxlen), utils.i18nFormat(i18n('passwordChars'), securityPolicy.passwordpolicy.password_char_combination), contSameCharLenTips, i18n('pwdNotUsernameOrInvert'), null, i18n);
            $scope.$apply();
        });
        $scope.model.equalValidate = iamUtils.validator.confirmPwd('passwordId');
        $scope.model.keyPress = function (event) {
            iamUtils.enterEvent(event, $scope.onSubmitClick);
        };
        $scope.onSubmitClick = function () {
            if ($scope.model.password === '' || $scope.model.confirmPassword === '') {
                return;
            }
            if ($('#submitBtn').hasClass('btnDisabled')) {
                return;
            }
            if (hasErrorInfo($scope)) {
                return;
            }
            $('#submitBtn').addClass('btnDisabled');
            $scope.model.passwdDtd.fail(function () {
                password2error($scope);
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }).done(function () {
                var productType = window.productType;
                if (productType == 'HWS') {
                    iamHttpService.get({
                        url: '/authui/logout',
                        mask: true
                    }).then(function (data) {
                        post('/authui/welcomeLogin' + window.location.search, {
                            passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                            confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                            pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                        });
                    }, function () {
                        post('/authui/welcomeLogin' + window.location.search, {
                            passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                            confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                            pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                        });
                    });
                } else {
                    post('/authui/welcomeLogin' + window.location.search, {
                        passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                        confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                        pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                    });
                }
            });
        };

        $scope.onCancelClick = function () {
            var service = iamUtils.getUrlParams().service;
            service !== undefined ? window.location.href = '/authui/logout?service=' + service : window.location.href = '/authui/logout';
        };
        setErrorMsg();
    };

    function hasErrorInfo($scope) {
        var errorIds = ['passwordError', 'confirmPasswordError'];
        var inputIds = ['passwordId', 'confirmPasswordId'];
        $scope.model.passwordBlur();
        $scope.model.onConfirmPasswordBlur();
        for (var index in errorIds) {
            if ($('#' + errorIds[index])[0] === undefined) {
                for (var index in inputIds) {
                    if ($('#' + inputIds[index] + '>input').hasClass('valid_error_input')) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function validatePwdAll(value, securityPolicy, $scope) {
        var password = value;
        var isBlank = value.length == 0;
        var minLenResult = password.length >= securityPolicy.passwordpolicy.password_minlen && password.length <= 32;
        var containsCharsResult = utils.validatePasswdChar(password, securityPolicy.passwordpolicy.password_char_combination);
        var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
        var validatePasswdName = utils.validatePasswdName(password, $scope.model.name) && utils.validatePasswdNameSHA256(password, $scope.model.name);

        if (!$scope.model.isWeakPassword || !minLenResult) {
            utils.setPwdLevel4Hws('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', password, i18n, securityPolicy.passwordpolicy.password_minlen);
        } else {
            utils.setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', 'low', i18n);
        }
        changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope);
    }

    function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
        change2ResultEach($scope, 'minLenId', minLenResult);
        change2ResultEach($scope, 'containsCharsId', containsCharsResult);
        change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
        change2ResultEach($scope, 'notNameId', validatePasswdName);
        if (isBlank) {
            $('#containsCharsId').attr('src', $scope.model.validTip);
            $('#minLenId').attr('src', $scope.model.validTip);
            $('#maxSameCharsId').attr('src', $scope.model.validTip);
            $('#notNameId').attr('src', $scope.model.validTip);
        }
    }
    function change2ResultEach($scope, id, result) {
        if (result) {
            $('#' + id).attr('src', $scope.model.validSuc);
        } else {
            $('#' + id).attr('src', $scope.model.validFail);
        }
    }

    function passwdAsynCheck($scope) {
        var dtd = $.Deferred();
        iamHttpService.post({
            url: '/authui/passwdAsynCheck',
            params: {
                domain: $scope.model.domain,
                username: $scope.model.name,
                pvvd: $scope.model.password,
                isCheckByName: 'true'
            }
        }).then(function (data) {
            if (data.result === true) {
                $scope.model.passwdErr = '';
                $scope.model.lastWeakPasswdLvl = '';
                dtd.resolve();
            } else {
                $scope.model.lastWeakPasswdLvl = 'low';
                if (data.error_code === '1000') {
                    $scope.model.passwdErr = i18n('invalidInput');
                } else if (data.error_code === '1001') {
                    $scope.model.passwdErr = i18n('pwdNotUsernameOrInvert');
                } else if (data.error_code === '1002') {
                    $scope.model.passwdErr = i18n('pwdNotContsMobileOrEmail');
                } else if (data.error_code === '1003') {
                    $scope.model.passwdErr = i18n('pwdWeak');
                    $scope.model.lowPasswords.push($scope.model.password);
                } else if (data === 'checkVerifyCode4Forbidden') {
                    $scope.model.passwdErr = i18n('freqLocked');
                } else {
                    $scope.model.passwdErr = i18n('systemException');
                }
                dtd.reject();
            }
        }, function () {
            $scope.model.passwdErr = i18n('systemException');
            dtd.reject();
        });
        $scope.model.passwdDtd = dtd.promise();
    }

    function password2error($scope) {
        var pwdObj = $('#' + $scope.model.passwordId); //兼容tiny1.48.1和之前的老版本
        if (pwdObj[0].tagName === 'INPUT') {
            pwdObj.addClass('tiny-input-text valid_error_input');
        } else {
            pwdObj.find('input').addClass('tiny-input-text valid_error_input');
        }
    }

    function setErrorMsg() {
        var url = '' + window.location;
        var errorMsgObj = {
            '401': i18n('selfManage.alertTip'),
            '403': i18n('resetPwd.resetFailed'),
            '402': i18n('pwdSame'),
            '406': i18n('invalidInput')
        };

        var paraStr = window.location.search;
        var paraArray = paraStr.split('&');
        for (var i = 0; i < paraArray.length; i++) {
            if (paraArray[i].indexOf('?actionErrors') === 0 || paraArray[i].indexOf('actionErrors') === 0) {
                $('#errorMsg').html(errorMsgObj[decodeURIComponent(paraArray[i].split('=')[1])]);
            }
        }
    }

    function post(URL, PARAMS) {
        var temp = document.createElement('form');
        temp.action = URL;
        temp.method = 'post';
        temp.style.display = 'none';
        for (var x in PARAMS) {
            var opt = document.createElement('textarea');
            opt.name = x;
            opt.value = PARAMS[x];
            temp.appendChild(opt);
        }
        document.body.appendChild(temp);
        temp.submit();
        return temp;
    }

    function getPasswordPolicy($scope, iamHttpService, securityPolicy) {
        var dtd = $.Deferred();
        iamHttpService.get({
            url: '/rest/authui/welcome/getPassvvdPolicy',
            mask: true
        }).then(function (data) {
            if (data.retinfo === 'success') {
                $scope.model.pwdMinLen = data.pwdMinLen;
                $scope.model.name = data.name;
                $scope.model.contSameCharLen = data.contSameCharLen;
                $scope.model.domain = data.domain;

                securityPolicy.passwordpolicy.password_minlen = data.pwdMinLen;
                securityPolicy.passwordpolicy.password_char_combination = data.password_char_combination;

                $scope.$apply();
                dtd.resolve();
            } else {
                iamUtils.redirect2Login();
                dtd.reject();
            }
            $('#' + $scope.model.passwordId).widget().option('focused', true);
        }, function (data) {
            iamUtils.redirect2Login();
            dtd.reject();
        });
        $scope.model.pwdMinLenDtd = dtd.promise();
    }

    ctrl = ['$scope', 'securityPolicy', ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.welcomeLogin.ctrl', ctrl);

    return ctrl;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(133)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Basestep) {
    Basestep.prototype.template = '<div id="{{ stepView.ID }}" wt ng-show="stepView.show" ng-repeat="stepView in viewModel">' + '<span id="{{stepView.numID}}" class="{{stepView.imgClzCur}}"></span>' + '<span id="{{stepView.titleID}}" class="{{stepView.titleClass}}" ng-bind="stepView.title"></span>' + '<span class="simple-next" ng-show="stepView.nextShow"><hr width="304" style=" display: inline-block;"></span>' + '</div>';

    return Basestep;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 隐藏遮罩 */\n#loading {\n\tdisplay: none\n}\n\n.casLoginMsgContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 992px;\n\tbackground: rgba(255,255,255,1);\n\tborder-radius: 2px;\n\tbox-shadow: 0 10px 20px 0 rgba(0,0,0,.1);\n\tmargin: 80px auto;\n\topacity: .8\n}\n\n.casLoginMsgContainer .errorIcon {\n\tbackground-image: url(" + escape(__webpack_require__(347)) + ");\n\tbackground-size: 24px 24px;\n\twidth: 24px;\n\theight: 24px;\n\tmargin-top: 40px\n}\n\n.casLoginMsgContainer .errorTitle {\n\tmargin-top: 16px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: #252b3a;\n\tline-height: 26px\n}\n\n.casLoginMsgContainer .errorContent {\n\tmargin-top: 12px;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: #252b3a;\n\tmargin-left: 60px;\n\tmargin-right: 60px;\n}\n\n.casLoginMsgContainer #loginBtn {\n\tmargin-top: 32px;\n\tmargin-bottom: 40px\n}\n\n.loginBtn {\n\tbackground-color: #C7000B;\n\tborder-radius: 2px;\n\tcolor: #fff;\n\tcursor: default;\n\twidth: 120px\n}\n\n.loginBtn:active,.loginBtn:focus,.loginBtn:hover {\n\tcursor: pointer;\n\tbox-shadow: 0 8px 16px rgba(246,111,106,.3);\n\toutline: 0\n}\n\n.loginBtn span {\n\tvertical-align: middle;\n\ttext-align: center;\n\tfont-size: 14px!important;\n\theight: 40px;\n\tmargin: 0 auto;\n\tdisplay: block;\n\tline-height: 40px\n}\n\na {\n\tcolor: #526ECC\n}\n\n@media(max-width:1220px) {\n\t#content,body,html {\n\t\tmin-width: 0\n\t}\n\n\t.casLoginMsgContainer {\n\t\twidth: 100%\n\t}\n}\n\n@media(max-width:500px) {\n\t#content,body,html {\n\t\theight: 100%;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tmin-width: 0\n\t}\n\n\t#content .widthLimit {\n\t\theight: 100%\n\t}\n\n\t.casLoginMsgContainer {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0\n\t}\n\n\t.casLoginMsgContainer .errorIcon {\n\t\tbackground-image: url(" + escape(__webpack_require__(316)) + ");\n\t\tbackground-size: 60px 60px;\n\t\twidth: 60px;\n\t\theight: 60px;\n\t}\n\n\t.loginBtn {\n\t\twidth: 90%\n\t}\n\n\t.casLoginMsgContainer .errorContent {\n\t\tmargin-top: 32px;\n\t\tmax-width: 90%;\n\t\ttext-align: left;\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t}\n\n\t.h5ErrorLinkDiv {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tposition: fixed;\n\t\tbottom: 32px\n\t}\n}", ""]);

// exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 隐藏遮罩 */\n#loading {\n    display: none;\n}", ""]);

// exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".fphoneDiv {\n    width: 1000px;\n    padding-left:40px;\n    padding-right:40px;\n    margin: 0 auto;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n#content {\n    position: relative;\n    margin: 0 0 -70px 0 !important;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 50px auto 10px;\n    padding-bottom: 30px;\n    width: 63%;\n    color: #9B9B9B;\n    position: relative;\n    font-size: 12px;\n}\n.formDiv > ul {\n    width: 85%;\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 170px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: lef;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 24px;\n    line-height: 30px;\n    color:#333;\n}\n\n#step {\n    /* height: 70px; */\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n    display: table;\n}\n\n#step .simple-next hr {\n    width: 10px !important;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n\tbackground-color: #e20074!important;\n}\n\n/* base fphone.css */\n.codeSelect{\n    display:inline-block;\n    vertical-align: middle;\n}\n\n.phoneInput{\n    display:inline-block;\n    margin:3px;\n}\n\n.btnDiv {\n    clear:both;\n    padding-top:30px;\n    margin: 0 auto;\n    display: table;\n}\n\n.field {\n    /* width: 650px !important; */\n}\n\n.formDiv {\n    /* margin-left: 180px; */\n    /* width: 83% !important; */\n}\n\n#step3 > ul{\n    text-align:center;\n    margin-top:3%;\n}\n\n.msgBtn {\n    height: 34px;\n    line-height: 34px;\n}\n\n.errorTipText {\n    margin: 0 auto;\n    color:red;\n}\n\n/*----sm-step begin----*/\n.step1_img{\n    background-image: url(" + escape(__webpack_require__(42)) + ");\n}\n.step2_img{\n    background-image: url(" + escape(__webpack_require__(43)) + ");\n}\n.step2_img_hl{\n    background-image: url(" + escape(__webpack_require__(44)) + ");\n}\n.step3_img{\n    background-image: url(" + escape(__webpack_require__(45)) + ");\n}\n.step3_img_hl{\n    background-image: url(" + escape(__webpack_require__(46)) + ");\n}\n\n\n/* main.css */\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    text-align: center;\n    color: #252b3a;\n    min-width: 70px;\n    border: 1px solid #adb0b8;\n    background: #fff;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    cursor: pointer;\n    border-color: #5e7ce0;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#step3 {\n    clear: both;\n}\n\n.success-title {\n    font-size: 18px;\n    line-height: 26px;\n}\n\n.success-title > img {\n    width: 40px;\n    height: 40px;\n}\n\n.number-info {\n    font-size: 12px;\n    color: #8A8E99;\n    line-height: 18px;\n    margin-bottom: 30px;\n}\n\n#redirect2Login {\n    margin-bottom: 10px;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n/* 适配移动端 */\n\n@media (max-width: 768px) {\n    body, html {\n        min-width: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #step {\n        /* display: none; */\n    }\n\n    #content {\n        min-width: 0;\n        min-height: 0;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    .pageTitle {\n        margin-bottom: 32px;\n        line-height: 1.5;\n    }\n\n    .fphoneDiv {\n        width: 100%;\n        box-sizing: border-box;\n        box-shadow: none;\n        background-color: transparent;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        font-size: 12px;\n    }\n\n    .formDiv {\n        margin-left: 0;\n        min-height: 0;\n        margin: 0;\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        min-width: 140px;\n        width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    .msgBtn {\n        height: 32px;\n        margin-left: 0px;\n        font-size: 12px;\n    }\n\n    .tiny-combobox-container {\n        height: 32px !important;\n    }\n\n    .tiny-combobox-editor {\n        height: 32px !important;\n    }\n\n    .tiny-textbox-container {\n        width: 100% !important;\n        /* max-width: 240px; */\n        flex-grow: 1;\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n        margin-right: 0;\n    }\n\n    #checkCodeId {\n        max-width: 100px !important;\n        margin-bottom: 8px;    \n    }\n\n    #inputVerifyCodeImg {\n        /* margin-top: 8px; */\n        /* margin-bottom: 8px; */\n        height: 30px;\n\n    }\n\n    #step2  .tiny-textbox-container {\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #step2 .field {\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > div:not(#emailMsgBtn){\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > span {\n        flex-grow: 1;\n        width: 100%;\n    }\n\n    #step2 .field > div > span {\n        width: 100%;\n    }\n\n    #step2 .filed span #emailVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #emailMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    .phoneInput {\n        width: auto !important;\n        min-width: 150px;\n        flex-grow: 1;\n        margin-left: 0px;\n    }\n\n    #phoneError {\n        display: block;\n    }\n\n    #step2 .filed span #smsVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #smsMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    #step3 ul {\n        margin-left: 0 !important;\n        text-align: center !important;\n    }\n\n    #step3 ul > li > div {\n        margin-right: 0 !important;\n    }\n\n    #step3 ul > li > div > span{\n        line-height: 32px;\n    }\n}\n\n/* 解决小屏幕下步骤栏换行的问题 */\n@media (max-width: 410px) {\n    .simple-next {\n        display: none;\n    }\n\n    #step > div {\n        float: none;\n        display: block;\n        height: 20px;\n        text-align: left;\n    }\n\n    #step {\n        margin-left: 40px;\n        margin-bottom: 40px;\n    }\n}", ""]);

// exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 新样式 */\n#loginVerificationDiv {\n    background-color: #FFFFFF;\n    max-width: 600px;\n    box-shadow: 1px 2px 8px #ccc;\n    border-radius: 2px;\n    margin: 0 auto;\n    margin-top: 60px;\n    margin-bottom: 120px;\n}\n#loginVerificationTitle {\n    width: 100%;\n    color: #333333;\n    font-size: 24px;\n    text-align: center;\n    letter-spacing: 0;\n    line-height: 34px;\n    margin: 30px 0px 20px 0px;\n    float: left;\n}\n\n#verificationContainer {\n    padding: 0px 30px 30px 30px;\n    float: left;\n}\n#verificationContainer div {\n    float: left;\n    text-align: left;\n}\n#verificationContainer .fieldItem {\n    width: 100%;\n    margin-bottom: 15px;\n}\n#verificationContainer .fieldItem:last-child {\n    margin-bottom: 0px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span {\n    display: block;\n    word-wrap: break-word;\n    max-height: 180px;\n    overflow-y: auto;\n}\n/* 滚动条样式 */\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar {\n    width: 4px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    background: rgba(0,0,0,0.2);\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    border-radius: 0;\n    background: rgba(0,0,0,0.1);\n}\n\n#verificationContainer .fieldItem.presetLoginInfo .presetTips {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-top: 5px;\n}\n#verificationContainer .fieldItem .itemLabel {\n    width: 160px;\n    font-size: 14px;\n    color: #999999;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent {\n    width: 380px;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent .tiny-input-text {\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n}\n#verificationContainer .fieldItem .itemContent .hintContext {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-left: 10px;\n}\n#verificationContainer .fieldItem .itemContent .bindTips {\n    display: block;\n    color: #F66F6A;\n    font-size: 12px;\n    margin-top: 5px;\n}\n/* 绑定虚拟MFA按钮 */\n#verificationContainer .fieldItem .itemContent .bindMFABtn {\n    cursor: pointer;\n    color: #526ECC;\n}\n#verificationContainer .fieldItem .itemContent .bindMFABtn:hover {\n    color: #006AD4;\n}\n\n/* 验证码输入框 */\n#verificationContainer .fieldItem .inputDiv {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n    height: 32px;\n}\n#verifyCodeId {\n    float: left;\n}\n#verificationContainer .fieldItem .inputDiv .tiny-input-text {\n    border: none;\n}\n#verificationContainer .fieldItem .inputDiv .seperate {\n    width: 1px;\n    height: 24px;\n    margin: 4px 0px;\n    background: #CCCCCC;\n}\n#verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    cursor: pointer;\n    color:  #526ECC;\n}\n#verificationContainer .fieldItem .inputDiv .retrieveTip {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    color: #999999;\n}\n#verificationContainer .fieldItem #sendCodeDoneTip {\n    font-size: 12px;\n    color: #999999;\n    margin: 5px 0px 0px 0px;\n}\n#verificationContainer .fieldItem #msgErrorTip {\n    width: 100%;\n    margin: 5px 0px 0px 0px;\n}\n/* 底部提示语 */\n#loginVerificationTips {\n    display: block;\n    float: left;\n    font-size: 12px;\n    color: #c3c3c3;\n    padding: 0 30px 20px;\n}\n/* END */\n\n\n/* 分割线 */\n#splitLine {\n    width: 100%;\n    height: 1px;\n    background-color: #E2E2E2;\n    border-radius: 1px;\n    float: left;\n    margin-bottom: 30px;\n}\n\n/* 底部按钮组 */\n#btnGroupDiv {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-bottom: 30px;\n    background-color: #FFFFFF;\n}\n#btnGroupDiv .btnDiv {\n    display: inline-block;\n    width: 263px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333333;\n    text-align: center;\n    border-radius: 2px;\n    cursor: pointer;\n}\n#btnGroupDiv #cancelBtn {\n    background: #FFFFFF;\n    border: 1px solid #adb0b8;\n    color: #252b3a;\n}\n\n#btnGroupDiv #cancelBtn:hover{\n    color: #526ecc;\n    border-color: #5e7ce0;\n}\n\n#btnGroupDiv #submitBtn {\n    margin-left: 10px;\n    background: #F66F6A;\n    border: 1px solid #F66F6A;\n    color: #FFFFFF;\n}\n\n#btnGroupDiv #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n#btnGroupDiv #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* 右侧绑定虚拟MFA弹窗框 */\n.bingMFAPage {\n    position: fixed;\n    top: 45px;\n    bottom: 70px;\n    left: 0;\n    right: 0;\n    background: rgb(0, 0, 0, 0.5);\n}\n.bingMFAPage .bindMFAModal {\n    width: 700px;\n    float: right;\n    background: #FFFFFF;\n    position: relative;\n    overflow-y: overlay;\n    overflow-x: hidden;\n    height: calc(100% - 60px);\n}\n.modalTitle {\n    width: 100%;\n    font-size: 24px;\n    line-height: 24px;\n    text-align: left;\n    margin: 30px 0px;\n    padding-left: 30px;\n    border-left: 3px solid #3399FF;\n}\n.modalContent {\n    float: left;\n    padding: 0px 0px 30px 20px;\n}\n.modalContent .stepDiv {\n    float: left;\n    width: 100%;\n}\n.modalContent .stepDiv#step1 {\n    height: 210px;\n}\n.modalContent .stepDiv#step2 {\n    height: 250px;\n}\n.modalContent .stepDiv .stepProgress {\n    width: 32px;\n    height: 100%;\n    float: left;\n    transform: translateY(6px);\n}\n.modalContent .stepDiv .stepProgress .stepImage {\n    width: 20px;\n    height: 20px;\n    line-height: 21px;\n    font-size: 14px;\n    color: #FFFFFF;\n    background: url(" + escape(__webpack_require__(49)) + ") no-repeat;\n    background-size: 100% 100%;\n}\n.modalContent .stepDiv .stepProgress .stepFill {\n    width: 2px;\n    height: 100%;\n    margin: -3px 14px 0px 14px;\n    background-color: #526ECC;\n}\n.modalContent .stepDiv .stepContent {\n    float: left;\n    width: 585px;\n    margin-left: 20px;\n}\n.modalContent .stepDiv .stepContent .title {\n    font-size: 16px;\n    padding: 5px 0px;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .tips {\n    font-size: 12px;\n    color: #8A8E99;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .appDownload {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .appDownload .HWCloud {\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    background: url(" + escape(__webpack_require__(48)) + ") center no-repeat;\n    background-size: cover;\n}\n.modalContent .stepDiv .stepContent .content {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n    float: left;\n    width: 120px;\n    height: 120px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n    float: left;\n    width: 450px;\n    font-size: 14px;\n    margin-left: 10px;\n    background: #F4F5F6;\n    padding: 5px 0px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem {\n    float: left;\n    padding: 5px 15px 5px 15px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoLabel {\n    float: left;\n    width: 90px;\n    text-align: left;\n    color: #999999;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n    float: left;\n    display: inline-block;\n    width: 330px;\n    text-align: left;\n    word-wrap: break-word;\n    word-break: break-all;\n    overflow: hidden;\n}\n.modalContent #msgMFAErrorTip {\n    padding-left: 172px;\n    text-align: left;\n    font-size: 12px;\n    color: #F66F6A;\n}\n.MFACodeDiv .codeFieldItem {\n    float: left;\n    padding: 10px 0px;\n    margin-right: 20px;\n}\n.MFACodeDiv .codeFieldItem .codeLabel {\n    float: left;\n    width: fit-content;\n    margin-right: 16px;\n    height: 32px;\n    line-height: 32px;\n    font-size: 14px;\n    color: #666666;\n}\n.MFACodeDiv .codeFieldItem .codeInput {\n    float: left;\n}\n.MFACodeDiv .codeFieldItem .codeInput .tiny-input-text {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n}\n\n/* 页面底部 */\n.modalFooter {\n    display: block;\n    position: fixed;\n    bottom: 80px;\n    width: 700px;\n    height: 60px;\n    float: left;\n    background-color: #f4f4f4;\n    border-top: 1px solid #eeeeee;\n}\n.modalFooter .btnDiv {\n    width: 100px;\n    padding: 5px 20px;\n    font-size: 14px;\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-top: 14px;\n    cursor: pointer;\n}\n.modalFooter #submitBtn {\n    border-color: #F66F6A;\n    background: #F66F6A;\n    color: #FFFFFF;\n}\n.modalFooter #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n.modalFooter #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.modalFooter #cancelBtn {\n    width: 80px;\n    margin-left: 10px;\n    color: #252b3a;\n    background: #fff;\n    border-color: #adb0b8;\n    cursor:pointer;\n}\n.modalFooter #cancelBtn:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n/* END */\n\n.commonTxt{\n    line-height: normal;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.titleText {\n    height:36px;\n    font-size: 24px;\n    color: #333;\n    text-align: left;\n}\n\n.hintTitle{\n    font-size:18px;\n    color:#333333;\n}\n\n.hintContextSMS{\n    font-weight:400;\n    font-size:14px;\n    color:#666666;\n}\n\n.presetInfo{\n    width: 650px;\n    word-wrap: break-word;\n    color: #999999;\n    text-align: left;\n    border:1px dashed #cccccc;\n    border-radius: 5px;\n    margin-top: 20px;\n    padding-top:10px;\n    padding-right:10px;\n    padding-left:10px;\n    padding-bottom:40px;\n    font-size: 12px;\n    background-color: #FFFFFF;\n}\n\n.loginInfo{\n    font-size: 14px;\n    color: #666666;\n    margin-top: 20px;\n    align:\"left\"\n}\n\n#getMsgCodeBtn{\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-left: 10px;\n    text-align: center;\n    height: 36px;\n    border-radius: 4px;\n    line-height: 36px;\n    vertical-align: middle;\n    color: #666;\n    padding-left:5px;\n    padding-right: 5px;\n}\n\n#getMsgCodeBtn:hover{\n    color: #009ae7;\n}\n\n.getMsgCodeBtn{\n    cursor: pointer;\n    background-color: #FFFFFF;\n}\n\n.disabledMsgBtn{\n    color: #666 !important;\n    background-color: #cccccc;\n    cursor: default;\n}\n\n.btnCommon{\n    width: 100px;\n    height: 35px;\n    text-align: center;\n    font-size: large;\n    line-height: 35px !important;\n    border-radius: 3px;\n    color: #333333;\n}\n\n\n\n#cancelBtnBtn{\n    background-color: #FFFFFF;\n    border: 1px solid #CCC;\n    cursor: pointer;\n}\n\n#cancelBtnBtn:hover{\n    /*background-color: #DDDDDD;*/\n    border-color: #60b0ff;\n    background-color: #FFFFFF;\n}\n\n.changePhonelink{\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 14px;\n    color: #526ECC;\n}\n\n#getMsgDiv{\n    margin-top:20px;\n    height:38px;\n    font-size: 14px;\n    margin-right: -200px;\n}\n\n.msgCodeHint{\n    display:inline-block;\n    min-width:107px;\n}\n\nbutton:focus{\n    outline:none;\n}\n\n/* 使步骤条与内容高度一致 */\n.stepDiv {\n    display: table;\n}\n\n.stepDiv > .stepProgress, .stepDiv > .stepContent {\n    display: table-cell;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.tiny-combobox-container {\n    height: 32px;\n    line-height: 30px;\n    border: 1px solid #d5d5d5;\n    border-radius: 2px;\n    background: #fff;\n    box-shadow: 1px 1px 1px #fff,inset 1px 1px 1px rgba(0,0,0,0.1);\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n@media only screen and (max-width: 1920px) {\n\n}\n@media only screen and (max-width: 1680px) {\n    \n}\n@media only screen and (max-width: 1440px) {\n    \n}\n@media only screen and (max-width: 1366px) {\n    \n}\n@media only screen and (max-width: 1280px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n@media only screen and (max-width: 1024px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    #btnGroupDiv {\n        background-color: transparent;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginVerificationDiv {\n        max-width: none;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 0px;\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 2px;\n        /* margin: 0 auto; */\n        margin-top: 0px;\n        margin-bottom: 20px;\n    }\n\n    #verificationContainer, #loginVerificationTips {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    #verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n        padding: 0 8px;\n    }\n\n    #verificationContainer .fieldItem {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        flex-wrap: nowrap;\n    }\n\n    #verificationContainer .fieldItem .itemContent {\n        width: auto;\n        font-size: 12px;\n    }\n\n    #verificationContainer .fieldItem .itemLabel {\n        min-width: 100px;\n        max-width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    #verificationContainer .fieldItem .itemContent .bindTips {\n        clear: both;\n    }\n\n    #verifyCodeId {\n        width: 100px !important;\n    }\n\n    #bindPhoneId {\n        width: 100% !important;\n    }\n\n    #bindEmailId {\n        width: 100% !important;\n    }\n\n    #btnGroupDiv {\n        flex-wrap: wrap;\n    }\n\n    #btnGroupDiv .btnDiv {\n        width: calc(50% - 16px);\n        padding-left: 8px;\n        padding-right: 8px;\n        margin: 8px;\n        min-width: 160px;\n        display: block;\n        box-sizing: border-box;\n        float: left;\n    }\n\n    #btnGroupDiv #submitBtn {\n        margin-left: 8px;\n    }\n\n    #countryCodeSelectId {\n        margin-bottom: 8px;\n    }\n\n    .modalTitle {\n        width: auto;\n    }\n\n    .bingMFAPage {\n        bottom: 0px;\n    }\n\n    .bingMFAPage .bindMFAModal {\n        width: 100%;\n    }\n\n    .modalFooter {\n        width: 100%;\n        bottom: 0px;\n    }\n\n    .modalContent .stepDiv .stepProgress {\n        /* display: none; */\n    }\n\n    .modalContent .stepDiv .stepContent {\n        float: left;\n        width: calc(100% - 32px);\n        margin-left: 0;\n    }\n\n    .modalContent {\n        padding-right: 20px;\n    }\n\n    .modalContent .stepDiv {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n        width: auto;\n        margin-left: 0px;\n        margin-top: 8px;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n        width: 100%;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeLabel {\n        text-align: left;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeInput {\n        text-align: left;\n    }\n\n    #verifyCodeId {\n        width: 88px !important;\n    }\n\n    .codeInput .tiny-textbox-container {\n        width: 120px !important;\n    }\n\n    .modalContent .stepDiv .stepContent .appDownload {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n        float: none;\n    }\n    \n    #verificationContainer .fieldItem .inputDiv .retrieveTip {\n        padding: 0px 5px;\n    }\n\n    .modalContent #msgMFAErrorTip {\n        padding-left: 0px;\n    }\n}\n\n\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    margin-top: 8px;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n    font-weight: normal;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -17px;\n    width: 12px;\n    height: 12px;\n    top: 3px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -13px;\n    top: 5px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n\n@media (max-width: 320px) {\n    #verifyCodeId {\n        width: 57px !important;\n    }\n}", ""]);

// exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滚动条轨道 内阴影+圆角*/\n::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滑块 内阴影+圆角*/\n::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #bfc3c6;\n}\n/*------  content begin ---------*/\n#loginAdv {\n    float: left;\n    max-width: 800px;\n    max-height: 515px;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n}\n\n#loginForm {\n    width: 380px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#loginForm > ul, #companyUser, #personalUser {\n    margin: auto auto 0px auto;\n    width: 320px;\n}\n\n/* 统一ID登录iframe */\n#uniIdIframeDiv {\n    width: 380px;\n    height: 500px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n/* END */\n\n/* 页面错误信息 */\n/* END */\n\n/* 主帐户 帐号/邮箱登录方式 */\n#loginForm .loginFormDiv {\n    padding: 0px 30px;\n    width: 320px;\n}\n/* END */\n\n/* 国家码选择框 */\n\n#loginForm .codeSelect {\n    display:inline-block;\n    vertical-align: middle;\n    float: left;\n}\n#loginForm .codeSelect .tiny-combobox-container {\n    border: none;\n    background-color: #FFFFFF;\n    box-shadow: none;\n}\n#loginForm .codeSelect .tiny-combobox-editor {\n    padding-left: 8px;\n    /*width: calc(100% - 10px);\n    width: -webkit-calc(100% - 10px);\n    width: -moz-calc(100% - 10px);*/\n}\n#loginForm .codeSelect .tiny-combobox-editor .tiny-combobox-input {\n    box-shadow: none;\n    border: none;\n    padding: 0px;\n    font-size: 12px;\n}\n#loginForm .codeSelect .tiny-combobox-popbutton:before {\n    right: 1px;\n    border-top: 5px solid #252B3A;\n}\n#loginForm .codeSelect .tiny-combobox-disable {\n    background-color: #FFFFFF;\n    border-color: none;\n    box-shadow: none;\n    border-right: none;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input {\n    /* font-family: PingFangSC-Regular; */\n    color: #696969;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input:disabled {\n    opacity: 1 !important;\n}\n/* END */\n\n/* 手机号输入框 */\n.phoneInput {\n    display:inline-block;\n    position: relative;\n}\n.phoneInput input.tiny-input-text.valid_error_input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n/* END */\n\n/*\n<!-- 帐号输入框 -->\n<!-- 密码输入框 -->\n<!-- 手机号登录方式 -->\n<!-- 国家码选择框 -->\n<!-- 手机号输入框 -->\n<!-- 手机绑定多帐号需选择 -->\n<!-- 密码输入框 -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 密码输入框 -->\n<!-- 主帐户 帐号/邮箱登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- <tiny-textbox id=\"model.userNameId\" validate=\"model.userValidator\" value=\"model.userName\"\n<!-- 主帐户 手机号登录方式 仅国内站-->\n<!-- 手机绑定多帐号需选择 -->\n<!-- end -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 国内IP placeholder不同-->\n<!-- 海外IP placeholder不同-->\n<!-- 密码输入框 非手机登录方式-->\n<!-- 密码输入框 手机登录方式-->\n<!-- 验证码输入框 -->\n<!-- 手机号登录方式切换按钮 -->\n<!-- 记住密码按钮 -->\n*/\n#companyUser, #personalUser {\n    color: #333333;\n    font-size: 28px;\n    margin-top: 35px !important;\n    margin-bottom: auto !important;\n}\n\n#companyUser > span, #personalUser > span {\n    line-height: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: top;\n}\n\n#companyUser > hr, #personalUser > hr {\n    display: inline-block;\n    margin: 5px 5px;\n    border: 0;\n    border-bottom: 1px solid #999999;\n}\n\n#companyUser > hr {\n    width: 28%;\n}\n\n#personalUser > hr {\n    width: 56%;\n}\n\n.errorTip {\n    display:block;\n    position: relative;\n    min-height: 32px;\n    font-size: 12px;\n    padding: 0px 8px;\n}\n.errorTip span {\n    color: #F66F6A;\n}\n\n#checkError, #serverError, #mobileErrorMsg, #mobileUsersSelectMsg, #isMobileTip {\n    color: #FF0000;\n    /*display: none;*/\n    clear: both;\n    /*margin: 10px 0 0 0;*/\n}\n\n/* 手机多用户时选择用户的下拉框 */\n.mobileUsersSelect {\n    margin-bottom: 15px;\n}\n.mobileUsersSelect .tiny-select {\n    width: 100%;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field {\n    height: 36px;\n    border: none;\n    padding-right: 0;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field input {\n    width: 100% !important;\n    border-right: none;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-input-field-selected-down:before, .tiny-select-input-field-selected-up:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-popup-container {\n    border: 1px solid #ADB0B8;\n    box-shadow: 0 2px 5px 0;\n}\n.tiny-select-option {\n    color: #252B3A;\n}\n.tiny-select-option-selected {\n    color: #F66F6A;\n    background: #FFEEED;\n}\n.tiny-select-option-default-selected {\n    background-color: #F66F6A;\n    color: #FFFFFF;\n}\n/* END */\n\n/* 验证码图片样式 */\n#inputVerifyCodeImg {\n    width: 100px;\n    height: 30px;\n    float: right;\n    cursor: pointer;\n}\n/* END */\n\n.inputField {\n    margin-bottom: 16px !important;\n    font-size: 14px !important;\n    border-bottom: 1px solid #DFE1E6;\n    position: relative;\n}\n.inputField:hover {\n    border-bottom: 1px solid #8A8E99;\n}\n.inputField:last-child {\n    margin-bottom: 0px !important;\n    font-size: 14px !important;\n}\n#loginForm .inputField input {\n    line-height: 20px;\n    border-radius: 0px;\n    /* font-family: \"PingFangSC-Regular\"; */\n    padding: 0px 8px;\n    box-shadow: none;\n}\n\n#loginForm > div:last-child {\n    /*position: absolute !important;*/\n    bottom: 0px;\n    width: 100%;\n}\n\n#buttonArea {\n    margin: 48px 38px 30px 38px;\n    width: 304px;\n}\n\n#smsPhone {\n    margin: 5px;\n    font-size: 13px !important;\n}\n\n#fpLink {\n    color: #00aaff;\n    float:right;\n}\n\n/* 手机号登录切换 以及 记住登录名 */\n.toDoDiv {\n    margin: 18px 38px 0;\n    width: 304px;\n}\n/* END */\n\n/* 手机号登录切换 */\n.typeSwitchDiv {\n    display: inline-block;\n    font-size: 12px;\n    font-style: normal;\n    color: #252B3A;\n    max-width: 180px;\n}\n#typeSwitchBtn {\n    cursor: pointer;\n}\n#typeSwitchBtn:hover {\n    color: #F66F6A;\n    text-decoration: underline;\n}\n/* END */\n\n/* 记住登录名 */\n.toDoDiv #checkArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -20px;\n    top: 0px;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -16px;\n    top: 2px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n/* END */\n\n.buttonAreaDiv {\n    width: 100%;\n    float: left;\n}\n\n.loginBtn {\n    background-color: #F66F6A;\n    border-radius: 2px;\n    color: #ffffff;\n    cursor: default;\n    width: 100%;\n}\n.loginBtn:hover,\n.loginBtn:active,\n.loginBtn:focus {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,0.3);\n    outline: none;\n}\n\n.loginBtn span, .loginBtnDisabled span {\n    vertical-align: middle;\n    text-align: center;\n    font-size: 14px !important;\n    display: table-cell;\n    height: 36px;\n    margin: 0 auto;\n    display: block;\n    line-height: 36px;\n}\n\n.loginBtnDisabled {\n    background-color: #CCCCCC;\n    border: 1px solid #CCCCCC;\n    border-radius: 3px 3px 3px 3px;\n    color: #ffffff;\n    font-size: 18px !important;\n    cursor: default;\n    width: 100%;\n}\n\n#bottomBtns {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: 10px;\n}\n\n/* 免费注册 & 忘记密码 & 用户切换 */\n.commonLinkDiv {\n    flex-basis: 50%;\n    margin-bottom: 10px;\n    text-align: center;\n}\n.splitLine {\n    display: none;\n    float: left;\n    width: 1px;\n    margin: 0px 2px;\n    height: 12px;\n    background: #DFE1E6;\n}\n/* END */\n\n#goLogin {\n    color:#5099F8;\n    cursor: pointer;\n    font-size:small;\n}\n#goLogin:hover{\n    text-decoration: underline;\n}\n/*-------- content end ---------*/\n\n/*------ page layout begin ------*/\n#content .widthLimit {\n    position: relative;\n    margin: 0px auto;\n    padding: 0px 20px;\n}\n\n#content .widthLimit{\n    max-width: 1200px;\n}\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 45px;\n}\n\nbody, html {\n    height:100%;\n    margin: 0;\n    padding: 0;\n    min-width: 1260px;\n}\n\n*{\n    margin: 0;\n    padding: 0;\n}\n.placeholder {\n    color: #aaa!important;\n    font-family: \"Microsoft Yahei\"!important;\n}\n\n.linkSeperator {\n    height:100%;\n    border-left: 1px #0678FF solid;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.expand {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-top: 10px solid #0678FF;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.collapse {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-bottom: 10px solid #0678FF;;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\n\n.requiredImage {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n#enterpriseSwitchTip {\n    background-color: #ffffff;\n    border: 1px solid #cccccc;\n    color: #666666;\n    width: 300px;\n    height: auto;\n    position: absolute;\n    float: right;\n    border-radius: 2px;\n    top: 50px;\n    z-index: 10;\n    padding:6px;\n    background-color: #f5f5f5;\n    font-size: 12px;\n}\n\n.loginTypeDiv {\n    color:#666666;\n    font-size:14px;\n    font-style: normal;\n    padding: 24px 30px 10px 30px;\n    text-align: center;\n}\n\n.loginTypeNoSelected {\n    box-sizing: border-box;\n    display: inline-block;\n    width:100%;\n    line-height: 18px;\n    font-size: 18px;\n    /* font-family: \"PingFangSC-Medium\"; */\n    text-align: center;\n    color: #252B3A;\n}\n\n.loginTypeSelected {\n    box-sizing: border-box;\n    border-color: #E41E2B;\n    border-style:solid;\n    border-top:0;\n    border-left:0;\n    border-right:0;\n    border-width: 3px;\n    display: inline-block;\n    width:47%;\n    text-align: center;\n    height: 44px;\n    line-height: 44px;\n    color:#E41E2B;\n    cursor: pointer\n}\n.loginBottomColor {\n    font-size: 12px;\n    color: #252B3A;\n    line-height: 16px;\n}\n.loginBottomColor:hover,\n.loginBottomColor:active,\n.loginBottomColor:focus {\n    color: #F66F6A;\n}\n.otherLoginColor{\n    font-size: 12px;\n    color: #666A75;\n    line-height: 16px;\n}\n.otherLoginColor:hover,\n.otherLoginColor:active,\n.otherLoginColor:focus {\n    color: #666A75;\n}\n\n/* 三方登录展示列表 */\n#otherLoginWays {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n#otherLoginWays .otherItemDiv {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: center;\n    margin-right: auto;\n    flex-grow: 1;\n}\n#otherLoginWays .otherItemDiv .textIcon {\n    height: 13px;\n    padding-top: 1px;\n}\n#otherLoginWays .otherItemDiv#vmallLinkDiv {\n    margin-left: auto;\n    margin-right: unset;\n}\n/* END */\n\n.tiny-input-text {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #333;\n    font-size: 14px;\n    font-face:NotoSansCJKsc-Regular\n}\n.tiny-input-text:focus {\n    border: none;\n}\n.tiny-input-text.valid_error_input:focus {\n    border: none;\n}\n\n:-ms-input-placeholder {\n    color: #999 !important;\n}\n\n#otherAccounts{\n    position: relative;\n    text-align: center;\n    margin-bottom: 5px;\n    line-height: 1;\n    cursor: pointer;\n}\n#otherAccounts:before{\n    content: '';\n    position: absolute;\n    top: 50%;\n    display: block;\n    width: 100%;\n    border-top: 1px solid #DDD;\n}\n\n#otherAccounts .downArrow {\n    margin-left: -7px;\n    padding-right: 7px;\n    display: inline-block;\n    position: relative;\n    z-index: 2;\n    background-color: #ffffff;\n}\n#otherAccounts .downArrow img {\n    width: 8px;\n    height: 8px;\n}\n#otherAccounts .downArrow img.otherAccountsOpen {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n#otherAccounts .downArrow img.otherAccountsClose {\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n#otherAccounts .otherLoginColor{\n    padding: 0 7px;\n    position: relative;\n    z-index: 2;\n    background-color: #fff;\n}\n\ninput[type=\"password\"] {\n    color: #333;\n}\n\n.homepageLink {\n    color: #A0A2A8;\n}\n\n.index-uniportal {\n    position: relative;\n}\n\n.index-uniportal>a {\n    cursor: pointer;\n}\n.index-uniportal:hover >.uniportalTip {\n    display: block;\n}\n\n.index-uniportal>.uniportalTip {\n    top: 17px;\n    display: none;\n    position: absolute;\n    bottom: 13px;\n}\n\n.index-uniportal>.uniportalTip>span {\n    padding: 2px;\n    box-shadow: 1px 1px 10px #ccc;\n    border: 1px solid #ccc;\n    display: block;\n    background: #fff;\n    margin-left: 90px;\n    width: 183px;\n    font-size: 10px;\n}\n.otherLogin{\n    position:relative;\n    margin-left: 120px;\n}\n.otherLogin:before{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: -120px;\n    content: \"\";\n}\n.otherLogin:after{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: 100px;\n    content: \"\";\n}\n.registUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 70px;\n    font-size: 13px;\n}\n.forgetPWDUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 0px;\n    font-size: 13px;\n}\n.shuXianSpan {\n    color: #666;\n    float: right;\n    margin-top: -21px;\n    margin-right: 63px;\n}\n\n.helpQuestionmark {\n    background-image: url(" + escape(__webpack_require__(47)) + ");\n    float: right;\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n}\n\n.loginswap {\n    line-height: 18px;\n}\n\n.loginswap:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.helptipfather {\n    display: inline-block; position:relative;\n}\n.userTypeLink:hover .helptipchild {\n    display:block;\n    width:220px;\n    padding:8px 3px 3px 6px;\n}\n.helptipfather span {\n    display:none;\n    color:#666666;\n    font-size:12px;\n    line-height:20px;\n    /* font-family:PingFangSC-Regular; */\n    background:#FFFFFF;\n    border-radius:0 0 0 2px 2px 2px 2px;\n    border:1px solid #EEEEEE;\n    box-shadow:0 2px 5px 0 rgba(0,0,0,0.15);\n    -moz-border-radius:1px;\n    -webkit-border-radius:1px;\n    text-align:left;\n    position: absolute;\n    left: -150px;\n    top: 10px;\n    z-index:10;\n    overflow: visible;\n}\n#loginAdv .login-logo-pad{\n    display: none;\n}\n.pwdShowimg {\n    top: 10px;\n    right: 8px;\n    position: absolute;\n    width: 15px;\n    height: 15px;\n}\n\n#personalPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n\n#mobilePasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n} \n\n#IAMPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n/*------ pad css start------*/\n@media (max-width: 1269px) {\n    .widthLimit{\n        box-sizing: border-box;\n        padding: 0;\n    }\n    html,body,#content{\n        max-width: 1270px;\n        min-width: 768px;\n    }\n    #content{\n        height: calc(100% - 90px);\n    }\n    #content .widthLimit{\n        max-width: 768px;\n    }\n    #loginAdv{\n        margin-top: 40px;\n        max-width: 352px;\n    }\n    #content .widthLimit{\n        padding: 0 15px;\n    }\n\n    #loginForm{\n        margin-top: 70px;\n    }\n    #loginAdv .login-logo-pad{\n        display: block;\n    }\n    #loginAdv .login-logo-pc{\n        display: none;\n    }\n}\n/*------ pad css end ------*/\n/*------ page layout end ------*/\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    #content {\n        height: 100%;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        padding: 0 30px;\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginAdv {\n        display: none;\n    }\n\n    body, html, #content {\n        height:100%;\n        margin: 0;\n        padding: 0;\n        min-width: 0px;\n    }\n\n    #loginForm {\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        /* padding: 0 30px; */\n    }\n\n    #uniIdIframeDiv {\n        width: 100%;\n        height: 100%;\n        margin-top: 0px;\n    }\n    #uniIdIframe {\n        width: 100%;\n        box-shadow: none;\n        background: none;\n    }\n\n    #loginForm .loginFormDiv {\n        width: 100% !important;\n        padding: 0;\n        margin: 0;\n    }\n\n    #loginForm .tiny-textbox-container {\n        width: 100% !important;\n    }\n\n    #verifyCode .tiny-textbox-container {\n        width: calc(100% - 138px) !important;\n    }\n\n    #inputVerifyCodeImg {\n        transform: translateY(4px);\n    }\n\n    .toDoDiv {\n        margin-left: 0px;\n        margin-right: 0px;\n        width: 100%;\n    }\n\n    #loginForm .mobileLoginDiv .phoneInput {\n        width: calc(100% - 115px);\n    }\n\n    #buttonArea {\n        margin: 38px auto;\n        width: 100%;\n    }\n\n    #otherAccounts .otherLoginColor {\n        background-color: #0000;\n    }\n\n    #otherAccounts .downArrow {\n        background-color: #0000;\n    }\n    \n    .userTypeLink:hover .helptipchild {\n        display: none;\n    }\n\n    #otherLoginWays .otherItemDiv {\n        margin-right: 0;\n    }\n\n    #otherLoginWays .otherItemDiv#vmallLinkDiv {\n        margin-left: 0;\n    }\n}\n\n/* 扫码登录 */\n#loginForm{\n    position: relative;\n}\n#QRLoginDiv {\n    position: relative;\n    background-color: #fff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228,228,228,1);\n    border-radius: 0;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,.1);\n    display: flex;\n    width: 380px;\n    height: 407px;\n    float: right;\n    margin-top: 80px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loginQRCodeDiv{\n    width: 159px;\n    padding: 10px;\n}\n\n.QRCodeOuter{\n    position:relative;\n    height: 179px;\n    width: 180px;\n    margin: 0 auto;\n    text-align: center;\n    border: 0px solid #DFE1E6;\n    background: url(" + escape(__webpack_require__(32)) + ");\n    background-size: cover;\n}\n.QRCodeInner{\n    position:absolute;\n    top: 0px;\n    left: 0px;\n    color: #FFFFFF;\n    height: 179px;\n    width: 180px;\n    background:rgba(7, 7, 7, 0.6);\n}\n\n\n.loginTypeSwitchImg{\n    margin-top: 8px;\n    margin-right: 8px;\n    width: 50px;\n    height: 50px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n}\n\n.loginTypeSwitchImg:hover{\n    cursor: pointer;\n}\n\n.ti-tooltip {\n    position: absolute;\n    top: 9px;\n    right: 58px;\n    background-color: #333854;\n    color: #dfe1e6;\n    padding: 11px 15px;\n    border: 1px solid #333854;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n    border-radius: 4px;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    box-sizing: border-box;\n    z-index: 5000;\n    white-space: normal;\n    word-wrap: break-word\n}\n\n.ti-tooltip-left:after {\n    height: 20px;\n    margin-top: -10px;\n    right: 0\n}\n\n.ti-tooltip-left:after,.ti-tooltip-left:before {\n    display: block;\n    position: absolute;\n    content: \"\";\n    overflow: hidden;\n    background: #333854;\n    width: 10px;\n    top: 50%\n}\n\n.ti-tooltip-left:before {\n    height: 10px;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    border-right: 1px solid #333854;\n    border-top: 1px solid #333854;\n    margin-top: -5px;\n    right: -5px;\n    box-shadow: 0 -2px 4px rgba(0,0,0,.2)\n}\n\n#countDownDiv {\n    text-align: center;\n    color: #252B3A;\n    font-size: 12px;\n    margin-top: 10px;\n    height: 20px;\n}\n\n.remainingTimeTxt{\n    color: #F66F6A;\n}\n\n#QRLoginBottomDiv {\n    width: calc(100% - 50px);\n    border-top: 1px solid #575D6C;\n    margin-left: 40px;\n    margin-right: 40px;\n    height: 60px;\n    line-height: 50px;\n    display: inline-flex;\n    justify-content: space-between;\n    font-size: 12px;\n}\n\n.QRLoginBottomColor {\n    font-size: 12px;\n    color: #575D6C;\n}\n.QRLoginBottomColor:hover,\n.QRLoginBottomColor:active,\n.QRLoginBottomColor:focus {\n    color: #F66F6A;\n}\n\n.QRCodeInvalid{\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 60px;\n}\n\n#refreshQRCodeBtn {\n    width: 80px;\n    margin: 0 auto;\n}\n\n.loginStatusDiv{\n    text-align: center;\n}\n\n.loginStatusImg{\n    height: 64px;\n    width: 64px;\n    margin-bottom: 16px;\n}\n\n.loginStatusTitle{\n    color: #252B3A;\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.loginStatusMessage{\n    color: #252B3A;\n    font-size: 12px;\n}\n\n@media (max-width: 1269px) {\n    #QRLoginDiv{\n        margin-top: 70px;\n    }\n    .loginTypeSwitchImgCover{\n        border-bottom: 50px solid linear-gradient(90deg,#F4F5FF 0,#E8EBFD 48%,#F4F5FF 100%) ;\n    }\n}\n\n@media (max-width: 768px) {\n    #QRLoginDiv{\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        display: none;\n    }\n\n    .loginTypeSwitchImg {\n        display: none;\n    }\n\n    #QRLoginTip {\n        display: none;\n    }\n\n}\n\n/**企业联邦登录**/\n#idpLoginForm{\n    width: 380px;\n    display: inline-block;\n    float:right;\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#idpLoginForm .loginFormDiv{\n    margin: 0 38px;\n}\n\n#idpLoginForm #otherLoginWays{\n    display: flex;\n    justify-content: space-around;\n}\n\n#idpLoginForm #otherLoginWays .otherItemDiv{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#idpLoginForm #loginBtn{\n    margin-bottom: 50px;\n}\n\n#idpLoginForm .tiny-select-text{\n    box-shadow: 0 0 0 0;\n}\n\n#idpLoginForm #idpCheckArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n\n@media (max-width: 768px){\n    #idpLoginForm{\n        width: 100%;\n        box-shadow: none;\n        background: 0 0;\n        margin-top: 20px;\n    }\n    #idpLoginForm .loginFormDiv{\n        margin: 0;\n    }\n\n    #idpLoginForm .loginFormDiv .tiny-textbox-container{\n        width: 100% !important;\n    }\n    #idpLoginForm .loginFormDiv .tiny-select-input-field{\n        width: 100% !important; \n    }\n}\n", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content .widthLimit {\n    max-width: 800px;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin: 0 auto;\n}\n\n#verifyTypeBtn {\n    color: #0088CC;\n    display: inline-block;\n    float: right;\n    margin-right: 7px;\n    height: 36px;\n    line-height: 36px;\n}\n\n#verifyTypeBtn:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n#resetTitle {\n    margin: 20px 0px;\n}\n\n#resetTitle > p {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 10px;\n}\n\n#resetTitle > span {\n    font-size: 14px;\n}\n\n.tip_no_border {\n    border-right:none !important;\n    border:none !important;\n    background-color:#F4F4F4 !important;\n    box-shadow:none !important;\n}\n#verifyCodeMsg {\n    margin-left: 340px;\n}\n#btnDiv {\n    clear:both;\n    padding-top:10px;\n    margin-left: 340px;\n    max-width: 240px;\n}\n\n#errorMsg {\n    margin-bottom: 5px;\n    display: block;\n    color: red;\n}\n\n.pwdStrengthContainer {\n    display:inline-block;\n    float: right;\n    margin-right:10px;\n    margin-top:10px;\n    clear: both;\n    font-size: 12px;\n    line-height: 13px;\n}\n#TIP span {\n    display: none;\n}\n#TIP.high .high{\n    display: inline-block;\n    color: #333;\n}\n#TIP.low .low{\n    display: inline-block;\n    color: #333;\n}\n#TIP.mid .mid{\n    display: inline-block;\n    color: #333;\n}\n\n.tootip-img {\n    width:16px;\n    height:16px;\n    margin:0 auto 3px 0;\n}\n\n.tootip-div{\n    margin: -21px 0 10px 20px;\n}\n\n.errorInfo {\n        width: 390px;\n        margin-left: 334px;\n}\n\n.errorInfo>span {\n    margin-left: 6px;\n    display: inline-block;\n    width: 315px;\n    color: #e41e2b;\n}\n\n#content {\n    position: relative;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 15px auto 10px;\n    padding: 30px 30px 30px 30px;\n    width: 800px;\n    color: #9B9B9B;\n    position: relative;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    border-radius: 2px;\n}\n.formDiv > ul {\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 320px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: right;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n    position: relative;\n}\n\n.pwd-state-icon {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 28px;\n    color:#333;\n}\n\n#step {\n    height: 70px;\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n    background-color: #e20074!important;\n}\n\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    color: #252b3a;\n    text-align: center;\n    min-width: 70px;\n    background-color: #FFFFFF;\n    border: 1px solid #adb0b8;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#formUl > li {\n    display: flow-root;\n}\n\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n        width: 100%;\n    }\n\n    #content .widthLimit {\n        padding: 0;\n        margin: 0px;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        /* background-image: none !important; */\n    }\n\n    #resetTitle {\n        margin-left: 20px;\n    }\n\n    .formDiv {\n        height: auto;\n        margin: 0;\n        width: 100%;\n        color: #9B9B9B;\n        position: relative;\n        box-sizing: border-box;\n        box-shadow: none;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        background-color: transparent;\n    }\n\n    .formDiv > ul {\n        width: 100%;\n        min-width: 0;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n    }\n\n    .field {\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container {\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container:not(#msgCodeId){\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        width: 120px;\n        font-size: 12px;\n        margin-right: 8px;\n        line-height: 18px;\n        height: fit-content;\n    }\n\n    #verifyCodeMsg {\n        margin-left: 0px;\n    }\n    #btnDiv {\n        max-width: none;\n        margin-left: 0px;\n        display: flex;\n        justify-content: center;\n        flex-flow: row;\n        flex-wrap: wrap;\n    }\n\n    #msgCodeId {\n        width: 60px !important;\n        height: 32px !important;\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #msgBtn {\n        font-size: 12px;\n        padding-left: 8px;\n        padding-right: 8px;\n        width: fit-content;\n    }\n\n    .tiny-tip-content-top {\n        /* font-size: 12px !important; */\n        left: 10% !important;\n        right: 10% !important;\n        line-height: 1;\n    }\n\n    .passwordStrength {\n        width: 24px;\n        transform: translateY(-7px) !important;\n    }\n\n    .tootip-img {\n        margin-bottom: 5px;\n    }\n\n    .errorInfo > span {\n        width: auto;\n    }\n\n    .errorInfo {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n@media (max-width: 360px) {\n    .fieldLabel {\n        width: 100px;\n    }\n}\n\n@media (max-width: 320px) {\n    .fieldLabel {\n        width: 95px;\n    }\n}", ""]);

// exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content {\n    background: unset !important;\n}\n\n#content .widthLimit {\n    padding: 0px 0px;\n    min-width: 1200px;\n}\n\n.error {\n    padding-top: 100px;\n    text-align: center;\n}\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.error_msg {\n    font-size: 20px;\n    color: #333333;\n    margin-top: 20px;\n    line-height: 1.5;\n}\n\n/* 适配移动端 */\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        min-width: 0px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}", ""]);

// exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".fphoneDiv {\n    width: 1000px;\n    padding-left:40px;\n    padding-right:40px;\n    margin: 0 auto;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n#content {\n    position: relative;\n    margin: 0 0 -70px 0 !important;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 50px auto 10px;\n    padding-bottom: 30px;\n    width: 700px;\n    color: #9B9B9B;\n    position: relative;\n    font-size: 12px;\n}\n.formDiv > ul {\n    width: 85%;\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 230px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: lef;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 24px;\n    line-height: 30px;\n    color:#333;\n}\n\n#step {\n    /* height: 70px; */\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n    display: table;\n}\n\n#step .simple-next hr {\n    width: 10px !important;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n\tbackground-color: #e20074!important;\n}\n\n/* base fphone.css */\n.codeSelect{\n    display:inline-block;\n    vertical-align: middle;\n}\n\n.phoneInput{\n    display:inline-block;\n    margin:3px;\n}\n\n.btnDiv {\n    clear:both;\n    padding-top:30px;\n    margin: 0 auto;\n    display: table;\n}\n\n.field {\n    /* width: 650px !important; */\n}\n\n.formDiv {\n    /* margin-left: 180px; */\n    /* width: 83% !important; */\n}\n\n#step3 > ul{\n    text-align:center;\n    margin-top:3%;\n}\n\n.msgBtn {\n    height: 34px;\n    line-height: 34px;\n}\n\n.errorTipText {\n    margin: 0 auto;\n    color:red;\n}\n\n/*----sm-step begin----*/\n.step1_img{\n    background-image: url(" + escape(__webpack_require__(42)) + ");\n}\n.step2_img{\n    background-image: url(" + escape(__webpack_require__(43)) + ");\n}\n.step2_img_hl{\n    background-image: url(" + escape(__webpack_require__(44)) + ");\n}\n.step3_img{\n    background-image: url(" + escape(__webpack_require__(45)) + ");\n}\n.step3_img_hl{\n    background-image: url(" + escape(__webpack_require__(46)) + ");\n}\n\n\n/* main.css */\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    text-align: center;\n    color: #252b3a;\n    min-width: 70px;\n    border: 1px solid #adb0b8;\n    background: #fff;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    cursor: pointer;\n    border-color: #5e7ce0;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#step3 {\n    clear: both;\n}\n\n.success-title {\n    font-size: 18px;\n    line-height: 26px;\n}\n\n.success-title > img {\n    width: 40px;\n    height: 40px;\n}\n\n.number-info {\n    font-size: 12px;\n    color: #8A8E99;\n    line-height: 18px;\n    margin-bottom: 30px;\n}\n\n#redirect2Login {\n    margin-bottom: 10px;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\n#emailMsgBtn, #newPhoneNumId, #smsMsgBtn {\n    width: 260px !important;\n}\n\n/* 适配移动端 */\n\n@media (max-width: 768px) {\n    body, html {\n        min-width: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #step {\n        /* display: none; */\n    }\n\n    #content {\n        min-width: 0;\n        min-height: 0;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    .pageTitle {\n        margin-bottom: 32px;\n        line-height: 1.5;\n    }\n\n    .fphoneDiv {\n        width: 100%;\n        box-sizing: border-box;\n        box-shadow: none;\n        background-color: transparent;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        font-size: 12px;\n    }\n\n    .formDiv {\n        margin-left: 0;\n        min-height: 0;\n        margin: 0;\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        min-width: 190px;\n        width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    .msgBtn {\n        height: 32px;\n        margin-left: 0px;\n        font-size: 12px;\n    }\n\n    .tiny-combobox-container {\n        height: 32px !important;\n    }\n\n    .tiny-combobox-editor {\n        height: 32px !important;\n    }\n\n    .tiny-textbox-container {\n        width: 100% !important;\n        /* max-width: 240px; */\n        flex-grow: 1;\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n        margin-right: 0;\n        min-width: 200px;\n    }\n\n    #checkCodeId {\n        max-width: 120px !important;\n    }\n\n    #inputVerifyCodeImg {\n        /* margin-top: 8px; */\n        margin-bottom: 8px;\n        height: 30px;\n\n    }\n\n    #step2  .tiny-textbox-container {\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #step2 .field {\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > div:not(#emailMsgBtn){\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > span {\n        flex-grow: 1;\n        width: 100%;\n    }\n\n    #step2 .field > div > span {\n        width: 100%;\n    }\n\n    #step2 .filed span #emailVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #emailMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    .phoneInput {\n        width: auto !important;\n        min-width: 150px;\n        flex-grow: 1;\n        margin-left: 0px;\n    }\n\n    #phoneError {\n        display: block;\n    }\n\n    #step2 .filed span #smsVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #smsMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    #emailMsgBtn, #newPhoneNumId, #smsMsgBtn {\n        width: 100% !important;\n    }\n\n    #step3 ul {\n        margin-left: 0 !important;\n        text-align: center !important;\n    }\n\n    #step3 ul > li > div {\n        margin-right: 0 !important;\n    }\n\n    #step3 ul > li > div > span{\n        line-height: 32px;\n    }\n}\n\n/* 解决小屏幕下步骤栏换行的问题 */\n@media (max-width: 768px) {\n    .simple-next {\n        display: none;\n    }\n\n    #step > div {\n        float: none;\n        display: block;\n        height: 20px;\n        text-align: left;\n    }\n\n    #step {\n        margin-left: 40px;\n        margin-bottom: 40px;\n    }\n}", ""]);

// exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 新样式 */\n#loginVerificationDiv {\n    background-color: #FFFFFF;\n    max-width: 600px;\n    box-shadow: 1px 2px 8px #ccc;\n    border-radius: 2px;\n    margin: 0 auto;\n    margin-top: 60px;\n    margin-bottom: 120px;\n}\n#loginVerificationTitle {\n    width: 100%;\n    color: #333333;\n    font-size: 24px;\n    text-align: center;\n    letter-spacing: 0;\n    line-height: 34px;\n    margin: 30px 0px 20px 0px;\n    float: left;\n}\n\n#verificationContainer {\n    padding: 0px 30px 30px 30px;\n    float: left;\n}\n#verificationContainer div {\n    float: left;\n    text-align: left;\n}\n#verificationContainer .fieldItem {\n    width: 100%;\n    margin-bottom: 15px;\n}\n#verificationContainer .fieldItem:last-child {\n    margin-bottom: 0px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span {\n    display: block;\n    word-wrap: break-word;\n    max-height: 180px;\n    overflow-y: auto;\n}\n/* 滚动条样式 */\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar {\n    width: 4px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    background: rgba(0,0,0,0.2);\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    border-radius: 0;\n    background: rgba(0,0,0,0.1);\n}\n\n#verificationContainer .fieldItem.presetLoginInfo .presetTips {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-top: 5px;\n}\n#verificationContainer .fieldItem .itemLabel {\n    width: 160px;\n    font-size: 14px;\n    color: #999999;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent {\n    width: 380px;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent .tiny-input-text {\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n}\n#verificationContainer .fieldItem .itemContent .hintContext {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-left: 10px;\n}\n#verificationContainer .fieldItem .itemContent .bindTips {\n    display: block;\n    color: #F66F6A;\n    font-size: 12px;\n    margin-top: 5px;\n}\n/* 绑定虚拟MFA按钮 */\n#verificationContainer .fieldItem .itemContent .bindMFABtn {\n    cursor: pointer;\n    color: #526ECC;\n}\n#verificationContainer .fieldItem .itemContent .bindMFABtn:hover {\n    color: #006AD4;\n}\n\n/* 验证码输入框 */\n#verificationContainer .fieldItem .inputDiv {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n    height: 32px;\n}\n#verifyCodeId {\n    float: left;\n}\n#verificationContainer .fieldItem .inputDiv .tiny-input-text {\n    border: none;\n}\n#verificationContainer .fieldItem .inputDiv .seperate {\n    width: 1px;\n    height: 24px;\n    margin: 4px 0px;\n    background: #CCCCCC;\n}\n#verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    cursor: pointer;\n    color:  #526ECC;\n}\n#verificationContainer .fieldItem .inputDiv .retrieveTip {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    color: #999999;\n}\n#verificationContainer .fieldItem #sendCodeDoneTip {\n    font-size: 12px;\n    color: #999999;\n    margin: 5px 0px 0px 0px;\n}\n#verificationContainer .fieldItem #msgErrorTip {\n    width: 100%;\n    margin: 5px 0px 0px 0px;\n}\n/* 底部提示语 */\n#loginVerificationTips {\n    display: block;\n    float: left;\n    font-size: 12px;\n    color: #c3c3c3;\n    padding: 0 30px 20px;\n}\n/* END */\n\n\n/* 分割线 */\n#splitLine {\n    width: 100%;\n    height: 1px;\n    background-color: #E2E2E2;\n    border-radius: 1px;\n    float: left;\n    margin-bottom: 30px;\n}\n\n/* 底部按钮组 */\n#btnGroupDiv {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-bottom: 30px;\n    background-color: #FFFFFF;\n}\n#btnGroupDiv .btnDiv {\n    display: inline-block;\n    width: 263px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333333;\n    text-align: center;\n    border-radius: 2px;\n    cursor: pointer;\n}\n#btnGroupDiv #cancelBtn {\n    background: #FFFFFF;\n    border: 1px solid #adb0b8;\n    color: #252b3a;\n}\n\n#btnGroupDiv #cancelBtn:hover{\n    color: #526ecc;\n    border-color: #5e7ce0;\n}\n\n#btnGroupDiv #submitBtn {\n    margin-left: 10px;\n    background: #F66F6A;\n    border: 1px solid #F66F6A;\n    color: #FFFFFF;\n}\n\n#btnGroupDiv #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n#btnGroupDiv #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* 右侧绑定虚拟MFA弹窗框 */\n.bingMFAPage {\n    position: fixed;\n    top: 45px;\n    bottom: 70px;\n    left: 0;\n    right: 0;\n    background: rgb(0, 0, 0, 0.5);\n}\n.bingMFAPage .bindMFAModal {\n    width: 700px;\n    float: right;\n    background: #FFFFFF;\n    position: relative;\n    overflow-y: overlay;\n    overflow-x: hidden;\n    height: calc(100% - 60px);\n}\n.modalTitle {\n    width: 100%;\n    font-size: 24px;\n    line-height: 24px;\n    text-align: left;\n    margin: 30px 0px;\n    padding-left: 30px;\n    border-left: 3px solid #3399FF;\n}\n.modalContent {\n    float: left;\n    padding: 0px 0px 30px 20px;\n}\n.modalContent .stepDiv {\n    float: left;\n    width: 100%;\n}\n.modalContent .stepDiv#step1 {\n    height: 210px;\n}\n.modalContent .stepDiv#step2 {\n    height: 250px;\n}\n.modalContent .stepDiv .stepProgress {\n    width: 32px;\n    height: 100%;\n    float: left;\n    transform: translateY(6px);\n}\n.modalContent .stepDiv .stepProgress .stepImage {\n    width: 20px;\n    height: 20px;\n    line-height: 21px;\n    font-size: 14px;\n    color: #FFFFFF;\n    background: url(" + escape(__webpack_require__(49)) + ") no-repeat;\n    background-size: 100% 100%;\n}\n.modalContent .stepDiv .stepProgress .stepFill {\n    width: 2px;\n    height: 100%;\n    margin: -3px 14px 0px 14px;\n    background-color: #526ECC;\n}\n.modalContent .stepDiv .stepContent {\n    float: left;\n    width: 585px;\n    margin-left: 20px;\n}\n.modalContent .stepDiv .stepContent .title {\n    font-size: 16px;\n    padding: 5px 0px;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .tips {\n    font-size: 12px;\n    color: #8A8E99;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .appDownload {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .appDownload .HWCloud {\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    background: url(" + escape(__webpack_require__(48)) + ") center no-repeat;\n    background-size: cover;\n}\n.modalContent .stepDiv .stepContent .content {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n    float: left;\n    width: 120px;\n    height: 120px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n    float: left;\n    width: 450px;\n    font-size: 14px;\n    margin-left: 10px;\n    background: #F4F5F6;\n    padding: 5px 0px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem {\n    float: left;\n    padding: 5px 15px 5px 15px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoLabel {\n    float: left;\n    width: 90px;\n    text-align: left;\n    color: #999999;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n    float: left;\n    display: inline-block;\n    width: 330px;\n    text-align: left;\n    word-wrap: break-word;\n    word-break: break-all;\n    overflow: hidden;\n}\n.modalContent #msgMFAErrorTip {\n    padding-left: 172px;\n    text-align: left;\n    font-size: 12px;\n    color: #F66F6A;\n}\n.MFACodeDiv .codeFieldItem {\n    float: left;\n    padding: 10px 0px;\n    margin-right: 20px;\n}\n.MFACodeDiv .codeFieldItem .codeLabel {\n    float: left;\n    width: fit-content;\n    margin-right: 16px;\n    height: 32px;\n    line-height: 32px;\n    font-size: 14px;\n    color: #666666;\n}\n.MFACodeDiv .codeFieldItem .codeInput {\n    float: left;\n}\n.MFACodeDiv .codeFieldItem .codeInput .tiny-input-text {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n}\n\n/* 页面底部 */\n.modalFooter {\n    display: block;\n    position: fixed;\n    bottom: 80px;\n    width: 700px;\n    height: 60px;\n    float: left;\n    background-color: #f4f4f4;\n    border-top: 1px solid #eeeeee;\n}\n.modalFooter .btnDiv {\n    width: 100px;\n    padding: 5px 20px;\n    font-size: 14px;\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-top: 14px;\n    cursor: pointer;\n}\n.modalFooter #submitBtn {\n    border-color: #F66F6A;\n    background: #F66F6A;\n    color: #FFFFFF;\n}\n.modalFooter #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n.modalFooter #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.modalFooter #cancelBtn {\n    width: 80px;\n    margin-left: 10px;\n    color: #252b3a;\n    background: #fff;\n    border-color: #adb0b8;\n    cursor:pointer;\n}\n.modalFooter #cancelBtn:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n/* END */\n\n.commonTxt{\n    line-height: normal;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.titleText {\n    height:36px;\n    font-size: 24px;\n    color: #333;\n    text-align: left;\n}\n\n.hintTitle{\n    font-size:18px;\n    color:#333333;\n}\n\n.hintContextSMS{\n    font-weight:400;\n    font-size:14px;\n    color:#666666;\n}\n\n.presetInfo{\n    width: 650px;\n    word-wrap: break-word;\n    color: #999999;\n    text-align: left;\n    border:1px dashed #cccccc;\n    border-radius: 5px;\n    margin-top: 20px;\n    padding-top:10px;\n    padding-right:10px;\n    padding-left:10px;\n    padding-bottom:40px;\n    font-size: 12px;\n    background-color: #FFFFFF;\n}\n\n.loginInfo{\n    font-size: 14px;\n    color: #666666;\n    margin-top: 20px;\n    align:\"left\"\n}\n\n#getMsgCodeBtn{\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-left: 10px;\n    text-align: center;\n    height: 36px;\n    border-radius: 4px;\n    line-height: 36px;\n    vertical-align: middle;\n    color: #666;\n    padding-left:5px;\n    padding-right: 5px;\n}\n\n#getMsgCodeBtn:hover{\n    color: #009ae7;\n}\n\n.getMsgCodeBtn{\n    cursor: pointer;\n    background-color: #FFFFFF;\n}\n\n.disabledMsgBtn{\n    color: #666 !important;\n    background-color: #cccccc;\n    cursor: default;\n}\n\n.btnCommon{\n    width: 100px;\n    height: 35px;\n    text-align: center;\n    font-size: large;\n    line-height: 35px !important;\n    border-radius: 3px;\n    color: #333333;\n}\n\n\n\n#cancelBtnBtn{\n    background-color: #FFFFFF;\n    border: 1px solid #CCC;\n    cursor: pointer;\n}\n\n#cancelBtnBtn:hover{\n    /*background-color: #DDDDDD;*/\n    border-color: #60b0ff;\n    background-color: #FFFFFF;\n}\n\n.changePhonelink{\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 14px;\n    color: #526ECC;\n}\n\n#getMsgDiv{\n    margin-top:20px;\n    height:38px;\n    font-size: 14px;\n    margin-right: -200px;\n}\n\n.msgCodeHint{\n    display:inline-block;\n    min-width:107px;\n}\n\nbutton:focus{\n    outline:none;\n}\n\n/* 使步骤条与内容高度一致 */\n.stepDiv {\n    display: table;\n}\n\n.stepDiv > .stepProgress, .stepDiv > .stepContent {\n    display: table-cell;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.tiny-combobox-container {\n    height: 32px;\n    line-height: 30px;\n    border: 1px solid #d5d5d5;\n    border-radius: 2px;\n    background: #fff;\n    box-shadow: 1px 1px 1px #fff,inset 1px 1px 1px rgba(0,0,0,0.1);\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n@media only screen and (max-width: 1920px) {\n\n}\n@media only screen and (max-width: 1680px) {\n    \n}\n@media only screen and (max-width: 1440px) {\n    \n}\n@media only screen and (max-width: 1366px) {\n    \n}\n@media only screen and (max-width: 1280px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n@media only screen and (max-width: 1024px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    #btnGroupDiv {\n        background-color: transparent;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginVerificationDiv {\n        max-width: none;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 0px;\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 2px;\n        /* margin: 0 auto; */\n        margin-top: 0px;\n        margin-bottom: 20px;\n    }\n\n    #verificationContainer, #loginVerificationTips {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    #verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n        padding: 0 8px;\n    }\n\n    #verificationContainer .fieldItem {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        flex-wrap: nowrap;\n    }\n\n    #verificationContainer .fieldItem .itemContent {\n        width: auto;\n        font-size: 12px;\n    }\n\n    #verificationContainer .fieldItem .itemLabel {\n        min-width: 100px;\n        max-width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    #verificationContainer .fieldItem .itemContent .bindTips {\n        clear: both;\n    }\n\n    #verifyCodeId {\n        width: 100px !important;\n    }\n\n    #bindPhoneId {\n        width: 100% !important;\n    }\n\n    #bindEmailId {\n        width: 100% !important;\n    }\n\n    #btnGroupDiv {\n        flex-wrap: wrap;\n    }\n\n    #btnGroupDiv .btnDiv {\n        width: calc(50% - 16px);\n        padding-left: 8px;\n        padding-right: 8px;\n        margin: 8px;\n        min-width: 160px;\n        display: block;\n        box-sizing: border-box;\n        float: left;\n    }\n\n    #btnGroupDiv #submitBtn {\n        margin-left: 8px;\n    }\n\n    #countryCodeSelectId {\n        margin-bottom: 8px;\n    }\n\n    .modalTitle {\n        width: auto;\n    }\n\n    .bingMFAPage {\n        bottom: 0px;\n    }\n\n    .bingMFAPage .bindMFAModal {\n        width: 100%;\n    }\n\n    .modalFooter {\n        width: 100%;\n        bottom: 0px;\n    }\n\n    .modalContent .stepDiv .stepProgress {\n        /* display: none; */\n    }\n\n    .modalContent .stepDiv .stepContent {\n        float: left;\n        width: calc(100% - 32px);\n        margin-left: 0;\n    }\n\n    .modalContent {\n        padding-right: 20px;\n    }\n\n    .modalContent .stepDiv {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n        width: auto;\n        margin-left: 0px;\n        margin-top: 8px;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n        width: 100%;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeLabel {\n        text-align: left;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeInput {\n        text-align: left;\n    }\n\n    #verifyCodeId {\n        width: 125px !important;\n    }\n\n    .codeInput .tiny-textbox-container {\n        width: 120px !important;\n    }\n\n    .modalContent .stepDiv .stepContent .appDownload {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n        float: none;\n    }\n    \n    #verificationContainer .fieldItem .inputDiv .retrieveTip {\n        padding: 0px 5px;\n    }\n\n    .modalContent #msgMFAErrorTip {\n        padding-left: 0px;\n    }\n}\n\n\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    margin-top: 8px;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n    font-weight: normal;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -17px;\n    width: 12px;\n    height: 12px;\n    top: 3px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -13px;\n    top: 5px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n\n/*适配移动端*/\n@media (max-width: 375px) {\n    #verifyCodeId {\n        width: 92px !important;\n    }\n}\n\n@media (max-width: 360px) {\n    #verifyCodeId {\n        width: 77px !important;\n    }\n}\n\n@media (max-width: 320px) {\n    #verifyCodeId {\n        width: 38px !important;\n    }\n}", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滚动条轨道 内阴影+圆角*/\n::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滑块 内阴影+圆角*/\n::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #bfc3c6;\n}\n/*------  content begin ---------*/\n#loginAdv {\n    float: left;\n    max-width: 800px;\n    max-height: 515px;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n}\n\n#loginForm {\n    width: 380px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#loginForm > ul, #companyUser, #personalUser {\n    margin: auto auto 0px auto;\n    width: 320px;\n}\n\n/* 统一ID登录iframe */\n#uniIdIframeDiv {\n    width: 380px;\n    height: 500px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n/* END */\n\n/* 页面错误信息 */\n/* END */\n\n/* 主帐户 帐号/邮箱登录方式 */\n#loginForm .loginFormDiv {\n    padding: 0px 30px;\n    width: 320px;\n}\n/* END */\n\n/* 国家码选择框 */\n\n#loginForm .codeSelect {\n    display:inline-block;\n    vertical-align: middle;\n    float: left;\n}\n#loginForm .codeSelect .tiny-combobox-container {\n    border: none;\n    background-color: #FFFFFF;\n    box-shadow: none;\n}\n#loginForm .codeSelect .tiny-combobox-editor {\n    padding-left: 8px;\n    /*width: calc(100% - 10px);\n    width: -webkit-calc(100% - 10px);\n    width: -moz-calc(100% - 10px);*/\n}\n#loginForm .codeSelect .tiny-combobox-editor .tiny-combobox-input {\n    box-shadow: none;\n    border: none;\n    padding: 0px;\n    font-size: 12px;\n}\n#loginForm .codeSelect .tiny-combobox-popbutton:before {\n    right: 1px;\n    border-top: 5px solid #252B3A;\n}\n#loginForm .codeSelect .tiny-combobox-disable {\n    background-color: #FFFFFF;\n    border-color: none;\n    box-shadow: none;\n    border-right: none;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input {\n    /* font-family: PingFangSC-Regular; */\n    color: #696969;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input:disabled {\n    opacity: 1 !important;\n}\n/* END */\n\n/* 手机号输入框 */\n.phoneInput {\n    display:inline-block;\n    position: relative;\n}\n.phoneInput input.tiny-input-text.valid_error_input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n/* END */\n\n/*\n<!-- 帐号输入框 -->\n<!-- 密码输入框 -->\n<!-- 手机号登录方式 -->\n<!-- 国家码选择框 -->\n<!-- 手机号输入框 -->\n<!-- 手机绑定多帐号需选择 -->\n<!-- 密码输入框 -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 密码输入框 -->\n<!-- 主帐户 帐号/邮箱登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- <tiny-textbox id=\"model.userNameId\" validate=\"model.userValidator\" value=\"model.userName\"\n<!-- 主帐户 手机号登录方式 仅国内站-->\n<!-- 手机绑定多帐号需选择 -->\n<!-- end -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 国内IP placeholder不同-->\n<!-- 海外IP placeholder不同-->\n<!-- 密码输入框 非手机登录方式-->\n<!-- 密码输入框 手机登录方式-->\n<!-- 验证码输入框 -->\n<!-- 手机号登录方式切换按钮 -->\n<!-- 记住密码按钮 -->\n*/\n#companyUser, #personalUser {\n    color: #333333;\n    font-size: 28px;\n    margin-top: 35px !important;\n    margin-bottom: auto !important;\n}\n\n#companyUser > span, #personalUser > span {\n    line-height: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: top;\n}\n\n#companyUser > hr, #personalUser > hr {\n    display: inline-block;\n    margin: 5px 5px;\n    border: 0;\n    border-bottom: 1px solid #999999;\n}\n\n#companyUser > hr {\n    width: 28%;\n}\n\n#personalUser > hr {\n    width: 56%;\n}\n\n.errorTip {\n    display:block;\n    position: relative;\n    min-height: 32px;\n    font-size: 12px;\n    padding: 0px 8px;\n}\n.errorTip span {\n    color: #F66F6A;\n}\n\n#checkError, #serverError, #mobileErrorMsg, #mobileUsersSelectMsg, #isMobileTip {\n    color: #FF0000;\n    /*display: none;*/\n    clear: both;\n    /*margin: 10px 0 0 0;*/\n}\n\n/* 手机多用户时选择用户的下拉框 */\n.mobileUsersSelect {\n    margin-bottom: 15px;\n}\n.mobileUsersSelect .tiny-select {\n    width: 100%;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field {\n    height: 36px;\n    border: none;\n    padding-right: 0;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field input {\n    width: 100% !important;\n    border-right: none;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-input-field-selected-down:before, .tiny-select-input-field-selected-up:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-popup-container {\n    border: 1px solid #ADB0B8;\n    box-shadow: 0 2px 5px 0;\n}\n.tiny-select-option {\n    color: #252B3A;\n}\n.tiny-select-option-selected {\n    color: #F66F6A;\n    background: #FFEEED;\n}\n.tiny-select-option-default-selected {\n    background-color: #F66F6A;\n    color: #FFFFFF;\n}\n/* END */\n\n/* 验证码图片样式 */\n#inputVerifyCodeImg {\n    width: 100px;\n    height: 30px;\n    float: right;\n    cursor: pointer;\n}\n/* END */\n\n.inputField {\n    margin-bottom: 16px !important;\n    font-size: 14px !important;\n    border-bottom: 1px solid #DFE1E6;\n    position: relative;\n}\n.inputField:hover {\n    border-bottom: 1px solid #8A8E99;\n}\n.inputField:last-child {\n    margin-bottom: 0px !important;\n    font-size: 14px !important;\n}\n#loginForm .inputField input {\n    line-height: 20px;\n    border-radius: 0px;\n    /* font-family: \"PingFangSC-Regular\"; */\n    padding: 0px 8px;\n    box-shadow: none;\n}\n\n#loginForm > div:last-child {\n    /*position: absolute !important;*/\n    bottom: 0px;\n    width: 100%;\n}\n\n#buttonArea {\n    margin: 48px 38px 30px 38px;\n    width: 304px;\n}\n\n#smsPhone {\n    margin: 5px;\n    font-size: 13px !important;\n}\n\n#fpLink {\n    color: #00aaff;\n    float:right;\n}\n\n/* 手机号登录切换 以及 记住登录名 */\n.toDoDiv {\n    margin: 18px 38px 0;\n    width: 304px;\n}\n/* END */\n\n/* 手机号登录切换 */\n.typeSwitchDiv {\n    display: inline-block;\n    font-size: 12px;\n    font-style: normal;\n    color: #252B3A;\n    max-width: 180px;\n}\n#typeSwitchBtn {\n    cursor: pointer;\n}\n#typeSwitchBtn:hover {\n    color: #F66F6A;\n    text-decoration: underline;\n}\n/* END */\n\n/* 记住登录名 */\n.toDoDiv #checkArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -20px;\n    top: 0px;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -16px;\n    top: 2px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n/* END */\n\n.buttonAreaDiv {\n    width: 100%;\n    float: left;\n}\n\n.loginBtn {\n    background-color: #F66F6A;\n    border-radius: 2px;\n    color: #ffffff;\n    cursor: default;\n    width: 100%;\n}\n.loginBtn:hover,\n.loginBtn:active,\n.loginBtn:focus {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,0.3);\n    outline: none;\n}\n\n.loginBtn span, .loginBtnDisabled span {\n    vertical-align: middle;\n    text-align: center;\n    font-size: 14px !important;\n    display: table-cell;\n    height: 36px;\n    margin: 0 auto;\n    display: block;\n    line-height: 36px;\n}\n\n.loginBtnDisabled {\n    background-color: #CCCCCC;\n    border: 1px solid #CCCCCC;\n    border-radius: 3px 3px 3px 3px;\n    color: #ffffff;\n    font-size: 18px !important;\n    cursor: default;\n    width: 100%;\n}\n\n#bottomBtns {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: 10px;\n}\n\n/* 免费注册 & 忘记密码 & 用户切换 */\n.commonLinkDiv {\n    flex-basis: 50%;\n    margin-bottom: 10px;\n    text-align: center;\n}\n.splitLine {\n    display: none;\n    float: left;\n    width: 1px;\n    margin: 0px 2px;\n    height: 12px;\n    background: #DFE1E6;\n}\n.freeRegisterLink {\n    width: 100px;\n}\n.forgetPwdLink {\n    width: 100px;\n}\n.userTypeLink {\n    width: 100px;\n}\n/* END */\n\n#goLogin {\n    color:#5099F8;\n    cursor: pointer;\n    font-size:small;\n}\n#goLogin:hover{\n    text-decoration: underline;\n}\n/*-------- content end ---------*/\n\n/*------ page layout begin ------*/\n#content .widthLimit {\n    position: relative;\n    margin: 0px auto;\n    padding: 0px 20px;\n}\n\n#content .widthLimit{\n    max-width: 1200px;\n}\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 45px;\n}\n\nbody, html {\n    height:100%;\n    margin: 0;\n    padding: 0;\n    min-width: 1260px;\n}\n\n*{\n    margin: 0;\n    padding: 0;\n}\n.placeholder {\n    color: #aaa!important;\n    font-family: \"Microsoft Yahei\"!important;\n}\n\n.linkSeperator {\n    height:100%;\n    border-left: 1px #0678FF solid;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.expand {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-top: 10px solid #0678FF;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.collapse {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-bottom: 10px solid #0678FF;;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\n\n.requiredImage {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n#enterpriseSwitchTip {\n    background-color: #ffffff;\n    border: 1px solid #cccccc;\n    color: #666666;\n    width: 300px;\n    height: auto;\n    position: absolute;\n    float: right;\n    border-radius: 2px;\n    top: 50px;\n    z-index: 10;\n    padding:6px;\n    background-color: #f5f5f5;\n    font-size: 12px;\n}\n\n.loginTypeDiv {\n    color:#666666;\n    font-size:14px;\n    font-style: normal;\n    padding: 24px 30px 10px 30px;\n    text-align: center;\n}\n\n.loginTypeNoSelected {\n    box-sizing: border-box;\n    display: inline-block;\n    width:100%;\n    line-height: 18px;\n    font-size: 18px;\n    /* font-family: \"PingFangSC-Medium\"; */\n    text-align: center;\n    color: #252B3A;\n    max-width: 300px;\n}\n\n.loginTypeSelected {\n    box-sizing: border-box;\n    border-color: #E41E2B;\n    border-style:solid;\n    border-top:0;\n    border-left:0;\n    border-right:0;\n    border-width: 3px;\n    display: inline-block;\n    width:47%;\n    text-align: center;\n    height: 44px;\n    line-height: 44px;\n    color:#E41E2B;\n    cursor: pointer\n}\n.loginBottomColor {\n    font-size: 12px;\n    color: #252B3A;\n    line-height: 16px;\n}\n.loginBottomColor:hover,\n.loginBottomColor:active,\n.loginBottomColor:focus {\n    color: #F66F6A;\n}\n.otherLoginColor{\n    font-size: 12px;\n    color: #666A75;\n    line-height: 16px;\n}\n.otherLoginColor:hover,\n.otherLoginColor:active,\n.otherLoginColor:focus {\n    color: #666A75;\n}\n\n/* 三方登录展示列表 */\n#otherLoginWays {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n#otherLoginWays .otherItemDiv {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n}\n#otherLoginWays .otherItemDiv .textIcon {\n    height: 13px;\n    padding-top: 3px;\n}\n#otherLoginWays .otherItemDiv#hwportalLinkDiv {\n    flex-grow: 1;\n}\n/* END */\n\n.tiny-input-text {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #333;\n    font-size: 14px;\n    font-face:NotoSansCJKsc-Regular\n}\n.tiny-input-text:focus {\n    border: none;\n}\n.tiny-input-text.valid_error_input:focus {\n    border: none;\n}\n\n:-ms-input-placeholder {\n    color: #999 !important;\n}\n\n#otherAccounts{\n    position: relative;\n    text-align: center;\n    margin-bottom: 5px;\n    line-height: 1;\n    cursor: pointer;\n}\n#otherAccounts:before{\n    content: '';\n    position: absolute;\n    top: 50%;\n    display: block;\n    width: 100%;\n    border-top: 1px solid #DDD;\n}\n\n#otherAccounts .downArrow {\n    margin-left: -7px;\n    padding-right: 7px;\n    display: inline-block;\n    position: relative;\n    z-index: 2;\n    background-color: #ffffff;\n}\n#otherAccounts .downArrow img {\n    width: 8px;\n    height: 8px;\n}\n#otherAccounts .downArrow img.otherAccountsOpen {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n#otherAccounts .downArrow img.otherAccountsClose {\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n#otherAccounts .otherLoginColor{\n    padding: 0 7px;\n    position: relative;\n    z-index: 2;\n    background-color: #fff;\n}\n\ninput[type=\"password\"] {\n    color: #333;\n}\n\n.homepageLink {\n    color: #A0A2A8;\n}\n\n.index-uniportal {\n    position: relative;\n}\n\n.index-uniportal>a {\n    cursor: pointer;\n}\n.index-uniportal:hover >.uniportalTip {\n    display: block;\n}\n\n.index-uniportal>.uniportalTip {\n    top: 17px;\n    display: none;\n    position: absolute;\n    bottom: 13px;\n}\n\n.index-uniportal>.uniportalTip>span {\n    padding: 2px;\n    box-shadow: 1px 1px 10px #ccc;\n    border: 1px solid #ccc;\n    display: block;\n    background: #fff;\n    margin-left: 90px;\n    width: 183px;\n    font-size: 10px;\n}\n.otherLogin{\n    position:relative;\n    margin-left: 120px;\n}\n.otherLogin:before{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: -120px;\n    content: \"\";\n}\n.otherLogin:after{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: 100px;\n    content: \"\";\n}\n.registUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 70px;\n    font-size: 13px;\n}\n.forgetPWDUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 0px;\n    font-size: 13px;\n}\n.shuXianSpan {\n    color: #666;\n    float: right;\n    margin-top: -21px;\n    margin-right: 63px;\n}\n\n.helpQuestionmark {\n    background-image: url(" + escape(__webpack_require__(47)) + ");\n    float: right;\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n}\n\n.loginswap {\n    line-height: 18px;\n}\n\n.loginswap:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.helptipfather {\n    display: inline-block; position:relative;\n}\n.userTypeLink:hover .helptipchild {\n    display:block;\n    width:220px;\n    padding:8px 3px 3px 6px;\n}\n.helptipfather span {\n    display:none;\n    color:#666666;\n    font-size:12px;\n    line-height:20px;\n    /* font-family:PingFangSC-Regular; */\n    background:#FFFFFF;\n    border-radius:0 0 0 2px 2px 2px 2px;\n    border:1px solid #EEEEEE;\n    box-shadow:0 2px 5px 0 rgba(0,0,0,0.15);\n    -moz-border-radius:1px;\n    -webkit-border-radius:1px;\n    text-align:left;\n    position: absolute;\n    left: -150px;\n    top: 10px;\n    z-index:10;\n    overflow: visible;\n}\n#loginAdv .login-logo-pad{\n    display: none;\n}\n.pwdShowimg {\n    top: 10px;\n    right: 8px;\n    position: absolute;\n    width: 15px;\n    height: 15px;\n}\n\n#personalPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n\n#mobilePasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n} \n\n#IAMPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n/*------ pad css start------*/\n@media (max-width: 1269px) {\n    .widthLimit{\n        box-sizing: border-box;\n        padding: 0;\n    }\n    html,body,#content{\n        max-width: 1270px;\n        min-width: 768px;\n    }\n    #content{\n        height: calc(100% - 90px);\n    }\n    #content .widthLimit{\n        max-width: 768px;\n    }\n    #loginAdv{\n        margin-top: 40px;\n        max-width: 352px;\n    }\n    #content .widthLimit{\n        padding: 0 15px;\n    }\n\n    #loginForm{\n        margin-top: 70px;\n    }\n    #loginAdv .login-logo-pad{\n        display: block;\n    }\n    #loginAdv .login-logo-pc{\n        display: none;\n    }\n}\n/*------ pad css end ------*/\n/*------ page layout end ------*/\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    #content {\n        height: 100%;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        padding: 0 30px;\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginAdv {\n        display: none;\n    }\n\n    body, html, #content {\n        height:100%;\n        margin: 0;\n        padding: 0;\n        min-width: 0px;\n    }\n\n    #loginForm {\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        /* padding: 0 30px; */\n    }\n\n    #uniIdIframeDiv {\n        width: 100%;\n        height: 100%;\n        margin-top: 0px;\n    }\n    #uniIdIframe {\n        width: 100%;\n        box-shadow: none;\n        background: none;\n    }\n    \n    #loginForm .loginFormDiv {\n        width: 100% !important;\n        padding: 0;\n        margin: 0;\n    }\n\n    #loginForm .tiny-textbox-container {\n        width: 100% !important;\n    }\n\n    #verifyCode .tiny-textbox-container {\n        width: calc(100% - 138px) !important;\n    }\n    \n    #inputVerifyCodeImg {\n        transform: translateY(4px);\n    }\n\n    .toDoDiv {\n        margin-left: 0px;\n        margin-right: 0px;\n        width: 100%;\n    }\n\n    #loginForm .mobileLoginDiv .phoneInput {\n        width: calc(100% - 115px);\n    }\n\n    #buttonArea {\n        margin: 38px auto;\n        width: 100%;\n    }\n\n    #otherAccounts .otherLoginColor {\n        background-color: #0000;\n    }\n\n    #otherAccounts .downArrow {\n        background-color: #0000;\n    }\n    \n    .userTypeLink:hover .helptipchild {\n        display: none;\n    }\n}\n\n/* 扫码登录 */\n#loginForm{\n    position: relative;\n}\n#QRLoginDiv {\n    position: relative;\n    background-color: #fff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228,228,228,1);\n    border-radius: 0;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,.1);\n    display: flex;\n    width: 380px;\n    height: 407px;\n    float: right;\n    margin-top: 80px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loginQRCodeDiv{\n    width: 159px;\n    padding: 10px;\n}\n\n.QRCodeOuter{\n    position:relative;\n    height: 179px;\n    width: 180px;\n    margin: 0 auto;\n    text-align: center;\n    border: 0px solid #DFE1E6;\n    background: url(" + escape(__webpack_require__(32)) + ");\n    background-size: cover;\n}\n.QRCodeInner{\n    position:absolute;\n    top: 0px;\n    left: 0px;\n    color: #FFFFFF;\n    height: 179px;\n    width: 180px;\n    background:rgba(7, 7, 7, 0.6);\n}\n\n\n.loginTypeSwitchImg{\n    margin-top: 8px;\n    margin-right: 8px;\n    width: 50px;\n    height: 50px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n}\n\n.loginTypeSwitchImg:hover{\n    cursor: pointer;\n}\n\n.ti-tooltip {\n    position: absolute;\n    top: 9px;\n    right: 58px;\n    background-color: #333854;\n    color: #dfe1e6;\n    padding: 11px 15px;\n    border: 1px solid #333854;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n    border-radius: 4px;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    box-sizing: border-box;\n    z-index: 5000;\n    white-space: normal;\n    word-wrap: break-word\n}\n\n.ti-tooltip-left:after {\n    height: 20px;\n    margin-top: -10px;\n    right: 0\n}\n\n.ti-tooltip-left:after,.ti-tooltip-left:before {\n    display: block;\n    position: absolute;\n    content: \"\";\n    overflow: hidden;\n    background: #333854;\n    width: 10px;\n    top: 50%\n}\n\n.ti-tooltip-left:before {\n    height: 10px;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    border-right: 1px solid #333854;\n    border-top: 1px solid #333854;\n    margin-top: -5px;\n    right: -5px;\n    box-shadow: 0 -2px 4px rgba(0,0,0,.2)\n}\n\n#countDownDiv {\n    text-align: center;\n    color: #252B3A;\n    font-size: 12px;\n    margin-top: 10px;\n    height: 20px;\n}\n\n.remainingTimeTxt{\n    color: #F66F6A;\n}\n\n#QRLoginBottomDiv {\n    width: calc(100% - 50px);\n    border-top: 1px solid #575D6C;\n    margin-left: 40px;\n    margin-right: 40px;\n    height: 60px;\n    line-height: 50px;\n    display: inline-flex;\n    justify-content: space-between;\n    font-size: 12px;\n}\n\n.QRLoginBottomColor {\n    font-size: 12px;\n    color: #575D6C;\n}\n.QRLoginBottomColor:hover,\n.QRLoginBottomColor:active,\n.QRLoginBottomColor:focus {\n    color: #F66F6A;\n}\n\n.QRCodeInvalid{\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 60px;\n}\n\n#refreshQRCodeBtn {\n    width: 80px;\n    margin: 0 auto;\n}\n\n.loginStatusDiv{\n    text-align: center;\n}\n\n.loginStatusImg{\n    height: 64px;\n    width: 64px;\n    margin-bottom: 16px;\n}\n\n.loginStatusTitle{\n    color: #252B3A;\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.loginStatusMessage{\n    color: #252B3A;\n    font-size: 12px;\n}\n\n@media (max-width: 1269px) {\n    #QRLoginDiv{\n        margin-top: 70px;\n    }\n    .loginTypeSwitchImgCover{\n        border-bottom: 50px solid linear-gradient(90deg,#F4F5FF 0,#E8EBFD 48%,#F4F5FF 100%) ;\n    }\n}\n\n@media (max-width: 768px) {\n    #QRLoginDiv{\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        display: none;\n    }\n\n    .loginTypeSwitchImg {\n        display: none;\n    }\n\n    #QRLoginTip {\n        display: none;\n    }\n\n}\n\n/**企业联邦登录**/\n#idpLoginForm{\n    width: 380px;\n    display: inline-block;\n    float:right;\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#idpLoginForm .loginFormDiv{\n    margin: 0 38px;\n}\n\n#idpLoginForm #otherLoginWays{\n    display: flex;\n    justify-content: space-around;\n}\n\n#idpLoginForm #otherLoginWays .otherItemDiv{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#idpLoginForm #loginBtn{\n    margin-bottom: 50px;\n}\n\n#idpLoginForm .tiny-select-text{\n    box-shadow: 0 0 0 0;\n}\n\n#idpLoginForm #idpCheckArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n\n@media (max-width: 768px){\n    #idpLoginForm{\n        width: 100%;\n        box-shadow: none;\n        background: 0 0;\n        margin-top: 20px;\n    }\n    #idpLoginForm .loginFormDiv{\n        margin: 0;\n    }\n\n    #idpLoginForm .loginFormDiv .tiny-textbox-container{\n        width: 100% !important;\n    }\n    #idpLoginForm .loginFormDiv .tiny-select-input-field{\n        width: 100% !important; \n    }\n}\n", ""]);

// exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content .widthLimit {\n    max-width: 800px;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin: 0 auto;\n}\n\n#verifyTypeBtn {\n    color: #0088CC;\n    display: inline-block;\n    float: right;\n    margin-right: 7px;\n    height: 36px;\n    line-height: 36px;\n}\n\n#verifyTypeBtn:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n#resetTitle {\n    margin: 20px 0px;\n}\n\n#resetTitle > p {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 10px;\n}\n\n#resetTitle > span {\n    font-size: 14px;\n}\n\n.tip_no_border {\n    border-right:none !important;\n    border:none !important;\n    background-color:#F4F4F4 !important;\n    box-shadow:none !important;\n}\n\n#verifyCodeMsg {\n    margin-left: 340px;\n}\n#btnDiv {\n    clear:both;\n    padding-top:10px;\n    margin-left: 340px;\n    max-width: 240px;\n}\n\n#errorMsg {\n    margin-bottom: 5px;\n    display: block;\n    color: red;\n}\n\n.pwdStrengthContainer {\n    display:inline-block;\n    float: right;\n    margin-right:10px;\n    margin-top:10px;\n    clear: both;\n    font-size: 12px;\n    line-height: 13px;\n}\n#TIP span {\n    display: none;\n}\n#TIP.high .high{\n    display: inline-block;\n    color: #333;\n}\n#TIP.low .low{\n    display: inline-block;\n    color: #333;\n}\n#TIP.mid .mid{\n    display: inline-block;\n    color: #333;\n}\n\n.tootip-img {\n    width:16px;\n    height:16px;\n    margin:0 auto 3px 0;\n}\n\n.tootip-div{\n    margin: -21px 0 10px 20px;\n}\n\n.errorInfo {\n        width: 390px;\n        margin-left: 334px;\n}\n\n.errorInfo>span {\n    margin-left: 6px;\n    display: inline-block;\n    width: 315px;\n    color: #e41e2b;\n}\n\n#content {\n    position: relative;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 15px auto 10px;\n    padding: 30px 30px 30px 30px;\n    width: 800px;\n    color: #9B9B9B;\n    position: relative;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    border-radius: 2px;\n}\n.formDiv > ul {\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 320px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: right;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n    position: relative;\n}\n\n.pwd-state-icon {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 28px;\n    color:#333;\n}\n\n#step {\n    height: 70px;\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") center;\n    vertical-align: middle;\n}\n\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n    background-color: #e20074!important;\n}\n\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    color: #252b3a;\n    text-align: center;\n    min-width: 70px;\n    background-color: #FFFFFF;\n    border: 1px solid #adb0b8;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#formUl > li {\n    display: flow-root;\n}\n\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n        width: 100%;\n    }\n\n    #content .widthLimit {\n        padding: 0;\n        margin: 0px;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        /* background-image: none !important; */\n    }\n\n    #resetTitle {\n        margin-left: 20px;\n    }\n\n    .formDiv {\n        height: auto;\n        margin: 0;\n        width: 100%;\n        color: #9B9B9B;\n        position: relative;\n        box-sizing: border-box;\n        box-shadow: none;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        background-color: transparent;\n    }\n\n    .formDiv > ul {\n        width: 100%;\n        min-width: 0;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n    }\n\n    .field {\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container {\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container:not(#msgCodeId){\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        width: 120px;\n        font-size: 12px;\n        margin-right: 8px;\n        line-height: 18px;\n        height: fit-content;\n    }\n\n    #verifyCodeMsg {\n        margin-left: 0px;\n    }\n    #btnDiv {\n        max-width: none;\n        margin-left: 0px;\n        display: flex;\n        justify-content: center;\n        flex-flow: row;\n        flex-wrap: wrap;\n    }\n\n    #msgCodeId {\n        width: 60px !important;\n        height: 32px !important;\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #msgBtn {\n        font-size: 12px;\n        padding-left: 8px;\n        padding-right: 8px;\n        width: fit-content;\n    }\n\n    .tiny-tip-content-top {\n        /* font-size: 12px !important; */\n        left: 10% !important;\n        right: 10% !important;\n        line-height: 1;\n    }\n\n    .passwordStrength {\n        width: 24px;\n        transform: translateY(-7px) !important;\n    }\n\n    .tootip-img {\n        margin-bottom: 5px;\n    }\n\n    .errorInfo > span {\n        width: auto;\n    }\n\n    .errorInfo {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n/* 小屏时换行显示 */\n@media (max-width: 400px) {\n    .fieldLabel {\n        width: fit-content;\n    }\n    .fieldContainer .field {\n        min-width: 270px;\n    }\n\n    .fieldContainer {\n        flex-wrap: wrap;\n    }\n}", ""]);

// exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ":focus {\n\toutline: 0\n}\n\n.common-link {\n\tcolor: #5E7CE0;\n\tcursor: pointer;\n\tdisplay: inline-block\n}\n\n.common-link:hover {\n\tcolor: #5E7CE0;\n\ttext-decoration: underline\n}\n\n.iam-input-text {\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 2px!important;\n\t-webkit-box-shadow: 0 1px 1px 0 #f6f6f6 inset;\n\tbox-shadow: 0 1px 1px 0 #f6f6f6 inset;\n\tborder: 1px solid #c3c3c3;\n\tcolor: #666;\n\tbackground-color: #fff;\n\tpadding: 2px 10px;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n\toutline: 0;\n\tvertical-align: middle\n}\n\n.iam-input-text:focus {\n\tborder: 1px solid #000\n}\n\ninput:disabled {\n\tbackground-color: #CCC;\n\tbox-shadow: none\n}\n\n.iam-input-error {\n\tborder-color: #FA2A2D;\n\tbackground-color: #FFEEED\n}\n\n.iam-input-text::-ms-clear,.iam-input-text::-ms-reveal {\n\tdisplay: none\n}\n\n.iam-tip-hidden {\n\tvisibility: hidden\n}\n\n#loading {\n\tdisplay: none\n}\n\n.findPwdDiv {\n\twidth: 932px;\n\tmargin: 80px auto 0;\n\tbackground-color: #fff;\n\tbox-shadow: 0 8px 16px 0 rgba(0,0,0,.1);\n\tpadding: 20px 30px 40px;\n}\n\n.findPwdDiv .stepDiv {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center\n}\n\n.findPwdDiv .fpwdTitle {\n\tfont-size: 24px;\n\tcolor: #252B3A;\n\ttext-align: center;\n\tline-height: 34px;\n\tmargin-top: 20px\n}\n\n.findPwdDiv .fpwdErrorMsg {\n\tfont-size: 12px;\n\tcolor: #FF4C4C\n}\n\n.findPwdDiv .fpwdTypeChangeDiv {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tcolor: #5E7CE0;\n\tcursor: pointer;\n\tmargin-bottom: 32px;\n\tmargin-top: 12px\n}\n\n.iam-icon-angle-left::before {\n\tcontent: url(" + escape(__webpack_require__(326)) + ")\n}\n\n.iam-icon-angle-left,.iam-icon-angle-right {\n\tmargin-bottom: -3px\n}\n\n.iam-icon-angle-right::before {\n\tcontent: url(" + escape(__webpack_require__(327)) + ")\n}\n\n.findPwdDiv .phoneField {\n\tmargin-bottom: 20px\n}\n\n.findPwdDiv .phoneInput {\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 1px solid #ADB0B8;\n\twidth: 380px;\n\tborder-radius: 2px\n}\n\n.findPwdDiv .iam-phoneInput-error {\n\tbackground-color: #FFEEED;\n\tborder-color: #FA2A2D\n}\n\n.findPwdDiv .iam-phoneInput-focused {\n\tborder: 1px solid #000\n}\n\n.findPwdDiv .phoneInput .codeSelect {\n\tmargin: auto 10px\n}\n\n.findPwdDiv .phoneInput input {\n\tborder: none;\n\tpadding-left: 10px\n}\n\n.findPwdDiv .findMethodChange {\n\tmargin-top: 16px\n}\n\n#verifyCode {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center\n}\n\n#inputVerifyCodeImg {\n\theight: 40px\n}\n\n#validresultImg {\n\ttop: 12px;\n\tright: 14px;\n\tposition: absolute\n}\n\n.findByEmail,.findPwdDiv .findMethodChange .findByPhone {\n\tfont-size: 12px!important\n}\n\n.findPwdDiv .stepBtnDiv {\n\ttext-align: center;\n\tdisplay: inline-block;\n\tmargin-top: 32px;\n\tcursor: pointer\n}\n\n.findPwdDiv .stepBtnDiv .next-step-btn {\n\tcolor: #fff;\n\tbackground-color: rgba(230,0,13,1);\n\tborder: 1px solid rgba(230,0,13,1);\n\tborder-radius: 4px;\n\tbox-sizing: border-box;\n\tmargin: 0\n}\n\n.findPwdDiv .stepBtnDiv .next-step-btn:hover {\n\tbox-shadow: 0 8px 16px rgba(246,111,106,.3)\n}\n\n.findPwdDiv .stepBtnDiv .stepNextBtn {\n\twidth: 380px;\n\tbox-sizing: border-box;\n\theight: 40px;\n\tline-height: 40px\n}\n\n.findPwdDiv .stepBtnDiv .stepNextBtn.disabledStepNextBtn {\n\tbox-shadow: none;\n\tbackground-color: #CA141D;\n\tborder: 1px solid #CA141D;\n\tborder-radius: 4px;\n\tcursor: not-allowed;\n\tcolor: rgba(255,255,255,1);\n\topacity: 0.3;\n}\n\n.findPwdDiv .authVerifyCode .sendVerifyCode {\n\tfont-size: 12px;\n\tborder: 1px solid #A0A2A8;\n\theight: 30px;\n\tline-height: 30px;\n\tpadding: 1px 16px 2px;\n\tborder-radius: 2px;\n\tcursor: pointer;\n\ttext-align: center;\n\tmargin-left: 16px\n}\n\n.findPwdDiv .authVerifyCode .retrieveVerifyCode {\n\tfont-size: 12px;\n\tcolor: #999;\n\tborder: 1px solid #A0A2A8;\n\theight: 30px;\n\tline-height: 30px;\n\tpadding: 1px 16px 2px;\n\tborder-radius: 2px;\n\ttext-align: center;\n\tmargin-left: 16px\n}\n\n.findPwdDiv .contactService {\n\twidth: 380px;\n\tmargin-top: 10px;\n\tmargin-bottom: 20px\n}\n\n.findPwdDiv .contactService span {\n\tdisplay: inline-block;\n\tcolor: #8A8E99;\n\tfont-size: 14px;\n\tpadding: 2px 0\n}\n\n.pwdShowimg {\n\ttop: 4px;\n\tright: 5px;\n\twidth: 32px;\n\theight: 32px;\n\tposition: absolute\n}\n\n.iam-icon-action-state-invisible {\n\tbackground-image: url(" + escape(__webpack_require__(101)) + ");\n\tbackground-size: 32px 32px;\n\tbackground-repeat: no-repeat\n}\n\n.iam-icon-action-state-visible {\n\tbackground-image: url(" + escape(__webpack_require__(102)) + ");\n\tbackground-size: 32px 32px;\n\tbackground-repeat: no-repeat\n}\n\n#passwordTipId {\n\tmax-width: 400px\n}\n\n.tootip-div {\n\tdisplay: flex;\n\tword-break: break-all;\n\tfont-size: 12px;\n\tfont-family: Arial;\n\tcolor: #DFE1E6;\n\tmargin: 5px 0 5px 10px\n}\n\n.tootip-div img {\n    height: 16px;\n    max-width: 16px;\n\tmargin-top: 2px\n}\n\n.strengthLowCircle {\n\twidth: 6px;\n\theight: 6px;\n\tbackground: #dcdcdc;\n\t-moz-border-radius: 3px;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px\n}\n\n.safetyDegreeDiv {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\theight: 20px\n}\n\n.passwordStrength {\n\tborder: none;\n\theight: 2px;\n\tmargin-top: 0\n}\n\n.findPwdDiv .resultDiv {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-top: 40px\n}\n\n.findPwdDiv .resultDiv .image {\n\twidth: 24px;\n\theight: 24px\n}\n\n.findPwdDiv .resultDiv .msg {\n\tfont-weight: 410;\n\tfont-size: 24px;\n\tline-height: 24px;\n\tmargin-top: 16px\n}\n\n.findPwdDiv .accountField,.findPwdDiv .userField {\n\tmargin-bottom: 20px\n}\n\n.findPwdDiv .authMethodList {\n\tmargin-bottom: 12px;\n\tmargin-top: 32px\n}\n\n.findPwdDiv .changeAuthMethodType {\n\tmargin-top: 16px\n}\n\n.step3 .newPassDiv {\n\tmargin-top: 32px;\n\twidth: 380px;\n\tmargin-bottom: 20px\n}\n\n.step3 .confirmPassDiv {\n\twidth: 380px\n}\n\n.findPwdDiv .step4 .stepBtnDiv .stepFinishBtn {\n\tline-height: 40px;\n\twidth: 120px;\n\theight: 40px;\n\tbackground: #c7020b;\n\tborder: 1px solid #c7000b;\n\tborder-radius: 2px\n}\n\n.findPwdDiv .step4 .tip {\n\tfont-size: 12px;\n\tmargin-top: 12px;\n\tfont-family: PingFangSC,PingFangSC-Regular;\n\tfont-weight: 400;\n\tcolor: #252b3a;\n\tline-height: 18px\n}\n\n.dropdown {\n\tfont-size: 16px;\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder: 1px solid #ADB0B8;\n\twidth: 100%;\n\tborder-radius: 2px\n}\n\n.dropdown:focus {\n\tborder: 1px solid #5E7CE0\n}\n\n.dropbtn {\n\tcursor: pointer;\n\theight: 40px;\n\tline-height: 40px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between\n}\n\n.dropbtn .dropbtn-txt {\n\tpadding-left: 10px\n}\n\n.dropbtn .dropbtn-arrow {\n\tpadding-right: 10px;\n\tfont-size: 12px\n}\n\n.dropdown-content {\n\tposition: absolute;\n\tleft: -1px;\n\tbackground-color: #FFF;\n    width: 100%;\n    max-height: 200px;\n    overflow: auto;\n\tborder-left: 1px solid #5E7CE0;\n\tborder-right: 1px solid #5E7CE0;\n\tborder-bottom: 1px solid #5E7CE0;\n\tz-index: 2\n}\n\n.dropdown-content div {\n\theight: 40px;\n\tline-height: 40px;\n\tcolor: #252B3A;\n\tpadding-left: 10px;\n\twidth: calc(100% - 10px);\n\tdisplay: block\n}\n\n.dropdown-content div:hover {\n\tcolor: #FFF;\n\tbackground-color: #5E7CE0\n}\n\n.dropdown-content .dropdown-splitline {\n\twidth: calc(100% - 10px);\n\theight: 1px;\n\tbackground-color: #DFE1E6\n}\n\n.fpwdErrorMsg {\n\tline-height: 12px;\n\tfont-size: 12px;\n\tmargin-top: 4px;\n\tcolor: #FA2A2D\n}\n\n.fpwdErrorMsg img {\n\twidth: 12px;\n\tvertical-align: bottom\n}\n\n.formDiv {\n\twidth: 380px\n}\n\n.authVerifyCode {\n\tdisplay: flex;\n\tjustify-content: space-between\n}\n\n.authVerifyCode .iam-input-text {\n\tflex: 1\n}\n\n@media(max-width:1220px) {\n\t#content,body,html {\n\t\tmin-width: 0\n\t}\n\n\t.findPwdDiv {\n\t\twidth: 100%;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0\n\t}\n}\n\n@media(max-width:500px) {\n\t#content {\n\t\tbackground: 0 0!important;\n\t\tmin-height: 0\n\t}\n\n\t.iam-ti-tooltip {\n\t\tdisplay: none!important\n\t}\n\n\t.findPwdDiv {\n\t\twidth: calc(100% - 30px);\n\t\tmargin-top: 0;\n\t\tbox-shadow: none\n\t}\n\n\t.iam-input-text {\n\t\tborder-bottom: 1px solid rgba(0,0,0,.2)\n\t}\n\n\t.iam-input-text,.iam-input-text:focus {\n\t\tborder-top-width: 0;\n\t\tborder-left-width: 0;\n\t\tborder-right-width: 0;\n\t\t-webkit-box-shadow: 0 0 0 0 #f6f6f6 inset;\n\t\tbox-shadow: 0 0 0 0 #f6f6f6 inset;\n\t\tborder-radius: 0!important;\n\t\tpadding: 2px\n\t}\n\n\t.iam-input-text::placeholder {\n\t\tcolor: rgba(24,24,26,.6)\n\t}\n\n\t.verifyCodeContainer #verifyCode {\n\t\tborder-bottom: 1px solid #c3c3c3\n\t}\n\n\t.formDiv .verifyCodeContainer #verifyCode.verifyCodeFocused {\n\t\tborder-bottom-color: #000\n\t}\n\n\t.verifyCodeContainer #verifyCode input {\n\t\tborder-width: 0\n\t}\n\n\t.findPwdDiv .phoneField {\n\t\tflex-direction: column\n\t}\n\n\t.findPwdDiv .phoneInput {\n\t\tborder-width: 0 0 1px;\n\t\twidth: 100%\n\t}\n\n\t.findPwdDiv .phoneInput input {\n\t\tpadding: 2px\n\t}\n\n\t.findPwdDiv .iam-phoneInput-error {\n\t\tborder-width: 0 0 1px;\n\t\tbackground-color: #fff\n\t}\n\n\t.formDiv {\n\t\twidth: 100%\n\t}\n\n\t.iam-input-error {\n\t\tbackground-color: #fff\n\t}\n\n\t.dropdown {\n\t\tborder-width: 0 0 1px;\n\t\tborder-radius: 0\n\t}\n\n\t.dropdown:focus {\n\t\tborder-top: none;\n\t\tborder-left: none;\n\t\tborder-right: none;\n\t\tborder-bottom: 1px solid #c3c3c3\n\t}\n\n\t.dropbtn .dropbtn-txt {\n\t\tpadding-left: 2px\n\t}\n\n\t.h5-dropdown-container {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 1;\n\t\tbackground-color: rgba(0,0,0,.2);\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse\n\t}\n\n\t.h5-dropdown-content {\n\t\twidth: calc(100% - 70px);\n\t\tmargin: 0 15px 15px;\n\t\tpadding: 20px;\n\t\tbackground-color: #fff;\n        border-radius: 16px;\n        max-height: 350px;\n        overflow: auto;\n\t}\n\n\t.findPwdDiv .stepBtnDiv,.findPwdDiv .stepBtnDiv .stepNextBtn {\n\t\twidth: 100%\n\t}\n\n\t.h5-dropdown-title {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t\theight: 58px;\n\t\tfont-weight: 600\n\t}\n\n\t.h5-option-div {\n\t\tdisplay: flex;\n\t\theight: 48px;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #ADB0B8\n\t}\n\n\t.h5-option-name {\n\t\tfont-size: 16px\n\t}\n\n\t.h5-option-button {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tborder: 1px solid #526ECC;\n\t\tvertical-align: middle;\n\t\tborder-radius: 50%\n\t}\n\n\t.h5-option-button-checked {\n\t\tpadding: 5px;\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tbackground-color: #526ECC;\n\t\tbackground-clip: content-box\n\t}\n\n\t.h5-dropdown-cancel {\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\tline-height: 22px;\n\t\tmargin-top: 36px;\n\t\tcolor: #526ECC\n\t}\n\n\t.findPwdDiv .contactService {\n\t\twidth: 100%\n\t}\n\n\t.findPwdDiv .authMethodList {\n\t\ttext-align: center\n\t}\n\n\t.authVerifyCode {\n\t\tborder-bottom: 1px solid rgba(0,0,0,.2)\n\t}\n\n\t.authVerifyCode .iam-input-text {\n\t\twidth: 50%;\n\t\tborder-bottom: none\n\t}\n\n\t.findPwdDiv .authVerifyCode .sendVerifyCode {\n\t\tcolor: rgba(94,124,224);\n\t\tborder: none\n\t}\n\n\t.findPwdDiv .authVerifyCode .retrieveVerifyCode {\n\t\tcolor: rgba(94,124,224,.38);\n\t\tborder: none\n\t}\n\n\t.step3 .newPassDiv {\n\t\twidth: 100%;\n\t\tmargin-bottom: 12px\n\t}\n\n\t.step3 .confirmPassDiv {\n\t\twidth: 100%\n\t}\n\n\t.tootip-div {\n\t\tcolor: rgba(96,97,98,1);\n\t\tmargin: 0\n\t}\n\n\t.strengthLowCircle {\n\t\twidth: 0;\n\t\theight: 0\n\t}\n\n\t.h5PasswordMsg {\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 10px;\n\t\tfont-size: 16px;\n\t\tline-height: 21px;\n\t\tcolor: rgba(0,0,0,1)\n\t}\n\n\t.safetyDegreeDiv {\n\t\tflex-wrap: wrap;\n\t\theight: auto\n\t}\n\n\t.safetyDegree {\n\t\twidth: 100%;\n\t\tmargin-top: 17px;\n\t\tfont-size: 14px;\n\t\tcolor: rgba(0,0,0,1)\n\t}\n\n\t#strengthflag {\n\t\tfont-size: 12px;\n\t\tline-height: 18px;\n\t\theight: 18px\n\t}\n\n\t.step3 .stepBtnDiv {\n\t\tmargin-top: 32px\n\t}\n\n\t.passwordStrength {\n\t\twidth: 100px\n\t}\n\n\t.findPwdDiv .step4 .stepBtnDiv .stepFinishBtn {\n\t\twidth: 100%\n\t}\n\n\t.findPwdDiv .resultDiv .msg {\n\t\tfont-size: 18px;\n\t\tline-height: 26px;\n\t\tcolor: rgba(37,43,58,1)\n\t}\n\n\t.findPwdDiv .resultDiv .image {\n\t\twidth: 60px;\n\t\theight: 60px\n\t}\n\n\t.step2Content {\n\t\twidth: 100%\n\t}\n\n\t.authVerifyCodeFocused {\n\t\tborder-bottom-color: rgba(0,0,0,1)\n\t}\n\t#inputVerifyCodeImg{\n\t\theight: 32px;\n\t\tmargin-right: 8px;\n\t\tmargin-bottom: 8px;\n\t}\n}\n\n#fpwd-graphics-verify-mask {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n}\n\n#fpwd-graphics-verify {\n    width: 400px;\n    max-width: 100vw;\n    position: fixed;\n    top: calc(50% - 200px);\n    left: calc(50% - 200px);\n    background: white;\n    box-shadow: 0 8px 16px 0 rgb(0 0 0 / 10%);\n    box-sizing: border-box;\n}\n\n@media(max-width:500px) {\n    #fpwd-graphics-verify {\n\tleft: 0;\n    }\n}\n\n#fpwd-graphics-verify .modal-header {\n    background-color: #444;\n    color: #fff;\n    padding: 14px 20px;\n    display: flex;\n    align-items: center;\n}\n\n#fpwd-graphics-verify .modal-header .header-title {\n    flex: 1;\n}\n\n#fpwd-graphics-verify .modal-header .header-icon {\n    background: url(" + escape(__webpack_require__(322)) + ");\n    height: 10px;\n    width: 10px;\n    cursor: pointer;\n}\n\n#fpwd-graphics-verify .modal-body {\n    padding: 20px;\n}\n\n#fpwd-graphics-verify .modal-body .verifycode-row {\n    display: flex;\n    align-items: center;\n}\n\n#fpwd-graphics-verify .modal-body .verifycode-row .iam-input-text {\n    width: 160px;\n    height: 30px;\n}\n\n#fpwd-graphics-verify .modal-body .verifycode-row .verifycode-img {\n    height: 30px;\n    margin-left: 8px;\n    cursor: pointer;\n}\n\n#fpwd-graphics-verify .modal-body .verifycode-row .status-img {\n    margin-left: 8px;\n}\n\n#fpwd-graphics-verify .modal-footer .footer-buttons {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}", ""]);

// exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ":focus{\n\toutline: none;\n}\n\n.iam-input-text,.iam-name-tooltip {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box\n}\n\n#hwidsdk_mudule_container {\n\twidth: 100%\n}\n\n.iam-input-text {\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 4px;\n\tborder: 1px solid #c3c3c3;\n\tcolor: #666;\n\tbackground-color: #fff;\n\tpadding: 2px 16px;\n\tbox-sizing: border-box;\n\toutline: 0;\n\tvertical-align: middle\n}\n\n.iam-input-text:focus {\n\tborder: 1px solid #000\n}\n\ninput:disabled {\n\tbackground-color: #CCC;\n\tbox-shadow: none\n}\n\n.iam-input-text::-ms-clear,.iam-input-text::-ms-reveal {\n\tdisplay: none\n}\n\n#loading {\n\tdisplay: none\n}\n\n#content .widthLimit {\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center\n}\n\n\n\n#loginAdv {\n\twidth: 800px;\n\theight: 515px;\n\tmargin-top: 80px;\n}\n\n#loginForm {\n\twidth: 376px;\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: #fff;\n\tborder-radius: 4px;\n\tflex-direction: column;\n\tpadding: 32px 44px\n}\n\n#loginForm .loginFormDiv {\n\twidth: 100%\n}\n\n#loginForm .loginTypeDiv {\n\tfont-size: 24px;\n\tfont-weight: 400;\n\tline-height: 32px;\n\tmargin-bottom: 32px\n}\n\n#loginForm .loginFormDiv .inputField {\n\tmargin-bottom: 24px\n}\n\n#loginForm .loginFormDiv .pwdInputField {\n\tposition: relative\n}\n\n.pwdShowimg {\n\ttop: 10px;\n\tright: 10px;\n\twidth: 32px;\n\theight: 32px;\n\tposition: absolute\n}\n\n.iam-icon-action-state-invisible {\n\tbackground-image: url(" + escape(__webpack_require__(101)) + ");\n\tbackground-size: 32px 32px;\n\tbackground-repeat: no-repeat\n}\n\n.iam-icon-action-state-visible {\n\tbackground-image: url(" + escape(__webpack_require__(102)) + ");\n\tbackground-size: 32px 32px;\n\tbackground-repeat: no-repeat\n}\n\n.buttonAreaDiv {\n\tmargin-top: 8px;\n\twidth: 100%\n}\n\n.loginBtn {\n\tbackground-color: #C7020B;\n\tborder-radius: 4px;\n\tcolor: #fff;\n\tcursor: default;\n\twidth: 100%\n}\n\n.loginBtn:active,.loginBtn:focus,.loginBtn:hover {\n\tcursor: pointer;\n\tbox-shadow: 0 8px 16px rgba(246,111,106,.3);\n\toutline: 0\n}\n\n.loginBtn:hover {\n\tbackground: #D64A52\n}\n\n.loginBtn:active,.loginBtn:focus {\n\tbackground: #B12220\n}\n\n.loginBtn span,.loginBtnDisabled span {\n\tvertical-align: middle;\n\ttext-align: center;\n\tfont-size: 14px!important;\n\theight: 48px;\n\tmargin: 0 auto;\n\tdisplay: block;\n\tline-height: 48px\n}\n\n.loginBtnDisabled {\n\tbackground-color: rgba(199,2,11,.3);\n\tborder-radius: 4px;\n\tcolor: #fff;\n\tfont-size: 18px!important;\n\tcursor: default;\n\twidth: 100%;\n}\n\n.loginBtnDisabled:active,.loginBtnDisabled:focus,.loginBtnDisabled:hover {\n\tbackground-color: rgba(199,2,11,.3);\n\tbox-shadow: none\n}\n\n#bottomBtns {\n\tmargin-top: 32px;\n\tmargin-bottom: 40px;\n\tfont-size: 14px;\n\tcolor: #252B3A;\n\tdisplay: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n}\n\n#bottomBtns .forgetPwdLink:hover,.closeImg,.learnMoreLink {\n\tcolor: #526ECC;\n\tcursor: pointer\n}\n\n.learnMoreLink {\n\tcursor: pointer;\n\ttext-decoration: underline\n}\n\n#bottomBtns .forgetPwdLink,.otherLoginWays {\n\tcolor: rgba(0,0,0,.5)\n}\n\n.otherLoginWays .otherItemDiv:hover {\n\tcursor: pointer;\n\topacity: 1;\n\tcolor: #526ECC\n}\n\n#quickLoginDiv .otherLoginWays,\n#hwLoginDivId .otherLoginWays{\n\twidth: 100%;\n\tmargin-top: 32px;\n}\n\n#quickLoginDiv .otherLoginWays .otherLoginTip span,\n#hwLoginDivId .otherLoginWays .otherLoginTip span {\n\tbackground-color: #fff;\n\tpadding: 0 12px;\n\tposition: relative\n}\n\n.intervalDiv{\n\tcolor: #DDD;\n}\n\n.hwInterval{\n    margin: 0 6px;\n}\n\n#quickLoginDiv .otherLoginWays .otherLoginTip,\n#hwLoginDivId .otherLoginWays .otherLoginTip {\n\twidth: 100%;\n\ttext-align: center;\n\tposition: relative;\n\tline-height: 1;\n\tmargin-bottom: 12px;\n\tdisplay: block\n}\n\n#quickLoginDiv .otherLoginWays .otherLoginTip:before,\n#hwLoginDivId .otherLoginWays .otherLoginTip:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 50%;\n\tdisplay: block;\n\twidth: 100%;\n\tborder-top: 1px solid #DDD\n}\n\n#hwLoginDivId .otherLoginWays.forMobile{\n    display: none ;\n}\n\n.privacyMsg span {\n\tcolor: #000;\n\topacity: .5\n}\n\n.errorMsgDiv {\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tpadding-top: 12px;\n\tpadding-bottom: 12px;\n\twidth: 100%;\n\tmargin-bottom: 24px;\n\tbackground-color: #FFEEED;\n\tborder: 1px solid #C7020B;\n\tborder-radius: 4px\n}\n\n.errorMsgDiv img {\n\twidth: 18px;\n\theight: 18px;\n\tmargin: 1px 8px 0 16px\n}\n\n.errorMsgDiv .msgDiv {\n\tmargin-right: 16px\n}\n\n.errorMsgDiv .msgDiv .msgContent {\n\tword-break: break-word\n}\n\n#verifyCode {\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center\n}\n\n#inputVerifyCodeImg {\n\theight: 40px\n}\n\n#validresultImg {\n\ttop: 16px;\n\tright: 14px;\n\tposition: absolute\n}\n\n.iam-name-tooltip {\n\tdisplay: none;\n\tposition: absolute;\n\tbackground-color: #fff;\n\tcolor: #000;\n\tpadding: 24px 15px;\n\tbox-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n\tborder-radius: 4px;\n\t-ms-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tz-index: 5000;\n\twhite-space: normal;\n\tword-wrap: break-word\n}\n\n.iam-name-tooltip a,.iam-name-tooltip a:hover {\n\tcolor: #526ECC\n}\n\n#hwLoginDivId,.hwLoginDivMask {\n\twidth: 376px;\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: #fff;\n\tborder-radius: 4px;\n\tflex-direction: column;\n\tpadding: 32px 44px\n}\n\n.hwLoginDivMask {\n\theight: calc(100% - 130px)\n}\n\n.iam-input-error {\n\tborder-color: #FA2A2D;\n\tbackground-color: #FFEEED\n}\n\n.loginErrorMsg {\n\tline-height: 12px;\n\tfont-size: 12px;\n\tmargin-top: 4px;\n\tcolor: #FA2A2D\n}\n\n.loginErrorMsg img {\n\twidth: 12px;\n\tvertical-align: bottom\n}\n\n.verifyCodeContainer {\n\twidth: 100%;\n\tmargin-bottom: 24px\n}\n\n.privacyMsg {\n\tmargin-top: 22px;\n\twidth: 100%;\n    font-size: 12px;\n}\n\n.privacyMsgLink {\n\tcolor: #526ECC\n}\n\n.privacyMsgLink:hover {\n\ttext-decoration: none;\n\tcolor: #526ECC\n}\n\n#hwLoginDivId .hwid-root {\n\twidth: 100%\n}\n\n#hwLoginDivId .hwid-root .hwid-login-root.hwid-login-root-iframe .hwid-common-content {\n\tmin-height: 0\n}\n\n#hwLoginDivId>div.hwid-root>div>div:nth-child(1)>div>div:nth-child(2)>div.hwid-common-content>div.hwid-header-tab {\n\tpadding-top: 48px\n}\n\n#hwLoginDivId .hwid-root .hwid-login-root.hwid-login-root-iframe .hwid-login-container {\n\theight: auto\n}\n\n.hwLoginDivMask .loadingImg {\n\tmargin: auto\n}\n\n.inputClearIcon {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: 16px;\n\tright: 16px;\n\twidth: 16px;\n\theight: 16px;\n\tbackground-image: url(" + escape(__webpack_require__(94)) + ");\n\tbackground-size: 16px 16px;\n\tcursor: pointer\n}\n\n.inputClearIcon:hover,input:focus+.inputClearIcon {\n\tdisplay: block\n}\n\n.loginDiv {\n\tmargin-top: 80px;\n\tbackground: #fff;\n\tborder-radius: 4px\n}\n\n.QRLoginSwitchDiv {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: space-around;\n\theight: 65px;\n\tborder-bottom: 1px solid #DFE1E6;\n\tfont-size: 18px;\n\tcolor: rgba(0,0,0,.5);\n\tcursor: pointer\n}\n\n.QRLoginSwitchDiv .QRLogin,.QRLoginSwitchDiv .accountLogin {\n\tflex-grow: 1;\n\ttext-align: center;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center\n}\n\n.QRLoginSwitchDiv .QRLogin div,.QRLoginSwitchDiv .accountLogin div {\n\theight: calc(100% - 5px);\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 3px solid transparent;\n\tborder-top: 3px solid transparent\n}\n\n.QRLoginSwitchDiv .intervalDiv {\n\theight: 20px;\n\tborder-right: 1px solid #DFE1E6\n}\n\n.QRLoginSwitchDiv div.selectedType {\n\tborder-bottom: 3px solid #252B3A;\n\tcolor: #252B3A\n}\n\n#QRLoginDiv {\n\tbackground-color: #fff;\n\tcolor: #DFE1E6;\n\tfont-size: 14px;\n\tborder-color: rgba(228,228,228,1);\n\tborder-radius: 4px;\n\tdisplay: flex;\n\twidth: 376px;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding-left: 44px;\n\tpadding-right: 44px;\n\theight: 90%;\n}\n\n.loginQRCodeDiv {\n\twidth: 260px;\n\tpadding: 20px\n}\n\n.QRCodeOuter {\n\tposition: relative;\n\theight: 300px;\n\twidth: 300px;\n\tmargin: 32px auto 0;\n\ttext-align: center;\n\tborder: 0 solid #DFE1E6;\n\tbackground: url(" + escape(__webpack_require__(32)) + ");\n\tbackground-size: cover\n}\n\n.QRCodeInner {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tcolor: #FFF;\n\theight: 300px;\n\twidth: 300px;\n\tbackground: rgba(7,7,7,.6)\n}\n\n#countDownDiv {\n\ttext-align: center;\n\tcolor: #252B3A;\n\tfont-size: 14px;\n\tmargin-top: 50px;\n\theight: 20px\n}\n\n.remainingTimeTxt {\n\tcolor: #F66F6A\n}\n\n#QRLoginBottomDiv {\n\theight: 14px;\n\tline-height: 14px;\n\tfont-size: 14px;\n\tmargin-bottom: 50px;\n\tmargin-top: 34px;\n}\n\n#QRLoginBottomDiv .intervalDiv {\n\tdisplay: inline;\n\tmargin: 0 10px\n}\n\n.QRLoginBottomColor {\n\tfont-size: 14px;\n\tcolor: rgba(0,0,0,.5)\n}\n\n.QRLoginBottomColor:active,.QRLoginBottomColor:focus,.QRLoginBottomColor:hover {\n\tcolor: #526ECC;\n\ttext-decoration: none\n}\n\n.QRCodeInvalid {\n\tfont-size: 16px;\n\ttext-align: center;\n\tmargin-bottom: 10px;\n\tmargin-top: 110px\n}\n\n#refreshQRCodeBtn {\n\twidth: 92px;\n\tmargin: 0 auto;\n\theight: 40px\n}\n\n#refreshQRCodeBtn span {\n\tline-height: 40px\n}\n\n.loginStatusDiv {\n\ttext-align: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 1\n}\n\n.loginStatusImg {\n\theight: 64px;\n\twidth: 64px;\n\tmargin-bottom: 32px\n}\n\n.loginStatusTitle {\n\tcolor: #252B3A;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin-bottom: 12px;\n\tline-height: 26px\n}\n\n.loginStatusMessage {\n\tcolor: #575D6C;\n\tfont-size: 14px;\n\tline-height: 18px\n}\n\n.loginStatusMessage a {\n\tcolor: #526ECC\n}\n\n#quickLoginDiv {\n\twidth: 376px;\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: #fff;\n\tborder-radius: 4px;\n\tflex-direction: column;\n\tpadding: 32px 44px;\n\tcolor: rgba(0,0,0,.5);\n\theight: auto;\n}\n\n#quickLoginDiv .loginTypeDiv {\n\tfont-size: 24px;\n\tfont-weight: 400;\n\tline-height: 32px;\n\tmargin-bottom: 24px;\n\tmargin-top: 16px;\n\tcolor: rgba(51,51,51,1);\n}\n\n#quickLoginDiv .quickLoginForm {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n}\n\n#quickLoginDiv .loginTip{\n\tfont-size: 14px;\n\tfont-weight: 400;\n\twidth: 100%;\n}\n\n#quickLoginDiv .inputField{\n\twidth: 100%;\n\tmargin-top: 24px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder: 1px solid #c3c3c3;\n\tborder-radius: 4px;\n\tposition: relative;\n}\n\n#quickLoginDiv .inputField .iam-input-text{\n\tflex: 1;\n}\n\n#quickLoginDiv .quickLoginCode{\n\tborder: 1px solid #c3c3c3;\n\tborder-radius: 4px;\n\theight: 48px;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: 24px;\n}\n\n#quickLoginDiv .iam-input-text{\n\tborder: none;\n\twidth: unset;\n\tflex: 1;\n}\n\n#quickLoginDiv .quickLoginCode .quickLoginCodeBtn{\n\tfont-size: 14px;\n\tcolor: rgba(82,110,204,1);\n\tmargin-right: 16px;\n\tcursor: pointer;\n}\n\n#quickLoginDiv .quickLoginCode .quickLoginCodeBtnDisabled{\n\tcolor: rgba(82,110,204,0.5);\n\tcursor: not-allowed;\n}\n\n#quickLoginDiv .quickLoginCodeFocused, #quickLoginDiv .inputFieldFocused{\n\tborder: 1px solid #000;\n}\n\n#quickLoginDiv .quickLoginType{\n\twidth: 100%;\n\tmargin-top: 24px;\n}\n\n#quickLoginDiv .quickLoginType span{\n\tcursor: pointer;\n\tfont-size: 14px;\n\tcolor: #526ecc;\n\tline-height: 18px;\n}\n\n#quickLoginDiv #quickLoginBtn{\n\tmargin-top: 24px;\n}\n\n#quickLoginDiv .selectUsersTitle{\n\tfont-size: 24px;\n\tfont-weight: 400;\n\tcolor: #333333;\n\tline-height: 32px;\n\tmargin-top: 16px;\n}\n\n#quickLoginDiv .selectUsers{\n\twidth: 100%;\n}\n\n#quickLoginDiv .userOptionsContainer{\n\tborder: 1px solid #cccccc;\n\tborder-radius: 4px;\n\tmax-height: 120px;\n\toverflow: auto;\n\tmargin-top: 24px;\n\tmargin-bottom: 32px\n}\n#quickLoginDiv .userOptionDiv{\n\theight: 40px;\n\tline-height: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n#quickLoginDiv .userOptionDiv:hover{\n\tbackground: #e6e6e6;\n}\n#quickLoginDiv .quickLoginError{\n\twidth: 100%;\n}\n.option-label{\n\theight: 18px;\n\tline-height: 18px;\n\tfont-size: 14px;\n\tcolor: #000000;\n\tmargin-left: 15px;\n}\n\n.option-button {\n    width: 18px;\n    height: 18px;\n    background: url(" + escape(__webpack_require__(103)) + ");\n\tbackground-size: cover;\n\tmargin-right: 15px;\n}\n\n.option-button-checked {\n    background: url(" + escape(__webpack_require__(104)) + ");\n}\n\n.right-arrow {\n    display: inline-block;\n    position: relative;\n    width: 15px;\n\theight: 10px;\n\tmargin-left: 10px;\n\tcursor: pointer;\n}\n\n.right-arrow::after {\n    display: inline-block;\n    content: \" \";\n    height: 12px;\n    width: 12px;\n    border-width: 0px 0px 1px 1px;\n    border-color: rgba(0,0,0,1);\n    border-style: solid;\n    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    margin-top: -9px;\n}\n\n#quickLoginDiv .inputField .input-icon-right{\n\tdisplay: flex;\n\tmargin-right: 20px;\n}\n\n#quickLoginDiv .inputField .icon-clear {\n\tdisplay: none;\n\twidth: 16px;\n\theight: 16px;\n\tbackground-image: url(" + escape(__webpack_require__(94)) + ");\n\tbackground-size: 16px 16px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n}\n\n#quickLoginDiv .inputField .icon-clear:hover, #quickLoginDiv .inputFieldFocused .icon-clear {\n\tdisplay: block;\n}\n\n#quickLoginDiv .users-dropdown{\n\tbackground-color: rgba(255,255,255,1);\n\tposition: absolute;\n\ttop: 50px;\n\tleft: -1px;\n\twidth: 101%;\n\tbox-shadow: 0px 2px 8px 0px rgba(0,0,0,0.10); \n}\n\n#quickLoginDiv .users-dropdown-option {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tfont-size: 14px;\n\theight: 40px;\n\tline-height: 40px;\n}\n\n#quickLoginDiv .users-dropdown-option:hover{\n\tbackground: #e6e6e6;\n}\n\n#quickLoginDiv .iam-input-error {\n\tborder-color: #FA2A2D;\n\tbackground-color: #FFEEED\n}\n\n#quickLoginDiv .iam-input-error .iam-input-text{\n\tbackground-color: #FFEEED\n}\n\n#quickLoginDiv .registerDiv{\n\tmargin-top: 32px;\n}\n\n#quickLoginDiv .registerDiv:hover {\n\tcursor: pointer;\n\topacity: 1;\n\tcolor: #526ECC\n}\n\n.otherLoginWays{\n\tmax-width: 100%;\n}\n\n.option-state-checked {\n    width: 18px;\n    height: 18px;\n    background: url(" + escape(__webpack_require__(328)) + ");\n\tbackground-size: cover;\n\tmargin-right: 15px;\n}\n\n.icon-downward {\n\twidth: 16px;\n\theight: 16px;\n\tbackground-image: url(" + escape(__webpack_require__(320)) + ");\n\tbackground-size: 16px 16px;\n\tbackground-position: center;\n\tmargin-left: 20px;\n}\n\n.icon-packup {\n\twidth: 16px;\n\theight: 16px;\n\tbackground-image: url(" + escape(__webpack_require__(338)) + ");\n\tbackground-size: 16px 16px;\n\tbackground-position: center;\n\tmargin-left: 20px;\n}\n\n#idp-login-container {\n    width: 376px;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    background: #fff;\n    border-radius: 4px;\n    flex-direction: column;\n    padding: 32px 44px;\n}\n\n#idp-login-container .idp-login-title{\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 32px;\n}\n\n#idp-login-container .idp-account-container{\n    margin-top: 32px;\n}\n\n#idp-login-container .idp-dropdown-container{\n    margin-top: 24px;\n}\n\n#idp-login-container .inputField{\n    width: 100%;\n}\n\n#idp-login-container #idpLoginBtn{\n    margin-top: 24px;\n}\n\n#idp-login-container .idp-dropdown-container{\n\tcolor: #666;\n}\n\n#idp-login-container .otherLoginWaysContainer{\n\tmargin-top: 42%;\n}\n\n.dropdown {\n\tfont-size: 14px;\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder: 1px solid #ADB0B8;\n\twidth: calc(100% - 2px);\n\tborder-radius: 4px;\n}\n\n.dropdown:focus {\n\tborder: 1px solid #000000\n}\n\n.dropbtn {\n\tcursor: pointer;\n\theight: 48px;\n\tline-height: 48px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between\n}\n\n.dropbtn .dropbtn-txt {\n\tpadding-left: 10px;\n\toverflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.dropbtn .dropbtn-arrow {\n\tpadding-right: 10px;\n\tfont-size: 12px\n}\n\n.dropbtn .dropbtn-arrow img{\n    width: 16px;\n}\n\n.dropdown-content {\n\tposition: absolute;\n\tleft: -1px;\n\tbackground-color: #FFF;\n    width: 100%;\n    max-height: 200px;\n    overflow: auto;\n\tborder-left: 1px solid #CCCCCC;\n\tborder-right: 1px solid #CCCCCC;\n\tborder-bottom: 1px solid #CCCCCC;\n\tz-index: 2\n}\n\n.dropdown-content div {\n\theight: 40px;\n\tline-height: 40px;\n\tcolor: #666;\n\tpadding-left: 10px;\n\twidth: calc(100% - 10px);\n\tdisplay: block;\n\tcursor: pointer;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.dropdown-content div:hover {\n\tbackground-color: rgba(199,0,11,.05);\n\tcolor: #c7000b;\n}\n\n.dropdown-content .dropdown-splitline {\n\twidth: calc(100% - 10px);\n\theight: 1px;\n\tbackground-color: #DFE1E6\n}\n\n.dropdown-content .dropdown-option-selected{\n    background-color: #f66f6a !important;\n    color: rgb(255, 255, 255) !important;\n\tdisplay: flex;\n\talign-items: center;\n    justify-content: space-between;\n}\n\n.dropdown-content .dropdown-option-selected img{\n\theight: 16px;\n    margin-right: 16px;\n}\n\n.dropdown-disable:focus{\n    border: 1px solid #ADB0B8;\n}\n\n.dropdown-disable{\n\tbackground-color: #f3f3f3;\n}\n\n.dropdown-disable .dropbtn-txt{\n    color: #999;\n}\n\n#idpCheckArea{\n    margin-top: 24px;\n    width: 100%;\n    text-align: right;\n    color: rgba(0,0,0,.5);\n}\n#iamCheckArea{\n\talign-self: flex-end;\n\tcursor: pointer;\n\tcolor: rgba(0,0,0,.5);\n}\n.checkArea input{\n    display: none;\n}\n.checkArea label {\n    display: inline-block;\n    width: 15px;\n    height: 15px;\n    border-radius: 2px;\n    border: 1px solid #DFE1E6;\n    position: relative;\n    cursor: pointer;\n    margin-bottom: -3px;\n    margin-right: 8px;\n}\n.checkArea label::before {\n    display: inline-block;\n    content: \" \";\n    width: 7px;\n    border: 2px solid #fff;\n    height: 4px;\n    border-top: none;\n    border-right: none;\n    transform: rotate(-45deg);\n    top: 3px;\n    left: 3px;\n    position: absolute;\n    opacity: 0;\n}\n.checkArea input:checked+label {\n    background: #526ECC;\n\tborder: 1px solid #526ECC;\n}\n.checkArea input:checked+label::before{\n    opacity: 1;\n    transform: all 0.5s;\n}\n\n\n@media (max-width:1269px) {\n\n    .loginDiv{\n        margin-top: 40px;\n    }\n\n\t#loginAdv {\n\t\tmargin-top: 40px;\n\t\tmax-width: 352px\n\t}\n}\n\n@media (max-width:1100px) {\n\t#content,body,html {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tmin-width: 0\n\t}\n}\n\n@media (max-width:768px) {\n\t#loginAdv,.QRLoginSwitchDiv {\n\t\tdisplay: none\n\t}\n\n\t#content {\n\t\tbackground: 0 0!important;\n\t}\n\n\t#content .widthLimit {\n\t\twidth: 100%;\n\t\tmax-width: 500px;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto\n\t}\n\n\t#loginForm {\n\t\twidth: 100%;\n\t\tmargin-top: 20px;\n\t\tbox-shadow: none\n\t}\n\n\t#hwLoginDivId,.hwLoginDivMask {\n\t\tmargin-top: 20px;\n\t\tpadding-bottom: 64px\n\t}\n}\n\n@media(max-height: 770px) {\n    #loginAdv{\n        margin-top: 40px;\n    }\n    .loginDiv{\n        margin-top: 40px;\n    } \n\t\n}\n@media(max-height: 700px){\n\tbody{\n\t\tdisplay: block;\n\t}\n}\n\n\n@media(max-width:500px) {\n\n    .loginDiv{\n        margin-top: 0px;\n        width: 100%;\n    }\n\n\t#loginForm,.hwLoginDivMask {\n\t\twidth: 100%;\n\t\tpadding: 0;\n\t\theight: 100%\n\t}\n\n\t#hwLoginDivId .hwid-root,#loginForm {\n\t\tmargin-top: 0\n\t}\n\n\t.hwLoginDivMask {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tmargin: 0;\n\t\tz-index: 10000\n\t}\n\n\t#loginAdv,#loginForm .otherLoginWays .otherLoginTip {\n\t\tdisplay: none\n\t}\n\n\t#content,body,html {\n\t\theight: 100%;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tmin-width: 0\n\t}\n\n\t#loginForm .loginTypeDiv {\n\t\tmargin-top: 40px\n\t}\n\n\t.errorMsgDiv {\n\t\tjustify-content: center;\n\t\tbackground-color: #fff;\n\t\tborder: 0 solid #C7020B;\n\t\tcolor: #FA2A2D;\n\t\tmargin-bottom: 0\n\t}\n\n\t.iam-input-text {\n\t\tborder-bottom: 1px solid rgba(0,0,0,.2)\n\t}\n\n\t.iam-input-text,.iam-input-text:focus {\n\t\tborder-top-width: 0;\n\t\tborder-left-width: 0;\n\t\tborder-right-width: 0;\n\t\t-webkit-box-shadow: 0 0 0 0 #f6f6f6 inset;\n\t\tbox-shadow: 0 0 0 0 #f6f6f6 inset;\n\t\tborder-radius: 0;\n\t\tpadding: 2px\n\t}\n\n\t.iam-input-text::placeholder {\n\t\tcolor: rgba(24,24,26,.6)\n\t}\n\n\t.inputField .iam-input-text {\n\t\tborder-radius: 0\n\t}\n\n\t#footer {\n\t\tbackground-color: #eeefef\n\t}\n\n\t.iam-name-tooltip {\n\t\tpadding: 2px 0 0 2px;\n\t\tbox-shadow: 0 0 0 0 rgba(0,0,0,.2);\n\t\tborder-radius: 0;\n\t\tposition: unset;\n\t\tcolor: rgba(96,97,98,1)\n\t}\n\n\t.verifyCodeContainer #verifyCode {\n\t\tborder-bottom: 1px solid #c3c3c3;\n\t\twidth: calc(100% - 30px)\n\t}\n\n\t#loginForm .verifyCodeContainer .verifyCodeFocused {\n\t\tborder-bottom-color: #000\n\t}\n\n\t.verifyCodeContainer #verifyCode input {\n\t\tborder-width: 0\n\t}\n\n\t.pwdShowimg {\n\t\ttop: 16px;\n\t\twidth: 20px;\n\t\theight: 20px\n\t}\n\n\t.iam-icon-action-state-invisible {\n\t\tbackground-image: url(" + escape(__webpack_require__(339)) + ");\n\t\tbackground-size: 20px 20px\n\t}\n\n\t.iam-icon-action-state-visible {\n\t\tbackground-image: url(" + escape(__webpack_require__(340)) + ");\n\t\tbackground-size: 20px 20px\n\t}\n\n\t#loginForm .loginFormDiv .inputField {\n\t\tmargin-bottom: 12px\n\t}\n\n\t.H5ErrorMaskDiv {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground-color: #000;\n\t\tz-index: 1001;\n\t\t-moz-opacity: .7;\n\t\topacity: .7;\n\t\tfilter: alpha(opacity=70)\n\t}\n\n\t.H5ErrorDiv {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: calc(100% - 60px);\n\t\tpadding: 10px 20px;\n\t\tmargin: 10px;\n\t\tbackground-color: #fff;\n\t\tborder-radius: 10px;\n\t\tz-index: 1002;\n\t\toverflow: auto\n\t}\n\n\t#h5BottomBtns {\n\t\tmargin-bottom: 32px;\n\t\tmargin-top: 12px;\n\t\tmargin-left: 15px;\n\t\tfont-size: 14px;\n\t\twidth: 100%;\n\t\tcolor: #526ECC\n\t}\n\n\t#loginForm .otherLoginWays {\n\t\tcolor: #526ECC;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-end;\n\t\tflex: 1;\n\t\tmargin-top: 50px\n\t}\n\n\t#loginForm .otherLoginWays #hwAccountLinkDiv {\n\t\tmargin-bottom: 24px;\n\t\tmargin-top: 50px;\n\t\ttext-align: center\n\t}\n\n\t#hwLoginDivId {\n\t\tmargin-top: 40px;\n\t\tpadding: 0 15px;\n\t\twidth: auto;\n\t}\n\n\t#hwLoginDivId .otherLoginWays {\n\t\tmargin-top: 80px\n\t}\n\n\t.otherLoginWaysContainer .otherLoginWays .otherLoginTip,\n\t.otherLoginWays .otherLoginTip {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tposition: relative;\n\t\tline-height: 1;\n\t\tmargin-bottom: 12px;\n\t\tdisplay: block\n\t}\n\t.otherLoginWaysContainer .otherLoginWays .otherLoginTip:before,\n\t.otherLoginWays .otherLoginTip:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tborder-top: 1px solid #DDD\n\t}\n\n\t#loginForm .loginFormDiv,.buttonAreaDiv {\n\t\twidth: calc(100% - 30px);\n\t\tmargin-right: 15px;\n\t\tmargin-left: 15px\n\t}\n\n\t.otherLoginWaysContainer .otherLoginWays .otherLoginTip span,\n\t.otherLoginWays .otherLoginTip span {\n\t\tbackground-color: #fff;\n\t\tpadding: 0 7px;\n\t\tposition: relative\n\t}\n\n\t.otherLoginWaysContainer .otherLoginWays .otherLoginColor,\n\t.otherLoginWays .otherLoginColor {\n\t\tcolor: #526ECC\n\t}\n\n\t.privacyMsg {\n\t\tmargin-top: 22px;\n\t}\n\n\t.loginBtn span,.loginBtnDisabled span {\n\t\theight: 44px;\n\t\tline-height: 44px;\n\t\tfont-size: 16px!important\n\t}\n\n\t.intervalDiv {\n\t\tcolor: #DDD\n\t}\n\n\t#content .widthLimit {\n\t\theight: calc(101%);\n\t\toverflow-x: hidden\n\t}\n\n\t#h5BottomBtns .forgetPwdLink {\n\t\tmargin-left: 15px\n\t}\n\n\t#content:after {\n\t\tpadding-top: 0\n\t}\n\n\t#quickLoginDiv{\n\t\tpadding: 24px 16px;\n\t\twidth: auto;\n\t\theight: calc(100% - 158px);\n\t}\n\n\t#quickLoginDiv .quickLoginCode,\n\t#quickLoginDiv .inputField{\n\t\tborder-top: none;\n\t\tborder-left: none;\n\t\tborder-right: none;\n\t\tborder-radius: 0px;\n\t}\n\n\t.h5-dropdown-container {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 1;\n\t\tbackground-color: rgba(0,0,0,.2);\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse\n\t}\n\n\t.h5-dropdown-content {\n\t\twidth: calc(100% - 70px);\n\t\tmargin: 0 15px 15px;\n\t\tpadding: 20px;\n\t\tbackground-color: #fff;\n\t\tborder-radius: 16px\n\t}\n\t.h5-dropdown-title {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t\theight: 58px;\n\t\tfont-weight: 600\n\t}\n\n\t.h5-option-div {\n\t\tdisplay: flex;\n\t\theight: 48px;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #ADB0B8\n\t}\n\n\t.h5-option-name {\n\t\tfont-size: 16px;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n    \tmax-width: calc(100% - 30px);\n\t}\n\n\t.h5-option-button {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tborder: 1px solid #526ECC;\n\t\tvertical-align: middle;\n\t\tborder-radius: 50%\n\t}\n\n\t.h5-option-button-checked {\n\t\tpadding: 5px;\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tbackground-color: #526ECC;\n\t\tbackground-clip: content-box\n\t}\n\n\t.h5-dropdown-buttons{\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\n\t}\n\n\t.h5-dropdown-cancel {\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\tline-height: 22px;\n\t\tmargin-top: 36px;\n\t}\n\n\t.h5-dropdown-ok {\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\tline-height: 22px;\n\t\tmargin-top: 36px;\n\t\tcolor: #526ECC\n\t}\n\n\t#idp-login-container {\n\t\twidth: auto;\n\t\tpadding: 32px 16px;\n\t}\n\n\t#idp-login-container .dropdown {\n\t\tborder-width: 0 0 1px 0;\n\t\tborder-radius: 0;\n\t}\n\t#idp-login-container .dropbtn .dropbtn-txt{\n\t\tpadding-left: 1px;\n\t}\n\t#idp-login-container .dropbtn .dropbtn-arrow{\n\t\tpadding-right: 1px;\n\t}\n\n\t#idp-login-container .h5-dropdown-buttons{\n\t\tdisplay: flex;\n\t}\n\n\t#idp-login-container .otherLoginWaysContainer{\n\t\twidth: calc(100% - 32px);\n\t\tposition: fixed;\n\t\tbottom: 16px;\n\t}\n\n\t#idp-login-container .otherLoginWaysContainer .otherLoginWays{\n\t\tdisplay: flex;\n    \tflex-wrap: wrap;\n    \tjustify-content: space-around;\n\t}\n\t#bottomBtns{\n\t\twidth: calc(100% - 30px);\n\t}\n\n\t#bottomBtns .forgetPwdLink {\n\t\tcolor: #526ECC;\n\t} \n}\n\n\n\ninput,textarea {\n\t-webkit-appearance: none\n}\n\nbody,html {\n\t-webkit-text-size-adjust: 100%;\n\t-webkit-tap-highlight-color: transparent\n}\n", ""]);

// exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#hwLoginDivId .otherLoginWays {\n    width: 100%;\n    justify-content: space-around;\n}\n\n.privacyMsg{\n    margin-top: 70px;\n    margin-bottom: 0px;\n}", ""]);

// exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 隐藏遮罩 */\n#loading {\n\tdisplay: none\n}\n.module-error{\n\twidth: 932px;\n\tmargin: 80px auto 0;\n\tbackground-color: #fff;\n\tbox-shadow: 0 8px 16px 0 rgb(0 0 0 / 10%);\n\tpadding: 20px 30px 40px;\n}\n.dt-content{\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n}\n#ERROR_TIP{\n\tmargin-bottom: 32px;\n\tmargin-top: 20px;\n}\n\n.errorIcon {\n\tbackground-image: url(" + escape(__webpack_require__(312)) + ");\n\tbackground-size: 40px 40px;\n\twidth: 40px;\n\theight: 40px;\n\tmargin-top: 40px\n}\n\n.errorTitle {\n\tmargin-top: 16px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: #252b3a;\n\tline-height: 26px\n}\n\n.errorContent {\n\tmargin-top: 12px;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: #252b3a;\n\tmargin-left: 60px;\n\tmargin-right: 60px;\n}\n", ""]);

// exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".privacyDiv {\n    width: 1060px;\n    margin: 80px auto;  \n    background-color: rgba(255,255,255,0.8);\n    border-radius: 2px;\n    box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 80px;\n}\n.privacyTitle{\n    font-family: \"Microsoft YaHei\";\n    font-size: 24px;\n    color: #333333;\n    text-align: center;\n}\n.privacycontent{\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n.privacycontent a{\n    color: #526ECC;\n}\n.privacycontent>p>img{\n    margin-left: 228px;\n}\nli{\n    list-style-type: none;\n}\n.okButton {\n    text-align: center;\n    height: 32px;\n    color: #fff;\n    border-radius: 3px;\n    font-size: 14px;\n    background: #C7000B none repeat scroll 0 0;\n    border: 1px solid #C7000B;\n    width: 70px;\n    font-family: 'TeleGroteskNormal';\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n.okButton:active {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n    color: #fff;\n    cursor: pointer;\n}\n.okButton:disabled {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.cancelButton {\n    text-align: center;\n    color: #252b3a;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    height: 32px;\n    width: 70px;\n    background: #ffffff none repeat scroll 0 0;\n    border: 1px solid #adb0b8;\n    font-size: 14px;\n    font-family: 'TeleGroteskNormal';\n}\n.cancelButton:hover {\n    color: #526ecc;\n    cursor: pointer;\n    background: #ffffff none repeat scroll 0 0;\n    border: 1px solid #5e7ce0;\n}\n.cancelButton:active {\n    background-color: #f1f8ff;\n    border: 1px solid #3399ff;\n    color: #3399ff;\n    cursor: pointer;\n}\n.cancelButton:disabled {\n    background-color: #f0f0f0;\n    border: 1px solid #cccccc;\n    color: #999;\n    cursor: default;\n}\n/*-------- banner begin ---------*/\n#logo {\n    margin-top: 12px;\n}\n#backToHomepage {\n    text-align: center;\n    height: 70px;\n    line-height: 70px;\n    float: right;\n}\n#backToHomepage a, #backToHomepage a:hover, #backToHomepage span, #backToHomepage span:hover {\n    color: #666666;\n    cursor: pointer;\n}\n#backToHomepage a:hover, #backToHomepage span:hover {\n    text-decoration: underline;\n}\n#languages {\n    background-color: #222222;\n    border: solid #222222;\n    border-width: 10px 0px;\n    color: #888888;\n    min-width: 100px;\n    height: auto;\n    position: relative;\n    float: right;\n    clear: both;\n    font-size: 14px;\n    border-radius: 2px;\n    margin-right: -20px;\n}\n#languages > li {\n    cursor: pointer;\n    color: #FFF;\n    text-align: center;\n    border-right: solid 3px #bb0000;\n}\n#languages > li:hover {\n    color: #bb0000;\n}\n#triangle {\n    width: 0px;\n    height: 7px;\n    background: #00aaff;\n    display: inline-block;\n}\n#triangle:after {\n    height: 0;\n    width: 0;\n    content: \"\";\n    position: absolute;\n    border-top: 8px solid #fff;\n    border-left: 4px solid #111214;\n    border-right: 4px solid #111214;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n@media (max-width: 1220px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n    .privacyDiv{\n        width: calc(100% - 200px);\n    }\n}\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n        box-sizing: border-box;\n        padding: 20px;\n    }\n\n    .privacyDiv {\n        width: 100%;\n        box-sizing: border-box;\n        margin-top: 0px;\n    }\n\n    .privacyTitle {\n        line-height: 26px;\n    }\n\n    .privacycontent {\n        border: none;\n        background-color: transparent;\n    }\n\n    .privacycontent > p {\n        text-align: center;\n        width: 100%;\n    }\n\n    .privacycontent > p > img {\n        margin-top: 0px !important;\n        width: 40px !important;\n        height: 40px !important;\n        margin-left: unset;\n    }\n\n    .privacycontent > ul {\n        padding-left: 0px !important;\n    }\n\n    .privacycontent > ul > li:first-child {\n        margin-top: 0px !important;\n    }\n\n    #btnDiv {\n        text-align: center;\n    }\n}", ""]);

// exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".fphoneDiv {\n    width: 1000px;\n    padding-left:40px;\n    padding-right:40px;\n    margin: 0 auto;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n#content {\n    position: relative;\n    margin: 0 0 -70px 0 !important;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 50px auto 10px;\n    padding-bottom: 30px;\n    width: 700px;\n    color: #9B9B9B;\n    position: relative;\n    font-size: 12px;\n}\n.formDiv > ul {\n    width: 85%;\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 230px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: lef;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 24px;\n    line-height: 30px;\n    color:#333;\n}\n\n#step {\n    /* height: 70px; */\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n    display: table;\n}\n\n#step .simple-next hr {\n    width: 10px !important;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n\tbackground-color: #e20074!important;\n}\n\n/* base fphone.css */\n.codeSelect{\n    display:inline-block;\n    vertical-align: middle;\n}\n\n.phoneInput{\n    display:inline-block;\n    margin:3px;\n}\n\n.btnDiv {\n    clear:both;\n    padding-top:30px;\n    margin: 0 auto;\n    display: table;\n}\n\n.field {\n    /* width: 650px !important; */\n}\n\n.formDiv {\n    /* margin-left: 180px; */\n    /* width: 83% !important; */\n}\n\n#step3 > ul{\n    text-align:center;\n    margin-top:3%;\n}\n\n.msgBtn {\n    height: 34px;\n    line-height: 34px;\n}\n\n.errorTipText {\n    margin: 0 auto;\n    color:red;\n}\n\n/*----sm-step begin----*/\n.step1_img{\n    background-image: url(" + escape(__webpack_require__(42)) + ");\n}\n.step2_img{\n    background-image: url(" + escape(__webpack_require__(43)) + ");\n}\n.step2_img_hl{\n    background-image: url(" + escape(__webpack_require__(44)) + ");\n}\n.step3_img{\n    background-image: url(" + escape(__webpack_require__(45)) + ");\n}\n.step3_img_hl{\n    background-image: url(" + escape(__webpack_require__(46)) + ");\n}\n\n\n/* main.css */\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    text-align: center;\n    color: #252b3a;\n    min-width: 70px;\n    border: 1px solid #adb0b8;\n    background: #fff;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    cursor: pointer;\n    border-color: #5e7ce0;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#step3 {\n    clear: both;\n}\n\n.success-title {\n    font-size: 18px;\n    line-height: 26px;\n}\n\n.success-title > img {\n    width: 40px;\n    height: 40px;\n}\n\n.number-info {\n    font-size: 12px;\n    color: #8A8E99;\n    line-height: 18px;\n    margin-bottom: 30px;\n}\n\n#redirect2Login {\n    margin-bottom: 10px;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\n#emailMsgBtn, #newPhoneNumId, #smsMsgBtn {\n    width: 260px !important;\n}\n\n/* 适配移动端 */\n\n@media (max-width: 768px) {\n    body, html {\n        min-width: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #step {\n        /* display: none; */\n    }\n\n    #content {\n        min-width: 0;\n        min-height: 0;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    .pageTitle {\n        margin-bottom: 32px;\n        line-height: 1.5;\n    }\n\n    .fphoneDiv {\n        width: 100%;\n        box-sizing: border-box;\n        box-shadow: none;\n        background-color: transparent;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        font-size: 12px;\n    }\n\n    .formDiv {\n        margin-left: 0;\n        min-height: 0;\n        margin: 0;\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        min-width: 190px;\n        width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    .msgBtn {\n        height: 32px;\n        margin-left: 0px;\n        font-size: 12px;\n    }\n\n    .tiny-combobox-container {\n        height: 32px !important;\n    }\n\n    .tiny-combobox-editor {\n        height: 32px !important;\n    }\n\n    .tiny-textbox-container {\n        width: 100% !important;\n        /* max-width: 240px; */\n        flex-grow: 1;\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n        margin-right: 0;\n        min-width: 200px;\n    }\n\n    #checkCodeId {\n        max-width: 120px !important;\n    }\n\n    #inputVerifyCodeImg {\n        /* margin-top: 8px; */\n        margin-bottom: 8px;\n        height: 30px;\n\n    }\n\n    #step2  .tiny-textbox-container {\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #step2 .field {\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > div:not(#emailMsgBtn){\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > span {\n        flex-grow: 1;\n        width: 100%;\n    }\n\n    #step2 .field > div > span {\n        width: 100%;\n    }\n\n    #step2 .filed span #emailVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #emailMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    .phoneInput {\n        width: auto !important;\n        min-width: 150px;\n        flex-grow: 1;\n        margin-left: 0px;\n    }\n\n    #phoneError {\n        display: block;\n    }\n\n    #step2 .filed span #smsVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #smsMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    #emailMsgBtn, #newPhoneNumId, #smsMsgBtn {\n        width: 100% !important;\n    }\n\n    #step3 ul {\n        margin-left: 0 !important;\n        text-align: center !important;\n    }\n\n    #step3 ul > li > div {\n        margin-right: 0 !important;\n    }\n\n    #step3 ul > li > div > span{\n        line-height: 32px;\n    }\n}\n\n/* 解决小屏幕下步骤栏换行的问题 */\n@media (max-width: 768px) {\n    .simple-next {\n        display: none;\n    }\n\n    #step > div {\n        float: none;\n        display: block;\n        height: 20px;\n        text-align: left;\n    }\n\n    #step {\n        margin-left: 40px;\n        margin-bottom: 40px;\n    }\n}", ""]);

// exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 新样式 */\n#loginVerificationDiv {\n    background-color: #FFFFFF;\n    max-width: 700px;\n    box-shadow: 1px 2px 8px #ccc;\n    border-radius: 2px;\n    margin: 0 auto;\n    margin-top: 30px;\n    margin-bottom: 100px;\n}\n#loginVerificationTitle {\n    width: 100%;\n    color: #333333;\n    font-size: 24px;\n    text-align: center;\n    letter-spacing: 0;\n    line-height: 34px;\n    margin: 30px 0px 20px 0px;\n    float: left;\n}\n\n#verificationContainer {\n    padding: 0px 20px 30px 20px;\n    float: left;\n}\n#verificationContainer div {\n    float: left;\n    text-align: left;\n}\n#verificationContainer .fieldItem {\n    width: 100%;\n    margin-bottom: 15px;\n}\n#verificationContainer .fieldItem:last-child {\n    margin-bottom: 0px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span {\n    display: block;\n    word-wrap: break-word;\n    max-height: 150px;\n    overflow-y: auto;\n}\n/* 滚动条样式 */\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar {\n    width: 4px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    background: rgba(0,0,0,0.2);\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    border-radius: 0;\n    background: rgba(0,0,0,0.1);\n}\n\n#verificationContainer .fieldItem.presetLoginInfo .presetTips {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-top: 5px;\n}\n#verificationContainer .fieldItem .itemLabel {\n    width: 260px;\n    font-size: 14px;\n    color: #999999;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent {\n    margin-left: 10px;\n    width: 390px;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent .tiny-input-text {\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n}\n#verificationContainer .fieldItem .itemContent .hintContext {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-left: 10px;\n}\n#verificationContainer .fieldItem .itemContent .bindTips {\n    display: block;\n    color: #F66F6A;\n    font-size: 12px;\n    margin-top: 5px;\n}\n/* 绑定虚拟MFA按钮 */\n#verificationContainer .fieldItem .itemContent .bindMFABtn {\n    cursor: pointer;\n    color: #526ECC;\n}\n#verificationContainer .fieldItem .itemContent .bindMFABtn:hover {\n    color: #006AD4;\n}\n\n/* 验证码输入框 */\n#verificationContainer .fieldItem .inputDiv {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n    height: 32px;\n}\n#verifyCodeId {\n    width: 170px !important;\n    float: left;\n}\n#verificationContainer .fieldItem .inputDiv .tiny-input-text {\n    border: none;\n}\n#verificationContainer .fieldItem .inputDiv .seperate {\n    width: 1px;\n    height: 24px;\n    margin: 4px 0px;\n    background: #CCCCCC;\n}\n#verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    cursor: pointer;\n    color:  #526ECC;\n}\n#verificationContainer .fieldItem .inputDiv .retrieveTip {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    color: #999999;\n}\n#verificationContainer .fieldItem #sendCodeDoneTip {\n    font-size: 12px;\n    color: #999999;\n    margin: 5px 0px 0px 0px;\n}\n#verificationContainer .fieldItem #msgErrorTip {\n    width: 100%;\n    margin: 5px 0px 0px 0px;\n}\n/* 底部提示语 */\n#loginVerificationTips {\n    display: block;\n    float: left;\n    font-size: 12px;\n    color: #c3c3c3;\n    padding: 0 30px 20px;\n}\n/* END */\n\n\n/* 分割线 */\n#splitLine {\n    width: 100%;\n    height: 1px;\n    background-color: #E2E2E2;\n    border-radius: 1px;\n    float: left;\n    margin-bottom: 30px;\n}\n\n/* 底部按钮组 */\n#btnGroupDiv {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-bottom: 30px;\n    background-color: #FFFFFF;\n}\n#btnGroupDiv .btnDiv {\n    display: inline-block;\n    width: 263px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333333;\n    text-align: center;\n    border-radius: 2px;\n    cursor: pointer;\n}\n#btnGroupDiv #cancelBtn {\n    background: #FFFFFF;\n    border: 1px solid #adb0b8;\n    color: #252b3a;\n}\n\n#btnGroupDiv #cancelBtn:hover{\n    color: #526ecc;\n    border-color: #5e7ce0;\n}\n\n#btnGroupDiv #submitBtn {\n    margin-left: 10px;\n    background: #F66F6A;\n    border: 1px solid #F66F6A;\n    color: #FFFFFF;\n}\n\n#btnGroupDiv #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n#btnGroupDiv #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* 右侧绑定虚拟MFA弹窗框 */\n.bingMFAPage {\n    position: fixed;\n    top: 45px;\n    bottom: 70px;\n    left: 0;\n    right: 0;\n    background: rgb(0, 0, 0, 0.5);\n}\n.bingMFAPage .bindMFAModal {\n    width: 700px;\n    float: right;\n    background: #FFFFFF;\n    position: relative;\n    overflow-y: overlay;\n    overflow-x: hidden;\n    height: calc(100% - 60px);\n}\n.modalTitle {\n    width: 100%;\n    font-size: 24px;\n    line-height: 24px;\n    text-align: left;\n    margin: 30px 0px;\n    padding-left: 30px;\n    border-left: 3px solid #3399FF;\n}\n.modalContent {\n    float: left;\n    padding: 0px 0px 30px 20px;\n}\n.modalContent .stepDiv {\n    float: left;\n    width: 100%;\n}\n.modalContent .stepDiv#step1 {\n    height: 210px;\n}\n.modalContent .stepDiv#step2 {\n    height: 250px;\n}\n.modalContent .stepDiv .stepProgress {\n    width: 32px;\n    height: 100%;\n    float: left;\n    transform: translateY(6px);\n}\n.modalContent .stepDiv .stepProgress .stepImage {\n    width: 20px;\n    height: 20px;\n    line-height: 21px;\n    font-size: 14px;\n    color: #FFFFFF;\n    background: url(" + escape(__webpack_require__(49)) + ") no-repeat;\n    background-size: 100% 100%;\n}\n.modalContent .stepDiv .stepProgress .stepFill {\n    width: 2px;\n    height: 100%;\n    margin: -3px 14px 0px 14px;\n    background-color: #526ECC;\n}\n.modalContent .stepDiv .stepContent {\n    float: left;\n    width: 585px;\n    margin-left: 20px;\n}\n.modalContent .stepDiv .stepContent .title {\n    font-size: 16px;\n    padding: 5px 0px;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .tips {\n    font-size: 12px;\n    color: #8A8E99;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .appDownload {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .appDownload .HWCloud {\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    background: url(" + escape(__webpack_require__(48)) + ") center no-repeat;\n    background-size: cover;\n}\n.modalContent .stepDiv .stepContent .content {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n    float: left;\n    width: 120px;\n    height: 120px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n    float: left;\n    width: 450px;\n    font-size: 14px;\n    margin-left: 10px;\n    background: #F4F5F6;\n    padding: 5px 0px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem {\n    float: left;\n    padding: 5px 15px 5px 15px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoLabel {\n    float: left;\n    width: 90px;\n    text-align: left;\n    color: #999999;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n    float: left;\n    display: inline-block;\n    width: 330px;\n    text-align: left;\n    word-wrap: break-word;\n    word-break: break-all;\n    overflow: hidden;\n}\n.modalContent #msgMFAErrorTip {\n    padding-left: 172px;\n    text-align: left;\n    font-size: 12px;\n    color: #F66F6A;\n}\n.MFACodeDiv .codeFieldItem {\n    float: left;\n    padding: 10px 0px;\n    margin-right: 20px;\n}\n.MFACodeDiv .codeFieldItem .codeLabel {\n    float: left;\n    width: fit-content;\n    margin-right: 16px;\n    height: 32px;\n    line-height: 32px;\n    font-size: 14px;\n    color: #666666;\n}\n.MFACodeDiv .codeFieldItem .codeInput {\n    float: left;\n}\n.MFACodeDiv .codeFieldItem .codeInput .tiny-input-text {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n}\n\n/* 页面底部 */\n.modalFooter {\n    display: block;\n    position: fixed;\n    bottom: 80px;\n    width: 700px;\n    height: 60px;\n    float: left;\n    background-color: #f4f4f4;\n    border-top: 1px solid #eeeeee;\n}\n.modalFooter .btnDiv {\n    width: 100px;\n    padding: 5px 20px;\n    font-size: 14px;\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-top: 14px;\n    cursor: pointer;\n}\n.modalFooter #submitBtn {\n    border-color: #F66F6A;\n    background: #F66F6A;\n    color: #FFFFFF;\n}\n.modalFooter #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n.modalFooter #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.modalFooter #cancelBtn {\n    width: 80px;\n    margin-left: 10px;\n    color: #252b3a;\n    background: #fff;\n    border-color: #adb0b8;\n    cursor:pointer;\n}\n.modalFooter #cancelBtn:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n/* END */\n\n.commonTxt{\n    line-height: normal;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.titleText {\n    height:36px;\n    font-size: 24px;\n    color: #333;\n    text-align: left;\n}\n\n.hintTitle{\n    font-size:18px;\n    color:#333333;\n}\n\n.hintContextSMS{\n    font-weight:400;\n    font-size:14px;\n    color:#666666;\n}\n\n.presetInfo{\n    width: 650px;\n    word-wrap: break-word;\n    color: #999999;\n    text-align: left;\n    border:1px dashed #cccccc;\n    border-radius: 5px;\n    margin-top: 20px;\n    padding-top:10px;\n    padding-right:10px;\n    padding-left:10px;\n    padding-bottom:40px;\n    font-size: 12px;\n    background-color: #FFFFFF;\n}\n\n.loginInfo{\n    font-size: 14px;\n    color: #666666;\n    margin-top: 20px;\n    align:\"left\"\n}\n\n#getMsgCodeBtn{\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-left: 10px;\n    text-align: center;\n    height: 36px;\n    border-radius: 4px;\n    line-height: 36px;\n    vertical-align: middle;\n    color: #666;\n    padding-left:5px;\n    padding-right: 5px;\n}\n\n#getMsgCodeBtn:hover{\n    color: #009ae7;\n}\n\n.getMsgCodeBtn{\n    cursor: pointer;\n    background-color: #FFFFFF;\n}\n\n.disabledMsgBtn{\n    color: #666 !important;\n    background-color: #cccccc;\n    cursor: default;\n}\n\n.btnCommon{\n    width: 100px;\n    height: 35px;\n    text-align: center;\n    font-size: large;\n    line-height: 35px !important;\n    border-radius: 3px;\n    color: #333333;\n}\n\n\n\n#cancelBtnBtn{\n    background-color: #FFFFFF;\n    border: 1px solid #CCC;\n    cursor: pointer;\n}\n\n#cancelBtnBtn:hover{\n    /*background-color: #DDDDDD;*/\n    border-color: #60b0ff;\n    background-color: #FFFFFF;\n}\n\n.changePhonelink{\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 14px;\n    color: #526ECC;\n}\n\n#getMsgDiv{\n    margin-top:20px;\n    height:38px;\n    font-size: 14px;\n    margin-right: -200px;\n}\n\n.msgCodeHint{\n    display:inline-block;\n    min-width:107px;\n}\n\nbutton:focus{\n    outline:none;\n}\n\n/* 使步骤条与内容高度一致 */\n.stepDiv {\n    display: table;\n}\n\n.stepDiv > .stepProgress, .stepDiv > .stepContent {\n    display: table-cell;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.tiny-combobox-container {\n    height: 32px;\n    line-height: 30px;\n    border: 1px solid #d5d5d5;\n    border-radius: 2px;\n    background: #fff;\n    box-shadow: 1px 1px 1px #fff,inset 1px 1px 1px rgba(0,0,0,0.1);\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n@media only screen and (max-width: 1920px) {\n\n}\n@media only screen and (max-width: 1680px) {\n    \n}\n@media only screen and (max-width: 1440px) {\n    \n}\n@media only screen and (max-width: 1366px) {\n    \n}\n@media only screen and (max-width: 1280px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n@media only screen and (max-width: 1024px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    #btnGroupDiv {\n        background-color: transparent;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginVerificationDiv {\n        max-width: none;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 0px;\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 2px;\n        /* margin: 0 auto; */\n        margin-top: 0px;\n        margin-bottom: 20px;\n    }\n\n    #verificationContainer, #loginVerificationTips {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    #verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n        padding: 0 8px;\n    }\n\n    #verificationContainer .fieldItem {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        flex-wrap: nowrap;\n    }\n\n    #verificationContainer .fieldItem .itemContent {\n        width: auto;\n        font-size: 12px;\n    }\n\n    #verificationContainer .fieldItem .itemLabel {\n        min-width: 100px;\n        max-width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    #verificationContainer .fieldItem .itemContent .bindTips {\n        clear: both;\n    }\n\n    #verifyCodeId {\n        width: 100px !important;\n    }\n\n    #bindPhoneId {\n        width: 100% !important;\n    }\n\n    #bindEmailId {\n        width: 100% !important;\n    }\n\n    #btnGroupDiv {\n        flex-wrap: wrap;\n    }\n\n    #btnGroupDiv .btnDiv {\n        width: calc(50% - 16px);\n        padding-left: 8px;\n        padding-right: 8px;\n        margin: 8px;\n        min-width: 160px;\n        display: block;\n        box-sizing: border-box;\n        float: left;\n    }\n\n    #btnGroupDiv #submitBtn {\n        margin-left: 8px;\n    }\n\n    #countryCodeSelectId {\n        margin-bottom: 8px;\n    }\n\n    .modalTitle {\n        width: auto;\n    }\n\n    .bingMFAPage {\n        bottom: 0px;\n    }\n\n    .bingMFAPage .bindMFAModal {\n        width: 100%;\n    }\n\n    .modalFooter {\n        width: 100%;\n        bottom: 0px;\n    }\n\n    .modalContent .stepDiv .stepProgress {\n        /* display: none; */\n    }\n\n    .modalContent .stepDiv .stepContent {\n        float: left;\n        width: calc(100% - 32px);\n        margin-left: 0;\n    }\n\n    .modalContent {\n        padding-right: 20px;\n    }\n\n    .modalContent .stepDiv {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n        width: auto;\n        margin-left: 0px;\n        margin-top: 8px;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n        width: 100%;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeLabel {\n        text-align: left;\n        width: 150px;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeInput {\n        text-align: left;\n    }\n\n    #verifyCodeId {\n        width: 88px !important;\n    }\n\n    .codeInput .tiny-textbox-container {\n        width: 120px !important;\n    }\n\n    .modalContent .stepDiv .stepContent .appDownload {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n        float: none;\n    }\n    \n    #verificationContainer .fieldItem .inputDiv .retrieveTip {\n        padding: 0px 5px;\n    }\n\n    .modalContent #msgMFAErrorTip {\n        padding-left: 0px;\n    }\n}\n\n\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    margin-top: 8px;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n    font-weight: normal;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -17px;\n    width: 12px;\n    height: 12px;\n    top: 3px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -13px;\n    top: 5px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n\n/*适配移动端*/\n@media (max-width: 375px) {\n    #verifyCodeId {\n        width: 83px !important;\n    }\n}\n\n@media (max-width: 360px) {\n    #verifyCodeId {\n        width: 68px !important;\n    }\n}\n\n@media (max-width: 320px) {\n    #verifyCodeId {\n        width: 38px !important;\n    }\n}", ""]);

// exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滚动条轨道 内阴影+圆角*/\n::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滑块 内阴影+圆角*/\n::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #bfc3c6;\n}\n/*------  content begin ---------*/\n#loginAdv {\n    float: left;\n    max-width: 800px;\n    max-height: 515px;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n}\n\n#loginForm {\n    width: 380px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#loginForm > ul, #companyUser, #personalUser {\n    margin: auto auto 0px auto;\n    width: 320px;\n}\n\n/* 统一ID登录iframe */\n#uniIdIframeDiv {\n    width: 380px;\n    height: 500px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n/* END */\n\n/* 页面错误信息 */\n/* END */\n\n/* 主帐户 帐号/邮箱登录方式 */\n#loginForm .loginFormDiv {\n    padding: 0px 30px;\n    width: 320px;\n}\n/* END */\n\n/* 国家码选择框 */\n\n#loginForm .codeSelect {\n    display:inline-block;\n    vertical-align: middle;\n    float: left;\n}\n#loginForm .codeSelect .tiny-combobox-container {\n    border: none;\n    background-color: #FFFFFF;\n    box-shadow: none;\n}\n#loginForm .codeSelect .tiny-combobox-editor {\n    padding-left: 8px;\n    /*width: calc(100% - 10px);\n    width: -webkit-calc(100% - 10px);\n    width: -moz-calc(100% - 10px);*/\n}\n#loginForm .codeSelect .tiny-combobox-editor .tiny-combobox-input {\n    box-shadow: none;\n    border: none;\n    padding: 0px;\n    font-size: 12px;\n}\n#loginForm .codeSelect .tiny-combobox-popbutton:before {\n    right: 1px;\n    border-top: 5px solid #252B3A;\n}\n#loginForm .codeSelect .tiny-combobox-disable {\n    background-color: #FFFFFF;\n    border-color: none;\n    box-shadow: none;\n    border-right: none;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input {\n    /* font-family: PingFangSC-Regular; */\n    color: #696969;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input:disabled {\n    opacity: 1 !important;\n}\n/* END */\n\n/* 手机号输入框 */\n.phoneInput {\n    display:inline-block;\n    position: relative;\n}\n.phoneInput input.tiny-input-text.valid_error_input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n/* END */\n\n/*\n<!-- 帐号输入框 -->\n<!-- 密码输入框 -->\n<!-- 手机号登录方式 -->\n<!-- 国家码选择框 -->\n<!-- 手机号输入框 -->\n<!-- 手机绑定多帐号需选择 -->\n<!-- 密码输入框 -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 密码输入框 -->\n<!-- 主帐户 帐号/邮箱登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- <tiny-textbox id=\"model.userNameId\" validate=\"model.userValidator\" value=\"model.userName\"\n<!-- 主帐户 手机号登录方式 仅国内站-->\n<!-- 手机绑定多帐号需选择 -->\n<!-- end -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 国内IP placeholder不同-->\n<!-- 海外IP placeholder不同-->\n<!-- 密码输入框 非手机登录方式-->\n<!-- 密码输入框 手机登录方式-->\n<!-- 验证码输入框 -->\n<!-- 手机号登录方式切换按钮 -->\n<!-- 记住密码按钮 -->\n*/\n#companyUser, #personalUser {\n    color: #333333;\n    font-size: 28px;\n    margin-top: 35px !important;\n    margin-bottom: auto !important;\n}\n\n#companyUser > span, #personalUser > span {\n    line-height: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: top;\n}\n\n#companyUser > hr, #personalUser > hr {\n    display: inline-block;\n    margin: 5px 5px;\n    border: 0;\n    border-bottom: 1px solid #999999;\n}\n\n#companyUser > hr {\n    width: 28%;\n}\n\n#personalUser > hr {\n    width: 56%;\n}\n\n.errorTip {\n    display:block;\n    position: relative;\n    min-height: 32px;\n    font-size: 12px;\n    padding: 0px 8px;\n}\n.errorTip span {\n    color: #F66F6A;\n}\n\n#checkError, #serverError, #mobileErrorMsg, #mobileUsersSelectMsg, #isMobileTip {\n    color: #FF0000;\n    /*display: none;*/\n    clear: both;\n    /*margin: 10px 0 0 0;*/\n}\n\n/* 手机多用户时选择用户的下拉框 */\n.mobileUsersSelect {\n    margin-bottom: 15px;\n}\n.mobileUsersSelect .tiny-select {\n    width: 100%;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field {\n    height: 36px;\n    border: none;\n    padding-right: 0;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field input {\n    width: 100% !important;\n    border-right: none;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-input-field-selected-down:before, .tiny-select-input-field-selected-up:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-popup-container {\n    border: 1px solid #ADB0B8;\n    box-shadow: 0 2px 5px 0;\n}\n.tiny-select-option {\n    color: #252B3A;\n}\n.tiny-select-option-selected {\n    color: #F66F6A;\n    background: #FFEEED;\n}\n.tiny-select-option-default-selected {\n    background-color: #F66F6A;\n    color: #FFFFFF;\n}\n/* END */\n\n/* 验证码图片样式 */\n#inputVerifyCodeImg {\n    width: 100px;\n    height: 30px;\n    float: right;\n    cursor: pointer;\n}\n/* END */\n\n.inputField {\n    margin-bottom: 16px !important;\n    font-size: 14px !important;\n    border-bottom: 1px solid #DFE1E6;\n    position: relative;\n}\n.inputField:hover {\n    border-bottom: 1px solid #8A8E99;\n}\n.inputField:last-child {\n    margin-bottom: 0px !important;\n    font-size: 14px !important;\n}\n#loginForm .inputField input {\n    line-height: 20px;\n    border-radius: 0px;\n    /* font-family: \"PingFangSC-Regular\"; */\n    padding: 0px 8px;\n    box-shadow: none;\n}\n\n#loginForm > div:last-child {\n    /*position: absolute !important;*/\n    bottom: 0px;\n    width: 100%;\n}\n\n#buttonArea {\n    margin: 48px 38px 30px 38px;\n    width: 304px;\n}\n\n#smsPhone {\n    margin: 5px;\n    font-size: 13px !important;\n}\n\n#fpLink {\n    color: #00aaff;\n    float:right;\n}\n\n/* 手机号登录切换 以及 记住登录名 */\n.toDoDiv {\n    margin: 18px 38px 0;\n    width: 304px;\n}\n/* END */\n\n/* 手机号登录切换 */\n.typeSwitchDiv {\n    display: inline-block;\n    font-size: 12px;\n    font-style: normal;\n    color: #252B3A;\n    max-width: 180px;\n}\n#typeSwitchBtn {\n    cursor: pointer;\n}\n#typeSwitchBtn:hover {\n    color: #F66F6A;\n    text-decoration: underline;\n}\n/* END */\n\n/* 记住登录名 */\n.toDoDiv #checkArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -20px;\n    top: 0px;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -16px;\n    top: 2px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n/* END */\n\n.buttonAreaDiv {\n    width: 100%;\n    float: left;\n}\n\n.loginBtn {\n    background-color: #F66F6A;\n    border-radius: 2px;\n    color: #ffffff;\n    cursor: default;\n    width: 100%;\n}\n.loginBtn:hover,\n.loginBtn:active,\n.loginBtn:focus {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,0.3);\n    outline: none;\n}\n\n.loginBtn span, .loginBtnDisabled span {\n    vertical-align: middle;\n    text-align: center;\n    font-size: 14px !important;\n    display: table-cell;\n    height: 36px;\n    margin: 0 auto;\n    display: block;\n    line-height: 36px;\n}\n\n.loginBtnDisabled {\n    background-color: #CCCCCC;\n    border: 1px solid #CCCCCC;\n    border-radius: 3px 3px 3px 3px;\n    color: #ffffff;\n    font-size: 18px !important;\n    cursor: default;\n    width: 100%;\n}\n\n#bottomBtns {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: 10px;\n}\n\n/* 免费注册 & 忘记密码 & 用户切换 */\n.commonLinkDiv {\n    flex-basis: 50%;\n    margin-bottom: 10px;\n    text-align: center;\n}\n.splitLine {\n    display: none;\n    float: left;\n    width: 1px;\n    margin: 0px 2px;\n    height: 12px;\n    background: #DFE1E6;\n}\n.freeRegisterLink {\n    width: 100px;\n}\n.forgetPwdLink {\n    width: 100px;\n}\n.userTypeLink {\n    width: 100px;\n}\n/* END */\n\n#goLogin {\n    color:#5099F8;\n    cursor: pointer;\n    font-size:small;\n}\n#goLogin:hover{\n    text-decoration: underline;\n}\n/*-------- content end ---------*/\n\n/*------ page layout begin ------*/\n#content .widthLimit {\n    position: relative;\n    margin: 0px auto;\n    padding: 0px 20px;\n}\n\n#content .widthLimit{\n    max-width: 1200px;\n}\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 45px;\n}\n\nbody, html {\n    height:100%;\n    margin: 0;\n    padding: 0;\n    min-width: 1260px;\n}\n\n*{\n    margin: 0;\n    padding: 0;\n}\n.placeholder {\n    color: #aaa!important;\n    font-family: \"Microsoft Yahei\"!important;\n}\n\n.linkSeperator {\n    height:100%;\n    border-left: 1px #0678FF solid;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.expand {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-top: 10px solid #0678FF;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.collapse {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-bottom: 10px solid #0678FF;;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\n\n.requiredImage {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n#enterpriseSwitchTip {\n    background-color: #ffffff;\n    border: 1px solid #cccccc;\n    color: #666666;\n    width: 300px;\n    height: auto;\n    position: absolute;\n    float: right;\n    border-radius: 2px;\n    top: 50px;\n    z-index: 10;\n    padding:6px;\n    background-color: #f5f5f5;\n    font-size: 12px;\n}\n\n.loginTypeDiv {\n    color:#666666;\n    font-size:14px;\n    font-style: normal;\n    padding: 24px 30px 10px 30px;\n    text-align: center;\n}\n\n.loginTypeNoSelected {\n    box-sizing: border-box;\n    display: inline-block;\n    width:100%;\n    line-height: 18px;\n    font-size: 18px;\n    /* font-family: \"PingFangSC-Medium\"; */\n    text-align: center;\n    color: #252B3A;\n    max-width: 300px;\n}\n\n.loginTypeSelected {\n    box-sizing: border-box;\n    border-color: #E41E2B;\n    border-style:solid;\n    border-top:0;\n    border-left:0;\n    border-right:0;\n    border-width: 3px;\n    display: inline-block;\n    width:47%;\n    text-align: center;\n    height: 44px;\n    line-height: 44px;\n    color:#E41E2B;\n    cursor: pointer\n}\n.loginBottomColor {\n    font-size: 12px;\n    color: #252B3A;\n    line-height: 16px;\n}\n.loginBottomColor:hover,\n.loginBottomColor:active,\n.loginBottomColor:focus {\n    color: #F66F6A;\n}\n.otherLoginColor{\n    font-size: 12px;\n    color: #666A75;\n    line-height: 16px;\n}\n.otherLoginColor:hover,\n.otherLoginColor:active,\n.otherLoginColor:focus {\n    color: #666A75;\n}\n\n/* 三方登录展示列表 */\n#otherLoginWays {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n#otherLoginWays .otherItemDiv {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n}\n#otherLoginWays .otherItemDiv .textIcon {\n    height: 13px;\n    padding-top: 3px;\n}\n#otherLoginWays .otherItemDiv#hwportalLinkDiv {\n    flex-grow: 1;\n}\n/* END */\n\n.tiny-input-text {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #333;\n    font-size: 14px;\n    font-face:NotoSansCJKsc-Regular\n}\n.tiny-input-text:focus {\n    border: none;\n}\n.tiny-input-text.valid_error_input:focus {\n    border: none;\n}\n\n:-ms-input-placeholder {\n    color: #999 !important;\n}\n\n#otherAccounts{\n    position: relative;\n    text-align: center;\n    margin-bottom: 5px;\n    line-height: 1;\n    cursor: pointer;\n}\n#otherAccounts:before{\n    content: '';\n    position: absolute;\n    top: 50%;\n    display: block;\n    width: 100%;\n    border-top: 1px solid #DDD;\n}\n\n#otherAccounts .downArrow {\n    margin-left: -7px;\n    padding-right: 7px;\n    display: inline-block;\n    position: relative;\n    z-index: 2;\n    background-color: #ffffff;\n}\n#otherAccounts .downArrow img {\n    width: 8px;\n    height: 8px;\n}\n#otherAccounts .downArrow img.otherAccountsOpen {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n#otherAccounts .downArrow img.otherAccountsClose {\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n#otherAccounts .otherLoginColor{\n    padding: 0 7px;\n    position: relative;\n    z-index: 2;\n    background-color: #fff;\n}\n\ninput[type=\"password\"] {\n    color: #333;\n}\n\n.homepageLink {\n    color: #A0A2A8;\n}\n\n.index-uniportal {\n    position: relative;\n}\n\n.index-uniportal>a {\n    cursor: pointer;\n}\n.index-uniportal:hover >.uniportalTip {\n    display: block;\n}\n\n.index-uniportal>.uniportalTip {\n    top: 17px;\n    display: none;\n    position: absolute;\n    bottom: 13px;\n}\n\n.index-uniportal>.uniportalTip>span {\n    padding: 2px;\n    box-shadow: 1px 1px 10px #ccc;\n    border: 1px solid #ccc;\n    display: block;\n    background: #fff;\n    margin-left: 90px;\n    width: 183px;\n    font-size: 10px;\n}\n.otherLogin{\n    position:relative;\n    margin-left: 120px;\n}\n.otherLogin:before{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: -120px;\n    content: \"\";\n}\n.otherLogin:after{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: 100px;\n    content: \"\";\n}\n.registUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 70px;\n    font-size: 13px;\n}\n.forgetPWDUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 0px;\n    font-size: 13px;\n}\n.shuXianSpan {\n    color: #666;\n    float: right;\n    margin-top: -21px;\n    margin-right: 63px;\n}\n\n.helpQuestionmark {\n    background-image: url(" + escape(__webpack_require__(47)) + ");\n    float: right;\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n}\n\n.loginswap {\n    line-height: 18px;\n}\n\n.loginswap:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.helptipfather {\n    display: inline-block; position:relative;\n}\n.userTypeLink:hover .helptipchild {\n    display:block;\n    width:220px;\n    padding:8px 3px 3px 6px;\n}\n.helptipfather span {\n    display:none;\n    color:#666666;\n    font-size:12px;\n    line-height:20px;\n    /* font-family:PingFangSC-Regular; */\n    background:#FFFFFF;\n    border-radius:0 0 0 2px 2px 2px 2px;\n    border:1px solid #EEEEEE;\n    box-shadow:0 2px 5px 0 rgba(0,0,0,0.15);\n    -moz-border-radius:1px;\n    -webkit-border-radius:1px;\n    text-align:left;\n    position: absolute;\n    left: -150px;\n    top: 10px;\n    z-index:10;\n    overflow: visible;\n}\n#loginAdv .login-logo-pad{\n    display: none;\n}\n.pwdShowimg {\n    top: 10px;\n    right: 8px;\n    position: absolute;\n    width: 15px;\n    height: 15px;\n}\n\n#personalPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n\n#mobilePasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n} \n\n#IAMPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n/*------ pad css start------*/\n@media (max-width: 1269px) {\n    .widthLimit{\n        box-sizing: border-box;\n        padding: 0;\n    }\n    html,body,#content{\n        max-width: 1270px;\n        min-width: 768px;\n    }\n    #content{\n        height: calc(100% - 90px);\n    }\n    #content .widthLimit{\n        max-width: 768px;\n    }\n    #loginAdv{\n        margin-top: 40px;\n        max-width: 352px;\n    }\n    #content .widthLimit{\n        padding: 0 15px;\n    }\n\n    #loginForm{\n        margin-top: 70px;\n    }\n    #loginAdv .login-logo-pad{\n        display: block;\n    }\n    #loginAdv .login-logo-pc{\n        display: none;\n    }\n}\n/*------ pad css end ------*/\n/*------ page layout end ------*/\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    #content {\n        height: 100%;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        padding: 0 30px;\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginAdv {\n        display: none;\n    }\n\n    body, html, #content {\n        height:100%;\n        margin: 0;\n        padding: 0;\n        min-width: 0px;\n    }\n\n    #loginForm {\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        /* padding: 0 30px; */\n    }\n\n    #uniIdIframeDiv {\n        width: 100%;\n        height: 100%;\n        margin-top: 0px;\n    }\n    #uniIdIframe {\n        width: 100%;\n        box-shadow: none;\n        background: none;\n    }\n    \n    #loginForm .loginFormDiv {\n        width: 100% !important;\n        padding: 0;\n        margin: 0;\n    }\n\n    #loginForm .tiny-textbox-container {\n        width: 100% !important;\n    }\n\n    #verifyCode .tiny-textbox-container {\n        width: calc(100% - 138px) !important;\n    }\n    \n    #inputVerifyCodeImg {\n        transform: translateY(4px);\n    }\n\n    .toDoDiv {\n        margin-left: 0px;\n        margin-right: 0px;\n        width: 100%;\n    }\n\n    #loginForm .mobileLoginDiv .phoneInput {\n        width: calc(100% - 115px);\n    }\n\n    #buttonArea {\n        margin: 38px auto;\n        width: 100%;\n    }\n\n    #otherAccounts .otherLoginColor {\n        background-color: #0000;\n    }\n\n    #otherAccounts .downArrow {\n        background-color: #0000;\n    }\n    \n    .userTypeLink:hover .helptipchild {\n        display: none;\n    }\n}\n\n/* 扫码登录 */\n#loginForm{\n    position: relative;\n}\n#QRLoginDiv {\n    position: relative;\n    background-color: #fff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228,228,228,1);\n    border-radius: 0;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,.1);\n    display: flex;\n    width: 380px;\n    height: 407px;\n    float: right;\n    margin-top: 80px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loginQRCodeDiv{\n    width: 159px;\n    padding: 10px;\n}\n\n.QRCodeOuter{\n    position:relative;\n    height: 179px;\n    width: 180px;\n    margin: 0 auto;\n    text-align: center;\n    border: 0px solid #DFE1E6;\n    background: url(" + escape(__webpack_require__(32)) + ");\n    background-size: cover;\n}\n.QRCodeInner{\n    position:absolute;\n    top: 0px;\n    left: 0px;\n    color: #FFFFFF;\n    height: 179px;\n    width: 180px;\n    background:rgba(7, 7, 7, 0.6);\n}\n\n\n.loginTypeSwitchImg{\n    margin-top: 8px;\n    margin-right: 8px;\n    width: 50px;\n    height: 50px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n}\n\n.loginTypeSwitchImg:hover{\n    cursor: pointer;\n}\n\n.ti-tooltip {\n    position: absolute;\n    top: 9px;\n    right: 58px;\n    background-color: #333854;\n    color: #dfe1e6;\n    padding: 11px 15px;\n    border: 1px solid #333854;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n    border-radius: 4px;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    box-sizing: border-box;\n    z-index: 5000;\n    white-space: normal;\n    word-wrap: break-word\n}\n\n.ti-tooltip-left:after {\n    height: 20px;\n    margin-top: -10px;\n    right: 0\n}\n\n.ti-tooltip-left:after,.ti-tooltip-left:before {\n    display: block;\n    position: absolute;\n    content: \"\";\n    overflow: hidden;\n    background: #333854;\n    width: 10px;\n    top: 50%\n}\n\n.ti-tooltip-left:before {\n    height: 10px;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    border-right: 1px solid #333854;\n    border-top: 1px solid #333854;\n    margin-top: -5px;\n    right: -5px;\n    box-shadow: 0 -2px 4px rgba(0,0,0,.2)\n}\n\n#countDownDiv {\n    text-align: center;\n    color: #252B3A;\n    font-size: 12px;\n    margin-top: 10px;\n    height: 20px;\n}\n\n.remainingTimeTxt{\n    color: #F66F6A;\n}\n\n#QRLoginBottomDiv {\n    width: calc(100% - 50px);\n    border-top: 1px solid #575D6C;\n    margin-left: 40px;\n    margin-right: 40px;\n    height: 60px;\n    line-height: 50px;\n    display: inline-flex;\n    justify-content: space-between;\n    font-size: 12px;\n}\n\n.QRLoginBottomColor {\n    font-size: 12px;\n    color: #575D6C;\n}\n.QRLoginBottomColor:hover,\n.QRLoginBottomColor:active,\n.QRLoginBottomColor:focus {\n    color: #F66F6A;\n}\n\n.QRCodeInvalid{\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 60px;\n}\n\n#refreshQRCodeBtn {\n    width: 80px;\n    margin: 0 auto;\n}\n\n.loginStatusDiv{\n    text-align: center;\n}\n\n.loginStatusImg{\n    height: 64px;\n    width: 64px;\n    margin-bottom: 16px;\n}\n\n.loginStatusTitle{\n    color: #252B3A;\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.loginStatusMessage{\n    color: #252B3A;\n    font-size: 12px;\n}\n\n@media (max-width: 1269px) {\n    #QRLoginDiv{\n        margin-top: 70px;\n    }\n    .loginTypeSwitchImgCover{\n        border-bottom: 50px solid linear-gradient(90deg,#F4F5FF 0,#E8EBFD 48%,#F4F5FF 100%) ;\n    }\n}\n\n@media (max-width: 768px) {\n    #QRLoginDiv{\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        display: none;\n    }\n\n    .loginTypeSwitchImg {\n        display: none;\n    }\n\n    #QRLoginTip {\n        display: none;\n    }\n\n}\n\n/**企业联邦登录**/\n#idpLoginForm{\n    width: 380px;\n    display: inline-block;\n    float:right;\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#idpLoginForm .loginFormDiv{\n    margin: 0 38px;\n}\n\n#idpLoginForm #otherLoginWays{\n    display: flex;\n    justify-content: space-around;\n}\n\n#idpLoginForm #otherLoginWays .otherItemDiv{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#idpLoginForm #loginBtn{\n    margin-bottom: 50px;\n}\n\n#idpLoginForm .tiny-select-text{\n    box-shadow: 0 0 0 0;\n}\n\n#idpLoginForm #idpCheckArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n\n@media (max-width: 768px){\n    #idpLoginForm{\n        width: 100%;\n        box-shadow: none;\n        background: 0 0;\n        margin-top: 20px;\n    }\n    #idpLoginForm .loginFormDiv{\n        margin: 0;\n    }\n\n    #idpLoginForm .loginFormDiv .tiny-textbox-container{\n        width: 100% !important;\n    }\n    #idpLoginForm .loginFormDiv .tiny-select-input-field{\n        width: 100% !important; \n    }\n}\n", ""]);

// exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content .widthLimit {\n    max-width: 800px;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin: 0 auto;\n}\n\n#verifyTypeBtn {\n    color: #0088CC;\n    display: inline-block;\n    float: right;\n    margin-right: 7px;\n    height: 36px;\n    line-height: 36px;\n}\n\n#verifyTypeBtn:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n#resetTitle {\n    margin: 20px 0px;\n}\n\n#resetTitle > p {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 10px;\n}\n\n#resetTitle > span {\n    font-size: 14px;\n}\n\n.tip_no_border {\n    border-right:none !important;\n    border:none !important;\n    background-color:#F4F4F4 !important;\n    box-shadow:none !important;\n}\n\n#verifyCodeMsg {\n    margin-left: 340px;\n}\n#btnDiv {\n    clear:both;\n    padding-top:10px;\n    margin-left: 340px;\n    max-width: 240px;\n}\n\n#errorMsg {\n    margin-bottom: 5px;\n    display: block;\n    color: red;\n}\n\n.pwdStrengthContainer {\n    display:inline-block;\n    float: right;\n    margin-right:10px;\n    margin-top:10px;\n    clear: both;\n    font-size: 12px;\n    line-height: 13px;\n}\n#TIP span {\n    display: none;\n}\n#TIP.high .high{\n    display: inline-block;\n    color: #333;\n}\n#TIP.low .low{\n    display: inline-block;\n    color: #333;\n}\n#TIP.mid .mid{\n    display: inline-block;\n    color: #333;\n}\n\n.tootip-img {\n    width:16px;\n    height:16px;\n    margin:0 auto 3px 0;\n}\n\n.tootip-div{\n    margin: -21px 0 10px 20px;\n}\n\n.errorInfo {\n        width: 390px;\n        margin-left: 334px;\n}\n\n.errorInfo>span {\n    margin-left: 6px;\n    display: inline-block;\n    width: 315px;\n    color: #e41e2b;\n}\n\n#content {\n    position: relative;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 15px auto 10px;\n    padding: 30px 30px 30px 30px;\n    width: 800px;\n    color: #9B9B9B;\n    position: relative;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    border-radius: 2px;\n}\n.formDiv > ul {\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 320px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: right;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n    position: relative;\n}\n\n.pwd-state-icon {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 28px;\n    color:#333;\n}\n\n#step {\n    height: 70px;\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ");\n    vertical-align: middle;\n}\n\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n    background-color: #e20074!important;\n}\n\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    color: #252b3a;\n    text-align: center;\n    min-width: 70px;\n    background-color: #FFFFFF;\n    border: 1px solid #adb0b8;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#formUl > li {\n    display: flow-root;\n}\n\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n        width: 100%;\n    }\n\n    #content .widthLimit {\n        padding: 0;\n        margin: 0px;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        /* background-image: none !important; */\n    }\n\n    #resetTitle {\n        margin-left: 20px;\n    }\n\n    .formDiv {\n        height: auto;\n        margin: 0;\n        width: 100%;\n        color: #9B9B9B;\n        position: relative;\n        box-sizing: border-box;\n        box-shadow: none;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        background-color: transparent;\n    }\n\n    .formDiv > ul {\n        width: 100%;\n        min-width: 0;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n    }\n\n    .field {\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container {\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container:not(#msgCodeId){\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        width: 120px;\n        font-size: 12px;\n        margin-right: 8px;\n        line-height: 18px;\n        height: fit-content;\n    }\n\n    #verifyCodeMsg {\n        margin-left: 0px;\n    }\n    #btnDiv {\n        max-width: none;\n        margin-left: 0px;\n        display: flex;\n        justify-content: center;\n        flex-flow: row;\n        flex-wrap: wrap;\n    }\n\n    #msgCodeId {\n        width: 60px !important;\n        height: 32px !important;\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #msgBtn {\n        font-size: 12px;\n        padding-left: 8px;\n        padding-right: 8px;\n        width: fit-content;\n    }\n\n    .tiny-tip-content-top {\n        /* font-size: 12px !important; */\n        left: 10% !important;\n        right: 10% !important;\n        line-height: 1;\n    }\n\n    .passwordStrength {\n        width: 24px;\n        transform: translateY(-7px) !important;\n    }\n\n    .tootip-img {\n        margin-bottom: 5px;\n    }\n\n    .errorInfo > span {\n        width: auto;\n    }\n\n    .errorInfo {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n/* 小屏时换行显示 */\n@media (max-width: 400px) {\n    .fieldLabel {\n        width: fit-content;\n    }\n    .fieldContainer .field {\n        min-width: 270px;\n    }\n\n    .fieldContainer {\n        flex-wrap: wrap;\n    }\n}", ""]);

// exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#loading {\n    display: none\n}\n\n#content div{\n    box-sizing: border-box;\n}\n\n.ssologinDiv {\n    width: 932px;\n    margin: 80px auto 0;\n    background-color: #fff;\n    box-shadow: 0 8px 16px 0 rgb(0 0 0 / 10%);\n    padding: 20px 30px 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n}\n\n.ssologinDiv .ssologinTitle {\n    font-size: 24px;\n    color: #252B3A;\n    text-align: center;\n    line-height: 34px;\n    margin-top: 20px;\n}\n\n.ssologinDiv .nextBtn {\n    box-shadow: none;\n    background-color: #CA141D;\n    border: 1px solid #CA141D;\n    border-radius: 4px;\n    color: rgba(255, 255, 255, 1);\n    width: 380px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    cursor: pointer;\n}\n\n.ssologinDiv .nextBtn.nextBtnDisabled{\n    cursor: not-allowed;\n    opacity: 0.3;\n}\n\n.ssologinDiv .domainListContainer{\n    width: 550px;\n    border: 1px solid #ADB0B8;\n    overflow-y: auto;\n    max-height: 300px;\n    margin: 32px 0;\n}\n\n.ssologinDiv .domainListContainer .domainDiv{\n    border-bottom: 1px solid #ADB0B8;\n    margin: 0 10px;\n    padding: 10px;\n}\n\n.ssologinDiv .domainListContainer .domainDiv:last-child{\n    border: none;\n}\n\n.ssologinDiv .domainListContainer .domainDiv .domainName{\n    margin-bottom: 10px;\n}\n\n.ssologinDiv .domainListContainer .idpDiv{\n    display: flex;\n    margin-bottom: 5px;\n    cursor: pointer;\n    align-items: center;\n}\n\n.ssologinDiv .domainListContainer .idpDiv .idpId{\n    word-break: break-all;\n    flex: 1;\n    \n}\n\n.option-button {\n    width: 18px;\n    height: 18px;\n    background: url(" + escape(__webpack_require__(103)) + ");\n\tbackground-size: cover;\n\tmargin-right: 15px;\n}\n\n.option-button-checked {\n    background: url(" + escape(__webpack_require__(104)) + ");\n}\n\n@media (max-width: 1269px) {\n    html,body,#content{\n        max-width: 1270px;\n        min-width: 0px;\n    }\n}\n\n@media (max-width: 932px) {\n    .ssologinDiv{\n        width: 100%;\n    }\n}\n\n@media (max-width: 600px) {\n    #content{\n        background: #fff !important;\n       \n    }\n    .ssologinDiv{\n        margin-top: 0px;\n        box-shadow: none;\n    }\n\n    .ssologinDiv #btnDiv{\n        width: 100%;\n    }\n\n    .ssologinDiv .nextBtn, .ssologinDiv .domainListContainer{\n        width: 100%;\n    }\n}\n", ""]);

// exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#loading {\n\tdisplay: none\n}\n#content {\n\theight: auto;\n}\n\n.upgradeContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 992px;\n\tbackground: rgba(255,255,255,1);\n\tborder-radius: 4px;\n\tmargin: 55px auto 0px;\n\tmin-height: 708px;\n}\n\n.upgradeTitle {\n\tfont-size: 24px;\n\tline-height: 33px;\n\tpadding-top: 40px;\n\tpadding-bottom: 16px;\n\tfont-weight: 500;\n\tcolor: #252B3A;\n\ttext-align: center\n}\n\n.upgradeDesc {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 20px;\n\tcolor: #252B3A;\n\tmargin: 0 102px;\n    max-width: calc(100% - 204px);\n}\n\n.upgradeImg {\n\twidth: 444px;\n\tmargin: 47px 0 16px 0;\n}\n\n.agreementDiv {\n\tmargin: 0 102px;\n\tdisplay: flex;\n\tflex-direction: row;\n    width: calc(100% - 204px);\n}\n\n.agreementDiv a, .upgradeDesc a{\n    color: #526ECC;\n}\n\n.agreementDiv .checkbox {\n\twidth: 17px;\n\theight: 16px;\n\tbackground-image: url(" + escape(__webpack_require__(343)) + ");\n\tbackground-repeat: no-repeat;\n\tbackground-size: 16px 16px;\n\tmin-height: 0;\n\tpadding-left: 0;\n\tmargin-top: 2px;\n    margin-right: 8px;\n    cursor: pointer;\n}\n\n.bottomBtns .cancelBtn,.bottomBtns .upgradeBtn {\n\twidth: 430px;\n\theight: 40px;\n\tline-height: 40px;\n\ttext-align: center;\n\tcursor: pointer\n}\n\n.agreementDiv .checked_checkbox {\n\tbackground-image: url(" + escape(__webpack_require__(318)) + ")\n}\n\n.agreementDiv .agreementDesc {\n\tflex: 1\n}\n\n.bottomBtns {\n    display: flex;\n    flex-direction: column;\n\tmargin-top: 32px;\n\tmargin-bottom: 32px;\n}\n\n.bottomBtns .upgradeBtn {\n\tcolor: rgba(255,255,255,1);\n\tbackground: #c7000b;\n\tborder: 1px solid #c7000b;\n\tborder-radius: 2px;\n}\n\n.bottomBtns .cancelBtn {\n\tcolor: rgba(153,153,153,1);\n\tbackground: rgba(255,255,255,.8);\n\theight: 16px;\n\tline-height: 16px;\n\tmargin-top: 16px;\n}\n\n.bottomBtns .upgradeBtn:hover {\n\tbackground: #D64A52;\n\tborder: 1px solid #D64A52\n}\n\n.bottomBtns .upgradeBtnDisabled,.bottomBtns .upgradeBtnDisabled:hover {\n\tbackground: rgba(238,179,181,1);\n\tborder: 1px solid rgba(238,179,181,1);\n\tborder-radius: 2px;\n\tcolor: rgba(255,255,255,1);\n\tcursor: not-allowed\n}\n\n.errorMsg {\n\tline-height: 12px;\n\tfont-size: 12px;\n\tmargin-top: 4px;\n\tcolor: #FA2A2D\n}\n\n.upgradeGoBack {\n    line-height: 92px;\n    height: 92px;\n    font-size: 20px;\n    text-align: left;\n    width: 100%;\n    border-bottom: 1px solid rgba(237,237,237,1);\n}\n.upgradeGoBack span{\n    cursor: pointer;\n}\n\n.right-arrow {\n    display: inline-block;\n    position: relative;\n    width: 15px;\n    height: 10px;\n    margin-left: 40px;\n}\n\n.right-arrow::after {\n    display: inline-block;\n    content: \" \";\n    height: 12px;\n    width: 12px;\n    border-width: 0px 0px 1px 1px;\n    border-color: rgba(0,0,0,1);\n    border-style: solid;\n    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    margin-top: -9px;\n}\n\n.upgradeLoading{\n    margin: auto;\n}\n\n.upgradeErrorImg{\n\tmargin-top: 150px;\n\twidth: 64px;\n\theight: 64px;\n}\n\n.upgradeErrorTitle{\n\tfont-size: 20px;\n\tfont-weight: 400;\n\tcolor: #000000;\n\tline-height: 28px;\n\theight: 28px;\n\tmargin-top: 32px;\n}\n\n.upgradeErrorDesc{\n\topacity: 0.5;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\ttext-align: center;\n\tcolor: #000000;\n\tline-height: 20px;\n\theight: 20px;\n\tmargin-top: 8px;\n}\n\n.upgradeErrorBtn{\n\twidth: 430px;\n\theight: 40px;\n\tbackground: #c7000b;\n\tborder-radius: 4px;\n\tline-height: 40px;\n\tcolor: #FFFFFF;\n\ttext-align: center;\n\tfont-size: 16px;\n\tmargin-top: 32px;\n\tcursor: pointer;\n}\n\n.upgradeErrorBtn:hover{\n\tbackground: #D64A52;\n}\n\n.sdkLoading{\n\twidth: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n}\n\n#hwidsdk_mudule_container{\n\twidth: 100%;\n\theight: 100%;\n}\n\n@media(max-width:1200px) {\n\t#content,body,html {\n\t\theight: 100%;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tmin-width: 0\n\t}\n}\n\n@media(max-width:992px) {\n\t.upgradeContainer {\n\t\twidth: 100%\n\t}\n}\n\n@media(max-width:500px) {\n\t#content {\n\t\tbackground: 0 0!important;\n\t\tmin-height: 0\n\t}\n\n\t.upgradeContainer {\n\t\twidth: 100%;\n\t\tmargin: 0;\n        min-height: auto;\n\t}\n\n\t.upgradeTitle {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t\tmargin-left: 24px;\n\t\tmargin-right: 24px;\n\t\tmargin-bottom: 8px;\n\t}\n\n\t.upgradeDesc {\n\t\tmargin: 0px 24px 0px;\n        max-width: calc(100% - 48px);\n    }\n    \n    .upgradeImg{\n\t\twidth: calc(100% - 70px);\n\t\tmargin: 24px 0px 10px;\n    }\n\n\t.agreementDiv {\n\t\tmargin: 0 24px;\n        width: calc(100% - 48px);\n\t}\n\n\t.agreementDiv .checked_checkbox {\n\t\tbackground-image: url(" + escape(__webpack_require__(317)) + ")\n\t}\n\n\t.bottomBtns {\n\t\tflex-direction: column;\n\t\twidth: calc(100% - 50px);\n\t\tmargin-top: 40px\n\t}\n\n\t.bottomBtns .upgradeBtn {\n\t\twidth: 100%\n\t}\n\n\t.bottomBtns .cancelBtn {\n\t\tmargin-left: 0;\n\t\tmargin-top: 16px;\n\t\twidth: 100%\n    }\n\n    .upgradeGoBack {\n        display: none;\n    }\n\n    .right-arrow {\n        margin-left: 20px;\n    }\n\n    .right-arrow::after {\n        height: 10px;\n        width: 10px;\n        margin-top: -6px;\n    }\n}", ""]);

// exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content .widthLimit {\n    width: 800px;\n    position: relative;\n    margin: 0 auto;\n    padding: 0 20px\n}\n\n.title {\n    margin-top:2%;\n    color: #252B3A;\n    font-size: 24px;\n    font-style: normal;\n    text-align: left;\n    line-height: 30px;\n    font-weight: 400;\n}\n\n.subTitle {\n    font-size: 14px;\n}\n\n.container {\n    height: auto;\n    width: auto;\n    min-height: 300px;\n    margin: 15% auto 0 auto;\n    text-align:center;\n}\n\n.errorMsg {\n    display: inline-block;\n    font-size: 30px;\n    margin-left: 10px;\n    color: #333333;\n    vertical-align: middle;\n}\n\n.helpMsg {\n    font-size:14px;\n    color:#333333;\n    margin-top:15px;\n}\n\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    padding-bottom: 30px;\n    padding-top: 30px;\n    margin: 5% auto 0px;\n    color: #9B9B9B;\n    position: relative;\n    width: 800px;\n    background-color: #FFFFFF;\n    box-shadow: 0 1px 3px 0 rgba(2,25,42,0.10);\n}\n\n.formDiv > ul {\n    min-width: 670px;\n}\n\n.pwdStrengthContainer {\n    display:inline-block;\n    float: right;\n    margin-right:10px;\n    margin-top:10px;\n    clear: both;\n    font-size:12px;\n    line-height: 13px;\n}\n\n#btnDiv {\n    clear:both;\n    padding-top:10px;\n    display: table;\n    margin: 0 auto;\n}\n\n#errorMsg {\n    margin-bottom: 5px;\n    display: block;\n    color: red;\n}\n\n.fieldContainer {\n    margin: 0px auto 0px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 260px;\n    float: left;\n    margin-right: 20px;\n    height: 32px;\n    line-height: 32px;\n    color: #333;\n    font-size: 12px;\n}\n.fieldLabel span {\n    float: right;\n}\n.field {\n    width: 315px;\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n}\n\ninput[type=password]::-ms-reveal {\n    width: 0;\n    height: 0;\n}\n#TIP span {\n    display: none;\n}\n#TIP.high .high{\n    display: inline-block;\n    color: #333;\n}\n#TIP.low .low{\n    display: inline-block;\n    color: #333;\n}\n#TIP.mid .mid{\n    display: inline-block;\n    color: #333;\n}\n.tootip-img {\n    width:16px;\n    height:16px;\n    margin:0 auto 3px 0;\n}\n\n.tootip-div{\n    margin: -21px 0 10px 20px;\n}\n\n.errorInfo {\n    width:100%;\n    margin-left: 50%;\n    line-height: 36px;\n}\n\n.errorInfo>span {\n    margin-left: 6px;\n    margin-top: -7px;\n    display: inline-block;\n    color: #e41e2b;\n}\n\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    background-color: #F66F6A;\n}\n\n.cancelButton {\n    text-align: center;\n    color: #ffffff;\n    min-width: 70px;\n    border: 1px solid #CCCCCC;\n    background-color: #CCCCCC;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #ffffff;\n    cursor: pointer;\n    background-color: #DDDDDD;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n.errorTip span {\n    color: #F66F6A;\n}\n\n#checkError, #serverError, #mobileErrorMsg, #mobileUsersSelectMsg, #isMobileTip {\n    color: #FF0000;\n    display: block;\n    clear: both;\n    margin: 10px 0 0 0;\n}\n\n.inputField {\n    margin-bottom: 16px !important;\n    font-size: 14px !important;\n    border-bottom: 1px solid #DFE1E6;\n    position: relative;\n}\n.inputField:hover {\n    border-bottom: 1px solid #8A8E99;\n}\n.inputField:last-child {\n    margin-bottom: 0px !important;\n    font-size: 14px !important;\n}\n\n#fpLink {\n    color: #00aaff;\n    float:right;\n}\n\n\n/*-------- content end ---------*/\n\n/*------ page layout begin ------*/\n\n\n\nbody, html {\n    height:100%;\n    margin: 0;\n    padding: 0;\n    min-width: 1260px;\n}\n\n*{\n    margin: 0;\n    padding: 0;\n}\n.placeholder {\n    color: #aaa!important;\n    font-family: \"Microsoft Yahei\"!important;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#formUl > li {\n    display: flow-root;\n}\n\n.tiny-textbox-container {\n    height: 32px !important;\n    font-size: 12px;\n}\n\n/*适配移动端*/\n\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n        width: 100%;\n    }\n\n    #content .widthLimit {\n        padding: 0;\n        margin: 0 auto px;\n        width: 100%;\n        max-width: 425px;\n        padding-left: 20px;\n        padding-right: 20px;\n        box-sizing: border-box;\n    }\n\n    #resetTitle {\n        margin: 20px 0px;\n        text-align: center;\n    }\n\n    .formDiv {\n        height: auto;\n        margin: 0;\n        margin-top: 130px;\n        width: 100%;\n        background-color: #00000000;\n        box-shadow: none;\n        position: relative;\n        box-sizing: border-box;\n    }\n\n    .formDiv > ul {\n        width: 100%;\n        min-width: 0;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n    }\n\n    .fieldContainer .fieldLabel {\n        width: auto !important;\n    }\n\n    .field .tiny-textbox-container:not(#msgCodeId){\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        min-width: 113px !important;\n        width: 113px !important;\n    }\n\n    #msgCodeId {\n        width: 120px !important;\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    .tiny-tip-content-top {\n        font-size: 12px !important;\n        left: 10% !important;\n        right: 10% !important;\n        line-height: 1;\n    }\n\n    .passwordStrength {\n        width: 24px;\n    }\n\n    .tootip-img {\n        margin-bottom: 5px;\n    }\n\n    .errorInfo > span {\n        width: auto;\n    }\n\n    .errorInfo {\n        width: 100%;\n        margin-left: 0;\n    }\n\n    .container {\n        width: auto;\n    }\n\n    .container .errorMsg {\n        line-height: 1.5;\n    }\n}", ""]);

// exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".fphoneDiv {\n    width: 1000px;\n    padding-left:40px;\n    padding-right:40px;\n    margin: 0 auto;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n#content {\n    position: relative;\n    margin: 0 0 -70px 0 !important;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 50px auto 10px;\n    padding-bottom: 30px;\n    width: 63%;\n    color: #9B9B9B;\n    position: relative;\n    font-size: 12px;\n}\n.formDiv > ul {\n    width: 85%;\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 160px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: lef;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 24px;\n    line-height: 30px;\n    color:#333;\n}\n\n#step {\n    /* height: 70px; */\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n    display: table;\n}\n\n#step .simple-next hr {\n    width: 10px !important;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n\tbackground-color: #e20074!important;\n}\n\n/* base fphone.css */\n.codeSelect{\n    display:inline-block;\n    vertical-align: middle;\n}\n\n.phoneInput{\n    display:inline-block;\n    margin:3px;\n}\n\n.btnDiv {\n    clear:both;\n    padding-top:30px;\n    margin: 0 auto;\n    display: table;\n}\n\n.field {\n    /* width: 650px !important; */\n}\n\n.formDiv {\n    /* margin-left: 180px; */\n    /* width: 83% !important; */\n}\n\n#step3 > ul{\n    text-align:center;\n    margin-top:3%;\n}\n\n.msgBtn {\n    height: 34px;\n    line-height: 34px;\n}\n\n.errorTipText {\n    margin: 0 auto;\n    color:red;\n}\n\n/*----sm-step begin----*/\n.step1_img{\n    background-image: url(" + escape(__webpack_require__(42)) + ");\n}\n.step2_img{\n    background-image: url(" + escape(__webpack_require__(43)) + ");\n}\n.step2_img_hl{\n    background-image: url(" + escape(__webpack_require__(44)) + ");\n}\n.step3_img{\n    background-image: url(" + escape(__webpack_require__(45)) + ");\n}\n.step3_img_hl{\n    background-image: url(" + escape(__webpack_require__(46)) + ");\n}\n\n\n/* main.css */\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    text-align: center;\n    color: #252b3a;\n    min-width: 70px;\n    border: 1px solid #adb0b8;\n    background: #fff;\n    border-radius: 3px 3px 3px 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    cursor: pointer;\n    border-color: #5e7ce0;\n}\n\n.selectedStepTitle {\n    color: #526ECC !important;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#step3 {\n    clear: both;\n}\n\n.success-title {\n    font-size: 18px;\n    line-height: 26px;\n}\n\n.success-title > img {\n    width: 40px;\n    height: 40px;\n}\n\n.number-info {\n    font-size: 12px;\n    color: #8A8E99;\n    line-height: 18px;\n    margin-bottom: 30px;\n}\n\n#redirect2Login {\n    margin-bottom: 10px;\n}\n/* 适配移动端 */\n\n@media (max-width: 768px) {\n    body, html {\n        min-width: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #step {\n        /* display: none; */\n    }\n\n    #content {\n        min-width: 0;\n        min-height: 0;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    .pageTitle {\n        margin-bottom: 32px;\n        line-height: 1.5;\n    }\n\n    .fphoneDiv {\n        width: 100%;\n        box-sizing: border-box;\n        box-shadow: none;\n        background-color: transparent;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        font-size: 12px;\n    }\n\n    .formDiv {\n        margin-left: 0;\n        min-height: 0;\n        margin: 0;\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        min-width: 100px;\n        width: 100px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    .msgBtn {\n        height: 32px;\n        margin-left: 0px;\n        font-size: 12px;\n    }\n\n    .tiny-combobox-container {\n        height: 32px !important;\n    }\n\n    .tiny-combobox-editor {\n        height: 32px !important;\n    }\n\n    .tiny-textbox-container {\n        width: 100% !important;\n        /* max-width: 240px; */\n        flex-grow: 1;\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n        margin-right: 0;\n    }\n\n    #checkCodeId {\n        max-width: 90px !important;\n        margin-bottom: 8px;    \n    }\n\n    #inputVerifyCodeImg {\n        /* margin-top: 8px; */\n        height: 30px;\n    }\n\n    #step2  .tiny-textbox-container {\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #step2 .field {\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > div:not(#emailMsgBtn){\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    #step2 .field > span {\n        flex-grow: 1;\n        width: 100%;\n    }\n\n    #step2 .field > div > span {\n        width: 100%;\n    }\n\n    #step2 .filed span #emailVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #emailMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    .phoneInput {\n        width: auto !important;\n        min-width: 150px;\n        flex-grow: 1;\n        margin-left: 0px;\n    }\n\n    #phoneError {\n        display: block;\n    }\n\n    #step2 .filed span #smsVerifyCodeId{\n        width: 100% !important;\n    }\n\n    #smsMsgBtn {\n        width: auto !important;\n        min-width: 110px;\n        flex-grow: 1;\n    }\n\n    #step3 ul {\n        margin-left: 0 !important;\n        text-align: center !important;\n    }\n\n    #step3 ul > li > div {\n        margin-right: 0 !important;\n    }\n\n    #step3 ul > li > div > span{\n        line-height: 32px;\n    }\n}", ""]);

// exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/* 新样式 */\n#loginVerificationDiv {\n    background-color: #FFFFFF;\n    max-width: 600px;\n    box-shadow: 1px 2px 8px #ccc;\n    border-radius: 2px;\n    margin: 0 auto;\n    margin-top: 60px;\n    margin-bottom: 120px;\n}\n#loginVerificationTitle {\n    width: 100%;\n    color: #333333;\n    font-size: 24px;\n    text-align: center;\n    letter-spacing: 0;\n    line-height: 34px;\n    margin: 30px 0px 20px 0px;\n    float: left;\n}\n\n#verificationContainer {\n    padding: 0px 30px 30px 30px;\n    float: left;\n}\n#verificationContainer div {\n    float: left;\n    text-align: left;\n}\n#verificationContainer .fieldItem {\n    width: 100%;\n    margin-bottom: 15px;\n}\n#verificationContainer .fieldItem:last-child {\n    margin-bottom: 0px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span {\n    display: block;\n    word-wrap: break-word;\n    max-height: 180px;\n    overflow-y: auto;\n}\n/* 滚动条样式 */\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar {\n    width: 4px;\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    background: rgba(0,0,0,0.2);\n}\n#verificationContainer .fieldItem.presetLoginInfo span::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);\n    border-radius: 0;\n    background: rgba(0,0,0,0.1);\n}\n\n#verificationContainer .fieldItem.presetLoginInfo .presetTips {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-top: 5px;\n}\n#verificationContainer .fieldItem .itemLabel {\n    width: 160px;\n    font-size: 14px;\n    color: #999999;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent {\n    width: 380px;\n    display: inline-block;\n}\n#verificationContainer .fieldItem .itemContent .tiny-input-text {\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n}\n#verificationContainer .fieldItem .itemContent .hintContext {\n    font-size: 12px;\n    color: #F66F6A;\n    margin-left: 10px;\n}\n#verificationContainer .fieldItem .itemContent .bindTips {\n    display: block;\n    color: #F66F6A;\n    font-size: 12px;\n    margin-top: 5px;\n}\n/* 绑定虚拟MFA按钮 */\n#verificationContainer .fieldItem .itemContent .bindMFABtn {\n    cursor: pointer;\n    color: #526ECC;\n}\n#verificationContainer .fieldItem .itemContent .bindMFABtn:hover {\n    color: #006AD4;\n}\n\n/* 验证码输入框 */\n#verificationContainer .fieldItem .inputDiv {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n    height: 32px;\n}\n#verifyCodeId {\n    float: left;\n}\n#verificationContainer .fieldItem .inputDiv .tiny-input-text {\n    border: none;\n}\n#verificationContainer .fieldItem .inputDiv .seperate {\n    width: 1px;\n    height: 24px;\n    margin: 4px 0px;\n    background: #CCCCCC;\n}\n#verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    cursor: pointer;\n    color:  #526ECC;\n}\n#verificationContainer .fieldItem .inputDiv .retrieveTip {\n    height: 32px;\n    line-height: 32px;\n    padding: 0px 20px;\n    font-size: 12px;\n    color: #999999;\n}\n#verificationContainer .fieldItem #sendCodeDoneTip {\n    font-size: 12px;\n    color: #999999;\n    margin: 5px 0px 0px 0px;\n}\n#verificationContainer .fieldItem #msgErrorTip {\n    width: 100%;\n    margin: 5px 0px 0px 0px;\n}\n\n/* 底部提示语 */\n#loginVerificationTips {\n    display: block;\n    float: left;\n    font-size: 12px;\n    color: #c3c3c3;\n    padding: 0 30px 20px;\n}\n/* END */\n\n/* 分割线 */\n#splitLine {\n    width: 100%;\n    height: 1px;\n    background-color: #E2E2E2;\n    border-radius: 1px;\n    float: left;\n    margin-bottom: 30px;\n}\n\n/* 底部按钮组 */\n#btnGroupDiv {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-bottom: 30px;\n    background-color: #FFFFFF;\n}\n#btnGroupDiv .btnDiv {\n    display: inline-block;\n    width: 263px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333333;\n    text-align: center;\n    border-radius: 2px;\n    cursor: pointer;\n}\n#btnGroupDiv #cancelBtn {\n    background: #FFFFFF;\n    border: 1px solid #adb0b8;\n    color: #252b3a;\n}\n\n#btnGroupDiv #cancelBtn:hover{\n    color: #526ecc;\n    border-color: #5e7ce0;\n}\n\n#btnGroupDiv #submitBtn {\n    margin-left: 10px;\n    background: #F66F6A;\n    border: 1px solid #F66F6A;\n    color: #FFFFFF;\n}\n\n#btnGroupDiv #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n#btnGroupDiv #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* 右侧绑定虚拟MFA弹窗框 */\n.bingMFAPage {\n    position: fixed;\n    top: 45px;\n    bottom: 70px;\n    left: 0;\n    right: 0;\n    background: rgb(0, 0, 0, 0.5);\n}\n.bingMFAPage .bindMFAModal {\n    width: 700px;\n    float: right;\n    background: #FFFFFF;\n    position: relative;\n    overflow-y: overlay;\n    overflow-x: hidden;\n    height: calc(100% - 60px);\n}\n.modalTitle {\n    width: 100%;\n    font-size: 24px;\n    line-height: 24px;\n    text-align: left;\n    margin: 30px 0px;\n    padding-left: 30px;\n    border-left: 3px solid #3399FF;\n}\n.modalContent {\n    float: left;\n    padding: 0px 0px 30px 20px;\n}\n.modalContent .stepDiv {\n    float: left;\n    width: 100%;\n}\n.modalContent .stepDiv#step1 {\n    height: 210px;\n}\n.modalContent .stepDiv#step2 {\n    height: 250px;\n}\n.modalContent .stepDiv .stepProgress {\n    width: 32px;\n    height: 100%;\n    float: left;\n    transform: translateY(6px);\n}\n.modalContent .stepDiv .stepProgress .stepImage {\n    width: 20px;\n    height: 20px;\n    line-height: 21px;\n    font-size: 14px;\n    color: #FFFFFF;\n    background: url(" + escape(__webpack_require__(49)) + ") no-repeat;\n    background-size: 100% 100%;\n}\n.modalContent .stepDiv .stepProgress .stepFill {\n    width: 2px;\n    height: 100%;\n    margin: -3px 14px 0px 14px;\n    background-color: #526ECC;\n}\n.modalContent .stepDiv .stepContent {\n    float: left;\n    width: 585px;\n    margin-left: 20px;\n}\n.modalContent .stepDiv .stepContent .title {\n    font-size: 16px;\n    padding: 5px 0px;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .tips {\n    font-size: 12px;\n    color: #8A8E99;\n    text-align: left;\n}\n.modalContent .stepDiv .stepContent .appDownload {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .appDownload .HWCloud {\n    width: 120px;\n    height: 120px;\n    text-align: center;\n    background: url(" + escape(__webpack_require__(48)) + ") center no-repeat;\n    background-size: cover;\n}\n.modalContent .stepDiv .stepContent .content {\n    float: left;\n    padding-top: 10px;\n}\n.modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n    float: left;\n    width: 120px;\n    height: 120px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n    float: left;\n    width: 450px;\n    font-size: 14px;\n    margin-left: 10px;\n    background: #F4F5F6;\n    padding: 5px 0px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem {\n    float: left;\n    padding: 5px 15px 5px 15px;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoLabel {\n    float: left;\n    width: 90px;\n    text-align: left;\n    color: #999999;\n}\n.modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n    float: left;\n    display: inline-block;\n    width: 330px;\n    text-align: left;\n    word-wrap: break-word;\n    word-break: break-all;\n    overflow: hidden;\n}\n.modalContent #msgMFAErrorTip {\n    padding-left: 172px;\n    text-align: left;\n    font-size: 12px;\n    color: #F66F6A;\n}\n.MFACodeDiv .codeFieldItem {\n    float: left;\n    padding: 10px 0px;\n    margin-right: 20px;\n}\n.MFACodeDiv .codeFieldItem .codeLabel {\n    float: left;\n    width: fit-content;\n    margin-right: 16px;\n    height: 32px;\n    line-height: 32px;\n    font-size: 14px;\n    color: #666666;\n}\n.MFACodeDiv .codeFieldItem .codeInput {\n    float: left;\n}\n.MFACodeDiv .codeFieldItem .codeInput .tiny-input-text {\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n}\n\n/* 页面底部 */\n.modalFooter {\n    display: block;\n    position: fixed;\n    bottom: 80px;\n    width: 700px;\n    height: 60px;\n    float: left;\n    background-color: #f4f4f4;\n    border-top: 1px solid #eeeeee;\n}\n.modalFooter .btnDiv {\n    width: 100px;\n    padding: 5px 20px;\n    font-size: 14px;\n    border-radius: 2px;\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-top: 14px;\n    cursor: pointer;\n}\n.modalFooter #submitBtn {\n    border-color: #F66F6A;\n    background: #F66F6A;\n    color: #FFFFFF;\n}\n.modalFooter #submitBtn:hover {\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n.modalFooter #submitBtn.disabledSubmitBtn {\n    background-color: #F7F7F7;\n    border: 1px solid #DDDDDD;\n    color: #A0A2A8;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n.modalFooter #cancelBtn {\n    width: 80px;\n    margin-left: 10px;\n    color: #252b3a;\n    background: #fff;\n    border-color: #adb0b8;\n    cursor:pointer;\n}\n.modalFooter #cancelBtn:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n/* END */\n\n.commonTxt{\n    line-height: normal;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.titleText {\n    height:36px;\n    font-size: 24px;\n    color: #333;\n    text-align: left;\n}\n\n.hintTitle{\n    font-size:18px;\n    color:#333333;\n}\n\n.hintContextSMS{\n    font-weight:400;\n    font-size:14px;\n    color:#666666;\n}\n\n.presetInfo{\n    width: 650px;\n    word-wrap: break-word;\n    color: #999999;\n    text-align: left;\n    border:1px dashed #cccccc;\n    border-radius: 5px;\n    margin-top: 20px;\n    padding-top:10px;\n    padding-right:10px;\n    padding-left:10px;\n    padding-bottom:40px;\n    font-size: 12px;\n    background-color: #FFFFFF;\n}\n\n.loginInfo{\n    font-size: 14px;\n    color: #666666;\n    margin-top: 20px;\n    align:\"left\"\n}\n\n#getMsgCodeBtn{\n    border: 1px solid #CCCCCC;\n    display: inline-block;\n    margin-left: 10px;\n    text-align: center;\n    height: 36px;\n    border-radius: 4px;\n    line-height: 36px;\n    vertical-align: middle;\n    color: #666;\n    padding-left:5px;\n    padding-right: 5px;\n}\n\n#getMsgCodeBtn:hover{\n    color: #009ae7;\n}\n\n.getMsgCodeBtn{\n    cursor: pointer;\n    background-color: #FFFFFF;\n}\n\n.disabledMsgBtn{\n    color: #666 !important;\n    background-color: #cccccc;\n    cursor: default;\n}\n\n.btnCommon{\n    width: 100px;\n    height: 35px;\n    text-align: center;\n    font-size: large;\n    line-height: 35px !important;\n    border-radius: 3px;\n    color: #333333;\n}\n\n\n\n#cancelBtnBtn{\n    background-color: #FFFFFF;\n    border: 1px solid #CCC;\n    cursor: pointer;\n}\n\n#cancelBtnBtn:hover{\n    /*background-color: #DDDDDD;*/\n    border-color: #60b0ff;\n    background-color: #FFFFFF;\n}\n\n.changePhonelink{\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 14px;\n    color: #526ECC;\n}\n\n#getMsgDiv{\n    margin-top:20px;\n    height:38px;\n    font-size: 14px;\n    margin-right: -200px;\n}\n\n.msgCodeHint{\n    display:inline-block;\n    min-width:107px;\n}\n\nbutton:focus{\n    outline:none;\n}\n\n/* 使步骤条与内容高度一致 */\n.stepDiv {\n    display: table;\n}\n\n.stepDiv > .stepProgress, .stepDiv > .stepContent {\n    display: table-cell;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.tiny-combobox-container {\n    height: 32px;\n    line-height: 30px;\n    border: 1px solid #d5d5d5;\n    border-radius: 2px;\n    background: #fff;\n    box-shadow: 1px 1px 1px #fff,inset 1px 1px 1px rgba(0,0,0,0.1);\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n@media only screen and (max-width: 1920px) {\n\n}\n@media only screen and (max-width: 1680px) {\n    \n}\n@media only screen and (max-width: 1440px) {\n    \n}\n@media only screen and (max-width: 1366px) {\n    \n}\n@media only screen and (max-width: 1280px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n@media only screen and (max-width: 1024px) {\n    .modalContent .stepDiv#step3 {\n        margin-bottom: 20px;\n    }\n    .modalFooter {\n        bottom: 110px;\n    }\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n    }\n\n    #btnGroupDiv {\n        background-color: transparent;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginVerificationDiv {\n        max-width: none;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 0px;\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 2px;\n        /* margin: 0 auto; */\n        margin-top: 0px;\n        margin-bottom: 20px;\n    }\n\n    #verificationContainer, #loginVerificationTips {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    #verificationContainer .fieldItem .inputDiv .getVerifyCodeBtn {\n        padding: 0 8px;\n    }\n\n    #verificationContainer .fieldItem {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        flex-wrap: nowrap;\n    }\n\n    #verificationContainer .fieldItem .itemContent {\n        width: auto;\n        font-size: 12px;\n    }\n\n    #verificationContainer .fieldItem .itemLabel {\n        max-width: 80px;\n        font-size: 12px;\n        margin-right: 8px;\n    }\n\n    #verificationContainer .fieldItem .itemContent .bindTips {\n        clear: both;\n    }\n\n    #verifyCodeId {\n        width: 100px !important;\n    }\n\n    #bindPhoneId {\n        width: 100% !important;\n    }\n\n    #bindEmailId {\n        width: 100% !important;\n    }\n\n    #btnGroupDiv {\n        flex-wrap: wrap;\n    }\n\n    #btnGroupDiv .btnDiv {\n        width: calc(50% - 16px);\n        padding-left: 8px;\n        padding-right: 8px;\n        margin: 8px;\n        min-width: 160px;\n        display: block;\n        box-sizing: border-box;\n        float: left;\n    }\n\n    #btnGroupDiv #submitBtn {\n        margin-left: 8px;\n    }\n\n    #countryCodeSelectId {\n        margin-bottom: 8px;\n    }\n\n    .modalTitle {\n        width: auto;\n    }\n\n    .bingMFAPage {\n        bottom: 0px;\n    }\n\n    .bingMFAPage .bindMFAModal {\n        width: 100%;\n    }\n\n    .modalFooter {\n        width: 100%;\n        bottom: 0px;\n    }\n\n    .modalContent .stepDiv .stepProgress {\n        /* display: none; */\n    }\n\n    .modalContent .stepDiv .stepContent {\n        float: left;\n        width: calc(100% - 32px);\n        margin-left: 0;\n    }\n\n    .modalContent {\n        padding-right: 20px;\n    }\n\n    .modalContent .stepDiv {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv {\n        width: auto;\n        margin-left: 0px;\n        margin-top: 8px;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAInfoDiv .infoFieldItem .infoText {\n        width: 100%;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeLabel {\n        text-align: left;\n    }\n\n    .MFACodeDiv .codeFieldItem .codeInput {\n        text-align: left;\n    }\n\n    #verifyCodeId {\n        width: 100px !important;\n    }\n\n    .codeInput .tiny-textbox-container {\n        width: 120px !important;\n    }\n\n    .modalContent .stepDiv .stepContent .appDownload {\n        float: none;\n    }\n\n    .modalContent .stepDiv .stepContent .content .MFAQRCodeDiv {\n        float: none;\n    }\n    \n    .modalContent #msgMFAErrorTip {\n        padding-left: 0px;\n    }\n}\n\n.checkboxDiv {\n    width: 100%;\n}\n\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    margin-top: 8px;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n    font-weight: normal;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -17px;\n    width: 12px;\n    height: 12px;\n    top: 3px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -13px;\n    top: 5px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n\n.checkboxDiv.checkboxDisabled label {\n    cursor: not-allowed;\n    color: #8A8E99;\n}\n\n.checkboxDiv .disabledTip {\n    color:#F66F6A;\n}\n\n/*适配移动端*/\n@media (max-width: 375px) {\n    #verifyCodeId {\n        width: 94px !important;\n    }\n}\n\n@media (max-width: 360px) {\n    #verifyCodeId {\n        width: 77px !important;\n    }\n}\n\n@media (max-width: 320px) {\n    #verifyCodeId {\n        width: 38px !important;\n    }\n}", ""]);

// exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".hwInterval{\n    margin: 0 1px;\n}\n\n#quickLoginDiv .otherLoginWays,\n#hwLoginDivId .otherLoginWays{\n\twidth: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n\n@media(max-width:500px) {\n    #hwLoginDivId .otherLoginWays.forPc{\n        display: none ;\n    }\n    #hwLoginDivId .otherLoginWays.forMobile{\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n    }\n\n    #hwLoginDivId .otherLoginWays.forMobile .loginLinkFirstLayer{\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    #hwLoginDivId .otherLoginWays.forMobile .loginLinkSecondLayer{\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-around;\n    }\n\n}", ""]);

// exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滚动条轨道 内阴影+圆角*/\n::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #F0F2F5;\n}\n/*定义滑块 内阴影+圆角*/\n::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #bfc3c6;\n}\n/*------  content begin ---------*/\n#loginAdv {\n    float: left;\n    max-width: 800px;\n    max-height: 515px;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n}\n\n#loginForm {\n    width: 380px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#loginForm > ul, #companyUser, #personalUser {\n    margin: auto auto 0px auto;\n    width: 320px;\n}\n\n/* 统一ID登录iframe */\n#uniIdIframeDiv {\n    width: 380px;\n    height: 500px;\n    display: inline-block;\n    float:right;\n    /*margin-left: 5%;*/\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n/* END */\n\n/* 页面错误信息 */\n/* END */\n\n/* 主帐户 帐号/邮箱登录方式 */\n#loginForm .loginFormDiv {\n    padding: 0px 30px;\n    width: 320px;\n}\n/* END */\n\n/* 国家码选择框 */\n#loginForm .codeSelect {\n    display:inline-block;\n    vertical-align: middle;\n    float: left;\n}\n#loginForm .codeSelect .tiny-combobox-container {\n    border: none;\n    background-color: #FFFFFF;\n    box-shadow: none;\n}\n#loginForm .codeSelect .tiny-combobox-editor {\n    padding-left: 8px;\n    /*width: calc(100% - 10px);\n    width: -webkit-calc(100% - 10px);\n    width: -moz-calc(100% - 10px);*/\n}\n#loginForm .codeSelect .tiny-combobox-editor .tiny-combobox-input {\n    box-shadow: none;\n    border: none;\n    padding: 0px;\n    font-size: 12px;\n}\n#loginForm .codeSelect .tiny-combobox-popbutton:before {\n    right: 1px;\n    border-top: 5px solid #252B3A;\n}\n#loginForm .codeSelect .tiny-combobox-disable {\n    background-color: #FFFFFF;\n    border-color: none;\n    box-shadow: none;\n    border-right: none;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input {\n    font-family: PingFangSC-Regular;\n    color: #696969;\n}\n#loginForm .codeSelect .tiny-combobox-disable .tiny-combobox-input:disabled {\n    opacity: 1 !important;\n}\n/* END */\n\n/* 手机号输入框 */\n#loginForm .phoneInput {\n    display:inline-block;\n    position: relative;\n}\n#loginForm .phoneInput input.tiny-input-text.valid_error_input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n/* END */\n/*\n<!-- 帐号输入框 -->\n<!-- 密码输入框 -->\n<!-- 手机号登录方式 -->\n<!-- 国家码选择框 -->\n<!-- 手机号输入框 -->\n<!-- 手机绑定多帐号需选择 -->\n<!-- 密码输入框 -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 密码输入框 -->\n<!-- 主帐户 帐号/邮箱登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- <tiny-textbox id=\"model.userNameId\" validate=\"model.userValidator\" value=\"model.userName\"\n<!-- 主帐户 手机号登录方式 仅国内站-->\n<!-- 手机绑定多帐号需选择 -->\n<!-- end -->\n<!-- IAM用户登录方式 -->\n<!-- 帐号名输入框 -->\n<!-- IAM用户名输入框 -->\n<!-- 国内IP placeholder不同-->\n<!-- 海外IP placeholder不同-->\n<!-- 密码输入框 非手机登录方式-->\n<!-- 密码输入框 手机登录方式-->\n<!-- 验证码输入框 -->\n<!-- 手机号登录方式切换按钮 -->\n<!-- 记住密码按钮 -->\n*/\n#companyUser, #personalUser {\n    color: #333333;\n    font-size: 28px;\n    margin-top: 35px !important;\n    margin-bottom: auto !important;\n}\n\n#companyUser > span, #personalUser > span {\n    line-height: 28px;\n    height: 28px;\n    display: inline-block;\n    vertical-align: top;\n}\n\n#companyUser > hr, #personalUser > hr {\n    display: inline-block;\n    margin: 5px 5px;\n    border: 0;\n    border-bottom: 1px solid #999999;\n}\n\n#companyUser > hr {\n    width: 28%;\n}\n\n#personalUser > hr {\n    width: 56%;\n}\n\n.errorTip {\n    display:block;\n    position: relative;\n    min-height: 32px;\n    font-size: 12px;\n    padding: 0px 8px;\n}\n.errorTip span {\n    color: #F66F6A;\n}\n\n#checkError, #serverError, #mobileErrorMsg, #mobileUsersSelectMsg, #isMobileTip {\n    color: #FF0000;\n    /*display: none;*/\n    clear: both;\n    /*margin: 10px 0 0 0;*/\n}\n\n/* 手机多用户时选择用户的下拉框 */\n.mobileUsersSelect {\n    margin-bottom: 15px;\n}\n.mobileUsersSelect .tiny-select {\n    width: 100%;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field {\n    height: 36px;\n    border: none;\n    padding-right: 0;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field input {\n    width: 100% !important;\n    border-right: none;\n}\n.mobileUsersSelect .tiny-select .tiny-select-input-field:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-input-field-selected-down:before, .tiny-select-input-field-selected-up:before {\n    border-top: 6px solid #252B3A;\n}\n.tiny-select-popup-container {\n    border: 1px solid #ADB0B8;\n    box-shadow: 0 2px 5px 0;\n}\n.tiny-select-option {\n    color: #252B3A;\n}\n.tiny-select-option-selected {\n    color: #F66F6A;\n    background: #FFEEED;\n}\n.tiny-select-option-default-selected {\n    background-color: #F66F6A;\n    color: #FFFFFF;\n}\n/* END */\n\n/* 验证码图片样式 */\n#inputVerifyCodeImg {\n    width: 100px;\n    height: 30px;\n    float: right;\n    cursor: pointer;\n}\n/* END */\n\n.inputField {\n    margin-bottom: 16px !important;\n    font-size: 14px !important;\n    border-bottom: 1px solid #DFE1E6;\n    position: relative;\n}\n.inputField:hover {\n    border-bottom: 1px solid #8A8E99;\n}\n.inputField:last-child {\n    margin-bottom: 0px !important;\n    font-size: 14px !important;\n}\n#loginForm .inputField input {\n    line-height: 20px;\n    border-radius: 0px;\n    font-family: \"PingFangSC-Regular\";\n    padding: 0px 8px;\n    box-shadow: none;\n}\n\n\n#loginForm > div:last-child {\n    /*position: absolute !important;*/\n    bottom: 0px;\n    width: 100%;\n}\n\n#buttonArea {\n    margin: 48px 38px 30px 38px;\n    width: 304px;\n}\n\n#smsPhone {\n    margin: 5px;\n    font-size: 13px !important;\n}\n\n#fpLink {\n    color: #00aaff;\n    float:right;\n}\n\n/* 手机号登录切换 以及 记住登录名 */\n.toDoDiv {\n    margin: 18px 38px 0;\n    width: 304px;\n}\n/* END */\n\n/* 手机号登录切换 */\n.typeSwitchDiv {\n    display: inline-block;\n    font-size: 12px;\n    font-style: normal;\n    color: #252B3A;\n    max-width: 180px;  \n}\n#typeSwitchBtn {\n    cursor: pointer;\n}\n#typeSwitchBtn:hover {\n    color: #F66F6A;\n    text-decoration: underline;\n}\n/* END */\n\n/* 记住登录名 */\n.toDoDiv #checkArea {\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n.checkboxDiv input[type='checkbox'] {\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n}\n.checkboxDiv input[type='checkbox']:checked + label:before {\n    background: #F66F6A;\n    border-color: #F66F6A;\n}\n.checkboxDiv input[type='checkbox']:checked + label:after {\n    background: #F66F6A;\n}\n.checkboxDiv label {\n    position: relative;\n    cursor: pointer;\n}\n.checkboxDiv label:before {\n    content: '';\n    position: absolute;\n    left: -20px;\n    top: 0px;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ADB0B8;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n.checkboxDiv label:after {\n    content: '';\n    position: absolute;\n    left: -16px;\n    top: 2px;\n    width: 4px;\n    height: 7px;\n    border: 0;\n    border-right: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    background: #fff;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transition: all 0.3s ease;\n    -webkit-transition: all 0.3s ease;\n    -moz-transition: all 0.3s ease;\n}\n/* END */\n\n.buttonAreaDiv {\n    width: 100%;\n    float: left;\n}\n\n.loginBtn {\n    background-color: #F66F6A;\n    border-radius: 2px;\n    color: #ffffff;\n    cursor: default;\n    width: 100%;\n}\n.loginBtn:hover,\n.loginBtn:active,\n.loginBtn:focus {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,0.3);\n    outline: none;\n}\n\n.loginBtn span, .loginBtnDisabled span {\n    vertical-align: middle;\n    text-align: center;\n    font-size: 14px !important;\n    display: table-cell;\n    height: 36px;\n    margin: 0 auto;\n    display: block;\n    line-height: 36px;\n}\n\n.loginBtnDisabled {\n    background-color: #CCCCCC;\n    border: 1px solid #CCCCCC;\n    border-radius: 3px 3px 3px 3px;\n    color: #ffffff;\n    font-size: 18px !important;\n    cursor: default;\n    width: 100%;\n}\n\n#bottomBtns {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    justify-content: space-around;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n/* 免费注册 & 忘记密码 & 用户切换 */\n.commonLinkDiv {\n    text-align: center;\n}\n.splitLine {\n    float: left;\n    width: 1px;\n    margin: 0px 2px;\n    height: 12px;\n    background: #DFE1E6;\n}\n.freeRegisterLink {\n}\n.forgetPwdLink {\n}\n.userTypeLink {\n}\n/* END */\n\n#goLogin {\n    color:#5099F8;\n    cursor: pointer;\n    font-size:small;\n}\n#goLogin:hover{\n    text-decoration: underline;\n}\n/*-------- content end ---------*/\n\n/*------ page layout begin ------*/\n#content .widthLimit {\n    position: relative;\n    margin: 0px auto;\n    padding: 0px 20px;\n}\n\n#content .widthLimit{\n    max-width: 1200px;\n}\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 45px;\n}\n\nbody, html {\n    height:100%;\n    margin: 0;\n    padding: 0;\n    min-width: 1260px;\n}\n\n*{\n    margin: 0;\n    padding: 0;\n}\n.placeholder {\n    color: #aaa!important;\n    font-family: \"Microsoft Yahei\"!important;\n}\n\n.linkSeperator {\n    height:100%;\n    border-left: 1px #0678FF solid;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.expand {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-top: 10px solid #0678FF;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.collapse {\n    height: 0;\n    width: 0;\n    position: absolute;\n    border-bottom: 10px solid #0678FF;;\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n    margin-left: 5px;\n    margin-top: 5px\n}\n\n.verticalLink{\n    font-size: 16px;\n    margin: 0 5px;\n    color: #e4e4e4!important;\n}\n\n.requiredImage {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n#enterpriseSwitchTip {\n    background-color: #ffffff;\n    border: 1px solid #cccccc;\n    color: #666666;\n    width: 300px;\n    height: auto;\n    position: absolute;\n    float: right;\n    border-radius: 2px;\n    top: 50px;\n    z-index: 10;\n    padding:6px;\n    background-color: #f5f5f5;\n    font-size: 12px;\n}\n\n.loginTypeDiv {\n    color:#666666;\n    font-size:14px;\n    font-style: normal;\n    padding: 24px 30px 10px 30px;\n    text-align: center;\n}\n\n.loginTypeNoSelected {\n    box-sizing: border-box;\n    display: inline-block;\n    width:100%;\n    line-height: 18px;\n    font-size: 18px;\n    font-family: \"PingFangSC-Medium\";\n    text-align: center;\n    color: #252B3A;\n}\n\n.loginTypeSelected {\n    box-sizing: border-box;\n    border-color: #E41E2B;\n    border-style:solid;\n    border-top:0;\n    border-left:0;\n    border-right:0;\n    border-width: 3px;\n    display: inline-block;\n    width:47%;\n    text-align: center;\n    height: 44px;\n    line-height: 44px;\n    color:#E41E2B;\n    cursor: pointer\n}\n.loginBottomColor {\n    font-size: 12px;\n    color: #252B3A;\n    line-height: 16px;\n}\n.loginBottomColor:hover,\n.loginBottomColor:active,\n.loginBottomColor:focus {\n    color: #F66F6A;\n}\n.otherLoginColor{\n    font-size: 12px;\n    color: #666A75;\n    line-height: 16px;\n}\n.otherLoginColor:hover,\n.otherLoginColor:active,\n.otherLoginColor:focus {\n    color: #666A75;\n}\n\n/* 三方登录展示列表 */\n#otherLoginWays {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n#otherLoginWays .otherItemDiv {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: center;\n}\n#otherLoginWays .otherItemDiv .textIcon {\n    height: 13px;\n    padding-top: 1px;\n}\n/* END */\n\n.tiny-input-text {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #333;\n    font-size: 14px;\n    font-face:NotoSansCJKsc-Regular\n}\n.tiny-input-text:focus {\n    border: none;\n}\n.tiny-input-text.valid_error_input:focus {\n    border: none;\n}\n\n:-ms-input-placeholder {\n    color: #999 !important;\n}\n\n#otherAccounts{\n    position: relative;\n    text-align: center;\n    margin-bottom: 5px;\n    line-height: 1;\n    cursor: pointer;\n}\n#otherAccounts:before{\n    content: '';\n    position: absolute;\n    top: 50%;\n    display: block;\n    width: 100%;\n    border-top: 1px solid #DDD;\n}\n#otherAccounts .downArrow {\n    margin-left: -7px;\n    padding-right: 7px;\n    display: inline-block;\n    position: relative;\n    z-index: 2;\n    background-color: #ffffff;\n}\n#otherAccounts .downArrow img {\n    width: 8px;\n    height: 8px;\n}\n#otherAccounts .downArrow img.otherAccountsOpen {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n#otherAccounts .downArrow img.otherAccountsClose {\n    -webkit-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n#otherAccounts .otherLoginColor{\n    padding: 0 7px;\n    position: relative;\n    z-index: 2;\n    background-color: #fff;\n}\n\ninput[type=\"password\"] {\n    color: #333;\n}\n\n.homepageLink {\n    color: #A0A2A8;\n}\n\n.index-uniportal {\n    position: relative;\n}\n\n.index-uniportal>a {\n    cursor: pointer;\n}\n.index-uniportal:hover >.uniportalTip {\n    display: block;\n}\n\n.index-uniportal>.uniportalTip {\n    top: 17px;\n    display: none;\n    position: absolute;\n    bottom: 13px;\n}\n\n.index-uniportal>.uniportalTip>span {\n    padding: 2px;\n    box-shadow: 1px 1px 10px #ccc;\n    border: 1px solid #ccc;\n    display: block;\n    background: #fff;\n    margin-left: 90px;\n    width: 183px;\n    font-size: 10px;\n}\n.otherLogin{\n    position:relative;\n    margin-left: 120px;\n}\n.otherLogin:before{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: -120px;\n    content: \"\";\n}\n.otherLogin:after{\n    position: absolute;\n    width: 100px;\n    height: 1px;\n    background: #ccc;\n    top: 10px;\n    left: 100px;\n    content: \"\";\n}\n.registUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 70px;\n    font-size: 13px;\n}\n.forgetPWDUrl {\n    color: #666;\n    float: right;\n    margin-top: -20px;\n    margin-right: 0px;\n    font-size: 13px;\n}\n.shuXianSpan {\n    color: #666;\n    float: right;\n    margin-top: -21px;\n    margin-right: 63px;\n}\n\n.helpQuestionmark {\n    background-image: url(" + escape(__webpack_require__(47)) + ");\n    float: right;\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n}\n\n.loginswap {\n    line-height: 18px;\n}\n\n.loginswap:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.helptipfather {\n    display: inline-block; position:relative;\n}\n.userTypeLink:hover .helptipchild {\n    display:block;\n    width:220px;\n    padding:8px 3px 3px 6px;\n}\n.helptipfather span {\n    display:none;\n    color:#666666;\n    font-size:12px;\n    line-height:20px;\n    /* font-family:PingFangSC-Regular; */\n    background:#FFFFFF;\n    border-radius:0 0 0 2px 2px 2px 2px;\n    border:1px solid #EEEEEE;\n    box-shadow:0 2px 5px 0 rgba(0,0,0,0.15);\n    -moz-border-radius:1px;\n    -webkit-border-radius:1px;\n    text-align:left;\n    position: absolute;\n    left: -150px;\n    top: 10px;\n    z-index:10;\n    overflow: visible;\n}\n#loginAdv .login-logo-pad{\n    display: none;\n}\n.pwdShowimg {\n    top: 10px;\n    right: 8px;\n    position: absolute;\n    width: 15px;\n    height: 15px;\n}\n\n#personalPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n\n#mobilePasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n} \n\n#IAMPasswordInputId > input {\n    ime-mode: disabled;\n    -ms-ime-mode: disabled;\n}\n/*------ pad css start------*/\n@media (max-width: 1269px) {\n    .widthLimit{\n        box-sizing: border-box;\n        padding: 0;\n    }\n    html,body,#content{\n        max-width: 1270px;\n        min-width: 768px;\n    }\n    #content{\n        height: calc(100% - 90px);\n    }\n    #content .widthLimit{\n        max-width: 768px;\n    }\n    #loginAdv{\n        margin-top: 40px;\n        max-width: 352px;\n    }\n    #content .widthLimit{\n        padding: 0 15px;\n    }\n\n    #loginForm{\n        margin-top: 70px;\n    }\n    #loginAdv .login-logo-pad{\n        display: block;\n    }\n    #loginAdv .login-logo-pc{\n        display: none;\n    }\n}\n/*------ pad css end ------*/\n/*------ page layout end ------*/\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n\n/*适配移动端*/\n@media (max-width: 768px) {\n    #content {\n        height: 100%;\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        padding: 0 30px;\n        width: 100%;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #loginAdv {\n        display: none;\n    }\n\n    body, html, #content {\n        height:100%;\n        margin: 0;\n        padding: 0;\n        min-width: 0px;\n    }\n\n    #loginForm {\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        /* padding: 0 30px; */\n    }\n\n    #uniIdIframeDiv {\n        width: 100%;\n        height: 100%;\n        margin-top: 0px;\n    }\n    #uniIdIframe {\n        width: 100%;\n        box-shadow: none;\n        background: none;\n    }\n\n    #loginForm .loginFormDiv {\n        width: 100% !important;\n        padding: 0;\n        margin: 0;\n    }\n\n    #loginForm .tiny-textbox-container {\n        width: 100% !important;\n    }\n\n    #verifyCode .tiny-textbox-container {\n        width: calc(100% - 138px) !important;\n    }\n    \n    #inputVerifyCodeImg {\n        transform: translateY(4px);\n    }\n\n    .toDoDiv {\n        margin-left: 0px;\n        margin-right: 0px;\n        width: 100%;\n    }\n\n    #loginForm .mobileLoginDiv .phoneInput {\n        width: calc(100% - 115px);\n    }\n\n    #buttonArea {\n        margin: 38px auto;\n        width: 100%;\n    }\n\n    #otherAccounts .otherLoginColor {\n        background-color: #0000;\n    }\n\n    #otherAccounts .downArrow {\n        background-color: #0000;\n    }\n\n    .userTypeLink:hover .helptipchild {\n        display: none;\n    }\n\n    #otherLoginWays .otherItemDiv {\n        margin-right: 0;\n    }\n\n    #otherLoginWays .otherItemDiv#vmallLinkDiv {\n        margin-left: 0;\n    }\n\n    #otherLoginWays .otherItemDiv#eChannelLinkDiv {\n        margin-left: 0;\n        padding: 0 3px;\n    }\n}\n\n/* 扫码登录 */\n#loginForm{\n    position: relative;\n}\n#QRLoginDiv {\n    position: relative;\n    background-color: #fff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228,228,228,1);\n    border-radius: 0;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,.1);\n    display: flex;\n    width: 380px;\n    height: 407px;\n    float: right;\n    margin-top: 80px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loginQRCodeDiv{\n    width: 159px;\n    padding: 10px;\n}\n\n.QRCodeOuter{\n    position:relative;\n    height: 179px;\n    width: 180px;\n    margin: 0 auto;\n    text-align: center;\n    border: 0px solid #DFE1E6;\n    background: url(" + escape(__webpack_require__(32)) + ");\n    background-size: cover;\n}\n.QRCodeInner{\n    position:absolute;\n    top: 0px;\n    left: 0px;\n    color: #FFFFFF;\n    height: 179px;\n    width: 180px;\n    background:rgba(7, 7, 7, 0.6);\n}\n\n\n.loginTypeSwitchImg{\n    margin-top: 8px;\n    margin-right: 8px;\n    width: 50px;\n    height: 50px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n}\n\n.loginTypeSwitchImg:hover{\n    cursor: pointer;\n}\n\n.ti-tooltip {\n    position: absolute;\n    top: 9px;\n    right: 58px;\n    background-color: #333854;\n    color: #dfe1e6;\n    padding: 11px 15px;\n    border: 1px solid #333854;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n    border-radius: 4px;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    box-sizing: border-box;\n    z-index: 5000;\n    white-space: normal;\n    word-wrap: break-word\n}\n\n.ti-tooltip-left:after {\n    height: 20px;\n    margin-top: -10px;\n    right: 0\n}\n\n.ti-tooltip-left:after,.ti-tooltip-left:before {\n    display: block;\n    position: absolute;\n    content: \"\";\n    overflow: hidden;\n    background: #333854;\n    width: 10px;\n    top: 50%\n}\n\n.ti-tooltip-left:before {\n    height: 10px;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    border-right: 1px solid #333854;\n    border-top: 1px solid #333854;\n    margin-top: -5px;\n    right: -5px;\n    box-shadow: 0 -2px 4px rgba(0,0,0,.2)\n}\n\n#countDownDiv {\n    text-align: center;\n    color: #252B3A;\n    font-size: 12px;\n    margin-top: 10px;\n    height: 20px;\n}\n\n.remainingTimeTxt{\n    color: #F66F6A;\n}\n\n#QRLoginBottomDiv {\n    width: calc(100% - 50px);\n    border-top: 1px solid #575D6C;\n    margin-left: 40px;\n    margin-right: 40px;\n    height: 60px;\n    line-height: 50px;\n    display: inline-flex;\n    justify-content: space-between;\n    font-size: 12px;\n}\n\n.QRLoginBottomColor {\n    font-size: 12px;\n    color: #575D6C;\n}\n.QRLoginBottomColor:hover,\n.QRLoginBottomColor:active,\n.QRLoginBottomColor:focus {\n    color: #F66F6A;\n}\n\n.QRCodeInvalid{\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 60px;\n}\n\n#refreshQRCodeBtn {\n    width: 80px;\n    margin: 0 auto;\n}\n\n.loginStatusDiv{\n    text-align: center;\n}\n\n.loginStatusImg{\n    height: 64px;\n    width: 64px;\n    margin-bottom: 16px;\n}\n\n.loginStatusTitle{\n    color: #252B3A;\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.loginStatusMessage{\n    color: #252B3A;\n    font-size: 12px;\n}\n\n\n@media (max-width: 1269px) {\n    #QRLoginDiv{\n        margin-top: 70px;\n    }\n    .loginTypeSwitchImgCover{\n        border-bottom: 50px solid linear-gradient(90deg,#F4F5FF 0,#E8EBFD 48%,#F4F5FF 100%) ;\n    }\n}\n\n@media (max-width: 768px) {\n    #QRLoginDiv{\n        width: 100%;\n        margin-top: 20px;\n        box-shadow: none;\n        background: none;\n        display: none;\n    }\n\n    .loginTypeSwitchImg {\n        display: none;\n    }\n\n    #QRLoginTip {\n        display: none;\n    }\n\n}\n\n/**企业联邦登录**/\n#idpLoginForm{\n    width: 380px;\n    display: inline-block;\n    float:right;\n    margin-top: 80px;\n    background-color: #ffffff;\n    color: #C1C1C1;\n    font-size: 14px;\n    border-color: rgba(228, 228, 228, 1);\n    border-radius: 0px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n}\n\n#idpLoginForm .loginFormDiv{\n    margin: 0 38px;\n}\n\n#idpLoginForm #otherLoginWays{\n    display: flex;\n    justify-content: space-around;\n}\n\n#idpLoginForm #otherLoginWays .otherItemDiv{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#idpLoginForm #loginBtn{\n    margin-bottom: 50px;\n}\n\n#idpLoginForm .tiny-select-text{\n    box-shadow: 0 0 0 0;\n}\n\n#idpLoginForm #idpCheckArea{\n    float: right;\n    display: inline-block;\n    font-size: 12px;\n    color: #252B3A;\n}\n\n@media (max-width: 768px){\n    #idpLoginForm{\n        width: 100%;\n        box-shadow: none;\n        background: 0 0;\n        margin-top: 20px;\n    }\n    #idpLoginForm .loginFormDiv{\n        margin: 0;\n    }\n\n    #idpLoginForm .loginFormDiv .tiny-textbox-container{\n        width: 100% !important;\n    }\n    #idpLoginForm .loginFormDiv .tiny-select-input-field{\n        width: 100% !important; \n    }\n}\n", ""]);

// exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(2);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#content .widthLimit {\n    max-width: 800px;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin: 0 auto;\n}\n\n#verifyTypeBtn {\n    color: #0088CC;\n    display: inline-block;\n    float: right;\n    margin-right: 7px;\n    height: 36px;\n    line-height: 36px;\n}\n\n#verifyTypeBtn:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n#resetTitle {\n    margin: 20px 0px;\n}\n\n#resetTitle > p {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 10px;\n}\n\n#resetTitle > span {\n    font-size: 14px;\n}\n\n.tip_no_border {\n    border-right:none !important;\n    border:none !important;\n    background-color:#F4F4F4 !important;\n    box-shadow:none !important;\n}\n#verifyCodeMsg {\n    margin-left: 340px;\n}\n#btnDiv {\n    clear:both;\n    padding-top:10px;\n    margin-left: 340px;\n    max-width: 240px;\n}\n\n#errorMsg {\n    margin-bottom: 5px;\n    display: block;\n    color: red;\n}\n\n.pwdStrengthContainer {\n    display:inline-block;\n    float: right;\n    margin-right:10px;\n    margin-top:10px;\n    clear: both;\n    font-size: 12px;\n    line-height: 13px;\n}\n#TIP span {\n    display: none;\n}\n#TIP.high .high{\n    display: inline-block;\n    color: #333;\n}\n#TIP.low .low{\n    display: inline-block;\n    color: #333;\n}\n#TIP.mid .mid{\n    display: inline-block;\n    color: #333;\n}\n\n.tootip-img {\n    width:16px;\n    height:16px;\n    margin:0 auto 3px 0;\n}\n\n.tootip-div{\n    margin: -21px 0 10px 20px;\n}\n\n.errorInfo {\n        width: 390px;\n        margin-left: 334px;\n}\n\n.errorInfo>span {\n    margin-left: 6px;\n    display: inline-block;\n    width: 315px;\n    color: #e41e2b;\n}\n\n#content {\n    position: relative;\n    height: 100%;\n    min-height: 770px;\n    background: #ffffff;\n}\n\n#content:before, #content:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n#content:before {\n    padding-top: 65px;\n}\n\n\n/**\"标签:输入框\"的表单风格--start*/\n.formDiv {\n    height: auto;\n    /* min-height: 600px; */\n    margin: 15px auto 10px;\n    padding: 30px 30px 30px 30px;\n    width: 800px;\n    color: #9B9B9B;\n    position: relative;\n    background-color: #FFFFFF;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.10);\n    border-radius: 2px;\n}\n.formDiv > ul {\n    min-width: 670px;\n}\n.fieldContainer {\n    margin: 10px auto 10px auto;\n    float: left;\n}\n.fieldContainer:before, .fieldContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.fieldLabel {\n    width: 320px;\n    float: left;\n    margin-right: 20px;\n    height: 36px;\n    line-height: 36px;\n    color: #333;\n    font-size: 14px;\n}\n.fieldLabel span {\n    float: right;\n}\n.field {\n    /* width: 315px; */\n    float: left;\n    margin-right: 10px;\n    font-size: 14px;\n    position: relative;\n}\n\n.pwd-state-icon {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n/**\"标签:输入框\"的表单风格--end*/\n\n.pageTitle {\n    font-size: 28px;\n    color:#333;\n}\n\n#step {\n    height: 70px;\n    /*width: 980px;*/\n    margin: 0 auto 10px auto;\n    font-size: 16px;\n}\n\n.required {\n    color: red;\n    display: inline-block;\n    margin-right: 5px;\n    width: 5px;\n    float: right;\n}\n\n.msgBtn {\n    height: 30px;\n    line-height: 30px;\n    border: 1px solid #c3c3c3;\n    background: #fff;\n    color: #666666;\n    cursor: pointer;\n    width: 168px;\n    border-radius: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.msgBtn span {\n    text-align: center;\n    display: block;\n}\n\n.msgBtn:hover {\n    color: #009ae7;\n}\n\n.msgBtnDisabled {\n    cursor: default;\n    background: #ececec;\n    color: #999;\n}\n\n.msgBtnDisabled:hover {\n    color: #999;\n}\n\n.passwordStrength {\n    background: none repeat scroll 0 0 #CCCCCC;\n    border: 1px solid #fff;\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    height: 2px;\n    line-height: 12px;\n    margin-top: 8px;\n    margin-left: 5px;\n    text-align: center;\n    width: 70px;\n}\n\n.customValidateTip {\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    border: none;\n    background-size: contain !important;\n    background: url(" + escape(__webpack_require__(10)) + ") no-repeat 0px center;\n    vertical-align: middle;\n}\n\nbutton {\n    font-family: inherit;\n}\n#btnId2 {\n    background-color: #e20074!important;\n}\n\n.content {\n    background-color: #F4F4F4;\n}\n\n.okButton {\n    background-color: #F66F6A;\n    border: 1px solid #F66F6A;\n    border-radius: 3px 3px 3px 3px;\n    cursor: default;\n    text-align: center;\n    height: 30px;\n    color: #ffffff;\n    border-radius: 3px;\n    min-width: 70px;\n    font-size:12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.okButton:hover {\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(246,111,106,.3);\n}\n\n.cancelButton {\n    color: #252b3a;\n    text-align: center;\n    min-width: 70px;\n    background-color: #FFFFFF;\n    border: 1px solid #adb0b8;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    height: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.cancelButton:hover {\n    color: #526ecc;\n    background: #fff;\n    border-color: #5e7ce0;\n}\n\nbutton {\n    font-family: inherit;\n}\n\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n#formUl > li {\n    display: flow-root;\n}\n\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n        width: 100%;\n    }\n\n    #content .widthLimit {\n        padding: 0;\n        margin: 0px;\n        max-width: 425px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    #content {\n        background: linear-gradient(90deg, #F4F5FF 0%, #E8EBFD 48%, #F4F5FF 100%) !important;\n        /* background-image: none !important; */\n    }\n\n    #resetTitle {\n        margin-left: 20px;\n    }\n\n    .formDiv {\n        height: auto;\n        margin: 0;\n        width: 100%;\n        color: #9B9B9B;\n        position: relative;\n        box-sizing: border-box;\n        box-shadow: none;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 0px;\n        background-color: transparent;\n    }\n\n    .formDiv > ul {\n        width: 100%;\n        min-width: 0;\n    }\n\n    .fieldContainer {\n        width: 100%;\n        display: flex;\n        flex-flow: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    .fieldContainer .field {\n        flex-grow: 1;\n    }\n\n    .field {\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container {\n        height: 32px !important;\n        font-size: 12px;\n    }\n\n    .field .tiny-textbox-container:not(#msgCodeId){\n        width: 100% !important;\n    }\n\n    .fieldLabel {\n        width: 80px;\n        font-size: 12px;\n        margin-right: 8px;\n        line-height: 18px;\n        height: fit-content;\n    }\n\n    #verifyCodeMsg {\n        margin-left: 0px;\n    }\n    #btnDiv {\n        max-width: none;\n        margin-left: 0px;\n        display: flex;\n        justify-content: center;\n        flex-flow: row;\n        flex-wrap: wrap;\n    }\n\n    #msgCodeId {\n        width: 60px !important;\n        height: 32px !important;\n        margin-top: 8px;\n        margin-bottom: 8px;\n    }\n\n    #msgBtn {\n        font-size: 12px;\n        padding-left: 8px;\n        padding-right: 8px;\n        width: fit-content;\n    }\n\n    .tiny-tip-content-top {\n        /* font-size: 12px !important; */\n        left: 10% !important;\n        right: 10% !important;\n        line-height: 1;\n    }\n\n    .passwordStrength {\n        width: 24px;\n        transform: translateY(-7px) !important;\n    }\n\n    .tootip-img {\n        margin-bottom: 5px;\n    }\n\n    .errorInfo > span {\n        width: auto;\n    }\n\n    .errorInfo {\n        width: 100%;\n        margin-left: 0;\n    }\n}", ""]);

// exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(91);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div id=\"GraphicsVerification\" ng-controller=\"graphicVerifyCode.ctrl\"> <div ng-style=\"style.verifyCodeInfo\"> <img class=\"graphicsTip\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span ng-bind=\"model.InputGrapVerifyCodeInfo\"></span> </div> <div ng-style=\"style.verifyCodeContent\"> <span style=\"color:red\" ng-if=\"!model.isMobile\">*</span> <span ng-bind=\"model.GraphicsVerifyCode\" ng-if=\"!model.isMobile\"></span> <div style=\"display:inline-block\" class=\"graphicsBouderStyle\"> <tiny-textbox id=\"model.inputId\" validate=\"model.checkCodeValidator\" focused=\"model.focused\" width=\"100\" height=\"35\" value=\"model.checkCode\" value=\"model.verifyCode\" placeholder=\"model.checkCodePH\" blur=\"model.onVerifyBlur()\" tip-position=\"model.tipPosition\" content-change=\"model.preValidVerifyCode(event, value)\" keypressfn=\"model.msgKeyPress\"></tiny-textbox> </div> <img id=\"GrapVerifyCodeImg\" title=\"{{model.checkCodeTip}}\" ng-src=\"{{ model.verifyCodeSrc }}\" ng-click=\"model.getVerifyCode()\" style=\"vertical-align:middle;margin-left:10px;cursor:pointer\"> <img id=\"validresultImg\" style=\"vertical-align:middle;margin-left:10px;display:none\"> </div> </div> <script>var injector=angular.injector([\"authui.config\"]);console.log(injector),injector.invoke([\"$compile\",function(i){var o=$(\"#GraphicsVerification\").scope();i($(\"#GraphicsVerification\"))(o),o.$digest()}])</script> ";
// Exports
module.exports = code;

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-if=\"model.currentLanguage === 'zh-cn'\" ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> <div id=\"triangle\"></div> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// Module
var code = "<div class=\"casLoginMsgContainer\"> <div class=\"errorIcon\"></div> <div class=\"errorTitle\">{{model.errorTitle}}</div> <div class=\"errorContent\"> <span ng-bind-html=\"model.errorContent\"></span> <span ng-if=\"model.errorLink&&!model.isMobile\">{{model.errotLinkTxtPre}}</span><a ng-if=\"model.errorLink&&!model.isMobile\" ng-href=\"{{model.errorLink}}\">{{model.errotLinkTxt}}</a> </div> <div id=\"loginBtn\" class=\"loginBtn ng-cloak\" tabindex=\"0\" ng-click=\"model.loginBtnClick()\"> <span id=\"btn_submit\">{{model.loginBtnTxt}}</span> </div> </div> <div ng-if=\"model.errorLink&&model.isMobile\" class=\"h5ErrorLinkDiv\"> <span ng-if=\"model.errorLink\">{{model.errotLinkTxtPre}}</span> <a ng-if=\"model.errorLink\" ng-href=\"{{model.errorLink}}\">{{model.errotLinkTxt}}</a> </div>";
// Exports
module.exports = code;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// Module
var code = "<link rel=\"stylesheet\" href=\"/authui/public/custom/css/closecookie.css\"/> <div style=\"margin-top:2%\"> <div style=\"min-width:1280px;position:relative;margin:0 auto\"> <div style=\"font-size:28px;color:#333;margin:100px auto 30px;width:44%;text-align:center\" ng-bind=\"i18n('cookie.title')\"></div> <div class=\"browserDiv\"> <img class=\"browserImage\" ng-src=\"{{model.chromeUrl}}\"><span class=\"browserNameDesc\"><span ng-bind=\"i18n('cookie.chromeName')\"></span><br/><span class=\"browserEnableDesc\" ng-bind=\"i18n('cookie.chromeDesc')\"></span></span> </div> <div class=\"browserDiv\"> <img class=\"browserImage\" ng-src=\"{{model.firefoxUrl}}\"><span class=\"browserNameDesc\"><span ng-bind=\"i18n('cookie.firefoxName')\"></span><br/><span class=\"browserEnableDesc\" ng-bind=\"i18n('cookie.firefoxDesc')\"></span></span> </div> <div class=\"browserDiv\"> <img class=\"browserImage\" ng-src=\"{{model.ieUrl}}\"><span class=\"browserNameDesc\"><span ng-bind=\"i18n('cookie.ieName')\"></span><br/><span class=\"browserEnableDesc\" ng-bind=\"i18n('cookie.ieDesc')\"></span></span> </div> </div> </div> ";
// Exports
module.exports = code;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// Module
var code = "<div class=\"error\"> <img ng-src=\"{{errorImg}}\"/> <div class=\"error_msg\" ng-if=\"!errorMsg\">{{errorMsg}}</div> <div class=\"error_msg\" ng-if=\"errorMsg\">{{errorMsg}} ({{errorCode}})</div> </div>";
// Exports
module.exports = code;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(342);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"fphoneDiv\" style=\"margin-top:2%\"> <div class=\"pageTitle\"> <p><span ng-bind=\"i18n('fphone.changePhoneNum')\"></span></p> </div> <div id=\"step\"></div> <div id=\"step1\" style=\"display:block\"> <ul class=\"formDiv\"> <li id=\"enterprise\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fpwd.enterpriseName')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <tiny-textbox id=\"model.enterpriseId\" value=\"model.enterpriseName\" validate=\"model.enterpriseValidator\" tip-position=\"'top'\" placeholder=\"model.enterpriseNamePH\" focus=\"model.enterpriseFocus()\" blur=\"model.textBlur(model.enterpriseId)\" focused=\"model.enterpriseFocused\" height=\"model.height\" width=\"model.width\" keypressfn=\"model.step1KeyPress\"></tiny-textbox> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fphone.registerEmail')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <tiny-textbox id=\"model.registerEmailId\" value=\"model.registerEmail\" validate=\"model.emailValidator\" tip-position=\"'top'\" placeholder=\"model.registerEmailPH\" blur=\"model.textBlur(model.registerEmailId)\" focus=\"model.registerEmailFocus()\" height=\"model.height\" focused=\"model.registerEmailFocused\" content-change=\"model.onEmailChange(event, value)\" width=\"model.width\" keypressfn=\"model.step1KeyPress\"></tiny-textbox> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('GraphicsVerifyCodeLabel')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <tiny-textbox id=\"model.checkCodeId\" validate=\"model.checkCodeValidator\" value=\"model.checkCode\" width=\"model.checkCodeWidth\" height=\"model.height\" placeholder=\"i18n('verifyCodePlaceHolder')\" content-change=\"model.preValidVerifyCode(event, value)\" blur=\"model.preValidVerifyCodeBlur()\" max-length=\"model.checkCodeMaxLength\"></tiny-textbox> <img id=\"inputVerifyCodeImg\" title=\"{{model.checkCodeTip}}\" ng-src=\"{{model.verifycodeImg}}\" ng-click=\"model.getVerifyCodeImg()\" style=\"vertical-align:middle;margin-left:10px;cursor:pointer\"> <img id=\"validresultImg\" style=\"vertical-align:middle;margin-left:10px;display:none\"> </span> </div> </li> <li class=\"li\"> <div class=\"btnDiv\"> <button id=\"step1NextBtn\" class=\"okButton\" style=\"float:left\" ng-click=\"nextStep1()\" ng-bind=\"i18n('fpwd.nextStepBtn')\"></button> <button id=\"cancelBtn\" class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"onCancelBtnClick()\" ng-bind=\"i18n('btnTxtCancel')\"></button> </div> </li> </ul> </div> <div id=\"step2\" style=\"display:none\"> <ul class=\"formDiv\"> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fphone.registerEmail')\" style=\"float:right\"></span> </span> <span class=\"field\" style=\"color:#333;height:36px;line-height:36px\"> <span ng-bind=\"model.registerEmail\"></span> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fphone.emailVerifyCode')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <span> <tiny-textbox id=\"model.emailVerifyCodeId\" value=\"model.emailVerifyCode\" validate=\"model.msgCodeValidator\" tip-position=\"'top'\" placeholder=\"i18n('fpwd.verifyCodePH')\" height=\"model.height\" width=\"model.verifyCodeWidth\" blur=\"model.textBlur(model.emailVerifyCodeId)\" content-change=\"model.onEmailVCodeChange(event, value)\" tip-position=\"model.tipPosition\" keypressfn=\"model.step2KeyPress\"></tiny-textbox> </span> <div id=\"emailMsgBtn\" class=\"msgBtn\" style=\"width:210px\" ng-click=\"model.emailVerifyCodeBtnClick()\" tabindex=\"0\"> <span ng-bind=\"model.emailVCodeBtnTxt\"></span> </div> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer errorTipText\" id=\"emailCodeMsg\" style=\"display:none\"> <span class=\"fieldLabel\" style=\"height:25px\"> </span> <span class=\"field\"> <span ng-bind=\"model.emailCodeMsg\"></span> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fphone.newPhoneNum')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <span class=\"codeSelect\"> <tiny-combobox id=\"model.codeSelectId\" values=\"model.codeValues\" value=\"model.defaultValue\" width=\"model.codeSelectWidth\" disable=\"model.disable\" option-width=\"model.optionWidth\" tip-position=\"'top'\" select=\"model.select()\" validate=\"model.countryCodeValidator\" height=\"model.scrollHeight\" content-change=\"model.selectChange(event, value)\" match-method=\"model.matchMethod\" input-field-height=\"model.inputFieldHeight\" tip-position=\"model.tipPosition\"></tiny-combobox> </span> <span class=\"phoneInput\"> <tiny-textbox id=\"model.newPhoneNumId\" value=\"model.newPhoneNum\" width=\"model.phoneInputWidth\" height=\"model.height\" validate=\"model.findPhoneValidator\" tip-position=\"'top'\" placeholder=\"model.newPhoneNumPH\" content-change=\"model.onPhoneChange(event, value)\" focused=\"model.newPhoneNumFocused\" blur=\"model.onPhoneBlur()\" keypressfn=\"model.step2KeyPress\"></tiny-textbox> </span> <span id=\"phoneError\" class=\"errorTipText\"></span> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span ng-bind=\"i18n('fphone.smsVerifyCode')\" style=\"display:inline-block;float:right\"></span> <span class=\"required\">*</span> </span> <span class=\"field\"> <div> <span> <tiny-textbox id=\"model.smsVerifyCodeId\" value=\"model.smsVerifyCode\" validate=\"model.smsMsgCodeValidator\" placeholder=\"i18n('fpwd.verifyCodePH')\" height=\"model.height\" width=\"model.verifyCodeWidth\" blur=\"model.textBlur(model.smsVerifyCodeId)\" content-change=\"model.onSmsVCodeChange(event, value)\" tip-position=\"model.tipPosition\" keypressfn=\"model.step2KeyPress\"></tiny-textbox> </span> <div id=\"smsMsgBtn\" class=\"msgBtn\" style=\"width:210px\" ng-click=\"model.smsVerifyCodeBtnClick()\" tabindex=\"0\"> <span ng-bind=\"model.smsVCodeBtnTxt\"></span> </div> </div> </span> </div> </li> <li class=\"li\"> <div class=\"fieldContainer errorTipText\" id=\"smsCodeMsg\" style=\"display:none\"> <span class=\"fieldLabel\" style=\"height:25px\"> </span> <span class=\"field\"> <span ng-bind=\"model.smsCodeMsg\"></span> </span> </div> </li> <li class=\"li\"> <div class=\"btnDiv\"> <button id=\"nextBtn\" class=\"okButton\" style=\"float:left\" ng-click=\"nextStep2()\" ng-bind=\"i18n('fpwd.nextStepBtn')\"></button> <button class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"turnToStep1()\" ng-bind=\"i18n('fpwd.backTo')\"></button> </div> </li> </ul> </div> <div id=\"step3\" style=\"display:none\" align=\"center\"> <div> <ul> <li> <div class=\"success-title\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"/> <span ng-bind=\"i18n('fphone.changePhoneSuccess')\"></span> </div> </li> <li class=\"li_text number-info\"> <span ng-bind=\"i18n('fphone.newPhoneNumInfo')\"></span> <span ng-bind=\"model.maskNewPhoneNum\"></span> </li> <li> <button id=\"redirect2Login\" class=\"okButton\" ng-click=\"redirect2Login()\" ng-bind=\"i18n('loginNow')\"></button> </li> <li class=\"li_text\"> <span ng-bind=\"model.countToHomepage\"></span> </li> <li class=\"li_text\"> <span style=\"color:#000\" ng-bind=\"i18n('fpwd.directBackTo')\"></span> </li> </ul> </div> </div> </div> <div id=\"fphonePopupMsg\"></div>";
// Exports
module.exports = code;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <span> <span ng-bind=\"i18n('alreadyHaveAccount')\"></span> <a href=\"{{ model.loginUrl }}\" ng-bind=\"i18n('login')\" style=\"color:#c7000b\"></a> </span> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> <div id=\"triangle\"></div> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(105);
var ___HTML_LOADER_IMPORT_1___ = __webpack_require__(91);
var ___HTML_LOADER_IMPORT_2___ = __webpack_require__(27);
var ___HTML_LOADER_IMPORT_3___ = __webpack_require__(10);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var ___HTML_LOADER_REPLACEMENT_2___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_2___);
var ___HTML_LOADER_REPLACEMENT_3___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_3___);
var code = "<meta name=\"viewport\" content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"> <div class=\"findPwdDiv\"> <div class=\"step1 stepDiv\" ng-if=\"model.currentStep === 1\"> <div class=\"fpwdTitle\">{{model.isCompany?i18n(\"fpwd.iamFpwdTitle\"):i18n(\"fpwd.accountFpwdTitle\")}}</div> <div class=\"fpwdTypeChangeDiv\" ng-click=\"model.typeChangeHandler()\"> <div ng-if=\"model.isCompany\" class=\"iam-icon-angle-left\"></div> <div style=\"margin:0 10px\">{{model.isCompany?i18n('fpwd.goAccountFpwd'):i18n('fpwd.goIAMFpwd')}}</div> <div ng-if=\"!model.isCompany\" class=\"iam-icon-angle-right\"></div> </div> <div class=\"formDiv personalAccountForm\" ng-if=\"!model.isCompany\"> <div class=\"formField accountField\" ng-if=\"model.findMethod === 'name'\"> <input type=\"text\" class=\"iam-input-text\" ng-model=\"personalAccountInput.value\" ng-class=\"{'iam-input-error': model.fpwdErrorMsg}\" id=\"{{personalAccountInput.id}}\" placeholder=\"{{personalAccountInput.ph}}\" ng-blur=\"personalAccountInput.blur()\" ng-change=\"personalAccountInput.change()\" ng-style=\"personalAccountInput.style\" maxlength=\"{{personalAccountInput.maxLength}}\" autocomplete=\"off\"> <div ng-if=\"model.fpwdErrorMsg\" class=\"fpwdErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{model.fpwdErrorMsg}}</span> </div> </div> <div class=\"formField phoneField\" ng-if=\"model.findMethod === 'phone'\"> <div class=\"phoneInput\" ng-class=\"{'iam-phoneInput-error': phoneInput.phoneErrorContent, 'iam-phoneInput-focused': phoneInput.focused}\"> <div class=\"codeSelect\" ng-if=\"!model.isMobile\"> {{phoneInput.defaultOption.label}} </div><span ng-if=\"!model.isMobile\">|</span> <input type=\"text\" ng-class=\"{'iam-input-error': phoneInput.phoneErrorContent}\" ng-model=\"phoneInput.phoneValue\" id=\"{{phoneInput.phoneInputId}}\" placeholder=\"{{phoneInput.phonePH}}\" ng-blur=\"phoneInput.phoneBlur()\" ng-change=\"phoneInput.phoneChange()\" ng-style=\"phoneInput.phoneInputStyle\" ng-focus=\"phoneInput.phoneFocus()\" maxlength=\"{{phoneInput.phoneMaxLength}}\" autocomplete=\"off\" ng-init=\"initTipPosition(phoneInput.phoneInputId, phoneInput.phoneTipId)\"> <div id=\"{{phoneInput.phoneTipId}}\" ng-class=\"{'iam-tip-hidden': !phoneInput.phoneErrorContent || !phoneInput.phoneTipShow}\" class=\"iam-ti-tooltip iam-ti-tooltip-top-left\" style=\"display:block\"> <div class=\"iam-ti-tooltip-content\" style=\"overflow-y:auto;padding:1px;white-space:normal\"> {{phoneInput.phoneErrorContent}}</div> <div class=\"iam-ti-tooltip-top-left-sqr\"></div> </div> </div> <div ng-if=\"model.fpwdErrorMsg\" class=\"fpwdErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{model.fpwdErrorMsg}}</span> </div> <div ng-if=\"phoneInput.phoneErrorContent && model.isMobile\" class=\"fpwdErrorMsg\"> <span>{{phoneInput.phoneErrorContent}}</span> </div> </div> <div class=\"formField phoneField\" ng-if=\"model.findMethod === 'phone' && mobileUsers.show\"> <div class=\"dropdown\" tabindex=\"0\" ng-click=\"mobileUsers.click()\" ng-blur=\"mobileUsers.blur()\" ng-focus=\"mobileUsers.focus()\"> <div class=\"dropbtn\"> <div class=\"dropbtn-txt\">{{mobileUsers.defaultOption.name}}</div> <div class=\"dropbtn-arrow\" ng-if=\"!mobileUsers.showOptions\">▼</div> <div class=\"dropbtn-arrow\" ng-if=\"mobileUsers.showOptions\">▲</div> </div> <div class=\"dropdown-content\" ng-if=\"mobileUsers.showOptions && !model.isMobile\"> <div class=\"dropdown-splitline\"></div> <div ng-repeat=\"option in mobileUsers.selectOptions\" ng-click=\"mobileUsers.select(option)\"> {{option.name}}</div> </div> </div> <div class=\"h5-dropdown-container\" ng-if=\"mobileUsers.showOptions && model.isMobile\" ng-click=\"mobileUsers.maskClick($event)\"> <div class=\"h5-dropdown-content\" ng-click=\"$event.stopPropagation()\"> <div class=\"h5-dropdown-title\">{{i18n(\"fpwd.selectUserTitle\")}}</div> <div class=\"h5-option-div\" ng-repeat=\"option in mobileUsers.selectOptions\" ng-click=\"mobileUsers.select(option)\"> <div class=\"h5-option-name\">{{option.name}}</div> <div class=\"h5-option-button\" ng-class=\"{'h5-option-button-checked': option.id === mobileUsers.defaultOption.id}\"> </div> </div> <div class=\"h5-dropdown-cancel\" ng-click=\"mobileUsers.maskClick($event)\"> {{i18n(\"cancelBtnTxt\")}}</div> </div> </div> </div> <div class=\"verifyCodeContainer\"> <div id=\"verifyCode\" ng-class=\"{'verifyCodeFocused': IAMVerifyCode.focused}\"> <div style=\"position:relative;flex:1;margin-right:16px\"> <input type=\"text\" class=\"iam-input-text\" ng-model=\"IAMVerifyCode.checkCode\" id=\"{{IAMVerifyCode.checkCodeId}}\" placeholder=\"{{IAMVerifyCode.checkCodePH}}\" ng-change=\"IAMVerifyCode.preValidVerifyCode()\" ng-focus=\"IAMVerifyCode.focus()\" ng-blur=\"IAMVerifyCode.preValidVerifyCodeBlur()\" ng-style=\"IAMVerifyCode.style\" maxlength=\"{{IAMVerifyCode.maxLength}}\" autocomplete=\"off\"> <img id=\"validresultImg\" style=\"vertical-align:middle;margin-left:10px;display:none\"> </div> <img id=\"inputVerifyCodeImg\" title=\"{{IAMVerifyCode.checkCodeTip}}\" ng-src=\"{{IAMVerifyCode.verifycode}}\" ng-click=\"IAMVerifyCode.getVerifyCode()\"> </div> <div id=\"verifyCodeVaildResult\" class=\"fpwdErrorMsg\" style=\"display:none\"> <img ng-if=\"!model.isMobile\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{i18n('fpwd.invalidVerifyCode')}}</span> </div> </div> <div ng-if=\"!ipIsInternational\" class=\"findMethodChange\"> <div class=\"common-link findByPhone\" ng-if=\"model.findMethod === 'name'\" ng-click=\"model.methodChangeHandler()\">{{i18n(\"fpwd.step1.fpwdByPhone\")}}</div> <div class=\"common-link findByEmail\" ng-if=\"model.findMethod === 'phone'\" ng-click=\"model.methodChangeHandler()\">{{i18n(\"fpwd.step1.fpwdByEmail\")}}</div> </div> </div> <div class=\"formDiv IAMAccountForm\" ng-if=\"model.isCompany\"> <div class=\"formField accountField\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': model.fpwdErrorMsg}\" ng-model=\"IAMAccountInput.value\" id=\"{{IAMAccountInput.id}}\" placeholder=\"{{IAMAccountInput.ph}}\" ng-blur=\"IAMAccountInput.blur()\" ng-change=\"IAMAccountInput.change()\" ng-style=\"IAMAccountInput.style\" maxlength=\"{{IAMAccountInput.maxLength}}\" autocomplete=\"off\"> </div> <div class=\"formField userField\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': model.fpwdErrorMsg}\" ng-model=\"IAMUsernameInput.value\" id=\"{{IAMUsernameInput.id}}\" placeholder=\"{{IAMUsernameInput.ph}}\" ng-blur=\"IAMUsernameInput.blur()\" ng-change=\"IAMUsernameInput.change()\" ng-style=\"IAMUsernameInput.style\" maxlength=\"{{IAMUsernameInput.maxLength}}\" autocomplete=\"off\"> <div ng-if=\"model.fpwdErrorMsg\" class=\"fpwdErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{model.fpwdErrorMsg}}</span> </div> <input style=\"position:absolute;top:-100px;left:0;z-index:-1\" type=\"password\" name=\"hidePass\" autocomplete=\"new-password\"> </div> <div class=\"verifyCodeContainer\"> <div id=\"verifyCode\" ng-class=\"{'verifyCodeFocused': IAMVerifyCode.focused}\"> <div style=\"position:relative;flex:1;margin-right:16px\"> <input type=\"text\" class=\"iam-input-text\" ng-model=\"IAMVerifyCode.checkCode\" id=\"{{IAMVerifyCode.checkCodeId}}\" placeholder=\"{{IAMVerifyCode.checkCodePH}}\" ng-change=\"IAMVerifyCode.preValidVerifyCode()\" ng-focus=\"IAMVerifyCode.focus()\" ng-blur=\"IAMVerifyCode.preValidVerifyCodeBlur()\" ng-style=\"IAMVerifyCode.style\" maxlength=\"{{IAMVerifyCode.maxLength}}\" autocomplete=\"off\"> </div> <img id=\"inputVerifyCodeImg\" title=\"{{IAMVerifyCode.checkCodeTip}}\" ng-src=\"{{IAMVerifyCode.verifycode}}\" ng-click=\"IAMVerifyCode.getVerifyCode()\"> </div> <div id=\"verifyCodeVaildResult\" class=\"fpwdErrorMsg\" style=\"display:none\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{i18n('fpwd.invalidVerifyCode')}}</span> </div> </div> </div> <div class=\"stepBtnDiv\"> <div class=\"next-step-btn stepNextBtn\" ng-class=\"{'disabledStepNextBtn': (personalAccountInput.value===''||IAMVerifyCode.checkCode=='') && (phoneInput.phoneValue===''|| IAMVerifyCode.checkCode==='') && (IAMAccountInput.value===''||IAMUsernameInput.value===''||IAMVerifyCode.checkCode==='')}\" ng-click=\"step1NextHandler()\">{{model.stepNextBtnTxt}}</div> </div> </div> <div class=\"step2 stepDiv\" ng-if=\"model.currentStep === 2\"> <div ng-if=\"authMethod.hasEmail || authMethod.hasPhone\" class=\"step2Content\"> <div class=\"fpwdTitle\">{{i18n(\"fpwd.identityVerification\")}}</div> <div class=\"fpwdErrorMsg\">{{model.fpwdErrorMsg}}</div> <div class=\"verifycodeDiv formDiv\"> <div class=\"authMethodList\"> {{authMethod.selectObj.authMethodText}} </div> <div class=\"authVerifyCode\" ng-class=\"{'authVerifyCodeFocused': authVerifyCode.tipShow}\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': authVerifyCode.errorContent || authVerifyCode.verifycodeErrorInfo}\" ng-model=\"authVerifyCode.value\" id=\"{{authVerifyCode.id}}\" placeholder=\"{{authVerifyCode.ph}}\" ng-blur=\"authVerifyCode.blur()\" ng-change=\"authVerifyCode.change()\" ng-style=\"authVerifyCode.style\" ng-focus=\"authVerifyCode.focus()\" maxlength=\"{{authVerifyCode.maxLength}}\" autocomplete=\"off\" ng-init=\"initTipPosition(authVerifyCode.id, authVerifyCode.tipId)\"> <div id=\"{{authVerifyCode.tipId}}\" ng-class=\"{'iam-tip-hidden': !authVerifyCode.errorContent || !authVerifyCode.tipShow}\" class=\"iam-ti-tooltip iam-ti-tooltip-top-left\" style=\"display:block\"> <div class=\"iam-ti-tooltip-content\" style=\"overflow-y:auto;padding:1px;white-space:normal\">{{authVerifyCode.errorContent}} </div> <div class=\"iam-ti-tooltip-top-left-sqr\"></div> </div> <div ng-if=\"!authMethod.selectObj.retrieveVerifyCode\" id=\"sendVerifyCode\" class=\"sendVerifyCode\" ng-click=\"authMethod.sendVerifyCodeClick()\">{{i18n(\"fpwd.step2.sendVerificationCode\")}}</div> <div ng-if=\"authMethod.selectObj.retrieveVerifyCode\" id=\"retrieveVerifyCode\" class=\"retrieveVerifyCode\"> {{authMethod.selectObj.retrieveVerifyCodeTxt}}</div> </div> <div ng-if=\"authVerifyCode.errorContent && model.isMobile\" class=\"fpwdErrorMsg\"> <span>{{authVerifyCode.errorContent}}</span> </div> <div class=\"fpwdErrorMsg\" ng-if=\"authVerifyCode.verifycodeErrorInfo\"> <img ng-if=\"!model.isMobile\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> {{authVerifyCode.verifycodeErrorInfo}} </div> <div ng-if=\"authMethod.hasEmail && authMethod.hasPhone\" class=\"changeAuthMethodType common-link\" ng-click=\"authMethod.authMethodChange()\"> {{authMethod.selectObj.changeAuthMethodText}} </div> </div> <div class=\"stepBtnDiv\"> <div class=\"next-step-btn stepNextBtn\" ng-class=\"{'disabledStepNextBtn': authVerifyCode.value==''}\" ng-click=\"step2NextHandler()\">{{model.stepNextBtnTxt}}</div> </div> <div class=\"contactService\"> <div ng-if=\"!model.isCompany\"> <span>{{i18n(\"fpwd.step2.accountHelpMsg\")}}</span> </div> <div ng-if=\"model.isCompany\"> <span>{{i18n(\"fpwd.step2.exceptionService\")}}</span> </div> </div> </div> <div ng-if=\"!authMethod.hasEmail && !authMethod.hasPhone\" class=\"step2Content\"> <div class=\"fpwdTitle\">{{i18n(\"fpwd.identityVerification\")}}</div> <div class=\"fpwdErrorMsg noAuthority\">{{fpwdModel.fpwdErrorMsg}}</div> <div class=\"exceptionService\" ng-if=\"fpwdModel.selectedType === 'iam'\"> {{i18n(\"fpwd.step2.exceptionService\")}}</div> <div class=\"stepBtnDiv\"> <div class=\"next-step-btn stepNextBtn\" ng-click=\"fpwdModel.redirect2Login()\">{{i18n(\"fpwd.goToLogin\")}} </div> </div> </div> </div> <div class=\"step3 stepDiv\" ng-if=\"model.currentStep === 3\"> <div class=\"fpwdTitle\">{{i18n(\"fpwd.passwordReset\")}}</div> <div class=\"fpwdErrorMsg\">{{model.fpwdErrorMsg}}</div> <div class=\"newPassDiv\"> <div style=\"position:relative\"> <input type=\"password\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': passwordInput.isWeakPassword || !passwordInput.isCorrect}\" ng-model=\"passwordInput.value\" id=\"{{passwordInput.id}}\" placeholder=\"{{passwordInput.ph}}\" ng-blur=\"passwordInput.blur()\" ng-style=\"passwordInput.style\" ng-change=\"passwordInput.change()\" ng-focus=\"passwordInput.focus()\" maxlength=\"{{passwordInput.maxLength}}\" autocomplete=\"new-password\" ng-init=\"initTipPosition(passwordInput.id, passwordInput.tipId, 'bottom-left')\"> <span class=\"pwdShowimg\" ng-class=\"{'iam-icon-action-state-visible': passwordInput.pwdVisible, 'iam-icon-action-state-invisible': !passwordInput.pwdVisible}\" ng-click=\"passwordInput.pwdVisibleFunc()\"></span> </div> <div id=\"{{passwordInput.tipId}}\" ng-class=\"{'iam-tip-hidden': !passwordInput.tipShow}\" class=\"iam-ti-tooltip iam-ti-tooltip-bottom-left\" style=\"display:block\"> <div class=\"iam-ti-tooltip-content\" style=\"overflow-y:auto;padding:1px;white-space:normal\"></div> <div class=\"iam-ti-tooltip-right-bottom-left-sqr\"></div> </div> </div> <div class=\"confirmPassDiv\"> <div style=\"position:relative\"> <input type=\"password\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': confirmPasswordInput.tipContent}\" ng-model=\"confirmPasswordInput.value\" id=\"{{confirmPasswordInput.id}}\" placeholder=\"{{confirmPasswordInput.ph}}\" ng-blur=\"confirmPasswordInput.blur()\" ng-style=\"confirmPasswordInput.style\" ng-change=\"confirmPasswordInput.change()\" ng-focus=\"confirmPasswordInput.focus()\" autocomplete=\"new-password\" ng-init=\"initTipPosition(confirmPasswordInput.id, confirmPasswordInput.tipId, 'bottom-left')\"> <span class=\"pwdShowimg\" ng-class=\"{'iam-icon-action-state-visible': confirmPasswordInput.pwdVisible, 'iam-icon-action-state-invisible': !confirmPasswordInput.pwdVisible}\" ng-click=\"confirmPasswordInput.pwdVisibleFunc()\"></span> </div> <div id=\"{{confirmPasswordInput.tipId}}\" ng-class=\"{'iam-tip-hidden': !confirmPasswordInput.tipShow || !confirmPasswordInput.tipContent}\" class=\"iam-ti-tooltip iam-ti-tooltip-bottom-left\" style=\"display:block\"> <div class=\"iam-ti-tooltip-content\" style=\"overflow-y:auto;padding:1px;white-space:normal\"> {{confirmPasswordInput.tipContent}}</div> <div class=\"iam-ti-tooltip-bottom-left-sqr\"></div> </div> <div ng-if=\"confirmPasswordInput.tipContent && model.isMobile\" class=\"fpwdErrorMsg\"> <span>{{confirmPasswordInput.tipContent}}</span> </div> </div> <div id=\"{{passwordInput.h5TipId}}\" ng-show=\"model.isMobile\" style=\"display:block\"> <div class=\"h5PasswordMsg\">{{i18n(\"fpwd.pwdValidateRule\")}}</div> <div class=\"iam-ti-tooltip-content\" style=\"padding:1px;white-space:normal\"></div> </div> <div class=\"stepBtnDiv\"> <div class=\"next-step-btn stepNextBtn\" ng-click=\"step3NextHandler()\">{{model.submitBtnTxt}}</div> </div> </div> <div class=\"step4 stepDiv\" ng-if=\"model.currentStep === 4\"> <div class=\"resultDiv\"> <img class=\"image\" ng-src=\"{{step4Model.resultImg}}\" alt=\"\"> <span class=\"msg\">{{i18n(\"fpwd.successTxt\")}}</span> </div> <div class=\"stepBtnDiv\"> <div class=\"next-step-btn stepFinishBtn\" ng-click=\"redirect2Login()\">{{i18n(\"loginNow\")}}</div> </div> <div class=\"tip\">{{step4Model.loginCountdownTxt}}</div> </div> </div> <div id=\"fpwdPopupMsg\"></div> <div id=\"fpwd-graphics-verify-mask\" ng-if=\"graphicVerifyCodeModal.isShow\"> </div> <div id=\"fpwd-graphics-verify\" ng-if=\"graphicVerifyCodeModal.isShow\"> <div> <div class=\"modal-header\"> <div class=\"header-title\"> {{i18n('GraphicsVerifyCode')}} </div> <div class=\"header-icon\" ng-click=\"graphicVerifyCodeModal.onCancel()\"> </div> </div> <div class=\"modal-body\"> <div> <img class=\"graphicsTip\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"> <span>{{i18n(\"InputGrapVerifyCodeInfo\")}}</span> </div> <div class=\"verifycode-row\"> <span>{{i18n(\"GraphicsVerifyCodeLabel\")}}</span> <input id=\"fpwd-graphics-input\" class=\"iam-input-text\" ng-model=\"graphicVerifyCodeModal.verifyCode\" ng-change=\"graphicVerifyCodeModal.onVerifyCodeChange()\"/> <img class=\"verifycode-img\" ng-src=\"{{graphicVerifyCodeModal.verifyCodeSrc}}\" ng-click=\"graphicVerifyCodeModal.init()\"/> <img ng-if='graphicVerifyCodeModal.verifyStatus === \"success\"' class=\"status-img\" src=\"" + ___HTML_LOADER_REPLACEMENT_2___ + "\"/> <img ng-if='graphicVerifyCodeModal.verifyStatus === \"fail\"' class=\"status-img\" src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"/> </div> </div> <div class=\"modal-footer\"> <div class=\"footer-buttons\"> <button class=\"tiny-btn-basic tiny-btn-without-icon\" ng-click=\"graphicVerifyCodeModal.onConfirm()\"> <span class=\"tiny-btn-text\" style=\"min-width:40px\"> {{i18n('submitBtnTxt')}} </span> </button> <button class=\"tiny-btn-basic tiny-btn-without-icon\" ng-click=\"graphicVerifyCodeModal.onCancel()\"> <span class=\"tiny-btn-text\" style=\"min-width:40px\"> <span class=\"tiny-btn-text\" style=\"min-width:40px\"> {{i18n('cancelBtnTxt')}} </span> </span></button> </div> </div> </div> </div>";
// Exports
module.exports = code;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-if=\"model.currentLanguage === 'zh-cn'\" ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> <div id=\"triangle\"></div> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(67);
var ___HTML_LOADER_IMPORT_1___ = __webpack_require__(92);
var ___HTML_LOADER_IMPORT_2___ = __webpack_require__(321);
var ___HTML_LOADER_IMPORT_3___ = __webpack_require__(105);
var ___HTML_LOADER_IMPORT_4___ = __webpack_require__(95);
var ___HTML_LOADER_IMPORT_5___ = __webpack_require__(324);
var ___HTML_LOADER_IMPORT_6___ = __webpack_require__(344);
var ___HTML_LOADER_IMPORT_7___ = __webpack_require__(329);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var ___HTML_LOADER_REPLACEMENT_2___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_2___);
var ___HTML_LOADER_REPLACEMENT_3___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_3___);
var ___HTML_LOADER_REPLACEMENT_4___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_4___);
var ___HTML_LOADER_REPLACEMENT_5___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_5___);
var ___HTML_LOADER_REPLACEMENT_6___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_6___);
var ___HTML_LOADER_REPLACEMENT_7___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_7___);
var code = "<style ng-if=\"model.isLiteSDK\">#hwLoginDivId .otherLoginWays{width:auto}.privacyMsg{margin-top:70px;margin-bottom:0}</style> <div id=\"loginAdv\" class=\"ng-cloak\"></div> <div class=\"loginDiv\"> <div class=\"QRLoginSwitchDiv\" ng-if=\"QRLoginModel.hasQRLogin && !quickLoginModel.hasQuickLogin\"> <div class=\"QRLogin\" ng-click=\"QRLoginModel.QRLoginTypeSwitch(true)\"> <div ng-class=\"{'selectedType': QRLoginModel.isQRLogin}\">{{i18n('QRLogin.title1')}}</div> </div> <div class=\"intervalDiv\"></div> <div class=\"accountLogin\" ng-click=\"QRLoginModel.QRLoginTypeSwitch(false)\"> <div ng-class=\"{'selectedType': !QRLoginModel.isQRLogin}\">{{i18n('QRLogin.accountLogin')}}</div> </div> </div> <div ng-if=\"QRLoginModel.isQRLogin\" id=\"QRLoginDiv\" class=\"ng-cloak\"> <div ng-if=\"QRLoginModel.QRCodeStatus == 'new'\"> <div id=\"countDownDiv\"> <span>{{i18n(\"QRLogin.countDownTipPre1\")}} <span style=\"color:#ff9220\">{{i18n(\"QRLogin.countDownTipPre2\")}}</span> {{i18n(\"QRLogin.countDownTipPre3\")}}</span><span ng-if=\"!QRLoginModel.QRCodeInvalid\">{{i18n(\"QRLogin.comma\")}}</span><span ng-if=\"model.language !== 'zh-cn' && !QRLoginModel.QRCodeInvalid\">{{QRLoginModel.countDownTipSuffix}}</span><span class=\"remainingTimeTxt\" ng-if=\"!QRLoginModel.QRCodeInvalid\">{{QRLoginModel.remainingTime}}</span><span ng-if=\"model.language === 'zh-cn' && !QRLoginModel.QRCodeInvalid\">{{QRLoginModel.countDownTipSuffix}}</span> </div> <div class=\"QRCodeOuter\"> <canvas id=\"loginQRCodeDiv\" class=\"loginQRCodeDiv\"></canvas> <div ng-if=\"QRLoginModel.QRCodeInvalid\" class=\"QRCodeInner\"> <div class=\"QRCodeInvalid\">{{i18n(\"QRLogin.QRCodeInvalid\")}}</div> <div id=\"refreshQRCodeBtn\" ng-click=\"QRLoginModel.refreshQRCode()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\">{{i18n(\"QRLogin.refresh\")}}</span> </div> </div> </div> </div> <div class=\"loginStatusDiv\" ng-if=\"QRLoginModel.QRCodeStatus == 'authorizing'\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" class=\"loginStatusImg\"> <div class=\"loginStatusTitle\">{{i18n(\"QRLogin.scanSuc\")}}</div> <div class=\"loginStatusMessage\">{{i18n(\"QRLogin.scanSucTip\")}}</div> </div> <div class=\"loginStatusDiv\" ng-if=\"QRLoginModel.QRCodeStatus == 'refused'\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\" class=\"loginStatusImg\"> <div> <div class=\"loginStatusTitle\">{{i18n(\"QRLogin.loginFail\")}}</div> <div class=\"loginStatusMessage\"> <span>{{i18n(\"QRLogin.loginFailTipPre\")}}</span><a href=\"javascript:void(0)\" ng-click=\"QRLoginModel.refreshQRCode()\">{{i18n(\"QRLogin.refresh\")}}</a><span>{{i18n(\"QRLogin.loginFailTipSuffix\")}}</span> </div> </div> </div> <div id=\"QRLoginBottomDiv\"> <a class=\"QRLoginBottomColor\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.registUrl}}\" ng-bind=\"i18n('quickLogin.register')\" ng-click=\"BiEvent('send','event','button','click','login_freeRegister',model.registUrl)\"></a> <div class=\"intervalDiv\">|</div> <a class=\"QRLoginBottomColor\" target=\"_blank\" rel=\"noopener noreferrer\" ng-bind=\"i18n('QRLogin.downloadApp')\" href=\"{{QRLoginModel.downloadUrl}}\"></a> </div> </div> <div ng-show=\"!QRLoginModel.isQRLogin && model.loginType === 'iam'\" id=\"loginForm\" class=\"ng-cloak\"> <div class=\"loginTypeDiv ng-cloak\"> <span class=\"loginTypeNoSelected\" ng-bind=\"i18n('enterpriseUser')\"></span> </div> <div ng-if=\"IAMLoginErrorMsg.show\" class=\"errorMsgDiv\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_2___ + "\"> <div class=\"msgDiv\"> <span class=\"msgContent\" ng-bind-html=\"IAMLoginErrorMsg.content\"></span> <a href=\"{{IAMLoginErrorMsg.goLoginHref}}\" ng-if=\"IAMLoginErrorMsg.goLoginShow\">{{IAMLoginErrorMsg.goLoginContent}}</a> </div> </div> <div id=\"serverError\"> <span style=\"font-size:small;color:#f66f6a;margin-left:0\"></span> </div> <div class=\"loginFormDiv\"> <div ng-if=\"!QRLoginModel.isQRLogin && model.isCompany\" class=\"hideInputDiv\" style=\"position:absolute;top:-100px;left:0;z-index:-1\"> <input type=\"text\" name=\"hideName\"> <input type=\"password\" name=\"hidePass\"> </div> <div class=\"inputField\" style=\"position:relative\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': IAMLoginErrorMsg.domainError, '': !IAMLoginErrorMsg.domainError}\" ng-model=\"IAMAccountInput.value\" id=\"{{IAMAccountInput.id}}\" placeholder=\"{{IAMAccountInput.ph}}\" ng-disabled=\"IAMAccountInput.disable\" ng-blur=\"IAMAccountInput.blur()\" ng-change=\"IAMAccountInput.change()\" ng-init=\"bindIAMAccountTip()\" ng-style=\"IAMAccountInput.style\" maxlength=\"{{IAMAccountInput.maxLength}}\" autocomplete=\"off\"> <div class=\"inputClearIcon\" ng-if=\"IAMAccountInput.value\" ng-click=\"IAMAccountInput.clear()\"></div> <div ng-if=\"IAMLoginErrorMsg.domainError\" class=\"loginErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{IAMLoginErrorMsg.content}}</span> </div> </div> <div class=\"inputField\" style=\"position:relative\"> <form action=\"javascript:void(0)\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': IAMLoginErrorMsg.usernameError || IAMLoginErrorMsg.nameOrPwdError, '': !IAMLoginErrorMsg.usernameError && !IAMLoginErrorMsg.nameOrPwdError}\" ng-model=\"IAMUsernameInput.value\" id=\"{{IAMUsernameInput.id}}\" placeholder=\"{{IAMUsernameInput.ph}}\" ng-blur=\"IAMUsernameInput.blur()\" ng-change=\"IAMUsernameInput.change()\" ng-init=\"bindIAMUsernameTip()\" ng-style=\"IAMUsernameInput.style\" maxlength=\"{{IAMUsernameInput.maxLength}}\" autocomplete=\"off\"> <div class=\"inputClearIcon\" ng-if=\"IAMUsernameInput.value\" ng-click=\"IAMUsernameInput.clear()\"></div> </form> <div ng-if=\"IAMLoginErrorMsg.usernameError\" class=\"loginErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{IAMLoginErrorMsg.content}}</span> </div> </div> <div class=\"inputField pwdInputField\"> <form action=\"javascript:void(0)\"> <input type=\"password\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': IAMLoginErrorMsg.pwdError || IAMLoginErrorMsg.nameOrPwdError, '': !IAMLoginErrorMsg.pwdError && !IAMLoginErrorMsg.nameOrPwdError}\" ng-model=\"IAMPasswordInput.value\" id=\"{{IAMPasswordInput.id}}\" placeholder=\"{{IAMPasswordInput.ph}}\" ng-blur=\"IAMPasswordInput.pwdBlur()\" ng-style=\"IAMPasswordInput.style\" ng-change=\"IAMPasswordInput.change()\" maxlength=\"{{IAMPasswordInput.maxLength}}\" autocomplete=\"new-password\" oncut=\"return!1\" oncopy=\"return!1\"> </form> <span class=\"pwdShowimg\" ng-class=\"{'iam-icon-action-state-visible': IAMPasswordInput.pwdVisible, 'iam-icon-action-state-invisible': !IAMPasswordInput.pwdVisible}\" ng-click=\"IAMPasswordInput.pwdVisibleFunc()\"></span> <div ng-if=\"IAMLoginErrorMsg.pwdError || IAMLoginErrorMsg.nameOrPwdError\" class=\"loginErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{IAMLoginErrorMsg.content}}</span> </div> </div> </div> <div class=\"verifyCodeContainer\" ng-if=\"IAMVerifyCode.isNeedVerifyCode\"> <div id=\"verifyCode\" ng-class=\"{'verifyCodeFocused': IAMVerifyCode.focused}\"> <div style=\"position:relative\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': IAMLoginErrorMsg.verifycodeError, '': !IAMLoginErrorMsg.verifycodeError}\" ng-model=\"IAMVerifyCode.checkCode\" id=\"{{IAMVerifyCode.checkCodeId}}\" placeholder=\"{{IAMVerifyCode.checkCodePH}}\" ng-change=\"IAMVerifyCode.preValidVerifyCode()\" ng-blur=\"IAMVerifyCode.preValidVerifyCodeBlur()\" ng-style=\"IAMVerifyCode.style\" ng-focus=\"IAMVerifyCode.focus()\" maxlength=\"{{IAMVerifyCode.maxLength}}\"> <img id=\"validresultImg\" style=\"vertical-align:middle;margin-left:10px;display:none\"> </div> <img id=\"inputVerifyCodeImg\" title=\"{{IAMVerifyCode.checkCodeTip}}\" ng-src=\"{{IAMVerifyCode.verifycode}}\" ng-click=\"IAMVerifyCode.getVerifyCode()\"> </div> <div ng-if=\"IAMLoginErrorMsg.verifycodeError\" class=\"loginErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{IAMLoginErrorMsg.content}}</span> </div> </div> <div class=\"buttonAreaDiv\"> <div id=\"buttonArea\"> <div id=\"loginBtn\" ng-class=\"{'loginBtnDisabled': loginBtn.disable}\" ng-click=\"loginBtn.loginClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"loginBtn.submitBtnText\"></span> </div> </div> </div> <div id=\"bottomBtns\"> <div class=\"forgetPwdLink commonLinkDiv\" tabindex=\"0\"> <span ng-click=\"goFpwd('send','event','button','click','login_fpwd')\" class=\"loginswap loginBottomColor\" ng-bind=\"i18n('hwId.forgetPwd')\"></span> </div> <div id=\"iamCheckArea\" class=\"checkboxDiv checkArea\"> <input id=\"checkboxInput\" type=\"checkbox\" name=\"checkboxInput\" ng-model=\"model.rememberChecked\"> <label for=\"checkboxInput\"></label> <span ng-click=\"model.rememberCheckedChange()\">{{model.chkTxt}}</span> </div> </div> <div class=\"otherLoginWays\" ng-if=\"!QRLoginModel.isQRLogin && model.loginType === 'iam'\"> <span class=\"otherLoginTip\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-if=\"model.isMobile\">{{i18n(\"hwId.otherAccount.h5\")}}</span> <span ng-if=\"!model.isMobile\">{{i18n(\"hwId.otherAccount\")}}</span> </span><span class=\"intervalDiv\"></span> <span id=\"hwAccountLinkDiv\" class=\"otherItemDiv\" tabindex=\"0\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goHwAccountLogin()\" ng-bind=\"quickLoginModel.hasQuickLogin ? i18n('quickLogin.title') : i18n('hwId.hwAccount')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\">|</span> <span id=\"idpLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_idp', model.hwportalUrl)\"> <span ng-click=\"goIDPLogin()\" ng-bind=\"i18n('idpLogin.loginLink')\" class=\"otherLoginColor\"></span> </span> </div> </div> <div ng-show=\"!QRLoginModel.isQRLogin && model.loginType === 'account' && !model.sdkLoading && !quickLoginModel.hasQuickLogin\" id=\"hwLoginDivId\" class=\"ng-cloak\"> <div id=\"hwidsdk_mudule_container\"> <div class=\"hwidsdk_mudule\"></div> </div> <div class=\"otherLoginWays forPc\" ng-if=\"!QRLoginModel.isQRLogin && model.loginType === 'account' && !model.sdkLoading && !quickLoginModel.hasQuickLogin\"> <div class=\"otherLoginTip\"> <span>{{i18n(\"usingOtherWaysLogin\")}}</span> </div> <div> <span id=\"IAMLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIAMLogin()\" ng-bind=\"i18n('fpwd.IAMAccount')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval firstInterval\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"idpLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_idp', model.hwportalUrl)\"> <span ng-click=\"goIDPLogin()\" ng-bind=\"i18n('idpLogin.loginLink')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval secondInterval\" ng-if=\"model.hasHwCloudLink\">|</span> <span id=\"hwportalLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"hwportalLogin()\" ng-bind=\"i18n('hwId.hwportal')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"eChannelLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.eChannelUrl)\"> <span ng-click=\"eChannelLogin()\" ng-bind=\"i18n('hwId.eChannel')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"originalLoginDiv\" ng-if=\"model.hasHwCloudLink\" class=\"otherItemDiv\"> <span ng-click=\"originalLogin()\" ng-bind=\"i18n('hwId.hwCloudAccount')\" class=\"otherLoginColor\"></span> </span> </div> </div> <div class=\"otherLoginWays forMobile\" ng-if=\"!QRLoginModel.isQRLogin && model.loginType === 'account' && !model.sdkLoading && !quickLoginModel.hasQuickLogin\"> <div class=\"otherLoginTip\"> <span>{{i18n(\"usingOtherWaysLogin\")}}</span> </div> <div class=\"loginLinkFirstLayer\" ng-if=\"!model.isLiteSDK\"> <span id=\"IAMLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIAMLogin()\" ng-bind=\"i18n('fpwd.IAMAccount')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval firstInterval\">|</span> <span id=\"idpLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_idp', model.hwportalUrl)\"> <span ng-click=\"goIDPLogin()\" ng-bind=\"i18n('idpLogin.loginLink')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval secondInterval\" ng-if=\"model.hasHwCloudLink\">|</span> <span id=\"hwportalLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"hwportalLogin()\" ng-bind=\"i18n('hwId.hwportal')\" class=\"otherLoginColor\"></span> </span> </div> <div class=\"loginLinkSecondLayer\" ng-if=\"!model.isLiteSDK\"> <span id=\"eChannelLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.eChannelUrl)\"> <span ng-click=\"eChannelLogin()\" ng-bind=\"i18n('hwId.eChannel')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval\">|</span> <span id=\"originalLoginDiv\" ng-if=\"model.hasHwCloudLink\" class=\"otherItemDiv\"> <span ng-click=\"originalLogin()\" ng-bind=\"i18n('hwId.hwCloudAccount')\" class=\"otherLoginColor\"></span> </span> </div> <div class=\"loginLinkSecondLayer\" ng-if=\"model.isLiteSDK\"> <span id=\"IAMLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIAMLogin()\" ng-bind=\"i18n('fpwd.IAMAccount')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv hwInterval firstInterval\">|</span> <span id=\"originalLoginDiv\" ng-if=\"model.hasHwCloudLink\" class=\"otherItemDiv\"> <span ng-click=\"originalLogin()\" ng-bind=\"i18n('hwId.hwCloudAccount')\" class=\"otherLoginColor\"></span> </span> </div> </div> <div class=\"privacyMsg\"> <span>{{i18n('hwId.privacyContent')}}</span><a class=\"privacyMsgLink\" href=\"{{model.privacyLink}}\">{{i18n('learnMore')}}</a> </div> </div> <div ng-show=\"!QRLoginModel.isQRLogin && model.loginType === 'account' && model.sdkLoading && !quickLoginModel.hasQuickLogin\" class=\"hwLoginDivMask\" class=\"ng-cloak\"> <img class=\"loadingImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_4___ + "\"/> </div> <div ng-if=\"!QRLoginModel.isQRLogin && model.loginType === 'account' && quickLoginModel.hasQuickLogin\" id=\"quickLoginDiv\" class=\"ng-cloak\"> <div class=\"quickLoginForm\" ng-if=\"!quickLoginModel.showSelectStep\"> <div class=\"loginTypeDiv ng-cloak\"> <span class=\"loginTypeNoSelected\" ng-bind=\"i18n('quickLogin.title')\"></span> </div> <div class=\"loginTip\">{{quickLoginModel.loginTip}}</div> <div class=\"inputField\" ng-class=\"{'inputFieldFocused': quickAccountInput.focused,'iam-input-error': quickAccountInput.error}\"> <input type=\"text\" class=\"iam-input-text\" ng-model=\"quickAccountInput.value\" id=\"{{quickAccountInput.id}}\" placeholder=\"{{quickAccountInput.ph}}\" ng-disabled=\"quickAccountInput.disable\" ng-blur=\"quickAccountInput.blur()\" ng-change=\"quickAccountInput.change()\" ng-style=\"quickAccountInput.style\" ng-focus=\"quickAccountInput.focus()\" maxlength=\"{{quickAccountInput.maxLength}}\" autocomplete=\"off\"> <div class=\"input-icon-right\"> <div class=\"icon-clear\" ng-if=\"quickAccountInput.value\" ng-click=\"quickAccountInput.clear()\"></div> <div ng-if=\"quickLoginUsers.hasDropdown\" ng-class=\"{'icon-downward': !quickLoginUsers.dropdownOpen, 'icon-packup': quickLoginUsers.dropdownOpen}\" ng-click=\"quickLoginUsers.dropdownBtnClick()\" ng-blur=\"quickLoginUsers.closeDropdown()\" tabindex=\"1\"> <div class=\"users-dropdown\" ng-if=\"quickLoginUsers.dropdownOpen && !model.isMobile\"> <div ng-repeat=\"option in quickLoginUsers.options\" class=\"users-dropdown-option\" ng-click=\"quickLoginUsers.dropdownSelect(option)\"> <div class=\"option-label\">{{option.name}}</div> <div class=\"option-state\" ng-class=\"{'option-state-checked': option.userid == quickLoginUsers.selectedUserTemp.userid}\"></div> </div> </div> <div class=\"h5-dropdown-container\" ng-if=\"quickLoginUsers.dropdownOpen && model.isMobile\" ng-click=\"quickLoginUsers.maskClick($event)\"> <div class=\"h5-dropdown-content\" ng-click=\"$event.stopPropagation()\"> <div class=\"h5-dropdown-title\">{{i18n(\"quickLogin.selectUsersTitle.h5\")}}</div> <div class=\"h5-option-div\" ng-repeat=\"option in quickLoginUsers.options\" ng-click=\"quickLoginUsers.H5DropdownSelect(option)\"> <div class=\"h5-option-name\">{{option.name}}</div> <div class=\"h5-option-button\" ng-class=\"{'h5-option-button-checked': option.userid == quickLoginUsers.selectedUserTemp.userid}\"> </div> </div> <div class=\"h5-dropdown-buttons\"> <div class=\"h5-dropdown-cancel\" ng-click=\"quickLoginUsers.maskClick($event)\"> {{i18n(\"cancelBtnTxt\")}}</div> <div class=\"h5-dropdown-cancel\"> |</div> <div class=\"h5-dropdown-ok\" ng-click=\"quickLoginUsers.H5DropdownSubmit($event)\"> {{i18n(\"submitBtnTxt\")}}</div> </div> </div> </div> </div> </div> </div> <div ng-if=\"quickAccountInput.error\" class=\"loginErrorMsg quickLoginError\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{quickAccountInput.error}}</span> </div> <div class=\"quickLoginCode\" ng-class=\"{'quickLoginCodeFocused': quickLoginCode.focused,'iam-input-error': quickLoginCode.error}\"> <input type=\"text\" class=\"iam-input-text\" id=\"{{quickLoginCode.id}}\" placeholder=\"{{quickLoginCode.ph}}\" ng-model=\"quickLoginCode.value\" ng-blur=\"quickLoginCode.blur()\" ng-focus=\"quickLoginCode.focus()\" ng-change=\"quickLoginCode.change()\"> <div class=\"quickLoginCodeBtn\" ng-class=\"{'quickLoginCodeBtnDisabled': quickLoginCode.emailBtnDisabled}\" ng-click=\"quickLoginCode.getVerifyCode()\" ng-if=\"quickLoginModel.loginType === 'email'\">{{quickLoginCode.emailBtnTxt}}</div> <div class=\"quickLoginCodeBtn\" ng-class=\"{'quickLoginCodeBtnDisabled': quickLoginCode.mobileBtnDisabled}\" ng-click=\"quickLoginCode.getVerifyCode()\" ng-if=\"quickLoginModel.loginType === 'mobile'\">{{quickLoginCode.mobileBtnTxt}}</div> </div> <div ng-if=\"quickLoginCode.error\" class=\"loginErrorMsg quickLoginError\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{quickLoginCode.error}}</span> </div> <div class=\"quickLoginType\"> <span ng-click=\"quickLoginModel.loginType === 'mobile' ? quickLoginModel.loginTypeChange('email') : quickLoginModel.loginTypeChange('mobile')\"> {{quickLoginModel.loginType === 'mobile' ? i18n('quickLogin.emailLogin') : i18n('quickLogin.mobileLogin') }} </span> </div> <div id=\"quickLoginBtn\" ng-class=\"{'loginBtnDisabled': !quickAccountInput.value || !quickLoginCode.value || quickAccountInput.error || quickLoginCode.error }\" ng-click=\"quickLoginBtn.loginClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"quickLoginBtn.submitBtnText\"></span> </div> </div> <div class=\"selectUsers\" ng-if=\"quickLoginModel.showSelectStep\"> <div class=\"selectUsersTitle\"> <span class=\"right-arrow\" ng-click=\"quickLoginUsers.back()\"></span> <span>{{i18n('quickLogin.selectUsersTitle')}}</span> </div> <div class=\"userOptionsContainer\"> <div ng-repeat=\"option in quickLoginUsers.options\" class=\"userOptionDiv\" ng-click=\"quickLoginUsers.select(option)\"> <div class=\"option-label\">{{option.name}}</div> <div class=\"option-button\" ng-class=\"{'option-button-checked': option.userid == quickLoginUsers.selectedUserTemp.userid}\"></div> </div> </div> <div id=\"quickLoginUsers.btnId\" ng-click=\"quickLoginUsers.btnClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"quickLoginUsers.btnText\"></span> </div> </div> <div class=\"registerDiv\"> <a class=\"QRLoginBottomColor\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.registUrl}}\" ng-bind=\"i18n('quickLogin.register')\" ng-click=\"BiEvent('send','event','button','click','login_freeRegister',model.registUrl)\"></a> </div> <div class=\"otherLoginWays\"> <span class=\"otherLoginTip\"> <span>{{i18n(\"hwId.otherAccount.h5\")}}</span> </span> <span id=\"IAMLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIAMLogin()\" ng-bind=\"i18n('enterpriseUserLogin')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"hwportalLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"hwportalLogin()\" ng-bind=\"i18n('hwId.hwportal')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"eChannelLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.eChannelUrl)\"> <span ng-click=\"eChannelLogin()\" ng-bind=\"i18n('hwId.eChannel')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\" ng-if=\"!model.isLiteSDK\">|</span> <span id=\"idpLinkDiv\" class=\"otherItemDiv\" ng-if=\"!model.isLiteSDK\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIDPLogin()\" ng-bind=\"i18n('idpLogin.loginLink')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\" ng-if=\"model.hasHwCloudLink\">|</span> <span id=\"originalLoginDiv\" class=\"otherItemDiv\" ng-if=\"model.hasHwCloudLink\"> <span ng-click=\"originalLogin()\" ng-bind=\"i18n('hwId.hwCloudAccount')\" class=\"otherLoginColor\"></span> </span> </div> </div> <div ng-if=\"!QRLoginModel.isQRLogin && model.loginType === 'idp'\" id=\"idp-login-container\"> <div class=\"idp-login-title ng-cloak\"> <span class=\"loginTypeNoSelected\" ng-bind=\"i18n('idpLogin.title')\"></span> </div> <div class=\"inputField idp-account-container\"> <input type=\"text\" class=\"iam-input-text\" ng-class=\"{'iam-input-error': idpAccountInput.error}\" ng-model=\"idpAccountInput.value\" id=\"{{idpAccountInput.id}}\" placeholder=\"{{idpAccountInput.ph}}\" ng-blur=\"idpAccountInput.blur()\" ng-change=\"idpAccountInput.change()\" ng-style=\"idpAccountInput.style\" ng-focus=\"idpAccountInput.focus()\" maxlength=\"{{idpAccountInput.maxLength}}\" autocomplete=\"off\"> <div ng-if=\"idpAccountInput.error\" class=\"loginErrorMsg\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\"> <span>{{idpAccountInput.error}}</span> </div> </div> <div class=\"inputField idp-dropdown-container\"> <div class=\"dropdown\" tabindex=\"0\" ng-click=\"idpSelect.click()\" ng-blur=\"idpSelect.blur()\" ng-class=\"{'dropdown-disable': idpSelect.disable}\"> <div class=\"dropbtn\"> <div class=\"dropbtn-txt\" title=\"{{idpSelect.defaultOption.name}}\">{{idpSelect.defaultOption.name}}</div> <div class=\"dropbtn-arrow\" ng-if=\"!idpSelect.showOptions\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_5___ + "\"> </div> <div class=\"dropbtn-arrow\" ng-if=\"idpSelect.showOptions\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_6___ + "\"> </div> </div> <div class=\"dropdown-content\" ng-if=\"idpSelect.showOptions && !model.isMobile\"> <div class=\"dropdown-splitline\"></div> <div ng-repeat=\"option in idpSelect.selectOptions\" title=\"{{option.name}}\" ng-click=\"idpSelect.select(option)\" ng-class=\"{'dropdown-option-selected': idpSelect.defaultOption == option}\"> {{option.name}} <img src=\"" + ___HTML_LOADER_REPLACEMENT_7___ + "\"> </div> </div> </div> <div class=\"h5-dropdown-container\" ng-if=\"idpSelect.showOptions && model.isMobile\" ng-click=\"idpSelect.maskClick($event)\"> <div class=\"h5-dropdown-content\" ng-click=\"$event.stopPropagation()\"> <div class=\"h5-dropdown-title\">{{i18n(\"idpLogin.h5SelectTip\")}}</div> <div class=\"h5-option-div\" ng-repeat=\"option in idpSelect.selectOptions\" ng-click=\"idpSelect.select(option)\"> <div class=\"h5-option-name\">{{option.name}}</div> <div class=\"h5-option-button\" ng-class=\"{'h5-option-button-checked': option.id === idpSelect.defaultOption.id}\"> </div> </div> <div class=\"h5-dropdown-buttons\"> <div class=\"h5-dropdown-cancel\" ng-click=\"idpSelect.maskClick($event)\"> {{i18n(\"cancelBtnTxt\")}}</div> <div class=\"h5-dropdown-ok\" ng-click=\"idpSelect.h5SubmitClick($event)\"> {{i18n(\"submitBtnTxt\")}}</div> </div> </div> </div> </div> <div id=\"idpCheckArea\" class=\"checkboxDiv checkArea\"> <input id=\"checkboxInput\" type=\"checkbox\" name=\"checkboxInput\" ng-model=\"model.rememberChecked\"> <label for=\"checkboxInput\"></label> <span ng-click=\"model.rememberCheckedChange()\">{{i18n('rememberLogin')}}</span> </div> <div id=\"idpLoginBtn\" ng-class=\"{'loginBtnDisabled': !idpAccountInput.value || idpAccountInput.error || idpSelect.disable}\" ng-click=\"idpLoginBtn.loginClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"idpLoginBtn.submitBtnText\"></span> </div> <div class=\"otherLoginWaysContainer\"> <div class=\"otherLoginWays\"> <span class=\"otherLoginTip\"> <span ng-if=\"model.isMobile\">{{i18n(\"hwId.otherAccount.h5\")}}</span> <span ng-if=\"!model.isMobile\">{{i18n(\"hwId.otherAccount\")}}</span> </span><span class=\"intervalDiv\" ng-if=\"!model.isMobile\"></span> <span id=\"IAMLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goIAMLogin()\" ng-bind=\"i18n('enterpriseUserLogin')\" class=\"otherLoginColor\"></span> </span><span class=\"intervalDiv\">|</span> <span id=\"hwAccountLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <span ng-click=\"goHwAccountLogin()\" ng-bind=\"quickLoginModel.hasQuickLogin ? i18n('quickLogin.title') : i18n('hwId.hwAccount')\" class=\"otherLoginColor\"></span> </span> </div> </div> </div> </div> <div id=\"CBC_RiskCheck_RiskInfo_Form\"> <input type=\"hidden\" name=\"cbc-hwmeta\" id=\"cbc-hwmeta\" value=\"\"> </div> ";
// Exports
module.exports = code;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(348);
var ___HTML_LOADER_IMPORT_1___ = __webpack_require__(93);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var code = " <style ng-if=\"!model.ipIsInternational && model.currentLanguage !== 'zh-cn'\">@media only screen and (max-width:1920px){#footer .footer-content{height:38px}#footer .footer-content.unfold{height:61px}}@media only screen and (max-width:1680px){#footer .footer-content{height:38px}}@media only screen and (max-width:1440px){#footer .footer-content{height:38px}}@media only screen and (max-width:1366px){#footer .footer-content{height:38px}}@media only screen and (max-width:1280px){#footer .widthLimit{margin:0;padding:0}#footer .footer-content.fold{height:65px;display:flex;flex-direction:column-reverse;align-items:center}#footer .footer-content.unfold{height:79px;display:flex;flex-direction:column-reverse;align-items:center}#footer .copyrightDiv{margin-bottom:15px}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:1024px){#footer .widthLimit{margin:0;padding:0}#footer .footer-content{height:109px;display:flex;flex-direction:column-reverse;align-items:center}#footer .copyrightDiv{text-align:center}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}</style> <style ng-if=\"model.ipIsInternational\">@media only screen and (max-width:1920px){#footer .footer-content{height:38px}}@media only screen and (max-width:1680px){#footer .footer-content{height:38px}}@media only screen and (max-width:1440px){#footer .footer-content{height:38px}}@media only screen and (max-width:1366px){#footer .footer-content{height:38px}}@media only screen and (max-width:1280px){#footer .widthLimit{margin:0;padding:0}#footer .copyrightDiv{text-align:center;margin-bottom:15px}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}@media only screen and (max-width:1024px){#footer .widthLimit{margin:0;padding:0}#footer .copyrightDiv{text-align:center}#footer .otherLinkDiv{text-align:center;margin-bottom:10px}}</style> <div id=\"cookieMsgDivId\" class=\"cookieMsgContainer\" ng-if=\"model.showCookie\"> <div class=\"cookieMsgContent\"> <img class=\"cookieWarnImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span>{{i18n(\"hwId.cookieMsg\")}}</span> <span class=\"learnMoreLink\" ng-bind=\"i18n('learnMore')\" ng-click=\"cookieClick()\"></span> </div> <div class=\"closeImg\" ng-click=\"hideCookieMsg()\"></div> </div> <div ng-if=\"!model.ipIsInternational\" class=\"footer-content\" ng-class=\"{'unfold': model.showICP, 'fold': !model.showICP}\"> <div class=\"copyrightDiv\"> <span class=\"right-space\" ng-bind=\"model.copyRight\"></span><span ng-if=\"model.currentLanguage !== 'zh-cn'\" class=\"swapClick\" ng-class=\"{'unfold': model.showICP, 'fold': !model.showICP}\" ng-click=\"swapICP()\"></span> <div class=\"right-space\" ng-if=\"model.showICP\"> <a class=\"link\" ng-bind=\"i18n('copyrightNotice3')\" href=\"http://beian.miit.gov.cn/publish/query/indexFirst.action\" target=\"_blank\" rel=\"noopener noreferrer nofollow\"></a> <span ng-bind=\"i18n('copyrightNotice4')\"></span> <a href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000093\" target=\"_blank\" rel=\"noopener noreferrer\"> <img style=\"vertical-align:sub\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\" alt=\"\"> </a> <a href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000093\" target=\"_blank\" rel=\"noopener noreferrer\" ng-bind=\"i18n('copyrightNotice5')\"></a> </div> </div> <div class=\"otherLinkDiv\"> <span id=\"laws\"> <a ng-if=\"footer.legalNotice\" ng-bind=\"i18n('legalStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.legalNotice }}\"></a> <span ng-if=\"footer.privacyProtect\">|</span> <a ng-if=\"footer.privacyProtect\" ng-bind=\"i18n('privacyStrategyStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.privacyProtect}}\"></a> <span ng-if=\"footer.cookies\">|</span> <a ng-if=\"footer.cookies\" ng-bind=\"i18n('hwId.cookies')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.cookies}}\"></a> </span> </div> </div> <div ng-if=\"model.ipIsInternational\" class=\"footer-content\"> <div class=\"copyrightDiv\"> <span class=\"right-space\" ng-bind=\"model.copyRight\"></span> <div class=\"right-space\" ng-bind=\"model.copyRightForHongKong\"></div> </div> <div class=\"otherLinkDiv\"> <span id=\"laws\"> <a ng-if=\"footer.siteTerms\" ng-bind=\"i18n('siteTerms')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.siteTerms }}\"></a> <span ng-if=\"footer.privacyProtect\">|</span> <a ng-if=\"footer.privacyProtect\" ng-bind=\"i18n('privacyStrategyStatement')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.privacyProtect }}\"></a> <span ng-if=\"footer.cookies\">|</span> <a ng-if=\"footer.cookies\" ng-bind=\"i18n('hwId.cookies')\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{footer.cookies}}\"></a> </span> </div> </div> <div ng-if=\"model.styleOfSite\" class=\"footer-content-russia\"> <div id=\"russia_follow_us\" class=\"col-md-6-left\" style=\"vertical-align:middle;margin-left:10px;cursor:pointer\" ng-click=\"model.toFacebook()\"> <p style=\"float:left;margin-top:5px\">Follow Us</p> <img id=\"facebook_pic\" ng-src=\"~custom/images/russia_facebook.png\" style=\"margin-left:10px\"> </div> <div class=\"col-md-6-right\"> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.paymentMethods }}\">Payment Methods</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.userAgreement }}\">User Agreement</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.contactUs }}\">Contact Us</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.privacyPolicy }}\">Privacy Policy</a> <span>|</span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{ footer.cookies }}\">Cookies</a> </div> </div> ";
// Exports
module.exports = code;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-if=\"model.currentLanguage === 'zh-cn'\" ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(310);
var ___HTML_LOADER_IMPORT_1___ = __webpack_require__(332);
var ___HTML_LOADER_IMPORT_2___ = __webpack_require__(341);
var ___HTML_LOADER_IMPORT_3___ = __webpack_require__(313);
var ___HTML_LOADER_IMPORT_4___ = __webpack_require__(325);
var ___HTML_LOADER_IMPORT_5___ = __webpack_require__(311);
var ___HTML_LOADER_IMPORT_6___ = __webpack_require__(67);
var ___HTML_LOADER_IMPORT_7___ = __webpack_require__(92);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var ___HTML_LOADER_REPLACEMENT_2___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_2___);
var ___HTML_LOADER_REPLACEMENT_3___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_3___);
var ___HTML_LOADER_REPLACEMENT_4___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_4___);
var ___HTML_LOADER_REPLACEMENT_5___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_5___);
var ___HTML_LOADER_REPLACEMENT_6___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_6___);
var ___HTML_LOADER_REPLACEMENT_7___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_7___);
var code = "<div id=\"loginAdv\" class=\"ng-cloak\"></div> <div ng-show=\"!model.isIdpLogin && !QRLoginModel.QRLoginType\" id=\"loginForm\" class=\"ng-cloak\"> <img ng-if=\"QRLoginModel.hasQRLogin && QRLoginModel.langIsCh\" class=\"loginTypeSwitchImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" ng-click=\"QRLoginModel.QRLoginTypeSwitch()\"> <div ng-if=\"QRLoginModel.hasQRLogin && QRLoginModel.langIsCh && QRLoginModel.showTip\" id=\"QRLoginTip\" class=\"ti-tooltip ti-tooltip-left\">{{i18n(\"QRLogin.title1\")}}</div> <div class=\"loginTypeDiv ng-cloak\"> <span ng-if=\"!model.isCompany\" class=\"loginTypeNoSelected\" ng-bind=\"model.personageUser\"></span> <span ng-if=\"model.isCompany\" class=\"loginTypeNoSelected\" ng-bind=\"model.enterpriseUser\"></span> </div> <div class=\"errorTip loginFormDiv ng-cloak\"> <span ng-if=\"!model.isCookieEnable\" ng-bind=\"i18n('cookie.loginTip')\"></span><a ng-if=\"!model.isCookieEnable\" href=\"{{model.cookieURL}}\" ng-bind=\"i18n('cookie.startCookie')\"></a> <div id=\"checkError\" ng-show=\"model.checkErrorInfo !== ''\"> <span id=\"checkErrorInfo\" style=\"margin-left:0\" ng-bind=\"model.checkErrorInfo\"></span> </div> <div id=\"serverError\" ng-show=\"model.serverError !== ''\"> <span style=\"font-size:small;color:#f66f6a;margin-left:0\" ng-bind-html=\"$sce.trustAsHtml(model.serverError)\"></span> <span id=\"goLogin\" class=\"ng-binding\" ng-bind=\"model.goLogin\"></span> <span style=\"font-size:small;color:#f66f6a;margin-left:0\" ng-bind=\"model.goLogin1\"></span> </div> <div id=\"intlIpMobileLoginTip\" ng-show=\"!model.isCompany && model.mobileLogin && ipIsInternational\"> <span ng-bind=\"mobileLoginModel.intlIpTip\"></span> </div> <div id=\"isMobileTip\" ng-show=\"mobileLoginModel.isMobilePattern\"> <span ng-bind=\"mobileLoginModel.isMobileTip\"></span><a href=\"#\" ng-mousedown=\"mobileLoginModel.switchTypeClick($event)\" ng-bind=\"mobileLoginModel.switchTypeLabel\"></a> </div> <div id=\"mobileErrorMsg\" ng-show=\"model.mobileLogin && mobileLoginModel.showMobileErrorMsg && !model.isCompany\"> <span ng-bind=\"mobileLoginModel.notRegisterTip\"></span><a href=\"{{mobileLoginModel.registUrl}}\" ng-bind=\"mobileLoginModel.registerNow\"></a> </div> <div id=\"mobileUsersSelectMsg\" ng-show=\"model.mobileLogin && mobileLoginModel.showMobileSelect && !model.isCompany\"> <span ng-bind=\"mobileLoginModel.multiUsersTip\"></span> </div> <div id=\"emailUsersSelectMsg\" ng-show=\"emailLoginModel.showEmailSelect\"> <span ng-bind=\"emailLoginModel.multiUsersTip\"></span> </div> </div> <div ng-if=\"!model.isCompany && !model.mobileLogin\" class=\"personalDiv loginFormDiv\"> <div class=\"inputField\"> <tiny-textbox id=\"personalAccountInput.id\" value=\"personalAccountInput.value\" focused=\"personalAccountInput.focused\" placeholder=\"personalAccountInput.ph\" validate=\"model.userValidator\" tip-position=\"'top'\" width=\"model.width\" height=\"model.height\" blur=\"personalAccountInput.blur()\" focus=\"personalAccountInput.focus()\" content-change=\"personalAccountInput.change()\"> </tiny-textbox> <img ng-show=\"emailLoginModel.emailCheckLoading\" class=\"requiredImage\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"> </div> <div ng-if=\"emailLoginModel.showEmailSelect\" class=\"inputField mobileUsersSelect\"> <form action=\"javascript:void(0)\"> <tiny-select id=\"emailUsers.id\" width=\"emailUsers.width\" height=\"emailUsers.scrollHeight\" input-field-height=\"emailUsers.inputFieldHeight\" mode=\"emailUsers.mode\" values=\"emailUsers.selectOptions\" select=\"emailUsers.select(selectId, label)\"></tiny-select> </form> </div> <div class=\"inputField\"> <tiny-textbox id=\"personalPasswordInput.id\" value=\"personalPasswordInput.value\" type=\"personalPasswordInput.type\" placeholder=\"personalPasswordInput.ph\" width=\"model.width\" height=\"model.height\" validate=\"model.pwdValidator\" focused=\"model.pwdFocused\" content-change=\"model.pwdChange()\" blur=\"model.pwdBlur()\"> </tiny-textbox> <span class=\"pwdShowimg\" ng-class=\"{'icon-cloud-action-state-visible': personalPasswordInput.pwdVisible, 'icon-cloud-action-state-Invisible': !personalPasswordInput.pwdVisible}\" ng-click=\"personalPasswordInput.pwdVisibleFunc()\"></span> </div> </div> <div ng-if=\"!model.isCompany && model.mobileLogin\" class=\"mobileLoginDiv loginFormDiv\"> <div class=\"hideInputDiv\" style=\"position:absolute;top:0;left:0;z-index:-1\"> <input type=\"text\" name=\"hideName\"> <input type=\"password\" name=\"hidePass\"> </div> <div class=\"inputField codeSelect\"> <form action=\"javascript:void(0)\"> <tiny-combobox id=\"model.codeSelectId\" values=\"model.codeValues\" value=\"model.countryCodeValue\" width=\"model.codeSelectWidth\" disable=\"model.areaCodeDisabled\" option-width=\"model.optionWidth\" height=\"model.scrollHeight\" match-method=\"model.matchMethod\" input-field-height=\"model.inputFieldHeight\"> </tiny-combobox> </form> </div> <div class=\"inputField phoneInput\"> <tiny-textbox id=\"mobileInput.id\" value=\"mobileInput.value\" focused=\"mobileInput.focused\" placeholder=\"mobileInput.ph\" validate=\"mobileLoginModel.mobileValidator\" tip-position=\"'top'\" width=\"model.phoneInputWidth\" height=\"model.height\" blur=\"mobileBlur()\" content-change=\"mobileChange()\"> </tiny-textbox> <img ng-show=\"mobileLoginModel.showMobileErrorMsg\" class=\"requiredImage\" src=\"" + ___HTML_LOADER_REPLACEMENT_2___ + "\"> <img ng-show=\"mobileLoginModel.mobileCheckLoading\" class=\"requiredImage\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"> </div> <div ng-if=\"model.mobileLogin && mobileLoginModel.showMobileSelect\" class=\"inputField mobileUsersSelect\"> <form action=\"javascript:void(0)\"> <tiny-select id=\"mobileUsers.id\" width=\"mobileUsers.width\" height=\"mobileUsers.scrollHeight\" input-field-height=\"mobileUsers.inputFieldHeight\" mode=\"mobileUsers.mode\" values=\"mobileUsers.selectOptions\" select=\"mobileUsers.select(selectId, label)\"></tiny-select> </form> </div> <div ng-if=\"model.mobileLogin\" class=\"inputField\" style=\"margin-bottom:5px\"> <tiny-textbox id=\"mobilePasswordInput.id\" value=\"mobilePasswordInput.value\" type=\"mobilePasswordInput.type\" placeholder=\"mobilePasswordInput.ph\" width=\"model.width\" height=\"model.height\" validate=\"model.pwdValidator\" focused=\"model.pwdFocused\" blur=\"model.pwdBlur()\"> </tiny-textbox> <span class=\"pwdShowimg\" ng-class=\"{'icon-cloud-action-state-visible': mobilePasswordInput.pwdVisible, 'icon-cloud-action-state-Invisible': !mobilePasswordInput.pwdVisible}\" ng-click=\"mobilePasswordInput.pwdVisibleFunc()\"></span> </div> </div> <div ng-if=\"model.isCompany\" class=\"loginFormDiv\"> <div class=\"hideInputDiv\" style=\"position:absolute;top:0;left:0;z-index:-1\"> <input type=\"text\" name=\"hideName\"> <input type=\"password\" name=\"hidePass\"> </div> <div class=\"inputField\"> <tiny-textbox id=\"IAMAccountInput.id\" value=\"IAMAccountInput.value\" focused=\"IAMAccountInput.focused\" placeholder=\"IAMAccountInput.ph\" disable=\"IAMAccountInput.disable\" blur=\"IAMAccountInput.blur()\" content-change=\"IAMAccountInput.change()\" width=\"model.width\" height=\"model.height\" tip-position=\"'top'\" validate=\"model.accountValidator\" ng-init=\"bindIAMAccountTip()\"> </tiny-textbox> </div> <div class=\"inputField\"> <form action=\"javascript:void(0)\"> <tiny-textbox id=\"IAMUsernameInput.id\" value=\"IAMUsernameInput.value\" focused=\"IAMUsernameInput.focused\" placeholder=\"IAMUsernameInput.phIntl\" blur=\"IAMUsernameInput.blur()\" content-change=\"IAMUsernameInput.change()\" width=\"model.width\" height=\"model.height\" tip-position=\"'top'\" validate=\"model.userValidator\" ng-init=\"bindIAMUsernameTip()\"> </tiny-textbox> </form> </div> <div class=\"inputField\" style=\"margin-bottom:5px\"> <form action=\"javascript:void(0)\"> <tiny-textbox type=\"IAMPasswordInput.type\" id=\"IAMPasswordInput.id\" value=\"IAMPasswordInput.value\" focused=\"IAMPasswordInput.focused\" placeholder=\"IAMPasswordInput.ph\" width=\"model.width\" height=\"model.height\" validate=\"model.pwdValidator\" focused=\"model.pwdFocused\" blur=\"model.pwdBlur()\"> </tiny-textbox> </form> <span class=\"pwdShowimg\" ng-class=\"{'icon-cloud-action-state-visible': IAMPasswordInput.pwdVisible, 'icon-cloud-action-state-Invisible': !IAMPasswordInput.pwdVisible}\" ng-click=\"IAMPasswordInput.pwdVisibleFunc()\"></span> </div> </div> <div id=\"verifyCode\" class=\"loginFormDiv\" style=\"display:block;margin-top:20px;margin-bottom:5px;background:#fff\" ng-if=\"model.isNeedVerifyCode\"> <div class=\"inputField\" style=\"margin-bottom:5px\"> <tiny-textbox id=\"model.checkCodeId\" validate=\"model.checkCodeValidator\" value=\"model.checkCode\" tip-position=\"'top'\" width=\"model.widthHalf\" height=\"model.height\" placeholder=\"model.checkCodePH\" content-change=\"model.preValidVerifyCode(event, value)\" blur=\"model.preValidVerifyCodeBlur()\" max-length=\"model.maxLength\"></tiny-textbox> <img id=\"inputVerifyCodeImg\" title=\"{{model.checkCodeTip}}\" ng-src=\"{{model.verifycode}}\" ng-click=\"model.getVerifyCode()\"> <img id=\"validresultImg\" style=\"vertical-align:middle;margin-left:10px;display:none\"> </div> </div> <div class=\"toDoDiv\"> <div class=\"typeSwitchDiv\" ng-show=\"!model.isCompany\"> <span id=\"typeSwitchBtn\" ng-mousedown=\"mobileLoginModel.switchTypeClick($event)\" tabindex=\"0\" ng-bind=\"mobileLoginModel.switchTypeLabel\"></span> </div> <div id=\"checkArea\" class=\"checkboxDiv\"> <input id=\"checkboxInput\" class=\"chat-button-location-radio-input\" type=\"checkbox\" name=\"checkboxInput\" ng-model=\"model.rememberChecked\" ng-click=\"model.rememberCheckedChange()\"> <label for=\"checkboxInput\" ng-bind=\"model.chkTxt\"></label> </div> </div> <div class=\"buttonAreaDiv\"> <div id=\"buttonArea\"> <div id=\"loginBtn\" ng-click=\"loginClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"model.submitBtnText\"></span> </div> <div id=\"bottomBtns\"> <div class=\"freeRegisterLink commonLinkDiv\"> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.registUrl}}\" class=\"loginBottomColor\" ng-bind=\"i18n('freeRegister')\" ng-click=\"BiEvent('send','event','button','click','login_freeRegister',model.registUrl)\"></a> </div> <div class=\"splitLine\"></div> <div class=\"forgetPwdLink commonLinkDiv\"> <a ng-click=\"goFindPwd('send','event','button','click','login_fpwd')\" class=\"loginswap loginBottomColor\" ng-bind=\"i18n('forgetPwd')\"></a> </div> <div class=\"splitLine\"></div> <div class=\"userTypeLink commonLinkDiv\"> <span id=\"ownerLogin\" class=\"loginswap loginBottomColor\" ng-bind=\"model.personageUser\" tabindex=\"0\" ng-show=\"model.isCompany\"></span> <span id=\"subUserLogin\" class=\"loginswap loginBottomColor\" ng-bind=\"model.enterpriseUser\" tabindex=\"0\" ng-show=\"!model.isCompany\"></span> <div class=\"helptipfather\" ng-show=\"!model.isCompany\"><span class=\"helptipchild\">{{i18n('iamUserTip')}}</span></div> </div> </div> <div id=\"otherAccounts\" ng-click=\"model.moreLinkIsShow = !model.moreLinkIsShow\"> <span ng-bind=\"i18n('usingOtherWaysLogin')\" class=\"otherLoginColor\"></span> <div class=\"downArrow\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\" ng-class=\"{'otherAccountsOpen': model.moreLinkIsShow, 'otherAccountsClose': !model.moreLinkIsShow}\"> </div> </div> <div ng-show=\"model.moreLinkIsShow\" id=\"otherLoginWays\"> <div id=\"hwportalLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_hwportal', model.hwportalUrl)\"> <img class=\"textIcon\" src=\"" + ___HTML_LOADER_REPLACEMENT_4___ + "\"> <a href=\"{{model.hwportalUrl}}\" ng-bind=\"i18n('hwportal')\" class=\"otherLoginColor\"></a> </div> <div id=\"eChannelLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send','event','button','click','login_enchannel',model.eChannelUrl)\"> <a href=\"{{model.eChannelUrl}}\" ng-bind=\"i18n('eChannelName')\" class=\"otherLoginColor\"></a> </div> <div id=\"vmallLinkDiv\" class=\"otherItemDiv\" ng-click=\"BiEvent('send', 'event', 'button', 'click', 'login_vmall', model.vmallUrl)\"> <a href=\"{{model.vmallUrl}}\" ng-bind=\"i18n('HWSdeveloper')\" class=\"otherLoginColor\"></a> </div> <div id=\"idpLoginLinkDiv\" class=\"otherItemDiv\" style=\"display:inline\"> <a href=\"javascript:void(0)\" ng-bind=\"i18n('idpLogin.loginLink')\" class=\"otherLoginColor\" ng-click=\"goIdpLogin()\"></a> </div> <div id=\"quickLoginLinkDiv\" ng-if=\"model.fromQuickLogin\" class=\"otherItemDiv\" style=\"display:inline\"> <a href=\"{{model.quickLoginUrl}}\" ng-bind=\"i18n('hwId.hwAccount')\" class=\"otherLoginColor\"></a> </div> </div> </div> </div> </div> <div ng-if=\"!model.isIdpLogin && QRLoginModel.QRLoginType\" id=\"QRLoginDiv\" class=\"ng-cloak\"> <img class=\"loginTypeSwitchImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_5___ + "\" ng-click=\"QRLoginModel.QRLoginTypeSwitch()\"> <div ng-if=\"QRLoginModel.showTip\" class=\"ti-tooltip ti-tooltip-left\">{{i18n(\"personageUser\")}}</div> <div class=\"loginTypeDiv ng-cloak\"> <span class=\"loginTypeNoSelected\">{{QRLoginModel.QRLoginTitle}}</span> </div> <div ng-if=\"QRLoginModel.QRCodeStatus == 'new'\"> <div class=\"QRCodeOuter\"> <canvas id=\"loginQRCodeDiv\" class=\"loginQRCodeDiv\"></canvas> <div ng-if=\"QRLoginModel.QRCodeInvalid\" class=\"QRCodeInner\"> <div class=\"QRCodeInvalid\">{{i18n(\"QRLogin.QRCodeInvalid\")}}</div> <div id=\"refreshQRCodeBtn\" ng-click=\"QRLoginModel.refreshQRCode()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\">{{i18n(\"QRLogin.refresh\")}}</span> </div> </div> </div> <div id=\"countDownDiv\"> <span>{{i18n(\"QRLogin.countDownTipPre1\")}} <span style=\"color:#ff9220\">{{i18n(\"QRLogin.countDownTipPre2\")}}</span> {{i18n(\"QRLogin.countDownTipPre3\")}}</span><span ng-if=\"!QRLoginModel.QRCodeInvalid\">{{i18n(\"QRLogin.comma\")}}</span><span class=\"remainingTimeTxt\" ng-if=\"!QRLoginModel.QRCodeInvalid\">{{QRLoginModel.remainingTime}}</span><span ng-if=\"!QRLoginModel.QRCodeInvalid\">{{QRLoginModel.countDownTipSuffix}}</span> </div> </div> <div class=\"loginStatusDiv\" ng-if=\"QRLoginModel.QRCodeStatus == 'authorizing'\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_6___ + "\" class=\"loginStatusImg\"> <div class=\"loginStatusTitle\">{{i18n(\"QRLogin.scanSuc\")}}</div> <div class=\"loginStatusMessage\">{{i18n(\"QRLogin.scanSucTip\")}}</div> </div> <div class=\"loginStatusDiv\" ng-if=\"QRLoginModel.QRCodeStatus == 'refused'\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_7___ + "\" class=\"loginStatusImg\"> <div> <div class=\"loginStatusTitle\">{{i18n(\"QRLogin.loginFail\")}}</div> <div class=\"loginStatusMessage\"> <span>{{i18n(\"QRLogin.loginFailTipPre\")}}</span><a href=\"javascript:void(0)\" ng-click=\"QRLoginModel.refreshQRCode()\">{{i18n(\"QRLogin.refresh\")}}</a><span>{{i18n(\"QRLogin.loginFailTipSuffix\")}}</span> </div> </div> </div> <div id=\"QRLoginBottomDiv\"> <a class=\"QRLoginBottomColor\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.registUrl}}\" ng-bind=\"i18n('freeRegister')\" ng-click=\"BiEvent('send','event','button','click','login_freeRegister',model.registUrl)\"></a> <a class=\"QRLoginBottomColor\" target=\"_blank\" rel=\"noopener noreferrer\" ng-bind=\"i18n('QRLogin.downloadApp')\" href=\"{{QRLoginModel.downloadUrl}}\"></a> </div> </div> <div ng-if=\"model.isIdpLogin\" id=\"idpLoginForm\" class=\"\"> <div class=\"loginTypeDiv ng-cloak\"> <span class=\"loginTypeNoSelected\" ng-bind=\"i18n('idpLogin.title')\"></span> </div> <div class=\"errorTip loginFormDiv ng-cloak\"> <div id=\"checkError\" ng-show=\"idpAccountInput.error !== ''\"> <span id=\"checkErrorInfo\" style=\"margin-left:0\" ng-bind=\"idpAccountInput.error\"></span> </div> </div> <div ng-if=\"true\" class=\"loginFormDiv\"> <div class=\"inputField\"> <tiny-textbox id=\"idpAccountInput.id\" value=\"idpAccountInput.value\" max-length=\"128\" placeholder=\"idpAccountInput.ph\" width=\"model.width\" height=\"model.height\" blur=\"idpAccountInput.blur()\" content-change=\"idpAccountInput.change()\"> </tiny-textbox> <img ng-show=\"emailLoginModel.emailCheckLoading\" class=\"requiredImage\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"> </div> <div class=\"inputField mobileUsersSelect\"> <form action=\"javascript:void(0)\"> <tiny-select id=\"idpSelect.id\" width=\"idpSelect.width\" height=\"idpSelect.scrollHeight\" input-field-height=\"idpSelect.inputFieldHeight\" mode=\"emailUsers.mode\" disable=\"idpSelect.disable\" values=\"idpSelect.selectOptions\" select=\"idpSelect.select(selectId)\" placeholder=\"idpSelect.ph\" default-selectid=\"idpSelect.defaultSelectId\"></tiny-select> </form> </div> <div id=\"idpCheckArea\" class=\"checkboxDiv\"> <input id=\"checkboxInput\" class=\"chat-button-location-radio-input\" type=\"checkbox\" name=\"checkboxInput\" ng-model=\"model.rememberChecked\" ng-click=\"model.rememberCheckedChange()\"> <label for=\"checkboxInput\">{{i18n('rememberLogin')}}</label> </div> </div> <div class=\"buttonAreaDiv\"> <div id=\"buttonArea\"> <div id=\"loginBtn\" ng-class=\"{'loginBtnDisabled': !idpAccountInput.value || idpAccountInput.error || idpSelect.disable}\" ng-click=\"idpLoginBtn.loginClick()\" class=\"loginBtn ng-cloak\" tabindex=\"0\"> <span id=\"btn_submit\" ng-bind=\"idpLoginBtn.submitBtnText\"></span> </div> <div id=\"otherAccounts\" ng-click=\"model.moreLinkIsShow = !model.moreLinkIsShow\"> <span ng-bind=\"i18n('usingOtherWaysLogin')\" class=\"otherLoginColor\"></span> <div class=\"downArrow\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_3___ + "\" ng-class=\"{'otherAccountsOpen': model.moreLinkIsShow, 'otherAccountsClose': !model.moreLinkIsShow}\"> </div> </div> <div ng-show=\"model.moreLinkIsShow\" id=\"otherLoginWays\"> <div class=\"otherItemDiv\"> <a href=\"javascript:void(0)\" ng-click=\"goAccountLogin()\" ng-bind=\"i18n('idpLogin.goAccountLogin')\" class=\"otherLoginColor\"></a> </div> <div class=\"otherItemDiv\"> <a href=\"javascript:void(0)\" ng-click=\"goIAMLogin()\" ng-bind=\"i18n('enterpriseUser')\" class=\"otherLoginColor\"></a> </div> </div> </div> </div> </div> ";
// Exports
module.exports = code;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// Module
var code = "<a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> ";
// Exports
module.exports = code;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// Module
var code = "<div id=\"loginVerificationDiv\" align=\"center\"> <div id=\"loginVerificationTitle\"> <p style=\"line-height:normal\" ng-bind=\"i18n('loginVerification')\"></p> </div> <div id=\"verificationContainer\"> <div class=\"fieldItem presetLoginInfo\" ng-if=\"model.presetInfo !== ''\"> <div class=\"itemLabel\">{{i18n('loginVerification.presetLoginInfo')}}</div> <div class=\"itemContent\"> <span ng-bind-html=\"model.presetInfo\"></span> <span class=\"presetTips\">{{i18n('loginVerification.warningInfo')}}</span> </div> </div> <div class=\"fieldItem\" ng-if=\"model.lastSuccessTime !== ''\"> <div class=\"itemLabel\">{{i18n('loginVerification.lastSuccessTime')}}</div> <div class=\"itemContent\">{{model.lastSuccessTime}}</div> </div> <div class=\"fieldItem\" ng-if=\"model.lastFailedTime !== ''\"> <div class=\"itemLabel\">{{i18n('loginVerification.lastFailedTime')}}</div> <div class=\"itemContent\">{{model.lastFailedTime}}</div> </div> <div class=\"fieldItem\" ng-if=\"model.lastFailedTime !== '' && (model.failedTimes !== '' || model.presetInfo !== '')\"> <div class=\"itemLabel\">{{i18n('loginVerification.failedTimes')}}</div> <div class=\"itemContent\"> <span>{{model.failedTimes}}</span><span class=\"hintContext\">{{model.lockInfo}}</span> </div> </div> <div class=\"fieldItem\" ng-if=\"model.verificationType !== '' &&  model.verificationType !== 'none'\"> <div class=\"itemLabel\">{{i18n('loginVerification.verificationType')}}</div> <div class=\"itemContent\" ng-if=\"model.verificationType === 'sms'\"> <span>{{i18n('loginVerification.checkBySMS')}} </span><span class=\"hintContextSMS\" ng-bind=\"i18n('loginVerification.SMSHasSentTo')\"></span> </div> <div class=\"itemContent\" ng-if=\"model.verificationType === 'email'\"> <span>{{i18n('loginVerification.emailCheckTitle')}}</span> </div> <div class=\"itemContent\" ng-if=\"model.verificationType === 'vmfa'\"> <span>{{i18n('loginVerification.MFATitle')}}</span> <span style=\"display:block;font-size:12px\" ng-bind-html=\"authModel.resetMFAHelpUrl\"></span> <a id=\"bindMFABtn\" class=\"bindMFABtn\" ng-if=\"!authModel.havaBindMFA\" ng-click=\"authModel.goBindMFA()\">{{i18n('loginVerification.title')}}</a> </div> </div> <div class=\"fieldItem\" ng-if=\"model.verificationType === 'sms'\"> <div class=\"itemLabel\">{{i18n('loginVerification.bindPhone')}}</div> <div class=\"itemContent\" ng-if=\"authModel.haveBindPhone\"> <span style=\"margin-right:16px\">{{model.phoneNum}}</span> <a href=\"{{model.changeMobileHref}}\" ng-click=\"model.changePhone()\"> <span class=\"changePhonelink\" ng-bind=\"i18n('fphone.changeMobile')\"></span> </a> </div> <div class=\"itemContent\" ng-if=\"!authModel.haveBindPhone\"> <tiny-combobox id=\"countryCodeModel.countryCodeSelectId\" values=\"countryCodeModel.countryCodeArray\" value=\"countryCodeModel.defaultCodeValue\" width=\"countryCodeModel.codeSelectWidth\" height=\"countryCodeModel.codeSelectWidth\" select=\"countryCodeModel.countryCodeSelect()\" tip-position=\"countryCodeModel.tipPosition\" disable=\"countryCodeModel.disable\"> </tiny-combobox> <span style=\"margin-left:3px\"></span> <tiny-textbox id=\"authModel.bindPhoneId\" value=\"authModel.bindPhoneValue\" width=\"authModel.bindPhoneInputWidth\" height=\"authModel.bindPhoneInputHeight\" placeholder=\"authModel.bindPhonePH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.bindPhoneValidator\" keypressfn=\"authModel.keypress\" focused=\"true\" blur=\"authModel.verifyCodeBlur()\"> </tiny-textbox> <span class=\"bindTips\">{{i18n('loginVerification.bindPhoneTips')}}</span> </div> </div> <div class=\"fieldItem\" ng-if=\"model.verificationType === 'email'\"> <div class=\"itemLabel\">{{i18n('loginVerification.bindEmail')}}</div> <div class=\"itemContent\" ng-if=\"authModel.haveBindEmail\"> <span>{{model.emailNum}}</span> </div> <div class=\"itemContent\" ng-if=\"!authModel.haveBindEmail\"> <tiny-textbox id=\"authModel.bindEmailId\" value=\"authModel.bindEmailValue\" width=\"authModel.bindEmailInputWidth\" height=\"authModel.bindEmailInputHeight\" placeholder=\"authModel.bindEmailPH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.bindEmailValidator\" keypressfn=\"authModel.keypress\" focused=\"true\" blur=\"authModel.verifyCodeBlur()\"> </tiny-textbox> <span class=\"bindTips\">{{i18n('loginVerification.bindEmailTips')}}</span> </div> </div> <div class=\"fieldItem\" ng-if=\"model.verificationType !== '' &&  model.verificationType !== 'none'\"> <div class=\"itemLabel\">{{i18n('loginVerification.verifyCode')}}</div> <div class=\"itemContent\" ng-if=\"model.verificationType === 'sms' || model.verificationType === 'email'\"> <div class=\"inputDiv\"> <tiny-textbox ng-if=\"model.verificationType === 'sms'\" id=\"authModel.verifyCodeId\" value=\"authModel.verifyCodeValue\" width=\"authModel.verifyCodeInputWidth\" height=\"authModel.verifyCodeInputHeight\" placeholder=\"authModel.verifyCodePH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.smsCodeValidator\" keypressfn=\"authModel.keypress\" focused=\"true\" blur=\"authModel.verifyCodeBlur()\" content-change=\"authModel.verifyCodeChange(event, value)\"> </tiny-textbox> <tiny-textbox ng-if=\"model.verificationType === 'email'\" id=\"authModel.verifyCodeId\" value=\"authModel.verifyCodeValue\" width=\"authModel.verifyCodeInputWidth\" height=\"authModel.verifyCodeInputHeight\" placeholder=\"authModel.verifyCodeEmailPH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.emailCodeValidator\" keypressfn=\"authModel.keypress\" focused=\"true\" blur=\"authModel.verifyCodeBlur()\" content-change=\"authModel.verifyCodeChange(event, value)\"> </tiny-textbox> <div class=\"seperate\"></div> <a id=\"getVerifyCodeBtn\" ng-if=\"!authModel.sendCodeSuccess\" class=\"getVerifyCodeBtn\" ng-click=\"authModel.getVerifyCode()\">{{authModel.verifyCodeBtnTxt}}</a> <span id=\"retrieveTip\" ng-if=\"authModel.sendCodeSuccess\" class=\"retrieveTip\">{{authModel.retrieveTxt}}</span> </div> <div id=\"sendCodeDoneTip\" ng-if=\"authModel.sendCodeSuccess\"><span class=\"icon-cloud-action-state-regular\"></span>{{authModel.sendCodeTxt}}</div> <div id=\"msgErrorTip\" ng-if=\"model.actionError !== ''\" class=\"hintContext\">{{model.actionError}}</div> </div> <div class=\"itemContent\" ng-if=\"model.verificationType === 'vmfa'\"> <div class=\"inputDiv\"> <tiny-textbox id=\"authModel.verifyCodeId\" value=\"authModel.verifyCodeValue\" width=\"authModel.verifyCodeInputWidth\" height=\"authModel.verifyCodeInputHeight\" placeholder=\"authModel.verifyCodePH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.mfaValidator\" keypressfn=\"authModel.keypress\" focused=\"true\" blur=\"authModel.verifyCodeBlur()\" content-change=\"authModel.verifyCodeChange(event, value)\"> </tiny-textbox> <br/> </div> <div class=\"checkboxDiv\" style=\"width:240px\" ng-class=\"authModel.rememberMFADisabled ? 'checkboxDisabled' : ''\" ng-if=\"authModel.showrememberMFACheckbox\"> <input id=\"checkboxInput\" ng-disabled=\"authModel.rememberMFADisabled\" class=\"chat-button-location-radio-input\" type=\"checkbox\" name=\"checkboxInput\" ng-model=\"authModel.rememberMFA\"/> <label for=\"checkboxInput\" id=\"rememberMFACheckbox\" ng-bind=\"authModel.rememberMFALabel\"></label> </div> <div id=\"msgErrorTip\" ng-if=\"model.actionError !== ''\" class=\"hintContext\">{{model.actionError}}</div> </div> </div> </div> <div id=\"loginVerificationTips\"> {{i18n('loginVerification.tips')}} </div> <div id=\"splitLine\"></div> <div id=\"btnGroupDiv\"> <span id=\"IAMCSRFClient\" ng-bind-html=\"model.IAMCSRF\" style=\"display:none\"></span> <div id=\"cancelBtn\" class=\"btnDiv\" ng-click=\"onCancelBtnClick()\">{{i18n('loginVerification.otherAccount')}}</div> <div id=\"submitBtn\" class=\"btnDiv\" ng-click=\"authModel.submitBtn()\" ng-class=\"{'disabledSubmitBtn': authModel.disabledSubmitBtn}\">{{i18n('loginVerification.goOnLogin')}}</div> </div> <div class=\"bingMFAPage\" ng-show=\"authModel.showBindMFA\"> <div class=\"bindMFAModal\"> <div class=\"modalTitle\">{{i18n('loginVerification.title')}}</div> <div class=\"modalContent\"> <div class=\"stepDiv\" id=\"step1\"> <div class=\"stepProgress\"> <div class=\"stepImage\">1</div> <div class=\"stepFill\"></div> </div> <div class=\"stepContent\"> <div class=\"title\">{{i18n('loginVerification.firstStep')}}</div> <div class=\"tips\">{{i18n('loginVerification.firstStepIntroduction')}}</div> <div class=\"appDownload\"> <div class=\"HWCloud\"></div> </div> </div> </div> <div class=\"stepDiv\" id=\"step2\"> <div class=\"stepProgress\"> <div class=\"stepImage\">2</div> <div class=\"stepFill\"></div> </div> <div class=\"stepContent\"> <div class=\"title\">{{i18n('loginVerification.secondStep')}}</div> <div class=\"tips\">{{i18n('loginVerification.secondStepIntroduction')}}</div> <div class=\"content\"> <canvas id=\"MFAQRCodeDiv\" class=\"MFAQRCodeDiv\"></canvas> <div class=\"MFAInfoDiv\"> <div class=\"infoFieldItem\"> <div class=\"infoLabel\">{{i18n('loginVerification.domainname')}}</div> <div class=\"infoText\">{{authModel.domainName}}</div> </div> <div class=\"infoFieldItem\"> <div class=\"infoLabel\">{{i18n('loginVerification.username')}}</div> <div class=\"infoText\">{{authModel.userName}}</div> </div> <div class=\"infoFieldItem\"> <div class=\"infoLabel\">{{i18n('loginVerification.secretKey')}}</div> <div class=\"infoText\">{{authModel.secretKey}}</div> </div> </div> </div> </div> </div> <div class=\"stepDiv\" id=\"step3\"> <div class=\"stepProgress\"> <div class=\"stepImage\">3</div> <div class=\"stepFill\"></div> </div> <div class=\"stepContent\"> <div class=\"title\">{{i18n('loginVerification.thirdStep')}}</div> <div class=\"tips\">{{i18n('loginVerification.thirdStepIntroduction')}}</div> <div class=\"content\"> <div class=\"MFACodeDiv\"> <div class=\"codeFieldItem\"> <div class=\"codeLabel\"><span style=\"color:#f66f6a\">* </span><span>{{i18n('loginVerification.firstRegCode')}}</span></div> <div class=\"codeInput\"> <tiny-textbox id=\"authModel.firstMFACodeId\" value=\"authModel.firstMFACodeValue\" width=\"authModel.MFACodeInputWidth\" height=\"authModel.MFACodeInputHeight\" placeholder=\"authModel.MFACodePH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.mfaValidator\" keypressfn=\"authModel.bindMFAKeypress\" focused=\"true\" blur=\"authModel.MFACodeBlur()\" content-change=\"authModel.MFACodeChange(event, value)\"> </tiny-textbox> </div> </div> <div class=\"codeFieldItem\"> <div class=\"codeLabel\"><span style=\"color:#f66f6a\">* </span><span>{{i18n('loginVerification.secondRegCode')}}</span></div> <div class=\"codeInput\"> <tiny-textbox id=\"authModel.secondMFACodeId\" value=\"authModel.secondMFACodeValue\" width=\"authModel.MFACodeInputWidth\" height=\"authModel.MFACodeInputHeight\" placeholder=\"authModel.MFACodePH\" tip-position=\"authModel.tipPosition\" tip-width=\"authModel.tipWidth\" validate=\"authModel.mfaValidator\" keypressfn=\"authModel.bindMFAKeypress\" blur=\"authModel.MFACodeBlur()\" content-change=\"authModel.MFACodeChange(event, value)\"> </tiny-textbox> </div> </div> </div> </div> </div> </div> <div id=\"msgMFAErrorTip\" ng-if=\"authModel.MFAErrorTxt !== ''\" class=\"stepDiv\">{{authModel.MFAErrorTxt}}</div> </div> <div class=\"modalFooter\"> <div id=\"submitBtn\" class=\"btnDiv\" ng-click=\"authModel.submitBindMFA()\" ng-class=\"{'disabledSubmitBtn': authModel.disabledMFASubmitBtn}\">{{i18n('loginVerification.submitText')}}</div> <div id=\"cancelBtn\" class=\"btnDiv\" ng-click=\"authModel.cancelBindMFA()\">{{i18n('cancelBtnTxt')}}</div> </div> </div> </div> </div> <div id=\"popupMsg\"></div>";
// Exports
module.exports = code;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// Module
var code = "<img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> <img id=\"ZBJ_logo\" ng-if=\"model.xAccountType == 'zbj'\" ng-src=\"{{ model.ZBJLogoSrc }}\"> <span id=\"backToHomepage\"> </span> <div id=\"firstLoginSwitchTip\" style=\"display:none\"> <span style=\"display:block;margin:10px\"></span> </div>";
// Exports
module.exports = code;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// Module
var code = "<div class=\"module-error\"> <div class=\"dt-content\" ng-if=\"model.loading\"> <span class=\"ERROR_TIP\" ng-bind=\"i18n('notify.openPage')\"></span> </div> <div class=\"dt-content\" ng-if=\"!model.loading\"> <div class=\"errorIcon\"></div> <div class=\"errorTitle\" ng-bind=\"i18n('notify.closeSecondBefore')\"></div> <div class=\"errorContent\" ng-bind=\"i18n('notify.closePage')\"></div> </div> </div> <iframe id=\"notify_result\" name=\"notify_result\" width=\"0\" height=\"0\" border=\"0\"></iframe> <form id=\"notify_form\" method=\"POST\" target=\"notify_result\"> <input type=\"hidden\" name=\"bindRequest\" id=\"bindRequest\"/> <input type=\"hidden\" name=\"Signature\" id=\"Signature\"/> <input type=\"hidden\" name=\"SigAlg\" id=\"SigAlg\"/> </form>";
// Exports
module.exports = code;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(64);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> <span id=\"bannerQuickLink\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <img style=\"width:18px\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span ng-bind=\"i18n('language')\"></span> </span> </span> <ul id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul>";
// Exports
module.exports = code;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// Module
var code = " <div class=\"privacyDiv\"> <div class=\"privacyTitle\"> <span ng-bind=\"model.privacyPolicyUpdate\"></span> </div> <div class=\"privacycontent\"> <span ng-bind=\"model.privacyTipPre\"></span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.privacyAgreement}}\" ng-bind=\"model.secretprotect\"></a> <span ng-bind=\"model.privacyTipSuf\"></span> </div> <div id=\"btnDiv\"> <button id=\"submitBtn\" class=\"okButton\" ng-click=\"onSubmitClick()\" ng-disabled=\"model.disable\" ng-bind=\"model.btnTxtOK\"></button> <button id=\"cancelBtn\" class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"onCancelClick()\" ng-bind=\"model.btnTxtCancel\"></button> </div> </div> <div id=\"popupMsg\"></div> ";
// Exports
module.exports = code;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(27);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div id=\"resetTitle\"> <p ng-bind=\"resetPwdTitle\"></p> <span ng-bind=\"titleDetail\"></span> </div> <div class=\"formDiv\" ng-if=\"model.isFormShow\"> <ul id=\"formUl\"> <li class=\"li\"> <span class=\"fieldLabel\" style=\"height:auto;min-height:0\"> </span> <span class=\"field\" style=\"width:100%\"> <span id=\"errorMsg\" style=\"text-align:center\"></span> </span> </li> <li id=\"oldPassword\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span style=\"display:inline-block;float:right\" ng-bind=\"model.oldPasswdLabel\"></span> </span> <span class=\"field\"> <tiny-textbox id=\"model.oldPasswordId\" validate=\"model.oldPasswdValidate\" tip-position=\"model.tipPosition\" value=\"model.oldPassword\" type=\"model.type\" height=\"model.height\" blur=\"model.oldPasswordBlur()\" width=\"model.width\" focused=\"model.focused\" content-change=\"model.onUserClickSomeBox()\" keypressfn=\"model.submitKeyPress\"> </tiny-textbox> </span> </div> </li> <li id=\"password\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span style=\"display:inline-block;float:right\" ng-bind=\"i18n('resetPwd.newPasswd')\"></span> </span> <span class=\"field\"> <tiny-textbox id=\"model.passwordId\" focus=\"model.onPasswordFocus()\" focused=\"model.passwordFocused\" value=\"model.password\" height=\"model.height\" blur=\"model.passwordBlur()\" type=\"model.newPwdType\" width=\"model.width\" content-change=\"model.onPasswordChange()\" keypressfn=\"model.submitKeyPress\" max-length=\"model.maxPwdLength\" tooltip=\"model.pwdTip\" tip-position=\"'top'\"> </tiny-textbox> <span class=\"pwd-state-icon\" ng-class=\"{'icon-cloud-action-state-visible': model.pwdVisible_1, 'icon-cloud-action-state-Invisible': !model.pwdVisible_1}\" ng-click=\"model.pwdVisibleFunc(1)\"></span> <img ng-if=\"model.showPasswordCheck\" style=\"position:absolute;right:-26px;top:9px\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> </span> </div> <div id=\"passwordError\" class=\"errorInfo\"> </div></li> <li id=\"confirmPassword\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span style=\"display:inline-block;float:right\" ng-bind=\"i18n('resetPwd.confirmNewPasswd')\"></span> </span> <span class=\"field\"> <tiny-textbox id=\"model.confirmPasswordId\" validate=\"model.equalValidate\" tip-position=\"model.tipPosition\" value=\"model.confirmPassword\" type=\"model.confirmPwdType\" height=\"model.height\" width=\"model.width\" content-change=\"model.onConfirmPasswordChange()\" keypressfn=\"model.submitKeyPress\"> </tiny-textbox> <span class=\"pwd-state-icon\" ng-class=\"{'icon-cloud-action-state-visible': model.pwdVisible_2, 'icon-cloud-action-state-Invisible': !model.pwdVisible_2}\" ng-click=\"model.pwdVisibleFunc(2)\"></span> <img ng-if=\"model.showConfirmPasswordCheck\" style=\"position:absolute;right:-26px;top:9px\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> </span> </div> </li> <li ng-if=\"model.needValidation\" id=\"verifyType\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span style=\"display:inline-block;float:right\" ng-bind=\"model.verifyTypeLabel\"></span> </span> <span class=\"field\" style=\"display:flex;flex-wrap:wrap;max-width:315px\"> <span style=\"height:36px;line-height:36px;margin-right:20px\" ng-bind=\"model.verifyTypeValue\"></span> <span ng-if=\"model.needVerifyTypeBtn\" id=\"verifyTypeBtn\" ng-click=\"model.onVerifyTypeClick()\" ng-bind=\"model.verifyTypeBtn\"></span> </span> </div> </li> <li ng-if=\"model.needValidation\" id=\"msgCode\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\"> <span style=\"display:inline-block;float:right\" ng-bind=\"model.msgCodeLabel\"></span> </span> <span class=\"field\"> <tiny-textbox id=\"model.msgCodeId\" validate=\"model.msgCodeValidator\" tip-width=\"model.textBoxTipWidth\" value=\"model.msgCode\" height=\"model.height\" blur=\"model.onMsgCodeBlur()\" width=\"model.msgCodeWidth\" tip-position=\"model.tipPosition\" content-change=\"model.onUserClickSomeBox()\" keypressfn=\"model.submitKeyPress\"> </tiny-textbox> <div id=\"msgBtn\" class=\"msgBtn\" style=\"margin-left:10px\" ng-click=\"model.onMsgCodeBtnClick()\"> <span ng-bind=\"model.msgBtnTxt\"></span> </div> </span> </div> <div> <span class=\"fieldLabel\" style=\"height:auto;min-height:1px\"></span> <span class=\"field\" ng-bind=\"model.verifyCodeMsg\" id=\"verifyCodeMsg\" style=\"color:red;display:none;margin-bottom:10px\"></span> </div> </li> <li class=\"li\"> <div id=\"btnDiv\"> <button id=\"submitBtn\" class=\"okButton\" style=\"float:left\" ng-click=\"onSubmitClick()\" ng-bind=\"i18n('btnTxtOK')\"></button> <button id=\"cancelBtn\" class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"onCancelClick()\" ng-bind=\"i18n('btnTxtCancel')\"></button> </div> </li> </ul> </div> <div id=\"popupMsg\"></div> ";
// Exports
module.exports = code;

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <span> <span ng-bind=\"i18n('alreadyHaveAccount')\"></span> <a href=\"{{ model.loginUrl }}\" ng-bind=\"i18n('login')\" style=\"color:#c7000b\"></a> </span> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a ng-if=\"!model.ipIsInternational && !model.styleOfSite\" class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> <div id=\"triangle\"></div> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// Module
var code = "<div class=\"ssologinDiv\"> <div class=\"ssologinTitle\"> <span>{{i18n('ssologin.title')}}</span> </div> <div class=\"domainListContainer\"> <div ng-repeat=\"domainObj in model.domainList\" class=\"domainDiv\"> <div class=\"domainName\" ng-bind=\"domainObj.domain_name\"></div> <div ng-repeat=\"id in domainObj.idp_id\" class=\"idpDiv\" ng-click=\"model.select(domainObj.domain_id, id)\"> <div class=\"option-button\" ng-class=\"{'option-button-checked': model.selectedDomain == domainObj.domain_id && model.selectedId == id}\"></div> <div class=\"idpId\">{{id}}</div> </div> </div> </div> <div id=\"btnDiv\"> <div class=\"nextBtn\" ng-class=\"{'nextBtnDisabled': !model.selectedDomain || !model.selectedId}\" ng-click=\"model.btnClick()\">{{i18n('ssologin.btnTxt')}}</div> </div> </div> <div id=\"popupMsg\"></div> ";
// Exports
module.exports = code;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// Module
var code = "<div ng-click=\"BiEvent('send','event','button','click','login_logoSrc',model.logoSrc)\" style=\"display:inline\"> <a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> </div> <span id=\"bannerQuickLink\"> <div ng-click=\"BiEvent('send','event','button','click','login_homePage',model.homepageUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('homepageLink')\" href=\"{{model.homepageUrl}}\"></a> </div> <div ng-click=\"BiEvent('send','event','button','click','login_helpCenter',model.helpCenterUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('helpCenter')\" href=\"{{model.helpCenterUrl}}\"></a> </div> <div ng-if=\"model.currentLanguage === 'zh-cn'\" ng-click=\"BiEvent('send','event','button','click','login_cloudCommunity',model.cloudCommunityUrl)\" style=\"display:inline\"> <a class=\"homepageLink\" ng-bind=\"i18n('cloudCommunity')\" href=\"{{model.cloudCommunityUrl}}\"></a> </div> <span id=\"languageSwitch\" ng-mouseenter=\"model.mouseOnLanguageChangeArea()\" ng-mouseleave=\"model.mouseLeaveLanguageChangeArea()\"> <span ng-bind=\"model.currentLanguageStyle\"></span> <div id=\"triangle\"></div> </span> </span> <ul ng-if=\"!model.styleOfSite\" id=\"loginPageLanguages\" style=\"display:none;opacity:94%\" ng-mouseleave=\"model.mouseLeaveLoginPageLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.loginPageLanguages\" id=\"{{ language.key }}\" ng-click=\"model.changeLanguage( language.key )\">{{ language.value }}</li> </ul> <ul ng-if=\"model.styleOfSite\" id=\"languages\" style=\"display:none\" ng-mouseleave=\"model.mouseLeaveLanguagesItems()\"> <li class=\"sel-lang\" ng-repeat=\"language in model.languages\" ng-if=\"model.currentLanguage !==  language.key\" id=\"{{ language.key }}\">{{ language.value }}</li> </ul> ";
// Exports
module.exports = code;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(345);
var ___HTML_LOADER_IMPORT_1___ = __webpack_require__(346);
var ___HTML_LOADER_IMPORT_2___ = __webpack_require__(95);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var ___HTML_LOADER_REPLACEMENT_2___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_2___);
var code = "<div class=\"upgradeContainer\" ng-show=\"!model.isUpgrading\"> <div class=\"upgradeTitle\">{{i18n(\"hwId.upgradeTitle\")}}</div> <div class=\"upgradeDesc\"> <span>{{i18n(\"hwId.upgradeDesc\")}}</span><a ng-href=\"{{model.upgradeDescLink}}\" target=\"_blank\">{{i18n(\"hwId.upgradeDescLink\")}}</a> </div> <img class=\"upgradeImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <div class=\"agreementDiv\"> <div ng-click=\"agreeClick()\" class=\"checkbox\" ng-class=\"{'checked_checkbox': model.agree}\"></div> <div class=\"agreementDesc\"> <span>{{i18n(\"hwId.upgradeAgreements.pre\")}}</span><a ng-href=\"{{model.userAgreementLink}}\" target=\"_blank\">{{i18n(\"hwId.upgradeAgreements.userAgreement\")}}</a><span>{{i18n(\"hwId.upgradeAgreements.and\")}}</span><a ng-href=\"{{model.privacyPolicyLink}}\" target=\"_blank\">{{i18n(\"hwId.upgradeAgreements.privacyPolicy\")}}</a><span>{{i18n(\"hwId.upgradeAgreements.period\")}}</span> </div> </div> <div class=\"bottomBtns\"> <div class=\"upgradeBtn\" ng-class=\"{'upgradeBtnDisabled': !model.agree}\" ng-click=\"goUpgrade()\">{{i18n(\"hwId.upgradeBtnTxt\")}}</div> <div ng-if=\"model.isOptional\" class=\"cancelBtn\" ng-click=\"cancelUpgrade()\">{{i18n(\"hwId.upgradeCancelBtnTxt\")}}</div> </div> </div> <div class=\"upgradeContainer upgradeErrorContainer\" ng-show=\"model.isUpgrading && model.upgradeError\"> <img class=\"upgradeErrorImg\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"> <div class=\"upgradeErrorTitle\">{{i18n(\"hwId.upgradeErrorTitle\")}}</div> <div class=\"upgradeErrorDesc\">{{i18n(\"hwId.upgradeErrorDesc\")}}</div> <div class=\"upgradeErrorBtn\" ng-click=\"cancelUpgrade()\">{{i18n(\"hwId.upgradeErrorBtn\")}}</div> </div> <div class=\"upgradeContainer sdkContainer\" ng-show=\"model.isUpgrading && !model.upgradeError\"> <div class=\"upgradeGoBack\"><span class=\"right-arrow\" ng-click=\"upgradeGoBack()\"></span><span ng-click=\"upgradeGoBack()\">{{i18n(\"hwId.upgradeGoBack\")}}</span></div> <div class=\"sdkLoading\" ng-show=\"model.sdkLoading\"><img src=\"" + ___HTML_LOADER_REPLACEMENT_2___ + "\"></div> <div id=\"hwidsdk_mudule_container\" ng-show=\"!model.sdkLoading\"> <div class=\"hwidsdk_mudule\"></div> </div> </div>";
// Exports
module.exports = code;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(106);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = " <div class=\"title\"> <p ng-bind=\"i18n('welcomeEmail.title')\"></p> </div> <div class=\"container\"> <div> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span class=\"errorMsg\" ng-bind=\"i18n('welcomeEmail.linkExpired')\"></span> </div> <div class=\"helpMsg\"> <span ng-bind=\"i18n('welcomeEmail.contactAdm')\"></span> </div> </div>";
// Exports
module.exports = code;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = __webpack_require__(12);
var ___HTML_LOADER_IMPORT_0___ = __webpack_require__(106);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"title\"> <p ng-bind=\"i18n('welcomeEmail.title')\"></p> </div> <div class=\"container\"> <div> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span class=\"errorMsg\" ng-bind=\"i18n('welcomeEmail.linkTimeout')\"></span> </div> <div class=\"helpMsg\"> <span ng-bind=\"i18n('linkFailedHelp')\"></span> <a href=\"\" id=\"resendLink\" class=\"link\" ng-bind=\"i18n('welcomeEmail.resendEmail')\" ng-click=\"resendEmail()\"></a> </div> </div> <div id=\"popupMsg\"></div>";
// Exports
module.exports = code;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// Module
var code = " <div class=\"title\"> <p ng-bind=\"i18n('welcomeEmail.setPassword')\"></p> <span class=\"subTitle\" ng-bind=\"i18n('welcomeLogin.titleDetail')\"></span> </div> <div class=\"formDiv\"> <ul id=\"formUl\"> <li class=\"li\"> <span class=\"fieldLabel\" style=\"height:auto;min-height:0\"> </span> <span class=\"field\" style=\"width:100%\"> <span id=\"errorMsg\" style=\"text-align:center\"></span> </span> </li> <li id=\"password\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\" style=\"width:260px\"> <span style=\"display:inline-block;float:right\" ng-bind=\"i18n('password')\"></span> <span class=\"required\" style=\"float:right\">*</span> </span> <span class=\"field\"> <tiny-textbox id=\"model.passwordId\" max-length=\"model.maxPwdLength\" value=\"model.password\" height=\"model.height\" blur=\"model.passwordBlur()\" type=\"model.type\" width=\"model.width\" content-change=\"model.onPasswordChange($event, model.password)\" focus=\"model.onPasswordFocus()\" tip-position=\"'top'\" keypressfn=\"model.keyPress\" tooltip=\"model.pwdTip\"> </tiny-textbox> </span> </div> </li> <li> <div class=\"fieldContainer\"> <span class=\"fieldLabel\" style=\"width:260px\"> </span> <span class=\"field\"> <div id=\"PasswordError\" class=\"errorInfo\" style=\"margin-left:0\"></div> </span> </div> </li> <li id=\"confirmPassword\" class=\"li\"> <div class=\"fieldContainer\"> <span class=\"fieldLabel\" style=\"width:260px\"> <span style=\"display:inline-block;float:right\" ng-bind=\"i18n('resetPwd.confirmNewPasswd')\"></span> <span class=\"required\" style=\"float:right\">*</span> </span> <span class=\"field\"> <tiny-textbox id=\"model.confirmPasswordId\" value=\"model.confirmPassword\" type=\"model.type\" height=\"model.height\" width=\"model.width\" blur=\"model.onConfirmPasswordBlur()\" content-change=\"model.onConfirmPasswordBlur()\" keypressfn=\"model.keyPress\"> </tiny-textbox> </span> </div> </li> <li> <div class=\"fieldContainer\"> <span class=\"fieldLabel\" style=\"width:260px\"> </span> <span class=\"field\"> <div id=\"confirmPasswordError\" class=\"errorInfo\" style=\"margin-left:0\"></div> </span> </div> </li> <li class=\"li\"> <div id=\"btnDiv\"> <button id=\"submitBtn\" class=\"okButton\" style=\"float:left\" ng-click=\"onSubmitClick()\" ng-bind=\"i18n('btnTxtOK')\"></button> <button id=\"cancelBtn\" class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"onCancelClick()\" ng-bind=\"i18n('btnTxtCancel')\"></button> </div> </li> </ul> </div> <div id=\"popupMsg\"></div>";
// Exports
module.exports = code;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(163)
var ieee754 = __webpack_require__(259)
var isArray = __webpack_require__(261)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 261 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

var getSymbolSize = __webpack_require__(22).getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  var posCount = Math.floor(version / 7) + 2
  var size = getSymbolSize(version)
  var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  var positions = [size - 7] // Last coord is always (size - 7)

  for (var i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * var pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var coords = []
  var pos = exports.getRowColCoords(version)
  var posLength = pos.length

  for (var i = 0; i < posLength; i++) {
    for (var j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) ||             // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(21)

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
var ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  var i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),
/* 265 */
/***/ (function(module, exports) {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    var bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = BufferUtil.alloc(size * size)
  this.reservedBit = BufferUtil.alloc(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  var index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)
var Mode = __webpack_require__(21)

function ByteData (data) {
  this.mode = Mode.BYTE
  this.data = BufferUtil.from(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (var i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var getSymbolSize = __webpack_require__(22).getSymbolSize
var FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(22)

var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
var G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  var data = ((errorCorrectionLevel.bit << 3) | mask)
  var d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)

var EXP_TABLE = BufferUtil.alloc(512)
var LOG_TABLE = BufferUtil.alloc(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  var x = 1
  for (var i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(21)
var Utils = __webpack_require__(22)

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  var i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    var value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
var PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  var size = data.size
  var points = 0
  var sameCountCol = 0
  var sameCountRow = 0
  var lastCol = null
  var lastRow = null

  for (var row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (var col = 0; col < size; col++) {
      var module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  var size = data.size
  var points = 0

  for (var row = 0; row < size - 1; row++) {
    for (var col = 0; col < size - 1; col++) {
      var last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  var size = data.size
  var points = 0
  var bitsCol = 0
  var bitsRow = 0

  for (var row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (var col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  var darkCount = 0
  var modulesCount = data.data.length

  for (var i = 0; i < modulesCount; i++) darkCount += data.data[i]

  var k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  var size = data.size

  for (var col = 0; col < size; col++) {
    for (var row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  var numPatterns = Object.keys(exports.Patterns).length
  var bestPattern = 0
  var lowerPenalty = Infinity

  for (var p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    var penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(21)

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  var i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  var remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)
var GF = __webpack_require__(270)

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Buffer} p1 Polynomial
 * @param  {Buffer} p2 Polynomial
 * @return {Buffer}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  var coeff = BufferUtil.alloc(p1.length + p2.length - 1)

  for (var i = 0; i < p1.length; i++) {
    for (var j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Buffer} divident Polynomial
 * @param  {Buffer} divisor  Polynomial
 * @return {Buffer}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  var result = BufferUtil.from(divident)

  while ((result.length - divisor.length) >= 0) {
    var coeff = result[0]

    for (var i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    var offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Buffer}        Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  var poly = BufferUtil.from([1])
  for (var i = 0; i < degree; i++) {
    poly = exports.mul(poly, [1, GF.exp(i)])
  }

  return poly
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)
var Utils = __webpack_require__(22)
var ECLevel = __webpack_require__(62)
var BitBuffer = __webpack_require__(265)
var BitMatrix = __webpack_require__(266)
var AlignmentPattern = __webpack_require__(263)
var FinderPattern = __webpack_require__(268)
var MaskPattern = __webpack_require__(272)
var ECCode = __webpack_require__(86)
var ReedSolomonEncoder = __webpack_require__(276)
var Version = __webpack_require__(278)
var FormatInfo = __webpack_require__(269)
var Mode = __webpack_require__(21)
var Segments = __webpack_require__(277)
var isArray = __webpack_require__(60)

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  var size = matrix.size
  var pos = FinderPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (var c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  var size = matrix.size

  for (var r = 8; r < size - 8; r++) {
    var value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  var pos = AlignmentPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -2; r <= 2; r++) {
      for (var c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  var size = matrix.size
  var bits = Version.getEncodedBits(version)
  var row, col, mod

  for (var i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  var size = matrix.size
  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  var i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix} matrix Modules matrix
 * @param  {Buffer}    data   Data codewords
 */
function setupData (matrix, data) {
  var size = matrix.size
  var inc = -1
  var row = size - 1
  var bitIndex = 7
  var byteIndex = 0

  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          var dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Buffer}                        Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  var buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  var totalCodewords = Utils.getSymbolTotalCodewords(version)
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (var i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Buffer}                         Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  var blocksInGroup2 = totalCodewords % ecTotalBlocks
  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  var rs = new ReedSolomonEncoder(ecCount)

  var offset = 0
  var dcData = new Array(ecTotalBlocks)
  var ecData = new Array(ecTotalBlocks)
  var maxDataSize = 0
  var buffer = BufferUtil.from(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (var b = 0; b < ecTotalBlocks; b++) {
    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  var data = BufferUtil.alloc(totalCodewords)
  var index = 0
  var i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  var segments

  if (isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    var estimatedVersion = version

    if (!estimatedVersion) {
      var rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments,
        errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  var bestVersion = Version.getBestVersionForData(segments,
      errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  var dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  var moduleCount = Utils.getSymbolSize(version)
  var modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  var errorCorrectionLevel = ECLevel.M
  var version
  var mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(26)
var Polynomial = __webpack_require__(274)
var Buffer = __webpack_require__(260).Buffer

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Buffer} data Buffer containing input data
 * @return {Buffer}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  var pad = BufferUtil.alloc(this.degree)
  var paddedData = Buffer.concat([data, pad], data.length + this.degree)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  var remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  var start = this.degree - remainder.length
  if (start > 0) {
    var buff = BufferUtil.alloc(this.degree)
    remainder.copy(buff, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(21)
var NumericData = __webpack_require__(273)
var AlphanumericData = __webpack_require__(264)
var ByteData = __webpack_require__(267)
var KanjiData = __webpack_require__(271)
var Regex = __webpack_require__(87)
var Utils = __webpack_require__(22)
var dijkstra = __webpack_require__(227)

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  var segments = []
  var result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  var byteSegs
  var kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  var nodes = []
  for (var i = 0; i < segs.length; i++) {
    var seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  var table = {}
  var graph = {'start': {}}
  var prevNodeIds = ['start']

  for (var i = 0; i < nodes.length; i++) {
    var nodeGroup = nodes[i]
    var currentNodeIds = []

    for (var j = 0; j < nodeGroup.length; j++) {
      var node = nodeGroup[j]
      var key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (var n = 0; n < prevNodeIds.length; n++) {
        var prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]]['end'] = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  var mode
  var bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  var nodes = buildNodes(segs)
  var graph = buildGraph(nodes, version)
  var path = dijkstra.find_path(graph.map, 'start', 'end')

  var optimizedSegs = []
  for (var i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(22)
var ECCode = __webpack_require__(86)
var ECLevel = __webpack_require__(62)
var Mode = __webpack_require__(21)
var VersionCheck = __webpack_require__(88)
var isArray = __webpack_require__(60)

// Generator polynomial used to encode version information
var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
var G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  var totalBits = 0

  segments.forEach(function (data) {
    var reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    var length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  var seg

  var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  var d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(89)

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  var opts = options
  var canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  var size = Utils.getImageWidth(qrData.modules.size, opts)

  var ctx = canvasEl.getContext('2d')
  var image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  var opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  var canvasEl = exports.render(qrData, canvas, opts)

  var type = opts.type || 'image/png'
  var rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(89)

function getColorAttrib (color, attrib) {
  var alpha = color.a / 255
  var str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  var str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  var path = ''
  var moveBy = 0
  var newRow = false
  var lineLength = 0

  for (var i = 0; i < data.length; i++) {
    var col = Math.floor(i % size)
    var row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  var opts = Utils.getOptions(options)
  var size = qrData.modules.size
  var data = qrData.modules.data
  var qrcodesize = size + opts.margin * 2

  var bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  var path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  var viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  var width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_casLoginError_lazy_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_casLoginError_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_casLoginError_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_casLoginError_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_casLoginError_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_closecookie_lazy_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_closecookie_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_closecookie_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_closecookie_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_closecookie_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_error_lazy_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_error_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_error_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_error_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_error_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fpwd2_lazy_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fpwd2_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fpwd2_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fpwd2_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fpwd2_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_sdk_lazy_css__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_sdk_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_sdk_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_sdk_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_sdk_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_notify_lazy_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_notify_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_notify_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_notify_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_notify_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_privacyUpdate_lazy_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_privacyUpdate_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_privacyUpdate_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_privacyUpdate_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_privacyUpdate_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_ssologin_lazy_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_ssologin_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_ssologin_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_ssologin_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_ssologin_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_upgrade_lazy_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_upgrade_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_upgrade_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_upgrade_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_upgrade_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_fphone_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginVerification_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_zh_lazy_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_zh_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_zh_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_zh_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_login_zh_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_loginpage_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css__);

            

var refs = 0;
var update;
var options = {"injectType":"lazyStyleTag"};

options.insert = "head";
options.singleton = false;

var exported = {};

exported.locals = __WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a.locals || {};
exported.use = function() {
  if (!(refs++)) {
    update = __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_css_loader_index_js_resetPwd_lazy_css___default.a, options);
  }

  return exported;
};
exported.unuse = function() {
  if (refs > 0 && !--refs) {
    update();
    update = null;
  }
};



;
       /* harmony default export */ __webpack_exports__["default"] = (exported);


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/base/error/theme/default/images/error-401.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/base/error/theme/default/images/error-404.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/base/error/theme/default/images/error-500.png";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxRTFFMEQ2NUY2QzgxMUU3OUVGQTk4RjY0MTA3QjA0MyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxRTFFMEQ2NkY2QzgxMUU3OUVGQTk4RjY0MTA3QjA0MyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFFMUUwRDYzRjZDODExRTc5RUZBOThGNjQxMDdCMDQzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjFFMUUwRDY0RjZDODExRTc5RUZBOThGNjQxMDdCMDQzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+9qJ2QwAAAQ5JREFUeNpi/P//PwMlgAVdgJGREUNReUW1KJDaAMRFHe0tJ5HlmAjZANTMD6S2ALEVEE9Dl2cioJkLarMZED8F4nCiDQBqZgNSq4HYAYjfALFHZ0frHaIMAGpmBlKLgdgLiD+BaKDmK9jUMmHRDArFmUAcBsTfgdgPqPk0Lpdic0EvECcD8W8gDgFqPogvnLAZwA+l/wDxD0KxhM2ANCBeDsScoBgAeskcnwGM6CkRlJCgMbAGiH2hgWgD9MplkDyGemwGQAOTHUhtB2JHaDSCDLmJrh5nOgAq/gmkfID4OBCLAPFeoKHKJKVEoCHfgJQnEJ8DYmkgXkWSAVBDPoJSIRAfA+IsgoFIKgAIMAAaM1QOb640VQAAAABJRU5ErkJggg=="

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/background.jpg";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/background_login.jpg";

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjBweCIgaGVpZ2h0PSI2MHB4IiB2aWV3Qm94PSIwIDAgNjAgNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5pY29uL+e7k+aenC/miJDlip88L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iOC1INS3nmbvlvZUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSI0LjAtLeeZu+W9leW8guW4uC3kuI3pgILnlKgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTcuMDAwMDAwLCAtMTk2LjAwMDAwMCkiIGZpbGw9IiNDNzAwMEIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uL+e7k+aenC/miJDlip8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ny4wMDAwMDAsIDE5Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMCwwIEMxMy40MzI1LDAgMCwxMy40Mjk1IDAsMzAgQzAsNDYuNTY3NSAxMy40MzI1LDYwIDMwLDYwIEM0Ni41NzA1LDYwIDYwLDQ2LjU2NzUgNjAsMzAgQzYwLDEzLjQyOTUgNDYuNTcwNSwwIDMwLDAgWiBNMzIuNzI3MjcyNyw0Ny43MjcyNzI3IEwyNy4yNzI3MjczLDQ3LjcyNzI3MjcgTDI3LjI3MjcyNzMsNDIuMjcyNzI3MyBMMzIuNzI3MjcyNyw0Mi4yNzI3MjczIEwzMi43MjcyNzI3LDQ3LjcyNzI3MjcgWiBNMzIuMTUxODI2MSwzNS40NTQ1NDU1IEwyNy44NDY3Mzg5LDM1LjQ1NDU0NTUgTDI3LjI3MjcyNzMsMTUgTDMyLjcyNzI3MjcsMTUgTDMyLjE1MTgyNjEsMzUuNDU0NTQ1NSBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT4tbW9ja3BsdXMtPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9Ikg1LeS6kemCgOivt+WNh+e6p0lEIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5Zu+5qCH5LiO6L6T5YWl54q25oCBIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcuMDAwMDAwLCAtNTEwLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iLW1vY2twbHVzLSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcuMDAwMDAwLCA1MTAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i5Z+656GA57uE5Lu2L+mAiemhuS/lpI3pgInmoYYv6YCJ5LitIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iY2hlY2tib3gv5aSN6YCJ5qGGL+mAieS4rSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSLliIbnu4QtNSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i5YiG57uELTMiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSLnn6nlvaItY29weSIgZmlsbD0iI0M3MDAwQiIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjEzLjI3MjI3MDIgNS43ODYyODU5OSAxMi4wMzc2Mjk5IDQuNTcxNDI4NzggNy41MTc3MTQzNyA5LjAxNzAyMTIyIDQuMjMyMzE1MjkgNS43ODczMDY4IDMgNi45OTc1OTI2MiA3LjUyMDAzOTQ5IDExLjQ0MzMwNjkgOC43NTExOTIzIDEwLjIzMzAyMTIiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT7liIbnu4QgMTA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUEMt5LqR6YKA6K+35Y2H57qnSUQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLeS6kemCgOivt+WNh+e6p0lEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTU2LjAwMDAwMCwgLTY4MS4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IuWIhue7hC0xMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTU2LjAwMDAwMCwgNjgxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IuWIhue7hC01Ij4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i5YiG57uELTMiPgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0i55+p5b2iLWNvcHkiIGZpbGw9IiM1MjZFQ0MiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iLW1vY2twbHVzLSIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iMSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9Iui3r+W+hCIgcG9pbnRzPSI1LjE3MzkxMzAzIDYuNTY1MjE3NSA3LjcxNzM5MTIyIDkuMTA4Njk1NzQgMTEuODI2MDg2NyA1IDEzIDYuMTczOTEzMTIgNy43MTczOTEyMiAxMS40NTY1MjIgNCA3LjczOTEzMDYyIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgb3BhY2l0eT0iMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLlm77lsYJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMzJweCIgaGVpZ2h0PSIxMzJweCIgdmlld0JveD0iMCAwIDE2IDE2IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAxNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cjxwb2x5Z29uIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNzc3ODdCIiBwb2ludHM9IjEzLjU5MywzLjU0OSA4LjAyOCw4Ljk3NyAyLjQwNywzLjU0OSAxLDQuOTU2ICYjMTA7JiM5OzguMDM1LDExLjc1IDE1LDQuOTU2ICIvPgo8L3N2Zz4="

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT7lvaLnirbnu5PlkIg8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iNy1QQy3nmbvlvZUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSI4LS0t6ZSZ6K+v5o+Q56S6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzY1OS4wMDAwMDAsIC02MTUuMDAwMDAwKSIgZmlsbD0iI0ZBMkEyRCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTM2NjUsNjE1IEMzNjY4LjMsNjE1IDM2NzEsNjE3LjcgMzY3MSw2MjEgQzM2NzEsNjI0LjMgMzY2OC4zLDYyNyAzNjY1LDYyNyBDMzY2MS43LDYyNyAzNjU5LDYyNC4zIDM2NTksNjIxIEMzNjU5LDYxNy43IDM2NjEuNyw2MTUgMzY2NSw2MTUgWiBNMzY2NS43NSw2MjIuOTUgTDM2NjQuMjUsNjIyLjk1IEwzNjY0LjI1LDYyNC40NSBMMzY2NS43NSw2MjQuNDUgTDM2NjUuNzUsNjIyLjk1IFogTTM2NjUuODI1LDYxNy4zMjUgTDM2NjQuMTc1LDYxNy4zMjUgTDM2NjQuNDYzMTcsNjIxLjgyNSBMMzY2NS40OTQ0Myw2MjEuODI1IEwzNjY1LjgyNSw2MTcuMzI1IFoiIGlkPSLlvaLnirbnu5PlkIgiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjRCMzM0QzlGOUREMTFFNDg1ODQ4OENFQ0UxMzZBRUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjRCMzM0Q0FGOUREMTFFNDg1ODQ4OENFQ0UxMzZBRUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNEIzMzRDN0Y5REQxMUU0ODU4NDg4Q0VDRTEzNkFFQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNEIzMzRDOEY5REQxMUU0ODU4NDg4Q0VDRTEzNkFFQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlNj95AAAABXSURBVHjadI9dCsAgDIODz3r/++jBqmGbtF1aCPTnUxLYU+uoHyGJu2nvsAr4QrxxMQQcIDL+tYd9z4+Q/XxAgKiGWFbOyrgKqKChAkIZVwFRQD94CzAASq841fALJpkAAAAASUVORK5CYII="

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/firefox.png";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzU3NUQ2Qzt9Cjwvc3R5bGU+CjxwYXRoIGlkPSLot6/lvoTlpI3liLYtNiIgY2xhc3M9InN0MCIgZD0iTTEyLjgsNS4yYzAuMy0wLjIsMC43LTAuMiwxLDBjMC4zLDAuMiwwLjMsMC43LDAsMC45bC01LjMsNC43Yy0wLjMsMC4yLTAuNywwLjItMSwwCglMMi4yLDYuMWMtMC4zLTAuMi0wLjMtMC43LDAtMC45YzAuMy0wLjIsMC43LTAuMiwxLDBMOCw5LjVMMTIuOCw1LjJ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA2MC4xICg4ODEzMykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+RmlsbCAxPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IjktUEPmib7lm57lr4bnoIEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSI1LUlBTeeUqOaIt+aJvuWvhiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkyMC4wMDAwMDAsIC0yMjkuMDAwMDAwKSIgZmlsbD0iIzVFN0NFMCIgc3Ryb2tlPSIjNUU3Q0UwIiBzdHJva2Utd2lkdGg9IjAuNCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik05MjAuNzIxMzEyLDIzNi4yNjI5MTcgTDkyNi4yOTIxMjEsMjQxLjg3Nzc4MiBDOTI2LjQ1NDI3NywyNDIuMDQwNzM5IDkyNi43MTYyOTYsMjQyLjA0MDczOSA5MjYuODc4Mzk0LDI0MS44Nzc3ODIgQzkyNy4wNDA1MzUsMjQxLjcxNDQyOCA5MjcuMDQwNTM1LDI0MS40NDk4ODggOTI2Ljg3ODM5NCwyNDEuMjg2NTIgTDkyMS41Nzk1NTIsMjM1Ljk0NTcwOSBMOTI2Ljc5MDg5NCwyMzAuNjkzMTI3IEM5MjYuOTQ4NDQsMjMwLjUzNDc0MyA5MjYuOTQ4NDQsMjMwLjI3Nzc2NiA5MjYuNzkwODk0LDIzMC4xMTkzODIgQzkyNi42MzM3NTYsMjI5Ljk2MDIwNiA5MjYuMzc4NzYyLDIyOS45NjAyMDYgOTI2LjIyMTIxNiwyMzAuMTE5MzgyIEw5MjAuODA4NzUzLDIzNS41NzM4NTQgQzkyMC43ODc2MDUsMjM1LjU5NTE2NyA5MjAuNzc3Mjc5LDIzNS42MjEwMzkgOTIwLjc2MTkzNSwyMzUuNjQ1NzI0IEM5MjAuNzQ5MDkyLDIzNS42NTUzNCA5MjAuNzMzMjk2LDIzNS42NjAzMjQgOTIwLjcyMTMxMiwyMzUuNjcyNDYxIEM5MjAuNTU5NTYzLDIzNS44MzU0MTkgOTIwLjU1OTU2MywyMzYuMDk5OTU5IDkyMC43MjEzMTIsMjM2LjI2MjkxNyBaIiBpZD0iRmlsbC0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MjMuODAwMDAwLCAyMzYuMDAwMDAwKSBzY2FsZSgtMSwgMSkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTkyMy44MDAwMDAsIC0yMzYuMDAwMDAwKSAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA2MC4xICg4ODEzMykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+RmlsbCAxPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IjktUEPmib7lm57lr4bnoIEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLS3ljY7kuLrkupHmib7lm57lr4bnoIEtLeaJi+acuuWPtyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTk4Ni4wMDAwMDAsIC0yMjguMDAwMDAwKSIgZmlsbD0iIzVFN0NFMCIgc3Ryb2tlPSIjNUU3Q0UwIiBzdHJva2Utd2lkdGg9IjAuNCI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUwLjAwMDAwMCwgMTQwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYzNy4xMjEzMTIsOTUuMjYyOTE3MSBMNjQyLjY5MjEyMSwxMDAuODc3NzgyIEM2NDIuODU0Mjc3LDEwMS4wNDA3MzkgNjQzLjExNjI5NiwxMDEuMDQwNzM5IDY0My4yNzgzOTQsMTAwLjg3Nzc4MiBDNjQzLjQ0MDUzNSwxMDAuNzE0NDI4IDY0My40NDA1MzUsMTAwLjQ0OTg4OCA2NDMuMjc4Mzk0LDEwMC4yODY1MiBMNjM3Ljk3OTU1Miw5NC45NDU3MDg5IEw2NDMuMTkwODk0LDg5LjY5MzEyNzIgQzY0My4zNDg0NCw4OS41MzQ3NDI5IDY0My4zNDg0NCw4OS4yNzc3NjYxIDY0My4xOTA4OTQsODkuMTE5MzgxOSBDNjQzLjAzMzc1Niw4OC45NjAyMDYgNjQyLjc3ODc2Miw4OC45NjAyMDYgNjQyLjYyMTIxNiw4OS4xMTkzODE5IEw2MzcuMjA4NzUzLDk0LjU3Mzg1NCBDNjM3LjE4NzYwNSw5NC41OTUxNjc0IDYzNy4xNzcyNzksOTQuNjIxMDM5NSA2MzcuMTYxOTM1LDk0LjY0NTcyNDMgQzYzNy4xNDkwOTIsOTQuNjU1MzQwMiA2MzcuMTMzMjk2LDk0LjY2MDMyNCA2MzcuMTIxMzEyLDk0LjY3MjQ2MTIgQzYzNi45NTk1NjMsOTQuODM1NDE4OSA2MzYuOTU5NTYzLDk1LjA5OTk1OTQgNjM3LjEyMTMxMiw5NS4yNjI5MTcxIFoiIGlkPSJGaWxsLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0MC4yMDAwMDAsIDk1LjAwMDAwMCkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTY0MC4yMDAwMDAsIC05NS4wMDAwMDApICI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNfdGljazwvdGl0bGU+CiAgICA8ZyBpZD0iaWNfdGljayIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Imljb25fanVtcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiPgogICAgICAgICAgICA8cGF0aCBkPSJNNC41LDE0IEM0LjIyMzg1NzYzLDE0IDQsMTMuNzc2MTQyNCA0LDEzLjUgQzQsMTMuMjIzODU3NiA0LjIyMzg1NzYzLDEzIDQuNSwxMyBMMTEsMTMgTDExLDIuNSBDMTEsMi4yMjM4NTc2MyAxMS4yMjM4NTc2LDIgMTEuNSwyIEMxMS43NzYxNDI0LDIgMTIsMi4yMjM4NTc2MyAxMiwyLjUgTDEyLDEzLjUgTDEyLDEzLjUgQzEyLDEzLjc0NTQ1OTkgMTEuODIzMTI0OCwxMy45NDk2MDg0IDExLjU4OTg3NTYsMTMuOTkxOTQ0MyBMMTEuNSwxNCBMMTEuNSwxNCBMNC41LDE0IFoiIGlkPSLlvaLnirbnu5PlkIgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCA4LjAwMDAwMCkgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTguMDAwMDAwLCAtOC4wMDAwMDApICI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNfdGljazwvdGl0bGU+CiAgICA8ZyBpZD0iaWNfdGljayIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Imljb25fanVtcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiNmZmZmZmYiPgogICAgICAgICAgICA8cGF0aCBkPSJNNC41LDE0IEM0LjIyMzg1NzYzLDE0IDQsMTMuNzc2MTQyNCA0LDEzLjUgQzQsMTMuMjIzODU3NiA0LjIyMzg1NzYzLDEzIDQuNSwxMyBMMTEsMTMgTDExLDIuNSBDMTEsMi4yMjM4NTc2MyAxMS4yMjM4NTc2LDIgMTEuNSwyIEMxMS43NzYxNDI0LDIgMTIsMi4yMjM4NTc2MyAxMiwyLjUgTDEyLDEzLjUgTDEyLDEzLjUgQzEyLDEzLjc0NTQ1OTkgMTEuODIzMTI0OCwxMy45NDk2MDg0IDExLjU4OTg3NTYsMTMuOTkxOTQ0MyBMMTEuNSwxNCBMMTEuNSwxNCBMNC41LDE0IFoiIGlkPSLlvaLnirbnu5PlkIgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCA4LjAwMDAwMCkgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTguMDAwMDAwLCAtOC4wMDAwMDApICI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/ie.png";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/language@red.png";

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7"

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAFV3XwhAAAAAXNSR0IArs4c6QAAAhtJREFUOBGNU71rFFEQn5nd5O6dGPaKEy0Ure1tPIiNXbQTS8vI3cHtoVwaiyv8ChjcI17ANp2SVMkfIBILwUJII1ZaJCGnkivC7h5J3jjz1k0CxwUH3nuzM7/5vTcfi9zpTCZ7/SERzpMqiLBsLc9h3KwxiPiIaIsBlTML4X1geAvMgfNqoODf6UcuGIe1bUFdyg2EDGUE3Ch1l9Ccm7hIQPiQgatJWN/A593d4+vykBGO3HH6pOwSXPV87zqSd0uce0DwGMF7oHcp2NfNlGAWXyz+UT1uNmbB2veMR1tJq+GxtYBpq/5S81bAiCDsmODCVRoL0AjJNxn0f5DqJuqR5qsLkKpE3m21y3lXgQ4khWWxPBH7sBS9+cST9B0Qv0hd7ijYPVwaVJS+fFCDk/Rw05TpcjI4+qbfGVOnk2bp4iqHYSAMUxDDVN6DkepmVCe7dvHsEpxgz9QcUT46ivQQ7hWipZXTUdL0ZUm9X8CJpykcrDPzTfVLtaYR/F0LBy43VwDnQNwsRL0V6dwigG3kZBIIRd9UwPfZzEfVOKx/FeJrptv7GLdqj8BmSFekf0HrjpDslkz6s2zhTyn7Z1xY+J2m+6/TZv2VCSo3kGTMRYTQtUP14xfJr7GWzDWvwPBwRh0q8piC9HTN6QAz0oVKMvi1XYp6bW63zyfD/WkHlO2/xjsHjz1lLskNprRPqrczFjjOoQQSqxx/AbLz2vmi2KDBAAAAAElFTkSuQmCC"

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAFV3XwhAAAAAXNSR0IArs4c6QAAAg1JREFUOBGdUz2IE1EQfjNvb5M9NSSg508hir2HIFyhIgh2Z2clXGMjJIWJglZCSj3QrKcGbCwsRa3sRVAL4RBUFMTC6g6ikIi6u5dk3zjfHqsL0YNzYHfnzXzfvNnvzSNpt/2431tjpmsMh8g8c04uU3S+LkaNjS3vhZNFyNBzMXIUARiDWAwgSFGzvmLE7MYCxkrbGYR3OKiZbR7bOdbsKG42XNKnu37n1qvf260T/lIjTxS/KJNtgi6U8whJ5tIBJmpN3+wS1h5eQW1mC7XbEfyoVb8obvha264kFxofXSqGklbjKv4bgAkjsxpUZ/bxPwFgaCvxoPeZ4UMmVfI+k53XxRnEYHZqahbArCfINh12j0HpoLS1sjb82VLMyI3TUwBnlSzzwbhZHyBAi4vfnUhHRA4p+Q+o1Ln9Ngi7VWI+CyCMiZ8YkTn4E+oiWDTot7EERfQGflYoHx3gyHonghtLT4scPfiXImYlYH8hdsNPqt2edSwvlCvbHyf93g+dPZpom4icsXK87NOHODLvlLjL87zDJk1lLLKcbxKQX4tlfNIY9wCxTMk8qd835eqOwKS0P47kK4roGa3615eWhWhkLZ/GY6x3hMJwoHvO59xCIbqkAzabfPtyRZPntLMXeujvCaqrpSL30tQ9xGOcy+6L/nJ2ZMhPXBEEN23aNWeDifHXxX8VUC5q/AJSOt4egopdEAAAAABJRU5ErkJggg=="

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/loginimg_intl_en-us.png";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/logo-en.svg";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/logo_zbj.png";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLlm77lsYJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMzJweCIgaGVpZ2h0PSIxMzJweCIgdmlld0JveD0iMCAwIDE2IDE2IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAxNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cjxwb2x5Z29uIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNzc3ODdCIiBwb2ludHM9IjE1LDEwLjU0NCA4LjAzNSwzLjc1IDEsMTAuNTQ0IDIuNDA3LDExLjk1MSA4LjAyOCw2LjUyMyAmIzEwOyYjOTsxMy41OTMsMTEuOTUxICIvPgo8L3N2Zz4="

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANlJREFUeNpiZEAD/zuME4CUPxAHoEltAOKNjBVnFyALMiJpFABS64HYgQE/OADEgUCDPsANgGq+D8QCDMQBkGZFkCFMUIH9WDVHzoRgTCAA1cPAAvWzAVZ75IzxucIApJcJGmDkAn8mLKFNCghgYqAQUGwAC17ZThOiXHABpywoFsTU8Om/ADJgIk5pUBpwLsZnwERYSjyPNS3YpDEwfHzOwHB5M1bbgSnREBYGiVhT45FZ+JJyIjwWgCaBwsERb3gg2QxSC9WDyI1o2Tkfi5cugP2Mlp0BAgwAxpU6qC6UUT8AAAAASUVORK5CYII="

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGMUExURV3UsG3btl7Vr13Vr17Trl7VsV3VsEdwTF3Vsl/UsV3VsGDfv2TTsV3UsF7VsF3Vr17Vs1Wqql/Sr17Vr1/Tr1zVsV3Vr13TsV3UsF3Ur2bZs13Vr13Url7Vr17TsF7SsF7WsFzRsF3RsF7TsoC/v2LatGDWs13Rrl3VsF3UsFnMs17Wr13Wr13UsF/VsF3VsF3Ur17Xrl3Ur13Ur/////7+/m7Yt+j4857lz53lz2HUsV/Ur9j47/X9+uL68mDUsPn+/f3//mPUsd7272PVsfj+/NX27Nb47d358PP9+qLm0Zbjy9b06/H7+MXv4o7hx43gx8nw5Kno1Mvx5fv//fr//fr+/ann1Ljr3HHZuMzy5ZjjzJrkzdL26uf69Nn47tj47u389+X59N768dj37uv89ur89u/79+n89uL58eD58d727vX+++79+Of79dv57/D8+O78+OD68tn579H16uv69dr479f27GbWs2XWs/H9+fD9+ev79uT689z379v37dj27d748Of79OX79EmUfIEAAAAzdFJOU00H/fhMMc4AYDu7CBehq/I8AzPxI0j6UvuDFMBYSYtEVz03TAQiJRb+5xSWs9aXss4T5r479PcAAAKeSURBVEjHpZdnQ+owFIZTRpUtIIiAIMgGQW+4C0SvW+/ee++99x5//NqTptTStMG8X0rTPDQ9yXlzgkZMVSiX3LlszOWKZXPuUrlg3guZtElFjwvtkstTlLjgWn4GmWgmX7OFkx7ElCdpCfsiyFIRHxv2T2ndpjOtuWo0Ho9W5UZmWmue8rPgcdpltC4nsE4JuT5Kn42bwmE3Rb0OPCCHl+Lu8CAsjZFn6aATm8oZTJMeY5IRDqvsZAgzFZpU6bABVsccqGALVQLqyHfDJFYTKWyj1IQ+agT2E3YW22qW0P4+7CPzm8IcSpH59mkwWVcBzCXy3REKJ0mcK3xwhcQ8qcKQC+kQ5lQI5ttD4Br8UxBzKwhADeA8rEknP+yElZpXYAly34uHkBfcQdqBi/BixzCwA15d3IEhXE174sDxE0fp7yYJGSqA18n27MF2u31MvZHBFQuoDL6R4GLbJ6k7gLeUUUm5ZPjY/afofUahSghyscHHHtYaGpCZKMfxyQMs+egcyiqXqq7npcsdWxZXFSqLYsol2m9eXT7/6LMdi6MKFUMwU3Gt9dryxfXehy82LI7DXBnh6xfWn29/vbtmzVLYOOxnve3Xb+48WbNk6bAHArb67cX3hzf/rOjZQ8b47yMBG5yqnw8e//23eL9jweI5MlWwSFr6B91fL38sPr230WGzuEUWicny7P5efLv16t37K0yWLk+zxOh+2vp4a3Ohx2RpYpimZHfj9ubCESarpSQxg7rhaeeGFYvrqhkwbGjlqgXbtyGGAS6dY7I6A2RZ79LZM6dtrXdkXsT0hbYbutE59rTRCW2xYpu7UFkhVtCIlVJiRZxQ+ShWuFqXzE2bktlYrDfkoYp1sWOC2AFF0fzej0aCh7IhjoP/AUoEsd42dGqRAAAAAElFTkSuQmCC"

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5SZWN0YW5nbGUgMyBDb3B55aSN5Yi2IDU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUEMt5LqR6YKA6K+35Y2H57qnSUQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLeS6kemCgOivt+WNh+e6p0lEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTU2LjAwMDAwMCwgLTY4MS4wMDAwMDApIiBzdHJva2U9IiNBREIwQjgiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTU2LjAwMDAwMCwgNjgwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ii1tb2NrcGx1cy0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSLln7rnoYDnu4Tku7Yv6YCJ6aG5L+WkjemAieahhi/pu5jorqQiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iLW1vY2twbHVzLSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQm9yZGVyL+e6ouahhiI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0zLUNvcHnlpI3liLYtNSIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzU3NUQ2Qzt9Cjwvc3R5bGU+CjxwYXRoIGlkPSLot6/lvoTlpI3liLYtNiIgY2xhc3M9InN0MCIgZD0iTTEyLjgsMTAuOGMwLjMsMC4yLDAuNywwLjIsMSwwYzAuMy0wLjIsMC4zLTAuNywwLTAuOUw4LjUsNS4yYy0wLjMtMC4yLTAuNy0wLjItMSwwCglMMi4yLDkuOWMtMC4zLDAuMi0wLjMsMC43LDAsMC45YzAuMywwLjIsMC43LDAuMiwxLDBMOCw2LjVMMTIuOCwxMC44eiIvPgo8L3N2Zz4K"

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/hws/images/upgrade.jpg";

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT7nvJbnu4Q8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iMy1QQy3kupHpgoDor7fljYfnuqdJRCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuWKoOi9vS/ns7vnu5/lpLHotKUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03NzYuMDAwMDAwLCAtMTA4My4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzc2LjAwMDAwMCwgMTA4My4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9IuakreWchuW9oiIgZmlsbD0iI0ZBMkEyRCIgY3g9IjMyIiBjeT0iMzIiIHI9IjMyIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIzMiIgeTE9IjE0LjM2MzM3NDciIHgyPSIzMiIgeTI9IjQxLjM2MzM3NDciIGlkPSLnm7Tnur8iIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIzMiIgeTE9IjQ5IiB4Mj0iMzIiIHkyPSI1MC4zNjMzNzQ3IiBpZD0i55u057q/5aSH5Lu9IiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj48L2xpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEUklEQVRoQ9Waf2jUdRjHX5/vbJ53Z/ZjTNjcomgbFU6Usp1WuP8qSCJTRAopMiqpMKJJkH8YhIvYqLAio5BExDKiyPpvkj9uVihOKrZF0eYGrvVj7e68ze37ied2p/ued97OPXdxz19j9/m+n+f9/T6/Ps/nY1CQH5hfMc5Es8EJGWiwUGfgWgvzBd7AqIW/DfRa6La44XLmdNzO6PBs1ZsrBeiAa3z414PzqME2WXDywTLgWkwnuB/Hie1rhn/yeT61Nm8CRwlWOtgXgGdIvuErUZz2zCjwjotpW0lkKB+8GRPYD2U1BDeD3Q4syEdJHmtHwGzrJ7JzHUzO5LkZETiB74ZxnH0W0zQT0NmuMdjOctz1y4j/ngsrJ4FjBO4F9kpQ5gLT/F2CHtiwgug3l8O9LIFOAo9Y+BC4StO4PLDOG3i8ieiebM9kJSDGA7vzzS55GDejpZKtgI3ZSGQkIG5j4Iv/8c2nkztvYXUmd7qEgARsnLKTxfb5XJ9DYsLH5NL0wPYQkFRZi/9IsbJNLqPTf5fs1Efsrukp1kMgTPA5sG/mC5y+/o7oEGV+v+ffk7EY3wcqZwstjcnzISJvXVKJkxW2R6NILe3vZu6iao+xY2cGOFnToECAERdTn6rYF75AmMAOoEVDw+JTYQKNiz1Q0a7TnF4S0oAXjNYQ0a3yR4LAVGMW6NPqbW7pOMiCVfd4jB059C0/N9+vRWA0TrRWGsAEgTD+p8C8q4Ve9+kerl/zoAfuzwOf0/uwlBYtsU+HiL2XJBA8CnaFFvSN77/Nwk2PeeDO7vqI3558VkuFOM+xEJGVRjYjE7hnNStuzY7tVLdIx31RBlrb6N+6TY2AVOg5OAvNceatdXH2qyEDVS9tobb1VQ9kX8srDL7erqkGB3edCRNoA7ZoIlc+sZGbdu30QP66aTNDH+zWVCNY7aaTwFcW1NKDoF730GrqD+z1GNuzZgN/fSbtlZ4YOCgEemQTrgcLV6+6m1s7vvZA/tR8H/8eOqypRmpArxD4w0KFJrK/8TYaTx33QHYtuZNY14+aaoTAsMRAHJiriVxeXcWyM9KVXJQTi+oZHxjUVCNYYwUh4MzzsTzmHfl856/APSfvSlXGCuJCYuLyc8M4Pl/CWjFcCGhLwoUKEcRiqLiQuJKIuI64UAEkEcTqaVQMbfjyE3x1Nydsjvf+QvcDa9XtT6TRQhQydUuzA7YXpJUoFgErrUQhmrliELjQzImyMLrtdHojlyIkDZ2eJNvpKQK6G5omG8loZ6cJ6tnPtA2N9payCAS8W8qpr6C3qS8CAe+mXghojlUKTCDzWCUZzCqDrcISyDLYEgJao8Wql1/MGKyDr70xqyDOOVoU9JIe7qZeT0mP11MkSvqAYzqJkj1imu5OJXvIlyJR0sesKRIlfdA9PXmX7FWD9ApUspc9MpVS2RRNMtHsJq/bMDXp81y3YerkPXHdxsENlyldt/kP3DOqnpYAWQEAAAAASUVORK5CYII="

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT4xIHBj6ZSZ6K+vaWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjEtcGPplJnor69pY29uIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMyI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIsMCBDNS40LDAgMCw1LjQgMCwxMiBDMCwxOC42IDUuNCwyNCAxMiwyNCBDMTguNiwyNCAyNCwxOC42IDI0LDEyIEMyNCw1LjQgMTguNiwwIDEyLDAgWiIgaWQ9IlhNTElEXzI5OF8iIGZpbGw9IiM1NTVCNjkiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy41LDE1LjcyOTY1MTIgTDEzLjUsMTguNzM4MzcyMSBMMTAuNSwxOC43MzgzNzIxIEwxMC41LDE1LjcyOTY1MTIgTDEzLjUsMTUuNzI5NjUxMiBaIE0xMy41LDUuNSBMMTIuOSwxMy45MjQ0MTg2IEwxMS4xLDEzLjkyNDQxODYgTDEwLjUsNS41IEwxMy41LDUuNSBaIiBpZD0i5b2i54q257uT5ZCIIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/fphone.lazy.css": 283,
	"./es-us/fphone.lazy.css": 288,
	"./pt-br/fphone.lazy.css": 296,
	"./zh-cn/fphone.lazy.css": 302
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 350;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/loginVerification.lazy.css": 284,
	"./es-us/loginVerification.lazy.css": 289,
	"./pt-br/loginVerification.lazy.css": 297,
	"./zh-cn/loginVerification.lazy.css": 303
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 351;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/loginpage.lazy.css": 285,
	"./es-us/loginpage.lazy.css": 290,
	"./pt-br/loginpage.lazy.css": 298,
	"./zh-cn/loginpage.lazy.css": 305
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 352;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/resetPwd.lazy.css": 286,
	"./es-us/resetPwd.lazy.css": 291,
	"./pt-br/resetPwd.lazy.css": 299,
	"./zh-cn/resetPwd.lazy.css": 306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/resource": 134,
	"./es-us/resource": 136,
	"./pt-br/resource": 138,
	"./zh-cn/resource": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-us/resourcehk": 135,
	"./es-us/resourcehk": 137,
	"./pt-br/resourcehk": 139,
	"./zh-cn/resourcehk": 141
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js